
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("calFH", function(module, exports) {
$parcel$export(module.exports, "BrowserRouter", () => $8db73abdae598f69$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "useSearchParams", () => $8db73abdae598f69$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("30t8d")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("30t8d")).useNavigate);
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $fBuCt = parcelRequire("fBuCt");

var $eseEd = parcelRequire("eseEd");
var $30t8d = parcelRequire("30t8d");

var $eseEd = parcelRequire("eseEd");
function $8db73abdae598f69$var$_extends() {
    $8db73abdae598f69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8db73abdae598f69$var$_extends.apply(this, arguments);
}
function $8db73abdae598f69$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8db73abdae598f69$var$defaultMethod = "get";
const $8db73abdae598f69$var$defaultEncType = "application/x-www-form-urlencoded";
function $8db73abdae598f69$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $8db73abdae598f69$var$isButtonElement(object) {
    return $8db73abdae598f69$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $8db73abdae598f69$var$isFormElement(object) {
    return $8db73abdae598f69$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $8db73abdae598f69$var$isInputElement(object) {
    return $8db73abdae598f69$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $8db73abdae598f69$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $8db73abdae598f69$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$8db73abdae598f69$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $8db73abdae598f69$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $8db73abdae598f69$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $8db73abdae598f69$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $8db73abdae598f69$var$_formDataSupportsSubmitter = null;
function $8db73abdae598f69$var$isFormDataSubmitterSupported() {
    if ($8db73abdae598f69$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $8db73abdae598f69$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $8db73abdae598f69$var$_formDataSupportsSubmitter = true;
    }
    return $8db73abdae598f69$var$_formDataSupportsSubmitter;
}
const $8db73abdae598f69$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $8db73abdae598f69$var$getFormEncType(encType) {
    if (encType != null && !$8db73abdae598f69$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $8db73abdae598f69$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($8db73abdae598f69$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $eseEd.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $8db73abdae598f69$var$defaultMethod;
        encType = $8db73abdae598f69$var$getFormEncType(target.getAttribute("enctype")) || $8db73abdae598f69$var$defaultEncType;
        formData = new FormData(target);
    } else if ($8db73abdae598f69$var$isButtonElement(target) || $8db73abdae598f69$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $eseEd.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $8db73abdae598f69$var$defaultMethod;
        encType = $8db73abdae598f69$var$getFormEncType(target.getAttribute("formenctype")) || $8db73abdae598f69$var$getFormEncType(form.getAttribute("enctype")) || $8db73abdae598f69$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$8db73abdae598f69$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($8db73abdae598f69$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $8db73abdae598f69$var$defaultMethod;
        action = null;
        encType = $8db73abdae598f69$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $8db73abdae598f69$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $8db73abdae598f69$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $8db73abdae598f69$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $8db73abdae598f69$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $8db73abdae598f69$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $8db73abdae598f69$export$1f3f55432a00e06d(routes, opts) {
    return (0, $eseEd.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8db73abdae598f69$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $eseEd.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8db73abdae598f69$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $30t8d.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8db73abdae598f69$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $eseEd.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8db73abdae598f69$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $eseEd.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8db73abdae598f69$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $30t8d.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8db73abdae598f69$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $8db73abdae598f69$var$_extends({}, state, {
        errors: $8db73abdae598f69$var$deserializeErrors(state.errors)
    });
    return state;
}
function $8db73abdae598f69$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $eseEd.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $8db73abdae598f69$export$7ad602f0e94e62d1 = /*#__PURE__*/ $1v5pe.createContext({
    isTransitioning: false
});
const $8db73abdae598f69$export$148fd98d095596d4 = /*#__PURE__*/ $1v5pe.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $8db73abdae598f69$var$START_TRANSITION = "startTransition";
const $8db73abdae598f69$var$startTransitionImpl = $1v5pe[$8db73abdae598f69$var$START_TRANSITION];
const $8db73abdae598f69$var$FLUSH_SYNC = "flushSync";
const $8db73abdae598f69$var$flushSyncImpl = $fBuCt[$8db73abdae598f69$var$FLUSH_SYNC];
const $8db73abdae598f69$var$USE_ID = "useId";
const $8db73abdae598f69$var$useIdImpl = $1v5pe[$8db73abdae598f69$var$USE_ID];
function $8db73abdae598f69$var$startTransitionSafe(cb) {
    if ($8db73abdae598f69$var$startTransitionImpl) $8db73abdae598f69$var$startTransitionImpl(cb);
    else cb();
}
function $8db73abdae598f69$var$flushSyncSafe(cb) {
    if ($8db73abdae598f69$var$flushSyncImpl) $8db73abdae598f69$var$flushSyncImpl(cb);
    else cb();
}
class $8db73abdae598f69$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8db73abdae598f69$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1v5pe.useState(router.state);
    let [pendingState, setPendingState] = $1v5pe.useState();
    let [vtContext, setVtContext] = $1v5pe.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $1v5pe.useState();
    let [transition, setTransition] = $1v5pe.useState();
    let [interruption, setInterruption] = $1v5pe.useState();
    let fetcherData = $1v5pe.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $1v5pe.useCallback((cb)=>{
        if (v7_startTransition) $8db73abdae598f69$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $1v5pe.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $8db73abdae598f69$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $8db73abdae598f69$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $8db73abdae598f69$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $8db73abdae598f69$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $8db73abdae598f69$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1v5pe.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $1v5pe.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $8db73abdae598f69$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $1v5pe.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $1v5pe.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $1v5pe.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $1v5pe.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1v5pe.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1v5pe.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $1v5pe.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement((0, $30t8d.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1v5pe.createElement((0, $30t8d.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $1v5pe.createElement($8db73abdae598f69$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $1v5pe.createElement($8db73abdae598f69$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $1v5pe.createElement((0, $30t8d.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1v5pe.createElement($8db73abdae598f69$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $8db73abdae598f69$var$MemoizedDataRoutes = /*#__PURE__*/ $1v5pe.memo($8db73abdae598f69$var$DataRoutes);
function $8db73abdae598f69$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $30t8d.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $8db73abdae598f69$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $1v5pe.useRef();
    if (historyRef.current == null) historyRef.current = (0, $eseEd.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1v5pe.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1v5pe.useCallback((newState)=>{
        v7_startTransition && $8db73abdae598f69$var$startTransitionImpl ? $8db73abdae598f69$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1v5pe.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1v5pe.createElement((0, $30t8d.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $8db73abdae598f69$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $1v5pe.useRef();
    if (historyRef.current == null) historyRef.current = (0, $eseEd.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1v5pe.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1v5pe.useCallback((newState)=>{
        v7_startTransition && $8db73abdae598f69$var$startTransitionImpl ? $8db73abdae598f69$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1v5pe.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1v5pe.createElement((0, $30t8d.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $8db73abdae598f69$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $1v5pe.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1v5pe.useCallback((newState)=>{
        v7_startTransition && $8db73abdae598f69$var$startTransitionImpl ? $8db73abdae598f69$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1v5pe.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1v5pe.createElement((0, $30t8d.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $8db73abdae598f69$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $8db73abdae598f69$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $8db73abdae598f69$export$a6c7ac8248d6e38a = /*#__PURE__*/ $1v5pe.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $8db73abdae598f69$var$_objectWithoutPropertiesLoose(_ref7, $8db73abdae598f69$var$_excluded);
    let { basename: basename } = $1v5pe.useContext((0, $30t8d.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $8db73abdae598f69$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($8db73abdae598f69$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $eseEd.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $30t8d.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $8db73abdae598f69$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $1v5pe.createElement("a", $8db73abdae598f69$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $8db73abdae598f69$export$b0d92dbee9b5b60d = /*#__PURE__*/ $1v5pe.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $8db73abdae598f69$var$_objectWithoutPropertiesLoose(_ref8, $8db73abdae598f69$var$_excluded2);
    let path = (0, $30t8d.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $30t8d.useLocation)();
    let routerState = $1v5pe.useContext((0, $30t8d.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $1v5pe.useContext((0, $30t8d.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8db73abdae598f69$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $eseEd.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $1v5pe.createElement($8db73abdae598f69$export$a6c7ac8248d6e38a, $8db73abdae598f69$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $8db73abdae598f69$export$a7fed597f4b8afd8 = /*#__PURE__*/ $1v5pe.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $8db73abdae598f69$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $8db73abdae598f69$var$_objectWithoutPropertiesLoose(_ref9, $8db73abdae598f69$var$_excluded3);
    let submit = $8db73abdae598f69$export$47c85c6e3a081d3();
    let formAction = $8db73abdae598f69$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $1v5pe.createElement("form", $8db73abdae598f69$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $8db73abdae598f69$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $8db73abdae598f69$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $8db73abdae598f69$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($8db73abdae598f69$var$DataRouterHook || ($8db73abdae598f69$var$DataRouterHook = {}));
var $8db73abdae598f69$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($8db73abdae598f69$var$DataRouterStateHook || ($8db73abdae598f69$var$DataRouterStateHook = {}));
// Internal hooks
function $8db73abdae598f69$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $8db73abdae598f69$var$useDataRouterContext(hookName) {
    let ctx = $1v5pe.useContext((0, $30t8d.UNSAFE_DataRouterContext));
    !ctx && (0, $eseEd.UNSAFE_invariant)(false);
    return ctx;
}
function $8db73abdae598f69$var$useDataRouterState(hookName) {
    let state = $1v5pe.useContext((0, $30t8d.UNSAFE_DataRouterStateContext));
    !state && (0, $eseEd.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $8db73abdae598f69$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $30t8d.useNavigate)();
    let location = (0, $30t8d.useLocation)();
    let path = (0, $30t8d.useResolvedPath)(to, {
        relative: relative
    });
    return $1v5pe.useCallback((event)=>{
        if ($8db73abdae598f69$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $eseEd.createPath)(location) === (0, $eseEd.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $8db73abdae598f69$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $1v5pe.useRef($8db73abdae598f69$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $1v5pe.useRef(false);
    let location = (0, $30t8d.useLocation)();
    let searchParams = $1v5pe.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $8db73abdae598f69$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $30t8d.useNavigate)();
    let setSearchParams = $1v5pe.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $8db73abdae598f69$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $8db73abdae598f69$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $8db73abdae598f69$var$fetcherId = 0;
let $8db73abdae598f69$var$getUniqueFetcherId = ()=>"__" + String(++$8db73abdae598f69$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $8db73abdae598f69$export$47c85c6e3a081d3() {
    let { router: router } = $8db73abdae598f69$var$useDataRouterContext($8db73abdae598f69$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $1v5pe.useContext((0, $30t8d.UNSAFE_NavigationContext));
    let currentRouteId = (0, $30t8d.UNSAFE_useRouteId)();
    return $1v5pe.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $8db73abdae598f69$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $8db73abdae598f69$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $8db73abdae598f69$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $8db73abdae598f69$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $1v5pe.useContext((0, $30t8d.UNSAFE_NavigationContext));
    let routeContext = $1v5pe.useContext((0, $30t8d.UNSAFE_RouteContext));
    !routeContext && (0, $eseEd.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $8db73abdae598f69$var$_extends({}, (0, $30t8d.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $30t8d.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $eseEd.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $eseEd.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $8db73abdae598f69$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $8db73abdae598f69$var$useDataRouterContext($8db73abdae598f69$var$DataRouterHook.UseFetcher);
    let state = $8db73abdae598f69$var$useDataRouterState($8db73abdae598f69$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $1v5pe.useContext($8db73abdae598f69$export$148fd98d095596d4);
    let route = $1v5pe.useContext((0, $30t8d.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $eseEd.UNSAFE_invariant)(false);
    !route && (0, $eseEd.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $eseEd.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $8db73abdae598f69$var$useIdImpl ? $8db73abdae598f69$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $1v5pe.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($8db73abdae598f69$var$getUniqueFetcherId());
    // Registration/cleanup
    $1v5pe.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $1v5pe.useCallback((href, opts)=>{
        !routeId && (0, $eseEd.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $8db73abdae598f69$export$47c85c6e3a081d3();
    let submit = $1v5pe.useCallback((target, opts)=>{
        submitImpl(target, $8db73abdae598f69$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $1v5pe.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $1v5pe.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $1v5pe.createElement($8db73abdae598f69$export$a7fed597f4b8afd8, $8db73abdae598f69$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $eseEd.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $1v5pe.useMemo(()=>$8db73abdae598f69$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $8db73abdae598f69$export$fa996778a3a31087() {
    let state = $8db73abdae598f69$var$useDataRouterState($8db73abdae598f69$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $8db73abdae598f69$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $8db73abdae598f69$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $8db73abdae598f69$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $8db73abdae598f69$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $8db73abdae598f69$var$useDataRouterContext($8db73abdae598f69$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $8db73abdae598f69$var$useDataRouterState($8db73abdae598f69$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $1v5pe.useContext((0, $30t8d.UNSAFE_NavigationContext));
    let location = (0, $30t8d.useLocation)();
    let matches = (0, $30t8d.useMatches)();
    let navigation = (0, $30t8d.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $1v5pe.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $8db73abdae598f69$var$usePageHide($1v5pe.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $8db73abdae598f69$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $8db73abdae598f69$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($8db73abdae598f69$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1v5pe.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $8db73abdae598f69$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $8db73abdae598f69$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1v5pe.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($8db73abdae598f69$var$_extends({}, location, {
                    pathname: (0, $eseEd.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($8db73abdae598f69$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1v5pe.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8db73abdae598f69$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $1v5pe.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8db73abdae598f69$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $1v5pe.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $8db73abdae598f69$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $30t8d.useBlocker)(when);
    $1v5pe.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $1v5pe.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $8db73abdae598f69$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $1v5pe.useContext($8db73abdae598f69$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $eseEd.UNSAFE_invariant)(false);
    let { basename: basename } = $8db73abdae598f69$var$useDataRouterContext($8db73abdae598f69$var$DataRouterHook.useViewTransitionState);
    let path = (0, $30t8d.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $eseEd.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $eseEd.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $eseEd.matchPath)(path.pathname, nextPath) != null || (0, $eseEd.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("eseEd", function(module, exports) {
$parcel$export(module.exports, "Action", () => $a85f0af1797bd60c$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $a85f0af1797bd60c$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $a85f0af1797bd60c$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $a85f0af1797bd60c$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $a85f0af1797bd60c$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $a85f0af1797bd60c$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $a85f0af1797bd60c$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $a85f0af1797bd60c$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $a85f0af1797bd60c$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $a85f0af1797bd60c$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $a85f0af1797bd60c$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $a85f0af1797bd60c$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $a85f0af1797bd60c$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $a85f0af1797bd60c$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $a85f0af1797bd60c$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $a85f0af1797bd60c$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $a85f0af1797bd60c$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $a85f0af1797bd60c$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $a85f0af1797bd60c$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $a85f0af1797bd60c$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $a85f0af1797bd60c$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a85f0af1797bd60c$var$_extends() {
    $a85f0af1797bd60c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a85f0af1797bd60c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a85f0af1797bd60c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a85f0af1797bd60c$export$e19cd5f9376f8cee || ($a85f0af1797bd60c$export$e19cd5f9376f8cee = {}));
const $a85f0af1797bd60c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a85f0af1797bd60c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a85f0af1797bd60c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a85f0af1797bd60c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a85f0af1797bd60c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a85f0af1797bd60c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a85f0af1797bd60c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a85f0af1797bd60c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a85f0af1797bd60c$export$fe53371bee54353d(to);
    }
    return $a85f0af1797bd60c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a85f0af1797bd60c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a85f0af1797bd60c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a85f0af1797bd60c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a85f0af1797bd60c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a85f0af1797bd60c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a85f0af1797bd60c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a85f0af1797bd60c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a85f0af1797bd60c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a85f0af1797bd60c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a85f0af1797bd60c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a85f0af1797bd60c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a85f0af1797bd60c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a85f0af1797bd60c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a85f0af1797bd60c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a85f0af1797bd60c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a85f0af1797bd60c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a85f0af1797bd60c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a85f0af1797bd60c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Push;
        let location = $a85f0af1797bd60c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a85f0af1797bd60c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Replace;
        let location = $a85f0af1797bd60c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a85f0af1797bd60c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a85f0af1797bd60c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a85f0af1797bd60c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a85f0af1797bd60c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a85f0af1797bd60c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a85f0af1797bd60c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a85f0af1797bd60c$var$ResultType || ($a85f0af1797bd60c$var$ResultType = {}));
const $a85f0af1797bd60c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a85f0af1797bd60c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a85f0af1797bd60c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a85f0af1797bd60c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a85f0af1797bd60c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a85f0af1797bd60c$var$isIndexRoute(route)) {
            let indexRoute = $a85f0af1797bd60c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a85f0af1797bd60c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a85f0af1797bd60c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $a85f0af1797bd60c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $a85f0af1797bd60c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $a85f0af1797bd60c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $a85f0af1797bd60c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a85f0af1797bd60c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a85f0af1797bd60c$var$flattenRoutes(routes);
    $a85f0af1797bd60c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $a85f0af1797bd60c$export$30d21fd6d7295f52(pathname);
        matches = $a85f0af1797bd60c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $a85f0af1797bd60c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a85f0af1797bd60c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a85f0af1797bd60c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a85f0af1797bd60c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a85f0af1797bd60c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a85f0af1797bd60c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a85f0af1797bd60c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a85f0af1797bd60c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a85f0af1797bd60c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a85f0af1797bd60c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a85f0af1797bd60c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a85f0af1797bd60c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a85f0af1797bd60c$var$paramRe = /^:[\w-]+$/;
const $a85f0af1797bd60c$var$dynamicSegmentValue = 3;
const $a85f0af1797bd60c$var$indexRouteValue = 2;
const $a85f0af1797bd60c$var$emptySegmentValue = 1;
const $a85f0af1797bd60c$var$staticSegmentValue = 10;
const $a85f0af1797bd60c$var$splatPenalty = -2;
const $a85f0af1797bd60c$var$isSplat = (s)=>s === "*";
function $a85f0af1797bd60c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a85f0af1797bd60c$var$isSplat)) initialScore += $a85f0af1797bd60c$var$splatPenalty;
    if (index) initialScore += $a85f0af1797bd60c$var$indexRouteValue;
    return segments.filter((s)=>!$a85f0af1797bd60c$var$isSplat(s)).reduce((score, segment)=>score + ($a85f0af1797bd60c$var$paramRe.test(segment) ? $a85f0af1797bd60c$var$dynamicSegmentValue : segment === "" ? $a85f0af1797bd60c$var$emptySegmentValue : $a85f0af1797bd60c$var$staticSegmentValue), initialScore);
}
function $a85f0af1797bd60c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a85f0af1797bd60c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a85f0af1797bd60c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $a85f0af1797bd60c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a85f0af1797bd60c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a85f0af1797bd60c$export$a5c6d149b50c1d86($a85f0af1797bd60c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a85f0af1797bd60c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $a85f0af1797bd60c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a85f0af1797bd60c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a85f0af1797bd60c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $a85f0af1797bd60c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a85f0af1797bd60c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a85f0af1797bd60c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a85f0af1797bd60c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a85f0af1797bd60c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a85f0af1797bd60c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a85f0af1797bd60c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $a85f0af1797bd60c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a85f0af1797bd60c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $a85f0af1797bd60c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $a85f0af1797bd60c$var$normalizeSearch(search),
        hash: $a85f0af1797bd60c$var$normalizeHash(hash)
    };
}
function $a85f0af1797bd60c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a85f0af1797bd60c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a85f0af1797bd60c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a85f0af1797bd60c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a85f0af1797bd60c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a85f0af1797bd60c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a85f0af1797bd60c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a85f0af1797bd60c$var$_extends({}, toArg);
        $a85f0af1797bd60c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a85f0af1797bd60c$var$getInvalidPathError("?", "pathname", "search", to));
        $a85f0af1797bd60c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a85f0af1797bd60c$var$getInvalidPathError("#", "pathname", "hash", to));
        $a85f0af1797bd60c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a85f0af1797bd60c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a85f0af1797bd60c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a85f0af1797bd60c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a85f0af1797bd60c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $a85f0af1797bd60c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a85f0af1797bd60c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a85f0af1797bd60c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a85f0af1797bd60c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $a85f0af1797bd60c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a85f0af1797bd60c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a85f0af1797bd60c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $a85f0af1797bd60c$export$4051a07651545597(data, init) {
    return new $a85f0af1797bd60c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $a85f0af1797bd60c$export$42a99a7a4bc0e76a extends Error {
}
class $a85f0af1797bd60c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a85f0af1797bd60c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a85f0af1797bd60c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a85f0af1797bd60c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a85f0af1797bd60c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a85f0af1797bd60c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a85f0af1797bd60c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a85f0af1797bd60c$var$unwrapTrackedPromise(value) {
    if (!$a85f0af1797bd60c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $a85f0af1797bd60c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a85f0af1797bd60c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a85f0af1797bd60c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a85f0af1797bd60c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a85f0af1797bd60c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a85f0af1797bd60c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a85f0af1797bd60c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $a85f0af1797bd60c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a85f0af1797bd60c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a85f0af1797bd60c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a85f0af1797bd60c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a85f0af1797bd60c$var$validMutationMethods = new Set($a85f0af1797bd60c$var$validMutationMethodsArr);
const $a85f0af1797bd60c$var$validRequestMethodsArr = [
    "get",
    ...$a85f0af1797bd60c$var$validMutationMethodsArr
];
const $a85f0af1797bd60c$var$validRequestMethods = new Set($a85f0af1797bd60c$var$validRequestMethodsArr);
const $a85f0af1797bd60c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a85f0af1797bd60c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a85f0af1797bd60c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a85f0af1797bd60c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a85f0af1797bd60c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a85f0af1797bd60c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a85f0af1797bd60c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a85f0af1797bd60c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a85f0af1797bd60c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a85f0af1797bd60c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a85f0af1797bd60c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a85f0af1797bd60c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $a85f0af1797bd60c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $a85f0af1797bd60c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a85f0af1797bd60c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a85f0af1797bd60c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a85f0af1797bd60c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$a85f0af1797bd60c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$a85f0af1797bd60c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a85f0af1797bd60c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $a85f0af1797bd60c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a85f0af1797bd60c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a85f0af1797bd60c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a85f0af1797bd60c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a85f0af1797bd60c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a85f0af1797bd60c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a85f0af1797bd60c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a85f0af1797bd60c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a85f0af1797bd60c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a85f0af1797bd60c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a85f0af1797bd60c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a85f0af1797bd60c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a85f0af1797bd60c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a85f0af1797bd60c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a85f0af1797bd60c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a85f0af1797bd60c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a85f0af1797bd60c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a85f0af1797bd60c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a85f0af1797bd60c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $a85f0af1797bd60c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $a85f0af1797bd60c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a85f0af1797bd60c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a85f0af1797bd60c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $a85f0af1797bd60c$var$findNearestBoundary(matches).route.id,
            {
                type: $a85f0af1797bd60c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $a85f0af1797bd60c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($a85f0af1797bd60c$var$isErrorResult(result) && $a85f0af1797bd60c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $a85f0af1797bd60c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $a85f0af1797bd60c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a85f0af1797bd60c$var$_extends({
            matches: updatedMatches || matches
        }, $a85f0af1797bd60c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a85f0af1797bd60c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a85f0af1797bd60c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $a85f0af1797bd60c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $a85f0af1797bd60c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $a85f0af1797bd60c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a85f0af1797bd60c$var$ResultType.error,
            error: $a85f0af1797bd60c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a85f0af1797bd60c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $a85f0af1797bd60c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a85f0af1797bd60c$var$isDeferredResult(result)) throw $a85f0af1797bd60c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($a85f0af1797bd60c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a85f0af1797bd60c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $a85f0af1797bd60c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a85f0af1797bd60c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a85f0af1797bd60c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($a85f0af1797bd60c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a85f0af1797bd60c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a85f0af1797bd60c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a85f0af1797bd60c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $a85f0af1797bd60c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a85f0af1797bd60c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $a85f0af1797bd60c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a85f0af1797bd60c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $a85f0af1797bd60c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a85f0af1797bd60c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $a85f0af1797bd60c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a85f0af1797bd60c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a85f0af1797bd60c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $a85f0af1797bd60c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a85f0af1797bd60c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a85f0af1797bd60c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a85f0af1797bd60c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $a85f0af1797bd60c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a85f0af1797bd60c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a85f0af1797bd60c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a85f0af1797bd60c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $a85f0af1797bd60c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a85f0af1797bd60c$var$isRedirectResult(actionResult) || $a85f0af1797bd60c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a85f0af1797bd60c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a85f0af1797bd60c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a85f0af1797bd60c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a85f0af1797bd60c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a85f0af1797bd60c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a85f0af1797bd60c$var$isDeferredResult(actionResult)) throw $a85f0af1797bd60c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a85f0af1797bd60c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a85f0af1797bd60c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a85f0af1797bd60c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a85f0af1797bd60c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a85f0af1797bd60c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a85f0af1797bd60c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a85f0af1797bd60c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $a85f0af1797bd60c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a85f0af1797bd60c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a85f0af1797bd60c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a85f0af1797bd60c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a85f0af1797bd60c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a85f0af1797bd60c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a85f0af1797bd60c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a85f0af1797bd60c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $a85f0af1797bd60c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a85f0af1797bd60c$var$isDeferredResult(result)) result = await $a85f0af1797bd60c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a85f0af1797bd60c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a85f0af1797bd60c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a85f0af1797bd60c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a85f0af1797bd60c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a85f0af1797bd60c$export$3e9cee6b33872309(!$a85f0af1797bd60c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a85f0af1797bd60c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $a85f0af1797bd60c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $a85f0af1797bd60c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $a85f0af1797bd60c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a85f0af1797bd60c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a85f0af1797bd60c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $a85f0af1797bd60c$export$e19cd5f9376f8cee.Replace : $a85f0af1797bd60c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a85f0af1797bd60c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a85f0af1797bd60c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $a85f0af1797bd60c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a85f0af1797bd60c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a85f0af1797bd60c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $a85f0af1797bd60c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $a85f0af1797bd60c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($a85f0af1797bd60c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $a85f0af1797bd60c$var$ResultType.redirect,
                response: $a85f0af1797bd60c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $a85f0af1797bd60c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $a85f0af1797bd60c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $a85f0af1797bd60c$var$ResultType.error,
                    error: $a85f0af1797bd60c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $a85f0af1797bd60c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $a85f0af1797bd60c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a85f0af1797bd60c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $a85f0af1797bd60c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a85f0af1797bd60c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a85f0af1797bd60c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a85f0af1797bd60c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a85f0af1797bd60c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a85f0af1797bd60c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a85f0af1797bd60c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a85f0af1797bd60c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $a85f0af1797bd60c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $a85f0af1797bd60c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a85f0af1797bd60c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a85f0af1797bd60c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $a85f0af1797bd60c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $a85f0af1797bd60c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $a85f0af1797bd60c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $a85f0af1797bd60c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $a85f0af1797bd60c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a85f0af1797bd60c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $a85f0af1797bd60c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a85f0af1797bd60c$export$4d0306f8f6a4585b = Symbol("deferred");
function $a85f0af1797bd60c$export$3336b097a6fbc59a(routes, opts) {
    $a85f0af1797bd60c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a85f0af1797bd60c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a85f0af1797bd60c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a85f0af1797bd60c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a85f0af1797bd60c$var$createLocation("", $a85f0af1797bd60c$export$fe53371bee54353d(url), null, "default");
        let matches = $a85f0af1797bd60c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a85f0af1797bd60c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a85f0af1797bd60c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a85f0af1797bd60c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a85f0af1797bd60c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a85f0af1797bd60c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($a85f0af1797bd60c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a85f0af1797bd60c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a85f0af1797bd60c$var$createLocation("", $a85f0af1797bd60c$export$fe53371bee54353d(url), null, "default");
        let matches = $a85f0af1797bd60c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a85f0af1797bd60c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a85f0af1797bd60c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a85f0af1797bd60c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a85f0af1797bd60c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a85f0af1797bd60c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a85f0af1797bd60c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($a85f0af1797bd60c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a85f0af1797bd60c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $a85f0af1797bd60c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a85f0af1797bd60c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a85f0af1797bd60c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $a85f0af1797bd60c$var$isResponse(result) ? result : $a85f0af1797bd60c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($a85f0af1797bd60c$var$isDataStrategyResult(e) && $a85f0af1797bd60c$var$isResponse(e.result)) {
                if (e.type === $a85f0af1797bd60c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a85f0af1797bd60c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a85f0af1797bd60c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a85f0af1797bd60c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $a85f0af1797bd60c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a85f0af1797bd60c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($a85f0af1797bd60c$var$isDeferredResult(result)) {
            let error = $a85f0af1797bd60c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a85f0af1797bd60c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a85f0af1797bd60c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($a85f0af1797bd60c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $a85f0af1797bd60c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $a85f0af1797bd60c$var$_extends({}, context, {
                statusCode: $a85f0af1797bd60c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $a85f0af1797bd60c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $a85f0af1797bd60c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a85f0af1797bd60c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1]) ? $a85f0af1797bd60c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $a85f0af1797bd60c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a85f0af1797bd60c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a85f0af1797bd60c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $a85f0af1797bd60c$var$callDataStrategyImpl(dataStrategy || $a85f0af1797bd60c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($a85f0af1797bd60c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $a85f0af1797bd60c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($a85f0af1797bd60c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $a85f0af1797bd60c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a85f0af1797bd60c$export$fec11da027c70692(routes, context, error) {
    let newContext = $a85f0af1797bd60c$var$_extends({}, context, {
        statusCode: $a85f0af1797bd60c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a85f0af1797bd60c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a85f0af1797bd60c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a85f0af1797bd60c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a85f0af1797bd60c$export$cae722b0cc860f13(to ? to : ".", $a85f0af1797bd60c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a85f0af1797bd60c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $a85f0af1797bd60c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a85f0af1797bd60c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a85f0af1797bd60c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a85f0af1797bd60c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a85f0af1797bd60c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a85f0af1797bd60c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a85f0af1797bd60c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a85f0af1797bd60c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a85f0af1797bd60c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a85f0af1797bd60c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a85f0af1797bd60c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a85f0af1797bd60c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a85f0af1797bd60c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a85f0af1797bd60c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a85f0af1797bd60c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a85f0af1797bd60c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a85f0af1797bd60c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a85f0af1797bd60c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a85f0af1797bd60c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a85f0af1797bd60c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $a85f0af1797bd60c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $a85f0af1797bd60c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $a85f0af1797bd60c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $a85f0af1797bd60c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $a85f0af1797bd60c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($a85f0af1797bd60c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a85f0af1797bd60c$var$shouldRevalidateLoader(match, $a85f0af1797bd60c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a85f0af1797bd60c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a85f0af1797bd60c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a85f0af1797bd60c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a85f0af1797bd60c$var$shouldRevalidateLoader(fetcherMatch, $a85f0af1797bd60c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a85f0af1797bd60c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $a85f0af1797bd60c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a85f0af1797bd60c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a85f0af1797bd60c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $a85f0af1797bd60c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $a85f0af1797bd60c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$a85f0af1797bd60c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $a85f0af1797bd60c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $a85f0af1797bd60c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$a85f0af1797bd60c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a85f0af1797bd60c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a85f0af1797bd60c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a85f0af1797bd60c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a85f0af1797bd60c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a85f0af1797bd60c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $a85f0af1797bd60c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $a85f0af1797bd60c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $a85f0af1797bd60c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $a85f0af1797bd60c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $a85f0af1797bd60c$var$ResultType.data,
                result: undefined
            });
        };
        return $a85f0af1797bd60c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $a85f0af1797bd60c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a85f0af1797bd60c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a85f0af1797bd60c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a85f0af1797bd60c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a85f0af1797bd60c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $a85f0af1797bd60c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $a85f0af1797bd60c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($a85f0af1797bd60c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a85f0af1797bd60c$var$ResultType.error,
                error: e
            };
        }
        if (type === $a85f0af1797bd60c$var$ResultType.error) return {
            type: $a85f0af1797bd60c$var$ResultType.error,
            error: new $a85f0af1797bd60c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $a85f0af1797bd60c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $a85f0af1797bd60c$var$ResultType.error) {
        if ($a85f0af1797bd60c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $a85f0af1797bd60c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $a85f0af1797bd60c$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $a85f0af1797bd60c$var$ResultType.error,
            error: result,
            statusCode: $a85f0af1797bd60c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($a85f0af1797bd60c$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $a85f0af1797bd60c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($a85f0af1797bd60c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $a85f0af1797bd60c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $a85f0af1797bd60c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $a85f0af1797bd60c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $a85f0af1797bd60c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$a85f0af1797bd60c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $a85f0af1797bd60c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $a85f0af1797bd60c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($a85f0af1797bd60c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $a85f0af1797bd60c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a85f0af1797bd60c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a85f0af1797bd60c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a85f0af1797bd60c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a85f0af1797bd60c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a85f0af1797bd60c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a85f0af1797bd60c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a85f0af1797bd60c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $a85f0af1797bd60c$export$3e9cee6b33872309(!$a85f0af1797bd60c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a85f0af1797bd60c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $a85f0af1797bd60c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a85f0af1797bd60c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($a85f0af1797bd60c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a85f0af1797bd60c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a85f0af1797bd60c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $a85f0af1797bd60c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($a85f0af1797bd60c$var$isErrorResult(result)) {
            let boundaryMatch = $a85f0af1797bd60c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a85f0af1797bd60c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a85f0af1797bd60c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a85f0af1797bd60c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a85f0af1797bd60c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a85f0af1797bd60c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a85f0af1797bd60c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a85f0af1797bd60c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a85f0af1797bd60c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $a85f0af1797bd60c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $a85f0af1797bd60c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a85f0af1797bd60c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a85f0af1797bd60c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a85f0af1797bd60c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a85f0af1797bd60c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a85f0af1797bd60c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($a85f0af1797bd60c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $a85f0af1797bd60c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a85f0af1797bd60c$export$8ccf933b0513f8d0(path) : path;
    return $a85f0af1797bd60c$export$fe53371bee54353d($a85f0af1797bd60c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a85f0af1797bd60c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a85f0af1797bd60c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $a85f0af1797bd60c$var$ResultType.data || result.type === $a85f0af1797bd60c$var$ResultType.error);
}
function $a85f0af1797bd60c$var$isRedirectDataStrategyResultResult(result) {
    return $a85f0af1797bd60c$var$isResponse(result.result) && $a85f0af1797bd60c$var$redirectStatusCodes.has(result.result.status);
}
function $a85f0af1797bd60c$var$isDeferredResult(result) {
    return result.type === $a85f0af1797bd60c$var$ResultType.deferred;
}
function $a85f0af1797bd60c$var$isErrorResult(result) {
    return result.type === $a85f0af1797bd60c$var$ResultType.error;
}
function $a85f0af1797bd60c$var$isRedirectResult(result) {
    return (result && result.type) === $a85f0af1797bd60c$var$ResultType.redirect;
}
function $a85f0af1797bd60c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $a85f0af1797bd60c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a85f0af1797bd60c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a85f0af1797bd60c$var$isRedirectResponse(result) {
    if (!$a85f0af1797bd60c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a85f0af1797bd60c$var$isValidMethod(method) {
    return $a85f0af1797bd60c$var$validRequestMethods.has(method.toLowerCase());
}
function $a85f0af1797bd60c$var$isMutationMethod(method) {
    return $a85f0af1797bd60c$var$validMutationMethods.has(method.toLowerCase());
}
async function $a85f0af1797bd60c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a85f0af1797bd60c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a85f0af1797bd60c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $a85f0af1797bd60c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $a85f0af1797bd60c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($a85f0af1797bd60c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $a85f0af1797bd60c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $a85f0af1797bd60c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $a85f0af1797bd60c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a85f0af1797bd60c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a85f0af1797bd60c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a85f0af1797bd60c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a85f0af1797bd60c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a85f0af1797bd60c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a85f0af1797bd60c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a85f0af1797bd60c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a85f0af1797bd60c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a85f0af1797bd60c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a85f0af1797bd60c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a85f0af1797bd60c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a85f0af1797bd60c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a85f0af1797bd60c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a85f0af1797bd60c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a85f0af1797bd60c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a85f0af1797bd60c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a85f0af1797bd60c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a85f0af1797bd60c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a85f0af1797bd60c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("30t8d", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $2307f812bd593d80$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $2307f812bd593d80$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $2307f812bd593d80$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $2307f812bd593d80$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $2307f812bd593d80$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $2307f812bd593d80$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $2307f812bd593d80$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $2307f812bd593d80$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $2307f812bd593d80$export$9770f232ac06a008);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $2307f812bd593d80$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $2307f812bd593d80$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $2307f812bd593d80$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $2307f812bd593d80$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $2307f812bd593d80$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $2307f812bd593d80$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Outlet", () => $2307f812bd593d80$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $2307f812bd593d80$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $2307f812bd593d80$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $2307f812bd593d80$export$52b333d321859367);
/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $eseEd = parcelRequire("eseEd");
function $2307f812bd593d80$var$_extends() {
    $2307f812bd593d80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2307f812bd593d80$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2307f812bd593d80$export$3add0d5dce533e2e = /*#__PURE__*/ $1v5pe.createContext(null);
const $2307f812bd593d80$export$145dfa71566a64dc = /*#__PURE__*/ $1v5pe.createContext(null);
const $2307f812bd593d80$var$AwaitContext = /*#__PURE__*/ $1v5pe.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2307f812bd593d80$export$26749e8557646306 = /*#__PURE__*/ $1v5pe.createContext(null);
const $2307f812bd593d80$export$c7914228fb69b0f5 = /*#__PURE__*/ $1v5pe.createContext(null);
const $2307f812bd593d80$export$9072aa6dd1f93057 = /*#__PURE__*/ $1v5pe.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2307f812bd593d80$var$RouteErrorContext = /*#__PURE__*/ $1v5pe.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $2307f812bd593d80$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2307f812bd593d80$export$9c954a9d03d32f4a() && (0, $eseEd.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $1v5pe.useContext($2307f812bd593d80$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2307f812bd593d80$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $eseEd.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $2307f812bd593d80$export$9c954a9d03d32f4a() {
    return $1v5pe.useContext($2307f812bd593d80$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $2307f812bd593d80$export$45d76561a5302f2b() {
    !$2307f812bd593d80$export$9c954a9d03d32f4a() && (0, $eseEd.UNSAFE_invariant)(false);
    return $1v5pe.useContext($2307f812bd593d80$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $2307f812bd593d80$export$1b3f31771c5d07c() {
    return $1v5pe.useContext($2307f812bd593d80$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $2307f812bd593d80$export$6c330e8992e8a295(pattern) {
    !$2307f812bd593d80$export$9c954a9d03d32f4a() && (0, $eseEd.UNSAFE_invariant)(false);
    let { pathname: pathname } = $2307f812bd593d80$export$45d76561a5302f2b();
    return $1v5pe.useMemo(()=>(0, $eseEd.matchPath)(pattern, (0, $eseEd.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2307f812bd593d80$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2307f812bd593d80$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $1v5pe.useContext($2307f812bd593d80$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1v5pe.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $2307f812bd593d80$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2307f812bd593d80$var$useNavigateStable() : $2307f812bd593d80$var$useNavigateUnstable();
}
function $2307f812bd593d80$var$useNavigateUnstable() {
    !$2307f812bd593d80$export$9c954a9d03d32f4a() && (0, $eseEd.UNSAFE_invariant)(false);
    let dataRouterContext = $1v5pe.useContext($2307f812bd593d80$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $1v5pe.useContext($2307f812bd593d80$export$26749e8557646306);
    let { matches: matches } = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2307f812bd593d80$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $eseEd.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $1v5pe.useRef(false);
    $2307f812bd593d80$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1v5pe.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $eseEd.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $eseEd.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2307f812bd593d80$var$OutletContext = /*#__PURE__*/ $1v5pe.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $2307f812bd593d80$export$4138103a3ae699cc() {
    return $1v5pe.useContext($2307f812bd593d80$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $2307f812bd593d80$export$a3be3530d8e40d0b(context) {
    let outlet = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $2307f812bd593d80$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $2307f812bd593d80$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $1v5pe.useContext($2307f812bd593d80$export$26749e8557646306);
    let { matches: matches } = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2307f812bd593d80$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $eseEd.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $1v5pe.useMemo(()=>(0, $eseEd.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $2307f812bd593d80$export$5d3fca4a98652595(routes, locationArg) {
    return $2307f812bd593d80$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2307f812bd593d80$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2307f812bd593d80$export$9c954a9d03d32f4a() && (0, $eseEd.UNSAFE_invariant)(false);
    let { navigator: navigator } = $1v5pe.useContext($2307f812bd593d80$export$26749e8557646306);
    let { matches: parentMatches } = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2307f812bd593d80$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $eseEd.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $eseEd.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $eseEd.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2307f812bd593d80$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $eseEd.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $eseEd.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2307f812bd593d80$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $eseEd.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2307f812bd593d80$var$DefaultErrorComponent() {
    let error = $2307f812bd593d80$export$ed527bf60f6e05f2();
    let message = (0, $eseEd.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $1v5pe.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $1v5pe.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2307f812bd593d80$var$defaultErrorElement = /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$DefaultErrorComponent, null);
class $2307f812bd593d80$var$RenderErrorBoundary extends $1v5pe.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2307f812bd593d80$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $1v5pe.useContext($2307f812bd593d80$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2307f812bd593d80$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $eseEd.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2307f812bd593d80$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2307f812bd593d80$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $1v5pe.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2307f812bd593d80$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2307f812bd593d80$var$DataRouterHook || {});
var $2307f812bd593d80$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2307f812bd593d80$var$DataRouterStateHook || {});
function $2307f812bd593d80$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2307f812bd593d80$var$useDataRouterContext(hookName) {
    let ctx = $1v5pe.useContext($2307f812bd593d80$export$3add0d5dce533e2e);
    !ctx && (0, $eseEd.UNSAFE_invariant)(false);
    return ctx;
}
function $2307f812bd593d80$var$useDataRouterState(hookName) {
    let state = $1v5pe.useContext($2307f812bd593d80$export$145dfa71566a64dc);
    !state && (0, $eseEd.UNSAFE_invariant)(false);
    return state;
}
function $2307f812bd593d80$var$useRouteContext(hookName) {
    let route = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057);
    !route && (0, $eseEd.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2307f812bd593d80$var$useCurrentRouteId(hookName) {
    let route = $2307f812bd593d80$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $eseEd.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2307f812bd593d80$export$5fc8298006ad9e58() {
    return $2307f812bd593d80$var$useCurrentRouteId($2307f812bd593d80$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2307f812bd593d80$export$d0fd4b7106de2769() {
    let state = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2307f812bd593d80$export$600dc272ed516c15() {
    let dataRouterContext = $2307f812bd593d80$var$useDataRouterContext($2307f812bd593d80$var$DataRouterHook.UseRevalidator);
    let state = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseRevalidator);
    return $1v5pe.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2307f812bd593d80$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseMatches);
    return $1v5pe.useMemo(()=>matches.map((m)=>(0, $eseEd.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2307f812bd593d80$export$1448a5050d252c4d() {
    let state = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2307f812bd593d80$var$useCurrentRouteId($2307f812bd593d80$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2307f812bd593d80$export$fd5d37484eab868d(routeId) {
    let state = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2307f812bd593d80$export$fdc00f3f26066d5e() {
    let state = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseActionData);
    let routeId = $2307f812bd593d80$var$useCurrentRouteId($2307f812bd593d80$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2307f812bd593d80$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $1v5pe.useContext($2307f812bd593d80$var$RouteErrorContext);
    let state = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseRouteError);
    let routeId = $2307f812bd593d80$var$useCurrentRouteId($2307f812bd593d80$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2307f812bd593d80$export$78a72ddb39bdd145() {
    let value = $1v5pe.useContext($2307f812bd593d80$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2307f812bd593d80$export$17f53340677d5831() {
    let value = $1v5pe.useContext($2307f812bd593d80$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2307f812bd593d80$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2307f812bd593d80$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2307f812bd593d80$var$useDataRouterContext($2307f812bd593d80$var$DataRouterHook.UseBlocker);
    let state = $2307f812bd593d80$var$useDataRouterState($2307f812bd593d80$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $1v5pe.useState("");
    let blockerFunction = $1v5pe.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2307f812bd593d80$var$_extends({}, currentLocation, {
                pathname: (0, $eseEd.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2307f812bd593d80$var$_extends({}, nextLocation, {
                pathname: (0, $eseEd.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $1v5pe.useEffect(()=>{
        let key = String(++$2307f812bd593d80$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $1v5pe.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $eseEd.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2307f812bd593d80$var$useNavigateStable() {
    let { router: router } = $2307f812bd593d80$var$useDataRouterContext($2307f812bd593d80$var$DataRouterHook.UseNavigateStable);
    let id = $2307f812bd593d80$var$useCurrentRouteId($2307f812bd593d80$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $1v5pe.useRef(false);
    $2307f812bd593d80$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1v5pe.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2307f812bd593d80$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2307f812bd593d80$var$alreadyWarned = {};
function $2307f812bd593d80$var$warningOnce(key, cond, message) {
    if (!cond && !$2307f812bd593d80$var$alreadyWarned[key]) $2307f812bd593d80$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2307f812bd593d80$var$START_TRANSITION = "startTransition";
const $2307f812bd593d80$var$startTransitionImpl = $1v5pe[$2307f812bd593d80$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2307f812bd593d80$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1v5pe.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1v5pe.useCallback((newState)=>{
        if (v7_startTransition && $2307f812bd593d80$var$startTransitionImpl) $2307f812bd593d80$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1v5pe.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $1v5pe.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1v5pe.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1v5pe.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2307f812bd593d80$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2307f812bd593d80$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $2307f812bd593d80$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $1v5pe.useRef();
    if (historyRef.current == null) historyRef.current = (0, $eseEd.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1v5pe.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1v5pe.useCallback((newState)=>{
        v7_startTransition && $2307f812bd593d80$var$startTransitionImpl ? $2307f812bd593d80$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1v5pe.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $2307f812bd593d80$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2307f812bd593d80$export$9c954a9d03d32f4a() && (0, $eseEd.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $1v5pe.useContext($2307f812bd593d80$export$26749e8557646306);
    let { matches: matches } = $1v5pe.useContext($2307f812bd593d80$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2307f812bd593d80$export$45d76561a5302f2b();
    let navigate = $2307f812bd593d80$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $eseEd.resolveTo)(to, (0, $eseEd.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $1v5pe.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $2307f812bd593d80$export$910ae8079b2c2852(props) {
    return $2307f812bd593d80$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $2307f812bd593d80$export$e7b0ac011bb776c6(_props) {
    (0, $eseEd.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $2307f812bd593d80$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $eseEd.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2307f812bd593d80$export$9c954a9d03d32f4a() && (0, $eseEd.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $1v5pe.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2307f812bd593d80$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $eseEd.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $1v5pe.useMemo(()=>{
        let trailingPathname = (0, $eseEd.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $2307f812bd593d80$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2307f812bd593d80$export$5d3fca4a98652595($2307f812bd593d80$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2307f812bd593d80$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$ResolveAwait, null, children));
}
var $2307f812bd593d80$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2307f812bd593d80$var$AwaitRenderStatus || {});
const $2307f812bd593d80$var$neverSettledPromise = new Promise(()=>{});
class $2307f812bd593d80$var$AwaitErrorBoundary extends $1v5pe.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2307f812bd593d80$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2307f812bd593d80$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2307f812bd593d80$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $2307f812bd593d80$var$AwaitRenderStatus.error : "_data" in promise ? $2307f812bd593d80$var$AwaitRenderStatus.success : $2307f812bd593d80$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2307f812bd593d80$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2307f812bd593d80$var$AwaitRenderStatus.error && promise._error instanceof (0, $eseEd.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $2307f812bd593d80$var$neverSettledPromise;
        if (status === $2307f812bd593d80$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2307f812bd593d80$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2307f812bd593d80$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $1v5pe.createElement($2307f812bd593d80$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2307f812bd593d80$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2307f812bd593d80$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $2307f812bd593d80$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $1v5pe.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $1v5pe.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $1v5pe.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2307f812bd593d80$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2307f812bd593d80$export$e7b0ac011bb776c6) && (0, $eseEd.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $eseEd.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2307f812bd593d80$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2307f812bd593d80$export$daf73786167a7f72(matches) {
    return $2307f812bd593d80$var$_renderMatches(matches);
}
function $2307f812bd593d80$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $1v5pe.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $1v5pe.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $1v5pe.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2307f812bd593d80$export$f30f7e456d254e83(routes, opts) {
    return (0, $eseEd.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2307f812bd593d80$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $eseEd.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2307f812bd593d80$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("aX5WL", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $2d81aa6051fd745a$export$e926676385687eaf);

var $guAL2 = parcelRequire("guAL2");

var $1v5pe = parcelRequire("1v5pe");

var $eMSEP = parcelRequire("eMSEP");
var $bQOrV = parcelRequire("bQOrV");

var $b2Az1 = parcelRequire("b2Az1");

var $8TrAC = parcelRequire("8TrAC");

var $dDtM2 = parcelRequire("dDtM2");
parcelRequire("1wxU2");
var $j0FUQ = parcelRequire("j0FUQ");
const $2d81aa6051fd745a$var$errorStyles = (0, $bQOrV.xcss)({
    marginTop: 'space.800',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 'space.150'
});
const $2d81aa6051fd745a$var$errorHeaderStyles = (0, $bQOrV.xcss)({
    font: 'font.heading.medium',
    fontWeight: 'font.weight.medium'
});
const $2d81aa6051fd745a$var$errorSubheaderStyles = (0, $bQOrV.xcss)({
    font: 'font.body'
});
const $2d81aa6051fd745a$var$defaultFallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
    testId: "default-error",
    xcss: $2d81aa6051fd745a$var$errorStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8TrAC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
    xcss: $2d81aa6051fd745a$var$errorHeaderStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $dDtM2.messages).errorHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
    xcss: $2d81aa6051fd745a$var$errorSubheaderStyles
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $dDtM2.messages).errorBoundarySubheader)));
const $2d81aa6051fd745a$export$e926676385687eaf = ({ children: children, fallback: fallback })=>{
    const reportUFOError = (0, $j0FUQ.useReportUFOError)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($guAL2.ErrorBoundary, {
        fallback: fallback ?? $2d81aa6051fd745a$var$defaultFallback,
        onError: reportUFOError
    }, children);
};

});
parcelRegister("b2Az1", function(module, exports) {
$parcel$export(module.exports, "default", () => $809c3e70ee8a3d04$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $kK7WO = parcelRequire("kK7WO");
function $809c3e70ee8a3d04$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $lmviS.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $lmviS.__rest)(nextProps, [
        "values"
    ]);
    return (0, $kfP5u.shallowEqual)(nextValues, values) && (0, $kfP5u.shallowEqual)(otherProps, nextOtherProps);
}
function $809c3e70ee8a3d04$var$FormattedMessage(props) {
    var intl = (0, $kK7WO.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $1v5pe.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $1v5pe.createElement(Component, null, nodes);
    return $1v5pe.createElement($1v5pe.Fragment, null, nodes);
}
$809c3e70ee8a3d04$var$FormattedMessage.displayName = 'FormattedMessage';
var $809c3e70ee8a3d04$var$MemoizedFormattedMessage = $1v5pe.memo($809c3e70ee8a3d04$var$FormattedMessage, $809c3e70ee8a3d04$var$areEqual);
$809c3e70ee8a3d04$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $809c3e70ee8a3d04$export$2e2bcd8739ae039 = $809c3e70ee8a3d04$var$MemoizedFormattedMessage;

});
parcelRegister("lmviS", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $f8d3ef3f5f1ac4bf$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $f8d3ef3f5f1ac4bf$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $f8d3ef3f5f1ac4bf$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $f8d3ef3f5f1ac4bf$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $f8d3ef3f5f1ac4bf$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $f8d3ef3f5f1ac4bf$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArray", () => $f8d3ef3f5f1ac4bf$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f8d3ef3f5f1ac4bf$var$extendStatics = function(d, b) {
    $f8d3ef3f5f1ac4bf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f8d3ef3f5f1ac4bf$var$extendStatics(d, b);
};
function $f8d3ef3f5f1ac4bf$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f8d3ef3f5f1ac4bf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b = function() {
    $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b.apply(this, arguments);
};
function $f8d3ef3f5f1ac4bf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f8d3ef3f5f1ac4bf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f8d3ef3f5f1ac4bf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f8d3ef3f5f1ac4bf$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f8d3ef3f5f1ac4bf$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f8d3ef3f5f1ac4bf$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f8d3ef3f5f1ac4bf$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f8d3ef3f5f1ac4bf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f8d3ef3f5f1ac4bf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f8d3ef3f5f1ac4bf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f8d3ef3f5f1ac4bf$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e(o, m, p);
}
function $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f8d3ef3f5f1ac4bf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f8d3ef3f5f1ac4bf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f8d3ef3f5f1ac4bf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f8d3ef3f5f1ac4bf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f8d3ef3f5f1ac4bf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c(v) {
    return this instanceof $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c ? (this.v = v, this) : new $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c(v);
}
function $f8d3ef3f5f1ac4bf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f8d3ef3f5f1ac4bf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f8d3ef3f5f1ac4bf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45 === "function" ? $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f8d3ef3f5f1ac4bf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f8d3ef3f5f1ac4bf$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f8d3ef3f5f1ac4bf$var$ownKeys = function(o) {
    $f8d3ef3f5f1ac4bf$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f8d3ef3f5f1ac4bf$var$ownKeys(o);
};
function $f8d3ef3f5f1ac4bf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f8d3ef3f5f1ac4bf$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f8d3ef3f5f1ac4bf$var$__setModuleDefault(result, mod);
    return result;
}
function $f8d3ef3f5f1ac4bf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f8d3ef3f5f1ac4bf$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f8d3ef3f5f1ac4bf$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f8d3ef3f5f1ac4bf$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f8d3ef3f5f1ac4bf$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f8d3ef3f5f1ac4bf$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f8d3ef3f5f1ac4bf$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f8d3ef3f5f1ac4bf$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f8d3ef3f5f1ac4bf$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f8d3ef3f5f1ac4bf$export$2e2bcd8739ae039 = {
    __extends: $f8d3ef3f5f1ac4bf$export$a8ba968b8961cb8a,
    __assign: $f8d3ef3f5f1ac4bf$export$18ce0697a983be9b,
    __rest: $f8d3ef3f5f1ac4bf$export$3c9a16f847548506,
    __decorate: $f8d3ef3f5f1ac4bf$export$29e00dfd3077644b,
    __param: $f8d3ef3f5f1ac4bf$export$d5ad3fd78186038f,
    __esDecorate: $f8d3ef3f5f1ac4bf$export$3a84e1ae4e97e9b0,
    __runInitializers: $f8d3ef3f5f1ac4bf$export$d831c04e792af3d,
    __propKey: $f8d3ef3f5f1ac4bf$export$6a2a36740a146cb8,
    __setFunctionName: $f8d3ef3f5f1ac4bf$export$d1a06452d3489bc7,
    __metadata: $f8d3ef3f5f1ac4bf$export$f1db080c865becb9,
    __awaiter: $f8d3ef3f5f1ac4bf$export$1050f835b63b671e,
    __generator: $f8d3ef3f5f1ac4bf$export$67ebef60e6f28a6,
    __createBinding: $f8d3ef3f5f1ac4bf$export$45d3717a4c69092e,
    __exportStar: $f8d3ef3f5f1ac4bf$export$f33643c0debef087,
    __values: $f8d3ef3f5f1ac4bf$export$19a8beecd37a4c45,
    __read: $f8d3ef3f5f1ac4bf$export$8d051b38c9118094,
    __spread: $f8d3ef3f5f1ac4bf$export$afc72e2116322959,
    __spreadArrays: $f8d3ef3f5f1ac4bf$export$6388937ca91ccae8,
    __spreadArray: $f8d3ef3f5f1ac4bf$export$1216008129fb82ed,
    __await: $f8d3ef3f5f1ac4bf$export$10c90e4f7922046c,
    __asyncGenerator: $f8d3ef3f5f1ac4bf$export$e427f37a30a4de9b,
    __asyncDelegator: $f8d3ef3f5f1ac4bf$export$bbd80228419bb833,
    __asyncValues: $f8d3ef3f5f1ac4bf$export$e3b29a3d6162315f,
    __makeTemplateObject: $f8d3ef3f5f1ac4bf$export$4fb47efe1390b86f,
    __importStar: $f8d3ef3f5f1ac4bf$export$c21735bcef00d192,
    __importDefault: $f8d3ef3f5f1ac4bf$export$da59b14a69baef04,
    __classPrivateFieldGet: $f8d3ef3f5f1ac4bf$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f8d3ef3f5f1ac4bf$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f8d3ef3f5f1ac4bf$export$81fdc39f203e4e04,
    __addDisposableResource: $f8d3ef3f5f1ac4bf$export$88ac25d8e944e405,
    __disposeResources: $f8d3ef3f5f1ac4bf$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f8d3ef3f5f1ac4bf$export$889dfb5d17574b0b
};

});

parcelRegister("kfP5u", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $ebecd645f84dc6af$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $ebecd645f84dc6af$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $ebecd645f84dc6af$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $ebecd645f84dc6af$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $ebecd645f84dc6af$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $ebecd645f84dc6af$export$d36bdfa510afb180);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $3zCfq = parcelRequire("3zCfq");
function $ebecd645f84dc6af$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $ebecd645f84dc6af$export$45c4bbf6e55bba1f(intl) {
    $ebecd645f84dc6af$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $ebecd645f84dc6af$export$b52f8d6fc0d47415 = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, (0, $3zCfq.DEFAULT_INTL_CONFIG)), {
    textComponent: $1v5pe.Fragment
});
var $ebecd645f84dc6af$var$toKeyedReactNode = function(reactNode, key) {
    return $1v5pe.isValidElement(reactNode) ? $1v5pe.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $ebecd645f84dc6af$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $1v5pe.Children.map(children, $ebecd645f84dc6af$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $ebecd645f84dc6af$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($ebecd645f84dc6af$export$d2fd241e0b53c057(parts));
    };
}
function $ebecd645f84dc6af$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("3zCfq", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $29a24f33d5456f79$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $29a24f33d5456f79$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $29a24f33d5456f79$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $29a24f33d5456f79$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $29a24f33d5456f79$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $29a24f33d5456f79$export$4ee1db8ce44a209b);

var $lmviS = parcelRequire("lmviS");

var $iZCbV = parcelRequire("iZCbV");
parcelRequire("5wzdk");
var $diqj4 = parcelRequire("diqj4");

var $elgnH = parcelRequire("elgnH");
function $29a24f33d5456f79$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $29a24f33d5456f79$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $29a24f33d5456f79$var$defaultErrorHandler = function(error) {};
var $29a24f33d5456f79$var$defaultWarnHandler = function(warning) {};
var $29a24f33d5456f79$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $29a24f33d5456f79$var$defaultErrorHandler,
    onWarn: $29a24f33d5456f79$var$defaultWarnHandler
};
function $29a24f33d5456f79$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $29a24f33d5456f79$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $29a24f33d5456f79$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $29a24f33d5456f79$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $iZCbV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $iZCbV.strategies).variadic
    });
    var getNumberFormat = (0, $iZCbV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.number),
        strategy: (0, $iZCbV.strategies).variadic
    });
    var getPluralRules = (0, $iZCbV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $lmviS.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $iZCbV.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $iZCbV.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $diqj4.IntlMessageFormat)(message, locales, overrideFormats, (0, $lmviS.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.message),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $iZCbV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $iZCbV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.list),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getDisplayNames: (0, $iZCbV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $29a24f33d5456f79$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $iZCbV.strategies).variadic
        })
    };
}
function $29a24f33d5456f79$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $elgnH.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("iZCbV", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $03917a0203ce2598$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $03917a0203ce2598$export$c5491a8691a23b9e);
//
// Main
//
function $03917a0203ce2598$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $03917a0203ce2598$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $03917a0203ce2598$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $03917a0203ce2598$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $03917a0203ce2598$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $03917a0203ce2598$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $03917a0203ce2598$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $03917a0203ce2598$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $03917a0203ce2598$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $03917a0203ce2598$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $03917a0203ce2598$var$monadic : $03917a0203ce2598$var$variadic;
    return $03917a0203ce2598$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $03917a0203ce2598$var$strategyVariadic(fn, options) {
    return $03917a0203ce2598$var$assemble(fn, this, $03917a0203ce2598$var$variadic, options.cache.create(), options.serializer);
}
function $03917a0203ce2598$var$strategyMonadic(fn, options) {
    return $03917a0203ce2598$var$assemble(fn, this, $03917a0203ce2598$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $03917a0203ce2598$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $03917a0203ce2598$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $03917a0203ce2598$var$cacheDefault = {
    create: function create() {
        return new $03917a0203ce2598$var$ObjectWithoutPrototypeCache();
    }
};
var $03917a0203ce2598$export$c5491a8691a23b9e = {
    variadic: $03917a0203ce2598$var$strategyVariadic,
    monadic: $03917a0203ce2598$var$strategyMonadic
};

});

parcelRegister("5wzdk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("783MZ")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("783MZ")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("hA2YD")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("diqj4")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $diqj4 = parcelRequire("diqj4");
parcelRequire("783MZ");
parcelRequire("hA2YD");
var $405b41a717912e93$export$2e2bcd8739ae039 = (0, $diqj4.IntlMessageFormat);

});
parcelRegister("diqj4", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $9ae15cc116d6cb99$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $lmviS = parcelRequire("lmviS");

var $iZCbV = parcelRequire("iZCbV");

var $3JjFu = parcelRequire("3JjFu");

var $hA2YD = parcelRequire("hA2YD");
// -- MessageFormat --------------------------------------------------------
function $9ae15cc116d6cb99$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $9ae15cc116d6cb99$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $9ae15cc116d6cb99$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $lmviS.__assign)({}, defaultConfig));
}
function $9ae15cc116d6cb99$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $9ae15cc116d6cb99$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $iZCbV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9ae15cc116d6cb99$var$createFastMemoizeCache(cache.number),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getDateTimeFormat: (0, $iZCbV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9ae15cc116d6cb99$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $iZCbV.strategies).variadic
        }),
        getPluralRules: (0, $iZCbV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $lmviS.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9ae15cc116d6cb99$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $iZCbV.strategies).variadic
        })
    };
}
var $9ae15cc116d6cb99$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $hA2YD.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $hA2YD.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $lmviS.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $lmviS.__assign)((0, $lmviS.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $9ae15cc116d6cb99$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $9ae15cc116d6cb99$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $3JjFu.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("3JjFu", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("4cQwB")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("4cQwB")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("4cQwB")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("4cQwB")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("4cQwB")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("4cQwB")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("4cQwB")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("4cQwB")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("4cQwB")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("4cQwB")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("4cQwB")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("4cQwB")).TYPE);
$parcel$export(module.exports, "parse", () => $2b74d4c6d875e768$export$98e6a39c04603d36);

var $lmviS = parcelRequire("lmviS");

var $hhvRB = parcelRequire("hhvRB");

var $lMzVS = parcelRequire("lMzVS");

var $4cQwB = parcelRequire("4cQwB");

var $hlkCH = parcelRequire("hlkCH");
function $2b74d4c6d875e768$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4cQwB.isSelectElement)(el) || (0, $4cQwB.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $2b74d4c6d875e768$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4cQwB.isNumberElement)(el) && (0, $4cQwB.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4cQwB.isDateElement)(el) || (0, $4cQwB.isTimeElement)(el)) && (0, $4cQwB.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4cQwB.isTagElement)(el)) $2b74d4c6d875e768$var$pruneLocation(el.children);
    });
}
function $2b74d4c6d875e768$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $lmviS.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $lMzVS.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $hhvRB.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $2b74d4c6d875e768$var$pruneLocation(result.val);
    return result.val;
}
var $2b74d4c6d875e768$export$d3c1bfa0f7d806e9 = (0, $lMzVS.Parser);

});
parcelRegister("hhvRB", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $c94cbda4fb48af24$export$896afd8541959ee5);
var $c94cbda4fb48af24$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($c94cbda4fb48af24$export$896afd8541959ee5 || ($c94cbda4fb48af24$export$896afd8541959ee5 = {}));

});

parcelRegister("lMzVS", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $fdb9f41ebf6a1729$export$7acfa6ed01010e37);

var $lmviS = parcelRequire("lmviS");

var $hhvRB = parcelRequire("hhvRB");

var $4cQwB = parcelRequire("4cQwB");

var $Ef8yO = parcelRequire("Ef8yO");
parcelRequire("4zrWy");
var $dJC6N = parcelRequire("dJC6N");
var $22Fn8 = parcelRequire("22Fn8");

var $8R32B = parcelRequire("8R32B");
var $fdb9f41ebf6a1729$var$_a;
var $fdb9f41ebf6a1729$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $Ef8yO.SPACE_SEPARATOR_REGEX).source, "*"));
var $fdb9f41ebf6a1729$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $Ef8yO.SPACE_SEPARATOR_REGEX).source, "*$"));
function $fdb9f41ebf6a1729$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $fdb9f41ebf6a1729$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $fdb9f41ebf6a1729$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $fdb9f41ebf6a1729$var$hasNativeFromEntries = !!Object.fromEntries;
var $fdb9f41ebf6a1729$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $fdb9f41ebf6a1729$var$hasTrimStart = !!String.prototype.trimStart;
var $fdb9f41ebf6a1729$var$hasTrimEnd = !!String.prototype.trimEnd;
var $fdb9f41ebf6a1729$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $fdb9f41ebf6a1729$var$isSafeInteger = $fdb9f41ebf6a1729$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $fdb9f41ebf6a1729$var$re = $fdb9f41ebf6a1729$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y = (($fdb9f41ebf6a1729$var$_a = $fdb9f41ebf6a1729$var$re.exec('a')) === null || $fdb9f41ebf6a1729$var$_a === void 0 ? void 0 : $fdb9f41ebf6a1729$var$_a[0]) === 'a';
} catch (_) {
    $fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $fdb9f41ebf6a1729$var$startsWith = $fdb9f41ebf6a1729$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $fdb9f41ebf6a1729$var$fromCodePoint = $fdb9f41ebf6a1729$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $fdb9f41ebf6a1729$var$fromEntries = // native
$fdb9f41ebf6a1729$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $fdb9f41ebf6a1729$var$codePointAt = $fdb9f41ebf6a1729$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $fdb9f41ebf6a1729$var$trimStart = $fdb9f41ebf6a1729$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($fdb9f41ebf6a1729$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $fdb9f41ebf6a1729$var$trimEnd = $fdb9f41ebf6a1729$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($fdb9f41ebf6a1729$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $fdb9f41ebf6a1729$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $fdb9f41ebf6a1729$var$matchIdentifierAtIndex;
if ($fdb9f41ebf6a1729$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $fdb9f41ebf6a1729$var$IDENTIFIER_PREFIX_RE_1 = $fdb9f41ebf6a1729$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $fdb9f41ebf6a1729$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $fdb9f41ebf6a1729$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $fdb9f41ebf6a1729$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$fdb9f41ebf6a1729$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $fdb9f41ebf6a1729$var$codePointAt(s, index);
        if (c === undefined || $fdb9f41ebf6a1729$var$_isWhiteSpace(c) || $fdb9f41ebf6a1729$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $fdb9f41ebf6a1729$var$fromCodePoint.apply(void 0, match);
};
var $fdb9f41ebf6a1729$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4cQwB.TYPE).pound,
                    location: $fdb9f41ebf6a1729$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $hhvRB.ErrorKind).UNMATCHED_CLOSING_TAG, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $fdb9f41ebf6a1729$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4cQwB.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$fdb9f41ebf6a1729$var$_isAlpha(this.char())) return this.error((0, $hhvRB.ErrorKind).INVALID_TAG, $fdb9f41ebf6a1729$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $hhvRB.ErrorKind).UNMATCHED_CLOSING_TAG, $fdb9f41ebf6a1729$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $hhvRB.ErrorKind).INVALID_TAG, $fdb9f41ebf6a1729$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4cQwB.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $hhvRB.ErrorKind).UNCLOSED_TAG, $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $hhvRB.ErrorKind).INVALID_TAG, $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $fdb9f41ebf6a1729$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $fdb9f41ebf6a1729$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4cQwB.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$fdb9f41ebf6a1729$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $fdb9f41ebf6a1729$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $fdb9f41ebf6a1729$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $hhvRB.ErrorKind).EMPTY_ARGUMENT, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $hhvRB.ErrorKind).MALFORMED_ARGUMENT, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4cQwB.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $hhvRB.ErrorKind).MALFORMED_ARGUMENT, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $fdb9f41ebf6a1729$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $fdb9f41ebf6a1729$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_TYPE, $fdb9f41ebf6a1729$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $fdb9f41ebf6a1729$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_STYLE, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $fdb9f41ebf6a1729$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $fdb9f41ebf6a1729$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $fdb9f41ebf6a1729$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4cQwB.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $hhvRB.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $8R32B.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4cQwB.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $dJC6N.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4cQwB.TYPE).date : (0, $4cQwB.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4cQwB.TYPE).number : argType === 'date' ? (0, $4cQwB.TYPE).date : (0, $4cQwB.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $hhvRB.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $fdb9f41ebf6a1729$var$createLocation(typeEndPosition_1, (0, $lmviS.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $hhvRB.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4cQwB.TYPE).select,
                        value: value,
                        options: $fdb9f41ebf6a1729$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4cQwB.TYPE).plural,
                        value: value,
                        options: $fdb9f41ebf6a1729$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $hhvRB.ErrorKind).INVALID_ARGUMENT_TYPE, $fdb9f41ebf6a1729$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $hhvRB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $hhvRB.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $fdb9f41ebf6a1729$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $22Fn8.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $hhvRB.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4cQwB.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $22Fn8.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $hhvRB.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $fdb9f41ebf6a1729$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $hhvRB.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $hhvRB.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $hhvRB.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $fdb9f41ebf6a1729$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $hhvRB.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $hhvRB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $hhvRB.ErrorKind).MISSING_OTHER_CLAUSE, $fdb9f41ebf6a1729$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $fdb9f41ebf6a1729$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$fdb9f41ebf6a1729$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $fdb9f41ebf6a1729$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($fdb9f41ebf6a1729$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $fdb9f41ebf6a1729$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $fdb9f41ebf6a1729$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $fdb9f41ebf6a1729$var$_isAlphaOrSlash(codepoint) {
    return $fdb9f41ebf6a1729$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $fdb9f41ebf6a1729$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $fdb9f41ebf6a1729$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $fdb9f41ebf6a1729$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4cQwB", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $310106c7780da567$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $310106c7780da567$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $310106c7780da567$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $310106c7780da567$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $310106c7780da567$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $310106c7780da567$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $310106c7780da567$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $310106c7780da567$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $310106c7780da567$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $310106c7780da567$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $310106c7780da567$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $310106c7780da567$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $310106c7780da567$export$7680c41f1a55f4cf);
var $310106c7780da567$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($310106c7780da567$export$b87f371cbc396fcf || ($310106c7780da567$export$b87f371cbc396fcf = {}));
var $310106c7780da567$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($310106c7780da567$export$906452485466fa53 || ($310106c7780da567$export$906452485466fa53 = {}));
function $310106c7780da567$export$cfa10c5697238752(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.literal;
}
function $310106c7780da567$export$4f55724281bdfaf9(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.argument;
}
function $310106c7780da567$export$e11187b219e191e1(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.number;
}
function $310106c7780da567$export$32d811605da75f40(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.date;
}
function $310106c7780da567$export$34ec46f596b1702f(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.time;
}
function $310106c7780da567$export$dcfe1c11d168b5a1(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.select;
}
function $310106c7780da567$export$6c796d116f0a4fbc(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.plural;
}
function $310106c7780da567$export$c0ece297bdd0c082(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.pound;
}
function $310106c7780da567$export$5c83de34745812b(el) {
    return el.type === $310106c7780da567$export$b87f371cbc396fcf.tag;
}
function $310106c7780da567$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $310106c7780da567$export$906452485466fa53.number);
}
function $310106c7780da567$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $310106c7780da567$export$906452485466fa53.dateTime);
}
function $310106c7780da567$export$f0ac572c1121c662(value) {
    return {
        type: $310106c7780da567$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $310106c7780da567$export$425e864b0ba114f1(value, style) {
    return {
        type: $310106c7780da567$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("Ef8yO", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $078f7a73000cfe1f$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $078f7a73000cfe1f$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $078f7a73000cfe1f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("4zrWy", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("dJC6N")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("22Fn8")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("22Fn8")).parseNumberSkeletonFromString);
parcelRequire("dJC6N");
parcelRequire("22Fn8");

});
parcelRegister("dJC6N", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $9ffd09e3947b5c5e$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $9ffd09e3947b5c5e$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $9ffd09e3947b5c5e$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($9ffd09e3947b5c5e$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("22Fn8", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $17cbdc51753bb5eb$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $17cbdc51753bb5eb$export$47c6f8480bda3e11);

var $lmviS = parcelRequire("lmviS");

var $g4rqc = parcelRequire("g4rqc");
function $17cbdc51753bb5eb$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $g4rqc.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $17cbdc51753bb5eb$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $17cbdc51753bb5eb$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $17cbdc51753bb5eb$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $17cbdc51753bb5eb$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $17cbdc51753bb5eb$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $17cbdc51753bb5eb$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($17cbdc51753bb5eb$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $17cbdc51753bb5eb$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $17cbdc51753bb5eb$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$17cbdc51753bb5eb$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $17cbdc51753bb5eb$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $17cbdc51753bb5eb$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $17cbdc51753bb5eb$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $17cbdc51753bb5eb$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, all), $17cbdc51753bb5eb$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, all), $17cbdc51753bb5eb$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($17cbdc51753bb5eb$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($17cbdc51753bb5eb$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($17cbdc51753bb5eb$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($17cbdc51753bb5eb$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), $17cbdc51753bb5eb$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($17cbdc51753bb5eb$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), $17cbdc51753bb5eb$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $17cbdc51753bb5eb$var$parseSign(token.stem);
        if (signOpts) result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $17cbdc51753bb5eb$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("g4rqc", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $bb324a64f7f21993$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $bb324a64f7f21993$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("8R32B", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $6725a1d136b0883c$export$29c5368be8904d27);

var $9b7g2 = parcelRequire("9b7g2");
function $6725a1d136b0883c$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $6725a1d136b0883c$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $6725a1d136b0883c$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $9b7g2.timeData)[regionTag || ''] || (0, $9b7g2.timeData)[languageTag || ''] || (0, $9b7g2.timeData)["".concat(languageTag, "-001")] || (0, $9b7g2.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("9b7g2", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $6aeac559d4e4f8ce$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $6aeac559d4e4f8ce$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("hlkCH", function(module, exports) {

var $lmviS = parcelRequire("lmviS");

var $4cQwB = parcelRequire("4cQwB");
function $ca04652d057de8bf$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $lmviS.__spreadArray)([], obj.map($ca04652d057de8bf$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $ca04652d057de8bf$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $ca04652d057de8bf$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $ca04652d057de8bf$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $ca04652d057de8bf$export$be5687ba8bbdf416((0, $lmviS.__spreadArray)((0, $lmviS.__spreadArray)((0, $lmviS.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $ca04652d057de8bf$var$isPluralOrSelectElement(el) {
    return (0, $4cQwB.isPluralElement)(el) || (0, $4cQwB.isSelectElement)(el);
}
function $ca04652d057de8bf$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($ca04652d057de8bf$var$isPluralOrSelectElement(el)) return true;
        if ((0, $4cQwB.isTagElement)(el)) return $ca04652d057de8bf$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $ca04652d057de8bf$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($ca04652d057de8bf$var$isPluralOrSelectElement(el)) return [
            $ca04652d057de8bf$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $4cQwB.isTagElement)(el) && $ca04652d057de8bf$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $ca04652d057de8bf$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $4cQwB.isArgumentElement)(el) || (0, $4cQwB.isDateElement)(el) || (0, $4cQwB.isTimeElement)(el) || (0, $4cQwB.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $4cQwB.isPluralElement)(el) || (0, $4cQwB.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $ca04652d057de8bf$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $4cQwB.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $ca04652d057de8bf$var$collectVariables(el.children, vars);
        }
    });
}
function $ca04652d057de8bf$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $ca04652d057de8bf$var$collectVariables(a, aVars);
    $ca04652d057de8bf$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $4cQwB.TYPE)[type], " vs ").concat((0, $4cQwB.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("hA2YD", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $ccc81b9daa1354c2$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $ccc81b9daa1354c2$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $ccc81b9daa1354c2$export$275d4a3bb5f66fda);
parcelRequire("3JjFu");
var $4cQwB = parcelRequire("4cQwB");

var $783MZ = parcelRequire("783MZ");
var $ccc81b9daa1354c2$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ccc81b9daa1354c2$export$49694c2877b44c57 || ($ccc81b9daa1354c2$export$49694c2877b44c57 = {}));
function $ccc81b9daa1354c2$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ccc81b9daa1354c2$export$49694c2877b44c57.literal || part.type !== $ccc81b9daa1354c2$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ccc81b9daa1354c2$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $ccc81b9daa1354c2$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4cQwB.isLiteralElement)(els[0])) return [
        {
            type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4cQwB.isLiteralElement)(el)) {
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4cQwB.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $783MZ.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4cQwB.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $ccc81b9daa1354c2$export$49694c2877b44c57.literal : $ccc81b9daa1354c2$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4cQwB.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4cQwB.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4cQwB.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4cQwB.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4cQwB.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4cQwB.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ccc81b9daa1354c2$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4cQwB.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ccc81b9daa1354c2$export$df0c12a2d414a163(formatFn)) throw new (0, $783MZ.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $ccc81b9daa1354c2$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $ccc81b9daa1354c2$export$49694c2877b44c57.literal : $ccc81b9daa1354c2$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4cQwB.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $783MZ.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ccc81b9daa1354c2$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4cQwB.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $783MZ.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $783MZ.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ccc81b9daa1354c2$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ccc81b9daa1354c2$var$mergeLiteral(result);
}

});
parcelRegister("783MZ", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $530c3836dc36a5b9$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $530c3836dc36a5b9$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $530c3836dc36a5b9$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $530c3836dc36a5b9$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $530c3836dc36a5b9$export$8bfc137e4d23fdf0);

var $lmviS = parcelRequire("lmviS");
var $530c3836dc36a5b9$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($530c3836dc36a5b9$export$d4e71bc0b80dc0fb || ($530c3836dc36a5b9$export$d4e71bc0b80dc0fb = {}));
var $530c3836dc36a5b9$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $530c3836dc36a5b9$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $530c3836dc36a5b9$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($530c3836dc36a5b9$export$7369836851cc1329);
var $530c3836dc36a5b9$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $530c3836dc36a5b9$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($530c3836dc36a5b9$export$7369836851cc1329);
var $530c3836dc36a5b9$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $530c3836dc36a5b9$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($530c3836dc36a5b9$export$7369836851cc1329);

});




parcelRegister("elgnH", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $a70fbbcf8430f01a$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $a70fbbcf8430f01a$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $a70fbbcf8430f01a$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $a70fbbcf8430f01a$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $a70fbbcf8430f01a$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $a70fbbcf8430f01a$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $a70fbbcf8430f01a$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $a70fbbcf8430f01a$export$2ddcb436d0aa3688);

var $lmviS = parcelRequire("lmviS");
var $a70fbbcf8430f01a$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($a70fbbcf8430f01a$export$557d6acb76e8a244 || ($a70fbbcf8430f01a$export$557d6acb76e8a244 = {}));
var $a70fbbcf8430f01a$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $a70fbbcf8430f01a$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);
var $a70fbbcf8430f01a$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($a70fbbcf8430f01a$export$e3b7eee1dbc44895);
var $a70fbbcf8430f01a$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $lmviS.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $a70fbbcf8430f01a$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($a70fbbcf8430f01a$export$c016d36112f6ddf8);

});



parcelRegister("kK7WO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f19e44bce5ed1452$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $lJYzG = parcelRequire("lJYzG");
function $f19e44bce5ed1452$export$2e2bcd8739ae039() {
    var intl = $1v5pe.useContext((0, $lJYzG.Context));
    (0, $kfP5u.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("lJYzG", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $fd3cc9ccf667a0a4$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $fd3cc9ccf667a0a4$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $fd3cc9ccf667a0a4$export$2e2bcd8739ae039);

var $lmviS = parcelRequire("lmviS");

var $35aua = parcelRequire("35aua");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");
function $fd3cc9ccf667a0a4$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $fd3cc9ccf667a0a4$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $1v5pe.createContext(null)) : $1v5pe.createContext(null);
var $fd3cc9ccf667a0a4$var$IntlConsumer = $fd3cc9ccf667a0a4$var$IntlContext.Consumer, $fd3cc9ccf667a0a4$var$IntlProvider = $fd3cc9ccf667a0a4$var$IntlContext.Provider;
var $fd3cc9ccf667a0a4$export$2881499e37b75b9a = $fd3cc9ccf667a0a4$var$IntlProvider;
var $fd3cc9ccf667a0a4$export$841858b892ce1f4c = $fd3cc9ccf667a0a4$var$IntlContext;
function $fd3cc9ccf667a0a4$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $1v5pe.createElement($fd3cc9ccf667a0a4$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $kfP5u.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $1v5pe.createElement(WrappedComponent, (0, $lmviS.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($fd3cc9ccf667a0a4$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($35aua)))(// @ts-expect-error
    $1v5pe.forwardRef(function(props, ref) {
        return $1v5pe.createElement(WithIntl, (0, $lmviS.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($35aua)))(WithIntl, WrappedComponent);
}

});
parcelRegister("35aua", function(module, exports) {
'use strict';

var $5G2sm = parcelRequire("5G2sm");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $23e9f8f01248e898$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $23e9f8f01248e898$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $23e9f8f01248e898$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $23e9f8f01248e898$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $23e9f8f01248e898$var$TYPE_STATICS = {};
$23e9f8f01248e898$var$TYPE_STATICS[$5G2sm.ForwardRef] = $23e9f8f01248e898$var$FORWARD_REF_STATICS;
$23e9f8f01248e898$var$TYPE_STATICS[$5G2sm.Memo] = $23e9f8f01248e898$var$MEMO_STATICS;
function $23e9f8f01248e898$var$getStatics(component) {
    // React v16.11 and below
    if ($5G2sm.isMemo(component)) return $23e9f8f01248e898$var$MEMO_STATICS;
     // React v16.12 and above
    return $23e9f8f01248e898$var$TYPE_STATICS[component['$$typeof']] || $23e9f8f01248e898$var$REACT_STATICS;
}
var $23e9f8f01248e898$var$defineProperty = Object.defineProperty;
var $23e9f8f01248e898$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $23e9f8f01248e898$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $23e9f8f01248e898$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $23e9f8f01248e898$var$getPrototypeOf = Object.getPrototypeOf;
var $23e9f8f01248e898$var$objectPrototype = Object.prototype;
function $23e9f8f01248e898$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($23e9f8f01248e898$var$objectPrototype) {
            var inheritedComponent = $23e9f8f01248e898$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $23e9f8f01248e898$var$objectPrototype) $23e9f8f01248e898$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $23e9f8f01248e898$var$getOwnPropertyNames(sourceComponent);
        if ($23e9f8f01248e898$var$getOwnPropertySymbols) keys = keys.concat($23e9f8f01248e898$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $23e9f8f01248e898$var$getStatics(targetComponent);
        var sourceStatics = $23e9f8f01248e898$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$23e9f8f01248e898$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $23e9f8f01248e898$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $23e9f8f01248e898$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $23e9f8f01248e898$var$hoistNonReactStatics;

});




parcelRegister("8TrAC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e9d1c572d133af8$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $cYe7u = parcelRequire("cYe7u");

var $5M9AH = parcelRequire("5M9AH");

var $gOztT = parcelRequire("gOztT");
const $0e9d1c572d133af8$var$ErrorIllustration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
        alt: "Error",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5M9AH))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gOztT)))
    });
var $0e9d1c572d133af8$export$2e2bcd8739ae039 = $0e9d1c572d133af8$var$ErrorIllustration;

});
parcelRegister("5M9AH", function(module, exports) {
module.exports = new URL("light.6e26cad7.svg", import.meta.url).toString();

});

parcelRegister("gOztT", function(module, exports) {
module.exports = new URL("dark.d6d496b3.svg", import.meta.url).toString();

});


parcelRegister("dDtM2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $330656388d41e79f$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $330656388d41e79f$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    errorHeader: {
        id: 'rovo-extension.error-header.label',
        defaultMessage: 'Something went wrong',
        description: 'Header label for extension error message'
    },
    chatErrorSubheader: {
        id: 'rovo-extension.chat-error-subheader.label',
        defaultMessage: 'Try refreshing the page, or starting a new chat.',
        description: 'Subheader label for extension error message suggestions'
    },
    errorBoundarySubheader: {
        id: 'rovo-extension.error-boundary-subheader.label',
        defaultMessage: 'Please try again.',
        description: 'Subheader label for extension error message'
    },
    rovoDisabledError: {
        id: 'rovo-extension.rovo-disabled-error.label',
        defaultMessage: 'Are you there Rovo?',
        description: "Header label for extension error message when Rovo is missing for the user's Atlassian site"
    },
    rovoDisabledErrorSubheader: {
        id: 'rovo-extension.rovo-disabled-error-subheader.label',
        defaultMessage: "It looks like you don't have access to Rovo.",
        description: "Subheader label for extension error message when Rovo is disabled for the user's Atlassian site"
    },
    rovoDisabledErrorLink: {
        id: 'rovo-extension.rovo-disabled-error-link.label',
        defaultMessage: 'More about Rovo',
        description: 'Link label for missing Rovo error message to redirect to more information about Rovo'
    },
    welcomeHeaderWithName: {
        id: 'rovo-extension.welcome-header-with-name.label',
        defaultMessage: 'What can I help you with, {name}?',
        description: "Header label for extension welcome message with user's name"
    },
    welcomeHeaderWithoutName: {
        id: 'rovo-extension.welcome-header-without-name.label',
        defaultMessage: 'What can I help you with?',
        description: "Header label for extension welcome message without user's name"
    },
    welcomeHeaderMorning: {
        id: 'rovo-extension.welcome-header-morning.label',
        defaultMessage: 'Good morning, {name}',
        description: 'Header label for extension welcome message in the morning'
    },
    welcomeHeaderMorningNoName: {
        id: 'rovo-extension.welcome-header-morning-no-name.label',
        defaultMessage: 'Good morning',
        description: 'Header label for extension welcome message in the morning when no name is provided'
    },
    welcomeHeaderAfternoon: {
        id: 'rovo-extension.welcome-header-afternoon.label',
        defaultMessage: 'Good afternoon, {name}',
        description: 'Header label for extension welcome message in the afternoon'
    },
    welcomeHeaderAfternoonNoName: {
        id: 'rovo-extension.welcome-header-afternoon-no-name.label',
        defaultMessage: 'Good afternoon',
        description: 'Header label for extension welcome message in the afternoon when no name is provided'
    },
    welcomeHeaderEvening: {
        id: 'rovo-extension.welcome-header-evening.label',
        defaultMessage: 'Good evening, {name}',
        description: 'Header label for extension welcome message in the evening'
    },
    welcomeHeaderEveningNoName: {
        id: 'rovo-extension.welcome-header-evening-no-name.label',
        defaultMessage: 'Good evening',
        description: 'Header label for extension welcome message in the evening when no name is provided'
    },
    reloadButtonLabel: {
        id: 'rovo-extension.rovo-disabled-error.button',
        defaultMessage: 'Try again',
        description: 'Label for reload button when Rovo is disabled'
    }
});

});
parcelRegister("75IaS", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $529b4426a6d8b1d2$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $529b4426a6d8b1d2$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $529b4426a6d8b1d2$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $529b4426a6d8b1d2$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $529b4426a6d8b1d2$export$db80edc1e6b2f63d);
$parcel$export(module.exports, "FormattedList", () => $529b4426a6d8b1d2$export$f52b44e459e6e71d);
$parcel$export(module.exports, "FormattedDisplayName", () => $529b4426a6d8b1d2$export$c2336ea5aaab92fa);
$parcel$export(module.exports, "FormattedDateParts", () => $529b4426a6d8b1d2$export$7fdc7d2c91ce149b);
$parcel$export(module.exports, "FormattedTimeParts", () => $529b4426a6d8b1d2$export$ec35873761676c2a);
$parcel$export(module.exports, "createIntlCache", () => (parcelRequire("3zCfq")).createIntlCache);
$parcel$export(module.exports, "InvalidConfigError", () => (parcelRequire("elgnH")).InvalidConfigError);
$parcel$export(module.exports, "MessageFormatError", () => (parcelRequire("elgnH")).MessageFormatError);
$parcel$export(module.exports, "MissingDataError", () => (parcelRequire("elgnH")).MissingDataError);
$parcel$export(module.exports, "MissingTranslationError", () => (parcelRequire("elgnH")).MissingTranslationError);
$parcel$export(module.exports, "ReactIntlError", () => (parcelRequire("elgnH")).IntlError);
$parcel$export(module.exports, "ReactIntlErrorCode", () => (parcelRequire("elgnH")).IntlErrorCode);
$parcel$export(module.exports, "UnsupportedFormatterError", () => (parcelRequire("elgnH")).UnsupportedFormatterError);
$parcel$export(module.exports, "createIntl", () => (parcelRequire("1YTwG")).createIntl);
$parcel$export(module.exports, "FormattedDateTimeRange", () => (parcelRequire("4DGRH")).default);
$parcel$export(module.exports, "FormattedMessage", () => (parcelRequire("b2Az1")).default);
$parcel$export(module.exports, "FormattedPlural", () => (parcelRequire("1wmds")).default);
$parcel$export(module.exports, "FormattedRelativeTime", () => (parcelRequire("1CCqZ")).default);
$parcel$export(module.exports, "injectIntl", () => (parcelRequire("lJYzG")).default);
$parcel$export(module.exports, "IntlContext", () => (parcelRequire("lJYzG")).Context);
$parcel$export(module.exports, "IntlProvider", () => (parcelRequire("cZ6aD")).default);
$parcel$export(module.exports, "RawIntlProvider", () => (parcelRequire("lJYzG")).Provider);
$parcel$export(module.exports, "useIntl", () => (parcelRequire("kK7WO")).default);
$parcel$export(module.exports, "FormattedListParts", () => (parcelRequire("56iES")).FormattedListParts);
$parcel$export(module.exports, "FormattedNumberParts", () => (parcelRequire("56iES")).FormattedNumberParts);

var $56iES = parcelRequire("56iES");

var $1YTwG = parcelRequire("1YTwG");

var $4DGRH = parcelRequire("4DGRH");

var $lJYzG = parcelRequire("lJYzG");

var $b2Az1 = parcelRequire("b2Az1");

var $1wmds = parcelRequire("1wmds");

var $cZ6aD = parcelRequire("cZ6aD");

var $1CCqZ = parcelRequire("1CCqZ");

var $kK7WO = parcelRequire("kK7WO");

var $3zCfq = parcelRequire("3zCfq");
var $elgnH = parcelRequire("elgnH");
function $529b4426a6d8b1d2$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $529b4426a6d8b1d2$export$747d244ee58120dd(msg) {
    return msg;
}
var $529b4426a6d8b1d2$export$40ae3194919d16b = (0, $56iES.createFormattedComponent)('formatDate');
var $529b4426a6d8b1d2$export$5b390a54f8a846f7 = (0, $56iES.createFormattedComponent)('formatTime');
var $529b4426a6d8b1d2$export$db80edc1e6b2f63d = (0, $56iES.createFormattedComponent)('formatNumber');
var $529b4426a6d8b1d2$export$f52b44e459e6e71d = (0, $56iES.createFormattedComponent)('formatList');
var $529b4426a6d8b1d2$export$c2336ea5aaab92fa = (0, $56iES.createFormattedComponent)('formatDisplayName');
var $529b4426a6d8b1d2$export$7fdc7d2c91ce149b = (0, $56iES.createFormattedDateTimePartsComponent)('formatDate');
var $529b4426a6d8b1d2$export$ec35873761676c2a = (0, $56iES.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("56iES", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $3b6bfc6bcf5a3490$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $3b6bfc6bcf5a3490$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $3b6bfc6bcf5a3490$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $3b6bfc6bcf5a3490$export$b37e14176d001dec);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");
var $3b6bfc6bcf5a3490$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($3b6bfc6bcf5a3490$var$DisplayName || ($3b6bfc6bcf5a3490$var$DisplayName = {}));
var $3b6bfc6bcf5a3490$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($3b6bfc6bcf5a3490$var$DisplayNameParts || ($3b6bfc6bcf5a3490$var$DisplayNameParts = {}));
var $3b6bfc6bcf5a3490$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $kK7WO.default)();
    var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$3b6bfc6bcf5a3490$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $3b6bfc6bcf5a3490$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $kK7WO.default)();
    var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$3b6bfc6bcf5a3490$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $3b6bfc6bcf5a3490$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $kK7WO.default)();
        var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $3b6bfc6bcf5a3490$var$DisplayNameParts[name];
    return ComponentParts;
}
function $3b6bfc6bcf5a3490$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $kK7WO.default)();
        var value = props.value, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $1v5pe.Fragment;
        return $1v5pe.createElement(Text, null, formattedValue);
    };
    Component.displayName = $3b6bfc6bcf5a3490$var$DisplayName[name];
    return Component;
}

});

parcelRegister("1YTwG", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $1716776161aaadb1$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lmviS = parcelRequire("lmviS");

var $4qdJT = parcelRequire("4qdJT");
var $9Hg69 = parcelRequire("9Hg69");

var $hA2YD = parcelRequire("hA2YD");

var $kfP5u = parcelRequire("kfP5u");
function $1716776161aaadb1$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $hA2YD.isFormatXMLElementFn)(v) ? (0, $kfP5u.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $1716776161aaadb1$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $1716776161aaadb1$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $9Hg69.formatMessage).apply(void 0, (0, $lmviS.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $kfP5u.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $1716776161aaadb1$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $lmviS.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $1716776161aaadb1$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $4qdJT.createIntl)((0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, (0, $kfP5u.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, coreIntl), {
        formatMessage: $1716776161aaadb1$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $1716776161aaadb1$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("4qdJT", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $33843f6e18504ce7$export$7e4cbedfdd7b4c0d);

var $lmviS = parcelRequire("lmviS");

var $fXOyZ = parcelRequire("fXOyZ");

var $3sWhm = parcelRequire("3sWhm");

var $elgnH = parcelRequire("elgnH");

var $bKDJF = parcelRequire("bKDJF");

var $9Hg69 = parcelRequire("9Hg69");

var $gZNX1 = parcelRequire("gZNX1");

var $eNCzn = parcelRequire("eNCzn");

var $frjbX = parcelRequire("frjbX");

var $3zCfq = parcelRequire("3zCfq");
function $33843f6e18504ce7$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $33843f6e18504ce7$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $33843f6e18504ce7$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $33843f6e18504ce7$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $3zCfq.createFormatters)(cache);
    var resolvedConfig = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, (0, $3zCfq.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $elgnH.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $elgnH.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $elgnH.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $33843f6e18504ce7$var$verifyConfigMessages(resolvedConfig);
    return (0, $lmviS.__assign)((0, $lmviS.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $gZNX1.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $gZNX1.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $frjbX.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $fXOyZ.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $fXOyZ.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $fXOyZ.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $fXOyZ.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $fXOyZ.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $eNCzn.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $9Hg69.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $9Hg69.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $bKDJF.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $bKDJF.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $3sWhm.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("fXOyZ", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $b9f39685a0a84745$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $b9f39685a0a84745$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $b9f39685a0a84745$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $b9f39685a0a84745$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $b9f39685a0a84745$export$af6e5d7a5c73edeb);

var $lmviS = parcelRequire("lmviS");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $b9f39685a0a84745$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $b9f39685a0a84745$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $3zCfq.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $b9f39685a0a84745$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $b9f39685a0a84745$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $b9f39685a0a84745$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $b9f39685a0a84745$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $b9f39685a0a84745$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $b9f39685a0a84745$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $b9f39685a0a84745$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("3sWhm", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $286131a4958e257e$export$62fe1a4d9e891fa2);

var $3zCfq = parcelRequire("3zCfq");

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");
var $286131a4958e257e$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $286131a4958e257e$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $783MZ.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $286131a4958e257e$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $elgnH.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("bKDJF", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $88e2d03c1dc3e99c$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $88e2d03c1dc3e99c$export$6f284aad1934db69);

var $lmviS = parcelRequire("lmviS");

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $88e2d03c1dc3e99c$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $88e2d03c1dc3e99c$var$now = Date.now();
function $88e2d03c1dc3e99c$var$generateToken(i) {
    return "".concat($88e2d03c1dc3e99c$var$now, "_").concat(i, "_").concat($88e2d03c1dc3e99c$var$now);
}
function $88e2d03c1dc3e99c$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $88e2d03c1dc3e99c$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $88e2d03c1dc3e99c$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $783MZ.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $88e2d03c1dc3e99c$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $88e2d03c1dc3e99c$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $lmviS.__assign)((0, $lmviS.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $elgnH.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("9Hg69", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $70f49df9403a3dd2$export$25868d1e8e76735f);

var $lmviS = parcelRequire("lmviS");
parcelRequire("3JjFu");
var $4cQwB = parcelRequire("4cQwB");
parcelRequire("5wzdk");
var $diqj4 = parcelRequire("diqj4");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
function $70f49df9403a3dd2$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $lmviS.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $70f49df9403a3dd2$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $lmviS.__assign)((0, $lmviS.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $70f49df9403a3dd2$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $diqj4.IntlMessageFormat).formats;
    return (0, $lmviS.__assign)((0, $lmviS.__assign)((0, $lmviS.__assign)({}, mfFormats), f1), {
        date: $70f49df9403a3dd2$var$deepMergeOptions($70f49df9403a3dd2$var$setTimeZoneInOptions(mfFormats.date, timeZone), $70f49df9403a3dd2$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $70f49df9403a3dd2$var$deepMergeOptions($70f49df9403a3dd2$var$setTimeZoneInOptions(mfFormats.time, timeZone), $70f49df9403a3dd2$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $70f49df9403a3dd2$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $3zCfq.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4cQwB.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $lmviS.__assign)((0, $lmviS.__assign)({}, defaultRichTextElements), values || {});
    formats = $70f49df9403a3dd2$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $70f49df9403a3dd2$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $elgnH.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $elgnH.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $lmviS.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $elgnH.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $elgnH.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("gZNX1", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $c5f917161729c38f$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $c5f917161729c38f$export$6871080848f10b2f);

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $c5f917161729c38f$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $c5f917161729c38f$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $3zCfq.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $3zCfq.filterProps)(options, $c5f917161729c38f$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $c5f917161729c38f$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $c5f917161729c38f$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $c5f917161729c38f$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $c5f917161729c38f$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("eNCzn", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $ac638f6e0c22b179$export$bbbd05c900f3568d);

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");

var $3zCfq = parcelRequire("3zCfq");
var $ac638f6e0c22b179$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $ac638f6e0c22b179$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $783MZ.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $3zCfq.filterProps)(options, $ac638f6e0c22b179$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $elgnH.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("frjbX", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $b3d843bb4dd5ca30$export$b4ea3b48dcf921f6);

var $3zCfq = parcelRequire("3zCfq");

var $783MZ = parcelRequire("783MZ");

var $elgnH = parcelRequire("elgnH");
var $b3d843bb4dd5ca30$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $b3d843bb4dd5ca30$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $3zCfq.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $3zCfq.filterProps)(options, $b3d843bb4dd5ca30$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $b3d843bb4dd5ca30$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $783MZ.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $783MZ.ErrorCode).MISSING_INTL_API));
    try {
        return $b3d843bb4dd5ca30$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $elgnH.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("4DGRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $360c0e15d24294be$export$2e2bcd8739ae039);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");
var $360c0e15d24294be$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $kK7WO.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $lmviS.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $1v5pe.Fragment;
    return $1v5pe.createElement(Text, null, formattedValue);
};
$360c0e15d24294be$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $360c0e15d24294be$export$2e2bcd8739ae039 = $360c0e15d24294be$var$FormattedDateTimeRange;

});

parcelRegister("1wmds", function(module, exports) {
$parcel$export(module.exports, "default", () => $11ba033b5cc531c8$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");
var $11ba033b5cc531c8$var$FormattedPlural = function(props) {
    var _a = (0, $kK7WO.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $1v5pe.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$11ba033b5cc531c8$var$FormattedPlural.displayName = 'FormattedPlural';
var $11ba033b5cc531c8$export$2e2bcd8739ae039 = $11ba033b5cc531c8$var$FormattedPlural;

});

parcelRegister("cZ6aD", function(module, exports) {
$parcel$export(module.exports, "default", () => $973ff7e5aa25ef51$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lmviS = parcelRequire("lmviS");

var $3zCfq = parcelRequire("3zCfq");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $1YTwG = parcelRequire("1YTwG");

var $lJYzG = parcelRequire("lJYzG");
function $973ff7e5aa25ef51$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $973ff7e5aa25ef51$var$IntlProvider = /** @class */ function(_super) {
    (0, $lmviS.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $3zCfq.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $1YTwG.createIntl)($973ff7e5aa25ef51$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $973ff7e5aa25ef51$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $973ff7e5aa25ef51$var$processIntlConfig(props);
        if (!(0, $kfP5u.shallowEqual)(prevConfig, config)) return {
            intl: (0, $1YTwG.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $kfP5u.invariantIntlContext)(this.state.intl);
        return $1v5pe.createElement((0, $lJYzG.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $kfP5u.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($1v5pe.PureComponent);
var $973ff7e5aa25ef51$export$2e2bcd8739ae039 = $973ff7e5aa25ef51$var$IntlProvider;

});

parcelRegister("1CCqZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $12e7274a9cd20e8d$export$2e2bcd8739ae039);

var $lmviS = parcelRequire("lmviS");

var $1v5pe = parcelRequire("1v5pe");

var $kfP5u = parcelRequire("kfP5u");

var $kK7WO = parcelRequire("kK7WO");
var $12e7274a9cd20e8d$var$MINUTE = 60;
var $12e7274a9cd20e8d$var$HOUR = 3600;
var $12e7274a9cd20e8d$var$DAY = 86400;
function $12e7274a9cd20e8d$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $12e7274a9cd20e8d$var$MINUTE) return 'second';
    if (absValue < $12e7274a9cd20e8d$var$HOUR) return 'minute';
    if (absValue < $12e7274a9cd20e8d$var$DAY) return 'hour';
    return 'day';
}
function $12e7274a9cd20e8d$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $12e7274a9cd20e8d$var$MINUTE;
        case 'hour':
            return $12e7274a9cd20e8d$var$HOUR;
        default:
            return $12e7274a9cd20e8d$var$DAY;
    }
}
function $12e7274a9cd20e8d$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $12e7274a9cd20e8d$var$MINUTE;
        default:
            return value * $12e7274a9cd20e8d$var$HOUR;
    }
}
var $12e7274a9cd20e8d$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $12e7274a9cd20e8d$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $12e7274a9cd20e8d$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $12e7274a9cd20e8d$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $kK7WO.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $lmviS.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $1v5pe.createElement(Text, null, formattedRelativeTime);
    return $1v5pe.createElement($1v5pe.Fragment, null, formattedRelativeTime);
};
var $12e7274a9cd20e8d$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $lmviS.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $kfP5u.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $12e7274a9cd20e8d$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $1v5pe.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $1v5pe.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $1v5pe.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($12e7274a9cd20e8d$var$canIncrement(unit) ? $12e7274a9cd20e8d$var$valueToSeconds(value, unit) : 0);
    }
    $1v5pe.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$12e7274a9cd20e8d$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $12e7274a9cd20e8d$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $12e7274a9cd20e8d$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($12e7274a9cd20e8d$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $12e7274a9cd20e8d$var$selectUnit(currentValueInSeconds);
        var unitDuration = $12e7274a9cd20e8d$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $1v5pe.createElement($12e7274a9cd20e8d$var$SimpleFormattedRelativeTime, (0, $lmviS.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$12e7274a9cd20e8d$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $12e7274a9cd20e8d$export$2e2bcd8739ae039 = $12e7274a9cd20e8d$var$FormattedRelativeTime;

});



parcelRegister("1wxU2", function(module, exports) {
$parcel$export(module.exports, "initUFO", () => (parcelRequire("iVysF")).initUFO);
$parcel$export(module.exports, "useReactUFORouteWatcher", () => (parcelRequire("67pgD")).useReactUFORouteWatcher);
$parcel$export(module.exports, "useReportUFOError", () => (parcelRequire("j0FUQ")).useReportUFOError);
$parcel$export(module.exports, "UFOLoadingSpinner", () => (parcelRequire("8widT")).UFOLoadingSpinner);
$parcel$export(module.exports, "UFOSuspenseFallback", () => (parcelRequire("cFd5E")).UFOSuspenseFallback);
$parcel$export(module.exports, "UFOSegment", () => (parcelRequire("6vVPG")).default);

var $iVysF = parcelRequire("iVysF");

var $67pgD = parcelRequire("67pgD");

var $j0FUQ = parcelRequire("j0FUQ");

var $7jMOi = parcelRequire("7jMOi");

var $8widT = parcelRequire("8widT");

var $cFd5E = parcelRequire("cFd5E");




var $6vVPG = parcelRequire("6vVPG");


});
parcelRegister("iVysF", function(module, exports) {
$parcel$export(module.exports, "initUFO", () => $b775c8566bc86c35$export$af995ee1d7017fea);

var $1v5pe = parcelRequire("1v5pe");

var $lo27E = parcelRequire("lo27E");

var $02dIe = parcelRequire("02dIe");

var $54iU5 = parcelRequire("54iU5");

var $dX6kP = parcelRequire("dX6kP");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $7jMOi = parcelRequire("7jMOi");
function $b775c8566bc86c35$export$af995ee1d7017fea() {
    const config = {
        product: 'rovoExtension',
        region: 'prod-west2',
        kind: {
            page_load: 1,
            transition: 1,
            press: 1,
            typing: 0,
            legacy: 0,
            hover: 0
        },
        vc: {
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            devToolsEnabled: false,
            selectorConfig: {
                id: false,
                role: true,
                className: true,
                testId: true
            }
        },
        assetsConfig: $7jMOi.assetsConfig
    };
    (0, $02dIe.init)(Promise.resolve((0, $dX6kP.analyticsClient)), config);
    (0, $lo27E.payloadPublisher).setup({
        gasv3: (0, $dX6kP.analyticsClient),
        product: config.product,
        region: config.region,
        app: {
            version: {
                web: (0, $dqHaj.bitbucketCommit) ?? 'unknown'
            },
            framework: {
                name: 'react',
                version: $1v5pe.version
            }
        }
    });
    (0, $54iU5.default)();
}

});
parcelRegister("lo27E", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $dc08ffefce6fd5ee$export$edb879ae55bb9be3);

var $2aEiL = parcelRequire("2aEiL");

var $fqfOD = parcelRequire("fqfOD");
var $8B5VS = parcelRequire("8B5VS");

var $jjfdf = parcelRequire("jjfdf");

var $9KfqA = parcelRequire("9KfqA");

var $hFdXd = parcelRequire("hFdXd");

var $kWNxm = parcelRequire("kWNxm");

var $bsNtJ = parcelRequire("bsNtJ");

var $4pYlS = parcelRequire("4pYlS");

var $4KkOL = parcelRequire("4KkOL");

var $hHhXx = parcelRequire("hHhXx");

var $aaLne = parcelRequire("aaLne");

var $6dwbd = parcelRequire("6dwbd");

var $b9Pvh = parcelRequire("b9Pvh");

var $03koQ = parcelRequire("03koQ");

var $aubM9 = parcelRequire("aubM9");

var $5KtuY = parcelRequire("5KtuY");

var $j2uN6 = parcelRequire("j2uN6");

var $bhNEM = parcelRequire("bhNEM");

var $kL6BQ = parcelRequire("kL6BQ");

var $9AxPR = parcelRequire("9AxPR");

var $9nMP7 = parcelRequire("9nMP7");

var $6aSQh = parcelRequire("6aSQh");

var $3GW2y = parcelRequire("3GW2y");
const $dc08ffefce6fd5ee$var$UNKNOWN_VALUE = 'unknown';
const $dc08ffefce6fd5ee$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $dc08ffefce6fd5ee$var$UNKNOWN_VALUE,
    id: $dc08ffefce6fd5ee$var$UNKNOWN_VALUE,
    uuid: $dc08ffefce6fd5ee$var$UNKNOWN_VALUE,
    state: {
        id: $dc08ffefce6fd5ee$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $fqfOD.ExperienceTypes).Experience,
    category: $dc08ffefce6fd5ee$var$UNKNOWN_VALUE,
    performanceType: (0, $fqfOD.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $hFdXd.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $dc08ffefce6fd5ee$var$Publisher {
    publish(data) {
        const payloadStart = (0, $3GW2y.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $9KfqA.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$dc08ffefce6fd5ee$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $kWNxm.UFO_BUILD_VERSION) || $dc08ffefce6fd5ee$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $03koQ.eventBrowserPlugin)(),
                    ...(0, $aubM9.eventCpusPlugin)(),
                    ...(0, $j2uN6.eventMemoryPlugin)(),
                    ...(0, $bhNEM.eventNetworkPlugin)(),
                    ...(0, $6dwbd.appFramework)(this.app),
                    ...(0, $b9Pvh.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $bsNtJ.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $hHhXx.pageVisibleState)(supportedData),
                    ...(0, $6aSQh.isInitialPageLoad)(supportedData) && (0, $9AxPR.ssrSuccess)(this.ssr),
                    ...(0, $6aSQh.isInitialPageLoad)(supportedData) && (0, $kL6BQ.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $5KtuY.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext && (0, $2aEiL.fg)('ufo_v1_tracing_2') ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: (0, $3GW2y.getPerformanceObject)()?.timeOrigin ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $3GW2y.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $9KfqA.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $jjfdf.getGlobalEventStream)() instanceof (0, $4pYlS.UFOGlobalEventStream))) {
            const eventStream = new (0, $4pYlS.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $hFdXd.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $jjfdf.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $8B5VS.visibilityChangeObserver).start();
        (0, $aaLne.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $4KkOL.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $dc08ffefce6fd5ee$var$UNKNOWN_VALUE;
        this.hostname = (0, $3GW2y.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $bsNtJ.TenantType).RealUser;
        this.app = {
            version: {
                web: $dc08ffefce6fd5ee$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $9nMP7.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $dc08ffefce6fd5ee$export$edb879ae55bb9be3 = new $dc08ffefce6fd5ee$var$Publisher();

});
parcelRegister("2aEiL", function(module, exports) {
$parcel$export(module.exports, "fg", () => $66aab3be55683b8e$export$b40ec24ac8275656);

var $5ErpT = parcelRequire("5ErpT");
function $66aab3be55683b8e$export$b40ec24ac8275656(name) {
    return (0, $5ErpT.resolveBooleanFlag)(name);
}

});
parcelRegister("5ErpT", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $b5053bcaf5f170df$export$6333b6aff9fc6275);

var $4d1Vr = parcelRequire("4d1Vr");

var $7u1vJ = parcelRequire("7u1vJ");

var $380IJ = parcelRequire("380IJ");

var $k2MNL = parcelRequire("k2MNL");

var $8puww = parcelRequire("8puww");

var $4cILa = parcelRequire("4cILa");
const $b5053bcaf5f170df$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $380IJ.ENV_ENABLE_PLATFORM_FF) || (0, $k2MNL.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $b5053bcaf5f170df$export$6333b6aff9fc6275(flagKey) {
    if ($b5053bcaf5f170df$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7u1vJ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $4cILa.pkgName), flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ((0, $8puww.globalVar)[0, $4cILa.PFF_GLOBAL_KEY]?.booleanResolver === undefined || (0, $8puww.globalVar)[0, $4cILa.PFF_GLOBAL_KEY]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $4d1Vr.default).checkGate(flagKey);
        const result = (0, $8puww.globalVar)[0, $4cILa.PFF_GLOBAL_KEY]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("7u1vJ", function(module, exports) {
$parcel$export(module.exports, "debug", () => $88ed502129b26741$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $88ed502129b26741$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $88ed502129b26741$var$DEBUG_MODE = !$88ed502129b26741$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $88ed502129b26741$export$1c9f709888824e05 = (...args)=>{
    if (!$88ed502129b26741$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});

parcelRegister("380IJ", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $084bbdaa78d6e70f$export$b574c24e1e6490f5);

var $4cILa = parcelRequire("4cILa");
const $084bbdaa78d6e70f$export$b574c24e1e6490f5 = (0, $4cILa.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("4cILa", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $2ece8187a9739e33$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $2ece8187a9739e33$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $2ece8187a9739e33$export$75f4a1454eff2805);

var $k1Wvt = parcelRequire("k1Wvt");
const $2ece8187a9739e33$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $2ece8187a9739e33$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
const $2ece8187a9739e33$export$75f4a1454eff2805 = typeof $k1Wvt !== 'undefined' && typeof $k1Wvt.env !== 'undefined';

});
parcelRegister("k1Wvt", function(module, exports) {
// shim for using process in browser
var $e95148d6a2d48abe$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e95148d6a2d48abe$var$cachedSetTimeout;
var $e95148d6a2d48abe$var$cachedClearTimeout;
function $e95148d6a2d48abe$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $e95148d6a2d48abe$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $e95148d6a2d48abe$var$cachedSetTimeout = setTimeout;
        else $e95148d6a2d48abe$var$cachedSetTimeout = $e95148d6a2d48abe$var$defaultSetTimout;
    } catch (e) {
        $e95148d6a2d48abe$var$cachedSetTimeout = $e95148d6a2d48abe$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $e95148d6a2d48abe$var$cachedClearTimeout = clearTimeout;
        else $e95148d6a2d48abe$var$cachedClearTimeout = $e95148d6a2d48abe$var$defaultClearTimeout;
    } catch (e) {
        $e95148d6a2d48abe$var$cachedClearTimeout = $e95148d6a2d48abe$var$defaultClearTimeout;
    }
})();
function $e95148d6a2d48abe$var$runTimeout(fun) {
    if ($e95148d6a2d48abe$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e95148d6a2d48abe$var$cachedSetTimeout === $e95148d6a2d48abe$var$defaultSetTimout || !$e95148d6a2d48abe$var$cachedSetTimeout) && setTimeout) {
        $e95148d6a2d48abe$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e95148d6a2d48abe$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e95148d6a2d48abe$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e95148d6a2d48abe$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e95148d6a2d48abe$var$runClearTimeout(marker) {
    if ($e95148d6a2d48abe$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e95148d6a2d48abe$var$cachedClearTimeout === $e95148d6a2d48abe$var$defaultClearTimeout || !$e95148d6a2d48abe$var$cachedClearTimeout) && clearTimeout) {
        $e95148d6a2d48abe$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e95148d6a2d48abe$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e95148d6a2d48abe$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e95148d6a2d48abe$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e95148d6a2d48abe$var$queue = [];
var $e95148d6a2d48abe$var$draining = false;
var $e95148d6a2d48abe$var$currentQueue;
var $e95148d6a2d48abe$var$queueIndex = -1;
function $e95148d6a2d48abe$var$cleanUpNextTick() {
    if (!$e95148d6a2d48abe$var$draining || !$e95148d6a2d48abe$var$currentQueue) return;
    $e95148d6a2d48abe$var$draining = false;
    if ($e95148d6a2d48abe$var$currentQueue.length) $e95148d6a2d48abe$var$queue = $e95148d6a2d48abe$var$currentQueue.concat($e95148d6a2d48abe$var$queue);
    else $e95148d6a2d48abe$var$queueIndex = -1;
    if ($e95148d6a2d48abe$var$queue.length) $e95148d6a2d48abe$var$drainQueue();
}
function $e95148d6a2d48abe$var$drainQueue() {
    if ($e95148d6a2d48abe$var$draining) return;
    var timeout = $e95148d6a2d48abe$var$runTimeout($e95148d6a2d48abe$var$cleanUpNextTick);
    $e95148d6a2d48abe$var$draining = true;
    var len = $e95148d6a2d48abe$var$queue.length;
    while(len){
        $e95148d6a2d48abe$var$currentQueue = $e95148d6a2d48abe$var$queue;
        $e95148d6a2d48abe$var$queue = [];
        while(++$e95148d6a2d48abe$var$queueIndex < len)if ($e95148d6a2d48abe$var$currentQueue) $e95148d6a2d48abe$var$currentQueue[$e95148d6a2d48abe$var$queueIndex].run();
        $e95148d6a2d48abe$var$queueIndex = -1;
        len = $e95148d6a2d48abe$var$queue.length;
    }
    $e95148d6a2d48abe$var$currentQueue = null;
    $e95148d6a2d48abe$var$draining = false;
    $e95148d6a2d48abe$var$runClearTimeout(timeout);
}
$e95148d6a2d48abe$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e95148d6a2d48abe$var$queue.push(new $e95148d6a2d48abe$var$Item(fun, args));
    if ($e95148d6a2d48abe$var$queue.length === 1 && !$e95148d6a2d48abe$var$draining) $e95148d6a2d48abe$var$runTimeout($e95148d6a2d48abe$var$drainQueue);
};
// v8 likes predictible objects
function $e95148d6a2d48abe$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e95148d6a2d48abe$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e95148d6a2d48abe$var$process.title = 'browser';
$e95148d6a2d48abe$var$process.browser = true;
$e95148d6a2d48abe$var$process.env = {};
$e95148d6a2d48abe$var$process.argv = [];
$e95148d6a2d48abe$var$process.version = ''; // empty string to avoid regexp issues
$e95148d6a2d48abe$var$process.versions = {};
function $e95148d6a2d48abe$var$noop() {}
$e95148d6a2d48abe$var$process.on = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.addListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.once = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.off = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.removeListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.removeAllListeners = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.emit = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.prependListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.prependOnceListener = $e95148d6a2d48abe$var$noop;
$e95148d6a2d48abe$var$process.listeners = function(name) {
    return [];
};
$e95148d6a2d48abe$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$e95148d6a2d48abe$var$process.cwd = function() {
    return '/';
};
$e95148d6a2d48abe$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$e95148d6a2d48abe$var$process.umask = function() {
    return 0;
};

});



parcelRegister("k2MNL", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $873f2a2dfcec513c$export$92f8b531feaeb23d);

var $4cILa = parcelRequire("4cILa");
const $873f2a2dfcec513c$export$92f8b531feaeb23d = (0, $4cILa.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("8puww", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $910a26afc7fab095$export$54ea85357b4e0159);

var $4cILa = parcelRequire("4cILa");
const $910a26afc7fab095$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $910a26afc7fab095$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$910a26afc7fab095$export$54ea85357b4e0159[0, $4cILa.PFF_GLOBAL_KEY] = $910a26afc7fab095$export$54ea85357b4e0159[0, $4cILa.PFF_GLOBAL_KEY] || $910a26afc7fab095$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("fqfOD", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $143efb82297c8737$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $143efb82297c8737$export$cc26007c03242fff);
var $143efb82297c8737$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $143efb82297c8737$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("8B5VS", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $696fc3c05736911a$export$13e680397ec8f3eb);

var $5IKwo = parcelRequire("5IKwo");
class $696fc3c05736911a$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $5IKwo.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $696fc3c05736911a$export$13e680397ec8f3eb = new $696fc3c05736911a$var$VisibilityChangeObserver();

});
parcelRegister("5IKwo", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $434a51e785fd4547$export$15e172712955e18f);
const $434a51e785fd4547$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("jjfdf", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $e8c811b02e31a2a4$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $e8c811b02e31a2a4$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $e8c811b02e31a2a4$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $e8c811b02e31a2a4$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $e8c811b02e31a2a4$export$7c957416596ca127);

var $9KfqA = parcelRequire("9KfqA");

var $hFdXd = parcelRequire("hFdXd");
const $e8c811b02e31a2a4$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $e8c811b02e31a2a4$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $e8c811b02e31a2a4$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $e8c811b02e31a2a4$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $9KfqA.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $e8c811b02e31a2a4$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $hFdXd.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e8c811b02e31a2a4$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $hFdXd.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e8c811b02e31a2a4$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $hFdXd.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("9KfqA", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $156b00335414a5f7$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $156b00335414a5f7$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $156b00335414a5f7$export$d53d07b6034c4560);
class $156b00335414a5f7$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($156b00335414a5f7$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($156b00335414a5f7$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $156b00335414a5f7$export$4ab84f6f04f6566d = new $156b00335414a5f7$var$UFOLogger();
const $156b00335414a5f7$export$b4958caff08a0960 = (...args)=>{
    $156b00335414a5f7$export$4ab84f6f04f6566d.log(...args);
};
const $156b00335414a5f7$export$d53d07b6034c4560 = (...args)=>{
    $156b00335414a5f7$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("hFdXd", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $4893cc8941877715$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $4893cc8941877715$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $4893cc8941877715$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $4893cc8941877715$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $4893cc8941877715$export$837e0f79a8056912);
var $4893cc8941877715$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $4893cc8941877715$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $4893cc8941877715$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $4893cc8941877715$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $4893cc8941877715$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $4893cc8941877715$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $4893cc8941877715$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $4893cc8941877715$export$9f2bf58999404c75 = 'fmp';
const $4893cc8941877715$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("kWNxm", function(module, exports) {
$parcel$export(module.exports, "UFO_BUILD_VERSION", () => $76224c46c01a9bb0$export$93809551debf385f);
// temp solution until a proper versioning
const $76224c46c01a9bb0$export$93809551debf385f = '0.1.7';

});

parcelRegister("bsNtJ", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $ffbaf6ede570bf82$export$92a757ac1398962f);

var $ffbaf6ede570bf82$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("4pYlS", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $df4eb30c3e02336d$export$faf4c91b80fc830e);

var $9KfqA = parcelRequire("9KfqA");

var $hFdXd = parcelRequire("hFdXd");
class $df4eb30c3e02336d$export$faf4c91b80fc830e {
    push(event) {
        (0, $9KfqA.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $hFdXd.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $hFdXd.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $hFdXd.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $hFdXd.SUBSCRIBE_ALL]) this.subscribers[0, $hFdXd.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $9KfqA.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("4KkOL", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $a8b98f4aef96af4c$export$738d24377baf6a5e);

var $fqfOD = parcelRequire("fqfOD");

var $hFdXd = parcelRequire("hFdXd");

var $6aSQh = parcelRequire("6aSQh");

var $JO8bV = parcelRequire("JO8bV");

var $8S372 = parcelRequire("8S372");

var $04yfh = parcelRequire("04yfh");

var $gUOUj = parcelRequire("gUOUj");
const $a8b98f4aef96af4c$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $a8b98f4aef96af4c$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $a8b98f4aef96af4c$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $a8b98f4aef96af4c$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $fqfOD.ExperiencePerformanceTypes).PageLoad:
            case (0, $fqfOD.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$a8b98f4aef96af4c$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$a8b98f4aef96af4c$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $fqfOD.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$a8b98f4aef96af4c$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$a8b98f4aef96af4c$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $fqfOD.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$a8b98f4aef96af4c$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};
const $a8b98f4aef96af4c$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $hFdXd.FMP_MARK))?.time || (0, $6aSQh.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$a8b98f4aef96af4c$var$LoadMetricKeys.tti]: Math.round(tti),
        [$a8b98f4aef96af4c$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$a8b98f4aef96af4c$var$getHistogram(data, performanceConfig)
    };
};
const $a8b98f4aef96af4c$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $hFdXd.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$a8b98f4aef96af4c$var$InlineResultMetricKeys.result]: Math.round(result),
        [$a8b98f4aef96af4c$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$a8b98f4aef96af4c$var$getHistogram(data, performanceConfig)
    };
};
const $a8b98f4aef96af4c$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$a8b98f4aef96af4c$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$a8b98f4aef96af4c$var$getHistogram(data, performanceConfig)
    };
};
const $a8b98f4aef96af4c$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $fqfOD.ExperiencePerformanceTypes).PageLoad:
        case (0, $fqfOD.ExperiencePerformanceTypes).PageSegmentLoad:
            return $a8b98f4aef96af4c$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $fqfOD.ExperiencePerformanceTypes).InlineResult:
            return $a8b98f4aef96af4c$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $fqfOD.ExperiencePerformanceTypes).Custom:
            return $a8b98f4aef96af4c$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $a8b98f4aef96af4c$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$a8b98f4aef96af4c$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $gUOUj.resourceTimings)(data, resourceConfig),
        ...(0, $04yfh.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $8S372.appTimings)(data, ssr),
        ...(0, $6aSQh.isInitialPageLoad)(data) ? (0, $JO8bV.navigationMetrics)() : null
    };
};

});
parcelRegister("6aSQh", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $16f1ad59f4b6a7b5$export$7167d96e9881d500);

var $fqfOD = parcelRequire("fqfOD");
const $16f1ad59f4b6a7b5$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $fqfOD.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("JO8bV", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $527982345c1999f1$export$b88d990436be0f8a);
const $527982345c1999f1$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("8S372", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $98487a9eb9a570a5$export$e952f50a4f2d02da);

var $fqfOD = parcelRequire("fqfOD");

var $6aSQh = parcelRequire("6aSQh");

var $ihzIW = parcelRequire("ihzIW");

var $9CvgC = parcelRequire("9CvgC");
const $98487a9eb9a570a5$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $fqfOD.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $ihzIW.customTimings)(data);
    const ssr = (0, $6aSQh.isInitialPageLoad)(data) ? (0, $9CvgC.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("ihzIW", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $c6574f2a782d8e2f$export$6126f85083a72c6e);
const $c6574f2a782d8e2f$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $c6574f2a782d8e2f$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $c6574f2a782d8e2f$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("9CvgC", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $cdf65f2a65bb7b3b$export$130f411261a599c5);

var $cqRiN = parcelRequire("cqRiN");
const $cdf65f2a65bb7b3b$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $cdf65f2a65bb7b3b$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $cdf65f2a65bb7b3b$var$SSR_PREFIX = 'ssr';
const $cdf65f2a65bb7b3b$var$mapKey = (key)=>{
    if (key === 'total') return $cdf65f2a65bb7b3b$var$SSR_PREFIX;
    return `${$cdf65f2a65bb7b3b$var$SSR_PREFIX}${0, $cqRiN.NESTED_METRIC_SEPARATOR}${key}`;
};
const $cdf65f2a65bb7b3b$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($cdf65f2a65bb7b3b$var$filterEntry(entry[1])) acc[$cdf65f2a65bb7b3b$var$mapKey(entry[0])] = $cdf65f2a65bb7b3b$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
parcelRegister("cqRiN", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $36b02a6c50947e5f$export$b98e411ae80c806f);
const $36b02a6c50947e5f$export$b98e411ae80c806f = '/';

});



parcelRegister("04yfh", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $cd3726c52c2b2983$export$1a2bb347935fc536);

var $3GW2y = parcelRequire("3GW2y");
const $cd3726c52c2b2983$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $3GW2y.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("3GW2y", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $f508cd229c257535$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $f508cd229c257535$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $f508cd229c257535$export$74560fd4e61fd440);
const $f508cd229c257535$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $f508cd229c257535$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $f508cd229c257535$export$9aa44f85591248d9() || {};
    return performance;
};
const $f508cd229c257535$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $f508cd229c257535$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("gUOUj", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $8eca70b9038bd841$export$81a7d52441a06b50);

var $3GW2y = parcelRequire("3GW2y");

var $aaLne = parcelRequire("aaLne");
const $8eca70b9038bd841$var$cacheableTypes = [
    'script',
    'link'
];
const $8eca70b9038bd841$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $8eca70b9038bd841$var$CACHE_NETWORK = 'network';
const $8eca70b9038bd841$var$CACHE_MEMORY = 'memory';
const $8eca70b9038bd841$var$CACHE_DISK = 'disk';
const $8eca70b9038bd841$var$calculateTransferType = (type, duration, size)=>{
    if (!$8eca70b9038bd841$var$cacheableTypes.includes(type)) return $8eca70b9038bd841$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $8eca70b9038bd841$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $8eca70b9038bd841$var$CACHE_DISK;
    if (size === undefined) return null;
    return $8eca70b9038bd841$var$CACHE_NETWORK;
};
const $8eca70b9038bd841$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$8eca70b9038bd841$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $3GW2y.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $8eca70b9038bd841$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $8eca70b9038bd841$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $8eca70b9038bd841$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $8eca70b9038bd841$var$getNetworkData = (item, eventStart, hasTimingHeaders = $8eca70b9038bd841$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$8eca70b9038bd841$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($8eca70b9038bd841$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $8eca70b9038bd841$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$8eca70b9038bd841$var$getSizeObject(transferSize)
        };
        if (transferType !== $8eca70b9038bd841$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$8eca70b9038bd841$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$8eca70b9038bd841$var$getSizeObject(transferSize)
    };
};
const $8eca70b9038bd841$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $3GW2y.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $aaLne.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $8eca70b9038bd841$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $8eca70b9038bd841$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$8eca70b9038bd841$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("aaLne", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $d1bcd03f772c832b$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $d1bcd03f772c832b$export$9eebb59359c2e9e5);
// @flow strict-local

var $9KfqA = parcelRequire("9KfqA");

var $3GW2y = parcelRequire("3GW2y");
const $d1bcd03f772c832b$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $3GW2y.getPerformanceObject)(), PerformanceObserver1 = (0, $3GW2y.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($d1bcd03f772c832b$export$bea963256235a63e.observer) {
            (0, $9KfqA.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $d1bcd03f772c832b$export$bea963256235a63e.timings = resources.map((resource)=>$d1bcd03f772c832b$export$bea963256235a63e.transformResource(resource));
        $d1bcd03f772c832b$export$bea963256235a63e.observer = new PerformanceObserver1($d1bcd03f772c832b$export$bea963256235a63e.addTimings);
        $d1bcd03f772c832b$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($d1bcd03f772c832b$export$bea963256235a63e.observer) {
            $d1bcd03f772c832b$export$bea963256235a63e.observer.disconnect();
            $d1bcd03f772c832b$export$bea963256235a63e.observer = null;
        }
        $d1bcd03f772c832b$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$d1bcd03f772c832b$export$bea963256235a63e.transformResource(entry));
        const overflow = $d1bcd03f772c832b$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $d1bcd03f772c832b$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $d1bcd03f772c832b$export$bea963256235a63e.maxSize;
            $d1bcd03f772c832b$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $d1bcd03f772c832b$export$bea963256235a63e.timings.push(...entries);
    }
};
const $d1bcd03f772c832b$export$9eebb59359c2e9e5 = (startTime, performance = (0, $3GW2y.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$d1bcd03f772c832b$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $d1bcd03f772c832b$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("hHhXx", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $902df9dfe44972c8$export$723b4c298aca63af);

var $hFdXd = parcelRequire("hFdXd");
const $902df9dfe44972c8$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $hFdXd.PageVisibleState).HIDDEN : (0, $hFdXd.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("6dwbd", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $ee9b61b037ebb5ab$export$e34e4529b979f74c);
const $ee9b61b037ebb5ab$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("b9Pvh", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $1fc1067adf223a07$export$82ae485178b37419);
const $1fc1067adf223a07$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("03koQ", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $4b4590ebe3e4a5bc$export$f435c2789ca334a7);

var $4c2Sh = parcelRequire("4c2Sh");

var $2IvOD = parcelRequire("2IvOD");

var $3GW2y = parcelRequire("3GW2y");
const $4b4590ebe3e4a5bc$export$f435c2789ca334a7 = (0, $2IvOD.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4c2Sh))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4c2Sh))).getParser((0, $3GW2y.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});
parcelRegister("4c2Sh", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});

parcelRegister("2IvOD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fa85ec6884a5e67$export$2e2bcd8739ae039);
var $1fa85ec6884a5e67$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $1fa85ec6884a5e67$var$isEqual(first, second) {
    if (first === second) return true;
    if ($1fa85ec6884a5e67$var$safeIsNaN(first) && $1fa85ec6884a5e67$var$safeIsNaN(second)) return true;
    return false;
}
function $1fa85ec6884a5e67$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$1fa85ec6884a5e67$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $1fa85ec6884a5e67$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $1fa85ec6884a5e67$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("aubM9", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $947013c8a1d634d5$export$db7649b8854107ad);

var $2IvOD = parcelRequire("2IvOD");
const $947013c8a1d634d5$export$db7649b8854107ad = (0, $2IvOD.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("5KtuY", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $c71396dea4a39032$export$e62953d023125748);
const $c71396dea4a39032$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("j2uN6", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $02bca10c029e8c57$export$81efaf8414879a1a);

var $2IvOD = parcelRequire("2IvOD");
const $02bca10c029e8c57$export$81efaf8414879a1a = (0, $2IvOD.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("bhNEM", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $7e004f1d7f1f8d74$export$ce1cf816dce1da56);
const $7e004f1d7f1f8d74$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("kL6BQ", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $69e104c0727100d9$export$fdbea518c19dfa8);
const $69e104c0727100d9$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("9AxPR", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $17a3bbce6fb5b322$export$a3dc8251cf55b2e0);
const $17a3bbce6fb5b322$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("9nMP7", function(module, exports) {
$parcel$export(module.exports, "Route", () => $31d031c3e50737e7$export$e7b0ac011bb776c6);
const $31d031c3e50737e7$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


parcelRegister("02dIe", function(module, exports) {
$parcel$export(module.exports, "init", () => $4529eb8a23e361e6$export$2cd8252107eb640b);

var $keFM9 = parcelRequire("keFM9");

var $2aEiL = parcelRequire("2aEiL");

var $jCX97 = parcelRequire("jCX97");

var $5tITM = parcelRequire("5tITM");

var $1Fm2L = parcelRequire("1Fm2L");

var $96k96 = parcelRequire("96k96");

var $cGjFC = parcelRequire("cGjFC");

var $8OjRF = parcelRequire("8OjRF");

var $kCpqu = parcelRequire("kCpqu");

var $hF6SW = parcelRequire("hF6SW");

var $bOxTu = parcelRequire("bOxTu");

var $7BZlZ = parcelRequire("7BZlZ");
let $4529eb8a23e361e6$var$initialized = false;
function $4529eb8a23e361e6$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $7BZlZ.default)(onIdle);
    }
    (0, $8OjRF.sinkInteractionHandler)(sinkFn);
}
function $4529eb8a23e361e6$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $8OjRF.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $7BZlZ.default)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $4529eb8a23e361e6$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $bOxTu.sinkTerminalErrorHandler)((errorData, context)=>{
        (0, $7BZlZ.default)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $4529eb8a23e361e6$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $7BZlZ.default)(onIdle);
    }
    (0, $1Fm2L.sinkExtraSearchPageInteractionHandler)(sinkFn);
}



function $4529eb8a23e361e6$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($4529eb8a23e361e6$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $5tITM.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $5tITM.isUFOEnabled)()) {
        $4529eb8a23e361e6$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $hF6SW.initialisePressureObserver)();
    (0, $hF6SW.initialiseMemoryObserver)();
    if ((0, $2aEiL.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $96k96.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $96k96.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $keFM9.context).setGlobalContextManager(contextManager);
    }
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $5tITM.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $8OjRF.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, $cGjFC.setupHiddenTimingCapture)();
    (0, $jCX97.startLighthouseObserver)();
    (0, $cGjFC.setupThrottleDetection)();
    $4529eb8a23e361e6$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $kCpqu.getPerformanceObserver)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("hJgqQ")),
        (parcelRequire("jxaNj")),
        (parcelRequire("347Kf"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $4529eb8a23e361e6$var$sinkInteraction(instance, payloadPackage);
            if (config?.terminalErrors?.enabled) $4529eb8a23e361e6$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $4529eb8a23e361e6$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $4529eb8a23e361e6$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $4529eb8a23e361e6$var$sinkInteraction(awc, payloadPackage);
            if (config?.terminalErrors?.enabled) $4529eb8a23e361e6$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $4529eb8a23e361e6$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $4529eb8a23e361e6$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}

});
parcelRegister("jCX97", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", () => $767152f875677225$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $767152f875677225$export$b46cecdf698e4bb5);

var $ithC0 = parcelRequire("ithC0");

var $9Lgqr = parcelRequire("9Lgqr");

var $8UMV2 = parcelRequire("8UMV2");

var $haLaD = parcelRequire("haLaD");

var $idxPB = parcelRequire("idxPB");
function $767152f875677225$export$5ecf2aafafee3e0() {
    (0, $idxPB.startLSObserver)();
    (0, $idxPB.startLTObserver)();
}
function $767152f875677225$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $8UMV2.getTBT)(start, stop, (0, $haLaD.EntriesBuffer)[(0, $9Lgqr.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $ithC0.getCLS)(start, stop, (0, $haLaD.EntriesBuffer)[(0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("ithC0", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $f8d6d827e5353763$export$fc6227831ee7c7);
function $f8d6d827e5353763$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $f8d6d827e5353763$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$f8d6d827e5353763$var$isSameRects(previousRect, currentRect));
        return isWithinObservationWindow && !allSourcesHaveSameRects;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("9Lgqr", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $0379aa7fb0ed38ea$export$a4def92db6fc8e17);
const $0379aa7fb0ed38ea$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("8UMV2", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $be88348f8c3f7709$export$2d6e933b35bd3407);
const $be88348f8c3f7709$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $be88348f8c3f7709$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $be88348f8c3f7709$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $be88348f8c3f7709$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $be88348f8c3f7709$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("haLaD", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $ba8a7283ef86860e$export$f7dc16cbd16f7bbe);

var $9Lgqr = parcelRequire("9Lgqr");
class $ba8a7283ef86860e$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $ba8a7283ef86860e$export$f7dc16cbd16f7bbe = {
    [(0, $9Lgqr.PerformanceObserverEntryTypes).LongTask]: new $ba8a7283ef86860e$export$2c6e86519c9e8188(),
    [(0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift]: new $ba8a7283ef86860e$export$2c6e86519c9e8188()
};

});

parcelRegister("idxPB", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $854b74f0e29122d6$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $854b74f0e29122d6$export$54fb8b6aaf70ec9c);

var $9Lgqr = parcelRequire("9Lgqr");

var $haLaD = parcelRequire("haLaD");
let $854b74f0e29122d6$var$pe = null;
function $854b74f0e29122d6$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($854b74f0e29122d6$var$pe !== null) return $854b74f0e29122d6$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift) (0, $haLaD.EntriesBuffer)[(0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $9Lgqr.PerformanceObserverEntryTypes).LongTask) (0, $haLaD.EntriesBuffer)[(0, $9Lgqr.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $854b74f0e29122d6$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $854b74f0e29122d6$var$pe;
}
function $854b74f0e29122d6$export$768ccc3ab7bac3ea() {
    $854b74f0e29122d6$var$getObserver()?.observe({
        type: (0, $9Lgqr.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $854b74f0e29122d6$export$54fb8b6aaf70ec9c() {
    $854b74f0e29122d6$var$getObserver()?.observe({
        type: (0, $9Lgqr.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("5tITM", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $435c1b8be196ab54$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $435c1b8be196ab54$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $435c1b8be196ab54$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $435c1b8be196ab54$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $435c1b8be196ab54$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $435c1b8be196ab54$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $435c1b8be196ab54$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $435c1b8be196ab54$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $435c1b8be196ab54$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $435c1b8be196ab54$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $435c1b8be196ab54$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $435c1b8be196ab54$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $435c1b8be196ab54$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $435c1b8be196ab54$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $435c1b8be196ab54$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $435c1b8be196ab54$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $435c1b8be196ab54$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $435c1b8be196ab54$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $435c1b8be196ab54$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $435c1b8be196ab54$export$c681731847989445);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $40Sn3 = parcelRequire("40Sn3");

var $2aEiL = parcelRequire("2aEiL");
let $435c1b8be196ab54$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $435c1b8be196ab54$var$cachedIsFedrampModerate;
function $435c1b8be196ab54$var$detectIsFedrampModerate() {
    if ($435c1b8be196ab54$var$cachedIsFedrampModerate !== undefined) return $435c1b8be196ab54$var$cachedIsFedrampModerate;
    try {
        $435c1b8be196ab54$var$cachedIsFedrampModerate = (0, $40Sn3.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $435c1b8be196ab54$var$cachedIsFedrampModerate = false;
    }
    return $435c1b8be196ab54$var$cachedIsFedrampModerate;
}
function $435c1b8be196ab54$export$89dc2b6be8cc261() {
    $435c1b8be196ab54$var$cachedIsFedrampModerate = undefined;
}
function $435c1b8be196ab54$export$1133b5e2873baa7a() {
    try {
        return $435c1b8be196ab54$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $435c1b8be196ab54$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $435c1b8be196ab54$export$f9bb3bb330fb9609 = 'fy26.04';
function $435c1b8be196ab54$export$2182e73d31080cbc() {
    return $435c1b8be196ab54$export$f9bb3bb330fb9609;
}
const $435c1b8be196ab54$export$d50dacda7fe6392b = 1000;
function $435c1b8be196ab54$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $435c1b8be196ab54$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $435c1b8be196ab54$var$config = newConfig;
}
function $435c1b8be196ab54$export$44487a86467333c3() {
    return $435c1b8be196ab54$var$config;
}
function $435c1b8be196ab54$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // 1. FedRAMP override always wins.
    if ($435c1b8be196ab54$var$detectIsFedrampModerate()) return $435c1b8be196ab54$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $435c1b8be196ab54$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $435c1b8be196ab54$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $435c1b8be196ab54$var$config?.enabled !== false;
}
const $435c1b8be196ab54$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $435c1b8be196ab54$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$435c1b8be196ab54$var$config) return [];
        if ($435c1b8be196ab54$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $435c1b8be196ab54$var$config.vc ?? {};
            if ($435c1b8be196ab54$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $2aEiL.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($435c1b8be196ab54$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $435c1b8be196ab54$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $435c1b8be196ab54$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $435c1b8be196ab54$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $435c1b8be196ab54$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $435c1b8be196ab54$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $435c1b8be196ab54$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $435c1b8be196ab54$export$2d8f8d64dc343d7b() {
    if (!$435c1b8be196ab54$var$config) return undefined;
    try {
        const stats = $435c1b8be196ab54$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $435c1b8be196ab54$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$435c1b8be196ab54$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $435c1b8be196ab54$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $435c1b8be196ab54$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $435c1b8be196ab54$export$48f4e0d964030a96(name, interactionType) {
    return $435c1b8be196ab54$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $435c1b8be196ab54$export$9c69f5a724f05f38(name, interactionType) {
    return $435c1b8be196ab54$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $435c1b8be196ab54$export$1d459f020c06ae34(name, interactionType) {
    return $435c1b8be196ab54$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $435c1b8be196ab54$export$29b9ffb14861a1d(capability) {
    if ((0, $2aEiL.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$435c1b8be196ab54$var$config) return 0;
        const { capability: capabilityRate } = $435c1b8be196ab54$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $435c1b8be196ab54$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$435c1b8be196ab54$var$config) return 0;
        const gotConfig = $435c1b8be196ab54$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $435c1b8be196ab54$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $435c1b8be196ab54$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$435c1b8be196ab54$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $435c1b8be196ab54$var$config;
        if (typingMethod != null && $435c1b8be196ab54$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $435c1b8be196ab54$export$2d311b3fd18dcab1() {
    try {
        if (!$435c1b8be196ab54$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $435c1b8be196ab54$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $435c1b8be196ab54$export$4f4649ef27b6f5d6() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $435c1b8be196ab54$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$b150ddad71c80d77() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $435c1b8be196ab54$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$3c170167645a0eff() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $435c1b8be196ab54$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$d6dc9444bd15f70f() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $435c1b8be196ab54$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $435c1b8be196ab54$export$20e8108b8ccdd0bd() {
    try {
        if (!$435c1b8be196ab54$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $435c1b8be196ab54$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $435c1b8be196ab54$export$2a8604960d7d23d9 = 60000;
function $435c1b8be196ab54$export$c681731847989445(ufoName) {
    try {
        if (!$435c1b8be196ab54$var$config) return $435c1b8be196ab54$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $435c1b8be196ab54$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $435c1b8be196ab54$export$2a8604960d7d23d9;
    } catch  {
        return $435c1b8be196ab54$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("40Sn3", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $8cc770332363bca6$export$104cb891a6e90b3a);

var $aPJb3 = parcelRequire("aPJb3");

var $ggGWC = parcelRequire("ggGWC");
function $8cc770332363bca6$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInFedramp ?? false;
    const atlCtxCookieValues = (0, $ggGWC.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $aPJb3.FEDRAMP_MODERATE);
}

});
parcelRegister("aPJb3", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $43d66246f5dc76db$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $43d66246f5dc76db$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $43d66246f5dc76db$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $43d66246f5dc76db$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $43d66246f5dc76db$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $43d66246f5dc76db$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $43d66246f5dc76db$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $43d66246f5dc76db$export$a0ffa0598c95dfb7);
$parcel$export(module.exports, "BIFROST_ATL_CTX_CLOUD_SERVICE_PROVIDER", () => $43d66246f5dc76db$export$74814ca8786924c3);
$parcel$export(module.exports, "CLOUD_SERVICE_PROVIDER_GCP", () => $43d66246f5dc76db$export$b61e047ddcc35726);
const $43d66246f5dc76db$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $43d66246f5dc76db$export$f005e2e9f707cb5f = 'commercial';
const $43d66246f5dc76db$export$17b81a3d6c98013c = 'isolated-cloud';
const $43d66246f5dc76db$export$a739cd5aac835909 = 'staging';
const $43d66246f5dc76db$export$42dd0cdd351a4a9 = 'prod';
const $43d66246f5dc76db$export$404582bc18fe4d9e = 'dev';
const $43d66246f5dc76db$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $43d66246f5dc76db$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $43d66246f5dc76db$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $43d66246f5dc76db$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $43d66246f5dc76db$export$b61e047ddcc35726 = 'GCP';
const $43d66246f5dc76db$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("ggGWC", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $4d4c1f8c6683dfc2$export$3fa7b7af96286cc9);

var $aPJb3 = parcelRequire("aPJb3");

var $4KYU8 = parcelRequire("4KYU8");
function $4d4c1f8c6683dfc2$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $4KYU8.getRawCookieValue)((0, $aPJb3.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $4KYU8.getRawCookieValue)((0, $aPJb3.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, $4KYU8.getRawCookieValue)((0, $aPJb3.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("4KYU8", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $ab6dc6ed062ce3a7$export$aa09aab30a92256c);
function $ab6dc6ed062ce3a7$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});




parcelRegister("1Fm2L", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", () => $0c8c0cf5e3c9a572$export$e6a07a94f3e112d4);
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $0c8c0cf5e3c9a572$export$74b9ce7e9d206a8);
const $0c8c0cf5e3c9a572$var$interactionBuffer = [];
let $0c8c0cf5e3c9a572$var$bufferInteractionData = (interactionId, data)=>{
    $0c8c0cf5e3c9a572$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $0c8c0cf5e3c9a572$var$clearInteractionBuffer() {
    $0c8c0cf5e3c9a572$var$interactionBuffer.length = 0;
}
function $0c8c0cf5e3c9a572$var$appendInteractionData(interactionId, data) {
    $0c8c0cf5e3c9a572$var$bufferInteractionData(interactionId, data);
}
function $0c8c0cf5e3c9a572$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $0c8c0cf5e3c9a572$var$interactionBuffer)handler(interactionId, data);
    $0c8c0cf5e3c9a572$var$clearInteractionBuffer();
    $0c8c0cf5e3c9a572$var$bufferInteractionData = handler;
}
function $0c8c0cf5e3c9a572$export$e6a07a94f3e112d4(sinkFn) {
    $0c8c0cf5e3c9a572$var$installInteractionSink(sinkFn);
}
function $0c8c0cf5e3c9a572$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $0c8c0cf5e3c9a572$var$appendInteractionData(interactionId, data);
        $0c8c0cf5e3c9a572$var$clearInteractionBuffer();
    }
}

});

parcelRegister("96k96", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $8f4c23928f3f735e$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $8f4c23928f3f735e$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $8f4c23928f3f735e$export$dd301b96c16f583d);

var $dCCNu = parcelRequire("dCCNu");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $8f4c23928f3f735e$var$contextManager;
function $8f4c23928f3f735e$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $8f4c23928f3f735e$var$contextManager = ctxMgr;
}
function $8f4c23928f3f735e$export$831109c9f7727010() {
    return $8f4c23928f3f735e$var$contextManager;
}
class $8f4c23928f3f735e$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $dCCNu.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $dCCNu.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $dCCNu.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $dCCNu.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
   * whether the context manager is enabled or not
   */ this._enabled = false;
        /**
   * Keeps the reference to current context
   */ this._currentContext = (0, $dCCNu.ROOT_CONTEXT);
    }
}

});

parcelRegister("cGjFC", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $41278ded42065dfe$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $41278ded42065dfe$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $41278ded42065dfe$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $41278ded42065dfe$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $41278ded42065dfe$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $41278ded42065dfe$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $41278ded42065dfe$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $41278ded42065dfe$export$5a06b84e47ad70d9);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dmmsG = parcelRequire("dmmsG");

var $2aEiL = parcelRequire("2aEiL");
const $41278ded42065dfe$var$timings = [];
let $41278ded42065dfe$var$wasHiddenFlag;
let $41278ded42065dfe$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $41278ded42065dfe$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $41278ded42065dfe$var$openedInBackground = null;
function $41278ded42065dfe$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $41278ded42065dfe$var$SIZE = 50;
let $41278ded42065dfe$var$insertIndex = 0;
function $41278ded42065dfe$export$754443ce7c615bd7(startTime, endTime) {
    const earliestHiddenTiming = $41278ded42065dfe$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)?.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $41278ded42065dfe$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $41278ded42065dfe$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $41278ded42065dfe$var$openedInBackground === true;
}
function $41278ded42065dfe$var$pushHidden(isPageHiddenFlag, time) {
    $41278ded42065dfe$var$timings[$41278ded42065dfe$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $41278ded42065dfe$var$insertIndex = ($41278ded42065dfe$var$insertIndex + 1) % $41278ded42065dfe$var$SIZE;
    $41278ded42065dfe$var$wasHiddenFlag = isPageHiddenFlag;
}
function $41278ded42065dfe$var$handleChange() {
    const isPageHiddenFlag = $41278ded42065dfe$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$41278ded42065dfe$var$wasHiddenFlag) $41278ded42065dfe$var$pushHidden(isPageHiddenFlag);
        $41278ded42065dfe$var$wasHiddenFlag = true;
    } else {
        if ($41278ded42065dfe$var$wasHiddenFlag) $41278ded42065dfe$var$pushHidden(isPageHiddenFlag);
        $41278ded42065dfe$var$wasHiddenFlag = false;
    }
}
let $41278ded42065dfe$var$hasHiddenTimingBeforeSetup = false;
function $41278ded42065dfe$export$95f048bd8bcdda23() {
    return $41278ded42065dfe$var$hasHiddenTimingBeforeSetup;
}
function $41278ded42065dfe$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results?.forEach((result)=>{
            if ((0, $2aEiL.fg)('platform_ufo_use_native_page_visibility_api')) $41278ded42065dfe$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $41278ded42065dfe$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $dmmsG.bind)(window, {
        type: 'pageshow',
        listener: $41278ded42065dfe$var$handleChange
    });
    (0, $dmmsG.bind)(window, {
        type: 'pagehide',
        listener: $41278ded42065dfe$var$handleChange
    });
    (0, $dmmsG.bind)(document, {
        type: 'visibilitychange',
        listener: $41278ded42065dfe$var$handleChange
    });
}
function $41278ded42065dfe$export$554cefe0f0373da4() {
    if (!$41278ded42065dfe$var$setupFlag) {
        const isPageHiddenFlag = $41278ded42065dfe$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($41278ded42065dfe$var$openedInBackground === null) $41278ded42065dfe$var$openedInBackground = isPageHiddenFlag && setupTime < $41278ded42065dfe$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $41278ded42065dfe$var$pushHidden(isPageHiddenFlag, 0);
        $41278ded42065dfe$var$setup();
        $41278ded42065dfe$var$setupFlag = true;
    }
}
function $41278ded42065dfe$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($41278ded42065dfe$var$timings.length === 0) return 'visible';
    const currentSize = $41278ded42065dfe$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $41278ded42065dfe$var$insertIndex;
    let endIdx = $41278ded42065dfe$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($41278ded42065dfe$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($41278ded42065dfe$var$timings[tmpIdx] && $41278ded42065dfe$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($41278ded42065dfe$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $41278ded42065dfe$var$timings[startIdx]) hiddenState = $41278ded42065dfe$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $41278ded42065dfe$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $41278ded42065dfe$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $41278ded42065dfe$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $41278ded42065dfe$var$throttleMeasurements = [];
let $41278ded42065dfe$var$throttleInsertIndex = 0;
let $41278ded42065dfe$var$throttleIntervalId = null;
let $41278ded42065dfe$var$lastThrottleCheckTime = null;
let $41278ded42065dfe$var$throttleSetupDone = false;
function $41278ded42065dfe$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $41278ded42065dfe$var$THROTTLE_DRIFT_THRESHOLD;
    $41278ded42065dfe$var$throttleMeasurements[$41278ded42065dfe$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $41278ded42065dfe$var$throttleInsertIndex = ($41278ded42065dfe$var$throttleInsertIndex + 1) % $41278ded42065dfe$var$THROTTLE_BUFFER_SIZE;
}
function $41278ded42065dfe$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($41278ded42065dfe$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $41278ded42065dfe$var$lastThrottleCheckTime;
        $41278ded42065dfe$var$recordThrottleMeasurement($41278ded42065dfe$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $41278ded42065dfe$var$lastThrottleCheckTime = currentTime;
}
function $41278ded42065dfe$export$fa0d29a9c87052da() {
    if ($41278ded42065dfe$var$throttleSetupDone) return;
    $41278ded42065dfe$var$throttleSetupDone = true;
    // Record the initial timestamp
    $41278ded42065dfe$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $41278ded42065dfe$var$throttleIntervalId = setInterval($41278ded42065dfe$var$throttleCheckCallback, $41278ded42065dfe$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $41278ded42065dfe$export$3279694d66e4a1() {
    if ($41278ded42065dfe$var$throttleIntervalId !== null) {
        clearInterval($41278ded42065dfe$var$throttleIntervalId);
        $41278ded42065dfe$var$throttleIntervalId = null;
    }
    $41278ded42065dfe$var$lastThrottleCheckTime = null;
    $41278ded42065dfe$var$throttleSetupDone = false;
    $41278ded42065dfe$var$throttleMeasurements.length = 0;
    $41278ded42065dfe$var$throttleInsertIndex = 0;
}
function $41278ded42065dfe$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($41278ded42065dfe$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $41278ded42065dfe$var$throttleMeasurements.length; i++){
        const measurement = $41278ded42065dfe$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $41278ded42065dfe$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $41278ded42065dfe$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $41278ded42065dfe$export$9332de935653b687(measurement) {
    $41278ded42065dfe$var$throttleMeasurements[$41278ded42065dfe$var$throttleInsertIndex] = measurement;
    $41278ded42065dfe$var$throttleInsertIndex = ($41278ded42065dfe$var$throttleInsertIndex + 1) % $41278ded42065dfe$var$THROTTLE_BUFFER_SIZE;
}
function $41278ded42065dfe$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($41278ded42065dfe$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $41278ded42065dfe$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($41278ded42065dfe$var$insertIndex + i) % currentSize;
        const entry = $41278ded42065dfe$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($41278ded42065dfe$var$insertIndex + i) % currentSize;
        const entry = $41278ded42065dfe$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $41278ded42065dfe$export$9332de935653b687
};

});
parcelRegister("dmmsG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $f3XIg = parcelRequire("f3XIg");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $f3XIg.bind;
    }
});

var $6entr = parcelRequire("6entr");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $6entr.bindAll;
    }
});

});
parcelRegister("f3XIg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $af757495d6637b42$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $af757495d6637b42$var$bind;

});

parcelRegister("6entr", function(module, exports) {
"use strict";
var $4896424d5f0c4bf3$var$__assign = module.exports && module.exports.__assign || function() {
    $4896424d5f0c4bf3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4896424d5f0c4bf3$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $f3XIg = parcelRequire("f3XIg");
function $4896424d5f0c4bf3$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $4896424d5f0c4bf3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $4896424d5f0c4bf3$var$__assign($4896424d5f0c4bf3$var$__assign({}, original), {
        options: $4896424d5f0c4bf3$var$__assign($4896424d5f0c4bf3$var$__assign({}, $4896424d5f0c4bf3$var$toOptions(sharedOptions)), $4896424d5f0c4bf3$var$toOptions(original.options))
    });
    return binding;
}
function $4896424d5f0c4bf3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $4896424d5f0c4bf3$var$getBinding(original, sharedOptions);
        return (0, $f3XIg.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $4896424d5f0c4bf3$var$bindAll;

});



parcelRegister("8OjRF", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $56736c0547554e17$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $56736c0547554e17$export$d8f52e8f804021e8);
$parcel$export(module.exports, "segmentUnmountCache", () => $56736c0547554e17$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $56736c0547554e17$export$2b3954d2e8509985);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $56736c0547554e17$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $56736c0547554e17$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCohortingCustomData", () => $56736c0547554e17$export$20265b12c6625451);
$parcel$export(module.exports, "addCustomTiming", () => $56736c0547554e17$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $56736c0547554e17$export$728e28c22a0fba4);
$parcel$export(module.exports, "addSpan", () => $56736c0547554e17$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $56736c0547554e17$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $56736c0547554e17$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $56736c0547554e17$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $56736c0547554e17$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $56736c0547554e17$export$2df109852219d16e);
$parcel$export(module.exports, "addError", () => $56736c0547554e17$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $56736c0547554e17$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $56736c0547554e17$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $56736c0547554e17$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $56736c0547554e17$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $56736c0547554e17$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $56736c0547554e17$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $56736c0547554e17$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $56736c0547554e17$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $56736c0547554e17$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $56736c0547554e17$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $56736c0547554e17$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $56736c0547554e17$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $56736c0547554e17$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $56736c0547554e17$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $56736c0547554e17$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $56736c0547554e17$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $56736c0547554e17$export$5342dcad19138a1c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $664X1 = parcelRequire("664X1");

var $fskN5 = parcelRequire("fskN5");

var $3D6wc = parcelRequire("3D6wc");

var $5tITM = parcelRequire("5tITM");

var $1Fm2L = parcelRequire("1Fm2L");

var $5Mr7y = parcelRequire("5Mr7y");

var $68Mzh = parcelRequire("68Mzh");

var $9S99b = parcelRequire("9S99b");

var $31aDV = parcelRequire("31aDV");

var $kPSgw = parcelRequire("kPSgw");

var $cNKkA = parcelRequire("cNKkA");

var $3SSwD = parcelRequire("3SSwD");

var $eId1k = parcelRequire("eId1k");

var $i0C6O = parcelRequire("i0C6O");
const $56736c0547554e17$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $56736c0547554e17$export$d8f52e8f804021e8 = new (0, $i0C6O.default)();
const $56736c0547554e17$var$interactionQueue = [];
const $56736c0547554e17$var$segmentCache = new Map();
const $56736c0547554e17$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $56736c0547554e17$var$segmentObservers = [];
function $56736c0547554e17$export$2b3954d2e8509985() {
    const interactionId = (0, $31aDV.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $eId1k.interactions).get(interactionId.current);
}
function $56736c0547554e17$var$isPerformanceTracingEnabled() {
    return (0, $5tITM.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $56736c0547554e17$var$performanceEventObserver;
const $56736c0547554e17$export$17afbba0f16b4b19 = ()=>{
    $56736c0547554e17$var$performanceEventObserver = $56736c0547554e17$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $56736c0547554e17$export$e6be05b411ce21a6(entry);
    });
    return $56736c0547554e17$var$performanceEventObserver;
};
const $56736c0547554e17$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $56736c0547554e17$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $56736c0547554e17$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $56736c0547554e17$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $56736c0547554e17$var$addSegmentObserver(observer) {
    $56736c0547554e17$var$segmentObservers.push(observer);
    for (const segmentInfo of $56736c0547554e17$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $56736c0547554e17$var$removeSegmentObserver(observer) {
    const index = $56736c0547554e17$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $56736c0547554e17$var$segmentObservers.splice(index, 1);
}
function $56736c0547554e17$export$cd7f480d6b8286c3(interactionId) {
    (0, $eId1k.interactions).delete(interactionId);
}
function $56736c0547554e17$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $56736c0547554e17$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $56736c0547554e17$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $56736c0547554e17$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $56736c0547554e17$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $56736c0547554e17$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $kPSgw.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $56736c0547554e17$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $56736c0547554e17$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $56736c0547554e17$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $56736c0547554e17$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $3D6wc.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($56736c0547554e17$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $56736c0547554e17$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $56736c0547554e17$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $56736c0547554e17$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $eId1k.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $56736c0547554e17$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $56736c0547554e17$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $eId1k.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $56736c0547554e17$export$9e04fe1a58571ec(moduleId, timestamp) {
    $56736c0547554e17$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $56736c0547554e17$export$6f228d1fdc911d7(identifier, start, end) {
    $56736c0547554e17$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $56736c0547554e17$var$moduleLoadingRequests = {};
function $56736c0547554e17$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $56736c0547554e17$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $56736c0547554e17$var$labelStackToString(labelStack), name, startTime);
}
function $56736c0547554e17$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $56736c0547554e17$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $664X1.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $56736c0547554e17$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $56736c0547554e17$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $56736c0547554e17$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $56736c0547554e17$var$removeHoldCriterion(id);
            const currentInteraction = (0, $eId1k.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $56736c0547554e17$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $56736c0547554e17$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $56736c0547554e17$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $56736c0547554e17$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $56736c0547554e17$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        $56736c0547554e17$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $56736c0547554e17$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $56736c0547554e17$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $eId1k.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($56736c0547554e17$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $56736c0547554e17$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $56736c0547554e17$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $56736c0547554e17$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $56736c0547554e17$export$2df109852219d16e(interactionId) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $56736c0547554e17$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $56736c0547554e17$export$9e04fe1a58571ec($56736c0547554e17$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $56736c0547554e17$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $56736c0547554e17$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $56736c0547554e17$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $56736c0547554e17$var$moduleLoadingRequests[info.identifier];
            $56736c0547554e17$export$6f228d1fdc911d7($56736c0547554e17$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $31aDV.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $56736c0547554e17$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $31aDV.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $56736c0547554e17$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $56736c0547554e17$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $56736c0547554e17$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $eId1k.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $56736c0547554e17$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $5tITM.getConfig)()?.postInteractionLog?.enabled) $56736c0547554e17$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $56736c0547554e17$var$pushToQueue(id, data) {
    $56736c0547554e17$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $56736c0547554e17$var$handleInteraction = $56736c0547554e17$var$pushToQueue;
const $56736c0547554e17$var$isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const $56736c0547554e17$var$hasMetricVariantCategory = (labelStack, category)=>labelStack?.some((label)=>'type' in label && label.type === category) ?? false;
const $56736c0547554e17$var$hasAnyMetricVariantCategory = (labelStack)=>labelStack?.some((label)=>'type' in label && $56736c0547554e17$var$isKnownMetricVariantCategory(label.type)) ?? false;
const $56736c0547554e17$var$getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack?.forEach((label)=>{
        if ('type' in label && $56736c0547554e17$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const $56736c0547554e17$var$hasMetricVariantCategoryInHoldData = (interaction, category)=>interaction.holdInfo.some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.holdActive.values() ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pInfo ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category));
const $56736c0547554e17$var$recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    const categories = $56736c0547554e17$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = interaction.metricCategoryEnds ?? {};
    categories.forEach((category)=>{
        interaction.metricCategoryEnds[category] = Math.max(interaction.metricCategoryEnds[category] ?? 0, end);
    });
};
const $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    interaction.hold3pActive?.forEach((hold)=>{
        $56736c0547554e17$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const $56736c0547554e17$var$hasActiveMetricVariantCategory = (interaction, category)=>[
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$56736c0547554e17$var$hasMetricVariantCategory(hold.labelStack, category));
function $56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    return $56736c0547554e17$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
function $56736c0547554e17$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $56736c0547554e17$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $56736c0547554e17$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$56736c0547554e17$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $56736c0547554e17$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $56736c0547554e17$var$ensureMetricWindows(interaction) {
    if (interaction.end === 0) return;
    const hasGenAI = $56736c0547554e17$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = $56736c0547554e17$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = interaction.metricCategoryEnds?.['third-party'] !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = interaction.metricCategoryEnds?.['gen-ai'] !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    };
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $56736c0547554e17$var$addLifecycleObservation(interaction, observation) {
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $56736c0547554e17$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $56736c0547554e17$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $56736c0547554e17$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $9S99b.currentFeatureFlagsAccessed));
    (0, $68Mzh.clearActiveTrace)();
    $56736c0547554e17$var$callCleanUpCallbacks(data);
    (0, $cNKkA.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $5tITM.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $fskN5.default)((0, $5tITM.getPostInteractionRate)((0, $5Mr7y.sanitizeUfoName)(data.ufoName), data.type))) $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    $56736c0547554e17$export$cd7f480d6b8286c3(id);
    $56736c0547554e17$export$dbba6cdedab4e68b.id = data.id;
    $56736c0547554e17$export$dbba6cdedab4e68b.type = data.type;
    $56736c0547554e17$export$dbba6cdedab4e68b.timestamp = data.end;
    $56736c0547554e17$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $56736c0547554e17$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $56736c0547554e17$var$handleInteraction(id, data);
    if ($56736c0547554e17$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $56736c0547554e17$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$56736c0547554e17$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $56736c0547554e17$export$9e614a29a1ac213e(sinkFn) {
    if ($56736c0547554e17$var$handleInteraction === $56736c0547554e17$var$pushToQueue) {
        $56736c0547554e17$var$handleInteraction = sinkFn;
        $56736c0547554e17$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $56736c0547554e17$var$interactionQueue.length = 0;
    }
}
function $56736c0547554e17$export$8a1ba7bef607358a(sinkFn) {
    $56736c0547554e17$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $56736c0547554e17$var$activeSubmitted = false;
function $56736c0547554e17$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $5tITM.getConfig)()?.postInteractionLog?.enabled) $56736c0547554e17$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $56736c0547554e17$var$activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $56736c0547554e17$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $56736c0547554e17$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$56736c0547554e17$var$activeSubmitted) {
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds.
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $56736c0547554e17$var$ensureMetricWindows(interaction);
                    $56736c0547554e17$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $5tITM.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $5tITM.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $1Fm2L.onSearchPageInteractionComplete)(interactionId, interaction);
                    $56736c0547554e17$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$56736c0547554e17$var$activeSubmitted) {
                $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $5tITM.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $5tITM.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $1Fm2L.onSearchPageInteractionComplete)(interactionId, interaction);
                $56736c0547554e17$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $56736c0547554e17$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $56736c0547554e17$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: interaction.hold3pActive?.size ?? 0
            });
            $56736c0547554e17$var$ensureMetricWindows(interaction);
            $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
            $56736c0547554e17$export$d8f52e8f804021e8.reset();
            $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $56736c0547554e17$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $56736c0547554e17$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (interaction.hold3pActive?.size ?? 0)
        });
        $56736c0547554e17$var$finishInteraction(interactionId, interaction);
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $56736c0547554e17$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $56736c0547554e17$var$ensureMetricWindows(interaction);
            $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
            $56736c0547554e17$export$d8f52e8f804021e8.reset();
            $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $56736c0547554e17$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $56736c0547554e17$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $56736c0547554e17$var$finishInteraction(interactionId, interaction);
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $56736c0547554e17$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $56736c0547554e17$export$2b3954d2e8509985();
    const finishInteractions = (0, $5tITM.getFinishInteractionOnTransition)();
    (0, $eId1k.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $5tITM.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $56736c0547554e17$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $56736c0547554e17$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $56736c0547554e17$var$ensureMetricWindows(interaction);
            $56736c0547554e17$var$finishInteraction(interactionId, interaction, endTime);
            $56736c0547554e17$export$d8f52e8f804021e8.reset();
            $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $56736c0547554e17$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $56736c0547554e17$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $56736c0547554e17$var$finishInteraction(interactionId, interaction);
        $56736c0547554e17$export$d8f52e8f804021e8.reset();
        $56736c0547554e17$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $56736c0547554e17$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $eId1k.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $56736c0547554e17$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $56736c0547554e17$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $5tITM.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $56736c0547554e17$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $56736c0547554e17$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $fskN5.default)((0, $5tITM.getCapabilityRate)('feature_flag_access'));
    const config = (0, $5tITM.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config?.extraSearchPageInteraction?.enabled,
        searchPageRoute: config?.extraSearchPageInteraction?.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $5tITM.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $3SSwD.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $9S99b.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $56736c0547554e17$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $56736c0547554e17$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $9S99b.currentFeatureFlagsAccessed).clear();
    (0, $eId1k.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $56736c0547554e17$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $56736c0547554e17$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $5tITM.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $56736c0547554e17$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $5tITM.getConfig)()?.postInteractionLog?.enabled) $56736c0547554e17$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $56736c0547554e17$export$4a759336b50e86e3(event) {
    const interaction = $56736c0547554e17$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $56736c0547554e17$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $56736c0547554e17$export$ad216cc25852d44b(apdex) {
    (0, $eId1k.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $56736c0547554e17$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $56736c0547554e17$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $56736c0547554e17$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $56736c0547554e17$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $56736c0547554e17$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $56736c0547554e17$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($56736c0547554e17$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $56736c0547554e17$export$1c43f9ac826b6462(labelStack) {
    const key = $56736c0547554e17$var$getSegmentCacheKey(labelStack);
    const existingSegment = $56736c0547554e17$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $56736c0547554e17$var$segmentCache.set(key, segmentInfo);
        $56736c0547554e17$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $56736c0547554e17$export$d0365e48b58231c3(labelStack) {
    const key = $56736c0547554e17$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $56736c0547554e17$var$segmentCache.get(key);
    if (segmentInfo) {
        $56736c0547554e17$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $5Mr7y.stringifyLabelStackFully)(labelStack);
        $56736c0547554e17$export$a2b14406ded37d60.set(cacheKey, ($56736c0547554e17$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $56736c0547554e17$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $56736c0547554e17$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $eId1k.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($56736c0547554e17$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $56736c0547554e17$export$6ce04c7ca6810a7e = [];
const $56736c0547554e17$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $56736c0547554e17$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $56736c0547554e17$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $56736c0547554e17$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("664X1", function(module, exports) {

var $hdh3K = parcelRequire("hdh3K");

var $k9lXV = parcelRequire("k9lXV");
var $470724c0d5c1b13a$var$uuid = $k9lXV;
$470724c0d5c1b13a$var$uuid.v1 = $hdh3K;
$470724c0d5c1b13a$var$uuid.v4 = $k9lXV;
module.exports = $470724c0d5c1b13a$var$uuid;

});
parcelRegister("hdh3K", function(module, exports) {

var $fBW1Z = parcelRequire("fBW1Z");

var $gYGeb = parcelRequire("gYGeb");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $c880e239bb943b53$var$_nodeId;
var $c880e239bb943b53$var$_clockseq;
// Previous uuid creation time
var $c880e239bb943b53$var$_lastMSecs = 0;
var $c880e239bb943b53$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $c880e239bb943b53$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $c880e239bb943b53$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $c880e239bb943b53$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $fBW1Z();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $c880e239bb943b53$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $c880e239bb943b53$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $c880e239bb943b53$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $c880e239bb943b53$var$_lastMSecs + (nsecs - $c880e239bb943b53$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $c880e239bb943b53$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $c880e239bb943b53$var$_lastMSecs = msecs;
    $c880e239bb943b53$var$_lastNSecs = nsecs;
    $c880e239bb943b53$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $gYGeb(b);
}
module.exports = $c880e239bb943b53$var$v1;

});
parcelRegister("fBW1Z", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $b5d75381458a75a0$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($b5d75381458a75a0$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $b5d75381458a75a0$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $b5d75381458a75a0$var$getRandomValues($b5d75381458a75a0$var$rnds8);
        return $b5d75381458a75a0$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $b5d75381458a75a0$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $b5d75381458a75a0$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $b5d75381458a75a0$var$rnds;
    };
}

});

parcelRegister("gYGeb", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $c5c3017f8b3fb3d0$var$byteToHex = [];
for(var $c5c3017f8b3fb3d0$var$i = 0; $c5c3017f8b3fb3d0$var$i < 256; ++$c5c3017f8b3fb3d0$var$i)$c5c3017f8b3fb3d0$var$byteToHex[$c5c3017f8b3fb3d0$var$i] = ($c5c3017f8b3fb3d0$var$i + 0x100).toString(16).substr(1);
function $c5c3017f8b3fb3d0$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $c5c3017f8b3fb3d0$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $c5c3017f8b3fb3d0$var$bytesToUuid;

});


parcelRegister("k9lXV", function(module, exports) {

var $fBW1Z = parcelRequire("fBW1Z");

var $gYGeb = parcelRequire("gYGeb");
function $eab5afc97be0a499$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $fBW1Z)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $gYGeb(rnds);
}
module.exports = $eab5afc97be0a499$var$v4;

});


parcelRegister("fskN5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ecdef8b2cee0fb9$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $1ecdef8b2cee0fb9$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $1ecdef8b2cee0fb9$export$2e2bcd8739ae039 = $1ecdef8b2cee0fb9$var$coinflip;

});

parcelRegister("3D6wc", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $f34a48f6d3f8904d$export$23e69abaca7d0236);
const $f34a48f6d3f8904d$export$4c07c8a3507ce307 = 255;
const $f34a48f6d3f8904d$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $f34a48f6d3f8904d$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $f34a48f6d3f8904d$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams?.get(param)));
    } catch  {
        return false;
    }
}
function $f34a48f6d3f8904d$export$23e69abaca7d0236(name) {
    if (name.length <= $f34a48f6d3f8904d$export$4c07c8a3507ce307) return name;
    if ($f34a48f6d3f8904d$var$isGqlUrl(name)) return name;
    return name.slice(0, $f34a48f6d3f8904d$export$4c07c8a3507ce307);
}

});

parcelRegister("5Mr7y", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $788f57d1f1745bce$export$e08487ea3ae92adb);
$parcel$export(module.exports, "sanitizeLabelStackName", () => $788f57d1f1745bce$export$3535cd9da4961282);
$parcel$export(module.exports, "isSegmentLabel", () => $788f57d1f1745bce$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $788f57d1f1745bce$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $788f57d1f1745bce$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $788f57d1f1745bce$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStackWithRegistry", () => $788f57d1f1745bce$export$cb3145456a04e238);
$parcel$export(module.exports, "getOldSegmentsLabelStack", () => $788f57d1f1745bce$export$b70bcfd92c93435e);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $5tITM = parcelRequire("5tITM");
function $788f57d1f1745bce$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $788f57d1f1745bce$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}
function $788f57d1f1745bce$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $788f57d1f1745bce$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $5tITM.getConfig)();
    const segmentThreshold = config?.segmentsThreshold;
    const addSegmentsMap = new Map();
    labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $788f57d1f1745bce$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $788f57d1f1745bce$export$1adbaf5c2363e4ae(label);
            const name = $788f57d1f1745bce$export$3535cd9da4961282(label.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    return {
        r: r
    };
}
function $788f57d1f1745bce$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = $788f57d1f1745bce$export$3535cd9da4961282(l.name);
        if ($788f57d1f1745bce$export$1adbaf5c2363e4ae(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}
function $788f57d1f1745bce$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        const name = $788f57d1f1745bce$export$3535cd9da4961282(l.name);
        if ($788f57d1f1745bce$export$1adbaf5c2363e4ae(l)) return `${name}:segment`;
        return name;
    }).join('/');
}
function $788f57d1f1745bce$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$788f57d1f1745bce$export$1adbaf5c2363e4ae(l) ? l.segmentId : $788f57d1f1745bce$export$3535cd9da4961282(l.name)).join('/');
}
function $788f57d1f1745bce$export$1787b1cd413c7e2(labelStack, startWith) {
    return $788f57d1f1745bce$export$caeee352b541de1f(labelStack).startsWith($788f57d1f1745bce$export$caeee352b541de1f(startWith));
}
function $788f57d1f1745bce$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $788f57d1f1745bce$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: $788f57d1f1745bce$export$3535cd9da4961282(ls.name),
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $788f57d1f1745bce$export$cb3145456a04e238(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        const ref = $788f57d1f1745bce$var$getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return $788f57d1f1745bce$export$a0cd72da07c76b4c(labelStack, reactUFOVersion);
}
function $788f57d1f1745bce$export$b70bcfd92c93435e(segments, _interactionType) {
    const config = (0, $5tITM.getConfig)();
    const addSegmentsMap = new Map();
    const segmentThreshold = config?.segmentsThreshold;
    return segments.map(({ labelStack: labelStack, ...others })=>{
        const stringifiedLabelStack = $788f57d1f1745bce$export$88f21baa687271f4(labelStack);
        const segmentsInfo = [];
        for (const ls of labelStack){
            const isSegment = $788f57d1f1745bce$export$1adbaf5c2363e4ae(ls);
            const name = $788f57d1f1745bce$export$3535cd9da4961282(ls.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            segmentsInfo.push({
                n: name,
                ...ls.segmentId ? {
                    s: ls.segmentId
                } : {},
                ...ls.type ? {
                    t: ls.type
                } : {}
            });
        }
        return {
            ...others,
            labelStack: segmentsInfo
        };
    });
}

});

parcelRegister("68Mzh", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $870359a3a230bd07$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $870359a3a230bd07$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $870359a3a230bd07$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $870359a3a230bd07$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $870359a3a230bd07$export$6e17cce6446848f9);

var $keFM9 = parcelRequire("keFM9");
var $dCCNu = parcelRequire("dCCNu");

var $2aEiL = parcelRequire("2aEiL");

var $96k96 = parcelRequire("96k96");

var $kejxJ = parcelRequire("kejxJ");
const $870359a3a230bd07$var$state = {
    context: null
};
const $870359a3a230bd07$var$traceIdKey = (0, $dCCNu.createContextKey)('traceId');
const $870359a3a230bd07$var$spanIdKey = (0, $dCCNu.createContextKey)('spanId');
const $870359a3a230bd07$var$experienceTypeKey = (0, $dCCNu.createContextKey)('type');
function $870359a3a230bd07$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $870359a3a230bd07$export$f2e521e495a88544(interactionId, experienceType) {
    $870359a3a230bd07$export$a1002be327997103(interactionId.replace(/-/g, ''), $870359a3a230bd07$export$295213bc4d0c54ad(), experienceType);
}
function $870359a3a230bd07$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $2aEiL.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $dCCNu.ROOT_CONTEXT).setValue($870359a3a230bd07$var$traceIdKey, traceId).setValue($870359a3a230bd07$var$spanIdKey, spanId).setValue($870359a3a230bd07$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $96k96.getContextManager)() instanceof (0, $96k96.UFOContextManager)) {
            let contextManager = (0, $96k96.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $870359a3a230bd07$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $870359a3a230bd07$export$b6ac780db3a3cc77() {
    if ((0, $2aEiL.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $keFM9.context).active().getValue($870359a3a230bd07$var$traceIdKey)),
            spanId: String((0, $keFM9.context).active().getValue($870359a3a230bd07$var$spanIdKey)),
            type: String((0, $keFM9.context).active().getValue($870359a3a230bd07$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return $870359a3a230bd07$var$state.context || undefined;
}
function $870359a3a230bd07$export$17ab21d7be720b() {
    if ((0, $2aEiL.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $96k96.getContextManager)() instanceof (0, $96k96.UFOContextManager)) {
            let contextManager = (0, $96k96.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $dCCNu.ROOT_CONTEXT));
        }
    } else $870359a3a230bd07$var$state.context = null;
}
function $870359a3a230bd07$export$6e17cce6446848f9(_url) {
    if ($870359a3a230bd07$export$b6ac780db3a3cc77() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = $870359a3a230bd07$export$b6ac780db3a3cc77();
    return (0, $kejxJ.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $870359a3a230bd07$export$a1e7396778592551(_url) {
    const traceHeaders = $870359a3a230bd07$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("kejxJ", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $d0d2babc9fb3efb5$export$1115c5277eb10d5e);
function $d0d2babc9fb3efb5$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("9S99b", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $9a0c0ac80b8f0e6c$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $9a0c0ac80b8f0e6c$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $9a0c0ac80b8f0e6c$export$47fade9662f71000);

var $doNbI = parcelRequire("doNbI");
const $9a0c0ac80b8f0e6c$export$5b78c989c8db2561 = new Map();
const $9a0c0ac80b8f0e6c$export$2a5c8df26bb89760 = new Map();
function $9a0c0ac80b8f0e6c$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $doNbI.redactValue)(featureFlagValue);
    $9a0c0ac80b8f0e6c$export$5b78c989c8db2561.set(featureFlagName, value);
    $9a0c0ac80b8f0e6c$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("doNbI", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $3ab07ae644b72355$export$fcc03ee4c944962f);

var $eP67m = parcelRequire("eP67m");
function $3ab07ae644b72355$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $3ab07ae644b72355$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $3ab07ae644b72355$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $3ab07ae644b72355$export$7b4abba432e57989(value) {
    return $3ab07ae644b72355$var$isString(value) && $3ab07ae644b72355$var$startsAsObject(value) || $3ab07ae644b72355$var$isObject(value);
}
function $3ab07ae644b72355$export$fcc03ee4c944962f(featureFlagValue) {
    return $3ab07ae644b72355$export$7b4abba432e57989(featureFlagValue) ? (0, $eP67m.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("eP67m", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $7eb96e12a818aa98$export$42f4885608027d0c);
const $7eb96e12a818aa98$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("31aDV", function(module, exports) {
$parcel$export(module.exports, "DefaultInteractionID", () => $5ef862ab02d90d26$export$3109542b68df9ba1);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $5ef862ab02d90d26$export$3e0c3023952f6774);
$parcel$export(module.exports, "default", () => $5ef862ab02d90d26$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $5ef862ab02d90d26$export$37bca3107733ac1e);

var $1v5pe = parcelRequire("1v5pe");
const $5ef862ab02d90d26$var$listeners = new Set();
// Observable interaction ID implementation
class $5ef862ab02d90d26$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $5ef862ab02d90d26$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $5ef862ab02d90d26$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $5ef862ab02d90d26$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $5ef862ab02d90d26$export$3109542b68df9ba1 = $5ef862ab02d90d26$var$initializeGlobalDefaultInteractionID();
const $5ef862ab02d90d26$export$3e0c3023952f6774 = (listener)=>{
    $5ef862ab02d90d26$var$listeners.add(listener);
    return ()=>{
        $5ef862ab02d90d26$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $5ef862ab02d90d26$var$interactionContext = (0, $1v5pe.createContext)($5ef862ab02d90d26$export$3109542b68df9ba1);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5ef862ab02d90d26$export$2e2bcd8739ae039 = $5ef862ab02d90d26$var$interactionContext;
const $5ef862ab02d90d26$export$37bca3107733ac1e = ()=>$5ef862ab02d90d26$export$3109542b68df9ba1;
const $5ef862ab02d90d26$export$9f6000531b78127e = ()=>$5ef862ab02d90d26$export$3109542b68df9ba1;

});

parcelRegister("kPSgw", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $2318f69729a1087a$export$c3b002e13fbb9ef2);
const $2318f69729a1087a$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("cNKkA", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $239d1aeca7e322be$export$c8760e11c713fafc);
$parcel$export(module.exports, "default", () => $239d1aeca7e322be$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $5tITM = parcelRequire("5tITM");

var $5Mr7y = parcelRequire("5Mr7y");

var $8OjRF = parcelRequire("8OjRF");

var $k1Wvt = parcelRequire("k1Wvt");
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $239d1aeca7e322be$var$startTimes = new Map();
const $239d1aeca7e322be$var$spanStates = new Map();
const $239d1aeca7e322be$export$cf4e4023c0a34c8d = ()=>{
    $239d1aeca7e322be$var$startTimes.clear();
    $239d1aeca7e322be$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $239d1aeca7e322be$var$lastActiveInteraction;
function $239d1aeca7e322be$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $8OjRF.getActiveInteraction)()?.id;
    if (!!$239d1aeca7e322be$var$lastActiveInteraction && $239d1aeca7e322be$var$lastActiveInteraction !== activeInteractionId) $239d1aeca7e322be$export$cf4e4023c0a34c8d();
    $239d1aeca7e322be$var$lastActiveInteraction = activeInteractionId;
}
const $239d1aeca7e322be$var$getIsNativeTracingEnabled = ()=>(0, $5tITM.getConfig)()?.ssr?.enableNativeTracing ?? false;
const $239d1aeca7e322be$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    if (!$239d1aeca7e322be$var$startTimes.has(id)) $239d1aeca7e322be$var$startTimes.set(id, []);
    $239d1aeca7e322be$var$startTimes.get(id)?.push(performance.now());
    if (!$239d1aeca7e322be$var$getIsNativeTracingEnabled()) return null;
    const startSpan = globalThis.__vm_internals__?.telemetry?.startSpan;
    let spanState = $239d1aeca7e322be$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext?.spanId
        });
        spanState = {
            span: span
        };
        $239d1aeca7e322be$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $239d1aeca7e322be$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $k1Wvt !== 'undefined' && Boolean($k1Wvt?.env?.REACT_SSR || false);
const $239d1aeca7e322be$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender?.();
    return null;
};
const $239d1aeca7e322be$var$ParentSpanContext = /*#__PURE__*/ (0, $1v5pe.createContext)(null);
const $239d1aeca7e322be$export$c8760e11c713fafc = ()=>{
    $239d1aeca7e322be$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $239d1aeca7e322be$var$spanStates.clear();
};
const $239d1aeca7e322be$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $1v5pe.useMemo)(()=>labelStack.map((l)=>(0, $5Mr7y.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $239d1aeca7e322be$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $1v5pe.useContext)($239d1aeca7e322be$var$ParentSpanContext);
    const currentSpanState = $239d1aeca7e322be$var$onStartRender(reactProfilerId, (0, $5Mr7y.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($239d1aeca7e322be$var$ParentSpanContext.Provider, {
        value: currentSpanState?.span.getSpanContext() ?? null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($239d1aeca7e322be$var$ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = $239d1aeca7e322be$var$startTimes.get(reactProfilerId);
            if (startTimesForId?.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = $239d1aeca7e322be$var$spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
const $239d1aeca7e322be$var$SsrRenderProfiler = (props)=>{
    if ($239d1aeca7e322be$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($239d1aeca7e322be$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($239d1aeca7e322be$var$ProfilerMarker, null), props.children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$239d1aeca7e322be$export$2e2bcd8739ae039 = $239d1aeca7e322be$var$SsrRenderProfiler;

});

parcelRegister("3SSwD", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $014dc2ea4d04a3f6$export$4a1fe1ab3c13bbf5);
$parcel$export(module.exports, "newVCObserver", () => $014dc2ea4d04a3f6$export$c69731bddfc24d85);

var $5tITM = parcelRequire("5tITM");

var $8auTb = parcelRequire("8auTb");

var $gY5Ep = parcelRequire("gY5Ep");

var $7BMVq = parcelRequire("7BMVq");

var $2x5fo = parcelRequire("2x5fo");

var $eJ691 = parcelRequire("eJ691");

var $k1Wvt = parcelRequire("k1Wvt");
class $014dc2ea4d04a3f6$export$4a1fe1ab3c13bbf5 {
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $eJ691.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $7BMVq.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $5tITM.isVCRevisionEnabled)('fy25.01') || (0, $5tITM.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $gY5Ep.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
        (0, $2x5fo.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        });
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result?.[0]?.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}
// Some products set this variable to indicate it is running in SSR
let $014dc2ea4d04a3f6$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $014dc2ea4d04a3f6$var$isReactSSR = typeof $k1Wvt !== 'undefined' && Boolean($k1Wvt?.env?.REACT_SSR || false);
function $014dc2ea4d04a3f6$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($014dc2ea4d04a3f6$var$isReactSSR || $014dc2ea4d04a3f6$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $014dc2ea4d04a3f6$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$014dc2ea4d04a3f6$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $8auTb.VCObserverNOOP)() : new $014dc2ea4d04a3f6$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $014dc2ea4d04a3f6$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$014dc2ea4d04a3f6$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $8auTb.VCObserverNOOP)() : new $014dc2ea4d04a3f6$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}

});
parcelRegister("8auTb", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $1fe11c102b379866$export$24d07287b49da906);
class $1fe11c102b379866$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("gY5Ep", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $06d9d1ee13c23a47$export$1f70d263701b1d01);

var $2aEiL = parcelRequire("2aEiL");

var $5tITM = parcelRequire("5tITM");

var $8OjRF = parcelRequire("8OjRF");

var $fOozI = parcelRequire("fOozI");

var $dQn6k = parcelRequire("dQn6k");

var $57H8M = parcelRequire("57H8M");

var $j8Y21 = parcelRequire("j8Y21");

var $eCDPR = parcelRequire("eCDPR");
const $06d9d1ee13c23a47$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $06d9d1ee13c23a47$var$UNUSED_SECTOR = 0;
function $06d9d1ee13c23a47$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $06d9d1ee13c23a47$export$1f70d263701b1d01 {
    static{
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $06d9d1ee13c23a47$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $06d9d1ee13c23a47$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $06d9d1ee13c23a47$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $dQn6k.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $dQn6k.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $57H8M.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $06d9d1ee13c23a47$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $06d9d1ee13c23a47$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $5tITM.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $8OjRF.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $5tITM.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($06d9d1ee13c23a47$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $2aEiL.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $8OjRF.getActiveInteraction)();
                        if (interaction?.type === 'press') break;
                    }
                    this.setAbortReason($06d9d1ee13c23a47$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($06d9d1ee13c23a47$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $fOozI.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $eCDPR.Observers)({
            selectorConfig: (0, $5tITM.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $5tITM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $06d9d1ee13c23a47$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $06d9d1ee13c23a47$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $06d9d1ee13c23a47$var$UNUSED_SECTOR && ssrTime !== $06d9d1ee13c23a47$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $06d9d1ee13c23a47$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $06d9d1ee13c23a47$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $06d9d1ee13c23a47$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $06d9d1ee13c23a47$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $06d9d1ee13c23a47$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $06d9d1ee13c23a47$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $5tITM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($06d9d1ee13c23a47$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $j8Y21.getViewportWidth)();
        this.viewport.h = (0, $j8Y21.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($06d9d1ee13c23a47$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($06d9d1ee13c23a47$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $06d9d1ee13c23a47$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("fOozI", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $5d5ed60250dc350f$export$9010aa71841a6887);

var $dmmsG = parcelRequire("dmmsG");

var $78F7G = parcelRequire("78F7G");

var $j8Y21 = parcelRequire("j8Y21");
function $5d5ed60250dc350f$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $dmmsG.bind)(window, {
        type: (0, $78F7G.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $78F7G.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $dmmsG.bind)(window, {
        type: (0, $78F7G.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $78F7G.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $dmmsG.bind)(window, {
        type: (0, $78F7G.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $j8Y21.getViewportWidth)() !== initialViewPort.w || (0, $j8Y21.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $78F7G.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("78F7G", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $61f1c9f223568925$export$199edc0307b5587f);
const $61f1c9f223568925$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("j8Y21", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $7d1377b30ef4e169$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $7d1377b30ef4e169$export$4f01c15d21ef9cc6);
function $7d1377b30ef4e169$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $7d1377b30ef4e169$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("dQn6k", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $212cf4c76a48b0e3$export$72e6dda9d5859230);
function $212cf4c76a48b0e3$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("57H8M", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $8666fec6ea05cfd2$export$5c86a34c9becd6d0);

var $5tITM = parcelRequire("5tITM");

var $cGjFC = parcelRequire("cGjFC");
const $8666fec6ea05cfd2$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $8666fec6ea05cfd2$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $8666fec6ea05cfd2$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $8666fec6ea05cfd2$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $8666fec6ea05cfd2$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $8666fec6ea05cfd2$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $cGjFC.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $5tITM.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $8666fec6ea05cfd2$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $5tITM.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $8666fec6ea05cfd2$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});

parcelRegister("eCDPR", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $5ac7787b4f4afa79$export$b65d046240060e78);

var $5tITM = parcelRequire("5tITM");

var $69x7c = parcelRequire("69x7c");

var $dCLz7 = parcelRequire("dCLz7");

var $2x5fo = parcelRequire("2x5fo");

var $eJ691 = parcelRequire("eJ691");
const $5ac7787b4f4afa79$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $5ac7787b4f4afa79$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $5ac7787b4f4afa79$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $5ac7787b4f4afa79$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $5tITM.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $eJ691.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $5ac7787b4f4afa79$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $5ac7787b4f4afa79$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $5ac7787b4f4afa79$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $5ac7787b4f4afa79$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $5ac7787b4f4afa79$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $5ac7787b4f4afa79$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $69x7c.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $dCLz7.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $69x7c.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$5ac7787b4f4afa79$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("69x7c", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $c907462cd7c245e5$export$f61fbc3b9c4a9019);

var $1R1hC = parcelRequire("1R1hC");
function $c907462cd7c245e5$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $1R1hC.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("1R1hC", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $6cc14ae230f77969$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $6cc14ae230f77969$export$7028e9efe569888c);

var $1v5pe = parcelRequire("1v5pe");
const $6cc14ae230f77969$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $6cc14ae230f77969$export$7028e9efe569888c = {
    [$6cc14ae230f77969$export$7674290405cc25b0]: true
};
function $6cc14ae230f77969$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", $6cc14ae230f77969$export$7028e9efe569888c, children);
}

});


parcelRegister("dCLz7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6aba97a6d8cb36ab$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $6aba97a6d8cb36ab$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $6aba97a6d8cb36ab$export$2e2bcd8739ae039 = $6aba97a6d8cb36ab$var$isNonVisualStyleMutation;

});

parcelRegister("2x5fo", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $f64ee0e5879f0e30$export$166779fc0f49d4df);
const $f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $f64ee0e5879f0e30$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY] = new $f64ee0e5879f0e30$export$166779fc0f49d4df();
            return globalThis[$f64ee0e5879f0e30$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $f64ee0e5879f0e30$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("eJ691", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $487c921a16ccd5c9$export$c0102f1a1198d10f);
const $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $487c921a16ccd5c9$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $487c921a16ccd5c9$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $487c921a16ccd5c9$var$PAGE_LAYOUT_ID) return $487c921a16ccd5c9$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $487c921a16ccd5c9$var$PAGE_LAYOUT_ID) return $487c921a16ccd5c9$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch  {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $487c921a16ccd5c9$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});



parcelRegister("7BMVq", function(module, exports) {
$parcel$export(module.exports, "getHasAbortingEventDuringSSR", () => $38e539c84ba4d052$export$88af4849fcc5bbc9);
$parcel$export(module.exports, "default", () => $38e539c84ba4d052$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $5tITM = parcelRequire("5tITM");

var $5Mr7y = parcelRequire("5Mr7y");

var $8OjRF = parcelRequire("8OjRF");

var $eJ691 = parcelRequire("eJ691");

var $1te8m = parcelRequire("1te8m");

var $5bpMv = parcelRequire("5bpMv");

var $lYAaG = parcelRequire("lYAaG");

var $1b6ay = parcelRequire("1b6ay");

var $5Zpwf = parcelRequire("5Zpwf");

var $eMj7K = parcelRequire("eMj7K");

var $142PG = parcelRequire("142PG");

var $iEFO6 = parcelRequire("iEFO6");

var $kOjDj = parcelRequire("kOjDj");

var $i9M5e = parcelRequire("i9M5e");
const $38e539c84ba4d052$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $38e539c84ba4d052$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
function $38e539c84ba4d052$export$88af4849fcc5bbc9() {
    return false;
}
class $38e539c84ba4d052$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $38e539c84ba4d052$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $1te8m.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $5tITM.getSelectorConfig)(config.selectorConfig, $38e539c84ba4d052$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $38e539c84ba4d052$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $eJ691.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $kOjDj.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue,
                    originalMutationTimestamp: mutationData?.timestamp
                };
                if (element) {
                    const labelStacks = $38e539c84ba4d052$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $i9M5e.default)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $2aEiL.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $8OjRF.getActiveInteraction)();
                    if (interaction?.type === 'press') return;
                }
                const abortEventTargetElement = $38e539c84ba4d052$var$isAbortEventTargetSupported(type) && event ? $38e539c84ba4d052$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $38e539c84ba4d052$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        this.entriesTimeline.clear();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $38e539c84ba4d052$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $5Zpwf.default)(),
                    width: (0, $eMj7K.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $5Zpwf.default)(),
                    right: (0, $eMj7K.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $lYAaG.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $5tITM.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $1b6ay.default)();
        const calculator_next = new (0, $142PG.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $5tITM.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $5tITM.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, $iEFO6.default)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime ?? stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible: isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $5bpMv.default)(this.selectorConfig, element);
    }
}
function $38e539c84ba4d052$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $38e539c84ba4d052$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $5Mr7y.sanitizeLabelStackName)(label.name)).join('/');
}
function $38e539c84ba4d052$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $5Mr7y.sanitizeLabelStackName)(label.name)).join('/');
}
function $38e539c84ba4d052$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $38e539c84ba4d052$var$labelStackFromFiber(currentFiber);
                labelStackString = $38e539c84ba4d052$var$labelStackToString(labelStack) || 'unknown';
                segment = $38e539c84ba4d052$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $38e539c84ba4d052$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $38e539c84ba4d052$var$traverseFiber(fiber) : null;
}
const $38e539c84ba4d052$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $38e539c84ba4d052$var$isAbortEventTargetSupported(type) {
    return $38e539c84ba4d052$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $38e539c84ba4d052$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("1te8m", function(module, exports) {
$parcel$export(module.exports, "default", () => $de8bf3fd8d1a5bf4$export$2e2bcd8739ae039);
class $de8bf3fd8d1a5bf4$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("5bpMv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e79b3709d59899f$export$2e2bcd8739ae039);
const $9e79b3709d59899f$var$nameCache = new WeakMap();
function $9e79b3709d59899f$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $9e79b3709d59899f$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $9e79b3709d59899f$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $9e79b3709d59899f$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $9e79b3709d59899f$var$nameCache.set(element, name);
    return name;
}
var $9e79b3709d59899f$export$2e2bcd8739ae039 = $9e79b3709d59899f$var$getElementName;

});

parcelRegister("lYAaG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6224feb15204bf76$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $hMXHM = parcelRequire("hMXHM");

var $Rgl3r = parcelRequire("Rgl3r");

var $3AS1h = parcelRequire("3AS1h");

var $42aJX = parcelRequire("42aJX");

var $jAsDj = parcelRequire("jAsDj");
const $6224feb15204bf76$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $6224feb15204bf76$var$REVISION_NO = 'fy25.03';
const $6224feb15204bf76$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $6224feb15204bf76$export$2e2bcd8739ae039 extends (0, $3AS1h.default) {
    constructor(revisionNo){
        super(revisionNo ?? $6224feb15204bf76$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$6224feb15204bf76$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $2aEiL.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $hMXHM.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $hMXHM.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $Rgl3r.containsDnDMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $42aJX.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $42aJX.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $42aJX.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $2aEiL.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $42aJX.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $2aEiL.fg)('platform_ufo_exclude_dark_reader_extension') || (0, $42aJX.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $2aEiL.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $jAsDj.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($6224feb15204bf76$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("hMXHM", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $98e60058c9a3b960$export$9db1624a8af791a4);

var $4d1Vr = parcelRequire("4d1Vr");

var $9S99b = parcelRequire("9S99b");
const $98e60058c9a3b960$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $4d1Vr.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $4d1Vr.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $9S99b.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("Rgl3r", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", () => $651c8d579bb27656$export$7867ddcf372cd2bf);
$parcel$export(module.exports, "default", () => $651c8d579bb27656$export$2e2bcd8739ae039);
const $651c8d579bb27656$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $651c8d579bb27656$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $651c8d579bb27656$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $651c8d579bb27656$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $651c8d579bb27656$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $651c8d579bb27656$var$parseStyleSet(oldValue);
    const newStyles = $651c8d579bb27656$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!$651c8d579bb27656$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!$651c8d579bb27656$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $651c8d579bb27656$export$2e2bcd8739ae039 = $651c8d579bb27656$export$e20e7bf2c822f3df;

});

parcelRegister("3AS1h", function(module, exports) {
$parcel$export(module.exports, "default", () => $79980d3adfe56d7b$export$2e2bcd8739ae039);

var $c2PID = parcelRequire("c2PID");

var $kiSKw = parcelRequire("kiSKw");

var $5Zpwf = parcelRequire("5Zpwf");

var $eMj7K = parcelRequire("eMj7K");

var $jAsDj = parcelRequire("jAsDj");
// Helper function for reporting ratios
function $79980d3adfe56d7b$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $79980d3adfe56d7b$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $eMj7K.default)();
        const viewportHeight = (0, $5Zpwf.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $79980d3adfe56d7b$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $jAsDj.default)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $c2PID.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $eMj7K.default)(),
                height: (0, $5Zpwf.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $kiSKw.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameWay ?? false,
                    dist: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameAmount ?? false
                },
                total_mut: layoutShiftOffendersResult?.layoutShiftOffenders.length ?? 0,
                mut: layoutShiftOffendersResult?.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("c2PID", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $e145ff91963f0f10$export$96ea73435089b05a);

var $2aEiL = parcelRequire("2aEiL");

var $g9ryB = parcelRequire("g9ryB");
async function $e145ff91963f0f10$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $g9ryB.ViewportCanvas)(viewport, (0, $2aEiL.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $e145ff91963f0f10$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $e145ff91963f0f10$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $g9ryB.ViewportCanvas)(viewport, (0, $2aEiL.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $e145ff91963f0f10$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $e145ff91963f0f10$export$2e2bcd8739ae039 = $e145ff91963f0f10$var$calculateTTVCPercentiles;
function $e145ff91963f0f10$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $e145ff91963f0f10$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});
parcelRegister("g9ryB", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $0f67717a4f36433b$export$3e59ac9de7402fb1);

var $fGlUY = parcelRequire("fGlUY");
class $0f67717a4f36433b$export$3e59ac9de7402fb1 {
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $0f67717a4f36433b$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $0f67717a4f36433b$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $0f67717a4f36433b$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $0f67717a4f36433b$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $0f67717a4f36433b$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $fGlUY.default)();
    }
    return arr;
}

});
parcelRegister("fGlUY", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd169abf8d6db57d$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $dd169abf8d6db57d$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $dd169abf8d6db57d$export$2e2bcd8739ae039 = $dd169abf8d6db57d$var$taskYield;

});



parcelRegister("kiSKw", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $84db84fe1421f4bc$export$93ce39b765ea2cd3);
const $84db84fe1421f4bc$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $84db84fe1421f4bc$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $84db84fe1421f4bc$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $84db84fe1421f4bc$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $84db84fe1421f4bc$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $84db84fe1421f4bc$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $84db84fe1421f4bc$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $84db84fe1421f4bc$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $84db84fe1421f4bc$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("5Zpwf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0e320622c832a63$export$2e2bcd8739ae039);
function $f0e320622c832a63$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $f0e320622c832a63$export$2e2bcd8739ae039 = $f0e320622c832a63$var$getViewportHeight;

});

parcelRegister("eMj7K", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f429ad1b84541e9$export$2e2bcd8739ae039);
function $6f429ad1b84541e9$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $6f429ad1b84541e9$export$2e2bcd8739ae039 = $6f429ad1b84541e9$var$getViewportWidth;

});

parcelRegister("jAsDj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3d2dd7ea7d29ef8$export$2e2bcd8739ae039);
function $c3d2dd7ea7d29ef8$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $c3d2dd7ea7d29ef8$export$2e2bcd8739ae039 = $c3d2dd7ea7d29ef8$var$isViewportEntryData;

});


parcelRegister("42aJX", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $24c5458bf663b76d$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $24c5458bf663b76d$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $24c5458bf663b76d$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $24c5458bf663b76d$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $24c5458bf663b76d$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $24c5458bf663b76d$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $24c5458bf663b76d$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $24c5458bf663b76d$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $24c5458bf663b76d$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $24c5458bf663b76d$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("1b6ay", function(module, exports) {
$parcel$export(module.exports, "default", () => $a520f259ecab00d1$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $lYAaG = parcelRequire("lYAaG");

var $42aJX = parcelRequire("42aJX");
const $a520f259ecab00d1$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $a520f259ecab00d1$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $a520f259ecab00d1$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $a520f259ecab00d1$export$2e2bcd8739ae039 extends (0, $lYAaG.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$a520f259ecab00d1$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $a520f259ecab00d1$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $2aEiL.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $42aJX.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $2aEiL.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, $42aJX.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : [],
            ...(0, $2aEiL.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $42aJX.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $42aJX.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $42aJX.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $a520f259ecab00d1$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("142PG", function(module, exports) {
$parcel$export(module.exports, "default", () => $68a6ac0f4f91fa61$export$2e2bcd8739ae039);

var $1b6ay = parcelRequire("1b6ay");
const $68a6ac0f4f91fa61$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $68a6ac0f4f91fa61$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $68a6ac0f4f91fa61$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $68a6ac0f4f91fa61$export$2e2bcd8739ae039 extends (0, $1b6ay.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$68a6ac0f4f91fa61$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $68a6ac0f4f91fa61$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($68a6ac0f4f91fa61$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("iEFO6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e056b37ef80a686a$export$2e2bcd8739ae039);

var $5tITM = parcelRequire("5tITM");

var $cGjFC = parcelRequire("cGjFC");

var $5Zpwf = parcelRequire("5Zpwf");

var $eMj7K = parcelRequire("eMj7K");
const $e056b37ef80a686a$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $e056b37ef80a686a$var$MAX_OBSERVATIONS = 200;
const $e056b37ef80a686a$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $e056b37ef80a686a$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $e056b37ef80a686a$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $e056b37ef80a686a$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($e056b37ef80a686a$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $cGjFC.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $eMj7K.default)(),
                h: (0, $5Zpwf.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $e056b37ef80a686a$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $e056b37ef80a686a$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $e056b37ef80a686a$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$e056b37ef80a686a$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $e056b37ef80a686a$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $e056b37ef80a686a$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$e056b37ef80a686a$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$e056b37ef80a686a$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $5tITM.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $eMj7K.default)(),
                h: (0, $5Zpwf.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("kOjDj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6f28342b3e39361$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $69x7c = parcelRequire("69x7c");

var $Rgl3r = parcelRequire("Rgl3r");

var $dCLz7 = parcelRequire("dCLz7");

var $cSmmC = parcelRequire("cSmmC");

var $2x5fo = parcelRequire("2x5fo");

var $F8nLl = parcelRequire("F8nLl");

var $adYmJ = parcelRequire("adYmJ");

var $iKi2c = parcelRequire("iKi2c");

var $6YZlL = parcelRequire("6YZlL");

var $g2glP = parcelRequire("g2glP");

var $4JcrE = parcelRequire("4JcrE");

var $apDf4 = parcelRequire("apDf4");

var $j61J2 = parcelRequire("j61J2");

var $8eh0L = parcelRequire("8eh0L");

var $iEqvs = parcelRequire("iEqvs");
const $b6f28342b3e39361$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $apDf4.default)(target)) return 'mutation:remount';
        if ((0, $69x7c.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $apDf4.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $8eh0L.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $b6f28342b3e39361$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $apDf4.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $69x7c.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $apDf4.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $8eh0L.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $b6f28342b3e39361$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $4JcrE.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $6YZlL.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $6YZlL.default)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $g2glP.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
                this.intersectionObserver?.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $b6f28342b3e39361$var$createElementMutationsWatcherNew : $b6f28342b3e39361$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $69x7c.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $6YZlL.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $6YZlL.default)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $g2glP.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $Rgl3r.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $dCLz7.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $cSmmC.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $2aEiL.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $j61J2.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $2x5fo.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $iEqvs.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $8eh0L.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            return this.searchPageConfig?.enableSmartAnswersMutations && this.searchPageConfig?.searchPageRoute && window?.location?.pathname && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $F8nLl.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $adYmJ.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $iKi2c.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $6YZlL.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("cSmmC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7138168166501b1b$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $7138168166501b1b$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $7138168166501b1b$export$846396c2d8be3710 = 'data-drop-target-for-';
function $7138168166501b1b$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($7138168166501b1b$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($7138168166501b1b$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("F8nLl", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $71bc833a27d1da0f$export$c3799d33e0ae80a5);

var $edFac = parcelRequire("edFac");
function $71bc833a27d1da0f$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $71bc833a27d1da0f$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $edFac.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$71bc833a27d1da0f$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("edFac", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $36ac99a49f3dd600$export$80d6b07c2266a1c6);
function $36ac99a49f3dd600$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("adYmJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1adba065fc8a517$export$2e2bcd8739ae039);

var $hMXHM = parcelRequire("hMXHM");
function $c1adba065fc8a517$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $hMXHM.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $c1adba065fc8a517$export$2e2bcd8739ae039 = $c1adba065fc8a517$var$createMutationObserver;

});

parcelRegister("iKi2c", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba27037996347b4d$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $ba27037996347b4d$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $ba27037996347b4d$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $ba27037996347b4d$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $ba27037996347b4d$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ba27037996347b4d$export$2e2bcd8739ae039 = $ba27037996347b4d$var$createPerformanceObserver;

});

parcelRegister("6YZlL", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $dcb3e1ebeea3a187$export$6a35c3789c327630);
$parcel$export(module.exports, "default", () => $dcb3e1ebeea3a187$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $fskN5 = parcelRequire("fskN5");

var $kFPqX = parcelRequire("kFPqX");

var $cQuS0 = parcelRequire("cQuS0");
const $dcb3e1ebeea3a187$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $dcb3e1ebeea3a187$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $dcb3e1ebeea3a187$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $dcb3e1ebeea3a187$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
// Cache cleanup
let $dcb3e1ebeea3a187$var$callCount = 0;
const $dcb3e1ebeea3a187$var$CLEANUP_THRESHOLD = 50;
function $dcb3e1ebeea3a187$var$maybeCleanup(resultCache) {
    $dcb3e1ebeea3a187$var$callCount++;
    if ($dcb3e1ebeea3a187$var$callCount >= $dcb3e1ebeea3a187$var$CLEANUP_THRESHOLD && (0, $fskN5.default)(0.3)) $dcb3e1ebeea3a187$export$6a35c3789c327630(resultCache);
}
function $dcb3e1ebeea3a187$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $dcb3e1ebeea3a187$var$callCount = 0;
    return resultCache;
}
function $dcb3e1ebeea3a187$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $dcb3e1ebeea3a187$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $2aEiL.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $dcb3e1ebeea3a187$var$NEW_DOM_WALK_MAX_LEVEL : $dcb3e1ebeea3a187$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $dcb3e1ebeea3a187$var$NEW_FIBER_WALK_MAX_LEVEL : $dcb3e1ebeea3a187$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $cQuS0.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $kFPqX.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("kFPqX", function(module, exports) {
$parcel$export(module.exports, "default", () => $78f74fb28de135b2$export$2e2bcd8739ae039);

var $kr13D = parcelRequire("kr13D");
function $78f74fb28de135b2$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $kr13D.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $78f74fb28de135b2$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("kr13D", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc35b3e7e68f26ef$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $bc35b3e7e68f26ef$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("cQuS0", function(module, exports) {
$parcel$export(module.exports, "default", () => $99730203ecb883ae$export$2e2bcd8739ae039);

var $d65Dm = parcelRequire("d65Dm");
function $99730203ecb883ae$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache?.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $d65Dm.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("d65Dm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fe88ae73d6119f3$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $5fe88ae73d6119f3$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("g2glP", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $ee64bddaa4fee9ab$export$16c2770458939f21);

var $brxde = parcelRequire("brxde");
function $ee64bddaa4fee9ab$export$16c2770458939f21(node) {
    const doc = (0, $brxde.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("brxde", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $6cf9a570e39d3c5c$export$f65ca476c09acec0);
const $6cf9a570e39d3c5c$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("4JcrE", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $86c651a56861c2b1$export$e989c0fffaa6b27a);
function $86c651a56861c2b1$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("apDf4", function(module, exports) {
$parcel$export(module.exports, "default", () => $014cec57022e0c56$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $014cec57022e0c56$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $014cec57022e0c56$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("j61J2", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $7d8352cb8bd61eaa$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $7d8352cb8bd61eaa$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("8eh0L", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $faa7bc555fe6bfc2$export$fde63bc968551821);
const $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $faa7bc555fe6bfc2$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $faa7bc555fe6bfc2$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("iEqvs", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $a4c55366a5e5d8ca$export$597b41700f7dcd36);
const $a4c55366a5e5d8ca$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $a4c55366a5e5d8ca$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $a4c55366a5e5d8ca$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $a4c55366a5e5d8ca$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("i9M5e", function(module, exports) {
$parcel$export(module.exports, "default", () => $c578a5e448f0e26a$export$2e2bcd8739ae039);

var $dmmsG = parcelRequire("dmmsG");
class $c578a5e448f0e26a$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $dmmsG.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $dmmsG.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("eId1k", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $6a2bccdfbb7b3d04$export$cc97b17ef9aeb088);
const $6a2bccdfbb7b3d04$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("i0C6O", function(module, exports) {
$parcel$export(module.exports, "default", () => $c29a54cb80154253$export$2e2bcd8739ae039);

var $5tITM = parcelRequire("5tITM");

var $cGjFC = parcelRequire("cGjFC");

var $3SSwD = parcelRequire("3SSwD");
const $c29a54cb80154253$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $c29a54cb80154253$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $3SSwD.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $cGjFC.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $5tITM.getConfig)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = (0, $5tITM.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $c29a54cb80154253$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
   * Basic info about interaction that has just finished
   */ this.lastInteractionFinish = null;
        /**
   * Array of observed react render timings
   */ this.reactProfilerTimings = [];
        /**
   * Store the scheduled sink timeout Id so that it can be cancelled when needed
   */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
   * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
   */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
   * Handler function to process / send the observation data
   */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("kCpqu", function(module, exports) {
$parcel$export(module.exports, "getPerformanceObserver", () => $4f8c7b50673b5ddd$export$17afbba0f16b4b19);

var $5tITM = parcelRequire("5tITM");

var $8OjRF = parcelRequire("8OjRF");

var $5anXw = parcelRequire("5anXw");
let $4f8c7b50673b5ddd$var$performanceEventObserver;
const $4f8c7b50673b5ddd$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
/**
 * Resolve the SelectorConfig for the performance-observer code path.
 *
 * In FedRAMP Moderate environments (when `getSelectorConfig()` returns the
 * forced all-`false` config) we honour that override; otherwise we fall back
 * to the historical default that enables every selector.
 */ function $4f8c7b50673b5ddd$var$resolveSelectorConfig() {
    return (0, $5tITM.getSelectorConfig)() ?? $4f8c7b50673b5ddd$var$DEFAULT_SELECTOR_CONFIG;
}
function $4f8c7b50673b5ddd$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $4f8c7b50673b5ddd$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $4f8c7b50673b5ddd$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($4f8c7b50673b5ddd$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $4f8c7b50673b5ddd$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $4f8c7b50673b5ddd$export$17afbba0f16b4b19 = ()=>{
    $4f8c7b50673b5ddd$var$performanceEventObserver = $4f8c7b50673b5ddd$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $4f8c7b50673b5ddd$export$e6be05b411ce21a6(entry);
    });
    return $4f8c7b50673b5ddd$var$performanceEventObserver;
};
const $4f8c7b50673b5ddd$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $8OjRF.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $4f8c7b50673b5ddd$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $5anXw.default)($4f8c7b50673b5ddd$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};

});
parcelRegister("5anXw", function(module, exports) {
$parcel$export(module.exports, "default", () => $425e93dc579d8f5f$export$2e2bcd8739ae039);
const $425e93dc579d8f5f$var$nameCache = new WeakMap();
function $425e93dc579d8f5f$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $425e93dc579d8f5f$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $425e93dc579d8f5f$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $425e93dc579d8f5f$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $425e93dc579d8f5f$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'data-testid') || $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $425e93dc579d8f5f$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($425e93dc579d8f5f$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $425e93dc579d8f5f$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$425e93dc579d8f5f$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $425e93dc579d8f5f$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $425e93dc579d8f5f$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $425e93dc579d8f5f$var$getUniqueSelector(selectorConfig, element);
    $425e93dc579d8f5f$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $425e93dc579d8f5f$export$2e2bcd8739ae039 = $425e93dc579d8f5f$var$getElementName;

});


parcelRegister("hF6SW", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $a80d49b8c669a248$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $a80d49b8c669a248$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $a80d49b8c669a248$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $a80d49b8c669a248$export$a3271f53e91faab7);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $a80d49b8c669a248$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $a80d49b8c669a248$var$pressureRecordBuffer = [];
let $a80d49b8c669a248$var$pressureObserver = null;
let $a80d49b8c669a248$var$memoryRecordBuffer = [];
let $a80d49b8c669a248$var$memoryInterval;
function $a80d49b8c669a248$export$6c1060bed5fea050() {
    $a80d49b8c669a248$var$pressureRecordBuffer.length = 0;
}
function $a80d49b8c669a248$export$aa672c7221b183b0() {
    $a80d49b8c669a248$var$memoryRecordBuffer.length = 0;
}
function $a80d49b8c669a248$export$ec86686c1d2e65bc(filter) {
    $a80d49b8c669a248$var$pressureRecordBuffer = $a80d49b8c669a248$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $a80d49b8c669a248$export$c0142ac82f5d0c28(filter) {
    $a80d49b8c669a248$var$memoryRecordBuffer = $a80d49b8c669a248$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $a80d49b8c669a248$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $a80d49b8c669a248$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $a80d49b8c669a248$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $a80d49b8c669a248$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $a80d49b8c669a248$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $a80d49b8c669a248$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $a80d49b8c669a248$var$convertBytesToMegabytes($a80d49b8c669a248$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $a80d49b8c669a248$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $a80d49b8c669a248$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $a80d49b8c669a248$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $a80d49b8c669a248$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $a80d49b8c669a248$var$pressureObserver = new PressureObserver((records)=>{
                if ($a80d49b8c669a248$var$pressureRecordBuffer.length + records.length <= $a80d49b8c669a248$var$BUFFER_MAX_LENGTH) $a80d49b8c669a248$var$pressureRecordBuffer.push(...records);
            });
            $a80d49b8c669a248$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $a80d49b8c669a248$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $a80d49b8c669a248$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($a80d49b8c669a248$var$memoryRecordBuffer.length <= $a80d49b8c669a248$var$BUFFER_MAX_LENGTH) $a80d49b8c669a248$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $a80d49b8c669a248$export$10899ada382f2ae3() {
    clearInterval($a80d49b8c669a248$var$memoryInterval);
}
function $a80d49b8c669a248$export$b9fdd785f0fc1d40() {
    $a80d49b8c669a248$var$pressureObserver?.disconnect();
}

});

parcelRegister("bOxTu", function(module, exports) {
$parcel$export(module.exports, "sinkTerminalErrorHandler", () => $992f58aa8ca6b70d$export$e5fa3ac6dc44efff);

var $1v5pe = parcelRequire("1v5pe");

var $68Mzh = parcelRequire("68Mzh");

var $hRUfe = parcelRequire("hRUfe");

var $8OjRF = parcelRequire("8OjRF");

var $5CbDz = parcelRequire("5CbDz");

var $6cTBm = parcelRequire("6cTBm");
let $992f58aa8ca6b70d$var$sinkHandlerFn = ()=>{};
function $992f58aa8ca6b70d$export$e5fa3ac6dc44efff(fn) {
    $992f58aa8ca6b70d$var$sinkHandlerFn = fn;
}
const $992f58aa8ca6b70d$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $992f58aa8ca6b70d$export$1a949ef92fd30eca = (error)=>error.name === $992f58aa8ca6b70d$var$RELAY_NETWORK_ERRORS_NAME;
const $992f58aa8ca6b70d$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $992f58aa8ca6b70d$var$getErrorStatusCode = (error)=>{
    if (!$992f58aa8ca6b70d$var$isErrorObject(error)) return undefined;
    if ($992f58aa8ca6b70d$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $992f58aa8ca6b70d$var$getErrorTraceId = (error)=>$992f58aa8ca6b70d$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $992f58aa8ca6b70d$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    const activeInteraction = (0, $8OjRF.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $6cTBm.classifyTerminalError)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $992f58aa8ca6b70d$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $68Mzh.getActiveTrace)()?.traceId ?? $992f58aa8ca6b70d$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $8OjRF.PreviousInteractionLog).timestamp != null ? currentTime - (0, $8OjRF.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $8OjRF.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $8OjRF.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $8OjRF.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $5CbDz.default).current ?? null
    };
    $992f58aa8ca6b70d$var$sinkHandlerFn(errorData, context);
}
function $992f58aa8ca6b70d$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $hRUfe.useInteractionContext)();
    const hasReportedRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $992f58aa8ca6b70d$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
}

});
parcelRegister("hRUfe", function(module, exports) {
$parcel$export(module.exports, "default", () => $de75a2afdc2c5381$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $de75a2afdc2c5381$export$11bcb6e9af2aca35);

var $1v5pe = parcelRequire("1v5pe");

var $7qISg = parcelRequire("7qISg");
var $de75a2afdc2c5381$export$2e2bcd8739ae039 = (0, $7qISg.default);
function $de75a2afdc2c5381$export$11bcb6e9af2aca35() {
    return (0, $1v5pe.useContext)((0, $7qISg.default));
}

});

parcelRegister("5CbDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b2509b0112247ac$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $0b2509b0112247ac$var$UFORouteName = {
    current: null
};
var $0b2509b0112247ac$export$2e2bcd8739ae039 = $0b2509b0112247ac$var$UFORouteName;

});

parcelRegister("6cTBm", function(module, exports) {
$parcel$export(module.exports, "classifyTerminalError", () => $d1ea7440bc8c0eee$export$17e837b2daecf805);
const $d1ea7440bc8c0eee$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $d1ea7440bc8c0eee$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $d1ea7440bc8c0eee$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $d1ea7440bc8c0eee$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $d1ea7440bc8c0eee$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $d1ea7440bc8c0eee$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($d1ea7440bc8c0eee$var$ABORT_ERROR_NAMES.has(name) || $d1ea7440bc8c0eee$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $d1ea7440bc8c0eee$var$AUTH_ERROR_NAMES.has(name) && $d1ea7440bc8c0eee$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($d1ea7440bc8c0eee$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $d1ea7440bc8c0eee$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $d1ea7440bc8c0eee$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($d1ea7440bc8c0eee$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $d1ea7440bc8c0eee$export$17e837b2daecf805(error) {
    const directMatch = $d1ea7440bc8c0eee$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $d1ea7440bc8c0eee$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}

});


parcelRegister("7BZlZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4511fb07bac9d5e1$export$2e2bcd8739ae039);

var $hziAm = parcelRequire("hziAm");

var $2aEiL = parcelRequire("2aEiL");
function $4511fb07bac9d5e1$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $2aEiL.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $hziAm.unstable_scheduleCallback)((0, $hziAm.unstable_IdlePriority), work);
}
var $4511fb07bac9d5e1$export$2e2bcd8739ae039 = $4511fb07bac9d5e1$var$scheduleIdleCallback;

});

parcelRegister("hJgqQ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("eoK4c")
]).then(()=>parcelRequire('3AuZz'));

});
parcelRegister("7mhPs", function(module, exports) {
"use strict";

function $55b86af18518ded8$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("7p89F")).resolve(id));
}
module.exports = $55b86af18518ded8$var$load;

});
parcelRegister("7p89F", function(module, exports) {
$parcel$export(module.exports, "register", () => $564131a031794f5a$export$6503ec6e8aabbaf, (v) => $564131a031794f5a$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $564131a031794f5a$export$f7ad0328861e2f03, (v) => $564131a031794f5a$export$f7ad0328861e2f03 = v);
var $564131a031794f5a$export$6503ec6e8aabbaf;
var $564131a031794f5a$export$f7ad0328861e2f03;
"use strict";
var $564131a031794f5a$var$mapping = new Map();
function $564131a031794f5a$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$564131a031794f5a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $564131a031794f5a$var$resolve(id) {
    var resolved = $564131a031794f5a$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$564131a031794f5a$export$6503ec6e8aabbaf = $564131a031794f5a$var$register;
$564131a031794f5a$export$f7ad0328861e2f03 = $564131a031794f5a$var$resolve;

});



parcelRegister("jxaNj", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('46i49'));

});

parcelRegister("347Kf", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('lGV9l'));

});


parcelRegister("54iU5", function(module, exports) {
$parcel$export(module.exports, "default", () => $033bc544096a6949$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $664X1 = parcelRequire("664X1");

var $fskN5 = parcelRequire("fskN5");

var $5tITM = parcelRequire("5tITM");

var $68Mzh = parcelRequire("68Mzh");

var $31aDV = parcelRequire("31aDV");

var $8OjRF = parcelRequire("8OjRF");

var $5CbDz = parcelRequire("5CbDz");
const $033bc544096a6949$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $033bc544096a6949$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $5tITM.isUFOEnabled)()) return;
    const activeInteraction = (0, $8OjRF.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $5CbDz.default).current = routeName || null;
    const rate = ufoName ? (0, $5tITM.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $fskN5.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $664X1.v4)();
        (0, $31aDV.DefaultInteractionID).current = newId;
        (0, $8OjRF.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $68Mzh.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $8OjRF.addHoldByID)(newId, [], $033bc544096a6949$var$AWAITING_PAGELOAD_NAME, $033bc544096a6949$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $8OjRF.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $8OjRF.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $8OjRF.removeHoldByID)(activeInteraction.id, $033bc544096a6949$var$AWAITING_PAGELOAD_NAME);
    }
}
var $033bc544096a6949$export$2e2bcd8739ae039 = $033bc544096a6949$var$traceUFOPageLoad;
function $033bc544096a6949$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $5tITM.isUFOEnabled)()) return;
    const interaction = (0, $8OjRF.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $5tITM.getInteractionRate)(ufoName, 'page_load');
        (0, $8OjRF.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $fskN5.default)(rate)) (0, $5CbDz.default).current = ufoName;
        else (0, $8OjRF.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $8OjRF.removeHoldByID)(interaction.id, $033bc544096a6949$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("dX6kP", function(module, exports) {
$parcel$export(module.exports, "analyticsClient", () => $3db39ce5777157b7$export$f1caacacb426dc27);
$parcel$export(module.exports, "useSendAnalyticEvent", () => $3db39ce5777157b7$export$48173b1537adccbd);

var $jcoDC = parcelRequire("jcoDC");
var $6yEEN = parcelRequire("6yEEN");

var $1v5pe = parcelRequire("1v5pe");

var $1QYE6 = parcelRequire("1QYE6");

var $22hwD = parcelRequire("22hwD");

var $6ascs = parcelRequire("6ascs");

const $3db39ce5777157b7$export$f1caacacb426dc27 = new (0, $jcoDC.default)({
    // local, dev, staging all get sent to the same staging environment
    // https://hello.atlassian.net/wiki/spaces/AAPT/pages/134328422/Analytics+Lesson+2+-+Sending+Events
    env: (0, (0, $6yEEN.envType).PROD),
    product: 'rovoExtension'
}, {
    // Steps we could take to turn this off: https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/Action+Required+api-private+is+broken+is+your+product+impacted
    useLegacyUrl: true,
    onNewSessionStarted: ()=>{
        (parcelRequire("1t5Vd")).then((m)=>m.onAnalyticsWebClientSessionRotation());
    }
});
const $3db39ce5777157b7$export$48173b1537adccbd = ()=>{
    const userMetadata = (0, $6ascs.useAnalyticsUserMetadata)()?.userMetadata;
    const sendAnalyticEvent = (0, $1v5pe.useCallback)(({ eventType: eventType, event: event, userId: userId })=>{
        const site = (0, $1QYE6.getSelectedSiteFromLocalStorage)();
        const payload = {
            ...event,
            attributes: {
                ...event.attributes,
                ...userMetadata
            }
        };
        if (site?.workspace.cloudId) $3db39ce5777157b7$export$f1caacacb426dc27.setTenantInfo((0, $6yEEN.tenantType).CLOUD_ID, site.workspace.cloudId);
        if (userId) $3db39ce5777157b7$export$f1caacacb426dc27.setUserInfo((0, $6yEEN.userType).ATLASSIAN_ACCOUNT, userId);
        // Use ui as the default type if the event doesn't have a type
        const type = eventType ?? 'ui';
        switch(type){
            case 'ui':
                if ($3db39ce5777157b7$var$isValidActionEvent(payload, type)) $3db39ce5777157b7$export$f1caacacb426dc27.sendUIEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: 'Failed to send UI analytics event'
                    });
                });
                break;
            case 'screen':
                if (payload.name) $3db39ce5777157b7$export$f1caacacb426dc27.sendScreenEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: 'Failed to send screen analytics event'
                    });
                });
                break;
            case 'track':
                if ($3db39ce5777157b7$var$isValidActionEvent(payload, type)) $3db39ce5777157b7$export$f1caacacb426dc27.sendTrackEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: 'Failed to send track analytics event'
                    });
                });
                break;
            case 'operational':
                if ($3db39ce5777157b7$var$isValidActionEvent(payload, type)) $3db39ce5777157b7$export$f1caacacb426dc27.sendOperationalEvent(payload).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: 'Failed to send operational analytics event'
                    });
                });
                break;
        }
    }, [
        userMetadata
    ]);
    return sendAnalyticEvent;
};
function $3db39ce5777157b7$var$isValidActionEvent(payload, type) {
    if (!payload?.source || !payload.actionSubject || !payload.action) {
        const missingFields = [
            !payload?.source && 'source',
            !payload?.actionSubject && 'actionSubject',
            !payload?.action && 'action'
        ].filter(Boolean);
        (0, $22hwD.logError)({
            error: new Error('Invalid analytics action event payload'),
            extra: {
                missingFields: missingFields,
                type: type,
                payload: payload
            }
        });
        return false;
    }
    return true;
}

});
parcelRegister("1QYE6", function(module, exports) {
$parcel$export(module.exports, "getSelectedSiteFromLocalStorage", () => $43a08c775d2b00b7$export$7972af24309c7242);
$parcel$export(module.exports, "useSendSiteChangeAnalytics", () => $43a08c775d2b00b7$export$9120fbebb13679dd);
$parcel$export(module.exports, "SiteProvider", () => $43a08c775d2b00b7$export$f12be7154ec345e8);
$parcel$export(module.exports, "useSite", () => $43a08c775d2b00b7$export$7870fa8e7cdd59f8);

var $1v5pe = parcelRequire("1v5pe");

var $f8dZw = parcelRequire("f8dZw");
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");

var $bFW4F = parcelRequire("bFW4F");

var $e9gYt = parcelRequire("e9gYt");

var $f0dSY = parcelRequire("f0dSY");

var $dX6kP = parcelRequire("dX6kP");

var $lsxLV = parcelRequire("lsxLV");

var $hmQ4u = parcelRequire("hmQ4u");

var $9JAaz = parcelRequire("9JAaz");
function $43a08c775d2b00b7$export$7972af24309c7242() {
    const selectedSite = (0, $fgIUF.getLocalStorageItem)((0, $fgIUF.LocalStorageKey).SELECTED_SITE);
    if (!selectedSite) return;
    return {
        workspace: {
            cloudId: selectedSite.cloudId,
            organisationId: selectedSite.orgId
        },
        defaultSiteBaseUrl: selectedSite.baseUrl
    };
}
const $43a08c775d2b00b7$export$7c9ab0c846d0fe5b = (atlassianSite)=>{
    return {
        workspace: {
            cloudId: atlassianSite.cloudId,
            organisationId: atlassianSite.orgId
        },
        defaultSiteBaseUrl: atlassianSite.baseUrl
    };
};
const $43a08c775d2b00b7$export$f70c502b152f67e7 = (rovoEnabledSites = [], selectedSite)=>{
    // Add null check to prevent runtime errors
    if (!Array.isArray(rovoEnabledSites) || rovoEnabledSites.length === 0) return undefined;
    const foundSite = rovoEnabledSites.find((s)=>s.cloudId === selectedSite?.cloudId) ?? rovoEnabledSites.find((s)=>(0, $e9gYt.isHello)(s.cloudId)) ?? rovoEnabledSites[0];
    return foundSite;
};
const $43a08c775d2b00b7$var$SiteContext = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $43a08c775d2b00b7$export$9120fbebb13679dd = ({ accountId: accountId })=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const sendSiteChangeAnalytics = (0, $1v5pe.useCallback)(({ site: site, caller: caller })=>{
        sendAnalyticEvent({
            eventType: 'track',
            event: {
                action: 'called setSiteStatesAndBroadcast',
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).SITE_SELECTOR,
                source: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_HOME_SCREEN,
                attributes: {
                    newValue: site,
                    trigger: caller
                }
            },
            userId: accountId
        });
    }, [
        accountId,
        sendAnalyticEvent
    ]);
    return sendSiteChangeAnalytics;
};
const $43a08c775d2b00b7$export$f12be7154ec345e8 = ({ children: children, userAccount: userAccount, onSiteChange: onSiteChange })=>{
    const lastSelectedSite = (0, $fgIUF.getLocalStorageItem)((0, $fgIUF.LocalStorageKey).SELECTED_SITE);
    const [selectedSite, setSelectedSite] = (0, $1v5pe.useState)(lastSelectedSite ?? undefined);
    const publish = (0, $f8dZw.usePublish)('ai-mate');
    const { data: data, isLoading: isLoading } = (0, $bFW4F.useSitesWithRovoEnabled)(userAccount);
    const rovoEnabledSites = (0, $1v5pe.useMemo)(()=>data?.results ?? [], [
        data
    ]);
    const handleSetSite = (0, $1v5pe.useCallback)((site)=>{
        if (site) {
            (0, $fgIUF.setLocalStorageItem)((0, $fgIUF.LocalStorageKey).SELECTED_SITE, {
                cloudId: site.cloudId,
                baseUrl: site.baseUrl,
                orgId: site.orgId
            });
            // publish chat-draft to clear any conversationId (same window)
            publish({
                type: 'chat-draft',
                source: 'extension'
            });
            setSelectedSite(site);
            onSiteChange?.($43a08c775d2b00b7$export$7c9ab0c846d0fe5b(site));
        }
    }, [
        publish,
        onSiteChange
    ]);
    const atlassianSite = (0, $1v5pe.useMemo)(()=>{
        return $43a08c775d2b00b7$export$f70c502b152f67e7(rovoEnabledSites, selectedSite);
    }, [
        rovoEnabledSites,
        selectedSite
    ]);
    const site = (0, $1v5pe.useMemo)(()=>{
        return atlassianSite ? $43a08c775d2b00b7$export$7c9ab0c846d0fe5b(atlassianSite) : undefined;
    }, [
        atlassianSite
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (site && atlassianSite) {
            const siteChanged = site.workspace.cloudId !== selectedSite?.cloudId;
            if (siteChanged) {
                // sets the selected site in local storage the first time the site is set
                if (!selectedSite) handleSetSite({
                    cloudId: site.workspace.cloudId,
                    baseUrl: site.defaultSiteBaseUrl,
                    siteName: atlassianSite.siteName,
                    orgId: site.workspace.organisationId
                });
                else onSiteChange?.(site);
            }
            // else just broadcast the config to the extension
            (0, $9JAaz.broadcastConfigToExtension)({
                workspace: {
                    cloudId: site.workspace.cloudId,
                    organisationId: site.workspace.organisationId
                },
                defaultSiteBaseUrl: site.defaultSiteBaseUrl
            });
        }
    }, [
        selectedSite,
        site,
        atlassianSite,
        handleSetSite,
        onSiteChange
    ]);
    const onLocalStorageChange = (0, $1v5pe.useCallback)((value)=>{
        if (value) {
            // tells chat to clear any conversationId
            if (value.cloudId !== selectedSite?.cloudId) publish({
                type: 'chat-draft',
                source: 'extension'
            });
            setSelectedSite(value);
        }
    }, [
        publish,
        selectedSite
    ]);
    (0, $fgIUF.addLocalStorageEventListener)((0, $fgIUF.LocalStorageKey).SELECTED_SITE, onLocalStorageChange);
    (0, $1v5pe.useEffect)(()=>{
        (0, $f0dSY.setSentryExperiments)();
        if (site) (0, $f0dSY.setSentrySiteId)(site.workspace.cloudId);
    }, [
        site
    ]);
    if (isLoading) // todo show loader here
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null);
    if (!site || !atlassianSite) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hmQ4u.default), {
        metadata: data?.metadata,
        showNavigation: true,
        userAccount: userAccount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($43a08c775d2b00b7$var$SiteContext.Provider, {
        value: {
            site: site,
            atlassianSite: atlassianSite,
            handleSetSite: handleSetSite,
            rovoEnabledSites: rovoEnabledSites
        }
    }, children);
};
const $43a08c775d2b00b7$export$7870fa8e7cdd59f8 = (options = {})=>{
    const context = (0, $1v5pe.useContext)($43a08c775d2b00b7$var$SiteContext);
    if (!options.allowUndefined && context === undefined) throw new Error('useSiteContext must be used within a SiteProvider');
    return context;
};

});
parcelRegister("f8dZw", function(module, exports) {
$parcel$export(module.exports, "useSubscribe", () => $25b69b6fe048bb63$export$d3d523392640272);
$parcel$export(module.exports, "usePublish", () => $25b69b6fe048bb63$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $25b69b6fe048bb63$export$60959659b2c22881);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");
const $25b69b6fe048bb63$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $25b69b6fe048bb63$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $25b69b6fe048bb63$var$isIgnoredForTriggerLatest = (type)=>{
    if ($25b69b6fe048bb63$var$ignoredTriggerLatestEvents.has(type)) return true;
    if (type === 'set-message-context') return (0, $2aEiL.fg)('rovo_chat_fix_cold_start_prompt_insertion');
    if (type === 'jira-create-context-payload') return (0, $2aEiL.fg)('rovo_chat_fix_jira_prompt_dropped_on_reopen');
    return false;
};
const $25b69b6fe048bb63$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $25b69b6fe048bb63$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$25b69b6fe048bb63$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $25b69b6fe048bb63$var$pubSub = $25b69b6fe048bb63$var$createPubSub();
const $25b69b6fe048bb63$var$usePubSub = ()=>{
    return $25b69b6fe048bb63$var$pubSub;
};
const $25b69b6fe048bb63$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe } = $25b69b6fe048bb63$var$usePubSub();
    const callbackRef = (0, $1v5pe.useRef)(callback);
    callbackRef.current = callback;
    (0, $1v5pe.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        consumeOnceKey
    ]);
};
const $25b69b6fe048bb63$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $25b69b6fe048bb63$var$usePubSub();
    const callbackRef = (0, $1v5pe.useRef)(callback);
    callbackRef.current = callback;
    (0, $1v5pe.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $25b69b6fe048bb63$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $25b69b6fe048bb63$var$usePubSub();
    (0, $1v5pe.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $25b69b6fe048bb63$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $25b69b6fe048bb63$var$usePubSub();
    const publishFn = (0, $1v5pe.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $25b69b6fe048bb63$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $25b69b6fe048bb63$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $25b69b6fe048bb63$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});

parcelRegister("cDuOd", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKey", () => (parcelRequire("fgIUF")).LocalStorageKey);
$parcel$export(module.exports, "setLocalStorageItem", () => (parcelRequire("fgIUF")).setLocalStorageItem);
$parcel$export(module.exports, "getLocalStorageItem", () => (parcelRequire("fgIUF")).getLocalStorageItem);
$parcel$export(module.exports, "addLocalStorageEventListener", () => (parcelRequire("fgIUF")).addLocalStorageEventListener);
$parcel$export(module.exports, "removeLocalStorageEventListener", () => (parcelRequire("fgIUF")).removeLocalStorageEventListener);

var $fgIUF = parcelRequire("fgIUF");

});
parcelRegister("fgIUF", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKey", () => $3afebd2523c634f1$export$e9d9376124133876);
$parcel$export(module.exports, "setLocalStorageItem", () => $3afebd2523c634f1$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $3afebd2523c634f1$export$93d719890ad66653);
$parcel$export(module.exports, "addLocalStorageEventListener", () => $3afebd2523c634f1$export$589491e71aa37313);
$parcel$export(module.exports, "removeLocalStorageEventListener", () => $3afebd2523c634f1$export$cdd6e8ebb7bf8992);
$parcel$export(module.exports, "setLocalStorageItemRawString", () => $3afebd2523c634f1$export$20508c4c4ae90dc7);
$parcel$export(module.exports, "getLocalStorageItemRawString", () => $3afebd2523c634f1$export$6b4cb6748a03c9ca);
$parcel$export(module.exports, "addLocalStorageEventListenerRawString", () => $3afebd2523c634f1$export$69a4116e1ad84bc6);

var $22hwD = parcelRequire("22hwD");
var $3afebd2523c634f1$export$e9d9376124133876 = /*#__PURE__*/ function(LocalStorageKey) {
    LocalStorageKey["RECENT_WORK_ENABLED"] = "recent_work_enabled";
    LocalStorageKey["CALENDAR_ENABLED"] = "calendar_enabled";
    LocalStorageKey["CALENDAR_SELECTED"] = "calendar_selected";
    LocalStorageKey["SELECTED_SITE"] = "selected_site";
    LocalStorageKey["BOOKMARKS_ENABLED"] = "bookmark_enabled";
    LocalStorageKey["THEME_COLOR_MODE"] = "theme_color_mode";
    LocalStorageKey["ANNOUNCEMENT_BANNER"] = "announcement_banner";
    LocalStorageKey["ANNOUNCEMENTS_ENABLED"] = "announcements_enabled";
    LocalStorageKey["PLUGIN_FEEDBACK"] = "plugin_feedback_usage";
    LocalStorageKey["HAS_USER_ONBOARDED_ON_INSTALL"] = "has_user_onboarded_on_install";
    LocalStorageKey["BACKGROUND_PREVIEW_FILE_TYPE"] = "background_preview_file_type";
    LocalStorageKey["BACKGROUND_PREVIEW_URL"] = "background_preview_url";
    LocalStorageKey["CHROME_EXTENSION_DEBUG_DATA"] = "chrome_extension_debug_data";
    LocalStorageKey["IS_FULL_PAGE_CHAT"] = "is_full_page_chat";
    LocalStorageKey["WELCOME_HEADER_ENABLED"] = "welcome_header_enabled";
    LocalStorageKey["GLOBAL_CREATE_ENABLED"] = "global_create_enabled";
    LocalStorageKey["LOCAL_DEV_BANNER_ENABLED"] = "local_dev_banner_enabled";
    LocalStorageKey["SELECTED_NTP_AGENT"] = "selected_ntp_agent";
    LocalStorageKey["NTP_AGENT_SPOTLIGHT_DISMISSED"] = "ntp_agent_spotlight_dismissed";
    LocalStorageKey["NTP_AGENT_DROPDOWN_OPEN_COUNT"] = "ntp_agent_dropdown_open_count";
    return LocalStorageKey;
}({});
const $3afebd2523c634f1$export$5aa524d86254b4f = (key, value)=>{
    try {
        const valueString = value !== undefined ? JSON.stringify(value) : '';
        localStorage.setItem(key, valueString);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to save to local storage',
            extra: {
                key: key
            }
        });
    }
};
const $3afebd2523c634f1$export$93d719890ad66653 = (key, defaultValue)=>{
    try {
        const valueString = localStorage.getItem(key);
        if (!valueString && defaultValue !== undefined) {
            $3afebd2523c634f1$export$5aa524d86254b4f(key, defaultValue);
            return defaultValue;
        }
        return valueString && JSON.parse(valueString);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to retrieve from local storage',
            extra: {
                key: key
            }
        });
        return null;
    }
};
const $3afebd2523c634f1$export$589491e71aa37313 = (key, callback)=>{
    const callbackHandle = (event)=>{
        if (event.key !== key) return;
        try {
            const value = event.newValue ? JSON.parse(event.newValue) : undefined;
            callback(value);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'Failed to parse storage event value',
                extra: {
                    key: key
                }
            });
        }
    };
    const customEventCallbackHandle = (event)=>{
        if (event.detail.key !== key) return;
        try {
            callback(event.detail.newValue);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'Failed to parse custom storage event value',
                extra: {
                    key: key
                }
            });
        }
    };
    window.addEventListener('storage', callbackHandle);
    window.addEventListener('STORAGE_SAME_WINDOW', customEventCallbackHandle);
    const destroyStorageListener = ()=>$3afebd2523c634f1$export$cdd6e8ebb7bf8992(callbackHandle);
    const destroyCustomEventListener = ()=>$3afebd2523c634f1$var$removeCustomEventListener(customEventCallbackHandle);
    return ()=>{
        destroyStorageListener();
        destroyCustomEventListener();
    };
};
const $3afebd2523c634f1$export$cdd6e8ebb7bf8992 = (callbackHandle)=>{
    window.removeEventListener('storage', callbackHandle);
};
const $3afebd2523c634f1$var$removeCustomEventListener = (callbackHandle)=>{
    window.removeEventListener('STORAGE_SAME_WINDOW', callbackHandle);
};
const $3afebd2523c634f1$export$c12b7b0e1d99a309 = ()=>{
    localStorage.clear();
};
const $3afebd2523c634f1$export$20508c4c4ae90dc7 = (key, value)=>{
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to save raw string to local storage',
            extra: {
                key: key
            }
        });
    }
};
const $3afebd2523c634f1$export$6b4cb6748a03c9ca = (key)=>{
    try {
        return localStorage.getItem(key);
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to retrieve raw string from local storage',
            extra: {
                key: key
            }
        });
        return null;
    }
};
const $3afebd2523c634f1$export$69a4116e1ad84bc6 = (key, callback)=>{
    const callbackHandle = (event)=>{
        if (event.key !== key || !event.newValue) return;
        callback(event.newValue);
    };
    window.addEventListener('storage', callbackHandle);
    return callbackHandle;
};

});
parcelRegister("22hwD", function(module, exports) {
$parcel$export(module.exports, "NamedError", () => $107b06f1fb575fbc$export$b63482fab140df79);
$parcel$export(module.exports, "normalizeError", () => $107b06f1fb575fbc$export$e7bd538fb0c5db1a);
$parcel$export(module.exports, "logInfo", () => $107b06f1fb575fbc$export$89c0607256d35f0a);
$parcel$export(module.exports, "logWarn", () => $107b06f1fb575fbc$export$cc36178e946876e8);
$parcel$export(module.exports, "logError", () => $107b06f1fb575fbc$export$58da9968c3170cb1);

var $i38Fr = parcelRequire("i38Fr");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");
class $107b06f1fb575fbc$export$b63482fab140df79 extends Error {
    constructor(name, cause){
        const originalError = cause instanceof Error ? cause : new Error(String(cause));
        super(originalError.message);
        this.name = name;
        this.cause = cause;
        if (originalError.stack) this.stack = originalError.stack;
    }
}
/**
 * Builds a concise, human-readable message from common error-shaped object
 * fields. Returns undefined when no useful fields are present so callers can
 * fall back to other strategies (e.g. JSON.stringify).
 */ function $107b06f1fb575fbc$var$getReadableMessageFromObject(obj, depth = 0) {
    const name = typeof obj.name === 'string' ? obj.name : undefined;
    const detail = typeof obj.description === 'string' && obj.description || typeof obj.message === 'string' && obj.message || typeof obj.reason === 'string' && obj.reason || undefined;
    if (name && detail) return `${name}: ${detail}`;
    if (name || detail) return name || detail;
    // Some libraries wrap the meaningful error one level deep under `error` (e.g.
    // media-picker) or the standard `cause`. Recurse into those before giving up so
    // we surface a readable message instead of a raw JSON dump. Bound the depth to
    // avoid cycles / runaway recursion.
    if (depth < 2) for (const key of [
        'error',
        'cause'
    ]){
        const nested = obj[key];
        if (nested && typeof nested === 'object') {
            const nestedMessage = $107b06f1fb575fbc$var$getReadableMessageFromObject(nested, depth + 1);
            if (nestedMessage) return nestedMessage;
        }
    }
    return undefined;
}
function $107b06f1fb575fbc$export$e7bd538fb0c5db1a(error) {
    // If it's already an Error instance, return as is
    if (error instanceof Error) return error;
    // Handle null/undefined explicitly
    if (error === null) return new Error('Error was null');
    if (error === undefined) return new Error('Error was undefined');
    // For objects, prefer a meaningful, human-readable message built from common
    // error-shaped fields (e.g. media-client errors expose name/description/reason)
    // before falling back to a full JSON dump, which produces noisy Sentry titles
    // and poor grouping.
    if (typeof error === 'object') {
        const readableMessage = $107b06f1fb575fbc$var$getReadableMessageFromObject(error);
        if (readableMessage) return new Error(readableMessage);
        try {
            return new Error(JSON.stringify(error));
        } catch  {
            return new Error('[Object cannot be stringified]');
        }
    }
    // For other primitives, convert to string
    return new Error(String(error));
}
function $107b06f1fb575fbc$export$89c0607256d35f0a(msg, ...args) {
    if (0, $dqHaj.debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
    $i38Fr.captureEvent({
        message: msg,
        level: 'info',
        extra: {
            ...args
        }
    });
}
function $107b06f1fb575fbc$export$cc36178e946876e8(msg, ...args) {
    if (0, $dqHaj.debugEnabled) // eslint-disable-next-line no-console
    console.warn(msg, ...args);
    $i38Fr.captureEvent({
        message: msg,
        level: 'warning',
        extra: {
            ...args
        }
    });
}
function $107b06f1fb575fbc$export$58da9968c3170cb1({ error: error, impact: impact, extra: extra, tags: tags, context: context }) {
    const errorObject = $107b06f1fb575fbc$export$e7bd538fb0c5db1a(error);
    if (0, $dqHaj.debugEnabled) // eslint-disable-next-line no-console
    console.error(impact, errorObject, extra);
    $i38Fr.captureException(errorObject, {
        tags: {
            ...tags
        },
        extra: {
            impact: impact,
            ...extra ?? {}
        },
        contexts: {
            ...context
        }
    });
}

});
parcelRegister("iuDZJ", function(module, exports) {
$parcel$export(module.exports, "bifrostEnv", () => (parcelRequire("dqHaj")).bifrostEnv);
$parcel$export(module.exports, "bitbucketCommit", () => (parcelRequire("dqHaj")).bitbucketCommit);
$parcel$export(module.exports, "debugEnabled", () => (parcelRequire("dqHaj")).debugEnabled);
$parcel$export(module.exports, "getIdentityUrl", () => (parcelRequire("dqHaj")).getIdentityUrl);
$parcel$export(module.exports, "getRovoExtensionWebBaseUrl", () => (parcelRequire("dqHaj")).getRovoExtensionWebBaseUrl);
$parcel$export(module.exports, "getAtlassianHomeUrl", () => (parcelRequire("dqHaj")).getAtlassianHomeUrl);
$parcel$export(module.exports, "getAdminHubUrl", () => (parcelRequire("dqHaj")).getAdminHubUrl);
$parcel$export(module.exports, "getStudioUrl", () => (parcelRequire("dqHaj")).getStudioUrl);
$parcel$export(module.exports, "getLocale", () => (parcelRequire("dqHaj")).getLocale);
$parcel$export(module.exports, "getBuildInfo", () => (parcelRequire("dqHaj")).getBuildInfo);
$parcel$export(module.exports, "getSessionReplayAmplitudeApiKey", () => (parcelRequire("dqHaj")).getSessionReplayAmplitudeApiKey);
/* eslint-disable no-restricted-imports -- It's ok in this file as it is exporting for the rest of the application */ 
var $dqHaj = parcelRequire("dqHaj");

var $iy6x4 = parcelRequire("iy6x4");

});
parcelRegister("dqHaj", function(module, exports) {
$parcel$export(module.exports, "bifrostEnv", () => $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8);
$parcel$export(module.exports, "getSessionReplayAmplitudeApiKey", () => $ef0f6fe5ca24b5a5$export$5a7069e28eb595d3);
$parcel$export(module.exports, "bitbucketCommit", () => $ef0f6fe5ca24b5a5$export$3da246011bdfb8cb);
$parcel$export(module.exports, "extensionUrl", () => $ef0f6fe5ca24b5a5$export$3c5eeed6890748ce);
$parcel$export(module.exports, "debugEnabled", () => $ef0f6fe5ca24b5a5$export$342c99cc1e9bc5c6);
$parcel$export(module.exports, "getStatsigUrl", () => $ef0f6fe5ca24b5a5$export$8abe4c34290ae3e9);
$parcel$export(module.exports, "getSwitcherooUrl", () => $ef0f6fe5ca24b5a5$export$dbb5d9628153315c);
$parcel$export(module.exports, "getIdentityUrl", () => $ef0f6fe5ca24b5a5$export$4fa18e6b13122af5);
$parcel$export(module.exports, "getRovoExtensionWebBaseUrl", () => $ef0f6fe5ca24b5a5$export$69a484083d87faa2);
$parcel$export(module.exports, "getAtlassianHomeUrl", () => $ef0f6fe5ca24b5a5$export$69576aae579b51af);
$parcel$export(module.exports, "getAdminHubUrl", () => $ef0f6fe5ca24b5a5$export$631ba87ff5b9e288);
$parcel$export(module.exports, "getStudioUrl", () => $ef0f6fe5ca24b5a5$export$22f3f17829eee7e0);
$parcel$export(module.exports, "getLocale", () => $ef0f6fe5ca24b5a5$export$180605366c04f0cd);
$parcel$export(module.exports, "getBuildInfo", () => $ef0f6fe5ca24b5a5$export$4ea39b9726d98a51);
const $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 = "prod";
const $ef0f6fe5ca24b5a5$export$5a7069e28eb595d3 = ()=>'4aa1cbd970f59a84661985c72484058f';
const $ef0f6fe5ca24b5a5$export$3da246011bdfb8cb = "184f96a70be42eee03bb4625a0369e10061e20b9";
const $ef0f6fe5ca24b5a5$export$3c5eeed6890748ce = "chrome-extension://npbjhobkibekbklkghlhfhieggcggpdb";
const $ef0f6fe5ca24b5a5$export$342c99cc1e9bc5c6 = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 !== 'prod';
const $ef0f6fe5ca24b5a5$export$8abe4c34290ae3e9 = (id, type)=>{
    switch(type){
        case 'featureGate':
            return `https://console.statsig.com/gates/${id}`;
        case 'experiment':
            return `https://console.statsig.com/experiments/${id}/setup`;
        case 'dynamicConfig':
            return `https://console.statsig.com/dynamic_configs/${id}`;
        default:
            throw new Error(`Unknown Statsig resource type: ${type}`);
    }
};
const $ef0f6fe5ca24b5a5$export$dbb5d9628153315c = (id, type)=>{
    switch(type){
        case 'flag':
            return `https://switcheroo.atlassian.com/ui/changes?flagSearch=${id}`;
        case 'dynamicConfig':
            return `https://switcheroo.atlassian.com/ui/configurations?search=${id}`;
        default:
            throw new Error(`Unknown Switcheroo resource type: ${type}`);
    }
};
const $ef0f6fe5ca24b5a5$export$4fa18e6b13122af5 = ()=>{
    const stagingLoginUrl = 'https://id.stg.internal.atlassian.com';
    const prodLoginUrl = 'https://id.atlassian.com';
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === 'prod';
    if (isProd) return prodLoginUrl;
    return stagingLoginUrl;
};
const $ef0f6fe5ca24b5a5$export$69a484083d87faa2 = ()=>{
    const stagingBaseUrl = 'https://rovo-extension-web.stg-east.frontend.public.atl-paas.net';
    const prodBaseUrl = 'https://rovo-extension-web.atlassian.com';
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === 'prod';
    if (isProd) return prodBaseUrl;
    return stagingBaseUrl;
};
const $ef0f6fe5ca24b5a5$export$c7a04534f7a88653 = ()=>`${$ef0f6fe5ca24b5a5$export$69a484083d87faa2()}/gateway/api/graphql`;
const $ef0f6fe5ca24b5a5$export$69576aae579b51af = ()=>{
    const stagingAtlassianHomeUrl = 'https://home.stg.atlassian.com';
    const prodAtlassianHomeUrl = 'https://home.atlassian.com';
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === 'prod';
    if (isProd) return prodAtlassianHomeUrl;
    return stagingAtlassianHomeUrl;
};
const $ef0f6fe5ca24b5a5$export$631ba87ff5b9e288 = ()=>{
    const stagingAdminHubUrl = 'https://admin.stg.atlassian.com';
    const prodAdminHubUrl = 'https://admin.atlassian.com';
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === 'prod';
    if (isProd) return prodAdminHubUrl;
    return stagingAdminHubUrl;
};
const $ef0f6fe5ca24b5a5$export$22f3f17829eee7e0 = ()=>{
    const stagingStudioUrl = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
    const prodStudioUrl = 'https://studio.atlassian.com';
    const isProd = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8 === 'prod';
    if (isProd) return prodStudioUrl;
    return stagingStudioUrl;
};
const $ef0f6fe5ca24b5a5$export$180605366c04f0cd = ()=>{
    return navigator.language;
};
const $ef0f6fe5ca24b5a5$export$4ea39b9726d98a51 = ()=>{
    const environment = $ef0f6fe5ca24b5a5$export$8a2eb78ddfc0abf8;
    const version = "184f96a70be42eee03bb4625a0369e10061e20b9";
    const buildNumber = "18645961";
    const buildUrl = buildNumber ? `https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pipelines/results/${buildNumber}` : undefined;
    return {
        environment: environment,
        version: version,
        buildNumber: buildNumber,
        buildUrl: buildUrl
    };
};

});

parcelRegister("iy6x4", function(module, exports) {
// Only used in local development (atlaspack dev flow)
// These must stay in sync with WindowMessageType in extension-chrome/src/scripts/message-bus/windowMessages.ts
const $da9ef5297cb8516b$var$SESSION_COOKIE_MESSAGE_TYPES = {
    REQUEST: 'GET_SESSION_COOKIE_REQUEST',
    RESPONSE: 'GET_SESSION_COOKIE_RESPONSE'
};
function $da9ef5297cb8516b$export$1620d451ff8602ae() {
    const match = document.cookie.match(/cloud.session.token.stg=([^;]+)/);
    return match ? match[1] : null;
}
function $da9ef5297cb8516b$export$7835b8deb2269e9c() {
    const existingSessionCookie = $da9ef5297cb8516b$export$1620d451ff8602ae();
    if (existingSessionCookie) return Promise.resolve(existingSessionCookie);
    return new Promise((resolve)=>{
        const handleMessage = (event)=>{
            if (event.data.type === $da9ef5297cb8516b$var$SESSION_COOKIE_MESSAGE_TYPES.RESPONSE) {
                window.removeEventListener('message', handleMessage);
                const cookie = event.data.cookie;
                resolve(cookie);
            }
        };
        window.addEventListener('message', handleMessage);
        window.parent.postMessage({
            type: $da9ef5297cb8516b$var$SESSION_COOKIE_MESSAGE_TYPES.REQUEST
        }, '*');
        // Timeout after 2 seconds
        setTimeout(()=>{
            window.removeEventListener('message', handleMessage);
            resolve(null);
        }, 2000);
    });
}
async function $da9ef5297cb8516b$export$7bcce6168ef1fdde() {
    const cookie = await $da9ef5297cb8516b$export$7835b8deb2269e9c();
    if (!cookie) return;
    try {
        const response = await fetch(`${window.location.origin}/set-session-cookie?token=${cookie}`);
        if (response.ok) // eslint-disable-next-line no-console
        console.log("\uD83C\uDF6A Cookie set via /set-session-cookie endpoint");
        else // eslint-disable-next-line no-console
        console.error('Failed to set cookie via /set-session-cookie endpoint');
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to set cookie via /set-session-cookie endpoint', error);
    }
}

});





parcelRegister("bFW4F", function(module, exports) {
$parcel$export(module.exports, "GatewayQueryKeys", () => $dea4808c67babfd0$export$f2e6cdf3896a09be);
$parcel$export(module.exports, "GatewayError", () => $dea4808c67babfd0$export$8ef93724ecb8bcb7);
$parcel$export(module.exports, "useSitesWithRovoEnabled", () => $dea4808c67babfd0$export$285ef510e139bb08);
$parcel$export(module.exports, "useSearchSiteResources", () => $dea4808c67babfd0$export$aa23cd1321ee74ce);
$parcel$export(module.exports, "useRovoEntitlement", () => $dea4808c67babfd0$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useUserAccount", () => $dea4808c67babfd0$export$355b5a80a2683ecb);
$parcel$export(module.exports, "extendSession", () => $dea4808c67babfd0$export$d0caa90bfa1dd141);
$parcel$export(module.exports, "use3PConnectors", () => $dea4808c67babfd0$export$546fbc853a926d44);
$parcel$export(module.exports, "getOrgAdminPermissions", () => $dea4808c67babfd0$export$6a5a4d31a72d7723);
$parcel$export(module.exports, "getSiteAdminPermissions", () => $dea4808c67babfd0$export$2a8816ad92ca751f);
$parcel$export(module.exports, "useOrgAdminPermissions", () => $dea4808c67babfd0$export$f44446fc6da7bd74);
$parcel$export(module.exports, "useSiteAdminPermissions", () => $dea4808c67babfd0$export$4c22a3fb2ef39a6);
$parcel$export(module.exports, "getAnnouncementSettings", () => $dea4808c67babfd0$export$f59e5704f7811ae4);
$parcel$export(module.exports, "getRovoExtensionAdminSettings", () => $dea4808c67babfd0$export$23fbf0ea178eddd2);
$parcel$export(module.exports, "saveAnnouncementSettings", () => $dea4808c67babfd0$export$46fc2e3ce5326cef);
$parcel$export(module.exports, "getCompanyThemingSettings", () => $dea4808c67babfd0$export$ba27034f167f88dc);
$parcel$export(module.exports, "saveCompanyThemingSettings", () => $dea4808c67babfd0$export$96dd258aa592820);
$parcel$export(module.exports, "getMediaToken", () => $dea4808c67babfd0$export$6d8018625f2049f7);
$parcel$export(module.exports, "saveRovoExtensionAdminSettings", () => $dea4808c67babfd0$export$8eaf99e03c8b850a);

var $hAXMW = parcelRequire("hAXMW");

var $dX6kP = parcelRequire("dX6kP");

var $lsxLV = parcelRequire("lsxLV");

var $crLv5 = parcelRequire("crLv5");

var $kwVgn = parcelRequire("kwVgn");

var $22hwD = parcelRequire("22hwD");

var $9aNsE = parcelRequire("9aNsE");

var $1ZAcM = parcelRequire("1ZAcM");
var $dea4808c67babfd0$export$f2e6cdf3896a09be = /*#__PURE__*/ function(GatewayQueryKeys) {
    GatewayQueryKeys["SEARCH_SITES_WITH_ROVO_ENABLED_WITH_METADATA_NEW"] = "searchSitesWithRovoEnabledWithMetadataNew";
    return GatewayQueryKeys;
}({});
class $dea4808c67babfd0$export$8ef93724ecb8bcb7 extends Error {
    constructor(error){
        super(error.errorMessage);
        this.errorType = error.errorType;
        this.statusCode = error.code;
    }
}
const $dea4808c67babfd0$export$b6542bdef08604ce = 'userAccount';
const $dea4808c67babfd0$var$fiveMinutesInMs = 300000; // five minutes, 60 seconds in a minutes, 1000 milliseconds in a second
const $dea4808c67babfd0$var$oneHourInMs = 3600000; // sixty minutes in an hour, 60 seconds in a minutes, 1000 milliseconds in a second
const $dea4808c67babfd0$var$oneDayInMs = 24 * $dea4808c67babfd0$var$oneHourInMs;
function $dea4808c67babfd0$export$285ef510e139bb08(userAccount, useQueryOptions) {
    return (0, $hAXMW.useQuery)({
        queryKey: [
            "searchSitesWithRovoEnabledWithMetadataNew",
            userAccount?.accountId
        ],
        ...useQueryOptions,
        queryFn: ()=>$dea4808c67babfd0$export$c8b284ba2f7ea5bc(),
        throwOnError (error) {
            (0, $22hwD.logError)({
                error: new (0, $22hwD.NamedError)('RovoEnabledSitesFetchError', error),
                impact: 'Error fetching rovo enabled sites'
            });
            return false;
        },
        staleTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        gcTime: $dea4808c67babfd0$var$oneHourInMs,
        retry: 1
    });
}
async function $dea4808c67babfd0$export$c8b284ba2f7ea5bc() {
    const sites = await $dea4808c67babfd0$var$getSearchSites();
    const siteMetadataList = sites.siteMetadata ?? [];
    const resourcesList = sites.resources ?? [];
    const rovoEnabledSitesMap = {};
    for(let i = 0; i < siteMetadataList.length; i++){
        const metadata = siteMetadataList[i];
        if (metadata.isRovoEnabled) rovoEnabledSitesMap[metadata.siteId] = {
            isRovoEnabled: true,
            orgId: metadata.orgId
        };
    }
    const rovoEnabledSites = new Map();
    for (const resource of resourcesList){
        const siteId = resource.id.split('/').pop() ?? '';
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (rovoEnabledSitesMap[siteId]?.isRovoEnabled) rovoEnabledSites.set(siteId, {
            cloudId: siteId,
            siteName: resource.siteName,
            baseUrl: resource.baseUrl,
            orgId: rovoEnabledSitesMap[siteId].orgId
        });
    }
    const metadata = {
        sitesFound: resourcesList.length,
        sitesWithRovoEnabled: rovoEnabledSites.size,
        rovoEnabledSitesMap: rovoEnabledSitesMap
    };
    if (!rovoEnabledSites.size) throw new Error("No sites returned from configuration endpoint \u2014 possible transient failure");
    return {
        results: Array.from(rovoEnabledSites.values()),
        metadata: metadata
    };
}
async function $dea4808c67babfd0$var$getSearchSites() {
    const url = '/gateway/api/xpsearch-aggregator/configuration/v1';
    const options = {
        method: 'GET',
        credentials: 'include'
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response;
}
function $dea4808c67babfd0$export$aa23cd1321ee74ce() {
    return (0, $hAXMW.useQuery)({
        queryKey: [
            'searchSiteResources'
        ],
        queryFn: ()=>$dea4808c67babfd0$var$getSearchSites(),
        staleTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        gcTime: $dea4808c67babfd0$var$oneHourInMs
    });
}
const $dea4808c67babfd0$export$66d5dd4be64dea43 = (cloudId, options)=>{
    return (0, $hAXMW.useQuery)({
        staleTime: 60000,
        // one minute
        ...options,
        queryFn: ()=>$dea4808c67babfd0$export$1486c04fa16d30fa(cloudId),
        queryKey: [
            'rovoEntitlement',
            cloudId
        ]
    });
};
async function $dea4808c67babfd0$export$1486c04fa16d30fa(cloudId) {
    const url = '/gateway/api/assist/rovo/v2/entitlement';
    const options = {
        method: 'GET',
        credentials: 'include',
        extraHeaders: new Headers({
            'X-Cloudid': cloudId
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response;
}
function $dea4808c67babfd0$export$355b5a80a2683ecb() {
    return (0, $hAXMW.useQuery)({
        queryKey: [
            $dea4808c67babfd0$export$b6542bdef08604ce
        ],
        queryFn: $dea4808c67babfd0$var$getUserAccount,
        retry: (retryAttempt, e)=>{
            if (e.errorType === (0, $9aNsE.RequestErrorType).AUTH_ERROR) return false;
            return retryAttempt < 3;
        },
        refetchOnWindowFocus: false,
        /* Persisted identity hydrates fast startup; always revalidate so stale identity is never
       trusted beyond the initial paint. */ staleTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        gcTime: $dea4808c67babfd0$var$oneDayInMs,
        refetchOnMount: 'always'
    });
}
async function $dea4808c67babfd0$var$getUserAccount() {
    const url = '/gateway/api/me';
    const options = {
        method: 'GET',
        credentials: 'include',
        extraHeaders: new Headers({
            Accept: 'application/json'
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    const userAccount = {
        accountId: response.account_id,
        email: response.email,
        name: response.name,
        nickname: response.nickname,
        picture: response.picture
    };
    if (!(0, $1ZAcM.isUserAccount)(userAccount)) {
        (0, $22hwD.logError)({
            error: new Error('Invalid user account data'),
            extra: {
                userAccount: userAccount
            }
        });
        throw new Error('Invalid user account data');
    }
    return userAccount;
}
function $dea4808c67babfd0$export$d0caa90bfa1dd141() {
    const url = '/gateway/api/session/heartbeat';
    const options = {
        method: 'POST',
        credentials: 'include',
        extraHeaders: new Headers({})
    };
    (0, $9aNsE.request)({
        url: url,
        options: options
    }).catch(()=>{});
}
async function $dea4808c67babfd0$var$get3PConnectors(cloudId) {
    const url = `/gateway/api/third-party-configuration/connected-data-sources/${cloudId}`;
    const options = {
        method: 'GET',
        credentials: 'include',
        extraHeaders: new Headers({
            'Content-Type': 'application/json',
            'X-Cloudid': cloudId
        })
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response;
}
function $dea4808c67babfd0$var$mergeOptimistic3pConnectors(data) {
    if (!data) return data;
    // Do not clear the overlay when we see isUserOAuthed here: that data may be our own
    // optimistic update.
    return data.map((connector)=>(0, $kwVgn.isOptimisticallyConnected)(connector.outboundAuthUrl) ? {
            ...connector,
            isUserOAuthed: true
        } : connector);
}
function $dea4808c67babfd0$export$546fbc853a926d44(cloudId) {
    return (0, $hAXMW.useQuery)({
        queryKey: [
            '3PConnectors',
            cloudId
        ],
        queryFn: ()=>$dea4808c67babfd0$var$get3PConnectors(cloudId),
        enabled: Boolean(cloudId),
        select: $dea4808c67babfd0$var$mergeOptimistic3pConnectors
    });
}
async function $dea4808c67babfd0$export$6a5a4d31a72d7723(orgId, cloudId, accountId) {
    const response = await (0, $9aNsE.request)({
        url: 'gateway/api/permissions/permitted',
        options: {
            method: 'POST',
            credentials: 'include',
            extraHeaders: new Headers({
                'Content-Type': 'application/json',
                'X-Cloudid': cloudId
            }),
            body: JSON.stringify({
                resourceId: `ari:cloud:platform::org/${orgId}`,
                principalId: `ari:cloud:identity::user/${accountId}`,
                permissionId: 'manage/org'
            })
        }
    });
    return response;
}
async function $dea4808c67babfd0$export$2a8816ad92ca751f(siteId, accountId, product) {
    const response = await (0, $9aNsE.request)({
        url: 'gateway/api/permissions/permitted',
        options: {
            method: 'POST',
            credentials: 'include',
            extraHeaders: new Headers({
                'Content-Type': 'application/json',
                'X-Cloudid': siteId
            }),
            body: JSON.stringify({
                resourceId: `ari:cloud:${product}::site/${siteId}`,
                principalId: `ari:cloud:identity::user/${accountId}`,
                permissionId: 'manage'
            })
        }
    });
    return response;
}
function $dea4808c67babfd0$export$f44446fc6da7bd74({ orgId: orgId, cloudId: cloudId, accountId: accountId }) {
    return (0, $hAXMW.useQuery)({
        queryKey: [
            'orgAdminAccess',
            orgId,
            accountId
        ],
        queryFn: ()=>$dea4808c67babfd0$export$6a5a4d31a72d7723(orgId, cloudId, accountId),
        staleTime: $dea4808c67babfd0$var$oneDayInMs,
        gcTime: $dea4808c67babfd0$var$oneDayInMs,
        enabled: Boolean(orgId)
    });
}
function $dea4808c67babfd0$export$4c22a3fb2ef39a6({ siteId: siteId, accountId: accountId, product: product = 'platform' }) {
    return (0, $hAXMW.useQuery)({
        queryKey: [
            'siteAdminAccess',
            siteId,
            accountId
        ],
        queryFn: ()=>$dea4808c67babfd0$export$2a8816ad92ca751f(siteId, accountId, product),
        staleTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        gcTime: $dea4808c67babfd0$var$fiveMinutesInMs,
        enabled: Boolean(siteId)
    });
}
const $dea4808c67babfd0$var$SETTINGS_ERROR_MESSAGES = {
    NETWORK_ERROR: 'Network connection failed',
    VALIDATION_ERROR: (context)=>`Invalid ${context} data`,
    SERVER_ERROR: 'Server error occurred',
    UNKNOWN_ERROR: 'Failed to save changes'
};
const $dea4808c67babfd0$var$getSettingsErrorType = (error)=>{
    if (error instanceof TypeError) // Network/connection errors (fetch failures, DNS issues, etc.)
    return (0, $1ZAcM.SettingsErrorType).NETWORK_ERROR;
    if (error && typeof error === 'object' && ('status' in error || 'statusCode' in error)) {
        // HTTP error with status code (check both status and statusCode for compatibility)
        const status = error.status ?? error.statusCode;
        if (status >= 400 && status < 500) return (0, $1ZAcM.SettingsErrorType).VALIDATION_ERROR;
        if (status >= 500) return (0, $1ZAcM.SettingsErrorType).SERVER_ERROR;
        return (0, $1ZAcM.SettingsErrorType).UNKNOWN_ERROR;
    }
    return (0, $1ZAcM.SettingsErrorType).UNKNOWN_ERROR;
};
const $dea4808c67babfd0$var$handleSaveSettingsError = (error, context)=>{
    const errorType = $dea4808c67babfd0$var$getSettingsErrorType(error);
    const errorKey = (0, $1ZAcM.SettingsErrorType)[errorType];
    const messageTemplate = $dea4808c67babfd0$var$SETTINGS_ERROR_MESSAGES[errorKey];
    const message = errorType === (0, $1ZAcM.SettingsErrorType).VALIDATION_ERROR ? messageTemplate(context) : messageTemplate;
    const settingsError = new $dea4808c67babfd0$export$8ef93724ecb8bcb7({
        errorMessage: message,
        code: errorType,
        errorType: (0, $9aNsE.RequestErrorType).OTHER_ERROR
    });
    throw settingsError;
};
const $dea4808c67babfd0$var$trackSettingsReadResult = (attributes)=>{
    (0, $dX6kP.analyticsClient).sendTrackEvent({
        action: 'completed',
        actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).SETTINGS_READ_RESULT,
        source: 'extensionFrontend',
        attributes: attributes
    }).catch((error)=>{
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to send settings read track event'
        });
    });
};
const $dea4808c67babfd0$var$trackSettingsMigrationResult = (attributes)=>{
    (0, $dX6kP.analyticsClient).sendTrackEvent({
        action: 'completed',
        actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).SETTINGS_MIGRATION_RESULT,
        source: 'extensionFrontend',
        attributes: attributes
    }).catch((error)=>{
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to send settings migration track event'
        });
    });
};
const $dea4808c67babfd0$var$getCompanyThemingAdminSettingsPayload = (data)=>({
        companyThemingFontColorLight: data.fontColorLight ?? '',
        companyThemingFontColorDark: data.fontColorDark ?? '',
        companyThemingNavbarColorLight: data.navbarColorLight ?? '',
        companyThemingNavbarColorDark: data.navbarColorDark ?? ''
    });
const $dea4808c67babfd0$var$toSiteSettingsReadSource = (readFromAdminSettings)=>readFromAdminSettings ? 'rovoextadminsettings' : 'legacy';
// Treat empty strings stored in the admin-settings namespace as "unset" so they
// map back to the `null` convention used by CompanyThemingSettingsData.
const $dea4808c67babfd0$var$adminSettingToThemingColor = (value)=>value ? value : null;
const $dea4808c67babfd0$var$getCompanyThemingSettingsFromAdminSettings = (adminSettings)=>({
        fontColorLight: $dea4808c67babfd0$var$adminSettingToThemingColor(adminSettings.companyThemingFontColorLight),
        fontColorDark: $dea4808c67babfd0$var$adminSettingToThemingColor(adminSettings.companyThemingFontColorDark),
        navbarColorLight: $dea4808c67babfd0$var$adminSettingToThemingColor(adminSettings.companyThemingNavbarColorLight),
        navbarColorDark: $dea4808c67babfd0$var$adminSettingToThemingColor(adminSettings.companyThemingNavbarColorDark)
    });
async function $dea4808c67babfd0$export$f59e5704f7811ae4(siteId) {
    // A user-facing settings read is the meaningful exposure point for the
    // data-migration experiment, so log exposure once here. The routing checks
    // below (and the nested admin-settings read) intentionally do not fire it.
    (0, $crLv5.exposeUserToSettingsDataMigrationExperiment)();
    // When the migration experiment is enabled, announcements are read exclusively
    // from the consolidated rovoextadminsettings source. No request is made to the
    // legacy rovo-extension-company-announcements setting. Read-result analytics for
    // this path are emitted by getRovoExtensionAdminSettings itself, so we do not
    // track again here to avoid double-counting events.
    if ((0, $crLv5.isSiteSettingsReadFromAdminSettings)()) {
        const adminSettings = await $dea4808c67babfd0$export$23fbf0ea178eddd2(siteId);
        return adminSettings.companyAnnouncements ?? [];
    }
    // Legacy read path — the analytics label is only needed from here on, and is
    // always 'legacy' since the admin-settings path returned above.
    const siteSettingsReadSource = 'legacy';
    const settingKey = 'rovo-extension-company-announcements';
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).GET,
        credentials: 'include',
        extraHeaders: new Headers({
            Accept: 'application/json',
            'X-CloudId': siteId
        })
    };
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        $dea4808c67babfd0$var$trackSettingsReadResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'success',
            operation: 'legacy_announcements_read'
        });
        return response.data.announcements ?? [];
    } catch (error) {
        $dea4808c67babfd0$var$trackSettingsReadResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'failure',
            operation: 'legacy_announcements_read',
            failureReason: 'api_read_failed'
        });
        throw error;
    }
}
async function $dea4808c67babfd0$export$46fc2e3ce5326cef(siteId, data) {
    const settingKey = 'rovo-extension-company-announcements';
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).PUT,
        credentials: 'include',
        extraHeaders: new Headers({
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CloudId': siteId
        }),
        body: JSON.stringify(data)
    };
    const siteSettingsReadSource = $dea4808c67babfd0$var$toSiteSettingsReadSource((0, $crLv5.isSiteSettingsReadFromAdminSettings)());
    let announcements;
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        announcements = response.data.announcements ?? [];
    } catch (error) {
        $dea4808c67babfd0$var$trackSettingsMigrationResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'failure',
            operation: 'announcement_double_write',
            failureReason: 'legacy_write_failed'
        });
        (0, $22hwD.logError)({
            error: error,
            impact: 'Settings migration: failed to save announcement settings to legacy namespace during double-write',
            tags: {
                siteSettingsReadSource: siteSettingsReadSource,
                settingsMigrationOperation: 'announcement_double_write',
                settingsMigrationFailureReason: 'legacy_write_failed'
            }
        });
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, 'announcement');
    }
    try {
        await $dea4808c67babfd0$var$saveRovoExtensionAdminSettingsRaw(siteId, {
            companyAnnouncements: data.announcements
        });
        $dea4808c67babfd0$var$trackSettingsMigrationResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'success',
            operation: 'announcement_double_write'
        });
        return announcements;
    } catch (error) {
        $dea4808c67babfd0$var$trackSettingsMigrationResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'failure',
            operation: 'announcement_double_write',
            failureReason: 'admin_settings_write_failed'
        });
        (0, $22hwD.logError)({
            error: error,
            impact: 'Settings migration: failed to save announcement settings to rovoextadminsettings during double-write',
            tags: {
                siteSettingsReadSource: siteSettingsReadSource,
                settingsMigrationOperation: 'announcement_double_write',
                settingsMigrationFailureReason: 'admin_settings_write_failed'
            }
        });
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, 'announcement');
    }
}
async function $dea4808c67babfd0$export$ba27034f167f88dc(siteId) {
    // A user-facing settings read is the meaningful exposure point for the
    // data-migration experiment, so log exposure once here. The routing checks
    // below (and the nested admin-settings read) intentionally do not fire it.
    (0, $crLv5.exposeUserToSettingsDataMigrationExperiment)();
    // When the migration experiment is enabled, theming is read exclusively from
    // the consolidated rovoextadminsettings source. No request is made to the
    // legacy rovo-extension-company-theming setting. Read-result analytics for this
    // path are emitted by getRovoExtensionAdminSettings itself, so we do not track
    // again here to avoid double-counting events.
    if ((0, $crLv5.isSiteSettingsReadFromAdminSettings)()) {
        const adminSettings = await $dea4808c67babfd0$export$23fbf0ea178eddd2(siteId);
        return $dea4808c67babfd0$var$getCompanyThemingSettingsFromAdminSettings(adminSettings);
    }
    // Legacy read path — the analytics label is only needed from here on, and is
    // always 'legacy' since the admin-settings path returned above.
    const siteSettingsReadSource = 'legacy';
    const defaultCompanyThemingSettings = {
        fontColorLight: null,
        fontColorDark: null,
        navbarColorLight: null,
        navbarColorDark: null
    };
    const settingKey = 'rovo-extension-company-theming';
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).GET,
        credentials: 'include',
        extraHeaders: new Headers({
            Accept: 'application/json',
            'X-CloudId': siteId
        })
    };
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        $dea4808c67babfd0$var$trackSettingsReadResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'success',
            operation: 'legacy_theming_read'
        });
        return response.data ?? defaultCompanyThemingSettings;
    } catch (error) {
        $dea4808c67babfd0$var$trackSettingsReadResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'failure',
            operation: 'legacy_theming_read',
            failureReason: 'api_read_failed'
        });
        throw error;
    }
}
async function $dea4808c67babfd0$export$96dd258aa592820(siteId, data) {
    const settingKey = 'rovo-extension-company-theming';
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).PUT,
        credentials: 'include',
        extraHeaders: new Headers({
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CloudId': siteId
        }),
        body: JSON.stringify(data)
    };
    const siteSettingsReadSource = $dea4808c67babfd0$var$toSiteSettingsReadSource((0, $crLv5.isSiteSettingsReadFromAdminSettings)());
    let legacyThemingSettings;
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        legacyThemingSettings = response.data;
    } catch (error) {
        $dea4808c67babfd0$var$trackSettingsMigrationResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'failure',
            operation: 'theming_double_write',
            failureReason: 'legacy_write_failed'
        });
        (0, $22hwD.logError)({
            error: error,
            impact: 'Settings migration: failed to save company theming settings to legacy namespace during double-write',
            tags: {
                siteSettingsReadSource: siteSettingsReadSource,
                settingsMigrationOperation: 'theming_double_write',
                settingsMigrationFailureReason: 'legacy_write_failed'
            }
        });
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, 'company theme');
    }
    try {
        await $dea4808c67babfd0$var$saveRovoExtensionAdminSettingsRaw(siteId, $dea4808c67babfd0$var$getCompanyThemingAdminSettingsPayload(legacyThemingSettings));
        $dea4808c67babfd0$var$trackSettingsMigrationResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'success',
            operation: 'theming_double_write'
        });
        return legacyThemingSettings;
    } catch (error) {
        $dea4808c67babfd0$var$trackSettingsMigrationResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'failure',
            operation: 'theming_double_write',
            failureReason: 'admin_settings_write_failed'
        });
        (0, $22hwD.logError)({
            error: error,
            impact: 'Settings migration: failed to save company theming settings to rovoextadminsettings during double-write',
            tags: {
                siteSettingsReadSource: siteSettingsReadSource,
                settingsMigrationOperation: 'theming_double_write',
                settingsMigrationFailureReason: 'admin_settings_write_failed'
            }
        });
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, 'company theme');
    }
}
async function $dea4808c67babfd0$export$6d8018625f2049f7(siteId) {
    const response = await (0, $9aNsE.request)({
        url: 'gateway/api/assist/rovo/v1/extension/media/token',
        options: {
            method: (0, $9aNsE.HTTPMethod).POST,
            credentials: 'include',
            extraHeaders: new Headers({
                'X-Product': 'rovo',
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': siteId,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                collection: 'rovo-extension'
            })
        }
    });
    return response;
}
async function $dea4808c67babfd0$export$23fbf0ea178eddd2(siteId) {
    const settingKey = 'rovoextadminsettings';
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).GET,
        credentials: 'include',
        extraHeaders: new Headers({
            Accept: 'application/json',
            'X-CloudId': siteId
        })
    };
    const siteSettingsReadSource = $dea4808c67babfd0$var$toSiteSettingsReadSource((0, $crLv5.isSiteSettingsReadFromAdminSettings)());
    try {
        const response = await (0, $9aNsE.request)({
            url: url,
            options: options
        });
        $dea4808c67babfd0$var$trackSettingsReadResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'success',
            operation: 'rovoextadminsettings_read'
        });
        return response.data ?? {};
    } catch (error) {
        $dea4808c67babfd0$var$trackSettingsReadResult({
            siteSettingsReadSource: siteSettingsReadSource,
            status: 'failure',
            operation: 'rovoextadminsettings_read',
            failureReason: 'api_read_failed'
        });
        throw error;
    }
}
async function $dea4808c67babfd0$var$saveRovoExtensionAdminSettingsRaw(siteId, data) {
    const settingKey = 'rovoextadminsettings';
    const encodedResourceAri = encodeURIComponent(`ari:cloud:rovo::site/${siteId}`);
    const url = `/gateway/api/rovo-extension-web/resource/${encodedResourceAri}/setting/${settingKey}`;
    const options = {
        method: (0, $9aNsE.HTTPMethod).PUT,
        credentials: 'include',
        extraHeaders: new Headers({
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CloudId': siteId
        }),
        body: JSON.stringify(data)
    };
    const response = await (0, $9aNsE.request)({
        url: url,
        options: options
    });
    return response.data;
}
async function $dea4808c67babfd0$export$8eaf99e03c8b850a(siteId, data) {
    try {
        return await $dea4808c67babfd0$var$saveRovoExtensionAdminSettingsRaw(siteId, data);
    } catch (error) {
        return $dea4808c67babfd0$var$handleSaveSettingsError(error, 'admin settings');
    }
}

});
parcelRegister("lsxLV", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_PLATFORM_ANALYTICS", () => $7c29402520d56d84$export$c2b2aecd22d35334);
$parcel$export(module.exports, "ANALYTICS_SCREEN_NAMES", () => $7c29402520d56d84$export$4add0c56ef03fe82);
$parcel$export(module.exports, "ANALYTICS_UI_SUBJECTS", () => $7c29402520d56d84$export$dcf9e0440080ae77);
$parcel$export(module.exports, "ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS", () => $7c29402520d56d84$export$9fc73ca44f63e3f4);
$parcel$export(module.exports, "ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS", () => $7c29402520d56d84$export$7157f0775e2fcec3);
var $7c29402520d56d84$export$c2b2aecd22d35334 = /*#__PURE__*/ function(ROVO_EXTENSION_PLATFORM_ANALYTICS) {
    ROVO_EXTENSION_PLATFORM_ANALYTICS["CHANNEL"] = "rovo-extension";
    ROVO_EXTENSION_PLATFORM_ANALYTICS["PRODUCT"] = "rovoExtension";
    return ROVO_EXTENSION_PLATFORM_ANALYTICS;
}({});
var $7c29402520d56d84$export$4add0c56ef03fe82 = /*#__PURE__*/ function(ANALYTICS_SCREEN_NAMES) {
    ANALYTICS_SCREEN_NAMES["EXTENSION_HOME_SCREEN"] = "extensionHomePage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_OPTIONS_SCREEN"] = "extensionOptionsPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NTP_LOGIN_SCREEN"] = "extensionNtpLogInPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_CHAT_LOGIN_SCREEN"] = "extensionChatLogInPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NEW_WELCOME_SCREEN"] = "extensionNewWelcomePage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_AUTO_LOGIN_SCREEN"] = "extensionAutoLoginScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_REDIRECT_TO_IDENTITY_SCREEN"] = "extensionRedirectToIdentityScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_AFTER_LOGIN_REDIRECT"] = "extensionAfterLoginRedirectScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_AFTER_LOGOUT_REDIRECT"] = "extensionAfterLogoutRedirectScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_CHAT_SCREEN"] = "extensionChatPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_POPUP_SCREEN"] = "extensionPopupPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_UNINSTALL_SCREEN"] = "extensionUninstallPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_ADMIN_OPTIONS_SCREEN"] = "extensionAdminOptionsScreen";
    ANALYTICS_SCREEN_NAMES["EXTENSION_WHATS_NEW_SCREEN"] = "extensionWhatsNewPage";
    ANALYTICS_SCREEN_NAMES["EXTENSION_CALENDAR_USER_AUTH_VIEW"] = "extensionCalendarUserAuthView";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NO_ROVO_VIEW"] = "extensionNoRovoView";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NO_SITE_VIEW"] = "extensionNoSiteView";
    ANALYTICS_SCREEN_NAMES["EXTENSION_ANNOUNCEMENT_VIEW"] = "extensionAnnouncementView";
    ANALYTICS_SCREEN_NAMES["EXTENSION_NOTIFICATIONS_DRAWER"] = "extensionNotificationsDrawer";
    return ANALYTICS_SCREEN_NAMES;
}({});
var $7c29402520d56d84$export$dcf9e0440080ae77 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECTS) {
    ANALYTICS_UI_SUBJECTS["EXTENSION_CHAT_SEARCH_BAR"] = "extensionChatSearchBar";
    ANALYTICS_UI_SUBJECTS["EXTENSION_QUICK_FIND_SEARCH_BAR"] = "extensionQuickFindSearchBar";
    ANALYTICS_UI_SUBJECTS["EXTENSION_SEARCH_BAR_HOTKEY"] = "extensionSearchBarHotkey";
    ANALYTICS_UI_SUBJECTS["HOME_PAGE_CHAT_BUTTON"] = "homePageChatButton";
    ANALYTICS_UI_SUBJECTS["EXTENSION_LOGIN"] = "extensionLogIn";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_ITEM"] = "shortcutsItem";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_ADD_BUTTON"] = "shortcutsAddButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS"] = "shortcuts";
    ANALYTICS_UI_SUBJECTS["NAV_BAR_CHAT_BUTTON"] = "navBarChatButton";
    ANALYTICS_UI_SUBJECTS["NAV_BAR_LOGO"] = "navBarLogo";
    ANALYTICS_UI_SUBJECTS["SITE_SELECTOR"] = "siteSelector";
    ANALYTICS_UI_SUBJECTS["FEEDBACK_BUTTON"] = "feedbackButton";
    ANALYTICS_UI_SUBJECTS["FEEDBACK_COLLECTOR"] = "feedbackCollector";
    ANALYTICS_UI_SUBJECTS["CHROME_APP_SHORTCUT"] = "chromeAppShortcut";
    ANALYTICS_UI_SUBJECTS["BOOKMARK"] = "bookmark";
    ANALYTICS_UI_SUBJECTS["DROPDOWN_BOOKMARK"] = "dropdownBookmark";
    ANALYTICS_UI_SUBJECTS["BOOKMARK_MANAGER_BUTTON"] = "bookmarkManagerButton";
    ANALYTICS_UI_SUBJECTS["BOOKMARKS_BAR_CLOSE_BUTTON"] = "bookmarksBarCloseButton";
    ANALYTICS_UI_SUBJECTS["APP_SWITCHER_BUTTON"] = "appSwitcherButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_CONFIG_MENU"] = "shortcutsConfigMenu";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_CONFIG_MENU_OPTION"] = "shortcutsConfigMenuOption";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_CONFIG_MENU_SAVE_BUTTON"] = "shortcutsConfigMenuSaveButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_EDIT_OPTIONS_MENU"] = "shortcutsEditOptionsMenu";
    ANALYTICS_UI_SUBJECTS["SHORTCUTS_EDIT_LINK_BUTTON"] = "shortcutsEditLinkButton";
    ANALYTICS_UI_SUBJECTS["SHORTCUT_ITEM_EDIT_MODAL"] = "shortcutItemEditModal";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_YES_BUTTON"] = "pluginFeedbackYesButton";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_NO_BUTTON"] = "pluginFeedbackNoButton";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_REVIEW_CONFIRM_BUTTON"] = "pluginFeedbackReviewConfirmButton";
    ANALYTICS_UI_SUBJECTS["PLUGIN_FEEDBACK_REVIEW_DISMISS_BUTTON"] = "pluginFeedbackReviewDismissButton";
    ANALYTICS_UI_SUBJECTS["LOGIN_BUTTON"] = "loginButton";
    ANALYTICS_UI_SUBJECTS["ANNOUNCEMENT_BANNER"] = "announcementBanner";
    ANALYTICS_UI_SUBJECTS["ROVO_CHAT_TAB"] = "rovoChatTab";
    ANALYTICS_UI_SUBJECTS["ROVO_SEARCH_TAB"] = "rovoSearchTab";
    ANALYTICS_UI_SUBJECTS["ROVO_GOOGLE_TAB"] = "rovoGoogleTab";
    ANALYTICS_UI_SUBJECTS["DEFAULT_SEARCH_TAB_OPTION"] = "defaultSearchTabUserOption";
    ANALYTICS_UI_SUBJECTS["RECENT_WORK_ROW"] = "recentWorkRow";
    ANALYTICS_UI_SUBJECTS["RECENT_WORK_DISMISS_BUTTON"] = "recentWorkDismissButton";
    ANALYTICS_UI_SUBJECTS["GLOBAL_CREATE_BUTTON"] = "globalCreateButton";
    ANALYTICS_UI_SUBJECTS["GLOBAL_CREATE_ITEM"] = "globalCreateItem";
    ANALYTICS_UI_SUBJECTS["OPEN_MENU_TAB_BUTTON"] = "openMenuTabButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_DISMISS_BUTTON"] = "calendarDismissButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_JOIN_MEETING_BUTTON"] = "calendarJoinMeetingButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_VIEW_MEETING_BUTTON"] = "calendarViewMeetingButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_DATE_PICKER"] = "calendarDatePicker";
    ANALYTICS_UI_SUBJECTS["CALENDAR_DATE_CHEVRON_BUTTON"] = "calendarDateChevronButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_SHOW_MORE_BUTTON"] = "calendarShowMoreButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_CONNECT_BUTTON"] = "calendarConnectButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_ADMIN_CONNECT_BUTTON"] = "calendarAdminConnectButton";
    ANALYTICS_UI_SUBJECTS["CALENDAR_EVENT_CARD"] = "calendarEventCard";
    ANALYTICS_UI_SUBJECTS["UNINSTALL_SURVEY"] = "uninstallSurvey";
    ANALYTICS_UI_SUBJECTS["NTP_CALENDAR_OPTION"] = "ntpCalendarOption";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_UPLOAD_BACKGROUND_BUTTON"] = "adminOptionsUploadBackgroundButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_REMOVE_BACKGROUND_BUTTON"] = "adminOptionsRemoveBackgroundButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_FILE_SELECTOR"] = "adminOptionsBackgroundFileSelector";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_UPLOAD_LOGO_BUTTON"] = "adminOptionsUploadLogoButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_REMOVE_LOGO_BUTTON"] = "adminOptionsRemoveLogoButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_LOGO_FILE_SELECTOR"] = "adminOptionsLogoFileSelector";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_CUSTOMIZE_LOGO_BEHAVIOR_BUTTON"] = "adminOptionsCustomizeLogoBehaviorButton";
    ANALYTICS_UI_SUBJECTS["ADMIN_OPTIONS_SITE_SELECTOR"] = "adminOptionsSiteSelector";
    ANALYTICS_UI_SUBJECTS["VIEW_PROFILE_BUTTON"] = "viewProfileButton";
    ANALYTICS_UI_SUBJECTS["WELCOME_PAGE_FEATURE_BUTTON"] = "welcomePageFeatureButton";
    ANALYTICS_UI_SUBJECTS["NEW_WELCOME_PAGE_CONTINUE_WITH_ROVO"] = "newWelcomePageContinueWithRovo";
    ANALYTICS_UI_SUBJECTS["NEW_WELCOME_PAGE_USE_DEFAULT_NEW_TAB"] = "newWelcomePageUseDefaultNewTab";
    ANALYTICS_UI_SUBJECTS["NEW_WELCOME_PAGE_GET_STARTED"] = "newWelcomePageGetStarted";
    ANALYTICS_UI_SUBJECTS["ADD_NEW_ANNOUNCEMENT_BUTTON"] = "addNewAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["DELETE_ANNOUNCEMENT_BUTTON"] = "deleteAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["SAVE_ANNOUNCEMENT_BUTTON"] = "saveAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["MANAGE_ANNOUNCEMENTS"] = "manageAnnouncements";
    ANALYTICS_UI_SUBJECTS["HIDE_ANNOUNCEMENTS_BUTTON"] = "hideAnnouncementButton";
    ANALYTICS_UI_SUBJECTS["ANNOUNCEMENT_VIEW_WINDOW"] = "announcementViewWindow";
    ANALYTICS_UI_SUBJECTS["ANNOUNCEMENT_TOGGLE_BUTTON"] = "announcementToggleButton";
    ANALYTICS_UI_SUBJECTS["CONNECTOR_ICON_BUTTON"] = "connectorIconButton";
    ANALYTICS_UI_SUBJECTS["CONNECTOR_DROPDOWN"] = "connectorDropdown";
    ANALYTICS_UI_SUBJECTS["CONNECTOR_DROPDOWN_CONNECT"] = "connectorDropdownConnect";
    ANALYTICS_UI_SUBJECTS["SETTING_TOGGLE"] = "settingToggle";
    ANALYTICS_UI_SUBJECTS["SETTING_PIN_EXTENSION_BUTTON"] = "settingPinExtensionButton";
    ANALYTICS_UI_SUBJECTS["SETTINGS_NAVIGATION_SECTION"] = "settingsNavigationSection";
    ANALYTICS_UI_SUBJECTS["NTP_AGENT_MENU"] = "ntpAgentMenu";
    ANALYTICS_UI_SUBJECTS["NTP_AGENT_MENU_OPTION"] = "ntpAgentMenuOption";
    ANALYTICS_UI_SUBJECTS["NTP_BROWSE_AGENTS_MODAL"] = "ntpBrowseAgentsModal";
    ANALYTICS_UI_SUBJECTS["NOTIFICATIONS_BUTTON"] = "notificationsButton";
    return ANALYTICS_UI_SUBJECTS;
}({});
var $7c29402520d56d84$export$9fc73ca44f63e3f4 = /*#__PURE__*/ function(ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS) {
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["LOGIN"] = "login";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["LOGOUT"] = "logout";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_UPLOAD"] = "adminOptionsBackgroundUpload";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_REPLACE"] = "adminOptionsBackgroundReplace";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_BACKGROUND_DELETE"] = "adminOptionsBackgroundDelete";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_DELETE"] = "adminOptionsLogoDelete";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_UPLOAD"] = "adminOptionsLogoUpload";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_REPLACE"] = "adminOptionsLogoReplace";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ADMIN_OPTIONS_LOGO_BEHAVIOR"] = "adminOptionsLogoBehavior";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_MEETING_JOIN"] = "calendarMeetingJoin";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_MEETING_VIEW"] = "calendarMeetingView";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_PICKER_NAVIGATE"] = "calendarPickerNavigate";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CALENDAR_OAUTH"] = "calendarOAuth";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["RECENT_WORK_ROW"] = "recentWorkRow";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["SHORTCUTS_ITEM"] = "shortcutsItem";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["BOOKMARK"] = "bookmark";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["BOOKMARKS_BAR"] = "bookmarksBar";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["BOOKMARK_MANAGER"] = "bookmarkManager";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CHROME_APPS"] = "chromeApps";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["WHATS_NEW"] = "whatsNew";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CHAT_SIDEPANEL"] = "chatSidepanel";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["OPEN_OPTIONS"] = "openOptions";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["TOP_BAR"] = "topBar";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["PROFILE_CARD"] = "profileCard";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["PROFILE_PAGE"] = "profilePage";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["THEME"] = "theme";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ROVO_EXTENSION_FRONTEND"] = "rovoExtensionFrontend";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["UPDATE_ANNOUNCEMENT"] = "updateAnnouncement";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["UPDATE_ANNOUNCEMENT_FAILED"] = "updateAnnouncementFailed";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ANNOUNCEMENT_IMAGE"] = "announcementImage";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["ANNOUNCEMENT_LOADED"] = "announcementLoaded";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CUSTOM_FONT_COLOR"] = "customFontColor";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["CUSTOM_NAVBAR_COLOR"] = "customNavbarColor";
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["WELCOME_POPOVER"] = "welcomePopover";
    // Data Portal registry: https://data-portal.internal.atlassian.com/analytics/registry/102373?tabIndex=Attributes
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["SETTINGS_MIGRATION_RESULT"] = "rovoExtSettingsMigrationResult";
    // Data Portal registry: https://data-portal.internal.atlassian.com/analytics/registry/103524
    ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS["SETTINGS_READ_RESULT"] = "rovoExtSettingsReadResult";
    return ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS;
}({});
var $7c29402520d56d84$export$7157f0775e2fcec3 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS) {
    ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS["FG_CLIENT_INITIALIZATION"] = "featureGatesClientInitialization";
    return ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS;
}({});

});

parcelRegister("crLv5", function(module, exports) {
$parcel$export(module.exports, "activeExperiments", () => $f13eaaa8c1382374$export$4b4e5a3c4cd2ff2);
$parcel$export(module.exports, "isNtpSearchFiltersEnabled", () => $f13eaaa8c1382374$export$a188f9ad759dcff4);
$parcel$export(module.exports, "isNtpSearchFilters3pConnectorsEnabled", () => $f13eaaa8c1382374$export$7f9b7a8ac013bc30);
$parcel$export(module.exports, "getNtpAgentsDropdownTreatment", () => $f13eaaa8c1382374$export$4113791eea1b8db6);
$parcel$export(module.exports, "isDefaultToCustomLinksEnabled", () => $f13eaaa8c1382374$export$d904fdccf7c63330);
$parcel$export(module.exports, "isSessionReplayEnabled", () => $f13eaaa8c1382374$export$51b3294dcd067697);
$parcel$export(module.exports, "isNtpNotificationsBellEnabled", () => $f13eaaa8c1382374$export$61f978fc5ad9fc21);
$parcel$export(module.exports, "isGoogleSearchToggleEnabled", () => $f13eaaa8c1382374$export$76bca765bb507b22);
$parcel$export(module.exports, "getAllRovoContextMenuVariants", () => $f13eaaa8c1382374$export$7f7b346391a67c63);
$parcel$export(module.exports, "deriveIsRovoContextMenuHighlightFabEnabled", () => $f13eaaa8c1382374$export$535a2c95a81e4dba);
$parcel$export(module.exports, "deriveIsRovoContextMenuRightClickFabEnabled", () => $f13eaaa8c1382374$export$d286ebb8403cba69);
$parcel$export(module.exports, "deriveIsRovoContextMenuSearchInSidePanelEnabled", () => $f13eaaa8c1382374$export$5df7871898917ffa);
$parcel$export(module.exports, "deriveIsRovoContextMenuSearchFullPageEnabled", () => $f13eaaa8c1382374$export$96fbf3e28a016ec1);
$parcel$export(module.exports, "deriveIsRovoContextMenuEnabled", () => $f13eaaa8c1382374$export$dc9e3a066a3d6d9a);
$parcel$export(module.exports, "isSiteSettingsReadFromAdminSettings", () => $f13eaaa8c1382374$export$6df582301d0cf7a);
$parcel$export(module.exports, "exposeUserToSettingsDataMigrationExperiment", () => $f13eaaa8c1382374$export$329887f0fe02a82b);
$parcel$export(module.exports, "isNtpDefaultChatEnabled", () => $f13eaaa8c1382374$export$2f3df4b812f0cb41);

var $4d1Vr = parcelRequire("4d1Vr");

var $TrAR1 = parcelRequire("TrAR1");

var $LpV4F = parcelRequire("LpV4F");
var $f13eaaa8c1382374$export$c53b54969232d4cd = /*#__PURE__*/ function(EXPERIMENTS) {
    EXPERIMENTS["NTP_SEARCH_FILTERS"] = "ntp_search_filters";
    EXPERIMENTS["NTP_SEARCH_FILTERS_3P_CONNECTORS"] = "ntp_search_filters_3p_connectors";
    EXPERIMENTS["NTP_AGENTS_DROPDOWN"] = "rovo_extension_ntp_agents_dropdown";
    EXPERIMENTS["DEFAULT_TO_CUSTOM_LINKS"] = "rovo_extension_default_to_custom_links";
    EXPERIMENTS["NTP_NOTIFICATIONS_BELL"] = "rovo-extension-ntp-notifications-bell";
    EXPERIMENTS["GOOGLE_SEARCH_TOGGLE"] = "rovo_extension_google_search_toggle";
    EXPERIMENTS["ROVO_CONTEXT_MENU_HIGHLIGHT_ENTRY"] = "rovo-ext_pcm_highlight_entry";
    EXPERIMENTS["ROVO_CONTEXT_MENU_SEARCH_BEHAVIOR"] = "rovo-ext_pcm_search_behavior";
    EXPERIMENTS["SETTINGS_DATA_MIGRATION"] = "rovo-ext_settings_data_migration";
    EXPERIMENTS["NTP_DEFAULT_CHAT_INPUT"] = "rovo-extension-ntp-default-chat-input";
    return EXPERIMENTS;
}({});
var $f13eaaa8c1382374$export$24702c30ff8e6bf1 = /*#__PURE__*/ function(PARAMETERS) {
    PARAMETERS["cohort"] = "cohort";
    PARAMETERS["isEnabled"] = "enabled";
    PARAMETERS["isNtpSearchFiltersEnabled"] = "is_search_filters_enabled";
    PARAMETERS["is3pConnectorEnabled"] = "is3pConnectorEnabled";
    PARAMETERS["ntpAgentsDropdownTreatment"] = "treatment";
    PARAMETERS["isSettingsUiRevampEnabled"] = "is_settings_ui_revamp_enabled";
    PARAMETERS["isDefaultToCustomLinksEnabled"] = "isEnabled";
    PARAMETERS["isNotificationsEnabled"] = "notificationsEnabled";
    PARAMETERS["isGoogleSearchToggleEnabled"] = "isEnabled";
    PARAMETERS["variant"] = "variant";
    PARAMETERS["siteSettingsReadSource"] = "siteSettingsReadSource";
    PARAMETERS["isDefaultChatEnabled"] = "isDefaultChatEnabled";
    return PARAMETERS;
}({});
const $f13eaaa8c1382374$export$4b4e5a3c4cd2ff2 = [
    {
        experimentName: "ntp_search_filters",
        parameterName: "is_search_filters_enabled"
    },
    {
        experimentName: "ntp_search_filters_3p_connectors",
        parameterName: "is3pConnectorEnabled"
    },
    {
        experimentName: "rovo_extension_ntp_agents_dropdown",
        parameterName: "treatment"
    },
    {
        experimentName: "rovo_extension_default_to_custom_links",
        parameterName: "isEnabled"
    },
    {
        experimentName: "rovo-extension-ntp-notifications-bell",
        parameterName: "notificationsEnabled"
    },
    {
        experimentName: "rovo_extension_google_search_toggle",
        parameterName: "isEnabled"
    },
    {
        experimentName: "rovo-ext_pcm_highlight_entry",
        parameterName: "variant"
    },
    {
        experimentName: "rovo-ext_pcm_search_behavior",
        parameterName: "variant"
    },
    {
        experimentName: "rovo-ext_settings_data_migration",
        parameterName: "siteSettingsReadSource"
    },
    {
        experimentName: "rovo-extension-ntp-default-chat-input",
        parameterName: "isDefaultChatEnabled"
    }
];
const $f13eaaa8c1382374$export$a188f9ad759dcff4 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "ntp_search_filters",
        parameterName: "is_search_filters_enabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$7f9b7a8ac013bc30 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "ntp_search_filters_3p_connectors",
        parameterName: "is3pConnectorEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$4113791eea1b8db6 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo_extension_ntp_agents_dropdown",
        parameterName: "treatment",
        defaultValue: 'control'
    });
};
const $f13eaaa8c1382374$export$d904fdccf7c63330 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo_extension_default_to_custom_links",
        parameterName: "isEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$51b3294dcd067697 = ()=>{
    return (0, $4d1Vr.default).checkGate((0, $TrAR1.STATSIG_FEATURE_GATES).SESSION_REPLAY);
};
const $f13eaaa8c1382374$export$61f978fc5ad9fc21 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-extension-ntp-notifications-bell",
        parameterName: "notificationsEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$76bca765bb507b22 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo_extension_google_search_toggle",
        parameterName: "isEnabled",
        defaultValue: false
    });
};
const $f13eaaa8c1382374$export$c8f036f7e28da0c0 = ()=>{
    return (0, $4d1Vr.default).checkGate((0, $TrAR1.STATSIG_FEATURE_GATES).CONSENT);
};
const $f13eaaa8c1382374$var$isRovoContextMenuHighlightEntryVariant = (value)=>value === 'control' || value === 'A' || value === 'B';
const $f13eaaa8c1382374$var$isRovoContextMenuSearchBehaviorVariant = (value)=>value === 'control' || value === 'A' || value === 'B';
const $f13eaaa8c1382374$export$36440f3884735227 = ()=>{
    const value = (0, $LpV4F.getExperiment)({
        experimentName: "rovo-ext_pcm_highlight_entry",
        parameterName: "variant",
        defaultValue: 'control'
    });
    return $f13eaaa8c1382374$var$isRovoContextMenuHighlightEntryVariant(value) ? value : 'control';
};
const $f13eaaa8c1382374$export$b2cfeb9948acae1f = ()=>{
    const value = (0, $LpV4F.getExperiment)({
        experimentName: "rovo-ext_pcm_search_behavior",
        parameterName: "variant",
        defaultValue: 'control'
    });
    return $f13eaaa8c1382374$var$isRovoContextMenuSearchBehaviorVariant(value) ? value : 'control';
};
const $f13eaaa8c1382374$export$7f7b346391a67c63 = ()=>({
        highlightEntry: $f13eaaa8c1382374$export$36440f3884735227(),
        searchBehavior: $f13eaaa8c1382374$export$b2cfeb9948acae1f()
    });
const $f13eaaa8c1382374$export$535a2c95a81e4dba = (variant)=>variant === 'A' || variant === 'B';
const $f13eaaa8c1382374$export$d286ebb8403cba69 = (variant)=>variant === 'B';
const $f13eaaa8c1382374$export$5df7871898917ffa = (variant)=>variant === 'A';
const $f13eaaa8c1382374$export$96fbf3e28a016ec1 = (variant)=>variant === 'B';
const $f13eaaa8c1382374$export$dc9e3a066a3d6d9a = (highlightEntry, searchBehavior)=>highlightEntry !== 'control' || searchBehavior !== 'control';
const $f13eaaa8c1382374$export$ff92ea107831deb3 = ()=>$f13eaaa8c1382374$export$535a2c95a81e4dba($f13eaaa8c1382374$export$36440f3884735227());
const $f13eaaa8c1382374$export$cdb3881a7fc2e468 = ()=>$f13eaaa8c1382374$export$d286ebb8403cba69($f13eaaa8c1382374$export$36440f3884735227());
const $f13eaaa8c1382374$export$d1f9af39de29756 = ()=>$f13eaaa8c1382374$export$5df7871898917ffa($f13eaaa8c1382374$export$b2cfeb9948acae1f());
const $f13eaaa8c1382374$export$358c345f88d462cb = ()=>$f13eaaa8c1382374$export$96fbf3e28a016ec1($f13eaaa8c1382374$export$b2cfeb9948acae1f());
const $f13eaaa8c1382374$export$b0dc46fa9c546db6 = ()=>{
    const { highlightEntry: highlightEntry, searchBehavior: searchBehavior } = $f13eaaa8c1382374$export$7f7b346391a67c63();
    return $f13eaaa8c1382374$export$dc9e3a066a3d6d9a(highlightEntry, searchBehavior);
};
const $f13eaaa8c1382374$export$6df582301d0cf7a = ()=>{
    const readSource = (0, $LpV4F.getExperimentNoExposure)({
        experimentName: "rovo-ext_settings_data_migration",
        parameterName: "siteSettingsReadSource",
        defaultValue: 'legacy'
    });
    return readSource === 'rovoextadminsettings';
};
// Guards against firing more than one exposure for the settings data-migration
// experiment per page/session. A single settings page commonly reads both
// announcements and theming, and each read is a legitimate exposure point, so we
// dedupe here rather than trying to pick a single "owning" read.
let $f13eaaa8c1382374$var$hasLoggedSettingsDataMigrationExposure = false;
const $f13eaaa8c1382374$export$329887f0fe02a82b = ()=>{
    if ($f13eaaa8c1382374$var$hasLoggedSettingsDataMigrationExposure) return;
    $f13eaaa8c1382374$var$hasLoggedSettingsDataMigrationExposure = true;
    (0, $LpV4F.manuallyLogExposure)("rovo-ext_settings_data_migration");
};
const $f13eaaa8c1382374$export$2f3df4b812f0cb41 = ()=>{
    return (0, $LpV4F.getExperiment)({
        experimentName: "rovo-extension-ntp-default-chat-input",
        parameterName: "isDefaultChatEnabled",
        defaultValue: false
    });
};

});
parcelRegister("TrAR1", function(module, exports) {
$parcel$export(module.exports, "STATSIG_FEATURE_GATES", () => $dd638642df7d5f32$export$1a1480a7981d844f);
$parcel$export(module.exports, "STATSIG_DYNAMIC_CONFIGS", () => $dd638642df7d5f32$export$c5d819d8db6dd067);
var $dd638642df7d5f32$export$1a1480a7981d844f = /*#__PURE__*/ function(STATSIG_FEATURE_GATES) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/rovo-ext_announcement_banner_enabled
    // FG for toggling announcement banner. Please don't remove it.
    STATSIG_FEATURE_GATES["ANNOUNCEMENT_BANNER_ENABLED"] = "rovo-ext_announcement_banner_enabled";
    // https://switcheroo.atlassian.com/ui/gates/558015fa-530c-4edd-9680-73da3160e8bf/key/rovo-ext_bannerman_enabled
    // FG for toggling Bannerman dynamic banner system. Please don't remove it.
    STATSIG_FEATURE_GATES["BANNERMAN_ENABLED"] = "rovo-ext_bannerman_enabled";
    // https://switcheroo.atlassian.com/ui/gates/cdebb45e-466d-4e00-8dc8-c8b914ba27f3/key/rovo-ext_ntp_calendar_widget_enabled
    STATSIG_FEATURE_GATES["NTP_CALENDAR_WIDGET_ENABLED"] = "rovo-ext_ntp_calendar_widget_enabled";
    // https://switcheroo.atlassian.com/ui/gates/43c7705c-5d94-4fbd-99cb-cc02861da827/key/rovo-ext-feature-gate-by-extension-version
    STATSIG_FEATURE_GATES["FEATURE_GATE_BY_EXTENSION_VERSION"] = "rovo-ext-feature-gate-by-extension-version";
    // https://switcheroo.atlassian.com/ui/gates/ff6bc152-83cf-429c-bd05-1df4a24d8d5f/key/hide_rovo_extension_ntp_welcome_header
    STATSIG_FEATURE_GATES["SHOW_ROVO_EXTENSION_NTP_WELCOME_HEADER"] = "hide_rovo_extension_ntp_welcome_header";
    // https://switcheroo.atlassian.com/ui/gates/d10cc0f3-f68b-436b-93d5-7f40ecfcd670/key/rovo_extension_safe_post_window
    STATSIG_FEATURE_GATES["SAFE_POST_WINDOW"] = "rovo_extension_safe_post_window";
    //https://switcheroo.atlassian.com/ui/gates/7c652b22-efe3-4db0-a485-cc9d6e988569/key/navx_uc_rovo_extension_platform_creation_enabled
    /**
   * Controls cross-app creation for team/goal/project
   * Not intended to release for all. Internal testing within NavX Team
   */ STATSIG_FEATURE_GATES["NAVX_PLATFORM_CREATION_ENABLED"] = "navx_uc_rovo_extension_platform_creation_enabled";
    // https://switcheroo.atlassian.com/ui/gates/rovo-entitlement-api-guard
    // Guards API calls from being made when rovo LLM entitlement is disabled
    STATSIG_FEATURE_GATES["ENTITLEMENT_API_GUARD"] = "rovo-entitlement-api-guard";
    // SBS (Side-by-Side) evaluation gates
    /** Master on/off gate for the SBS evaluation system. */ STATSIG_FEATURE_GATES["SBS_ENABLED"] = "rovo-ext_sbs_enabled";
    /** Whether this user has ChatGPT Enterprise access and is eligible for ChatGPT SBS pairings. */ STATSIG_FEATURE_GATES["SBS_CHATGPT_ELIGIBLE"] = "rovo-ext_sbs_chatgpt_eligible";
    // https://switcheroo.atlassian.com/ui/gates/aa878173-3ca2-47e1-b18c-0cc707b269b7/key/rovo-extension-session-replay-gate
    // Feature gate replacing the rovo-extension-session-replay experiment for controlling session replay.
    STATSIG_FEATURE_GATES["SESSION_REPLAY"] = "rovo-extension-session-replay-gate";
    // https://switcheroo.atlassian.com/ui/gates/7639bf18-5d1c-46bf-a870-9f7912a3b88a/key/rovo_extension_consent_gate
    // Enables consent banner and respecting user privacy settings when accessing browser storage, incl. through third-party scripts.
    STATSIG_FEATURE_GATES["CONSENT"] = "rovo_extension_consent_gate";
    return STATSIG_FEATURE_GATES;
}({});
var $dd638642df7d5f32$export$c5d819d8db6dd067 = /*#__PURE__*/ function(STATSIG_DYNAMIC_CONFIGS) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo-ext_debug_menu_config
    STATSIG_DYNAMIC_CONFIGS["DEBUG_MENU_CONFIG"] = "rovo-ext_debug_menu_config";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo_extension_demo_search_config
    STATSIG_DYNAMIC_CONFIGS["DEMO_SEARCH_CONFIG"] = "rovo_extension_demo_search_config";
    return STATSIG_DYNAMIC_CONFIGS;
}({});

});

parcelRegister("LpV4F", function(module, exports) {
$parcel$export(module.exports, "getExperiment", () => $fba07258a93afe84$export$2f86411d819a755e);
$parcel$export(module.exports, "getExperimentNoExposure", () => $fba07258a93afe84$export$e7f1197dcc92c6cd);
$parcel$export(module.exports, "manuallyLogExposure", () => $fba07258a93afe84$export$e3afcb8f6255381d);

var $4d1Vr = parcelRequire("4d1Vr");
const $fba07258a93afe84$export$2f86411d819a755e = ({ experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options })=>{
    return (0, $4d1Vr.default).getExperimentValue(experimentName, parameterName, defaultValue, options);
};
const $fba07258a93afe84$export$e7f1197dcc92c6cd = ({ experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue })=>{
    return (0, $4d1Vr.default).getExperimentValue(experimentName, parameterName, defaultValue, {
        fireExperimentExposure: false
    });
};
const $fba07258a93afe84$export$e3afcb8f6255381d = (experimentName)=>{
    (0, $4d1Vr.default).manuallyLogExperimentExposure(experimentName);
};

});


parcelRegister("kwVgn", function(module, exports) {
$parcel$export(module.exports, "setOptimisticConnect", () => $230f5b54e748ff84$export$6593ecac7966ef1a);
$parcel$export(module.exports, "isOptimisticallyConnected", () => $230f5b54e748ff84$export$6bd24ca2088367e6);
/**
 * Tracks connectors we optimistically marked as connected after OAuth success,
 * so refetches (e.g. refetchOnWindowFocus) do not overwrite with stale server
 * data until the backend has propagated.
 */ const $230f5b54e748ff84$var$GRACE_MS = 10000;
const $230f5b54e748ff84$var$overlay = new Map();
function $230f5b54e748ff84$export$6593ecac7966ef1a(outboundAuthUrl) {
    $230f5b54e748ff84$var$overlay.set(outboundAuthUrl, Date.now());
}
function $230f5b54e748ff84$export$6bd24ca2088367e6(outboundAuthUrl) {
    const at = $230f5b54e748ff84$var$overlay.get(outboundAuthUrl);
    if (at == null) return false;
    if (Date.now() - at >= $230f5b54e748ff84$var$GRACE_MS) {
        $230f5b54e748ff84$export$c18dbba562c95dd(outboundAuthUrl);
        return false;
    }
    return true;
}
function $230f5b54e748ff84$export$c18dbba562c95dd(outboundAuthUrl) {
    $230f5b54e748ff84$var$overlay.delete(outboundAuthUrl);
}

});

parcelRegister("9aNsE", function(module, exports) {
$parcel$export(module.exports, "RequestErrorType", () => $a0a3285d23add2be$export$c0cc522fa83a630);
$parcel$export(module.exports, "HTTPMethod", () => $a0a3285d23add2be$export$f03a741ee867f39c);
$parcel$export(module.exports, "request", () => $a0a3285d23add2be$export$b5fe3f66a567bec0);

var $iZrH9 = parcelRequire("iZrH9");

var $bFW4F = parcelRequire("bFW4F");
var $a0a3285d23add2be$export$c0cc522fa83a630 = /*#__PURE__*/ function(RequestErrorType) {
    RequestErrorType["AUTH_ERROR"] = "AUTH_ERROR";
    RequestErrorType["OTHER_ERROR"] = "OTHER_ERROR";
    return RequestErrorType;
}({});
var $a0a3285d23add2be$export$f03a741ee867f39c = /*#__PURE__*/ function(HTTPMethod) {
    HTTPMethod["GET"] = "GET";
    HTTPMethod["POST"] = "POST";
    HTTPMethod["PUT"] = "PUT";
    HTTPMethod["PATCH"] = "PATCH";
    HTTPMethod["DELETE"] = "DELETE";
    return HTTPMethod;
}({});
const $a0a3285d23add2be$var$isAuthErrorStatusCode = (statusCode)=>statusCode === 401 || statusCode === 403;
async function $a0a3285d23add2be$export$b5fe3f66a567bec0({ url: url, options: options }) {
    const isFormData = 'body' in options && options.body instanceof FormData;
    const requestHeaders = $a0a3285d23add2be$var$buildHeaders({
        extraHeaders: options.extraHeaders,
        inferContentType: isFormData
    });
    const requestOptions = {
        method: options.method,
        headers: requestHeaders,
        credentials: options.credentials,
        body: options.method === 'POST' || options.method === 'PUT' || options.method === 'PATCH' ? options.body : undefined
    };
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
        const isAuthError = $a0a3285d23add2be$var$isAuthErrorStatusCode(response.status);
        if (isAuthError) try {
            (0, $iZrH9.reportExpectedAuthHttpFailure)({
                method: options.method,
                statusCode: response.status,
                url: url
            });
        } catch  {
        // Auth failure telemetry is best-effort and must not change the error returned to callers.
        }
        throw new (0, $bFW4F.GatewayError)({
            errorType: isAuthError ? "AUTH_ERROR" : "OTHER_ERROR",
            code: response.status,
            errorMessage: `${response.status} - Failed to ${options.method} ${url}`
        });
    }
    if (response.headers.get('Content-Type')?.includes('application/json') ?? requestHeaders.get('Accept') === 'application/json') return response.json();
    return response;
}
function $a0a3285d23add2be$var$buildHeaders({ extraHeaders: extraHeaders, inferContentType: inferContentType }) {
    const headers = new Headers();
    if (!inferContentType) headers.set('Content-Type', 'application/json');
    extraHeaders?.forEach((value, key)=>{
        headers.set(key, value);
    });
    return headers;
}

});
parcelRegister("iZrH9", function(module, exports) {
$parcel$export(module.exports, "reportExpectedAuthHttpFailure", () => $794c5a5691f648cb$export$45c490ba2161c913);

var $i38Fr = parcelRequire("i38Fr");

var $dqHaj = parcelRequire("dqHaj");
const $794c5a5691f648cb$var$EXPECTED_AUTH_HTTP_FAILURE_PROD_SAMPLE_RATE = 0.01;
// Report every expected auth failure outside prod to make staging/dev smoke tests deterministic.
// In prod, sample these high-volume 401/403 events so Sentry keeps auth visibility without noise.
const $794c5a5691f648cb$var$shouldReportExpectedAuthHttpFailure = ()=>(0, $dqHaj.bifrostEnv) !== 'prod' || Math.random() < $794c5a5691f648cb$var$EXPECTED_AUTH_HTTP_FAILURE_PROD_SAMPLE_RATE;
const $794c5a5691f648cb$var$stripQueryAndHash = (url)=>url.split(/[?#]/)[0];
const $794c5a5691f648cb$var$getRequestPath = (url)=>{
    try {
        return new URL(url, window.location.origin).pathname;
    } catch  {
        return $794c5a5691f648cb$var$stripQueryAndHash(url);
    }
};
const $794c5a5691f648cb$export$45c490ba2161c913 = ({ method: method, statusCode: statusCode, url: url })=>{
    if (!$794c5a5691f648cb$var$shouldReportExpectedAuthHttpFailure()) return;
    const requestPath = $794c5a5691f648cb$var$getRequestPath(url);
    const serializedStatusCode = String(statusCode);
    $i38Fr.captureMessage('Expected auth HTTP failure', {
        level: 'info',
        fingerprint: [
            'expected-auth-http-failure',
            method,
            requestPath,
            serializedStatusCode
        ],
        tags: {
            expectedAuthFailure: 'true',
            requestMethod: method,
            requestPath: requestPath,
            statusCode: serializedStatusCode
        },
        contexts: {
            authHttpFailure: {
                method: method,
                path: requestPath,
                statusCode: serializedStatusCode
            }
        }
    });
};

});


parcelRegister("1ZAcM", function(module, exports) {
$parcel$export(module.exports, "isUserAccount", () => $17a9ac43c1700b1c$export$523b7140f1dfc1f0);
$parcel$export(module.exports, "SettingsErrorType", () => $17a9ac43c1700b1c$export$7ec6bbb46b9e5f23);
const $17a9ac43c1700b1c$export$523b7140f1dfc1f0 = (data)=>{
    return Boolean(data.accountId && data.email && data.name && data.nickname && data.picture);
};
var $17a9ac43c1700b1c$export$7ec6bbb46b9e5f23 = /*#__PURE__*/ function(SettingsErrorType) {
    SettingsErrorType[SettingsErrorType["NETWORK_ERROR"] = 1000] = "NETWORK_ERROR";
    SettingsErrorType[SettingsErrorType["VALIDATION_ERROR"] = 1001] = "VALIDATION_ERROR";
    SettingsErrorType[SettingsErrorType["SERVER_ERROR"] = 1002] = "SERVER_ERROR";
    SettingsErrorType[SettingsErrorType["UNKNOWN_ERROR"] = 1003] = "UNKNOWN_ERROR";
    return SettingsErrorType;
}({});

});


parcelRegister("e9gYt", function(module, exports) {
$parcel$export(module.exports, "isHello", () => $b0bcb443f0ff1d7d$export$8e3fc93123f96c19);
function $b0bcb443f0ff1d7d$export$8e3fc93123f96c19(cloudId) {
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
}

});

parcelRegister("f0dSY", function(module, exports) {
$parcel$export(module.exports, "initializeSentry", () => $1c5e2247836c7d2a$export$1f7656c617418e15);
$parcel$export(module.exports, "setSentryUser", () => $1c5e2247836c7d2a$export$5ceec5c8be62fa1b);
$parcel$export(module.exports, "setSentrySiteId", () => $1c5e2247836c7d2a$export$90b57d32e0a1baf4);
$parcel$export(module.exports, "clearSentryUser", () => $1c5e2247836c7d2a$export$e3ad57e6f9f2f051);
$parcel$export(module.exports, "setSentryExperiments", () => $1c5e2247836c7d2a$export$68c09cda53c4724c);

var $Mb6Wv = parcelRequire("Mb6Wv");
var $4pCtk = parcelRequire("4pCtk");
var $i38Fr = parcelRequire("i38Fr");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $6jMOU = parcelRequire("6jMOU");

var $crLv5 = parcelRequire("crLv5");

var $LpV4F = parcelRequire("LpV4F");

var $3GGL5 = parcelRequire("3GGL5");

var $5XDeM = parcelRequire("5XDeM");
const $1c5e2247836c7d2a$var$getSentryDsn = (env)=>{
    if (env === 'dev') return 'https://f53c67cb2614beaabdff4ee6a84aaa95@o55978.ingest.us.sentry.io/4507891849625600';
    return 'https://9cf62308d0228b7d1d63b292839a8c37@o55978.ingest.us.sentry.io/4507891849625600';
};
const $1c5e2247836c7d2a$var$getRovoExtensionVersion = ()=>{
    const version = new URLSearchParams(window.location.search).get('version');
    return version ?? 'unknown';
};
const $1c5e2247836c7d2a$export$c9336bd12880d863 = (value)=>{
    if (value === undefined || value === '') return value;
    return '[SANITIZED]';
};
const $1c5e2247836c7d2a$var$sensitiveParamKeys = Object.freeze([
    'rovoChatPrompt'
]);
const $1c5e2247836c7d2a$var$sanitizeQueryParams = (queryString)=>{
    if (!queryString) return;
    if (Array.isArray(queryString)) return queryString.map(([key, value])=>[
            key,
            $1c5e2247836c7d2a$var$sensitiveParamKeys.includes(key) ? $1c5e2247836c7d2a$export$c9336bd12880d863(value) ?? '' : value
        ]);
    else if (typeof queryString === 'string') {
        const params = new URLSearchParams(queryString);
        $1c5e2247836c7d2a$var$sensitiveParamKeys.forEach((key)=>{
            if (params.has(key)) params.set(key, $1c5e2247836c7d2a$export$c9336bd12880d863(params.get(key) ?? '') ?? '');
        });
        return params.toString();
    }
    const sanitizedQuery = {};
    for (const [key, value] of Object.entries(queryString))sanitizedQuery[key] = $1c5e2247836c7d2a$var$sensitiveParamKeys.includes(key) ? $1c5e2247836c7d2a$export$c9336bd12880d863(value) ?? '' : value;
    return sanitizedQuery;
};
const $1c5e2247836c7d2a$var$sanitizeUrl = (url)=>{
    if (!url || !url.includes('?')) return url;
    const [baseUrl, queryString] = url.split('?');
    const sanitizedQueryString = $1c5e2247836c7d2a$var$sanitizeQueryParams(queryString);
    return sanitizedQueryString ? `${baseUrl}?${sanitizedQueryString}` : baseUrl;
};
const $1c5e2247836c7d2a$var$hasUserAccountKeys = (obj)=>{
    if (!obj || typeof obj !== 'object') return false;
    const userAccountKeys = [
        'email',
        'name',
        'nickname',
        'picture'
    ];
    return userAccountKeys.some((key)=>key in obj);
};
const $1c5e2247836c7d2a$export$e958bec57fbab05f = (event)=>{
    const sanitizedEvent = {
        ...event
    };
    sanitizedEvent.contexts = {
        ...event.contexts,
        response: {
            ...event.contexts?.response,
            cookies: undefined,
            headers: undefined
        },
        'Atlassian Trace': {
            trace_id: event.contexts?.response?.headers?.['x-trace-id'],
            request_id: event.contexts?.response?.headers?.['atl-request-id']
        }
    };
    if (sanitizedEvent.extra && $1c5e2247836c7d2a$var$hasUserAccountKeys(sanitizedEvent.extra)) sanitizedEvent.extra = {
        ...sanitizedEvent.extra,
        email: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.email),
        name: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.name),
        nickname: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.nickname),
        picture: $1c5e2247836c7d2a$export$c9336bd12880d863(sanitizedEvent.extra.picture)
    };
    if (event.request?.method) sanitizedEvent.message = `${event.contexts?.response?.status_code} - Failed to ${event.request.method} ${event.request.url ? new URL(event.request.url).pathname : ''}`;
    sanitizedEvent.request = {
        ...event.request,
        url: $1c5e2247836c7d2a$var$sanitizeUrl(event.request?.url),
        headers: {
            'User-Agent': event.request?.headers?.['User-Agent'] ?? ''
        },
        cookies: undefined,
        query_string: $1c5e2247836c7d2a$var$sanitizeQueryParams(event.request?.query_string)
    };
    if (sanitizedEvent.exception?.values) sanitizedEvent.exception.values = sanitizedEvent.exception.values.map((value)=>{
        if (value.type === 'Error' && value.mechanism?.type === 'http.client') return {
            ...value,
            value: sanitizedEvent.message
        };
        return value;
    });
    return sanitizedEvent;
};
const $1c5e2247836c7d2a$var$processBeforeSendEvent = (event)=>{
    // Drop errors thrown inside *other* browser extensions injected into our page.
    // Sentry's addEventListener instrumentation catches exceptions from third-party
    // extensions' listeners on the shared window and misattributes them to us. See
    // foreignExtensionErrors.ts.
    if ((0, $5XDeM.isForeignExtensionError)(event)) return null;
    // Keep wide httpClientIntegration monitoring (400-599) but drop a curated set
    // of expected HTTP responses the integration reports as errors (e.g. a 404
    // that is really a lookup's negative answer). See ignoredHttpClientErrors.ts.
    if ((0, $3GGL5.isIgnoredHttpClientError)(event)) return null;
    const sanitizedEvent = $1c5e2247836c7d2a$export$e958bec57fbab05f(event);
    // Send error analytics before sending to Sentry
    try {
        (0, $6jMOU.sendErrorAnalytics)(sanitizedEvent);
    } catch  {
    // do nothing
    }
    return sanitizedEvent;
};
const $1c5e2247836c7d2a$export$1f7656c617418e15 = ()=>{
    $4pCtk.init({
        dsn: $1c5e2247836c7d2a$var$getSentryDsn((0, $dqHaj.bifrostEnv)),
        environment: (0, $dqHaj.bifrostEnv),
        release: `rovo-extension-frontend@${(0, $dqHaj.bitbucketCommit)}`,
        sendDefaultPii: true,
        integrations: [
            $Mb6Wv.httpClientIntegration({
                failedRequestStatusCodes: [
                    [
                        400,
                        400
                    ],
                    [
                        402,
                        402
                    ],
                    [
                        404,
                        599
                    ]
                ]
            })
        ],
        beforeSend: $1c5e2247836c7d2a$var$processBeforeSendEvent,
        normalizeDepth: 5
    });
    $i38Fr.setTag('rovoExtensionVersion', $1c5e2247836c7d2a$var$getRovoExtensionVersion());
};
const $1c5e2247836c7d2a$export$5ceec5c8be62fa1b = (accountId)=>{
    $i38Fr.setUser({
        id: accountId
    });
};
const $1c5e2247836c7d2a$export$90b57d32e0a1baf4 = (siteId)=>{
    $i38Fr.setTag('siteId', siteId);
};
const $1c5e2247836c7d2a$export$e3ad57e6f9f2f051 = ()=>{
    $i38Fr.setUser(null);
};
const $1c5e2247836c7d2a$export$68c09cda53c4724c = ()=>{
    (0, $crLv5.activeExperiments).forEach((experiment)=>{
        const value = (0, $LpV4F.getExperimentNoExposure)({
            experimentName: experiment.experimentName,
            parameterName: experiment.parameterName,
            defaultValue: false
        });
        $i38Fr.setTag(`exp.${experiment.experimentName}`, value ? 'enabled' : 'disabled');
    });
};

});
parcelRegister("6jMOU", function(module, exports) {
$parcel$export(module.exports, "sendErrorAnalytics", () => $68a29dd5f0ffb3c0$export$552acb5702b97c64);

var $6yEEN = parcelRequire("6yEEN");

var $dX6kP = parcelRequire("dX6kP");

var $lsxLV = parcelRequire("lsxLV");
/**
 * Extracts relevant error information from Sentry event for analytics
 */ const $68a29dd5f0ffb3c0$var$extractErrorAttributes = (event)=>{
    const attributes = {
        environment: event.environment,
        userAgent: event.request?.headers?.['User-Agent'],
        extensionVersion: event.tags?.rovoExtensionVersion,
        siteId: event.tags?.siteId,
        userId: event.user?.id?.toString()
    };
    // Extract error type
    if (event.exception?.values?.[0]) {
        const exception = event.exception.values[0];
        attributes.errorType = exception.type;
    }
    if (event.contexts?.response) attributes.httpStatusCode = event.contexts.response.status_code;
    if (event.request?.method) {
        attributes.requestMethod = event.request.method;
        try {
            const url = event.request.url ? new URL(event.request.url).pathname : undefined;
            attributes.requestPath = url;
        } catch  {
        // Invalid URL, skip
        }
    }
    return attributes;
};
const $68a29dd5f0ffb3c0$export$552acb5702b97c64 = (event)=>{
    if (event.level !== 'error' && event.level !== 'fatal') return;
    const attributes = $68a29dd5f0ffb3c0$var$extractErrorAttributes(event);
    // Set tenant info if available
    if (attributes.siteId) (0, $dX6kP.analyticsClient).setTenantInfo((0, $6yEEN.tenantType).CLOUD_ID, attributes.siteId);
    // Set user info if available
    if (attributes.userId) (0, $dX6kP.analyticsClient).setUserInfo((0, $6yEEN.userType).ATLASSIAN_ACCOUNT, attributes.userId);
    // https://data-portal.internal.atlassian.com/analytics/registry/86838
    (0, $dX6kP.analyticsClient).sendTrackEvent({
        source: 'rovoExtensionFrontend',
        action: 'error',
        actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).ROVO_EXTENSION_FRONTEND,
        attributes: {
            ...attributes
        }
    }).catch(()=>{
    // do nothing
    });
};

});

parcelRegister("3GGL5", function(module, exports) {
$parcel$export(module.exports, "isIgnoredHttpClientError", () => $d27fb936b7d072d7$export$63bc222fbc99937b);
const $d27fb936b7d072d7$export$d88702beda71ecdd = [
    {
        reason: "Expected negative result, not a failure. profilecard's TeamCentralCardClient fires this as part of a deliberate parallel prefetch (constructor preload) to resolve the site's Team Central workspace type ahead of time. A 404 is how the API reports \"no Atlas/Townsquare workspace here\"; the client handles it (returns undefined, so getIsGlobalExperienceWorkspace resolves false). It is a false-positive for httpClientIntegration (which flags every 4xx/5xx), not an app error - but it accounted for ~31k users / ~864k events in 14 days.",
        reference: 'ROVO-EXTENSION-FRONTEND-69N',
        methods: [
            'GET'
        ],
        statusCodes: [
            404
        ],
        pathPattern: /\/gateway\/api\/townsquare\/s\/[^/]+\/workspace\/existsWithWorkspaceType$/
    },
    {
        reason: 'Expected negative result from the sibling prefetch (organization/containsAnyWorkspace) fired in the same TeamCentralCardClient constructor. A 404 means "this org has no Townsquare workspace" and is handled by getOrgContainsAnyWorkspace (treated as false). Same false-positive class as existsWithWorkspaceType, not an app error.',
        reference: 'ROVO-EXTENSION-FRONTEND-69N',
        methods: [
            'GET'
        ],
        statusCodes: [
            404
        ],
        pathPattern: /\/gateway\/api\/townsquare\/s\/[^/]+\/organization\/containsAnyWorkspace$/
    }
];
const $d27fb936b7d072d7$var$isHttpClientEvent = (event)=>event.exception?.values?.some((value)=>value.mechanism?.type === 'http.client') ?? false;
const $d27fb936b7d072d7$var$getPathname = (url)=>{
    if (!url) return undefined;
    try {
        return new URL(url).pathname;
    } catch  {
        return undefined;
    }
};
const $d27fb936b7d072d7$export$63bc222fbc99937b = (event)=>{
    if (!$d27fb936b7d072d7$var$isHttpClientEvent(event)) return false;
    const pathname = $d27fb936b7d072d7$var$getPathname(event.request?.url);
    if (!pathname) return false;
    const method = event.request?.method?.toUpperCase();
    const status = event.contexts?.response?.status_code;
    return $d27fb936b7d072d7$export$d88702beda71ecdd.some((rule)=>{
        if (rule.methods && !(method !== undefined && rule.methods.includes(method))) return false;
        if (rule.statusCodes && !(status !== undefined && rule.statusCodes.includes(status))) return false;
        return rule.pathPattern.test(pathname);
    });
};

});

parcelRegister("5XDeM", function(module, exports) {
$parcel$export(module.exports, "isForeignExtensionError", () => $5595322ca4555d1a$export$b4318fee52979374);

var $cCr6T = parcelRequire("cCr6T");
/**
 * Drops errors that originate from *other* browser extensions injected into the
 * same page as the Rovo web app, rather than from our own code.
 *
 * Why these reach our project at all: the Sentry browser SDK instruments
 * `addEventListener`, wrapping every listener callback in a try/catch so it can
 * report unhandled exceptions. When a third-party extension registers a listener
 * on the shared page `window` (e.g. a `blur` handler) and that listener throws,
 * Sentry's wrapper catches the exception on our page and attributes it to the
 * Rovo project even though the failing code lives in `chrome-extension://<other>/…`.
 *
 * These are not Rovo bugs and cannot be fixed by us, so we drop them in
 * `beforeSend`. Example: ROVO-EXTENSION-FRONTEND-6J2 —
 * `ReferenceError: Cannot access 'w' before initialization` thrown from
 * `chrome-extension://bbidpgoneibefablhfcnaennjkfbflmk/content-injected/index.iife.js`.
 *
 * Safety: we only drop an event when it has at least one `chrome-extension://`
 * frame AND *every* attributable script frame is a `chrome-extension://` frame
 * that is not the Rovo extension. Genuine Rovo errors (which run in the iframe on
 * `https://…atlassian.com`) and normal page errors therefore always pass through.
 */ // `ROVO_EXTENSION_IDS` (our own dev/staging/prod IDs) is imported from
// `../constants/extensionIds`. Errors from those IDs are our own and must NOT be
// dropped by this filter, so they are used as an allow-list below. The frontend
// runs in an iframe served over https and would not normally produce
// `chrome-extension://<rovo-id>` frames here, but the allow-list ensures our own
// code is never accidentally silenced.
const $5595322ca4555d1a$var$CHROME_EXTENSION_FRAME = /^chrome-extension:\/\/([a-p]{32})\//;
/**
 * Frames whose filename matches these are SDK/runtime plumbing, not the code
 * that actually threw, so they must be ignored when deciding attribution.
 * Sentry's own wrapper (`@sentry/browser` helpers) is always on top of these
 * cross-extension stacks and would otherwise mask the real origin.
 */ const $5595322ca4555d1a$var$isNonAttributableFrame = (filename)=>{
    if (!filename) return true;
    if (filename === '<anonymous>' || filename === '[native code]') return true;
    // Sentry SDK plumbing (the instrumenting wrapper), regardless of how it is bundled.
    if (/@sentry[/\\]/.test(filename) || /\bsentry[^/\\]*\.(?:js|mjs|cjs)/.test(filename)) return true;
    return false;
};
const $5595322ca4555d1a$var$getExtensionId = (filename)=>{
    if (!filename) return undefined;
    const match = $5595322ca4555d1a$var$CHROME_EXTENSION_FRAME.exec(filename);
    return match?.[1];
};
const $5595322ca4555d1a$export$b4318fee52979374 = (event)=>{
    const values = event.exception?.values;
    if (!values || values.length === 0) return false;
    let sawForeignExtensionFrame = false;
    for (const value of values){
        const frames = value.stacktrace?.frames;
        if (!frames || frames.length === 0) continue;
        for (const frame of frames){
            const filename = frame.filename;
            if ($5595322ca4555d1a$var$isNonAttributableFrame(filename)) continue;
            const extensionId = $5595322ca4555d1a$var$getExtensionId(filename);
            if (extensionId === undefined) // An attributable, non-extension frame (e.g. our https app code or a
            // normal page script): this is not a pure foreign-extension error.
            return false;
            if ((0, $cCr6T.ROVO_EXTENSION_IDS).includes(extensionId)) // A frame from our own extension: never drop.
            return false;
            sawForeignExtensionFrame = true;
        }
    }
    return sawForeignExtensionFrame;
};

});
parcelRegister("cCr6T", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_ID_PROD", () => $159b50bfc09003bd$export$fc62cb424abd17f9);
$parcel$export(module.exports, "ROVO_EXTENSION_IDS", () => $159b50bfc09003bd$export$223ed54ff67fa53c);
/**
 * Chrome Web Store extension IDs for the Rovo browser extension, one per
 * environment.
 *
 * Source of truth for the environment → ID mapping is
 * `scripts/generate-env-var-exports.js` (and `build-config/config.js` in the
 * extension-chrome package). Keep these in sync if the published extension IDs
 * ever change.
 */ /** Local development / unpacked build. */ const $159b50bfc09003bd$export$3ee18a3ac5e07567 = 'dmjofbngkpnmmiccjhikngiodkbofnpc';
const $159b50bfc09003bd$export$a8ab1036f8ff62b5 = 'deejhllflojhohbeechaicbcofamcbkp';
const $159b50bfc09003bd$export$fc62cb424abd17f9 = 'npbjhobkibekbklkghlhfhieggcggpdb';
const $159b50bfc09003bd$export$223ed54ff67fa53c = Object.freeze([
    $159b50bfc09003bd$export$3ee18a3ac5e07567,
    $159b50bfc09003bd$export$a8ab1036f8ff62b5,
    $159b50bfc09003bd$export$fc62cb424abd17f9
]);

});



parcelRegister("hmQ4u", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f872f4916d4a3d7$export$2e2bcd8739ae039);

var $eMSEP = parcelRequire("eMSEP");
var $bQOrV = parcelRequire("bQOrV");

var $49361 = parcelRequire("49361");

var $eAih2 = parcelRequire("eAih2");

var $1v5pe = parcelRequire("1v5pe");

var $hpF1c = parcelRequire("hpF1c");

var $b2Az1 = parcelRequire("b2Az1");

var $hRUfe = parcelRequire("hRUfe");

var $8RBNz = parcelRequire("8RBNz");

var $dDtM2 = parcelRequire("dDtM2");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $bFW4F = parcelRequire("bFW4F");

var $9A7Rq = parcelRequire("9A7Rq");

var $5w8e3 = parcelRequire("5w8e3");
const $9f872f4916d4a3d7$var$errorStyles = (0, $bQOrV.xcss)({
    marginTop: 'space.800',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textWrap: 'wrap',
    textAlign: 'center'
});
const $9f872f4916d4a3d7$var$textStyles = (0, $bQOrV.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 'space.050',
    marginBottom: 'space.200'
});
const $9f872f4916d4a3d7$var$errorMessageStyles = (0, $bQOrV.xcss)({
    font: 'font.heading.xxlarge',
    fontWeight: 'font.weight.medium'
});
const $9f872f4916d4a3d7$var$subtextStyles = (0, $bQOrV.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 'space.250',
    font: 'font.body'
});
const $9f872f4916d4a3d7$var$linkStyles = (0, $bQOrV.xcss)({
    color: 'color.text',
    textDecoration: 'underline',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $9f872f4916d4a3d7$var$RovoDisabledError = ({ userAccount: userAccount, metadata: metadata, showNavigation: showNavigation = false })=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const queryClient = (0, $eAih2.useQueryClient)();
    const [isLoading, setIsLoading] = (0, $1v5pe.useState)(false);
    const ufoContext = (0, $hRUfe.useInteractionContext)();
    const handleReload = async ()=>{
        setIsLoading(true);
        const releaseHold = ufoContext?.hold('rovo-disabled-reload');
        try {
            await queryClient.invalidateQueries({
                queryKey: [
                    (0, $bFW4F.GatewayQueryKeys).SEARCH_SITES_WITH_ROVO_ENABLED_WITH_METADATA_NEW
                ]
            });
        } finally{
            setIsLoading(false);
            releaseHold?.();
        }
    };
    // https://data-portal.internal.atlassian.com/analytics/registry/87408
    (0, $1v5pe.useEffect)(()=>{
        sendAnalyticEvent({
            eventType: 'screen',
            event: {
                name: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_NO_ROVO_VIEW,
                attributes: {
                    ...metadata
                }
            },
            userId: userAccount?.accountId
        });
    }, [
        sendAnalyticEvent,
        userAccount?.accountId,
        metadata
    ]);
    const errorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $9f872f4916d4a3d7$var$errorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8RBNz.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $9f872f4916d4a3d7$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $9f872f4916d4a3d7$var$errorMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $dDtM2.messages).rovoDisabledError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $9f872f4916d4a3d7$var$subtextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $dDtM2.messages).rovoDisabledErrorSubheader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.default), {
        href: "https://www.atlassian.com/software/rovo",
        target: "_parent",
        xcss: $9f872f4916d4a3d7$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $dDtM2.messages).rovoDisabledErrorLink)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $49361.default), {
        appearance: "primary",
        isLoading: isLoading,
        onClick: handleReload
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $dDtM2.messages).reloadButtonLabel)));
    const shouldShowHeader = showNavigation && userAccount?.accountId && !(0, $9A7Rq.isNarrowWindow)();
    return shouldShowHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5w8e3.default), {
        site: undefined,
        testId: "rovo-disabled-top-navigation",
        userAccount: userAccount
    }, errorContent) : errorContent;
};
var $9f872f4916d4a3d7$export$2e2bcd8739ae039 = $9f872f4916d4a3d7$var$RovoDisabledError;

});
parcelRegister("49361", function(module, exports) {
$parcel$export(module.exports, "default", () => $65e2863bd86ba227$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $1895S = parcelRequire("1895S");

var $1TZ74 = parcelRequire("1TZ74");

var $lreqQ = parcelRequire("lreqQ");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $65e2863bd86ba227$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1895S.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest
    }, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1TZ74.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $lreqQ.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1TZ74.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1TZ74.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $lreqQ.default), {
        icon: iconAfter
    })));
}));
$65e2863bd86ba227$var$Button.displayName = 'Button';
var $65e2863bd86ba227$export$2e2bcd8739ae039 = $65e2863bd86ba227$var$Button;

});
parcelRegister("1895S", function(module, exports) {
$parcel$export(module.exports, "default", () => $49f0534daadba05f$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.40.0 */ /* button-base.tsx generated by @compiled/babel-plugin v0.40.0 */ /* button-base.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $Ms2ib = parcelRequire("Ms2ib");

var $lHxwq = parcelRequire("lHxwq");

var $2aEiL = parcelRequire("2aEiL");

var $g4uNb = parcelRequire("g4uNb");

var $kFr83 = parcelRequire("kFr83");

var $3xwP1 = parcelRequire("3xwP1");

var $510jU = parcelRequire("510jU");

var $3iTXu = parcelRequire("3iTXu");

var $1ObgC = parcelRequire("1ObgC");
const $49f0534daadba05f$var$LOADING_LABEL = ', Loading';
const $49f0534daadba05f$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $49f0534daadba05f$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $49f0534daadba05f$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $49f0534daadba05f$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const $49f0534daadba05f$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $49f0534daadba05f$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $49f0534daadba05f$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $49f0534daadba05f$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $49f0534daadba05f$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $49f0534daadba05f$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $1v5pe.useRef)(null);
    const splitButtonContext = (0, $510jU.useSplitButtonContext)();
    const loadingLabelId = (0, $lHxwq.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $Ms2ib.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $g4uNb.Pressable), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $fl4ll.default)([
            localRef,
            ref
        ]),
        xcss: (0, $ky45w.cx)($49f0534daadba05f$var$styles.base, (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $49f0534daadba05f$var$styles.baseT26Shape, isInteractive && (0, $2aEiL.fg)('platform-dst-motion-uplift-button') && $49f0534daadba05f$var$styles.interactiveMotion, appearance === 'default' && $49f0534daadba05f$var$defaultStyles.root, appearance === 'default' && isInteractive && $49f0534daadba05f$var$defaultStyles.interactive, appearance === 'primary' && $49f0534daadba05f$var$primaryStyles.root, appearance === 'primary' && isInteractive && $49f0534daadba05f$var$primaryStyles.interactive, appearance === 'rovo' && $49f0534daadba05f$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $49f0534daadba05f$var$rovoStyles.interactive, appearance === 'warning' && $49f0534daadba05f$var$warningStyles.root, appearance === 'warning' && isInteractive && $49f0534daadba05f$var$warningStyles.interactive, appearance === 'danger' && $49f0534daadba05f$var$dangerStyles.root, appearance === 'danger' && isInteractive && $49f0534daadba05f$var$dangerStyles.interactive, appearance === 'discovery' && $49f0534daadba05f$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $49f0534daadba05f$var$discoveryStyles.interactive, appearance === 'subtle' && $49f0534daadba05f$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $49f0534daadba05f$var$subtleStyles.interactive, $49f0534daadba05f$var$styles.linkDecorationUnset, isSelected && $49f0534daadba05f$var$selectedStyles.root, isSelected && isSplitButton && $49f0534daadba05f$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $49f0534daadba05f$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $49f0534daadba05f$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $49f0534daadba05f$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $49f0534daadba05f$var$selectedStyles.discovery, isDisabled && $49f0534daadba05f$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $49f0534daadba05f$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $49f0534daadba05f$var$defaultStyles.disabled, spacing === 'compact' && $49f0534daadba05f$var$styles.spacingCompact, spacing === 'compact' && (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $49f0534daadba05f$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $49f0534daadba05f$var$styles.circle, shouldFitContainer && $49f0534daadba05f$var$styles.fullWidth, hasIconBefore && $49f0534daadba05f$var$styles.buttonIconBefore, hasIconAfter && $49f0534daadba05f$var$styles.buttonIconAfter, isIconButton && $49f0534daadba05f$var$styles.iconButton, isIconButton && spacing === 'compact' && $49f0534daadba05f$var$styles.iconButtonCompact, isLoading && $49f0534daadba05f$var$styles.loading, isSplitButton && $49f0534daadba05f$var$styles.splitButton, isNavigationSplitButton && $49f0534daadba05f$var$styles.navigationSplitButton),
        isDisabled: (0, $2aEiL.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled,
        ...(0, $2aEiL.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-live': 'polite'
        },
        ...isLoading && (0, $2aEiL.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$49f0534daadba05f$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $3iTXu.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $3xwP1.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $49f0534daadba05f$var$styles.loadingOverlay
        ])
    }, (0, $1ObgC.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kFr83.default), {
        id: loadingLabelId
    }, $49f0534daadba05f$var$LOADING_LABEL)));
});
var $49f0534daadba05f$export$2e2bcd8739ae039 = $49f0534daadba05f$var$ButtonBase;

});
parcelRegister("hMvDh", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf1f74e83e39b972$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $cf1f74e83e39b972$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $cf1f74e83e39b972$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $cf1f74e83e39b972$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("3xwP1", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $31dafb6d95c4b4c9$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $1v5pe = parcelRequire("1v5pe");
const $31dafb6d95c4b4c9$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});

parcelRegister("510jU", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $cd41f3327218c180$export$47e2c6fdb142d947);

var $1v5pe = parcelRequire("1v5pe");

var $3xwP1 = parcelRequire("3xwP1");
const $cd41f3327218c180$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $1v5pe.useContext)((0, $3xwP1.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("3iTXu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2160cc5bed4a8cb$export$2e2bcd8739ae039);
function $b2160cc5bed4a8cb$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $b2160cc5bed4a8cb$var$tabKeyCode = 9;
function $b2160cc5bed4a8cb$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b2160cc5bed4a8cb$var$tabKeyCode) return;
    $b2160cc5bed4a8cb$var$abort(event);
}
function $b2160cc5bed4a8cb$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $b2160cc5bed4a8cb$var$abort,
        onMouseUpCapture: $b2160cc5bed4a8cb$var$abort,
        onKeyDownCapture: $b2160cc5bed4a8cb$var$onKey,
        onKeyUpCapture: $b2160cc5bed4a8cb$var$onKey,
        onTouchStartCapture: $b2160cc5bed4a8cb$var$abort,
        onTouchEndCapture: $b2160cc5bed4a8cb$var$abort,
        onPointerDownCapture: $b2160cc5bed4a8cb$var$abort,
        onPointerUpCapture: $b2160cc5bed4a8cb$var$abort,
        onClickCapture: $b2160cc5bed4a8cb$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $b2160cc5bed4a8cb$var$abort
    } : events;
}

});

parcelRegister("1ObgC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b9c30dd6d7316a7$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $5I7AE = parcelRequire("5I7AE");
function $4b9c30dd6d7316a7$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $4b9c30dd6d7316a7$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $4b9c30dd6d7316a7$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5I7AE.default), {
        size: $4b9c30dd6d7316a7$var$getIconSpacing(spacing),
        appearance: $4b9c30dd6d7316a7$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("1TZ74", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c33814dfe247865$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");
const $2c33814dfe247865$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $2c33814dfe247865$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("span", {
        className: (0, $hMvDh.default)([
            $2c33814dfe247865$var$styles.common,
            type === 'text' && $2c33814dfe247865$var$styles.text,
            type === 'icon' && $2c33814dfe247865$var$styles.icon,
            isLoading && $2c33814dfe247865$var$styles.fade
        ])
    }, children);
};
var $2c33814dfe247865$export$2e2bcd8739ae039 = $2c33814dfe247865$var$Content;

});

parcelRegister("lreqQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ba8d66f4aae8c37$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");
function $4ba8d66f4aae8c37$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $4ba8d66f4aae8c37$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $4ba8d66f4aae8c37$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $2aEiL.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Icon, iconProps));
};
var $4ba8d66f4aae8c37$export$2e2bcd8739ae039 = $4ba8d66f4aae8c37$var$IconRenderer;

});


parcelRegister("8RBNz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e72fe1fa4fff3f0$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $cYe7u = parcelRequire("cYe7u");

var $dAePw = parcelRequire("dAePw");

var $eGcnh = parcelRequire("eGcnh");
const $1e72fe1fa4fff3f0$var$ErrorSearchNoResultIllustration = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        style: {
            width: '275px',
            height: '275px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
        alt: "Error",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dAePw))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($eGcnh)))
    }));
var $1e72fe1fa4fff3f0$export$2e2bcd8739ae039 = $1e72fe1fa4fff3f0$var$ErrorSearchNoResultIllustration;

});
parcelRegister("dAePw", function(module, exports) {
module.exports = new URL("light.a00ae47b.svg", import.meta.url).toString();

});

parcelRegister("eGcnh", function(module, exports) {
module.exports = new URL("dark.5ca83755.svg", import.meta.url).toString();

});


parcelRegister("9A7Rq", function(module, exports) {
$parcel$export(module.exports, "isNarrowWindow", () => $7d983ae5a67592a9$export$37afcf3a4bc9baab);

var $gEFgM = parcelRequire("gEFgM");
const $7d983ae5a67592a9$export$37afcf3a4bc9baab = ()=>window.innerWidth <= (0, $gEFgM.S_BREAKPOINT);

});
parcelRegister("gEFgM", function(module, exports) {
$parcel$export(module.exports, "S_BREAKPOINT", () => $f3f3f0fccc8b99e7$export$5cbddc7791c72241);

var $1v5pe = parcelRequire("1v5pe");
const $f3f3f0fccc8b99e7$export$f0bb0390451181cf = 767; // <= 767px
const $f3f3f0fccc8b99e7$export$5cbddc7791c72241 = 1023; // 768-1023px
const $f3f3f0fccc8b99e7$export$b5a622e4c6afebbe = 1439; // 1024-1439px
const $f3f3f0fccc8b99e7$export$ff773012c79069c9 = 1767; // 1440p-1767x
function $f3f3f0fccc8b99e7$export$74514a3460910744() {
    const [windowSizeWidth, setWindowSize] = (0, $1v5pe.useState)(undefined);
    const [breakpoint, setBreakpoint] = (0, $1v5pe.useState)('XL');
    (0, $1v5pe.useEffect)(()=>{
        function handleResize() {
            setWindowSize(document.documentElement.clientWidth);
            if (window.innerWidth <= $f3f3f0fccc8b99e7$export$f0bb0390451181cf) setBreakpoint('XS');
            else if (window.innerWidth <= $f3f3f0fccc8b99e7$export$5cbddc7791c72241) setBreakpoint('S');
            else if (window.innerWidth <= $f3f3f0fccc8b99e7$export$b5a622e4c6afebbe) setBreakpoint('M');
            else if (window.innerWidth <= $f3f3f0fccc8b99e7$export$ff773012c79069c9) setBreakpoint('L');
            else setBreakpoint('XL');
        }
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return ()=>window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return {
        windowSizeWidth: windowSizeWidth,
        breakpoint: breakpoint
    };
}

});


parcelRegister("5w8e3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5617884d005c84a9$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $iWPIE = parcelRequire("iWPIE");
var $7kOlB = parcelRequire("7kOlB");
var $fsTfg = parcelRequire("fsTfg");
var $9eJtQ = parcelRequire("9eJtQ");
var $XC39w = parcelRequire("XC39w");

var $jJnEW = parcelRequire("jJnEW");

var $b6kD3 = parcelRequire("b6kD3");

var $jqltP = parcelRequire("jqltP");

var $gN3lo = parcelRequire("gN3lo");
/**
 * A lightweight top bar layout that only shows the company logo and profile.
 * Used in contexts where we don't need the full navigation features.
 */ const $5617884d005c84a9$var$ProfileOnlyTopBarLayout = ({ userAccount: userAccount, site: site, children: children, testId: testId = 'profile-only-top-navigation' })=>{
    const customNavbarColor = (0, $b6kD3.useCompanyThemingNavbarColor)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $7kOlB.Root), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fsTfg.TopNav), {
        testId: testId,
        UNSAFE_theme: {
            backgroundColor: (0, $jJnEW.parseHex)(customNavbarColor),
            highlightColor: (0, $jJnEW.parseHex)(customNavbarColor)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $XC39w.TopNavStart), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $gN3lo.ExtensionTopBarCompanyLogo), {
        site: site,
        userAccount: userAccount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9eJtQ.TopNavEnd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $jqltP.Profile), {
        showWhatsNewButton: false,
        site: site,
        userAccount: userAccount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iWPIE.Main), null, children));
};
var $5617884d005c84a9$export$2e2bcd8739ae039 = $5617884d005c84a9$var$ProfileOnlyTopBarLayout;

});
parcelRegister("b6kD3", function(module, exports) {
$parcel$export(module.exports, "useCompanyThemingFontColor", () => $ea9dfdce1bcf6891$export$9bc017cf4e473db4);
$parcel$export(module.exports, "useCompanyThemingNavbarColor", () => $ea9dfdce1bcf6891$export$44ce6761be442ae9);

var $ii4ep = parcelRequire("ii4ep");

var $kc9pJ = parcelRequire("kc9pJ");
const $ea9dfdce1bcf6891$export$9bc017cf4e473db4 = ()=>{
    const { data: companyThemingSettings } = (0, $ii4ep.useCompanyThemingSettings)();
    const resolvedTheme = (0, $kc9pJ.useResolvedTheme)();
    const fontColor = resolvedTheme === 'light' ? companyThemingSettings?.fontColorLight : companyThemingSettings?.fontColorDark;
    return fontColor ?? '';
};
const $ea9dfdce1bcf6891$export$44ce6761be442ae9 = ()=>{
    const { data: companyThemingSettings } = (0, $ii4ep.useCompanyThemingSettings)();
    const resolvedTheme = (0, $kc9pJ.useResolvedTheme)();
    const navbarColor = resolvedTheme === 'light' ? companyThemingSettings?.navbarColorLight : companyThemingSettings?.navbarColorDark;
    return navbarColor ?? '';
};

});
parcelRegister("ii4ep", function(module, exports) {
$parcel$export(module.exports, "setCachedThemingSettings", () => $4cedf723395debfd$export$3e978c690fdba065);
$parcel$export(module.exports, "useCompanyThemingSettings", () => $4cedf723395debfd$export$452fdb4ed6f4cf76);

var $hAXMW = parcelRequire("hAXMW");

var $bFW4F = parcelRequire("bFW4F");

var $22hwD = parcelRequire("22hwD");

var $1QYE6 = parcelRequire("1QYE6");

var $bI4fx = parcelRequire("bI4fx");
const $4cedf723395debfd$var$THIRTY_MINUTES_MS = 1800000;
/**
 * Checks chrome.storage.local for cached company theming settings via message bus
 */ function $4cedf723395debfd$var$getCachedThemingSettings(siteId) {
    return new Promise((resolve)=>{
        const timeoutId = setTimeout(()=>{
            window.removeEventListener('message', messageHandler);
            resolve(null);
        }, 2000);
        const messageHandler = (event)=>{
            if (event.data.type === 'GET_COMPANY_THEMING_CACHE_RESPONSE') {
                clearTimeout(timeoutId);
                window.removeEventListener('message', messageHandler);
                resolve(event.data.data);
            }
        };
        window.addEventListener('message', messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: 'GET_COMPANY_THEMING_CACHE',
            siteId: siteId
        });
    });
}
function $4cedf723395debfd$export$3e978c690fdba065(siteId, themingSettings) {
    (0, $bI4fx.postMessageToParent)({
        type: 'SET_COMPANY_THEMING_CACHE',
        siteId: siteId,
        themingSettings: themingSettings
    });
}
/**
 * Fetches company theming settings with chrome.storage.local caching
 * - First checks cache, returns if fresh (< 30 min old)
 * - If stale/missing, fetches from API and updates cache
 */ async function $4cedf723395debfd$var$fetchThemingSettingsWithCache(siteId) {
    const cachedData = await $4cedf723395debfd$var$getCachedThemingSettings(siteId);
    if (cachedData !== null) return cachedData;
    const freshData = await (0, $bFW4F.getCompanyThemingSettings)(siteId);
    $4cedf723395debfd$export$3e978c690fdba065(siteId, freshData);
    return freshData;
}
function $4cedf723395debfd$export$452fdb4ed6f4cf76() {
    const siteContext = (0, $1QYE6.useSite)({
        allowUndefined: true
    });
    const siteId = siteContext?.site.workspace.cloudId;
    return (0, $hAXMW.useQuery)({
        queryKey: [
            'companyThemingSettings',
            siteId
        ],
        queryFn: ()=>$4cedf723395debfd$var$fetchThemingSettingsWithCache(siteId),
        enabled: !!siteId,
        throwOnError (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'Error fetching company theming settings'
            });
            return false;
        },
        staleTime: $4cedf723395debfd$var$THIRTY_MINUTES_MS,
        gcTime: $4cedf723395debfd$var$THIRTY_MINUTES_MS * 2,
        refetchOnWindowFocus: false,
        retry: (failureCount, error)=>{
            if (error.statusCode === 429) return false;
            return failureCount < 2;
        }
    });
}

});
parcelRegister("bI4fx", function(module, exports) {
$parcel$export(module.exports, "postMessageToParent", () => $3ab263d3af3d1132$export$a4c9d94f3c8b4b41);
$parcel$export(module.exports, "requestDomContext", () => $3ab263d3af3d1132$export$5f4f1566b18cbae3);

var $4d1Vr = parcelRequire("4d1Vr");

var $dqHaj = parcelRequire("dqHaj");

var $TrAR1 = parcelRequire("TrAR1");
function $3ab263d3af3d1132$export$a4c9d94f3c8b4b41(message) {
    const isSafePostWindowEnabled = (0, $4d1Vr.default).checkGate((0, $TrAR1.STATSIG_FEATURE_GATES).SAFE_POST_WINDOW);
    if (isSafePostWindowEnabled) window.parent.postMessage(message, (0, $dqHaj.extensionUrl));
    else window.parent.postMessage(message, '*');
}
function $3ab263d3af3d1132$export$5f4f1566b18cbae3() {
    $3ab263d3af3d1132$export$a4c9d94f3c8b4b41({
        type: 'REQUEST_DOM_CONTEXT',
        payload: {
            getDomContext: true
        }
    });
}

});


parcelRegister("kc9pJ", function(module, exports) {
$parcel$export(module.exports, "useResolvedTheme", () => $c4e271175ecbc176$export$2a99b39f322aac1c);

var $1v5pe = parcelRequire("1v5pe");

var $kA1Vr = parcelRequire("kA1Vr");
/**
 * Detects the browser's native theme preference.
 * Listens for changes via `prefers-color-scheme` media query.
 *
 * @returns The browser's native theme: "light" | "dark"
 */ const $c4e271175ecbc176$var$useBrowserThemePreference = ()=>{
    const [theme, setTheme] = (0, $1v5pe.useState)(()=>{
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    });
    (0, $1v5pe.useEffect)(()=>{
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e)=>{
            setTheme(e.matches ? 'dark' : 'light');
        };
        mediaQuery.addEventListener('change', handleChange);
        return ()=>mediaQuery.removeEventListener('change', handleChange);
    }, []);
    return theme;
};
const $c4e271175ecbc176$export$2a99b39f322aac1c = ()=>{
    const { localThemeColorMode: localThemeColorMode } = (0, $kA1Vr.useThemeContext)();
    const browserTheme = $c4e271175ecbc176$var$useBrowserThemePreference();
    return localThemeColorMode === 'auto' ? browserTheme : localThemeColorMode;
};

});
parcelRegister("kA1Vr", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $7344e2acf380820b$export$d8964aec282183a3);
$parcel$export(module.exports, "useThemeContext", () => $7344e2acf380820b$export$c4281ec44b929e6);

var $dxx1U = parcelRequire("dxx1U");

var $1v5pe = parcelRequire("1v5pe");

var $fgIUF = parcelRequire("fgIUF");

var $22hwD = parcelRequire("22hwD");

var $bI4fx = parcelRequire("bI4fx");
const $7344e2acf380820b$var$ThemeContext = /*#__PURE__*/ (0, $1v5pe.createContext)(null);
const $7344e2acf380820b$var$useThemeLogic = ()=>{
    const [themeColorMode, setThemeColorMode] = (0, $1v5pe.useState)((0, $fgIUF.getLocalStorageItem)((0, $fgIUF.LocalStorageKey).THEME_COLOR_MODE, 'auto') ?? 'auto');
    const setLocalThemeColorMode = (newTheme)=>{
        setThemeColorMode(newTheme);
        (0, $fgIUF.setLocalStorageItem)((0, $fgIUF.LocalStorageKey).THEME_COLOR_MODE, newTheme);
        // Always post message to parent for theme changes (visual refresh enabled)
        (0, $bI4fx.postMessageToParent)({
            type: 'SET_SIDEPANEL_THEME',
            theme: newTheme
        });
    };
    (0, $1v5pe.useEffect)(()=>{
        // for custom background color
        document.body.classList.remove('theme-light', 'theme-dark');
        document.documentElement.classList.remove('theme-light', 'theme-dark');
        if (themeColorMode === 'light' || themeColorMode === 'dark') {
            document.body.classList.add(`theme-${themeColorMode}`);
            document.documentElement.classList.add(`theme-${themeColorMode}`);
        }
        // for sub-components theme
        (0, $dxx1U.default)({
            light: 'light',
            dark: 'dark',
            colorMode: themeColorMode,
            typography: 'typography'
        }).catch(()=>{
            (0, $22hwD.logInfo)('Failed to set global theme.');
        });
    }, [
        themeColorMode
    ]);
    return {
        localThemeColorMode: themeColorMode,
        setLocalThemeColorMode: setLocalThemeColorMode
    };
};
const $7344e2acf380820b$export$d8964aec282183a3 = ({ children: children })=>{
    const theme = $7344e2acf380820b$var$useThemeLogic();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7344e2acf380820b$var$ThemeContext.Provider, {
        value: theme
    }, children);
};
const $7344e2acf380820b$export$c4281ec44b929e6 = ()=>{
    const context = (0, $1v5pe.useContext)($7344e2acf380820b$var$ThemeContext);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};

});
parcelRegister("dxx1U", function(module, exports) {
$parcel$export(module.exports, "default", () => $b57c42ddde60d130$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $cgaUN = parcelRequire("cgaUN");

var $j3ot2 = parcelRequire("j3ot2");

var $bblC7 = parcelRequire("bblC7");

var $2Cuue = parcelRequire("2Cuue");

var $19yAB = parcelRequire("19yAB");

var $2TWNJ = parcelRequire("2TWNJ");

var $G4moy = parcelRequire("G4moy");

var $faVsI = parcelRequire("faVsI");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $b57c42ddde60d130$var$setGlobalTheme = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $j3ot2.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $j3ot2.themeStateDefaults)['contrastMode'], dark: dark = (0, $j3ot2.themeStateDefaults)['dark'], light: light = (0, $j3ot2.themeStateDefaults)['light'], shape: shape = (0, $j3ot2.themeStateDefaults)['shape'](), spacing: spacing = (0, $j3ot2.themeStateDefaults)['spacing'], typography: typography = (0, $j3ot2.themeStateDefaults)['typography'], motion: motion = (0, $j3ot2.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $j3ot2.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $j3ot2.themeStateDefaults),
        typography: (0, $j3ot2.themeStateDefaults)['typography'],
        shape: (0, $j3ot2.themeStateDefaults)['shape'](),
        motion: (0, $j3ot2.themeStateDefaults)['motion'](),
        ...(0, $cgaUN.default)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $2aEiL.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $2TWNJ.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $faVsI.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $G4moy.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $j3ot2.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $2Cuue.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("6Ncem"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $19yAB.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $bblC7.default)(themeState);
    return autoUnbind;
};
var $b57c42ddde60d130$export$2e2bcd8739ae039 = $b57c42ddde60d130$var$setGlobalTheme;

});
parcelRegister("cgaUN", function(module, exports) {
$parcel$export(module.exports, "default", () => $27604db4b33a1813$export$2e2bcd8739ae039);

var $21yAH = parcelRequire("21yAH");

var $jbymH = parcelRequire("jbymH");

var $anwEU = parcelRequire("anwEU");
const $27604db4b33a1813$var$isThemeColorMode = (colorMode)=>{
    return (0, $jbymH.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $27604db4b33a1813$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $21yAH.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $21yAH.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $anwEU.themeStringToObject)(theme),
        ...$27604db4b33a1813$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $27604db4b33a1813$export$2e2bcd8739ae039 = $27604db4b33a1813$var$getGlobalTheme;

});
parcelRegister("21yAH", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $a4c09e4de3749474$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $a4c09e4de3749474$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $a4c09e4de3749474$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $a4c09e4de3749474$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $a4c09e4de3749474$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $a4c09e4de3749474$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $a4c09e4de3749474$export$9d7b58831ae93caa);
const $a4c09e4de3749474$export$4ef52930e33717cd = 'data-theme';
const $a4c09e4de3749474$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $a4c09e4de3749474$export$a00eac3f8684bcd0 = 'data-color-mode';
const $a4c09e4de3749474$export$2112803007239c61 = 'data-contrast-mode';
const $a4c09e4de3749474$export$352e418ed5b6193a = 'data-custom-theme';
const $a4c09e4de3749474$export$6f0c6fb8c80fcc92 = 'ds';
const $a4c09e4de3749474$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $a4c09e4de3749474$export$dddac1532e822863 = `--${$a4c09e4de3749474$export$6f0c6fb8c80fcc92}-token-not-found`;
const $a4c09e4de3749474$export$9d7b58831ae93caa = `--${$a4c09e4de3749474$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});

parcelRegister("jbymH", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $aad8be85ed571266$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $aad8be85ed571266$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});

parcelRegister("anwEU", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $48cef401e2b6925b$export$f19b488f7c0547ee);

var $fcMBA = parcelRequire("fcMBA");

var $VJ5Z0 = parcelRequire("VJ5Z0");

var $lMeSE = parcelRequire("lMeSE");
const $48cef401e2b6925b$var$customThemeOptions = 'UNSAFE_themeOptions';
const $48cef401e2b6925b$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $fcMBA.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $lMeSE.isThemeKind)(kind) && (0, $VJ5Z0.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $48cef401e2b6925b$var$customThemeOptions) try {
            themeObject[$48cef401e2b6925b$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});
parcelRegister("fcMBA", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $e8b8be26062c0434$export$4a14e169b1de4ee7);
const $e8b8be26062c0434$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("VJ5Z0", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $bac7a593658e72f7$export$ea35b8958c39dd07);

var $fdGCC = parcelRequire("fdGCC");
const $bac7a593658e72f7$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $fdGCC.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("fdGCC", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $2afeb8891762b84b$export$7d43e72a58e3283f);
const $2afeb8891762b84b$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("lMeSE", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $d7ba6b4d02867005$export$958fa026be3a263e);
const $d7ba6b4d02867005$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $d7ba6b4d02867005$export$958fa026be3a263e = (themeKind)=>{
    return $d7ba6b4d02867005$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});



parcelRegister("j3ot2", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $0303901240983f7d$export$9aedcfa7336a207);

var $2aEiL = parcelRequire("2aEiL");
function $0303901240983f7d$var$getShapeDefault() {
    if ((0, $2aEiL.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $0303901240983f7d$var$getMotionDefault() {
    return 'motion';
}
const $0303901240983f7d$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $0303901240983f7d$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $0303901240983f7d$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("bblC7", function(module, exports) {
$parcel$export(module.exports, "default", () => $73be6079969c2763$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $4r3Q4 = parcelRequire("4r3Q4");

var $kGZGA = parcelRequire("kGZGA");

var $hqjx2 = parcelRequire("hqjx2");
function $73be6079969c2763$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $kGZGA.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $kGZGA.default).bind();
    } else (0, $kGZGA.default).unbind();
    if ((0, $2aEiL.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $hqjx2.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $hqjx2.default).bind();
        } else (0, $hqjx2.default).unbind();
    }
    const themeAttributes = (0, $4r3Q4.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $kGZGA.default).unbind();
        if ((0, $2aEiL.fg)('platform_increased-contrast-themes')) (0, $hqjx2.default).unbind();
    };
}

});
parcelRegister("4r3Q4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f9eaf152b5dd551$export$2e2bcd8739ae039);

var $2aEiL = parcelRequire("2aEiL");

var $21yAH = parcelRequire("21yAH");

var $j3ot2 = parcelRequire("j3ot2");

var $5C02M = parcelRequire("5C02M");

var $4Meqh = parcelRequire("4Meqh");

var $G4moy = parcelRequire("G4moy");
const $4f9eaf152b5dd551$var$defaultColorMode = 'light';
const $4f9eaf152b5dd551$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $4f9eaf152b5dd551$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $j3ot2.themeStateDefaults)['colorMode'], dark: dark = (0, $j3ot2.themeStateDefaults)['dark'], light: light = (0, $j3ot2.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $j3ot2.themeStateDefaults)['contrastMode'], motion: motion = (0, $j3ot2.themeStateDefaults)['motion'](), shape: shape = (0, $j3ot2.themeStateDefaults)['shape'](), spacing: spacing = (0, $j3ot2.themeStateDefaults)['spacing'], typography: typography = (0, $j3ot2.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $j3ot2.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $5C02M.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $21yAH.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $21yAH.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $4f9eaf152b5dd551$var$defaultColorMode : colorMode
    };
    if ((0, $2aEiL.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $21yAH.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $4f9eaf152b5dd551$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $G4moy.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $4Meqh.hash)(optionString);
        result[0, $21yAH.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $4f9eaf152b5dd551$export$2e2bcd8739ae039 = $4f9eaf152b5dd551$var$getThemeHtmlAttrs;

});
parcelRegister("5C02M", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $274a5185c74bb2b4$export$62c37ab81302621a);

var $fcMBA = parcelRequire("fcMBA");

var $VJ5Z0 = parcelRequire("VJ5Z0");

var $lMeSE = parcelRequire("lMeSE");
const $274a5185c74bb2b4$var$customThemeOptions = 'UNSAFE_themeOptions';
const $274a5185c74bb2b4$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $fcMBA.isColorMode)(id) || // custom theme state
        kind === $274a5185c74bb2b4$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $lMeSE.isThemeKind)(kind) && typeof id === 'string' && (0, $VJ5Z0.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});

parcelRegister("4Meqh", function(module, exports) {
$parcel$export(module.exports, "hash", () => $eb913f77b484dd70$export$d6af199866bfb566);
const $eb913f77b484dd70$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("G4moy", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $9400dc89a993b258$export$53031ac1ecb71f44);
const $9400dc89a993b258$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("kGZGA", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a1c5147d7a15cbd$export$2e2bcd8739ae039);

var $dmmsG = parcelRequire("dmmsG");

var $21yAH = parcelRequire("21yAH");

var $faVsI = parcelRequire("faVsI");
const $2a1c5147d7a15cbd$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $2a1c5147d7a15cbd$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $21yAH.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $2a1c5147d7a15cbd$var$darkModeMql = $2a1c5147d7a15cbd$var$isMatchMediaAvailable && window.matchMedia((0, $faVsI.darkModeMediaQuery));
class $2a1c5147d7a15cbd$var$ColorModeObserver {
    getColorMode() {
        if (!$2a1c5147d7a15cbd$var$darkModeMql) return 'light';
        return $2a1c5147d7a15cbd$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($2a1c5147d7a15cbd$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dmmsG.bind)($2a1c5147d7a15cbd$var$darkModeMql, {
            type: 'change',
            listener: $2a1c5147d7a15cbd$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $2a1c5147d7a15cbd$var$SingletonColorModeObserver = new $2a1c5147d7a15cbd$var$ColorModeObserver();
var $2a1c5147d7a15cbd$export$2e2bcd8739ae039 = $2a1c5147d7a15cbd$var$SingletonColorModeObserver;

});
parcelRegister("faVsI", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $01f7bf57d53cc3a4$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $01f7bf57d53cc3a4$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $01f7bf57d53cc3a4$export$8662df6937d86fcb);

var $21yAH = parcelRequire("21yAH");

var $3R70r = parcelRequire("3R70r");
const $01f7bf57d53cc3a4$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $21yAH.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $21yAH.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await (0, $3R70r.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $01f7bf57d53cc3a4$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $01f7bf57d53cc3a4$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("3R70r", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $d1f3a79e33812296$export$8a48286ed7df6720);

var $eR5vK = parcelRequire("eR5vK");
const $d1f3a79e33812296$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $eR5vK.default)[themeId]();
    return themeCss;
};

});
parcelRegister("eR5vK", function(module, exports) {
$parcel$export(module.exports, "default", () => $56d63eaf46707399$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









const $56d63eaf46707399$var$themeImportsMap = {
    'light': ()=>(parcelRequire("5nF1U")),
    'light-future': ()=>(parcelRequire("a9H7T")),
    'light-increased-contrast': ()=>(parcelRequire("4Cspo")),
    'dark': ()=>(parcelRequire("6adUK")),
    'dark-future': ()=>(parcelRequire("R1psb")),
    'dark-increased-contrast': ()=>(parcelRequire("d65bH")),
    'spacing': ()=>(parcelRequire("jl6dc")),
    'typography': ()=>(parcelRequire("auKSX")),
    'shape': ()=>(parcelRequire("7tMiW")),
    'motion': ()=>(parcelRequire("9xUwP"))
};
var $56d63eaf46707399$export$2e2bcd8739ae039 = $56d63eaf46707399$var$themeImportsMap;

});
parcelRegister("5nF1U", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('3Gr7K'));

});

parcelRegister("a9H7T", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('8K59U'));

});

parcelRegister("4Cspo", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('6aA9I'));

});

parcelRegister("6adUK", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('865gV'));

});

parcelRegister("R1psb", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('fx9Vc'));

});

parcelRegister("d65bH", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('gjVTm'));

});

parcelRegister("jl6dc", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('a2gva'));

});

parcelRegister("auKSX", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('7yomw'));

});

parcelRegister("7tMiW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('kHC6H'));

});

parcelRegister("9xUwP", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lEmgh").then(()=>parcelRequire('6q7AY'));

});





parcelRegister("hqjx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cad10cccd5b8177$export$2e2bcd8739ae039);

var $dmmsG = parcelRequire("dmmsG");

var $21yAH = parcelRequire("21yAH");

var $faVsI = parcelRequire("faVsI");
const $2cad10cccd5b8177$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $2cad10cccd5b8177$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $21yAH.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $2cad10cccd5b8177$var$contrastModeMql = $2cad10cccd5b8177$var$isMatchMediaAvailable && window.matchMedia((0, $faVsI.moreContrastMediaQuery));
class $2cad10cccd5b8177$var$ContrastModeObserver {
    getContrastMode() {
        if (!$2cad10cccd5b8177$var$contrastModeMql) return 'no-preference';
        return $2cad10cccd5b8177$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($2cad10cccd5b8177$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dmmsG.bind)($2cad10cccd5b8177$var$contrastModeMql, {
            type: 'change',
            listener: $2cad10cccd5b8177$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $2cad10cccd5b8177$var$SingletonContrastModeObserver = new $2cad10cccd5b8177$var$ContrastModeObserver();
var $2cad10cccd5b8177$export$2e2bcd8739ae039 = $2cad10cccd5b8177$var$SingletonContrastModeObserver;

});


parcelRegister("2Cuue", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $635af4f85bb802f7$export$bd1ac9300b0e885a);

var $21yAH = parcelRequire("21yAH");

var $4Meqh = parcelRequire("4Meqh");
function $635af4f85bb802f7$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $4Meqh.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $21yAH.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $21yAH.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("19yAB", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $3921ba61a8ebecb8$export$5d76d7014f4a5d08);
const $3921ba61a8ebecb8$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});

parcelRegister("2TWNJ", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $3b010900218c5883$export$dd6aeb7c823fc03d);

var $2aEiL = parcelRequire("2aEiL");

var $jM9Uu = parcelRequire("jM9Uu");

const $3b010900218c5883$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $2aEiL.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $jM9Uu.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $2aEiL.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $jM9Uu.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});
parcelRegister("jM9Uu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd9e33e8358a7933$export$2e2bcd8739ae039);

var $j750x = parcelRequire("j750x");
function $cd9e33e8358a7933$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $j750x.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});
parcelRegister("j750x", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9791af1a358b5e9$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $fdGCC = parcelRequire("fdGCC");


var $j3ot2 = parcelRequire("j3ot2");
/**
 * Contrast preferences: The system contrast preference
 */ const $b9791af1a358b5e9$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $b9791af1a358b5e9$var$themeOverrideIds = [];
const $b9791af1a358b5e9$export$92ba366331403db2 = [
    ...(0, $fdGCC.themeIds),
    ...$b9791af1a358b5e9$var$themeOverrideIds
];
const $b9791af1a358b5e9$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b9791af1a358b5e9$export$2e2bcd8739ae039 = $b9791af1a358b5e9$var$themeConfig;

});



parcelRegister("6Ncem", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("6hfmJ")
]).then(()=>parcelRequire('YyYQE'));

});





parcelRegister("jqltP", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $22f25ba18ab8de37$export$5120f2d0b8d4cab8);

var $jprnS = parcelRequire("jprnS");

var $1v5pe = parcelRequire("1v5pe");

var $b2Az1 = parcelRequire("b2Az1");

var $eMSEP = parcelRequire("eMSEP");
var $f4K70 = parcelRequire("f4K70");
var $bQOrV = parcelRequire("bQOrV");

var $fBVmT = parcelRequire("fBVmT");
var $hwVAu = parcelRequire("hwVAu");

var $91Vpq = parcelRequire("91Vpq");

var $30A4O = parcelRequire("30A4O");
parcelRequire("calFH");
var $30t8d = parcelRequire("30t8d");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $kA1Vr = parcelRequire("kA1Vr");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $9ALFH = parcelRequire("9ALFH");

var $5DgeC = parcelRequire("5DgeC");

var $3yHBw = parcelRequire("3yHBw");

var $jPKf9 = parcelRequire("jPKf9");

var $fgIUF = parcelRequire("fgIUF");
parcelRequire("atGCc");
var $8VUj0 = parcelRequire("8VUj0");
const $22f25ba18ab8de37$var$blockStyles = (0, $bQOrV.xcss)({
    borderRadius: 'radius.xsmall'
});
const $22f25ba18ab8de37$var$profileContainerStyles = (0, $bQOrV.xcss)({
    cursor: 'pointer'
});
const $22f25ba18ab8de37$export$5120f2d0b8d4cab8 = ({ userAccount: userAccount, site: site, showWhatsNewButton: showWhatsNewButton })=>{
    const currentScreenName = (0, $jPKf9.useCurrentScreenName)();
    const rovoLogoutUrl = `${(0, $dqHaj.getRovoExtensionWebBaseUrl)()}/extension/log-out`;
    const LAST_SEEN_ID = 'lastSeenAnnouncementId';
    const navigate = (0, $30t8d.useNavigate)();
    const { localThemeColorMode: localThemeColorMode, setLocalThemeColorMode: setLocalThemeColorMode } = (0, $kA1Vr.useThemeContext)();
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = (0, $1v5pe.useState)(false);
    const showFeedbackButton = userAccount.accountId && site;
    const handleFeedbackClick = ()=>{
        setIsFeedbackModalOpen(true);
        // https://data-portal.internal.atlassian.com/analytics/registry/73849
        sendAnalyticEvent({
            eventType: 'ui',
            event: {
                action: 'click',
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).FEEDBACK_BUTTON,
                source: currentScreenName
            },
            userId: userAccount.accountId
        });
    };
    const handleWhatsNewClick = ()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/77235
        sendAnalyticEvent({
            eventType: 'ui',
            event: {
                action: 'click',
                source: currentScreenName,
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).OPEN_MENU_TAB_BUTTON
            },
            userId: userAccount.accountId
        });
        if ((0, $9ALFH.announcements).length > 0) (0, $fgIUF.setLocalStorageItemRawString)(LAST_SEEN_ID, (0, $9ALFH.announcements)[0].id);
        // https://data-portal.internal.atlassian.com/analytics/registry/79796
        sendAnalyticEvent({
            eventType: 'track',
            event: {
                action: 'navigate',
                actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).WHATS_NEW,
                source: currentScreenName
            },
            userId: userAccount.accountId
        });
        navigate('/extension/menu');
    };
    const profileUrl = site ? `${(0, $dqHaj.getAtlassianHomeUrl)()}/o/${site.workspace.organisationId}/people/${userAccount.accountId}?cloudId=${site.workspace.cloudId}` : `${(0, $dqHaj.getAtlassianHomeUrl)()}/people/me`;
    const handleViewProfileClick = (event)=>{
        // The default behavior will load the profile page as an iframe, which we want to avoid.
        event.preventDefault();
        window.open(profileUrl, '_blank');
    };
    const handleThemeChange = (theme)=>{
        setLocalThemeColorMode(theme);
        // https://data-portal.internal.atlassian.com/analytics/registry/86671
        sendAnalyticEvent({
            eventType: 'track',
            event: {
                action: 'switched',
                actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).THEME,
                source: currentScreenName
            },
            userId: userAccount.accountId
        });
    };
    const extraMenuItems = [
        showWhatsNewButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fBVmT.default), {
            key: "whats-new",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91Vpq))), {
                label: "Menu"
            }),
            onClick: handleWhatsNewClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $5DgeC.messages).whatsNew)),
        showFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fBVmT.default), {
            key: "give-feedback",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($30A4O))), {
                label: "feedback"
            }),
            onClick: handleFeedbackClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $5DgeC.messages).giveFeedback))
    ].filter(Boolean);
    const finalMenuItems = extraMenuItems.length > 0 ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hwVAu.default), {
            key: "extra-menu-items",
            hasSeparator: true
        }, extraMenuItems)
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8VUj0.SessionReplayUGC), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        testId: "profile-container",
        xcss: $22f25ba18ab8de37$var$blockStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        alignInline: "end",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $22f25ba18ab8de37$var$profileContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $jprnS.AccountMenuNav3), {
        currentTheme: localThemeColorMode,
        email: userAccount.email,
        extraMenuItems: finalMenuItems,
        logOutLink: rovoLogoutUrl,
        name: userAccount.name,
        onThemeChange: handleThemeChange,
        onViewProfileClick: handleViewProfileClick,
        picture: userAccount.picture,
        testId: "account-menu",
        viewProfileLink: profileUrl
    }))))), showFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $3yHBw.default), {
        setShowModal: (showModal)=>setIsFeedbackModalOpen(showModal),
        showModal: isFeedbackModalOpen,
        site: site,
        userAccount: userAccount
    }));
};

});
parcelRegister("jprnS", function(module, exports) {
$parcel$export(module.exports, "AccountMenuNav3", () => $d1108b658753162c$export$4ff56e5cf713dc64);

var $1v5pe = parcelRequire("1v5pe");

var $fATQl = parcelRequire("fATQl");

var $jkNcg = parcelRequire("jkNcg");

var $jvTx6 = parcelRequire("jvTx6");
const $d1108b658753162c$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $jvTx6.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $fATQl.AccountMenuLoggedOutStateNav3),
        AccountMenuTrigger: (0, $jkNcg.AccountMenuTriggerNav3)
    });
};

});
parcelRegister("fATQl", function(module, exports) {
$parcel$export(module.exports, "AccountMenuLoggedOutStateNav3", () => $cbb56b11f15dd89e$export$5e6158d2118ae4aa);

var $1v5pe = parcelRequire("1v5pe");

var $gIVhA = parcelRequire("gIVhA");

var $5zCRw = parcelRequire("5zCRw");

var $lnQLz = parcelRequire("lnQLz");

var $eMx2y = parcelRequire("eMx2y");
const $cbb56b11f15dd89e$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $gIVhA.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $lnQLz.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $eMx2y.logInTooltip),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5zCRw))), {
            color: "currentColor",
            label: ""
        })
    });

});
parcelRegister("5zCRw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::507659515fe9bcca164f85b1b4a1c070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40ee5dde512b11cd$var$_react = $40ee5dde512b11cd$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $40ee5dde512b11cd$var$_baseNew = $40ee5dde512b11cd$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $40ee5dde512b11cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-in
 * Usage guidance:
 * Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40ee5dde512b11cd$var$LogInIcon = (props)=>/*#__PURE__*/ $40ee5dde512b11cd$var$_react.default.createElement($40ee5dde512b11cd$var$_baseNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$40ee5dde512b11cd$var$LogInIcon.displayName = 'LogInIcon';
var $40ee5dde512b11cd$var$_default = module.exports.default = $40ee5dde512b11cd$var$LogInIcon;

});
parcelRegister("9ZOp1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("5CpUv")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("5CpUv")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $5CpUv = parcelRequire("5CpUv");

});
parcelRegister("5CpUv", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $2ca28ffd177dec65$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $2ca28ffd177dec65$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $2ca28ffd177dec65$var$svgStyles = null;
const $2ca28ffd177dec65$var$iconStyles = null;
const $2ca28ffd177dec65$var$smallIconStyles = null;
const $2ca28ffd177dec65$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $2ca28ffd177dec65$var$baseHcmStyles = null;
const $2ca28ffd177dec65$var$scaleSize = null;
const $2ca28ffd177dec65$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $2ca28ffd177dec65$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $2ca28ffd177dec65$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $2ca28ffd177dec65$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1v5pe.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $2ca28ffd177dec65$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $1v5pe.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $hMvDh.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $1v5pe.createElement("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $hMvDh.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $2ca28ffd177dec65$var$coreSizeSmall[spacing] : $2ca28ffd177dec65$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2ca28ffd177dec65$export$2e2bcd8739ae039 = $2ca28ffd177dec65$export$f04a61298a47a40f;

});



parcelRegister("lnQLz", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $814f021136935840$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $814f021136935840$export$3cbe56a0cabcff38);
const $814f021136935840$export$515664faa1398f37 = 'navigation';
const $814f021136935840$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: undefined,
    packageVersion: undefined
};

});

parcelRegister("eMx2y", function(module, exports) {
$parcel$export(module.exports, "logInTooltip", () => $21d0f780c54243fe$export$b495e6c63a3a03c1);

var $1v5pe = parcelRequire("1v5pe");

var $b2Az1 = parcelRequire("b2Az1");
const $21d0f780c54243fe$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});


parcelRegister("jkNcg", function(module, exports) {
$parcel$export(module.exports, "AccountMenuTriggerNav3", () => $b50bc65dc9519b6f$export$89d857133932d6aa);
/* nav3.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $kK7WO = parcelRequire("kK7WO");

var $gIVhA = parcelRequire("gIVhA");

var $bsPVC = parcelRequire("bsPVC");

var $i6IfC = parcelRequire("i6IfC");

var $69Imn = parcelRequire("69Imn");
const $b50bc65dc9519b6f$var$imgStyles = null;
const $b50bc65dc9519b6f$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $kK7WO.default)();
    const state = (0, $i6IfC.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $69Imn.messages).triggerTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $gIVhA.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("img", {
            src: picture,
            alt: tooltip,
            className: (0, $hMvDh.default)([
                "_2rko1rr0 _1bsb1ejb _4t3i1ejb"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsPVC))), {
            color: "currentColor",
            label: tooltip,
            spacing: "spacious"
        })
    });
});

});
parcelRegister("bsPVC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::535899575b09ff56fcaf3a7be26604a1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $858a971b6016bac1$var$_react = $858a971b6016bac1$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $858a971b6016bac1$var$_baseNew = $858a971b6016bac1$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $858a971b6016bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-avatar
 * Usage guidance:
 * Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $858a971b6016bac1$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $858a971b6016bac1$var$_react.default.createElement($858a971b6016bac1$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$858a971b6016bac1$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $858a971b6016bac1$var$_default = module.exports.default = $858a971b6016bac1$var$PersonAvatarIcon;

});

parcelRegister("i6IfC", function(module, exports) {
$parcel$export(module.exports, "useImageState", () => $48ca804ce55be9a3$export$2c1df3428fc3264c);

var $1v5pe = parcelRequire("1v5pe");
const $48ca804ce55be9a3$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $1v5pe.useState)('pending');
    const imgRef = (0, $1v5pe.useRef)();
    (0, $1v5pe.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("69Imn", function(module, exports) {
$parcel$export(module.exports, "messages", () => $07f7234300e2230d$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $07f7234300e2230d$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});

});


parcelRegister("jvTx6", function(module, exports) {
$parcel$export(module.exports, "AccountMenu", () => $0ca6268674d742c8$export$ff20d75d5eda4388);

var $1v5pe = parcelRequire("1v5pe");

var $VveMF = parcelRequire("VveMF");

var $lnQLz = parcelRequire("lnQLz");

var $6QyvR = parcelRequire("6QyvR");

var $kXYZ2 = parcelRequire("kXYZ2");

var $4bmyg = parcelRequire("4bmyg");
const $0ca6268674d742c8$export$ff20d75d5eda4388 = ({ testId: testId, globalColorMode: globalColorMode, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange, avatarOverlay: avatarOverlay, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $VveMF.NavigationAnalyticsContext), {
        data: (0, $lnQLz.ANALYTICS_CONTEXT)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kXYZ2.AccountMenuIntlProvider), null, logInLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(AccountMenuLoggedOutState, {
        testId: testId && `${testId}--logged-out-state`,
        logInLink: logInLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $4bmyg.AccountMenuPopup), {
        testId: testId,
        picture: picture,
        trustPicture: trustPicture,
        email: email,
        AccountMenuTrigger: AccountMenuTrigger,
        content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6QyvR.AccountMenuContent), {
                testId: testId && `${testId}--content`,
                closePopup: closePopup,
                globalColorMode: globalColorMode,
                name: name,
                picture: picture,
                email: email,
                managedBy: managedBy,
                manageProfileLink: manageProfileLink,
                viewProfileLink: viewProfileLink,
                onViewProfileClick: onViewProfileClick,
                switchAccountLink: switchAccountLink,
                logOutLink: logOutLink,
                onThemeChange: onThemeChange,
                currentTheme: currentTheme,
                extraMenuItems: extraMenuItems,
                onLogoutClick: onLogoutClick,
                onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
                avatarOverlay: avatarOverlay
            })
    })));

});
parcelRegister("6QyvR", function(module, exports) {
$parcel$export(module.exports, "AccountMenuContent", () => $5b90441d590bcd04$export$49c2771125e1e9f1);
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $b2Az1 = parcelRequire("b2Az1");

var $9hVBA = parcelRequire("9hVBA");

var $8g8jL = parcelRequire("8g8jL");

var $iX39w = parcelRequire("iX39w");

var $4UBIg = parcelRequire("4UBIg");

var $75khh = parcelRequire("75khh");

var $iWseU = parcelRequire("iWseU");

var $gVHHY = parcelRequire("gVHHY");
var $97k28 = parcelRequire("97k28");
var $hwVAu = parcelRequire("hwVAu");

var $2aEiL = parcelRequire("2aEiL");

var $fc9Ow = parcelRequire("fc9Ow");

var $lnQLz = parcelRequire("lnQLz");

var $2BSFi = parcelRequire("2BSFi");

var $ezqtN = parcelRequire("ezqtN");
const $5b90441d590bcd04$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, extraMenuItems: extraMenuItems = null, onLogoutClick: onLogoutClick, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange, avatarOverlay: avatarOverlay })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $97k28.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hwVAu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2BSFi.AccountDetails), {
        testId: testId && `${testId}--details`,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy,
        avatarOverlay: avatarOverlay
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hwVAu.default), null, viewProfileLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && `${testId}--view-profile`,
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$ManageProfileLink, {
        testId: testId && `${testId}--manage-profile`,
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && ((0, $2aEiL.fg)('replace-account-menu-theme-switcher') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fc9Ow.default), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentColorMode: currentTheme,
        accountColorMode: globalColorMode ?? undefined,
        onOpenChange: onThemeSwitcherOpenChange,
        appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $ezqtN.ThemeSwitcher), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme,
        globalColorMode: globalColorMode,
        onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
        appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink?.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
    }))), extraMenuItems, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hwVAu.default), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$SwitchAccountLink, {
        testId: testId && `${testId}--switch-account`,
        href: switchAccountLink,
        closePopup: closePopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$LogOutLink, {
        testId: testId && `${testId}--log-out`,
        href: logOutLink,
        closePopup: closePopup,
        onClick: onLogoutClick
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5b90441d590bcd04$var$Container = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_vchhusvi _1ul9ko4j",
            __cmplp.className
        ])
    });
});
const $5b90441d590bcd04$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75khh))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile",
        description: "Text shown when hovering over profile information"
    }));
const $5b90441d590bcd04$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iWseU))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings",
        description: "Text for link to account management page"
    }));
const $5b90441d590bcd04$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4UBIg))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account",
        description: "Label for button in account menu to switch to another another account"
    }));
const $5b90441d590bcd04$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($5b90441d590bcd04$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iX39w))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out",
        description: "Label for button in account menu to log out"
    }));
const $5b90441d590bcd04$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    const handleClick = (0, $1v5pe.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $9hVBA.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $lnQLz.NAVIGATION_CHANNEL));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $gVHHY.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props
    }, children);
};

});
parcelRegister("8g8jL", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $623fc1d773e1d7c1$export$5bf35293e545f20c);

var $dfVKT = parcelRequire("dfVKT");

var $2wC77 = parcelRequire("2wC77");

var $4jgWK = parcelRequire("4jgWK");
function $623fc1d773e1d7c1$export$5bf35293e545f20c() {
    const analyticsContext = (0, $4jgWK.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $dfVKT.useCallbackOne)((payload)=>{
        return new (0, $2wC77.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dfVKT", function(module, exports) {
$parcel$export(module.exports, "useCallbackOne", () => $9a697a1a20f1eb39$export$33752cf3ee811995);
$parcel$export(module.exports, "useMemo", () => $9a697a1a20f1eb39$export$1538c33de8887b59);
$parcel$export(module.exports, "useCallback", () => $9a697a1a20f1eb39$export$35808ee640e87ca7);

var $1v5pe = parcelRequire("1v5pe");
function $9a697a1a20f1eb39$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $9a697a1a20f1eb39$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $1v5pe.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $1v5pe.useRef)(true);
    var committed = (0, $1v5pe.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $9a697a1a20f1eb39$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $1v5pe.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $9a697a1a20f1eb39$export$33752cf3ee811995(callback, inputs) {
    return $9a697a1a20f1eb39$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $9a697a1a20f1eb39$export$1538c33de8887b59 = $9a697a1a20f1eb39$export$b6feb8998cd9b342;
var $9a697a1a20f1eb39$export$35808ee640e87ca7 = $9a697a1a20f1eb39$export$33752cf3ee811995;

});

parcelRegister("2wC77", function(module, exports) {
$parcel$export(module.exports, "default", () => $828c4c3689eba8e0$export$2e2bcd8739ae039);
/// <reference types="node" />

var $2aEiL = parcelRequire("2aEiL");

var $fHJyA = parcelRequire("fHJyA");
class $828c4c3689eba8e0$export$2e2bcd8739ae039 extends (0, $fHJyA.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = $828c4c3689eba8e0$var$clonePayload(this.payload);
            return new $828c4c3689eba8e0$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}
const $828c4c3689eba8e0$var$clonePayload = (payload)=>{
    if ((0, $2aEiL.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};

});
parcelRegister("fHJyA", function(module, exports) {
$parcel$export(module.exports, "default", () => $45979b05f235576b$export$2e2bcd8739ae039);
class $45979b05f235576b$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $45979b05f235576b$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("4jgWK", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $bd63b222505563e4$export$d1f587f82ad51c4);

var $1v5pe = parcelRequire("1v5pe");

var $eRjpU = parcelRequire("eRjpU");
const $bd63b222505563e4$export$d1f587f82ad51c4 = ()=>{
    return (0, $1v5pe.useContext)((0, $eRjpU.default));
};

});
parcelRegister("eRjpU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ad1513b8943145a5$export$2e2bcd8739ae039);

var $aABFI = parcelRequire("aABFI");
var $ad1513b8943145a5$export$2e2bcd8739ae039 = (0, $aABFI.default);

});
parcelRegister("aABFI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b5a7d05a8905834$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
var $7b5a7d05a8905834$var$AnalyticsNextContext = (0, $1v5pe.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $7b5a7d05a8905834$export$2e2bcd8739ae039 = $7b5a7d05a8905834$var$AnalyticsNextContext;

});




parcelRegister("iX39w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4306c086c5cd10c1744314f905c12513>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcc02eb99c9c1f4d$var$_react = $dcc02eb99c9c1f4d$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $dcc02eb99c9c1f4d$var$_baseNew = $dcc02eb99c9c1f4d$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $dcc02eb99c9c1f4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-out
 * Usage guidance:
 * Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dcc02eb99c9c1f4d$var$LogOutIcon = (props)=>/*#__PURE__*/ $dcc02eb99c9c1f4d$var$_react.default.createElement($dcc02eb99c9c1f4d$var$_baseNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$dcc02eb99c9c1f4d$var$LogOutIcon.displayName = 'LogOutIcon';
var $dcc02eb99c9c1f4d$var$_default = module.exports.default = $dcc02eb99c9c1f4d$var$LogOutIcon;

});

parcelRegister("4UBIg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df4fc88f40749d293570c808b4b489c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3939a55e6dd553e8$var$_react = $3939a55e6dd553e8$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3939a55e6dd553e8$var$_baseNew = $3939a55e6dd553e8$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $3939a55e6dd553e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/people-group
 * Usage guidance:
 * Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3939a55e6dd553e8$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $3939a55e6dd553e8$var$_react.default.createElement($3939a55e6dd553e8$var$_baseNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$3939a55e6dd553e8$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $3939a55e6dd553e8$var$_default = module.exports.default = $3939a55e6dd553e8$var$PeopleGroupIcon;

});

parcelRegister("75khh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78e29a42ae04e7de3faf9cb14ac698bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5288bac71b6a8977$var$_react = $5288bac71b6a8977$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $5288bac71b6a8977$var$_baseNew = $5288bac71b6a8977$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $5288bac71b6a8977$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5288bac71b6a8977$var$PersonIcon = (props)=>/*#__PURE__*/ $5288bac71b6a8977$var$_react.default.createElement($5288bac71b6a8977$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$5288bac71b6a8977$var$PersonIcon.displayName = 'PersonIcon';
var $5288bac71b6a8977$var$_default = module.exports.default = $5288bac71b6a8977$var$PersonIcon;

});

parcelRegister("iWseU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e14a292f801fb6f142cba86986a6f69b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dca38c8a49e32505$var$_react = $dca38c8a49e32505$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $dca38c8a49e32505$var$_baseNew = $dca38c8a49e32505$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $dca38c8a49e32505$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dca38c8a49e32505$var$SettingsIcon = (props)=>/*#__PURE__*/ $dca38c8a49e32505$var$_react.default.createElement($dca38c8a49e32505$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$dca38c8a49e32505$var$SettingsIcon.displayName = 'SettingsIcon';
var $dca38c8a49e32505$var$_default = module.exports.default = $dca38c8a49e32505$var$SettingsIcon;

});

parcelRegister("2BSFi", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $7c93bbd68c7bdfde$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
var $13EEb = parcelRequire("13EEb");

var $b2Az1 = parcelRequire("b2Az1");

var $75khh = parcelRequire("75khh");

var $eRdXd = parcelRequire("eRdXd");

var $6exOV = parcelRequire("6exOV");

var $8be8g = parcelRequire("8be8g");
const $7c93bbd68c7bdfde$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, avatarOverlay: avatarOverlay })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$ManagedBy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$PersonIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75khh))), {
        color: "currentColor",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        description: "Label showing the user which organisation manages their Atlassian account",
        values: {
            b: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eRdXd.Text), {
                    as: "strong",
                    size: "small",
                    color: "inherit"
                }, text),
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email,
        avatarOverlay: avatarOverlay
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c93bbd68c7bdfde$var$Container = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $7c93bbd68c7bdfde$var$ManagedBy = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cp8ho _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _y3gn1h6o _13lifajl _qrwqfajl _mrkbidpf _1o0zidpf _bfhk19ip _syazazsu",
            __cmplp.className
        ])
    });
});
const $7c93bbd68c7bdfde$var$PersonIconWrapper = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_2hwx1b66 _nbgx1crf _1f021crf",
            __cmplp.className
        ])
    });
});
const $7c93bbd68c7bdfde$var$Content = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasHeader: hasHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1xsu82h": (0, $13EEb.default)(__cmplp.hasHeader ? `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}` : "var(--ds-radius-small, 3px)")
        },
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_2rko107z _1e0c1txw _2lx21bp4 _bfhkhfxm",
            __cmplp.className
        ])
    });
});
const $7c93bbd68c7bdfde$var$Profile = ({ name: name, email: email, picture: picture, testId: testId, avatarOverlay: avatarOverlay })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$ProfileWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6exOV.ProfilePicture), {
        src: picture,
        testId: testId && `${testId}--picture`,
        avatarOverlay: avatarOverlay
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$NameAndEmail, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eRdXd.Text), {
        size: "large",
        weight: "bold",
        testId: testId && `${testId}--name`
    }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8be8g.SkeletonText), {
        length: "6em"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7c93bbd68c7bdfde$var$EmailAddress, {
        "data-testid": testId && `${testId}--email`
    }, email || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8be8g.SkeletonText), {
        length: "10em"
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c93bbd68c7bdfde$var$ProfileWrapper = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_1e0c1txw _2lx2vrvc _19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $7c93bbd68c7bdfde$var$NameAndEmail = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_1e0c1txw _2lx21bp4 _19pk1wug _2hwxidpf _otyr1wug _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $7c93bbd68c7bdfde$var$EmailAddress = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_19pkv77o _syaz1rpy _k48pi7a9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("13EEb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5599ec4b92df05$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $0c5599ec4b92df05$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("6exOV", function(module, exports) {
$parcel$export(module.exports, "ProfilePicture", () => $0bdb5e2517f76831$export$2d75367b6e042d67);
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ /* index.tsx generated by @compiled/babel-plugin v0.40.0 */ /* index.tsx generated by @compiled/babel-plugin v0.40.0 */ // eslint-disable-next-line no-restricted-imports

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $bsPVC = parcelRequire("bsPVC");

var $8GxWE = parcelRequire("8GxWE");

var $i6IfC = parcelRequire("i6IfC");
const $0bdb5e2517f76831$var$styles = {
    imgContainer: "_1bsbvbgk _4t3ivbgk _mezjvbgk _w8l5vbgk _bna7vbgk _1752vbgk",
    imgContainerSkeleton: "_2rko1rr0 _bfhki8nm",
    img: "_2rko1rr0 _1e0c1ule",
    overlayWrapper: "_kqswh2mm _1e0c1o8l"
};
const $0bdb5e2517f76831$export$2d75367b6e042d67 = ({ testId: testId, src: src, avatarOverlay: avatarOverlay })=>{
    const state = (0, $i6IfC.useImageState)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ $1v5pe.createElement((0, $8GxWE.Box), {
        xcss: avatarOverlay ? $0bdb5e2517f76831$var$styles.overlayWrapper : undefined
    }, /*#__PURE__*/ $1v5pe.createElement((0, $8GxWE.Box), {
        testId: testId,
        xcss: (0, $hGIzV.cx)($0bdb5e2517f76831$var$styles.imgContainer, displaySkeleton && $0bdb5e2517f76831$var$styles.imgContainerSkeleton)
    }, displayImage && /*#__PURE__*/ $1v5pe.createElement("img", {
        "data-testid": testId && `${testId}--img`,
        src: src,
        alt: "",
        className: (0, $hMvDh.default)([
            $0bdb5e2517f76831$var$styles.img
        ])
    }), displayFallback && /*#__PURE__*/ $1v5pe.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsPVC))), {
        spacing: "spacious",
        testId: testId && `${testId}--fallback`,
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    })), avatarOverlay);
};

});
parcelRegister("hGIzV", function(module, exports) {
$parcel$export(module.exports, "cx", () => $ce08f04945169e71$export$a274e22fb40f762e);

var $hMvDh = parcelRequire("hMvDh");
const $ce08f04945169e71$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $hMvDh.default)(actualStyles);
};

});


parcelRegister("8be8g", function(module, exports) {
$parcel$export(module.exports, "SkeletonText", () => $66b2cab85eef7da4$export$cb6ddd830302c2a8);
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $89lSy = parcelRequire("89lSy");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $66b2cab85eef7da4$var$SkeletonWrapper = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hMvDh.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $66b2cab85eef7da4$export$cb6ddd830302c2a8 = ({ length: length })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($66b2cab85eef7da4$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $89lSy.default), {
        width: length,
        height: "1em",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }));

});


parcelRegister("ezqtN", function(module, exports) {
$parcel$export(module.exports, "ThemeSwitcher", () => $0b79ba7f8cea0fe5$export$9d63163ee2173b37);

var $1v5pe = parcelRequire("1v5pe");

var $75IaS = parcelRequire("75IaS");
var $b2Az1 = parcelRequire("b2Az1");

var $jglR3 = parcelRequire("jglR3");
var $2iPkt = parcelRequire("2iPkt");
var $f0dDz = parcelRequire("f0dDz");
var $bF8jv = parcelRequire("bF8jv");

var $50r2H = parcelRequire("50r2H");

var $euBeS = parcelRequire("euBeS");

var $axNvh = parcelRequire("axNvh");

var $fBVmT = parcelRequire("fBVmT");

var $bkr3m = parcelRequire("bkr3m");
var $2txLH = parcelRequire("2txLH");
var $eRdXd = parcelRequire("eRdXd");

var $fpxBl = parcelRequire("fpxBl");

var $dmuCW = parcelRequire("dmuCW");

var $jUMJo = parcelRequire("jUMJo");
const $0b79ba7f8cea0fe5$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme, globalColorMode: globalColorMode, appearancePreferencesLink: appearancePreferencesLink, onThemeSwitcherOpenChange: onThemeSwitcherOpenChange })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, $0b79ba7f8cea0fe5$var$themeOptions.map(({ value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("link", {
            rel: "preload",
            href: thumbnail,
            as: "image",
            key: value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $jglR3.default), {
        testId: testId,
        placement: "auto-start",
        onOpenChange: onThemeSwitcherOpenChange,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fBVmT.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($axNvh))), {
                    color: "currentColor",
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50r2H))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                }),
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
                id: "identity.account-menu.theme-switcher.theme-button",
                defaultMessage: "Theme",
                description: "Label for button in the account menu to switch to a different theme"
            })),
        shouldRenderToParent: false
    }, $0b79ba7f8cea0fe5$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>{
        const isSynced = globalColorMode !== undefined && globalColorMode === value;
        const isSelected = currentTheme === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bF8jv.default), {
            testId: `${testId}--radio-${value}`,
            id: value,
            key: value,
            onClick: ()=>onThemeChange(value),
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bkr3m.Inline), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("img", {
            src: thumbnail,
            width: 64,
            height: 48,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2txLH.Stack), {
            space: "space.025"
        }, label, isSynced && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eRdXd.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), $0b79ba7f8cea0fe5$var$messages.syncedAcrossApps)))));
    }), appearancePreferencesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f0dDz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2iPkt.default), {
        href: appearancePreferencesLink,
        target: "_blank",
        rel: "noopener",
        testId: testId && `${testId}--personalize`,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euBeS))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), $0b79ba7f8cea0fe5$var$messages.personalize)))));
};
const $0b79ba7f8cea0fe5$var$messages = (0, $75IaS.defineMessages)({
    light: {
        id: 'identity.account-menu.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'identity.account-menu.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'identity.account-menu.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    },
    syncedAcrossApps: {
        id: 'identity.account-menu.theme-switcher.synced-across-apps',
        defaultMessage: 'Synced across apps',
        description: 'Indicates the theme option is synced with global account settings across all apps'
    },
    personalize: {
        id: 'identity.account-menu.theme-switcher.personalize',
        defaultMessage: 'Personalize',
        description: 'Link to personalize settings in the theme switcher menu'
    }
});
const $0b79ba7f8cea0fe5$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), $0b79ba7f8cea0fe5$var$messages.light),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($dmuCW)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), $0b79ba7f8cea0fe5$var$messages.dark),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($fpxBl)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), $0b79ba7f8cea0fe5$var$messages.matchBrowser),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($jUMJo)))
    }
];

});
parcelRegister("50r2H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae4272f6629317895b037fe9aca7fab1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51edf1314ec529$var$_react = $3a51edf1314ec529$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $3a51edf1314ec529$var$_baseNew = $3a51edf1314ec529$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $3a51edf1314ec529$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-right
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51edf1314ec529$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $3a51edf1314ec529$var$_react.default.createElement($3a51edf1314ec529$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$3a51edf1314ec529$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $3a51edf1314ec529$var$_default = module.exports.default = $3a51edf1314ec529$var$ChevronRightIcon;

});

parcelRegister("euBeS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4f837bc4fc4ebb0701c77b659a16c91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8d0c0ee312ca8c3$var$_react = $a8d0c0ee312ca8c3$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $a8d0c0ee312ca8c3$var$_baseNew = $a8d0c0ee312ca8c3$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $a8d0c0ee312ca8c3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-external
 * Usage guidance:
 * Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8d0c0ee312ca8c3$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $a8d0c0ee312ca8c3$var$_react.default.createElement($a8d0c0ee312ca8c3$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$a8d0c0ee312ca8c3$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $a8d0c0ee312ca8c3$var$_default = module.exports.default = $a8d0c0ee312ca8c3$var$LinkExternalIcon;

});

parcelRegister("axNvh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7bf27e3feec66e04a5aec92b6d9b745>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ad362cb62dc8147$var$_react = $7ad362cb62dc8147$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $7ad362cb62dc8147$var$_baseNew = $7ad362cb62dc8147$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $7ad362cb62dc8147$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/theme
 * Usage guidance:
 * Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ad362cb62dc8147$var$ThemeIcon = (props)=>/*#__PURE__*/ $7ad362cb62dc8147$var$_react.default.createElement($7ad362cb62dc8147$var$_baseNew.default, Object.assign({
        name: "ThemeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$7ad362cb62dc8147$var$ThemeIcon.displayName = 'ThemeIcon';
var $7ad362cb62dc8147$var$_default = module.exports.default = $7ad362cb62dc8147$var$ThemeIcon;

});

parcelRegister("fpxBl", function(module, exports) {
module.exports = new URL("dark-mode.c2768bcf.svg", import.meta.url).toString();

});

parcelRegister("dmuCW", function(module, exports) {
module.exports = new URL("light-mode.e7c3914f.svg", import.meta.url).toString();

});

parcelRegister("jUMJo", function(module, exports) {
module.exports = new URL("match-browser.a2bb9bea.svg", import.meta.url).toString();

});



parcelRegister("kXYZ2", function(module, exports) {
$parcel$export(module.exports, "AccountMenuIntlProvider", () => $39a65d2c804a7763$export$6c1f1571e3dd1b34);

var $1v5pe = parcelRequire("1v5pe");

var $cZ6aD = parcelRequire("cZ6aD");
var $kK7WO = parcelRequire("kK7WO");

var $MfUDF = parcelRequire("MfUDF");

var $k1Wvt = parcelRequire("k1Wvt");
const $39a65d2c804a7763$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $kK7WO.default)();
    const messages = $39a65d2c804a7763$var$useMessages(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cZ6aD.default), {
        locale: locale,
        messages: messages,
        onError: (err)=>{
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($k1Wvt?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        }
    }, children);
};
const $39a65d2c804a7763$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $1v5pe.useState)();
    (0, $1v5pe.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $39a65d2c804a7763$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $39a65d2c804a7763$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $MfUDF.default)[`${language}_${region}`] || (0, $MfUDF.default)[language])?.())?.default;
};

});
parcelRegister("MfUDF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8ee91bb986f9cd1$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $e8ee91bb986f9cd1$var$lazyMessages = {
    cs: ()=>(parcelRequire("lAegX")),
    cs_CZ: ()=>(parcelRequire("fUnZs")),
    da: ()=>(parcelRequire("3HKSQ")),
    da_DK: ()=>(parcelRequire("c0dIo")),
    de: ()=>(parcelRequire("jET4n")),
    de_DE: ()=>(parcelRequire("ba4lE")),
    en_GB: ()=>(parcelRequire("h2e9w")),
    en_ZZ: ()=>(parcelRequire("5Bpnb")),
    es: ()=>(parcelRequire("aXkgG")),
    fi: ()=>(parcelRequire("e6B7M")),
    fi_FI: ()=>(parcelRequire("b0yK8")),
    fr: ()=>(parcelRequire("a2Z9O")),
    fr_FR: ()=>(parcelRequire("gO4JB")),
    hu: ()=>(parcelRequire("5J2eT")),
    hu_HU: ()=>(parcelRequire("1ZmJ1")),
    it: ()=>(parcelRequire("fLj37")),
    it_IT: ()=>(parcelRequire("agX7s")),
    ja: ()=>(parcelRequire("89XxV")),
    ja_JP: ()=>(parcelRequire("5bbcB")),
    ko: ()=>(parcelRequire("3MF1p")),
    ko_KR: ()=>(parcelRequire("4VtWw")),
    nb: ()=>(parcelRequire("fjBUl")),
    nb_NO: ()=>(parcelRequire("2b5tE")),
    nl: ()=>(parcelRequire("gsJdd")),
    nl_NL: ()=>(parcelRequire("3ue77")),
    pl: ()=>(parcelRequire("3wL8j")),
    pl_PL: ()=>(parcelRequire("dA9KW")),
    pt_BR: ()=>(parcelRequire("lsis4")),
    ru: ()=>(parcelRequire("ct6o3")),
    ru_RU: ()=>(parcelRequire("lCfCp")),
    sv: ()=>(parcelRequire("7GXIs")),
    sv_SE: ()=>(parcelRequire("hLcYa")),
    th: ()=>(parcelRequire("KyiLz")),
    th_TH: ()=>(parcelRequire("bNfeh")),
    tr: ()=>(parcelRequire("jorIR")),
    tr_TR: ()=>(parcelRequire("eb5Mr")),
    uk: ()=>(parcelRequire("fRmB5")),
    uk_UA: ()=>(parcelRequire("gvbET")),
    vi: ()=>(parcelRequire("dN72B")),
    vi_VN: ()=>(parcelRequire("a4lBG")),
    zh: ()=>(parcelRequire("6HN7q")),
    zh_CN: ()=>(parcelRequire("jE9ef")),
    zh_TW: ()=>(parcelRequire("cH3Oi"))
};
var $e8ee91bb986f9cd1$export$2e2bcd8739ae039 = $e8ee91bb986f9cd1$var$lazyMessages;

});
parcelRegister("lAegX", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('a2jZt'));

});

parcelRegister("fUnZs", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('kLGzS'));

});

parcelRegister("3HKSQ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('3WWx7'));

});

parcelRegister("c0dIo", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('jr4Ab'));

});

parcelRegister("jET4n", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('2IutD'));

});

parcelRegister("ba4lE", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('abPg7'));

});

parcelRegister("h2e9w", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('llQJd'));

});

parcelRegister("5Bpnb", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('6M05V'));

});

parcelRegister("aXkgG", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('lmLV7'));

});

parcelRegister("e6B7M", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('54w6Z'));

});

parcelRegister("b0yK8", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('ltHl5'));

});

parcelRegister("a2Z9O", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('6y4ao'));

});

parcelRegister("gO4JB", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('6JrFq'));

});

parcelRegister("5J2eT", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('6dpH4'));

});

parcelRegister("1ZmJ1", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('cQqjo'));

});

parcelRegister("fLj37", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('3pYZD'));

});

parcelRegister("agX7s", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('eVe74'));

});

parcelRegister("89XxV", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('lSW6r'));

});

parcelRegister("5bbcB", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('fyeSP'));

});

parcelRegister("3MF1p", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('dfOHF'));

});

parcelRegister("4VtWw", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('6Jzxh'));

});

parcelRegister("fjBUl", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('39hyU'));

});

parcelRegister("2b5tE", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('deeaY'));

});

parcelRegister("gsJdd", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('iHzOb'));

});

parcelRegister("3ue77", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('5ccUT'));

});

parcelRegister("3wL8j", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('hBK5e'));

});

parcelRegister("dA9KW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('hbTfg'));

});

parcelRegister("lsis4", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('i9yLf'));

});

parcelRegister("ct6o3", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('h2HPo'));

});

parcelRegister("lCfCp", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('b3nJN'));

});

parcelRegister("7GXIs", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('8HfNx'));

});

parcelRegister("hLcYa", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('alrc1'));

});

parcelRegister("KyiLz", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('gfM4x'));

});

parcelRegister("bNfeh", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('epR9l'));

});

parcelRegister("jorIR", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('2qyVx'));

});

parcelRegister("eb5Mr", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('jqq00'));

});

parcelRegister("fRmB5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('jMspg'));

});

parcelRegister("gvbET", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('4NdKk'));

});

parcelRegister("dN72B", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('5EuYn'));

});

parcelRegister("a4lBG", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('fmkDA'));

});

parcelRegister("6HN7q", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('6IQad'));

});

parcelRegister("jE9ef", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('87gtq'));

});

parcelRegister("cH3Oi", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('wnCGS'));

});



parcelRegister("4bmyg", function(module, exports) {
$parcel$export(module.exports, "AccountMenuPopup", () => $99cdabe4cba3cedb$export$473cb05bf335b0e1);

var $1v5pe = parcelRequire("1v5pe");

var $9hVBA = parcelRequire("9hVBA");

var $kOkIw = parcelRequire("kOkIw");

var $c633V = parcelRequire("c633V");

var $lnQLz = parcelRequire("lnQLz");
const $99cdabe4cba3cedb$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $1v5pe.useState)(false);
    const close = (0, $kOkIw.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $9hVBA.UI_EVENT_TYPE),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $lnQLz.NAVIGATION_CHANNEL));
    const open = (0, $kOkIw.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $9hVBA.UI_EVENT_TYPE),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $lnQLz.NAVIGATION_CHANNEL));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $c633V.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content
    });
};

});
parcelRegister("kOkIw", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $6e9cc230231c4cb4$export$53c2b9c37c40e0d8);

var $1v5pe = parcelRequire("1v5pe");

var $8g8jL = parcelRequire("8g8jL");

var $gEAl7 = parcelRequire("gEAl7");
const $6e9cc230231c4cb4$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    const methodRef = (0, $gEAl7.useTrackedRef)(method);
    const payloadRef = (0, $gEAl7.useTrackedRef)(payload);
    return (0, $1v5pe.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});
parcelRegister("gEAl7", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $76ed38080b3f8b17$export$1d27a74659855e44);

var $1v5pe = parcelRequire("1v5pe");
const $76ed38080b3f8b17$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $1v5pe.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("91Vpq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc75fd262840a994d6e2b1d456aac983>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6930bd5213caf8af$var$_react = $6930bd5213caf8af$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $6930bd5213caf8af$var$_baseNew = $6930bd5213caf8af$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $6930bd5213caf8af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/megaphone
 * Usage guidance:
 * Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6930bd5213caf8af$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $6930bd5213caf8af$var$_react.default.createElement($6930bd5213caf8af$var$_baseNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$6930bd5213caf8af$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $6930bd5213caf8af$var$_default = module.exports.default = $6930bd5213caf8af$var$MegaphoneIcon;

});

parcelRegister("30A4O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::438a97f59a6ff2783bbf26f581467704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $230d5b45cb79c6b3$var$_react = $230d5b45cb79c6b3$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $230d5b45cb79c6b3$var$_baseNew = $230d5b45cb79c6b3$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $230d5b45cb79c6b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/feedback
 * Usage guidance:
 * Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $230d5b45cb79c6b3$var$FeedbackIcon = (props)=>/*#__PURE__*/ $230d5b45cb79c6b3$var$_react.default.createElement($230d5b45cb79c6b3$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$230d5b45cb79c6b3$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $230d5b45cb79c6b3$var$_default = module.exports.default = $230d5b45cb79c6b3$var$FeedbackIcon;

});

parcelRegister("9ALFH", function(module, exports) {
$parcel$export(module.exports, "announcements", () => $ff3f4e519ae5d302$export$d7f3895e994ed5c7);
parcelRequire("1v5pe");

var $c7n79 = parcelRequire("c7n79");

var $dDkso = parcelRequire("dDkso");
const $ff3f4e519ae5d302$export$d7f3895e994ed5c7 = [
    {
        id: 'announcement-2025-06-17',
        date: '2025-06-17',
        ...(0, $dDkso.ThemingAnnouncementData)
    },
    {
        id: 'announcement-2025-03-25',
        date: '2025-03-25',
        ...(0, $c7n79.ShortCutAnnouncementData)
    }
]; // Note for developers:
 /*
When adding new announcements:
1. Add them at the TOP of the array
2. Use the format "announcement-YYYY-MM-DD" for IDs
3. Ensure images are imported from the assets directory
4. Place images in: src/assets/images/
5. The most recent announcement will trigger the "NEW" badge for users
*/ 

});
parcelRegister("c7n79", function(module, exports) {
$parcel$export(module.exports, "ShortCutAnnouncementData", () => $f16410cbb2244670$export$3fcaac43a559316e);

var $eMSEP = parcelRequire("eMSEP");
var $f4K70 = parcelRequire("f4K70");
var $iOq8l = parcelRequire("iOq8l");

var $1v5pe = parcelRequire("1v5pe");

var $cYe7u = parcelRequire("cYe7u");

var $b2Az1 = parcelRequire("b2Az1");
var $kK7WO = parcelRequire("kK7WO");

var $67Flg = parcelRequire("67Flg");

var $afq8D = parcelRequire("afq8D");

var $1ELgd = parcelRequire("1ELgd");

var $8XcJc = parcelRequire("8XcJc");

var $6JPfj = parcelRequire("6JPfj");

var $bfsuf = parcelRequire("bfsuf");

var $hQ4xg = parcelRequire("hQ4xg");

var $fietS = parcelRequire("fietS");

var $i9BIV = parcelRequire("i9BIV");
const $f16410cbb2244670$var$ShortcutAnnouncement = ()=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: (0, $afq8D.MediaStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        alignBlock: "stretch",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
        alt: formatMessage((0, $1ELgd.messages).shortcutGifAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8XcJc))),
        width: "65%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
        alt: formatMessage((0, $1ELgd.messages).chatShortcutAlt),
        src: (0, $i9BIV.isMacOs)() ? (0, (/*@__PURE__*/$parcel$interopDefault($6JPfj))) : (0, (/*@__PURE__*/$parcel$interopDefault($hQ4xg)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
        alt: formatMessage((0, $1ELgd.messages).searchShortcutAlt),
        src: (0, $i9BIV.isMacOs)() ? (0, (/*@__PURE__*/$parcel$interopDefault($bfsuf))) : (0, (/*@__PURE__*/$parcel$interopDefault($fietS)))
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).shortcutIntro), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        as: "ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).chatTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        as: "ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("li", null, (0, $i9BIV.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).macChatAccess) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).windowsChatAccess)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).searchTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        as: "ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).searchAnytimeTitle)), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).searchAnytimeDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).searchNewTabTitle)), "\xa0", (0, $i9BIV.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).searchNewTabMacDesc) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1ELgd.messages).searchNewTabWindowsDesc)))))));
};
const $f16410cbb2244670$export$3fcaac43a559316e = {
    title: (0, $1ELgd.messages).shortcutTitle.defaultMessage,
    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($f16410cbb2244670$var$ShortcutAnnouncement, null),
    tags: [
        (0, $67Flg.CATEGORIES).AI_SEARCH,
        (0, $67Flg.CATEGORIES).CHAT,
        (0, $67Flg.CATEGORIES).EXTENSION
    ]
};
var $f16410cbb2244670$export$2e2bcd8739ae039 = $f16410cbb2244670$var$ShortcutAnnouncement;

});
parcelRegister("67Flg", function(module, exports) {
$parcel$export(module.exports, "CATEGORIES", () => $e91e5d07501f2aed$export$a513ea61a7bee91c);
$parcel$export(module.exports, "default", () => $e91e5d07501f2aed$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $b2Az1 = parcelRequire("b2Az1");

var $eMSEP = parcelRequire("eMSEP");
var $iOq8l = parcelRequire("iOq8l");
var $bQOrV = parcelRequire("bQOrV");

var $bcdfp = parcelRequire("bcdfp");

var $2dnyN = parcelRequire("2dnyN");
parcelRequire("1wxU2");
var $6vVPG = parcelRequire("6vVPG");
const $e91e5d07501f2aed$var$SidebarContainerStyles = (0, $bQOrV.xcss)({
    position: 'sticky',
    top: 'space.500',
    maxHeight: '100vh',
    overflowY: 'auto'
});
const $e91e5d07501f2aed$var$ButtonWrapperStyles = (isSelected)=>(0, $bQOrV.xcss)({
        width: '100%',
        paddingBlock: 'space.150',
        paddingInline: 'space.200',
        backgroundColor: isSelected ? 'color.background.selected' : 'elevation.surface',
        font: 'font.body',
        textAlign: 'left',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: isSelected ? 'color.background.selected.hovered' : 'color.background.neutral.hovered'
        }
    });
const $e91e5d07501f2aed$var$CategoriesContainerStyles = (0, $bQOrV.xcss)({
    maxHeight: 'calc(100vh - 100px)',
    overflowY: 'auto'
});
var $e91e5d07501f2aed$export$a513ea61a7bee91c = /*#__PURE__*/ function(CATEGORIES) {
    CATEGORIES["ALL"] = "All";
    CATEGORIES["AI_SEARCH"] = "AI Search";
    CATEGORIES["CHAT"] = "Chat";
    CATEGORIES["AGENT_STUDIO"] = "Agent Studio";
    CATEGORIES["EXTENSION"] = "Extension";
    return CATEGORIES;
}({});
const $e91e5d07501f2aed$var$DISPLAYED_CATEGORIES_LABEL = {
    ALL: (0, $2dnyN.messages).allCategoryLabel,
    AI_SEARCH: (0, $2dnyN.messages).aiSearchCategoryLabel,
    CHAT: (0, $2dnyN.messages).chatCategoryLabel,
    AGENT_STUDIO: (0, $2dnyN.messages).agentStudioCategoryLabel,
    EXTENSION: (0, $2dnyN.messages).extensionCategoryLabel
};
const $e91e5d07501f2aed$var$convertSpaceToUnderscore = (str)=>str.replace(/\s+/g, '_').toUpperCase();
const $e91e5d07501f2aed$var$CategorySidebar = ({ announcements: announcements, selectedCategory: selectedCategory, onCategorySelect: onCategorySelect })=>{
    const announcementTags = announcements.flatMap((announ)=>announ.tags);
    const categories = Array.from(new Set(announcementTags));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $e91e5d07501f2aed$var$SidebarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $e91e5d07501f2aed$var$CategoriesContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
        name: "category-buttons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        space: "space.200"
    }, categories.map((category, index)=>{
        const categoryKey = $e91e5d07501f2aed$var$convertSpaceToUnderscore(category);
        const categoryString = $e91e5d07501f2aed$var$DISPLAYED_CATEGORIES_LABEL[categoryKey];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
            key: index,
            name: "category-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
            onClick: ()=>onCategorySelect(category),
            xcss: $e91e5d07501f2aed$var$ButtonWrapperStyles(selectedCategory === category)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bcdfp.default), {
            appearance: "subtle",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), categoryString))));
    })))));
};
var $e91e5d07501f2aed$export$2e2bcd8739ae039 = $e91e5d07501f2aed$var$CategorySidebar;

});
parcelRegister("bcdfp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d556e1cc0878738a$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $aD9yk = parcelRequire("aD9yk");

var $5Qmrb = parcelRequire("5Qmrb");

var $eJD8u = parcelRequire("eJD8u");

var $H8FDJ = parcelRequire("H8FDJ");
const $d556e1cc0878738a$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $d556e1cc0878738a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $aD9yk.default), onMouseUp: providedOnMouseUp = (0, $aD9yk.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $H8FDJ.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $1v5pe.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $1v5pe.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($d556e1cc0878738a$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $1v5pe.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($d556e1cc0878738a$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $1v5pe.useMemo)(()=>(0, $eJD8u.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5Qmrb.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$d556e1cc0878738a$var$Button.displayName = 'Button';
var $d556e1cc0878738a$export$2e2bcd8739ae039 = $d556e1cc0878738a$var$Button;

});
parcelRegister("5Qmrb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce18d0e8c92f494e$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hRuTh = parcelRequire("hRuTh");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");

var $Ms2ib = parcelRequire("Ms2ib");

var $8uWRL = parcelRequire("8uWRL");

var $7qISg = parcelRequire("7qISg");

var $i8DvG = parcelRequire("i8DvG");

var $b32Ws = parcelRequire("b32Ws");

var $6SyBh = parcelRequire("6SyBh");

var $k4gsk = parcelRequire("k4gsk");

var $hckPA = parcelRequire("hckPA");

var $6eehW = parcelRequire("6eehW");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $ce18d0e8c92f494e$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $ce18d0e8c92f494e$var$iconBeforeSpacingFixStyle = (0, $hRuTh.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const $ce18d0e8c92f494e$var$iconAfterSpacingFixStyle = (0, $hRuTh.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const $ce18d0e8c92f494e$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $hckPA.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $ce18d0e8c92f494e$var$getChildren = (children, childrenStyles)=>{
    if ((0, $hckPA.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $hRuTh.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $ce18d0e8c92f494e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $aD9yk.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $aD9yk.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $1v5pe.useRef)();
    const setRef = (0, $1v5pe.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $Ms2ib.default)(ourRef, autoFocus);
    const interactionContext = (0, $1v5pe.useContext)((0, $7qISg.default));
    const handleClick = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $1v5pe.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1v5pe.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, $hRuTh.css)((0, $6SyBh.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $hRuTh.jsx)((0, $8uWRL.default), null, /*#__PURE__*/ (0, $hRuTh.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $ce18d0e8c92f494e$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $i8DvG.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $hRuTh.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $k4gsk.getIconStyle)({
                spacing: spacing
            }),
            $ce18d0e8c92f494e$var$getSpacingFix(children, $ce18d0e8c92f494e$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $ce18d0e8c92f494e$var$getChildren(children, [
        fadeStyles,
        (0, $b32Ws.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $hRuTh.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $k4gsk.getIconStyle)({
                spacing: spacing
            }),
            $ce18d0e8c92f494e$var$getSpacingFix(children, $ce18d0e8c92f494e$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $hRuTh.jsx)("span", {
        css: [
            (0, $6eehW.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ce18d0e8c92f494e$export$2e2bcd8739ae039 = $ce18d0e8c92f494e$var$ButtonBase;

});
parcelRegister("hRuTh", function(module, exports) {
$parcel$export(module.exports, "createElement", () => $d00f591d08112ff5$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "Global", () => $d00f591d08112ff5$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $d00f591d08112ff5$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $d00f591d08112ff5$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $d00f591d08112ff5$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $d00f591d08112ff5$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "CacheProvider", () => (parcelRequire("jVAFm")).C);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("jVAFm")).T);
$parcel$export(module.exports, "ThemeProvider", () => (parcelRequire("jVAFm")).a);
$parcel$export(module.exports, "__unsafe_useEmotionCache", () => (parcelRequire("jVAFm"))._);
$parcel$export(module.exports, "useTheme", () => (parcelRequire("jVAFm")).u);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("jVAFm")).w);
$parcel$export(module.exports, "withTheme", () => (parcelRequire("jVAFm")).b);

var $jVAFm = parcelRequire("jVAFm");

var $1v5pe = parcelRequire("1v5pe");

var $eSd6x = parcelRequire("eSd6x");

var $9oExk = parcelRequire("9oExk");

var $90BXC = parcelRequire("90BXC");
parcelRequire("iLuH2");
parcelRequire("87uOn");
parcelRequire("7LkUp");

parcelRequire("35aua");
var $d00f591d08112ff5$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $d00f591d08112ff5$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $jVAFm.h).call(props, 'css')) // $FlowFixMe
    return $1v5pe.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jVAFm.E);
    createElementArgArray[1] = (0, $jVAFm.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $1v5pe.createElement.apply(null, createElementArgArray);
};
var $d00f591d08112ff5$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $d00f591d08112ff5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jVAFm.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $90BXC.serializeStyles)([
        styles
    ], undefined, $1v5pe.useContext((0, $jVAFm.T)));
    if (!(0, $jVAFm.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1v5pe.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1v5pe.useRef();
    (0, $9oExk.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9oExk.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $eSd6x.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $d00f591d08112ff5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90BXC.serializeStyles)(args);
}
var $d00f591d08112ff5$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $d00f591d08112ff5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $d00f591d08112ff5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $d00f591d08112ff5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $eSd6x.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $d00f591d08112ff5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $9oExk.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $eSd6x.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $d00f591d08112ff5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jVAFm.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90BXC.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $eSd6x.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $d00f591d08112ff5$var$merge(cache.registered, css, $d00f591d08112ff5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1v5pe.useContext((0, $jVAFm.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement($d00f591d08112ff5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $d00f591d08112ff5$var$isBrowser, $d00f591d08112ff5$var$isTestEnv, $d00f591d08112ff5$var$globalContext, $d00f591d08112ff5$var$globalKey;

});
parcelRegister("jVAFm", function(module, exports) {
$parcel$export(module.exports, "i", () => $e81fc850a2193ca7$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $e81fc850a2193ca7$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $e81fc850a2193ca7$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $e81fc850a2193ca7$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $e81fc850a2193ca7$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $e81fc850a2193ca7$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $e81fc850a2193ca7$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $e81fc850a2193ca7$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $e81fc850a2193ca7$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "c", () => $e81fc850a2193ca7$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $e81fc850a2193ca7$export$a9c23c6ac3fc3eca);

var $1v5pe = parcelRequire("1v5pe");

var $iLuH2 = parcelRequire("iLuH2");

var $87uOn = parcelRequire("87uOn");

var $7LkUp = parcelRequire("7LkUp");

var $3hx71 = parcelRequire("3hx71");

var $eSd6x = parcelRequire("eSd6x");

var $90BXC = parcelRequire("90BXC");

var $9oExk = parcelRequire("9oExk");
var $e81fc850a2193ca7$export$23f2a1d2818174ef = true;
var $e81fc850a2193ca7$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e81fc850a2193ca7$var$EmotionCacheContext = /* #__PURE__ */ $1v5pe.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $iLuH2.default)({
    key: 'css'
}) : null);
var $e81fc850a2193ca7$export$e7094788287c5e9b = $e81fc850a2193ca7$var$EmotionCacheContext.Provider;
var $e81fc850a2193ca7$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1v5pe.useContext)($e81fc850a2193ca7$var$EmotionCacheContext);
};
var $e81fc850a2193ca7$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $1v5pe.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1v5pe.useContext)($e81fc850a2193ca7$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e81fc850a2193ca7$export$23f2a1d2818174ef) $e81fc850a2193ca7$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $1v5pe.useContext)($e81fc850a2193ca7$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $iLuH2.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $1v5pe.createElement($e81fc850a2193ca7$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e81fc850a2193ca7$export$971d5caa766a69d7 = /* #__PURE__ */ $1v5pe.createContext({});
var $e81fc850a2193ca7$export$3b14a55fb2447963 = function useTheme() {
    return $1v5pe.useContext($e81fc850a2193ca7$export$971d5caa766a69d7);
};
var $e81fc850a2193ca7$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $87uOn.default)({}, outerTheme, theme);
};
var $e81fc850a2193ca7$var$createCacheWithTheme = /* #__PURE__ */ (0, $7LkUp.default)(function(outerTheme) {
    return (0, $7LkUp.default)(function(theme) {
        return $e81fc850a2193ca7$var$getTheme(outerTheme, theme);
    });
});
var $e81fc850a2193ca7$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $1v5pe.useContext($e81fc850a2193ca7$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e81fc850a2193ca7$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1v5pe.createElement($e81fc850a2193ca7$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e81fc850a2193ca7$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $1v5pe.useContext($e81fc850a2193ca7$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1v5pe.createElement(Component, (0, $87uOn.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $1v5pe.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3hx71.default)(WithTheme, Component);
}
var $e81fc850a2193ca7$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $e81fc850a2193ca7$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $e81fc850a2193ca7$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $e81fc850a2193ca7$var$getLastPart(match[1]);
    return undefined;
};
var $e81fc850a2193ca7$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $e81fc850a2193ca7$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $e81fc850a2193ca7$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $e81fc850a2193ca7$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($e81fc850a2193ca7$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $e81fc850a2193ca7$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $e81fc850a2193ca7$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e81fc850a2193ca7$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $e81fc850a2193ca7$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e81fc850a2193ca7$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e81fc850a2193ca7$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $e81fc850a2193ca7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $eSd6x.registerStyles)(cache, serialized, isStringTag);
    (0, $9oExk.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $eSd6x.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e81fc850a2193ca7$var$Emotion = /* #__PURE__ */ $e81fc850a2193ca7$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e81fc850a2193ca7$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $eSd6x.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90BXC.serializeStyles)(registeredStyles, undefined, $1v5pe.useContext($e81fc850a2193ca7$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e81fc850a2193ca7$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $e81fc850a2193ca7$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement($e81fc850a2193ca7$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $1v5pe.createElement(WrappedComponent, newProps));
});
var $e81fc850a2193ca7$export$a9c23c6ac3fc3eca = $e81fc850a2193ca7$var$Emotion;

});
parcelRegister("iLuH2", function(module, exports) {
$parcel$export(module.exports, "default", () => $da946cd43c0deced$export$2e2bcd8739ae039);

var $b9AiO = parcelRequire("b9AiO");

var $dhEBD = parcelRequire("dhEBD");
var $jjhpc = parcelRequire("jjhpc");
var $7MQd3 = parcelRequire("7MQd3");
var $buE9b = parcelRequire("buE9b");
var $5Z4pX = parcelRequire("5Z4pX");
var $6RQdH = parcelRequire("6RQdH");
parcelRequire("7LkUp");
parcelRequire("bhM3W");
var $da946cd43c0deced$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $dhEBD.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $dhEBD.token)(character)) break;
        (0, $dhEBD.next)();
    }
    return (0, $dhEBD.slice)(begin, (0, $dhEBD.position));
};
var $da946cd43c0deced$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $dhEBD.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $dhEBD.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $da946cd43c0deced$var$identifierWithPointTracking((0, $dhEBD.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $dhEBD.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $dhEBD.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jjhpc.from)(character);
    }
    while (character = (0, $dhEBD.next)());
    return parsed;
};
var $da946cd43c0deced$var$getRules = function getRules(value, points) {
    return (0, $dhEBD.dealloc)($da946cd43c0deced$var$toRules((0, $dhEBD.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $da946cd43c0deced$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $da946cd43c0deced$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$da946cd43c0deced$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $da946cd43c0deced$var$fixedElements.set(element, true);
    var points = [];
    var rules = $da946cd43c0deced$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $da946cd43c0deced$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $da946cd43c0deced$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $da946cd43c0deced$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($da946cd43c0deced$var$ignoreFlag) > -1;
};
var $da946cd43c0deced$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($da946cd43c0deced$var$isIgnoringComment(node)) return;
                    break;
                }
            }
        }
    };
};
var $da946cd43c0deced$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $da946cd43c0deced$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$da946cd43c0deced$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $da946cd43c0deced$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $da946cd43c0deced$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$da946cd43c0deced$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $da946cd43c0deced$var$nullifyElement(element);
    } else if ($da946cd43c0deced$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $da946cd43c0deced$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $da946cd43c0deced$var$prefix(value, length) {
    switch((0, $jjhpc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $buE9b.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $buE9b.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MOZ) + value + (0, $buE9b.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + value + value;
        // order
        case 6165:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $buE9b.WEBKIT) + value + (0, $jjhpc.replace)(value, /(\w+).+(:[^]+)/, (0, $buE9b.WEBKIT) + 'box-$1$2' + (0, $buE9b.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-item-' + (0, $jjhpc.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-line-pack' + (0, $jjhpc.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $buE9b.WEBKIT) + 'box-' + (0, $jjhpc.replace)(value, '-grow', '') + (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $buE9b.WEBKIT) + (0, $jjhpc.replace)(value, /([^-])(transform)/g, '$1' + (0, $buE9b.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(zoom-|grab)/, (0, $buE9b.WEBKIT) + '$1'), /(image-set)/, (0, $buE9b.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jjhpc.replace)(value, /(image-set\([^]*)/, (0, $buE9b.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $buE9b.WEBKIT) + 'box-pack:$3' + (0, $buE9b.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $buE9b.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jjhpc.replace)(value, /(.+)-inline(.+)/, (0, $buE9b.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jjhpc.strlen)(value) - 1 - length > 6) switch((0, $jjhpc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jjhpc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jjhpc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $buE9b.WEBKIT) + '$2-$3' + '$1' + (0, $buE9b.MOZ) + ((0, $jjhpc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jjhpc.indexof)(value, 'stretch') ? $da946cd43c0deced$var$prefix((0, $jjhpc.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $jjhpc.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $jjhpc.charat)(value, (0, $jjhpc.strlen)(value) - 3 - (~(0, $jjhpc.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $jjhpc.replace)(value, ':', ':' + (0, $buE9b.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $jjhpc.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $buE9b.WEBKIT) + ((0, $jjhpc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $buE9b.WEBKIT) + '$2$3' + '$1' + (0, $buE9b.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $jjhpc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + value + value;
    }
    return value;
}
var $da946cd43c0deced$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $buE9b.DECLARATION:
                element["return"] = $da946cd43c0deced$var$prefix(element.value, element.length);
                break;
            case 0, $buE9b.KEYFRAMES:
                return (0, $6RQdH.serialize)([
                    (0, $dhEBD.copy)(element, {
                        value: (0, $jjhpc.replace)(element.value, '@', '@' + (0, $buE9b.WEBKIT))
                    })
                ], callback);
            case 0, $buE9b.RULESET:
                if (element.length) return (0, $jjhpc.combine)(element.props, function(value) {
                    switch((0, $jjhpc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(read-\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, (0, $buE9b.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $da946cd43c0deced$var$defaultStylisPlugins = [
    $da946cd43c0deced$var$prefixer
];
var $da946cd43c0deced$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $da946cd43c0deced$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $da946cd43c0deced$var$compat,
        $da946cd43c0deced$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $6RQdH.stringify),
        (0, $5Z4pX.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $5Z4pX.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $6RQdH.serialize)((0, $7MQd3.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $b9AiO.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("b9AiO", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $81ecb1e320c1ad3f$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $81ecb1e320c1ad3f$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $81ecb1e320c1ad3f$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $81ecb1e320c1ad3f$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($81ecb1e320c1ad3f$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $81ecb1e320c1ad3f$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("dhEBD", function(module, exports) {
$parcel$export(module.exports, "position", () => $9abc5c6483fbd68f$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $9abc5c6483fbd68f$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $9abc5c6483fbd68f$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $9abc5c6483fbd68f$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $9abc5c6483fbd68f$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $9abc5c6483fbd68f$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $9abc5c6483fbd68f$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $9abc5c6483fbd68f$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $9abc5c6483fbd68f$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $9abc5c6483fbd68f$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $9abc5c6483fbd68f$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $9abc5c6483fbd68f$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $9abc5c6483fbd68f$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $9abc5c6483fbd68f$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $9abc5c6483fbd68f$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $9abc5c6483fbd68f$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $9abc5c6483fbd68f$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $9abc5c6483fbd68f$export$4254d4e2b3745c4c);

var $jjhpc = parcelRequire("jjhpc");
var $9abc5c6483fbd68f$export$53f1d5ea8de3d7c = 1;
var $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1;
var $9abc5c6483fbd68f$export$f24224f1c91d8156 = 0;
var $9abc5c6483fbd68f$export$5880b8b5730aff45 = 0;
var $9abc5c6483fbd68f$export$c0306caf338ac095 = 0;
var $9abc5c6483fbd68f$export$30a86d91af8ff6e6 = '';
function $9abc5c6483fbd68f$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $9abc5c6483fbd68f$export$53f1d5ea8de3d7c,
        column: $9abc5c6483fbd68f$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $9abc5c6483fbd68f$export$784d13d8ee351f07(root, props) {
    return (0, $jjhpc.assign)($9abc5c6483fbd68f$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $9abc5c6483fbd68f$export$eba6f6f03b0a92e7() {
    return $9abc5c6483fbd68f$export$c0306caf338ac095;
}
function $9abc5c6483fbd68f$export$232faf9add678146() {
    $9abc5c6483fbd68f$export$c0306caf338ac095 = $9abc5c6483fbd68f$export$5880b8b5730aff45 > 0 ? (0, $jjhpc.charat)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, --$9abc5c6483fbd68f$export$5880b8b5730aff45) : 0;
    if ($9abc5c6483fbd68f$export$4e0c71f277ca26b3--, $9abc5c6483fbd68f$export$c0306caf338ac095 === 10) $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1, $9abc5c6483fbd68f$export$53f1d5ea8de3d7c--;
    return $9abc5c6483fbd68f$export$c0306caf338ac095;
}
function $9abc5c6483fbd68f$export$48cfd1e771a65c4f() {
    $9abc5c6483fbd68f$export$c0306caf338ac095 = $9abc5c6483fbd68f$export$5880b8b5730aff45 < $9abc5c6483fbd68f$export$f24224f1c91d8156 ? (0, $jjhpc.charat)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, $9abc5c6483fbd68f$export$5880b8b5730aff45++) : 0;
    if ($9abc5c6483fbd68f$export$4e0c71f277ca26b3++, $9abc5c6483fbd68f$export$c0306caf338ac095 === 10) $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1, $9abc5c6483fbd68f$export$53f1d5ea8de3d7c++;
    return $9abc5c6483fbd68f$export$c0306caf338ac095;
}
function $9abc5c6483fbd68f$export$4d3fb11e950abb9e() {
    return (0, $jjhpc.charat)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, $9abc5c6483fbd68f$export$5880b8b5730aff45);
}
function $9abc5c6483fbd68f$export$e88cb2efb12ae807() {
    return $9abc5c6483fbd68f$export$5880b8b5730aff45;
}
function $9abc5c6483fbd68f$export$58adb3bec8346d0f(begin, end) {
    return (0, $jjhpc.substr)($9abc5c6483fbd68f$export$30a86d91af8ff6e6, begin, end);
}
function $9abc5c6483fbd68f$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $9abc5c6483fbd68f$export$2de70f21292aac9e(value) {
    return $9abc5c6483fbd68f$export$53f1d5ea8de3d7c = $9abc5c6483fbd68f$export$4e0c71f277ca26b3 = 1, $9abc5c6483fbd68f$export$f24224f1c91d8156 = (0, $jjhpc.strlen)($9abc5c6483fbd68f$export$30a86d91af8ff6e6 = value), $9abc5c6483fbd68f$export$5880b8b5730aff45 = 0, [];
}
function $9abc5c6483fbd68f$export$45918ac1574455b1(value) {
    return $9abc5c6483fbd68f$export$30a86d91af8ff6e6 = '', value;
}
function $9abc5c6483fbd68f$export$410ac95b9ec204b8(type) {
    return (0, $jjhpc.trim)($9abc5c6483fbd68f$export$58adb3bec8346d0f($9abc5c6483fbd68f$export$5880b8b5730aff45 - 1, $9abc5c6483fbd68f$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $9abc5c6483fbd68f$export$660b2ee2d4fb4eff(value) {
    return $9abc5c6483fbd68f$export$45918ac1574455b1($9abc5c6483fbd68f$export$5f8c09e3ae6f64e1($9abc5c6483fbd68f$export$2de70f21292aac9e(value)));
}
function $9abc5c6483fbd68f$export$7af1228ff777d175(type) {
    while($9abc5c6483fbd68f$export$c0306caf338ac095 = $9abc5c6483fbd68f$export$4d3fb11e950abb9e())if ($9abc5c6483fbd68f$export$c0306caf338ac095 < 33) $9abc5c6483fbd68f$export$48cfd1e771a65c4f();
    else break;
    return $9abc5c6483fbd68f$export$9e1725a4cfeada27(type) > 2 || $9abc5c6483fbd68f$export$9e1725a4cfeada27($9abc5c6483fbd68f$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $9abc5c6483fbd68f$export$5f8c09e3ae6f64e1(children) {
    while($9abc5c6483fbd68f$export$48cfd1e771a65c4f())switch($9abc5c6483fbd68f$export$9e1725a4cfeada27($9abc5c6483fbd68f$export$c0306caf338ac095)){
        case 0:
            (0, $jjhpc.append)($9abc5c6483fbd68f$export$c2ab62c7bf24634($9abc5c6483fbd68f$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $jjhpc.append)($9abc5c6483fbd68f$export$410ac95b9ec204b8($9abc5c6483fbd68f$export$c0306caf338ac095), children);
            break;
        default:
            (0, $jjhpc.append)((0, $jjhpc.from)($9abc5c6483fbd68f$export$c0306caf338ac095), children);
    }
    return children;
}
function $9abc5c6483fbd68f$export$955ba06d119e085e(index, count) {
    while(--count && $9abc5c6483fbd68f$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($9abc5c6483fbd68f$export$c0306caf338ac095 < 48 || $9abc5c6483fbd68f$export$c0306caf338ac095 > 102 || $9abc5c6483fbd68f$export$c0306caf338ac095 > 57 && $9abc5c6483fbd68f$export$c0306caf338ac095 < 65 || $9abc5c6483fbd68f$export$c0306caf338ac095 > 70 && $9abc5c6483fbd68f$export$c0306caf338ac095 < 97) break;
    return $9abc5c6483fbd68f$export$58adb3bec8346d0f(index, $9abc5c6483fbd68f$export$e88cb2efb12ae807() + (count < 6 && $9abc5c6483fbd68f$export$4d3fb11e950abb9e() == 32 && $9abc5c6483fbd68f$export$48cfd1e771a65c4f() == 32));
}
function $9abc5c6483fbd68f$export$c889f2fcc19dbf12(type) {
    while($9abc5c6483fbd68f$export$48cfd1e771a65c4f())switch($9abc5c6483fbd68f$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $9abc5c6483fbd68f$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $9abc5c6483fbd68f$export$c889f2fcc19dbf12($9abc5c6483fbd68f$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $9abc5c6483fbd68f$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $9abc5c6483fbd68f$export$48cfd1e771a65c4f();
            break;
    }
    return $9abc5c6483fbd68f$export$5880b8b5730aff45;
}
function $9abc5c6483fbd68f$export$4254d4e2b3745c4c(type, index) {
    while($9abc5c6483fbd68f$export$48cfd1e771a65c4f())// //
    if (type + $9abc5c6483fbd68f$export$c0306caf338ac095 === 57) break;
    else if (type + $9abc5c6483fbd68f$export$c0306caf338ac095 === 84 && $9abc5c6483fbd68f$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $9abc5c6483fbd68f$export$58adb3bec8346d0f(index, $9abc5c6483fbd68f$export$5880b8b5730aff45 - 1) + '*' + (0, $jjhpc.from)(type === 47 ? type : $9abc5c6483fbd68f$export$48cfd1e771a65c4f());
}
function $9abc5c6483fbd68f$export$c2ab62c7bf24634(index) {
    while(!$9abc5c6483fbd68f$export$9e1725a4cfeada27($9abc5c6483fbd68f$export$4d3fb11e950abb9e()))$9abc5c6483fbd68f$export$48cfd1e771a65c4f();
    return $9abc5c6483fbd68f$export$58adb3bec8346d0f(index, $9abc5c6483fbd68f$export$5880b8b5730aff45);
}

});
parcelRegister("jjhpc", function(module, exports) {
$parcel$export(module.exports, "abs", () => $e0ed4b03afd8ea51$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $e0ed4b03afd8ea51$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $e0ed4b03afd8ea51$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $e0ed4b03afd8ea51$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $e0ed4b03afd8ea51$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $e0ed4b03afd8ea51$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $e0ed4b03afd8ea51$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $e0ed4b03afd8ea51$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $e0ed4b03afd8ea51$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $e0ed4b03afd8ea51$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $e0ed4b03afd8ea51$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $e0ed4b03afd8ea51$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $e0ed4b03afd8ea51$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $e0ed4b03afd8ea51$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $e0ed4b03afd8ea51$export$2335f513bbd82c6d = Math.abs;
var $e0ed4b03afd8ea51$export$6788812c4e6611e6 = String.fromCharCode;
var $e0ed4b03afd8ea51$export$e6e34fd1f2686227 = Object.assign;
function $e0ed4b03afd8ea51$export$d6af199866bfb566(value, length) {
    return $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 0)) << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 1)) << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 2)) << 2 ^ $e0ed4b03afd8ea51$export$a9db5e087081082d(value, 3) : 0;
}
function $e0ed4b03afd8ea51$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $e0ed4b03afd8ea51$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $e0ed4b03afd8ea51$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $e0ed4b03afd8ea51$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $e0ed4b03afd8ea51$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $e0ed4b03afd8ea51$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $e0ed4b03afd8ea51$export$36776f635604f274(value) {
    return value.length;
}
function $e0ed4b03afd8ea51$export$f9084667e487ed46(value) {
    return value.length;
}
function $e0ed4b03afd8ea51$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $e0ed4b03afd8ea51$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("7MQd3", function(module, exports) {
$parcel$export(module.exports, "compile", () => $5ab583d041aa3f57$export$ef7acd7185315e22);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");

var $dhEBD = parcelRequire("dhEBD");
function $5ab583d041aa3f57$export$ef7acd7185315e22(value) {
    return (0, $dhEBD.dealloc)($5ab583d041aa3f57$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $dhEBD.alloc)(value), 0, [
        0
    ], value));
}
function $5ab583d041aa3f57$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $dhEBD.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $jjhpc.charat)(characters, length - 1) == 58) {
                if ((0, $jjhpc.indexof)(characters += (0, $jjhpc.replace)((0, $dhEBD.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $dhEBD.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $dhEBD.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $dhEBD.escaping)((0, $dhEBD.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $dhEBD.peek)()){
                case 42:
                case 47:
                    (0, $jjhpc.append)($5ab583d041aa3f57$export$4a34f930e789283c((0, $dhEBD.commenter)((0, $dhEBD.next)(), (0, $dhEBD.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $jjhpc.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $jjhpc.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $jjhpc.strlen)(characters) - length) (0, $jjhpc.append)(property > 32 ? $5ab583d041aa3f57$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $5ab583d041aa3f57$export$f8483753829ec8f3((0, $jjhpc.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $jjhpc.append)(reference = $5ab583d041aa3f57$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $5ab583d041aa3f57$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $jjhpc.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $5ab583d041aa3f57$export$98e6a39c04603d36(value, reference, reference, rule && (0, $jjhpc.append)($5ab583d041aa3f57$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $5ab583d041aa3f57$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $jjhpc.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $dhEBD.prev)() == 125) continue;
            }
            switch(characters += (0, $jjhpc.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $jjhpc.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $dhEBD.peek)() === 45) characters += (0, $dhEBD.delimit)((0, $dhEBD.next)());
                    atrule = (0, $dhEBD.peek)(), offset = length = (0, $jjhpc.strlen)(type = characters += (0, $dhEBD.identifier)((0, $dhEBD.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $jjhpc.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $5ab583d041aa3f57$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $jjhpc.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $jjhpc.substr)(value, post + 1, post = (0, $jjhpc.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $jjhpc.trim)(j > 0 ? rule[x] + ' ' + y : (0, $jjhpc.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $dhEBD.node)(value, root, parent, offset === 0 ? (0, $buE9b.RULESET) : type, props, children, length);
}
function $5ab583d041aa3f57$export$4a34f930e789283c(value, root, parent) {
    return (0, $dhEBD.node)(value, root, parent, (0, $buE9b.COMMENT), (0, $jjhpc.from)((0, $dhEBD.char)()), (0, $jjhpc.substr)(value, 2, -2), 0);
}
function $5ab583d041aa3f57$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $dhEBD.node)(value, root, parent, (0, $buE9b.DECLARATION), (0, $jjhpc.substr)(value, 0, length), (0, $jjhpc.substr)(value, length + 1, -1), length);
}

});
parcelRegister("buE9b", function(module, exports) {
$parcel$export(module.exports, "MS", () => $85e1a372462440e6$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $85e1a372462440e6$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $85e1a372462440e6$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $85e1a372462440e6$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $85e1a372462440e6$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $85e1a372462440e6$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $85e1a372462440e6$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $85e1a372462440e6$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $85e1a372462440e6$export$d773506282b3cfe6);
var $85e1a372462440e6$export$71ad59f2e432cfe8 = '-ms-';
var $85e1a372462440e6$export$2c0f367103c8d01c = '-moz-';
var $85e1a372462440e6$export$39dfd62a25e0fe93 = '-webkit-';
var $85e1a372462440e6$export$a29989082612d0d9 = 'comm';
var $85e1a372462440e6$export$aa3a2e812ca8570d = 'rule';
var $85e1a372462440e6$export$527d108ccf083c2b = 'decl';
var $85e1a372462440e6$export$d3d35020fa5b54f0 = '@page';
var $85e1a372462440e6$export$500415a86c544f73 = '@media';
var $85e1a372462440e6$export$a763edbf796b780a = '@import';
var $85e1a372462440e6$export$2790aeb8b4e5c826 = '@charset';
var $85e1a372462440e6$export$1cc683e23b84b133 = '@viewport';
var $85e1a372462440e6$export$9447a5efea57e862 = '@supports';
var $85e1a372462440e6$export$ef011b4e114b1fba = '@document';
var $85e1a372462440e6$export$6aad947bda0f3f46 = '@namespace';
var $85e1a372462440e6$export$b44a8529a35fcb60 = '@keyframes';
var $85e1a372462440e6$export$2c16de31893252e6 = '@font-face';
var $85e1a372462440e6$export$3d846dd52e150c6f = '@counter-style';
var $85e1a372462440e6$export$22314bfbb57653fe = '@font-feature-values';
var $85e1a372462440e6$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("5Z4pX", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $45b613815fd25d99$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $45b613815fd25d99$export$38bcb760f1d4871c);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");

var $dhEBD = parcelRequire("dhEBD");

var $6RQdH = parcelRequire("6RQdH");

var $2kwCb = parcelRequire("2kwCb");
function $45b613815fd25d99$export$5a7767152ae0305f(collection) {
    var length = (0, $jjhpc.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $45b613815fd25d99$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $45b613815fd25d99$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $buE9b.DECLARATION:
                element.return = (0, $2kwCb.prefix)(element.value, element.length, children);
                return;
            case 0, $buE9b.KEYFRAMES:
                return (0, $6RQdH.serialize)([
                    (0, $dhEBD.copy)(element, {
                        value: (0, $jjhpc.replace)(element.value, '@', '@' + (0, $buE9b.WEBKIT))
                    })
                ], callback);
            case 0, $buE9b.RULESET:
                if (element.length) return (0, $jjhpc.combine)(element.props, function(value) {
                    switch((0, $jjhpc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(read-\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $6RQdH.serialize)([
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, ':' + (0, $buE9b.MOZ) + '$1')
                                    ]
                                }),
                                (0, $dhEBD.copy)(element, {
                                    props: [
                                        (0, $jjhpc.replace)(value, /:(plac\w+)/, (0, $buE9b.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $45b613815fd25d99$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $buE9b.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $jjhpc.combine)((0, $dhEBD.tokenize)(value), function(value, index, children) {
                    switch((0, $jjhpc.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $jjhpc.substr)(value, 1, (0, $jjhpc.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $jjhpc.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $jjhpc.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $jjhpc.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("6RQdH", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $5000331b77d59caa$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $5000331b77d59caa$export$fac44ee5b035f737);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");
function $5000331b77d59caa$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $jjhpc.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $5000331b77d59caa$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $buE9b.LAYER:
            if (element.children.length) break;
        case 0, $buE9b.IMPORT:
        case 0, $buE9b.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $buE9b.COMMENT:
            return '';
        case 0, $buE9b.KEYFRAMES:
            return element.return = element.value + '{' + $5000331b77d59caa$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $buE9b.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $jjhpc.strlen)(children = $5000331b77d59caa$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("2kwCb", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $1b26bfac7c9cdada$export$82e9f45cca5ba907);

var $buE9b = parcelRequire("buE9b");

var $jjhpc = parcelRequire("jjhpc");
function $1b26bfac7c9cdada$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $jjhpc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $buE9b.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $buE9b.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $buE9b.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MOZ) + value + (0, $buE9b.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $jjhpc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + value + value;
        // order
        case 6165:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $buE9b.WEBKIT) + value + (0, $jjhpc.replace)(value, /(\w+).+(:[^]+)/, (0, $buE9b.WEBKIT) + 'box-$1$2' + (0, $buE9b.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-item-' + (0, $jjhpc.replace)(value, /flex-|-self/g, '') + (!(0, $jjhpc.match)(value, /flex-|baseline/) ? (0, $buE9b.MS) + 'grid-row-' + (0, $jjhpc.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + 'flex-line-pack' + (0, $jjhpc.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $buE9b.WEBKIT) + 'box-' + (0, $jjhpc.replace)(value, '-grow', '') + (0, $buE9b.WEBKIT) + value + (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $buE9b.WEBKIT) + (0, $jjhpc.replace)(value, /([^-])(transform)/g, '$1' + (0, $buE9b.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(zoom-|grab)/, (0, $buE9b.WEBKIT) + '$1'), /(image-set)/, (0, $buE9b.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jjhpc.replace)(value, /(image-set\([^]*)/, (0, $buE9b.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jjhpc.replace)((0, $jjhpc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $buE9b.WEBKIT) + 'box-pack:$3' + (0, $buE9b.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $buE9b.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $jjhpc.match)(value, /flex-|baseline/)) return (0, $buE9b.MS) + 'grid-column-align' + (0, $jjhpc.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $buE9b.MS) + (0, $jjhpc.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $jjhpc.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $jjhpc.indexof)(value + (children = children[length].value), 'span') ? value : (0, $buE9b.MS) + (0, $jjhpc.replace)(value, '-start', '') + value + (0, $buE9b.MS) + 'grid-row-span:' + (~(0, $jjhpc.indexof)(children, 'span') ? (0, $jjhpc.match)(children, /\d+/) : +(0, $jjhpc.match)(children, /\d+/) - +(0, $jjhpc.match)(value, /\d+/)) + ';';
            return (0, $buE9b.MS) + (0, $jjhpc.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $jjhpc.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $buE9b.MS) + (0, $jjhpc.replace)((0, $jjhpc.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jjhpc.replace)(value, /(.+)-inline(.+)/, (0, $buE9b.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jjhpc.strlen)(value) - 1 - length > 6) switch((0, $jjhpc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jjhpc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jjhpc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $buE9b.WEBKIT) + '$2-$3' + '$1' + (0, $buE9b.MOZ) + ((0, $jjhpc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jjhpc.indexof)(value, 'stretch') ? $1b26bfac7c9cdada$export$82e9f45cca5ba907((0, $jjhpc.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $jjhpc.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $buE9b.MS) + a + ':' + b + f + (c ? (0, $buE9b.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $jjhpc.charat)(value, length + 6) === 121) return (0, $jjhpc.replace)(value, ':', ':' + (0, $buE9b.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $jjhpc.charat)(value, (0, $jjhpc.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $jjhpc.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $buE9b.WEBKIT) + ((0, $jjhpc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $buE9b.WEBKIT) + '$2$3' + '$1' + (0, $buE9b.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $jjhpc.replace)(value, ':', ':' + (0, $buE9b.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $jjhpc.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("7LkUp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a6d24410be87591$export$2e2bcd8739ae039);
var $5a6d24410be87591$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("bhM3W", function(module, exports) {
function $837690759379fb73$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("87uOn", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e96e0ae3c8e2999$export$2e2bcd8739ae039);
function $5e96e0ae3c8e2999$export$2e2bcd8739ae039() {
    return $5e96e0ae3c8e2999$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e96e0ae3c8e2999$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3hx71", function(module, exports) {
$parcel$export(module.exports, "default", () => $263ca508648a6bcb$export$2e2bcd8739ae039);

var $35aua = parcelRequire("35aua");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $263ca508648a6bcb$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($35aua)))(targetComponent, sourceComponent);
};

});

parcelRegister("eSd6x", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $ad404616b71240e2$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $ad404616b71240e2$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $ad404616b71240e2$export$6f077d94b33a01aa);
var $ad404616b71240e2$var$isBrowser = true;
function $ad404616b71240e2$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $ad404616b71240e2$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ad404616b71240e2$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $ad404616b71240e2$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $ad404616b71240e2$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("90BXC", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $68f18f4ea61e9c41$export$6321afa313b251b5);

var $aCY0v = parcelRequire("aCY0v");

var $55h8i = parcelRequire("55h8i");

var $62Oof = parcelRequire("62Oof");
var $68f18f4ea61e9c41$var$isDevelopment = false;
var $68f18f4ea61e9c41$var$hyphenateRegex = /[A-Z]|^ms/g;
var $68f18f4ea61e9c41$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $68f18f4ea61e9c41$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $68f18f4ea61e9c41$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $68f18f4ea61e9c41$var$processStyleName = /* #__PURE__ */ (0, $62Oof.default)(function(styleName) {
    return $68f18f4ea61e9c41$var$isCustomProperty(styleName) ? styleName : styleName.replace($68f18f4ea61e9c41$var$hyphenateRegex, '-$&').toLowerCase();
});
var $68f18f4ea61e9c41$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($68f18f4ea61e9c41$var$animationRegex, function(match, p1, p2) {
                $68f18f4ea61e9c41$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $68f18f4ea61e9c41$var$cursor
                };
                return p1;
            });
    }
    if ((0, $55h8i.default)[key] !== 1 && !$68f18f4ea61e9c41$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $68f18f4ea61e9c41$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $68f18f4ea61e9c41$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $68f18f4ea61e9c41$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $68f18f4ea61e9c41$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $68f18f4ea61e9c41$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $68f18f4ea61e9c41$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $68f18f4ea61e9c41$var$cursor;
                var result = interpolation(mergedProps);
                $68f18f4ea61e9c41$var$cursor = previousCursor;
                return $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $68f18f4ea61e9c41$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($68f18f4ea61e9c41$var$isProcessableValue(asString)) string += $68f18f4ea61e9c41$var$processStyleName(key) + ":" + $68f18f4ea61e9c41$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $68f18f4ea61e9c41$var$isDevelopment) throw new Error($68f18f4ea61e9c41$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($68f18f4ea61e9c41$var$isProcessableValue(value[_i])) string += $68f18f4ea61e9c41$var$processStyleName(key) + ":" + $68f18f4ea61e9c41$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $68f18f4ea61e9c41$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $68f18f4ea61e9c41$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $68f18f4ea61e9c41$var$cursor;
function $68f18f4ea61e9c41$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $68f18f4ea61e9c41$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $68f18f4ea61e9c41$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $68f18f4ea61e9c41$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $68f18f4ea61e9c41$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $aCY0v.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $68f18f4ea61e9c41$var$cursor
    };
}

});
parcelRegister("aCY0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bcc002b5700def0$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7bcc002b5700def0$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("55h8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b3ab59f97f8b260$export$2e2bcd8739ae039);
var $3b3ab59f97f8b260$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("62Oof", function(module, exports) {
$parcel$export(module.exports, "default", () => $466a0462a396a56a$export$2e2bcd8739ae039);
function $466a0462a396a56a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("9oExk", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $6d75cca965600918$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $6d75cca965600918$export$811a713a7276cb9d);

var $1v5pe = parcelRequire("1v5pe");
var $6d75cca965600918$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6d75cca965600918$var$useInsertionEffect = false;
var $6d75cca965600918$export$db21c7ffa21794e7 = $6d75cca965600918$var$useInsertionEffect || $6d75cca965600918$var$syncFallback;
var $6d75cca965600918$export$811a713a7276cb9d = $6d75cca965600918$var$useInsertionEffect || $1v5pe.useLayoutEffect;

});



parcelRegister("j9QYE", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $89e7f8d5047bc7d4$export$a4687b0234b40e28);

var $1v5pe = parcelRequire("1v5pe");

var $8g8jL = parcelRequire("8g8jL");

var $gEAl7 = parcelRequire("gEAl7");
function $89e7f8d5047bc7d4$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gEAl7.useTrackedRef)(analyticsData);
    const fnRef = (0, $gEAl7.useTrackedRef)(fn);
    const handler = (0, $1v5pe.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("i8DvG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b22fa924f865e60d$export$2e2bcd8739ae039);
function $b22fa924f865e60d$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $b22fa924f865e60d$var$tabKeyCode = 9;
function $b22fa924f865e60d$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $b22fa924f865e60d$var$tabKeyCode) return;
    $b22fa924f865e60d$var$abort(event);
}
const $b22fa924f865e60d$var$block = {
    onMouseDownCapture: $b22fa924f865e60d$var$abort,
    onMouseUpCapture: $b22fa924f865e60d$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $b22fa924f865e60d$var$onKey,
    onKeyUpCapture: $b22fa924f865e60d$var$onKey,
    onTouchStartCapture: $b22fa924f865e60d$var$abort,
    onTouchEndCapture: $b22fa924f865e60d$var$abort,
    onPointerDownCapture: $b22fa924f865e60d$var$abort,
    onPointerUpCapture: $b22fa924f865e60d$var$abort,
    onClickCapture: $b22fa924f865e60d$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $b22fa924f865e60d$var$abort
};
const $b22fa924f865e60d$var$doNotBlock = {};
function $b22fa924f865e60d$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $b22fa924f865e60d$var$doNotBlock : $b22fa924f865e60d$var$block;
}

});

parcelRegister("b32Ws", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $8592433700eea827$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
function $8592433700eea827$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $hRuTh.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("6SyBh", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $e65f184a21624a8b$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
function $e65f184a21624a8b$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $hRuTh.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("k4gsk", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $5b3b350e1901f6a0$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hRuTh = parcelRequire("hRuTh");
function $5b3b350e1901f6a0$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $hRuTh.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("hckPA", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $72e303532ffb2193$export$20bbd2efb0d734c4);

var $1v5pe = parcelRequire("1v5pe");

var $kFr83 = parcelRequire("kFr83");
const $72e303532ffb2193$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $1v5pe.isValidElement)(children) && children.type === (0, $kFr83.default);
};

});

parcelRegister("6eehW", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $d0977fa093015bff$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $d0977fa093015bff$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("eJD8u", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $f3fc4416b1b0dcc2$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2aEiL = parcelRequire("2aEiL");
const $f3fc4416b1b0dcc2$var$gridSize = 8;
const $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $f3fc4416b1b0dcc2$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $f3fc4416b1b0dcc2$var$lineHeights = {
    default: $f3fc4416b1b0dcc2$var$heights.default,
    compact: $f3fc4416b1b0dcc2$var$heights.compact,
    none: 'inherit'
};
const $f3fc4416b1b0dcc2$var$padding = {
    // 10px gutter
    default: `0 ${$f3fc4416b1b0dcc2$var$gridSize + $f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    compact: `0 ${$f3fc4416b1b0dcc2$var$gridSize + $f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    none: '0'
};
const $f3fc4416b1b0dcc2$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    default: `0 ${$f3fc4416b1b0dcc2$var$gridSize / 4}px`,
    none: '0'
};
const $f3fc4416b1b0dcc2$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $f3fc4416b1b0dcc2$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $f3fc4416b1b0dcc2$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$f3fc4416b1b0dcc2$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $f3fc4416b1b0dcc2$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $f3fc4416b1b0dcc2$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $f3fc4416b1b0dcc2$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $f3fc4416b1b0dcc2$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $f3fc4416b1b0dcc2$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $f3fc4416b1b0dcc2$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $f3fc4416b1b0dcc2$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$f3fc4416b1b0dcc2$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ const $f3fc4416b1b0dcc2$var$defaultWithAnchorTextColorStyles = {
    ...$f3fc4416b1b0dcc2$var$defaultStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$f3fc4416b1b0dcc2$var$defaultStyles['&:hover'],
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$f3fc4416b1b0dcc2$var$defaultStyles['&:active'],
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }
};
const $f3fc4416b1b0dcc2$var$primaryWithAnchorTextColorStyles = {
    ...$f3fc4416b1b0dcc2$var$primaryStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$f3fc4416b1b0dcc2$var$primaryStyles['&:hover'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$f3fc4416b1b0dcc2$var$primaryStyles['&:active'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }
};
const $f3fc4416b1b0dcc2$var$linkWithAnchorTextColorStyles = {
    ...$f3fc4416b1b0dcc2$var$linkStyles,
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$subtleWithAnchorTextColorStyles = {
    ...$f3fc4416b1b0dcc2$var$subtleStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$f3fc4416b1b0dcc2$var$subtleStyles['&:hover'],
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$f3fc4416b1b0dcc2$var$subtleStyles['&:active'],
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }
};
const $f3fc4416b1b0dcc2$var$subtleLinkWithAnchorTextColorStyles = {
    ...$f3fc4416b1b0dcc2$var$subtleLinkStyles,
    textDecoration: 'none'
};
const $f3fc4416b1b0dcc2$var$warningWithAnchorTextColorStyles = {
    ...$f3fc4416b1b0dcc2$var$warningStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$f3fc4416b1b0dcc2$var$warningStyles['&:hover'],
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$f3fc4416b1b0dcc2$var$warningStyles['&:active'],
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }
};
const $f3fc4416b1b0dcc2$var$dangerWithAnchorTextColorStyles = {
    ...$f3fc4416b1b0dcc2$var$dangerStyles,
    textDecoration: 'none',
    '&:hover': {
        ...$f3fc4416b1b0dcc2$var$dangerStyles['&:hover'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        ...$f3fc4416b1b0dcc2$var$dangerStyles['&:active'],
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }
};
const $f3fc4416b1b0dcc2$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $f3fc4416b1b0dcc2$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $2aEiL.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $2aEiL.fg)('platform-dst-motion-uplift-button') ? `${"var(--ds-button-hovered, background-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)` : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $f3fc4416b1b0dcc2$var$heights[spacing],
        lineHeight: $f3fc4416b1b0dcc2$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $f3fc4416b1b0dcc2$var$singleIconPadding[spacing] : $f3fc4416b1b0dcc2$var$padding[spacing],
        verticalAlign: $f3fc4416b1b0dcc2$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $f3fc4416b1b0dcc2$var$selectedStyles : {
            ...(0, $2aEiL.fg)('platform-dst-legacy-button-anchor-text-color') ? {
                ...appearance === 'default' && $f3fc4416b1b0dcc2$var$defaultWithAnchorTextColorStyles,
                ...appearance === 'primary' && $f3fc4416b1b0dcc2$var$primaryWithAnchorTextColorStyles,
                ...appearance === 'link' && $f3fc4416b1b0dcc2$var$linkWithAnchorTextColorStyles,
                ...appearance === 'subtle' && $f3fc4416b1b0dcc2$var$subtleWithAnchorTextColorStyles,
                ...appearance === 'subtle-link' && $f3fc4416b1b0dcc2$var$subtleLinkWithAnchorTextColorStyles,
                ...appearance === 'warning' && $f3fc4416b1b0dcc2$var$warningWithAnchorTextColorStyles,
                ...appearance === 'danger' && $f3fc4416b1b0dcc2$var$dangerWithAnchorTextColorStyles
            } : {
                ...appearance === 'default' && $f3fc4416b1b0dcc2$var$defaultStyles,
                ...appearance === 'primary' && $f3fc4416b1b0dcc2$var$primaryStyles,
                ...appearance === 'link' && $f3fc4416b1b0dcc2$var$linkStyles,
                ...appearance === 'subtle' && $f3fc4416b1b0dcc2$var$subtleStyles,
                ...appearance === 'subtle-link' && $f3fc4416b1b0dcc2$var$subtleLinkStyles,
                ...appearance === 'warning' && $f3fc4416b1b0dcc2$var$warningStyles,
                ...appearance === 'danger' && $f3fc4416b1b0dcc2$var$dangerStyles
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $f3fc4416b1b0dcc2$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$f3fc4416b1b0dcc2$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRegister("H8FDJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ad8a40ce63139e0$export$2e2bcd8739ae039);

var $hckPA = parcelRequire("hckPA");
function $1ad8a40ce63139e0$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $hckPA.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("2dnyN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $47958c9cf24c1f3f$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $47958c9cf24c1f3f$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    loadingMessage: {
        id: 'rovo-extension.menu-page.loading-message',
        defaultMessage: 'Loading...',
        description: 'Message displayed when the menu page is loading.'
    },
    menuHeadingMessage: {
        id: 'rovo-extension.menu-page.menu-heading-message',
        defaultMessage: "What's new in Rovo",
        description: 'Message displayed on heading of menu page.'
    },
    menuSubheadingMessage: {
        id: 'rovo-extension.menu-page.menu-subheading-message',
        defaultMessage: 'Discover the latest updates and new features in Rovo',
        description: 'Message displayed on subheading of menu page.'
    },
    allCategoryLabel: {
        id: 'rovo-extension.menu-page.all-category-label',
        defaultMessage: 'All',
        description: 'The text is shown as a category filter tab or sidebar item in the menu page that, when selected, displays all available features across every category.'
    },
    aiSearchCategoryLabel: {
        id: 'rovo-extension.menu-page.ai-search-category-label',
        defaultMessage: 'AI Search',
        description: 'The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only AI Search-related features.'
    },
    chatCategoryLabel: {
        id: 'rovo-extension.menu-page.chat-category-label',
        defaultMessage: 'Chat',
        description: 'The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only Chat-related features.'
    },
    agentStudioCategoryLabel: {
        id: 'rovo-extension.menu-page.agent-studio-category-label',
        defaultMessage: 'Agent Studio',
        description: 'Label displayed for Agent Studio category'
    },
    extensionCategoryLabel: {
        id: 'rovo-extension.menu-page.extension-category-label',
        defaultMessage: 'Extension',
        description: 'The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only browser extension-specific features.'
    },
    announcementAriaLabel: {
        id: 'rovo-extension.menu-page.announcements.aria-label',
        defaultMessage: 'Announcement: {title}',
        description: 'Aria label for announcement on menu page. Title will be replaced with the actual announcement title.'
    }
});

});


parcelRegister("afq8D", function(module, exports) {
$parcel$export(module.exports, "MediaStyles", () => $961ffb54c1c96f2c$export$2850b44a08bd83be);
$parcel$export(module.exports, "default", () => $961ffb54c1c96f2c$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $eMSEP = parcelRequire("eMSEP");
var $f4K70 = parcelRequire("f4K70");
var $iOq8l = parcelRequire("iOq8l");
var $bQOrV = parcelRequire("bQOrV");

var $5X2O7 = parcelRequire("5X2O7");

var $bcdfp = parcelRequire("bcdfp");

var $kK7WO = parcelRequire("kK7WO");

var $2dnyN = parcelRequire("2dnyN");
parcelRequire("1wxU2");
var $6vVPG = parcelRequire("6vVPG");
const $961ffb54c1c96f2c$var$AnnouncementCardStyles = (0, $bQOrV.xcss)({
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.large',
    padding: 'space.400',
    marginBottom: 'space.400',
    boxShadow: 'elevation.shadow.raised',
    cursor: 'pointer',
    transition: 'box-shadow 0.3s ease',
    ':hover': {
        boxShadow: 'elevation.shadow.overlay'
    }
});
const $961ffb54c1c96f2c$var$InlineStyles = (0, $bQOrV.xcss)({
    display: 'flex',
    gap: 'space.100',
    flexWrap: 'wrap'
});
const $961ffb54c1c96f2c$var$HeadingSmallTextStyles = (0, $bQOrV.xcss)({
    font: 'font.heading.medium',
    fontWeight: 'font.weight.medium',
    marginBottom: 'space.200'
});
const $961ffb54c1c96f2c$var$BodyTextStyles = (0, $bQOrV.xcss)({
    font: 'font.body',
    marginBottom: 'space.200'
});
const $961ffb54c1c96f2c$export$2850b44a08bd83be = (0, $bQOrV.xcss)({
    maxWidth: '100%',
    height: 'auto',
    borderRadius: 'radius.small',
    marginBottom: 'space.300'
});
const $961ffb54c1c96f2c$var$LinkButtonStyles = (0, $bQOrV.xcss)({
    marginRight: 'space.100',
    marginBottom: 'space.100'
});
const $961ffb54c1c96f2c$var$DateStyles = (0, $bQOrV.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtlest'
});
const $961ffb54c1c96f2c$var$AnnouncementCard = ({ announcement: announcement, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        "aria-label": formatMessage((0, $2dnyN.messages).announcementAriaLabel, {
            title: announcement.title
        }),
        onClick: onClick,
        role: "button",
        tabIndex: 0,
        xcss: $961ffb54c1c96f2c$var$AnnouncementCardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
        name: "announcement-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        color: "color.text",
        xcss: $961ffb54c1c96f2c$var$HeadingSmallTextStyles
    }, announcement.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $961ffb54c1c96f2c$var$InlineStyles
    }, announcement.tags.map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5X2O7.default), {
            key: tag,
            appearance: "new",
            isBold: true
        }, tag.toUpperCase()))))), announcement.media && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
        name: "announcement-media"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        alt: announcement.media.alt ?? '',
        as: "img",
        src: announcement.media.url.default,
        xcss: $961ffb54c1c96f2c$export$2850b44a08bd83be
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
        name: "announcement-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $961ffb54c1c96f2c$var$BodyTextStyles
    }, announcement.content)), announcement.links && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
        name: "announcement-links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $961ffb54c1c96f2c$var$InlineStyles
    }, announcement.links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
            key: index,
            xcss: $961ffb54c1c96f2c$var$LinkButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bcdfp.default), {
            appearance: "default",
            href: link.url,
            rel: "noopener noreferrer",
            target: "_blank"
        }, link.text))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $961ffb54c1c96f2c$var$DateStyles
    }, announcement.date)));
};
var $961ffb54c1c96f2c$export$2e2bcd8739ae039 = $961ffb54c1c96f2c$var$AnnouncementCard;

});

parcelRegister("1ELgd", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9c6b8ee42d53ba5f$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $9c6b8ee42d53ba5f$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    shortcutTitle: {
        id: 'rovo-extension.announcements.shortcuts.title',
        defaultMessage: 'Extension shortcuts: Search and Chat even faster',
        description: 'The text is shown as the main heading of an announcement card or modal introducing keyboard shortcut features for the Rovo browser extension, specifically for Search and Chat actions.'
    },
    shortcutIntro: {
        id: 'rovo-extension.announcements.shortcuts.intro',
        defaultMessage: 'You can now use keyboard shortcuts to quickly access the best features in the extension.',
        description: 'Introduction text for shortcuts announcement'
    },
    chatTitle: {
        id: 'rovo-extension.announcements.shortcuts.chat.title',
        defaultMessage: 'Chat',
        description: 'The text is shown as a section heading within the shortcuts announcement, labelling the Chat shortcut subsection that describes how to open the Rovo chat feature.'
    },
    macChatAccess: {
        id: 'rovo-extension.announcements.shortcuts.mac-chat-access',
        defaultMessage: 'Access your extension-powered Chat at any time by pressing CMD + Shift + Y.',
        description: 'Chat shortcut instructions for Mac OS users'
    },
    windowsChatAccess: {
        id: 'rovo-extension.announcements.shortcuts.windows-chat-access',
        defaultMessage: 'Access your extension-powered Chat at any time by pressing CTRL + Shift + Y.',
        description: 'Chat shortcut instructions for windows users'
    },
    searchTitle: {
        id: 'rovo-extension.announcements.shortcuts.search.title',
        defaultMessage: 'Search',
        description: 'The text is shown as a section heading within the shortcuts announcement, labelling the Search shortcut subsection that describes how to use Rovo-powered search.'
    },
    searchAnytimeTitle: {
        id: 'rovo-extension.announcements.shortcuts.search.anytime.title',
        defaultMessage: 'Anytime, anywhere',
        description: 'The text is shown as a sub-heading within the Search shortcuts announcement section, introducing the feature that lets users search from anywhere in the browser at any time.'
    },
    searchAnytimeDesc: {
        id: 'rovo-extension.announcements.shortcuts.search.anytime.description',
        defaultMessage: 'From the address bar: Press r + space to perform a Rovo-powered search instantly.',
        description: 'The text is shown as a descriptive paragraph within the shortcuts announcement, explaining to users how to trigger a Rovo-powered search from the browser address bar using the "r + space" keyboard shortcut.'
    },
    searchNewTabTitle: {
        id: 'rovo-extension.announcements.shortcuts.search.newtab.title',
        defaultMessage: 'In your new tab Rovo page',
        description: 'The text is shown as a sub-heading within the Search shortcuts announcement section, introducing the search shortcut available on the Rovo new tab page.'
    },
    searchNewTabMacDesc: {
        id: 'rovo-extension.announcements.shortcuts.search.newtab.mac-description',
        defaultMessage: "If you're not in the address bar (you can hit tab to focus out of this), press CMD + B to jump into the Search box.",
        description: 'Description for new tab search feature for mac users'
    },
    searchNewTabWindowsDesc: {
        id: 'rovo-extension.announcements.shortcuts.search.newtab.windows-description',
        defaultMessage: "If you're not in the address bar (you can hit tab to focus out of this), press CTRL + B to jump into the Search box.",
        description: 'Description for new tab search feature for windows users'
    },
    shortcutGifAlt: {
        id: 'rovo-extension.announcements.shortcuts.images.shortcut-gif',
        defaultMessage: 'How to use search shortcut',
        description: 'The text is used as the alt attribute for an animated GIF image shown in the shortcuts announcement, demonstrating how to use the search shortcut keyboard combination.'
    },
    chatShortcutAlt: {
        id: 'rovo-extension.announcements.shortcuts.images.chat-shortcut',
        defaultMessage: 'Chat shortcut',
        description: 'The text is used as the alt attribute for an image shown in the shortcuts announcement, illustrating the keyboard shortcut keys used to open the Rovo chat feature.'
    },
    searchShortcutAlt: {
        id: 'rovo-extension.announcements.shortcuts.images.search-shortcut',
        defaultMessage: 'Search shortcut',
        description: 'The text is used as the alt attribute for an image shown in the shortcuts announcement, illustrating the keyboard shortcut keys used to trigger a Rovo-powered search.'
    },
    themingTitle: {
        id: 'rovo-extension.announcements.theming.title',
        defaultMessage: 'Company theming for your Rovo sites',
        description: 'The text is shown as the main heading of an announcement card or modal that introduces the company theming feature, allowing organisations to customise the appearance of their Rovo new tab page.'
    },
    themingIntro: {
        id: 'rovo-extension.announcements.theming.intro',
        defaultMessage: '<bold>Company Theming for the Rovo Browser Extension is Now Live!</bold>',
        description: 'Introduction text for theming announcement'
    },
    themingDescriptionFirstSection: {
        id: 'rovo-extension.announcements.theming.description.1',
        defaultMessage: "Imagine transforming your Rovo new tab page with a touch of your company's distinctive style. Organization administrators can customize the navigation of the Rovo new tab by adding a unique company logo and background.",
        description: 'The text is shown as the first descriptive paragraph in the company theming announcement modal, introducing the concept of customising the Rovo new tab page with company branding.'
    },
    themingDescriptionSecondSection: {
        id: 'rovo-extension.announcements.theming.description.2',
        defaultMessage: 'This enhancement goes beyond aesthetics; it highlights how your company is integrating AI into everyday workflows.',
        description: "The text is shown as the second descriptive paragraph in the company theming announcement modal, explaining that the theming feature also signals the company's adoption of AI in daily workflows."
    },
    themingDescriptionThirdSection: {
        id: 'rovo-extension.announcements.theming.description.3',
        defaultMessage: 'You can find this feature in the admin console settings located on the extension options page, <bold>accessible to all organization administrators</bold>. <link>Find more directions here</link>.',
        description: 'Last section of theming description with bold text and link'
    },
    themingImageBeforeAlt: {
        id: 'rovo-extension.announcements.theming.images.alt',
        defaultMessage: 'Preview of the Rovo Browser Extension new tab page before theming',
        description: 'The text is used as the alt attribute for an image in the theming announcement showing the Rovo browser extension new tab page in its default appearance before any company theming has been applied.'
    },
    themingImageAfterAlt: {
        id: 'rovo-extension.announcements.theming.images.alt',
        defaultMessage: 'Preview of the Rovo Browser Extension after theming',
        description: 'The text is used as the alt attribute for an image in the theming announcement showing the Rovo browser extension new tab page after company theming colours and branding have been applied.'
    }
});

});

parcelRegister("8XcJc", function(module, exports) {
module.exports = new URL("shortcut.81f036d5.gif", import.meta.url).toString();

});

parcelRegister("6JPfj", function(module, exports) {
module.exports = new URL("chat_shortcut_mac.b00550ed.png", import.meta.url).toString();

});

parcelRegister("bfsuf", function(module, exports) {
module.exports = new URL("search_shortcut_mac.e576f54b.png", import.meta.url).toString();

});

parcelRegister("hQ4xg", function(module, exports) {
module.exports = new URL("chat_shortcut_windows.6416e7a0.png", import.meta.url).toString();

});

parcelRegister("fietS", function(module, exports) {
module.exports = new URL("search_shortcut_windows.e0978f2a.png", import.meta.url).toString();

});

parcelRegister("i9BIV", function(module, exports) {
$parcel$export(module.exports, "isMacOs", () => $8ea0c380148ece2f$export$c5e71f489eb3970b);
const $8ea0c380148ece2f$export$c5e71f489eb3970b = ()=>/Mac/i.test(window.navigator.userAgent);

});


parcelRegister("dDkso", function(module, exports) {
$parcel$export(module.exports, "ThemingAnnouncementData", () => $d92e6ba7defe4170$export$9c183be060963bec);

var $1v5pe = parcelRequire("1v5pe");

var $eMSEP = parcelRequire("eMSEP");
var $f4K70 = parcelRequire("f4K70");
var $iOq8l = parcelRequire("iOq8l");
var $fRfXo = parcelRequire("fRfXo");
var $bQOrV = parcelRequire("bQOrV");

var $cYe7u = parcelRequire("cYe7u");

var $kK7WO = parcelRequire("kK7WO");

var $67Flg = parcelRequire("67Flg");

var $1ELgd = parcelRequire("1ELgd");

var $1RB7D = parcelRequire("1RB7D");

var $ebsiQ = parcelRequire("ebsiQ");
const $d92e6ba7defe4170$var$contentStyles = (0, $bQOrV.xcss)({
    marginTop: 'space.200'
});
const $d92e6ba7defe4170$var$ImageStyles = (0, $bQOrV.xcss)({
    width: '100%'
});
const $d92e6ba7defe4170$export$eeda29ad50ff5bb = ()=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $d92e6ba7defe4170$var$ImageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
        alt: formatMessage((0, $1ELgd.messages).themingImageBeforeAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1RB7D)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $d92e6ba7defe4170$var$ImageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
        alt: formatMessage((0, $1ELgd.messages).themingImageAfterAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ebsiQ)))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        space: "space.200",
        xcss: $d92e6ba7defe4170$var$contentStyles
    }, formatMessage((0, $1ELgd.messages).themingIntro, {
        bold: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("b", null, text)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fRfXo.default), null, formatMessage((0, $1ELgd.messages).themingDescriptionFirstSection)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fRfXo.default), null, formatMessage((0, $1ELgd.messages).themingDescriptionSecondSection)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fRfXo.default), null, formatMessage((0, $1ELgd.messages).themingDescriptionThirdSection, {
        bold: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("b", null, text),
        link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("a", {
                href: "https://community.atlassian.com/forums/Atlassian-AI-Rovo-articles/Brand-Rovo-as-your-company-s-search-amp-chat-company-theming-now/ba-p/3040952",
                rel: "noopener noreferrer",
                target: "_blank"
            }, text)
    })))));
};
const $d92e6ba7defe4170$export$9c183be060963bec = {
    title: (0, $1ELgd.messages).themingTitle.defaultMessage,
    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($d92e6ba7defe4170$export$eeda29ad50ff5bb, null),
    tags: [
        (0, $67Flg.CATEGORIES).EXTENSION
    ]
};
var $d92e6ba7defe4170$export$2e2bcd8739ae039 = $d92e6ba7defe4170$export$eeda29ad50ff5bb;

});
parcelRegister("1RB7D", function(module, exports) {
module.exports = new URL("theming_before.77c0996c.png", import.meta.url).toString();

});

parcelRegister("ebsiQ", function(module, exports) {
module.exports = new URL("theming_after.c6f8c1c8.png", import.meta.url).toString();

});



parcelRegister("5DgeC", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6b64ad8ad790c586$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $6b64ad8ad790c586$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    whatsNew: {
        id: 'rovo-extension.profile.whats-new-button.label',
        defaultMessage: "What's New",
        description: "Label for the 'What's new' button in the profile menu"
    },
    giveFeedback: {
        id: 'rovo-extension.profile.give-feedback-button.label',
        defaultMessage: 'Give feedback',
        description: "Label for the 'Give feedback' button in the profile menu"
    }
});

});

parcelRegister("3yHBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $f40feef796d9633c$export$2e2bcd8739ae039);

var $gWFtA = parcelRequire("gWFtA");

var $9f7IR = parcelRequire("9f7IR");

var $1v5pe = parcelRequire("1v5pe");

var $5fHZY = parcelRequire("5fHZY");

var $b2Az1 = parcelRequire("b2Az1");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $cGfIx = parcelRequire("cGfIx");

var $e9gYt = parcelRequire("e9gYt");

var $hAM4Q = parcelRequire("hAM4Q");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $53tof = parcelRequire("53tof");

const $f40feef796d9633c$var$AkFeedbackCollector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("aoiih")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $f40feef796d9633c$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("aoiih")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $f40feef796d9633c$export$d897f55d9ef86c2 = (feedback)=>{
    const summary = `[CHROME - ${(0, $dqHaj.bifrostEnv)}] ` + feedback;
    if (summary.length >= 255) return summary.substring(0, 250) + '...';
    return `Environment: ${0, $dqHaj.bifrostEnv}\n${summary}`;
};
const $f40feef796d9633c$export$2466210fe8715900 = (browserManifestVersion, site, userAccount)=>{
    const feedbackContext = {
        version: (0, $dqHaj.bitbucketCommit),
        release: browserManifestVersion,
        source: (0, $cGfIx.SOURCE),
        userId: userAccount.accountId,
        cloudId: site.workspace.cloudId,
        isHello: (0, $e9gYt.isHello)(site.workspace.cloudId),
        environment: (0, $dqHaj.bifrostEnv)
    };
    return JSON.stringify(feedbackContext);
};
const $f40feef796d9633c$var$FeedbackModal = ({ site: site, userAccount: userAccount, showModal: showModal, setShowModal: setShowModal })=>{
    const { browserManifestVersion: browserManifestVersion } = (0, $hAM4Q.useManifestVersion)();
    const [description, setDescription] = (0, $1v5pe.useState)('');
    const [displayFlag, setDisplayFlag] = (0, $1v5pe.useState)(false);
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const hideFlag = ()=>setDisplayFlag(false);
    const onSubmit = ()=>{
        setDisplayFlag(true);
        // https://data-portal.internal.atlassian.com/analytics/registry/73850
        sendAnalyticEvent({
            eventType: 'ui',
            event: {
                action: 'submitFeedback',
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).FEEDBACK_COLLECTOR,
                source: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_HOME_SCREEN
            },
            userId: userAccount.accountId
        });
    };
    const close = ()=>{
        setShowModal(false);
        setDescription('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1v5pe.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($f40feef796d9633c$var$AkFeedbackCollector, {
        additionalFields: [
            {
                id: (0, $cGfIx.FEEDBACK_CONTEXT_FIELD_ID),
                value: $f40feef796d9633c$export$2466210fe8715900(browserManifestVersion, site, userAccount)
            }
        ],
        atlassianAccountId: userAccount.accountId,
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $gWFtA.default), {
            defaultValue: "",
            isRequired: true,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $53tof.messages).feedbackCollectorLabel),
            name: "description-field"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9f7IR.default), {
                ...fieldProps,
                minimumRows: 6,
                name: "feedback-collector-description",
                onChange: (e)=>setDescription(e.target.value),
                placeholder: "",
                value: description
            }))),
        descriptionDefaultValue: description,
        email: userAccount.email,
        entrypointId: (0, $cGfIx.ENTRYPOINT_ID),
        locale: (0, $dqHaj.getLocale)(),
        name: userAccount.name,
        onClose: close,
        onSubmit: onSubmit,
        showDefaultTextFields: false,
        showTypeField: false,
        summaryDefaultValue: $f40feef796d9633c$export$d897f55d9ef86c2(description)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5fHZY.default), {
        onDismissed: hideFlag
    }, displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1v5pe.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($f40feef796d9633c$var$AkFeedbackFlag, {
        locale: (0, $dqHaj.getLocale)()
    }))));
};
var $f40feef796d9633c$export$2e2bcd8739ae039 = $f40feef796d9633c$var$FeedbackModal;

});
parcelRegister("cGfIx", function(module, exports) {
$parcel$export(module.exports, "ENTRYPOINT_ID", () => $a91d43cde40226d0$export$25dc0a1e75f58d8f);
$parcel$export(module.exports, "FEEDBACK_CONTEXT_FIELD_ID", () => $a91d43cde40226d0$export$7d5d4c32f29189c3);
$parcel$export(module.exports, "SOURCE", () => $a91d43cde40226d0$export$83c8d7110915321e);
// Feedbacks will be sent to Plex's feedback project
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/SANDSF/queues/custom/108
const $a91d43cde40226d0$export$25dc0a1e75f58d8f = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $a91d43cde40226d0$export$7d5d4c32f29189c3 = 'customfield_10047';
const $a91d43cde40226d0$export$83c8d7110915321e = 'rovo-extension';

});

parcelRegister("hAM4Q", function(module, exports) {
$parcel$export(module.exports, "useManifestVersion", () => $92f29700b4baddbf$export$d1a9989589baf7f6);
// Store the manifest version at module level to persist across navigation
let $92f29700b4baddbf$var$cachedManifestVersion = null;
function $92f29700b4baddbf$export$d1a9989589baf7f6() {
    if ($92f29700b4baddbf$var$cachedManifestVersion === null) {
        const { search: search } = window.location;
        $92f29700b4baddbf$var$cachedManifestVersion = new URLSearchParams(search).get('version') ?? '0.0';
    }
    const browserManifestVersion = $92f29700b4baddbf$var$cachedManifestVersion;
    const isNewerThan = (version)=>$92f29700b4baddbf$var$isGreaterThanCompareVersion(version, browserManifestVersion);
    return {
        browserManifestVersion: browserManifestVersion,
        isNewerThan: isNewerThan
    };
}
// Checks if the current version is greater than the comparison version
const $92f29700b4baddbf$var$isGreaterThanCompareVersion = (comparisonVersion, currentVersion)=>{
    const compareParts = comparisonVersion.split('.').map(Number);
    const currentParts = currentVersion.split('.').map(Number);
    for(let i = 0; i < 3; i++){
        const compareValue = compareParts[i] ?? 0;
        const currentValue = currentParts[i] ?? 0;
        if (currentValue > compareValue) return true;
        if (currentValue < compareValue) return false;
    }
    return false; // Versions equal
};

});

parcelRegister("53tof", function(module, exports) {
$parcel$export(module.exports, "messages", () => $37cd1038405fb930$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $37cd1038405fb930$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    giveFeedback: {
        id: 'rovo-extension.feedback.give-feedback-button.label',
        defaultMessage: 'Give feedback',
        description: 'The text is shown on a button in the Rovo extension interface that, when clicked, opens a feedback form or modal allowing the user to submit feedback about the extension.'
    },
    feedbackCollectorLabel: {
        id: 'rovo-extension.feedback.feedback-collector.label',
        defaultMessage: "Let us know what's on your mind",
        description: 'The text is shown as the introductory label or heading at the top of the feedback collector form or modal, prompting the user to share their thoughts about the Rovo extension.'
    },
    areYouEnjoying: {
        id: 'rovo-extension.feedback.are-you-enjoying.label',
        defaultMessage: 'Are you enjoying the Rovo Chrome plugin?',
        description: 'Label for the question asking if the user is enjoying the Rovo Chrome plugin.'
    },
    shareYourThoughts: {
        id: 'rovo-extension.feedback.share-your-thoughts.label',
        defaultMessage: 'Share your thoughts',
        description: 'Label for the title of the feedback modal.'
    },
    yes: {
        id: 'rovo-extension.feedback.yes.label',
        defaultMessage: 'Yes',
        description: "Label for the 'Yes' button in the feedback modal."
    },
    no: {
        id: 'rovo-extension.feedback.no.label',
        defaultMessage: 'No',
        description: "Label for the 'No' button in the feedback modal."
    },
    reviewConfirmationTitle: {
        id: 'rovo-extension.feedback.review-confirmation-title',
        defaultMessage: 'Thanks for the feedback!',
        description: 'Title for the review step shown in the feedback flag after user clicks Yes.'
    },
    reviewConfirmationBody: {
        id: 'rovo-extension.feedback.review-confirmation-body',
        defaultMessage: 'Want to leave a quick review in the Chrome Web Store?',
        description: 'Body text for the review step asking user to leave a Chrome Web Store review.'
    },
    reviewConfirmationConfirm: {
        id: 'rovo-extension.feedback.review-confirmation-confirm',
        defaultMessage: 'Leave a review',
        description: 'Label for the confirm button in the review step that opens Chrome Web Store.'
    },
    reviewConfirmationDismiss: {
        id: 'rovo-extension.feedback.review-confirmation-dismiss',
        defaultMessage: 'Not now',
        description: 'Label for the dismiss button in the review step of the feedback flag.'
    }
});

});

parcelRegister("aoiih", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("6y1PR"),
    $7mhPs("fNh6N")
]).then(()=>parcelRequire('43LZC'));

});


parcelRegister("jPKf9", function(module, exports) {
$parcel$export(module.exports, "useCurrentScreenName", () => $2ca03d226d0eebdb$export$ac619b093bd74b42);
parcelRequire("calFH");
var $30t8d = parcelRequire("30t8d");

var $lsxLV = parcelRequire("lsxLV");
const $2ca03d226d0eebdb$var$extensionPathToScreenNameMap = {
    '/extension': (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_HOME_SCREEN,
    '/extension/menu': (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_WHATS_NEW_SCREEN,
    '/extension/options': (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_OPTIONS_SCREEN,
    '/extension/rovo-chat': (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_CHAT_SCREEN
};
const $2ca03d226d0eebdb$var$isValidExtensionPath = (path)=>{
    return path in $2ca03d226d0eebdb$var$extensionPathToScreenNameMap;
};
const $2ca03d226d0eebdb$export$ac619b093bd74b42 = ()=>{
    const location = (0, $30t8d.useLocation)();
    const normalizedPath = location.pathname.replace(/\/$/, ''); // Remove trailing slash
    return $2ca03d226d0eebdb$var$isValidExtensionPath(normalizedPath) ? $2ca03d226d0eebdb$var$extensionPathToScreenNameMap[normalizedPath] : 'unknown';
};

});

parcelRegister("atGCc", function(module, exports) {
$parcel$export(module.exports, "SessionReplayUGC", () => (parcelRequire("8VUj0")).SessionReplayUGC);

var $8VUj0 = parcelRequire("8VUj0");

});
parcelRegister("8VUj0", function(module, exports) {
$parcel$export(module.exports, "SessionReplayUGC", () => $d95646efdf60abd0$export$dd7e8131d58a5e73);

var $1v5pe = parcelRequire("1v5pe");
const $d95646efdf60abd0$export$dd7e8131d58a5e73 = ({ as: Component = 'div', children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, {
        className: "amp-mask"
    }, children);
};

});



parcelRegister("gN3lo", function(module, exports) {
$parcel$export(module.exports, "ExtensionTopBarCompanyLogo", () => $20e2344e7517fc5c$export$37e6c72980c86988);

var $1v5pe = parcelRequire("1v5pe");

var $cYe7u = parcelRequire("cYe7u");

var $8G6Yr = parcelRequire("8G6Yr");

var $hpF1c = parcelRequire("hpF1c");
var $bQOrV = parcelRequire("bQOrV");

var $63LZx = parcelRequire("63LZx");

var $kK7WO = parcelRequire("kK7WO");

var $2vAyx = parcelRequire("2vAyx");

var $lHN9r = parcelRequire("lHN9r");

var $e9vmu = parcelRequire("e9vmu");

var $dX6kP = parcelRequire("dX6kP");

var $jPKf9 = parcelRequire("jPKf9");

var $lsxLV = parcelRequire("lsxLV");

var $30t8d = parcelRequire("30t8d");

var $kvcqg = parcelRequire("kvcqg");

var $056A9 = parcelRequire("056A9");

var $b0UAF = parcelRequire("b0UAF");
parcelRequire("jMN8E");
var $hZQIF = parcelRequire("hZQIF");
const $20e2344e7517fc5c$var$logoStyles = (0, $bQOrV.xcss)({
    height: "var(--ds-space-300, 24px)"
});
const $20e2344e7517fc5c$export$37e6c72980c86988 = ({ userAccount: userAccount, site: site })=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    const currentScreenName = (0, $jPKf9.useCurrentScreenName)();
    const handleLogoClick = (0, $1v5pe.useCallback)((e, logoType)=>{
        // Prevent anchor's default navigation to avoid full page reload when using React Router
        e.preventDefault();
        // https://data-portal.internal.atlassian.com/analytics/registry/86536
        sendAnalyticEvent({
            eventType: 'ui',
            event: {
                action: 'click',
                actionSubject: (0, $lsxLV.ANALYTICS_UI_SUBJECTS).NAV_BAR_LOGO,
                source: currentScreenName,
                attributes: {
                    logoType: logoType
                }
            },
            userId: userAccount.accountId
        });
    }, [
        currentScreenName,
        sendAnalyticEvent,
        userAccount.accountId
    ]);
    if (!site) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($20e2344e7517fc5c$var$DefaultCompanyIcon, {
        isRovoLLMEnabled: false,
        onLogoClick: handleLogoClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($20e2344e7517fc5c$var$CompanyIcon, {
        onLogoClick: handleLogoClick,
        site: site
    });
};
const $20e2344e7517fc5c$var$CompanyIcon = ({ site: site, onLogoClick: onLogoClick })=>{
    const { data: themeFileMetadata, isLoading: isLoading } = (0, $2vAyx.useNtpThemeFileMetadata)({
        siteId: site.workspace.cloudId
    });
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $b0UAF.useEntitlementCheck)();
    (0, $056A9.useQueryInvalidationBroadcast)([
        'getNtpThemeFileMetadata',
        site.workspace.cloudId
    ], true);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null);
    const logoThemeMetadata = themeFileMetadata?.find((m)=>m.themeFileType === (0, $lHN9r.ThemeFileType).LOGO);
    if (logoThemeMetadata) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($20e2344e7517fc5c$var$CustomCompanyIcon, {
        isRovoLLMEnabled: isRovoLLMEnabled,
        onLogoClick: onLogoClick,
        s3Etag: logoThemeMetadata.s3Etag,
        site: site
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($20e2344e7517fc5c$var$DefaultCompanyIcon, {
        isRovoLLMEnabled: isRovoLLMEnabled,
        onLogoClick: onLogoClick
    });
};
const $20e2344e7517fc5c$var$DefaultCompanyIcon = ({ onLogoClick: onLogoClick, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    const isOnHomePage = !!(0, $30t8d.useMatch)('/extension');
    const { navigateToChat: navigateToChat, navigateToRovoNtp: navigateToRovoNtp } = (0, $kvcqg.useExtensionNavigation)();
    const rovoIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $63LZx.RovoIcon), {
            shouldUseHexLogo: true,
            ...props
        });
    const rovoLogo = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $63LZx.RovoLogo), {
            shouldUseHexLogo: true,
            ...props
        });
    const handleDefaultLogoClick = (e)=>{
        onLogoClick(e, 'default');
        if (isOnHomePage && isRovoLLMEnabled) navigateToChat();
        else navigateToRovoNtp();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8G6Yr.NavLogo), {
        href: "/extension",
        icon: rovoIcon,
        label: formatMessage((0, $e9vmu.messages).homeLabel),
        logo: rovoLogo,
        onClick: handleDefaultLogoClick
    });
};
const $20e2344e7517fc5c$var$CustomCompanyIcon = ({ s3Etag: s3Etag, site: site, onLogoClick: onLogoClick, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    const { navigateToHome: navigateToHome, navigateToChatWithPrompt: navigateToChatWithPrompt } = (0, $kvcqg.useExtensionNavigation)();
    const { remoteAdminSettings: remoteAdminSettings } = (0, $hZQIF.useSettings)();
    const isOnHomePage = !!(0, $30t8d.useMatch)('/extension');
    const handleCustomLogoClick = (e)=>{
        onLogoClick(e, 'custom');
        if (isOnHomePage) {
            const companyQuery = remoteAdminSettings.customLogoCompanyQuery?.trim();
            const companyLink = remoteAdminSettings.customLogoCompanyLink?.trim();
            if (companyQuery && isRovoLLMEnabled) {
                navigateToChatWithPrompt(companyQuery);
                return;
            } else if (companyLink) {
                window.parent.location.href = companyLink;
                return;
            }
        }
        navigateToHome();
    };
    const { data: logoFileData, isLoading: isLoading } = (0, $2vAyx.useNtpThemeFile)({
        siteId: site.workspace.cloudId,
        fileType: (0, $lHN9r.ThemeFileType).LOGO,
        s3Etag: s3Etag
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $1v5pe.useState)(false);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null);
    if (!logoFileData?.url) // Fallback on default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($20e2344e7517fc5c$var$DefaultCompanyIcon, {
        isRovoLLMEnabled: isRovoLLMEnabled,
        onLogoClick: onLogoClick
    });
    const ImageComponent = (props)=>isImageLoaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
            alt: formatMessage((0, $e9vmu.messages).companyLogoAlt),
            src: logoFileData.url,
            style: {
                height: "var(--ds-space-300, 24px)"
            },
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cYe7u.default), {
            alt: formatMessage((0, $e9vmu.messages).companyLogoAlt),
            onLoad: ()=>setIsImageLoaded(true),
            src: logoFileData.url,
            style: {
                display: 'none'
            },
            ...props
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.default), {
        "aria-label": formatMessage((0, $e9vmu.messages).homeLabel),
        href: "/extension",
        onClick: handleCustomLogoClick,
        xcss: $20e2344e7517fc5c$var$logoStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(ImageComponent, null));
};

});
parcelRegister("2vAyx", function(module, exports) {
$parcel$export(module.exports, "ThemeValidationError", () => $4b1b5a4456d678f2$export$a8709ca93ec22f7a);
$parcel$export(module.exports, "uploadThemeImage", () => $4b1b5a4456d678f2$export$669ef9f41d56c75f);
$parcel$export(module.exports, "deleteThemeImage", () => $4b1b5a4456d678f2$export$8468f01ff043a3ba);
$parcel$export(module.exports, "updateThemeImage", () => $4b1b5a4456d678f2$export$e33cd16006ce448e);
$parcel$export(module.exports, "useNtpThemeFileMetadata", () => $4b1b5a4456d678f2$export$be984cb06a349554);
$parcel$export(module.exports, "useNtpThemeFile", () => $4b1b5a4456d678f2$export$64eb611b14b2dff3);

var $hAXMW = parcelRequire("hAXMW");

var $9aNsE = parcelRequire("9aNsE");

var $22hwD = parcelRequire("22hwD");

var $lHN9r = parcelRequire("lHN9r");
class $4b1b5a4456d678f2$export$a8709ca93ec22f7a extends Error {
    constructor(message){
        super(message);
        this.name = 'ThemeValidationError';
        this.type = (0, $lHN9r.ThemeErrorType).VALIDATION_ERROR;
        // ES5 does not fully support subclassing built-in types, instanceof operator doesn't function as expected for custom classes that extend built-in types like Error.
        // Explicitly setting prototype ensures instanceof correctly identifies instances of custom class and its superclasses
        Object.setPrototypeOf(this, $4b1b5a4456d678f2$export$a8709ca93ec22f7a.prototype);
    }
}
async function $4b1b5a4456d678f2$export$669ef9f41d56c75f({ file: file, fileType: fileType, siteId: siteId }) {
    if (!Object.values((0, $lHN9r.AllowedImageType)).includes(file.type)) throw new $4b1b5a4456d678f2$export$a8709ca93ec22f7a('File must be PNG, JPEG, or GIF');
    const formData = new FormData();
    formData.append('file', file);
    const response = await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: (0, $9aNsE.HTTPMethod).POST,
            credentials: 'include',
            extraHeaders: new Headers({
                'X-Product': 'rovo',
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': siteId
            }),
            body: formData
        }
    });
    return response;
}
async function $4b1b5a4456d678f2$export$8468f01ff043a3ba({ fileType: fileType, siteId: siteId }) {
    await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: (0, $9aNsE.HTTPMethod).DELETE,
            credentials: 'include',
            extraHeaders: new Headers({
                'X-Product': 'rovo',
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': siteId
            })
        }
    });
}
async function $4b1b5a4456d678f2$export$e33cd16006ce448e({ file: file, fileType: fileType, siteId: siteId }) {
    if (!Object.values((0, $lHN9r.AllowedImageType)).includes(file.type)) throw new $4b1b5a4456d678f2$export$a8709ca93ec22f7a('File must be PNG, JPEG, or GIF');
    const formData = new FormData();
    formData.append('file', file);
    const response = await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: (0, $9aNsE.HTTPMethod).PUT,
            credentials: 'include',
            extraHeaders: new Headers({
                'X-Product': 'rovo',
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': siteId
            }),
            body: formData
        }
    });
    return response;
}
/**
 * Type guard that validates a single item conforms to ThemeFileMetadata.
 */ function $4b1b5a4456d678f2$var$isThemeFileMetadata(item) {
    if (item === null || typeof item !== 'object') return false;
    const record = item;
    return typeof record.id === 'string' && typeof record.s3Etag === 'string' && typeof record.size === 'number' && typeof record.themeFileType === 'string' && Object.values((0, $lHN9r.ThemeFileType)).includes(record.themeFileType);
}
/**
 * Type guard that validates a response conforms to GetThemeFileMetadataResponse (ThemeFileMetadata[]).
 * Used as a runtime safety check since request<T> uses an unsafe `as T` cast on response.json().
 */ function $4b1b5a4456d678f2$var$isGetThemeFileMetadataResponse(response) {
    return Array.isArray(response) && response.every($4b1b5a4456d678f2$var$isThemeFileMetadata);
}
async function $4b1b5a4456d678f2$var$getNtpThemeFileMetadata(siteId) {
    const response = await (0, $9aNsE.request)({
        url: 'gateway/api/assist/rovo/v1/extension/theme/file/metadata',
        options: {
            method: 'GET',
            credentials: 'include',
            extraHeaders: new Headers({
                'X-Product': 'rovo',
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': siteId
            })
        }
    });
    if (!$4b1b5a4456d678f2$var$isGetThemeFileMetadataResponse(response)) {
        (0, $22hwD.logError)({
            error: new (0, $22hwD.NamedError)('ThemeMetadataInvalidResponseError', new Error(`Expected GetThemeFileMetadataResponse but received ${Array.isArray(response) ? 'array with invalid items' : typeof response}`)),
            impact: 'getNtpThemeFileMetadata response does not match expected type, returning empty array as fallback',
            extra: {
                isArray: Array.isArray(response),
                receivedType: typeof response,
                siteId: siteId
            }
        });
        return [];
    }
    return response;
}
function $4b1b5a4456d678f2$export$be984cb06a349554({ siteId: siteId }) {
    const queryFn = ()=>$4b1b5a4456d678f2$var$getNtpThemeFileMetadata(siteId);
    return (0, $hAXMW.useQuery)({
        queryKey: [
            'getNtpThemeFileMetadata',
            siteId
        ],
        queryFn: queryFn,
        refetchOnWindowFocus: false,
        enabled: true
    });
}
async function $4b1b5a4456d678f2$var$getNtpThemeFile({ siteId: siteId, fileType: fileType, s3Etag: s3Etag }) {
    const response = await (0, $9aNsE.request)({
        url: `gateway/api/assist/rovo/v1/extension/theme/file/${fileType}`,
        options: {
            method: 'GET',
            credentials: 'include',
            extraHeaders: new Headers({
                'Content-Type': 'image',
                'X-Product': 'rovo',
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': siteId,
                'X-ETag': s3Etag
            })
        }
    });
    const reader = response.body.getReader();
    const chunks = [];
    const blob = await reader.read().then(async function process({ done: done, value: value }) {
        if (done) return new Blob(chunks);
        chunks.push(value);
        return reader.read().then(process);
    });
    const url = URL.createObjectURL(blob);
    return {
        url: url
    };
}
function $4b1b5a4456d678f2$export$64eb611b14b2dff3({ siteId: siteId, fileType: fileType, s3Etag: s3Etag }) {
    return (0, $hAXMW.useQuery)({
        queryKey: [
            'getNtpThemeFile',
            siteId,
            fileType,
            s3Etag
        ],
        queryFn: ()=>$4b1b5a4456d678f2$var$getNtpThemeFile({
                siteId: siteId,
                fileType: fileType,
                s3Etag: s3Etag
            }),
        refetchOnWindowFocus: false
    });
}

});
parcelRegister("lHN9r", function(module, exports) {
$parcel$export(module.exports, "ThemeFileType", () => $5b5dd0d32edc83ba$export$dd66fc48c3b68388);
$parcel$export(module.exports, "AllowedImageType", () => $5b5dd0d32edc83ba$export$efe490cbd0256876);
$parcel$export(module.exports, "ThemeErrorType", () => $5b5dd0d32edc83ba$export$bea1b160bc7d7c5b);
var $5b5dd0d32edc83ba$export$dd66fc48c3b68388 = /*#__PURE__*/ function(ThemeFileType) {
    ThemeFileType["BACKGROUND"] = "BACKGROUND";
    ThemeFileType["DARK_BACKGROUND"] = "DARKBACKGROUND";
    ThemeFileType["LOGO"] = "LOGO";
    return ThemeFileType;
}({});
var $5b5dd0d32edc83ba$export$efe490cbd0256876 = /*#__PURE__*/ function(AllowedImageType) {
    AllowedImageType["PNG"] = "image/png";
    AllowedImageType["JPEG"] = "image/jpeg";
    AllowedImageType["GIF"] = "image/gif";
    return AllowedImageType;
}({});
var $5b5dd0d32edc83ba$export$bea1b160bc7d7c5b = /*#__PURE__*/ function(ThemeErrorType) {
    ThemeErrorType["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    return ThemeErrorType;
}({});

});


parcelRegister("e9vmu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8c5952f9266aa28d$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $8c5952f9266aa28d$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    companyLogoAlt: {
        id: 'rovo-extension.navigation.company-logo.alt',
        defaultMessage: 'Company logo',
        description: 'The text is used as the alt attribute for the company logo image shown in the top navigation bar of the Rovo new tab page when an organisation has configured their company branding.'
    },
    homeLabel: {
        id: 'rovo-extension.navigation.home.label',
        defaultMessage: 'Home',
        description: 'The text is used as an aria-label or visible label for the Home navigation item in the top navigation bar of the Rovo extension, which takes the user back to the main new tab page.'
    },
    siteNavigationLabel: {
        id: 'rovo-extension.navigation.site.label',
        defaultMessage: 'site',
        description: 'Label for site navigation component. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on.'
    },
    siteIconLabel: {
        id: 'rovo-extension.navigation.site-icon.label',
        defaultMessage: 'site',
        description: 'Label for site icon in site switcher. Label is used for screenreaders only, not rendered in UI. Here, site refers to the Atlassian organization the user is on. Icon is the ADS office building icon.'
    },
    appSwitcherTooltip: {
        id: 'rovo-extension.navigation.app-switcher.tooltip',
        defaultMessage: 'Switch to...',
        description: 'The text is shown as a tooltip on the app switcher icon button in the top navigation bar of the Rovo extension, indicating that clicking it will allow the user to switch between Atlassian products.'
    }
});

});

parcelRegister("kvcqg", function(module, exports) {
$parcel$export(module.exports, "useExtensionNavigation", () => $5ff1dabdd9a7cbf0$export$525656442beacd31);
parcelRequire("calFH");
var $30t8d = parcelRequire("30t8d");

var $bI4fx = parcelRequire("bI4fx");
// Capture the initial pathname at module load time (before React Router changes it)
let $5ff1dabdd9a7cbf0$var$initialPathname = typeof window !== 'undefined' ? window.location.pathname : '/extension';
function $5ff1dabdd9a7cbf0$export$a7b3e8fb508d50bd(pathname) {
    $5ff1dabdd9a7cbf0$var$initialPathname = pathname;
}
function $5ff1dabdd9a7cbf0$export$1f865db7b7fcff3f() {
    return $5ff1dabdd9a7cbf0$var$initialPathname === '/extension';
}
function $5ff1dabdd9a7cbf0$export$525656442beacd31() {
    const navigate = (0, $30t8d.useNavigate)();
    const navigateToHome = ()=>{
        if ($5ff1dabdd9a7cbf0$export$1f865db7b7fcff3f()) navigate('/extension');
        else // In non-NTP contexts (like options), ask the parent page to open the NTP via full page refresh.
        // This is necessary to ensure we properly initialize window message event listeners via ntp.js
        (0, $bI4fx.postMessageToParent)({
            type: 'NAVIGATE_TO_HOME'
        });
    };
    const navigateToRovoNtp = ()=>{
        if ($5ff1dabdd9a7cbf0$export$1f865db7b7fcff3f()) navigate('/extension');
        else // In non-NTP contexts (like options), ask the parent page to open the Rovo Extension NTP directly,
        // bypassing any user/admin-configured NTP redirect URL.
        (0, $bI4fx.postMessageToParent)({
            type: 'NAVIGATE_TO_ROVO_NTP'
        });
    };
    const navigateToOptionsPage = ()=>{
        navigate('/extension/options');
    };
    const navigateToChat = ()=>{
        navigate('/extension/rovo-chat?fullPageChat=true');
    };
    const navigateToChatWithPrompt = (prompt)=>{
        const encodedPrompt = encodeURIComponent(prompt);
        navigate(`/extension/rovo-chat?rovoChatPathway=chat&rovoChatPrompt=${encodedPrompt}&fullPageChat=true`);
    };
    return {
        navigateToHome: navigateToHome,
        navigateToRovoNtp: navigateToRovoNtp,
        navigateToOptionsPage: navigateToOptionsPage,
        navigateToChat: navigateToChat,
        navigateToChatWithPrompt: navigateToChatWithPrompt
    };
}

});

parcelRegister("056A9", function(module, exports) {
$parcel$export(module.exports, "useQueryInvalidationBroadcast", () => $3555b665f89f05cf$export$8e80384d8b3de2d);

var $1v5pe = parcelRequire("1v5pe");

var $eAih2 = parcelRequire("eAih2");

var $22hwD = parcelRequire("22hwD");
const $3555b665f89f05cf$var$CHANNEL_NAME = 'query-cache-invalidation';
function $3555b665f89f05cf$export$8e80384d8b3de2d(queryKey, listen = false) {
    const queryClient = (0, $eAih2.useQueryClient)();
    const queryKeyRef = (0, $1v5pe.useRef)(queryKey);
    const channelRef = (0, $1v5pe.useRef)(null);
    // Keep queryKey ref updated
    (0, $1v5pe.useEffect)(()=>{
        queryKeyRef.current = queryKey;
    }, [
        queryKey
    ]);
    // Set up listener for invalidation messages from other tabs
    (0, $1v5pe.useEffect)(()=>{
        if (!listen) return;
        try {
            channelRef.current = new BroadcastChannel($3555b665f89f05cf$var$CHANNEL_NAME);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'Failed to create BroadcastChannel for query invalidation',
                extra: {
                    channelName: $3555b665f89f05cf$var$CHANNEL_NAME
                }
            });
            return;
        }
        const handleMessage = (event)=>{
            if (event.data.type === 'INVALIDATE_QUERY' && Array.isArray(event.data.queryKey)) {
                // Check if this message is for our query key
                const messageKey = JSON.stringify(event.data.queryKey);
                const ourKey = JSON.stringify(queryKeyRef.current);
                if (messageKey === ourKey) queryClient.invalidateQueries({
                    queryKey: event.data.queryKey
                }).catch((error)=>{
                    (0, $22hwD.logError)({
                        error: error,
                        impact: 'Failed to invalidate query cache from broadcast',
                        extra: {
                            queryKey: event.data.queryKey
                        }
                    });
                });
            }
        };
        channelRef.current.addEventListener('message', handleMessage);
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener('message', handleMessage);
                channelRef.current.close();
                channelRef.current = null;
            }
        };
    }, [
        listen,
        queryClient
    ]);
    // Function to broadcast invalidation to other tabs
    const broadcastInvalidation = (0, $1v5pe.useCallback)(()=>{
        try {
            const channel = new BroadcastChannel($3555b665f89f05cf$var$CHANNEL_NAME);
            channel.postMessage({
                type: 'INVALIDATE_QUERY',
                queryKey: queryKeyRef.current,
                timestamp: Date.now()
            });
            channel.close();
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'Failed to broadcast query invalidation to other tabs',
                extra: {
                    queryKey: queryKeyRef.current
                }
            });
        }
    }, []);
    return {
        broadcastInvalidation: broadcastInvalidation
    };
}

});

parcelRegister("b0UAF", function(module, exports) {
$parcel$export(module.exports, "useEntitlementCheck", () => $7e5010d2d976a390$export$45b3e3e13efd78c7);

var $1v5pe = parcelRequire("1v5pe");

var $dNZ1k = parcelRequire("dNZ1k");

var $kK7WO = parcelRequire("kK7WO");

var $eAih2 = parcelRequire("eAih2");

var $bFW4F = parcelRequire("bFW4F");

var $1QYE6 = parcelRequire("1QYE6");

var $9JAaz = parcelRequire("9JAaz");

var $2bRmU = parcelRequire("2bRmU");
const $7e5010d2d976a390$var$errorState = {
    shownFlag: false
};
const $7e5010d2d976a390$export$45b3e3e13efd78c7 = ()=>{
    const { site: site } = (0, $1QYE6.useSite)();
    const { showFlag: showFlag } = (0, $dNZ1k.useFlags)();
    const queryClient = (0, $eAih2.useQueryClient)();
    const { data: rovoEntitlement, error: error, isLoading: isLoading } = (0, $bFW4F.useRovoEntitlement)(site.workspace.cloudId);
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    (0, $1v5pe.useEffect)(()=>{
        if (error && !$7e5010d2d976a390$var$errorState.shownFlag) {
            $7e5010d2d976a390$var$errorState.shownFlag = true;
            showFlag({
                title: formatMessage((0, $2bRmU.messages).entitlementCheckFailedFlagTitle),
                description: formatMessage((0, $2bRmU.messages).entitlementCheckFailedFlagDescription),
                appearance: 'error',
                actions: [
                    {
                        content: formatMessage((0, $2bRmU.messages).entitlementCheckFailedFlagAction),
                        onClick: async ()=>{
                            await queryClient.invalidateQueries({
                                queryKey: [
                                    'rovoEntitlement',
                                    site.workspace.cloudId
                                ]
                            });
                            window.location.reload();
                        }
                    }
                ]
            });
        }
    }, [
        error,
        showFlag,
        queryClient,
        site.workspace.cloudId,
        formatMessage
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (rovoEntitlement) (0, $9JAaz.broadcastEntitlementToExtension)(rovoEntitlement.isRovoLLMEnabled);
    }, [
        rovoEntitlement
    ]);
    return {
        isRovoLLMEnabled: rovoEntitlement?.isRovoLLMEnabled ?? false,
        isLoading: isLoading
    };
};

});
parcelRegister("9JAaz", function(module, exports) {
$parcel$export(module.exports, "broadcastConfigToExtension", () => $f02ad6548406da52$export$19d3f038df2cba24);
$parcel$export(module.exports, "broadcastEntitlementToExtension", () => $f02ad6548406da52$export$efabda5991991ee8);
$parcel$export(module.exports, "broadcastRovoContextMenuVariantsToExtension", () => $f02ad6548406da52$export$e476148910d14e6d);

var $bI4fx = parcelRequire("bI4fx");
function $f02ad6548406da52$export$19d3f038df2cba24(site) {
    (0, $bI4fx.postMessageToParent)({
        type: 'SITE_DATA_UPDATE',
        value: site && {
            baseUrl: site.defaultSiteBaseUrl,
            cloudId: site.workspace.cloudId,
            orgId: site.workspace.organisationId
        }
    });
}
function $f02ad6548406da52$export$efabda5991991ee8(isRovoLLMEnabled) {
    (0, $bI4fx.postMessageToParent)({
        type: 'ENTITLEMENT_DATA_UPDATE',
        value: {
            isRovoLLMEnabled: isRovoLLMEnabled
        }
    });
}
function $f02ad6548406da52$export$e476148910d14e6d(variants) {
    (0, $bI4fx.postMessageToParent)({
        type: 'SET_ROVO_CONTEXT_MENU_VARIANTS',
        value: variants
    });
}
function $f02ad6548406da52$export$2764600b87a6588d(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;
    return a.workspace.cloudId === b.workspace.cloudId && a.workspace.organisationId === b.workspace.organisationId && a.defaultSiteBaseUrl === b.defaultSiteBaseUrl;
}
function $f02ad6548406da52$export$dd6ffe7a6a2a2431(a, b) {
    return a === b || a?.cloudId === b?.workspace.cloudId && a?.orgId === b?.workspace.organisationId && a?.baseUrl === b?.defaultSiteBaseUrl;
}

});

parcelRegister("2bRmU", function(module, exports) {
$parcel$export(module.exports, "messages", () => $280c5846829aee26$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $280c5846829aee26$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    entitlementCheckFailedFlagTitle: {
        id: 'rovo-extension.hook.entitlement-check-failed-flag-title',
        defaultMessage: 'Failed to retrieve Rovo access',
        description: 'Title for the entitlement check failed flag'
    },
    entitlementCheckFailedFlagDescription: {
        id: 'rovo-extension.hook.entitlement-check-failed-flag-description',
        defaultMessage: "Something went wrong when checking your access to Rovo. Click 'Try again' to access AI chat.",
        description: 'Description for the entitlement check failed flag'
    },
    entitlementCheckFailedFlagAction: {
        id: 'rovo-extension.hook.entitlement-check-failed-flag-action',
        defaultMessage: 'Try again',
        description: 'Action for the entitlement check failed flag'
    }
});

});


parcelRegister("jMN8E", function(module, exports) {
$parcel$export(module.exports, "SettingsProvider", () => (parcelRequire("hZQIF")).SettingsProvider);
$parcel$export(module.exports, "useSettings", () => (parcelRequire("hZQIF")).useSettings);

var $hZQIF = parcelRequire("hZQIF");

});
parcelRegister("hZQIF", function(module, exports) {
$parcel$export(module.exports, "SettingsProvider", () => $cdf5305077045ce8$export$e134aa690da9cc14);
$parcel$export(module.exports, "useSettings", () => $cdf5305077045ce8$export$9115b42802a3e44f);

var $1v5pe = parcelRequire("1v5pe");

var $jbdyd = parcelRequire("jbdyd");
var $hAXMW = parcelRequire("hAXMW");
var $eAih2 = parcelRequire("eAih2");

var $1QYE6 = parcelRequire("1QYE6");

var $22hwD = parcelRequire("22hwD");

var $bI4fx = parcelRequire("bI4fx");

var $bFW4F = parcelRequire("bFW4F");

var $9feau = parcelRequire("9feau");
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");

var $gLHVH = parcelRequire("gLHVH");

var $id9ES = parcelRequire("id9ES");

var $bdhse = parcelRequire("bdhse");
var $cdf5305077045ce8$export$422cbc209f7199c9 = /*#__PURE__*/ function(SettingsQueryKeys) {
    SettingsQueryKeys["REMOTE_ADMIN_SETTINGS"] = "remoteAdminSettings";
    return SettingsQueryKeys;
}({});
/**
 * Checks chrome.storage.local for cached remote admin settings via message bus
 */ function $cdf5305077045ce8$var$getCachedRemoteAdminSettings(siteId) {
    return new Promise((resolve)=>{
        const timeoutId = setTimeout(()=>{
            window.removeEventListener('message', messageHandler);
            resolve(null);
        }, 2000);
        const messageHandler = (event)=>{
            if (event.data.type === 'GET_REMOTE_ADMIN_SETTINGS_CACHE_RESPONSE') {
                clearTimeout(timeoutId);
                window.removeEventListener('message', messageHandler);
                resolve(event.data.data);
            }
        };
        window.addEventListener('message', messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: 'GET_REMOTE_ADMIN_SETTINGS_CACHE',
            siteId: siteId
        });
    });
}
/**
 * Updates the chrome.storage.local cache with new settings
 */ function $cdf5305077045ce8$var$setCachedRemoteAdminSettings(siteId, settings) {
    (0, $bI4fx.postMessageToParent)({
        type: 'SET_REMOTE_ADMIN_SETTINGS_CACHE',
        siteId: siteId,
        settings: settings
    });
}
/**
 * Clears the chrome.storage.local cache to force a fresh API fetch
 * Returns a promise that resolves after a short delay to allow the message to be processed
 */ function $cdf5305077045ce8$var$clearCachedRemoteAdminSettings(siteId) {
    (0, $bI4fx.postMessageToParent)({
        type: 'CLEAR_REMOTE_ADMIN_SETTINGS_CACHE',
        siteId: siteId
    });
    // Wait a short time for the message to be processed by the parent
    return new Promise((resolve)=>setTimeout(resolve, 100));
}
/**
 * Fetches remote admin settings with chrome.storage.local caching
 */ async function $cdf5305077045ce8$var$fetchRemoteAdminSettingsWithCache(siteId) {
    const cachedData = await $cdf5305077045ce8$var$getCachedRemoteAdminSettings(siteId);
    if (cachedData !== null) return cachedData;
    const freshData = await (0, $bFW4F.getRovoExtensionAdminSettings)(siteId);
    $cdf5305077045ce8$var$setCachedRemoteAdminSettings(siteId, freshData);
    return freshData;
}
const $cdf5305077045ce8$var$SettingsContext = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $cdf5305077045ce8$export$e134aa690da9cc14 = ({ children: children })=>{
    const [chromeStoredSettings, setChromeStoredSettings] = (0, $1v5pe.useState)((0, $id9ES.DEFAULT_CHROME_STORED_SETTINGS));
    (0, $1v5pe.useEffect)(()=>{
        const messageHandler = (event)=>{
            switch(event.data.type){
                case 'GET_OPTIONS_RESPONSE':
                case 'SET_OPTIONS_RESPONSE':
                    setChromeStoredSettings((prev)=>({
                            ...prev,
                            ...event.data.options
                        }));
                    break;
                default:
                    break;
            }
        };
        window.addEventListener('message', messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: 'GET_OPTIONS'
        });
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, []);
    const updateChromeStoredSetting = (0, $1v5pe.useCallback)((params)=>{
        setChromeStoredSettings((prev)=>({
                ...prev,
                [params.key]: params.value
            }));
        (0, $bI4fx.postMessageToParent)({
            type: 'SET_OPTIONS',
            updated: {
                [params.key]: params.value
            },
            ...params.key === 'rovoCompanionEnabled' && params.value === false ? {
                suppressCompanionDisabledPopup: true
            } : {}
        });
    }, []);
    const [welcomeHeaderEnabled, setWelcomeHeaderEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED, true);
    const [globalCreateEnabled, setGlobalCreateEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED, true);
    const [localDevBannerEnabled, setLocalDevBannerEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED, true);
    const [calendarEnabled, setCalendarEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED, false);
    const [recentWorkEnabled, setRecentWorkEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED, true);
    const [bookmarksEnabled, setBookmarksEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED, true);
    const [announcementsEnabled, setAnnouncementsEnabled] = (0, $gLHVH.useStateWithSync)((0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED, true);
    const localStoredSettings = (0, $1v5pe.useMemo)(()=>({
            [(0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED]: welcomeHeaderEnabled,
            [(0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED]: globalCreateEnabled,
            [(0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED]: localDevBannerEnabled,
            [(0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED]: calendarEnabled,
            [(0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED]: recentWorkEnabled,
            [(0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED]: bookmarksEnabled,
            [(0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED]: announcementsEnabled
        }), [
        welcomeHeaderEnabled,
        globalCreateEnabled,
        localDevBannerEnabled,
        calendarEnabled,
        recentWorkEnabled,
        bookmarksEnabled,
        announcementsEnabled
    ]);
    const updateLocalStoredSetting = (0, $1v5pe.useCallback)((params)=>{
        switch(params.key){
            case (0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED:
                setWelcomeHeaderEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED:
                setGlobalCreateEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED:
                setLocalDevBannerEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED:
                setCalendarEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED:
                setRecentWorkEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED:
                setBookmarksEnabled(params.value);
                return;
            case (0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED:
                setAnnouncementsEnabled(params.value);
                return;
            default:
                return;
        }
    }, [
        setWelcomeHeaderEnabled,
        setGlobalCreateEnabled,
        setLocalDevBannerEnabled,
        setCalendarEnabled,
        setRecentWorkEnabled,
        setBookmarksEnabled,
        setAnnouncementsEnabled
    ]);
    const siteContext = (0, $1QYE6.useSite)({
        allowUndefined: true
    });
    const siteId = siteContext ? siteContext.site.workspace.cloudId : undefined;
    const queryClient = (0, $eAih2.useQueryClient)();
    const [remoteAdminSettingsMutationError, setRemoteAdminSettingsMutationError] = (0, $1v5pe.useState)(null);
    const { data: remoteAdminSettings = (0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS), isLoading: isLoadingRemoteAdminSettings, error: queryErrorRaw } = (0, $hAXMW.useQuery)({
        queryKey: [
            "remoteAdminSettings",
            siteId
        ],
        queryFn: ()=>{
            if (!siteId) throw new Error('siteId is required to fetch remote admin settings');
            return $cdf5305077045ce8$var$fetchRemoteAdminSettingsWithCache(siteId);
        },
        enabled: !!siteId,
        staleTime: 60000,
        // Re-check chrome.storage to hand off caching decisions
        gcTime: Infinity,
        refetchOnWindowFocus: false,
        retry: 1,
        throwOnError: false
    });
    const previousErrorRef = (0, $1v5pe.useRef)(null);
    // Handle error logging once when error state changes
    (0, $1v5pe.useEffect)(()=>{
        if (queryErrorRaw && queryErrorRaw !== previousErrorRef.current) {
            (0, $22hwD.logError)({
                error: queryErrorRaw,
                impact: 'Failed to fetch remote admin settings'
            });
            previousErrorRef.current = queryErrorRaw;
        }
    }, [
        queryErrorRaw
    ]);
    const remoteAdminSettingsQueryError = (0, $1v5pe.useMemo)(()=>{
        if (!queryErrorRaw) return null;
        return new (0, $9feau.RemoteAdminSettingsError)({
            type: (0, $9feau.RemoteAdminSettingsErrorType).QUERY_ERROR,
            originalError: queryErrorRaw
        });
    }, [
        queryErrorRaw
    ]);
    const mutation = (0, $jbdyd.useMutation)({
        mutationFn: async (data)=>{
            if (!siteId) throw new Error('siteId is required to update remote admin settings');
            return (0, $bFW4F.saveRovoExtensionAdminSettings)(siteId, data);
        },
        onMutate: async (newData)=>{
            // Cancel any outgoing refetches to avoid overwriting optimistic update
            await queryClient.cancelQueries({
                queryKey: [
                    "remoteAdminSettings",
                    siteId
                ]
            });
            // Snapshot the previous value.
            // NOTE: React Query cache may be empty on first load; keep a concrete fallback so we can always rollback.
            const previousSettingsFromCache = queryClient.getQueryData([
                "remoteAdminSettings",
                siteId
            ]);
            const previousSettings = previousSettingsFromCache ?? (0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS);
            // Optimistically update to the new value
            const optimisticSettings = {
                ...previousSettings,
                ...newData
            };
            queryClient.setQueryData([
                "remoteAdminSettings",
                siteId
            ], optimisticSettings);
            // Return context with the previous value for rollback
            return {
                previousSettings: previousSettings
            };
        },
        onError: (originalError, newData, context)=>{
            // Rollback to previous value on error
            queryClient.setQueryData([
                "remoteAdminSettings",
                siteId
            ], context?.previousSettings ?? (0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS));
            const settingKey = Object.keys(newData)[0];
            const error = new (0, $9feau.RemoteAdminSettingsError)({
                type: (0, $9feau.RemoteAdminSettingsErrorType).MUTATION_ERROR,
                originalError: originalError,
                context: {
                    settingKey: settingKey,
                    attemptedValue: Object.values(newData)[0],
                    previousValue: context?.previousSettings?.[settingKey]
                }
            });
            setRemoteAdminSettingsMutationError(error);
            (0, $22hwD.logError)({
                error: originalError,
                impact: 'Failed to update remote admin settings'
            });
        },
        onSuccess: (data)=>{
            // Update chrome.storage.local so other tabs immediately see the new settings
            if (siteId) $cdf5305077045ce8$var$setCachedRemoteAdminSettings(siteId, data);
        },
        onSettled: ()=>{
            // Refetch to ensure we have the latest data
            queryClient.invalidateQueries({
                queryKey: [
                    "remoteAdminSettings",
                    siteId
                ]
            });
        }
    });
    const updateRemoteAdminSettings = (0, $1v5pe.useCallback)(async (params)=>{
        if (!siteId) return;
        // Clear previous mutation error when starting a new mutation
        setRemoteAdminSettingsMutationError(null);
        try {
            await mutation.mutateAsync({
                [params.key]: params.value
            });
        } catch  {
        // Error is handled by onError callback, but we need to catch it here
        // to prevent unhandled promise rejection
        }
    }, [
        siteId,
        mutation
    ]);
    const refreshRemoteAdminSettings = (0, $1v5pe.useCallback)(async ()=>{
        if (!siteId) return;
        // Step 1: Clear chrome.storage.local cache and wait for it to be processed
        await $cdf5305077045ce8$var$clearCachedRemoteAdminSettings(siteId);
        // Step 2: Invalidate React Query state, triggering a refetch
        await queryClient.invalidateQueries({
            queryKey: [
                "remoteAdminSettings",
                siteId
            ]
        });
    }, [
        siteId,
        queryClient
    ]);
    const effectiveRemoteAdminSettings = (0, $1v5pe.useMemo)(()=>{
        const merged = {
            ...(0, $id9ES.DEFAULT_REMOTE_ADMIN_SETTINGS),
            ...remoteAdminSettings
        };
        // The admin surface is a single toggle plus an opt-in URL field; together
        // they encode three enforcement modes:
        //
        //   `controlledUserNtpEnabled === true`         → mode 1 (enforce Rovo NTP
        //                                                 on all users)
        //   `controlledUserNtpEnabled === false` + no
        //   valid `defaultNtpUrl` (or undefined)        → mode 2 (no enforcement;
        //                                                 users default to Rovo
        //                                                 and may opt out)
        //   `controlledUserNtpEnabled === false` plus a
        //   valid `defaultNtpUrl`                       → mode 3 (enforce that URL
        //                                                 on all users)
        //
        // The admin-set redirect URL is therefore only meaningful in mode 3 — i.e.
        // when `controlledUserNtpEnabled === false`. Mask it everywhere else so
        // chrome.storage, the user-side hide-when-active gate, and the admin-side
        // defaulting in `DefaultNtpUrlField` all see the same coherent value
        // without each duplicating the gate.
        const isAdminDefaultNtpUrlInScope = merged.controlledUserNtpEnabled === false;
        return {
            ...merged,
            defaultNtpUrl: isAdminDefaultNtpUrlInScope ? merged.defaultNtpUrl : ''
        };
    }, [
        remoteAdminSettings
    ]);
    const syncAdminControlledFeaturesToChrome = (0, $1v5pe.useCallback)((settings)=>{
        (0, $bI4fx.postMessageToParent)({
            type: 'SET_ADMIN_CONTROLLED_FEATURES',
            features: {
                definitionsAppEnabled: settings.controlledUserGdocsDefinitionsEnabled !== false,
                defaultNtpUrl: settings.defaultNtpUrl
            }
        });
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        syncAdminControlledFeaturesToChrome(effectiveRemoteAdminSettings);
    }, [
        effectiveRemoteAdminSettings,
        isLoadingRemoteAdminSettings,
        syncAdminControlledFeaturesToChrome
    ]);
    const previousNtpEnforcementModeRef = (0, $1v5pe.useRef)(undefined);
    const previousControlledUserCompanionEnabledRef = (0, $1v5pe.useRef)(undefined);
    const previousControlledUserCompanyAnnouncementsRef = (0, $1v5pe.useRef)(undefined);
    (0, $1v5pe.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        const currentNtp = effectiveRemoteAdminSettings.controlledUserNtpEnabled;
        const adminUrl = effectiveRemoteAdminSettings.defaultNtpUrl;
        // Tri-state mode resolution. `defaultNtpUrl` has already been masked to
        // `""` when the admin is not in mode 3, so a non-empty + http(s)-valid
        // value here is the unambiguous mode-3 signal.
        const currentMode = currentNtp === true ? 'enforceRovo' : currentNtp === false && adminUrl.length > 0 && (0, $bdhse.isValidHttpUrl)(adminUrl) ? 'enforceCustomUrl' : 'noEnforcement';
        const previousMode = previousNtpEnforcementModeRef.current;
        if (currentMode !== previousMode) {
            if (currentMode === 'enforceRovo') // Force the user's stored `ntpEnabled` to true so `setupNewTabPage`
            // renders the iframe regardless of any prior opt-out.
            (0, $bI4fx.postMessageToParent)({
                type: 'SET_OPTIONS',
                updated: {
                    ntpEnabled: true
                }
            });
            else if (currentMode === 'enforceCustomUrl') // Force `ntpEnabled = false` so the runtime falls into the redirect
            // branch and applies the admin's URL.
            (0, $bI4fx.postMessageToParent)({
                type: 'SET_OPTIONS',
                updated: {
                    ntpEnabled: false
                }
            });
            else if (previousMode === 'enforceRovo' || previousMode === 'enforceCustomUrl') // Admin lifted enforcement → reset the user's stored value to the
            // default. The user can then opt in/out from their own settings.
            (0, $bI4fx.postMessageToParent)({
                type: 'SET_OPTIONS',
                updated: {
                    ntpEnabled: (0, $id9ES.DEFAULT_USER_SETTINGS).ntpEnabled
                }
            });
        }
        previousNtpEnforcementModeRef.current = currentMode;
    }, [
        effectiveRemoteAdminSettings.controlledUserNtpEnabled,
        effectiveRemoteAdminSettings.defaultNtpUrl,
        isLoadingRemoteAdminSettings
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        const currentCompanion = effectiveRemoteAdminSettings.controlledUserRovoCompanionEnabled;
        const previousCompanion = previousControlledUserCompanionEnabledRef.current;
        // Admin disables Companion for all users (transition to false)
        if (currentCompanion === false && previousCompanion !== false) (0, $bI4fx.postMessageToParent)({
            type: 'SET_OPTIONS',
            updated: {
                rovoCompanionEnabled: false
            }
        });
        // Admin re-enables Companion for all users (false -> true/undefined)
        if (previousCompanion === false && currentCompanion !== false) (0, $bI4fx.postMessageToParent)({
            type: 'SET_OPTIONS',
            updated: {
                rovoCompanionEnabled: (0, $id9ES.DEFAULT_USER_SETTINGS).rovoCompanionEnabled
            }
        });
        previousControlledUserCompanionEnabledRef.current = currentCompanion;
    }, [
        effectiveRemoteAdminSettings.controlledUserRovoCompanionEnabled,
        isLoadingRemoteAdminSettings
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (isLoadingRemoteAdminSettings) return;
        const currentAnnouncements = effectiveRemoteAdminSettings.controlledUserCompanyAnnouncements;
        const previousAnnouncements = previousControlledUserCompanyAnnouncementsRef.current;
        // Admin disables Company Announcements for all users (transition to false)
        if (currentAnnouncements === false && previousAnnouncements !== false) setAnnouncementsEnabled(false);
        // Admin re-enables Company Announcements for all users (false -> true/undefined)
        if (previousAnnouncements === false && currentAnnouncements !== false) setAnnouncementsEnabled((0, $id9ES.DEFAULT_LOCAL_STORED_SETTINGS)[(0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED]);
        previousControlledUserCompanyAnnouncementsRef.current = currentAnnouncements;
    }, [
        effectiveRemoteAdminSettings.controlledUserCompanyAnnouncements,
        isLoadingRemoteAdminSettings,
        setAnnouncementsEnabled
    ]);
    const contextValue = (0, $1v5pe.useMemo)(()=>({
            remoteAdminSettings: effectiveRemoteAdminSettings,
            updateRemoteAdminSettings: updateRemoteAdminSettings,
            refreshRemoteAdminSettings: refreshRemoteAdminSettings,
            isLoadingRemoteAdminSettings: isLoadingRemoteAdminSettings,
            remoteAdminSettingsQueryError: remoteAdminSettingsQueryError,
            remoteAdminSettingsMutationError: remoteAdminSettingsMutationError,
            localStoredSettings: localStoredSettings,
            updateLocalStoredSetting: updateLocalStoredSetting,
            chromeStoredSettings: chromeStoredSettings,
            updateChromeStoredSetting: updateChromeStoredSetting
        }), [
        effectiveRemoteAdminSettings,
        updateRemoteAdminSettings,
        refreshRemoteAdminSettings,
        isLoadingRemoteAdminSettings,
        remoteAdminSettingsQueryError,
        remoteAdminSettingsMutationError,
        localStoredSettings,
        updateLocalStoredSetting,
        chromeStoredSettings,
        updateChromeStoredSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($cdf5305077045ce8$var$SettingsContext.Provider, {
        value: contextValue
    }, children);
};
const $cdf5305077045ce8$export$9115b42802a3e44f = ()=>{
    const context = (0, $1v5pe.useContext)($cdf5305077045ce8$var$SettingsContext);
    if (context === undefined) throw new Error('useSettings must be used within a SettingsProvider');
    return context;
};

});
parcelRegister("9feau", function(module, exports) {
$parcel$export(module.exports, "RemoteAdminSettingsErrorType", () => $7eda3013cc83a601$export$473f48a3ea5b378f);
$parcel$export(module.exports, "RemoteAdminSettingsError", () => $7eda3013cc83a601$export$26868db8586b4283);
var $7eda3013cc83a601$export$473f48a3ea5b378f = /*#__PURE__*/ function(RemoteAdminSettingsErrorType) {
    RemoteAdminSettingsErrorType["QUERY_ERROR"] = "QUERY_ERROR";
    RemoteAdminSettingsErrorType["MUTATION_ERROR"] = "MUTATION_ERROR";
    return RemoteAdminSettingsErrorType;
}({});
class $7eda3013cc83a601$export$26868db8586b4283 extends Error {
    constructor({ type: type, originalError: originalError, context: context }){
        super(originalError.message);
        this.name = 'RemoteAdminSettingsError';
        this.type = type;
        this.originalError = originalError;
        this.timestamp = Date.now();
        this.context = context;
    }
}

});

parcelRegister("gLHVH", function(module, exports) {
$parcel$export(module.exports, "useStateWithSync", () => $095771bc639797f5$export$5d79a5c424614073);

var $1v5pe = parcelRequire("1v5pe");

var $22hwD = parcelRequire("22hwD");
function $095771bc639797f5$export$5d79a5c424614073(key, initialValue) {
    // Create a unique channel name for this key
    const channelName = `state-sync-${key}`;
    const channelRef = (0, $1v5pe.useRef)(null);
    // Helper function to safely parse JSON from localStorage
    const getStoredValue = (0, $1v5pe.useCallback)(()=>{
        try {
            const item = localStorage.getItem(key);
            if (item === null) return initialValue;
            return JSON.parse(item);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'useStateWithSync: Failed to parse localStorage value',
                extra: {
                    key: key
                }
            });
            return initialValue;
        }
    }, [
        key,
        initialValue
    ]);
    // Initialize state with value from localStorage or initialValue
    const [state, setState] = (0, $1v5pe.useState)(getStoredValue);
    const setStoredValue = (0, $1v5pe.useCallback)((value)=>{
        try {
            if (value === undefined) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'useStateWithSync: Failed to store value in localStorage',
                extra: {
                    key: key
                }
            });
        }
    }, [
        key
    ]);
    // Custom setter that updates both state and localStorage, and broadcasts the change
    const setStateWithSync = (0, $1v5pe.useCallback)((value)=>{
        setState((prevState)=>{
            const newValue = typeof value === 'function' ? value(prevState) : value;
            // Store in localStorage
            setStoredValue(newValue);
            // Broadcast the change to other tabs
            if (channelRef.current) try {
                channelRef.current.postMessage({
                    key: key,
                    value: newValue,
                    timestamp: Date.now()
                });
            } catch (error) {
                (0, $22hwD.logError)({
                    error: error,
                    impact: 'useStateWithSync: Failed to broadcast message',
                    extra: {
                        key: key
                    }
                });
            }
            return newValue;
        });
    }, [
        key,
        setStoredValue
    ]);
    // Set up BroadcastChannel for cross-tab synchronization
    (0, $1v5pe.useEffect)(()=>{
        // Create the BroadcastChannel
        try {
            channelRef.current = new BroadcastChannel(channelName);
        } catch (error) {
            (0, $22hwD.logError)({
                error: error,
                impact: 'useStateWithSync: Failed to create BroadcastChannel',
                extra: {
                    channelName: channelName
                }
            });
            return;
        }
        // Listen for messages from other tabs
        const handleMessage = (event)=>{
            const { key: messageKey, value: value } = event.data;
            // Only update if the message is for our key
            if (messageKey === key) setState(value);
        };
        // Add the message listener
        channelRef.current.addEventListener('message', handleMessage);
        // Cleanup function
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener('message', handleMessage);
                channelRef.current.close();
                channelRef.current = null;
            }
        };
    }, [
        key,
        channelName
    ]);
    return [
        state,
        setStateWithSync
    ];
}

});

parcelRegister("id9ES", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USER_SETTINGS", () => $ce2307f4e12abcd3$export$77a705a84867edc0);
$parcel$export(module.exports, "DEFAULT_CHROME_STORED_SETTINGS", () => $ce2307f4e12abcd3$export$aade23df1b04ff57);
$parcel$export(module.exports, "DEFAULT_REMOTE_ADMIN_SETTINGS", () => $ce2307f4e12abcd3$export$83bdfcdff5be99ba);
$parcel$export(module.exports, "DEFAULT_LOCAL_STORED_SETTINGS", () => $ce2307f4e12abcd3$export$8da2810e49f51041);
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");
const $ce2307f4e12abcd3$export$77a705a84867edc0 = {
    ntpEnabled: true,
    rovoCompanionEnabled: true,
    gdocsDefinitionsEnabled: true
};
const $ce2307f4e12abcd3$export$aade23df1b04ff57 = {
    ntpEnabled: true,
    topSitesEnabled: true,
    // A.K.A "Custom links"
    rovoCompanionEnabled: true,
    gdocsDefinitionsEnabled: true,
    ntpRedirectUrl: ''
};
const $ce2307f4e12abcd3$export$83bdfcdff5be99ba = {
    controlledUserRovoCompanionEnabled: true,
    controlledUserGdocsDefinitionsEnabled: true,
    controlledUserDomContentEnabled: true,
    controlledUserCompanyAnnouncements: true,
    // Empty string is the canonical "no admin override" value. The settings
    // service stores `""` when an admin clears the field; pre-fetch / no-data
    // cases should look the same to consumers.
    defaultNtpUrl: ''
};
const $ce2307f4e12abcd3$export$8da2810e49f51041 = {
    [(0, $fgIUF.LocalStorageKey).WELCOME_HEADER_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).GLOBAL_CREATE_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).CALENDAR_ENABLED]: false,
    [(0, $fgIUF.LocalStorageKey).RECENT_WORK_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).BOOKMARKS_ENABLED]: true,
    [(0, $fgIUF.LocalStorageKey).ANNOUNCEMENTS_ENABLED]: true
};

});

parcelRegister("bdhse", function(module, exports) {
$parcel$export(module.exports, "isValidHttpUrl", () => $db1d6ac445565805$export$fc99885b7e473d08);
/**
 * Returns true when `url` parses via the WHATWG `URL` constructor and uses the
 * `http:` or `https:` protocol.
 *
 * Use whenever the URL will be rendered as a clickable target or passed to
 * `window.location` / `chrome.tabs.update`, to reject `javascript:`, `file:`,
 * `data:` and other non-navigation protocols.
 */ const $db1d6ac445565805$export$fc99885b7e473d08 = (url)=>{
    let parsed;
    try {
        parsed = new URL(url);
    } catch  {
        return false;
    }
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
};

});







parcelRegister("6ascs", function(module, exports) {
$parcel$export(module.exports, "AnalyticsUserMetadataProvider", () => $aae8b551a2b64d12$export$bdea01a6b1d2d7bb);
$parcel$export(module.exports, "useAnalyticsUserMetadata", () => $aae8b551a2b64d12$export$5266e6a20baaf888);

var $1v5pe = parcelRequire("1v5pe");

var $bI4fx = parcelRequire("bI4fx");
const $aae8b551a2b64d12$export$a31cbab4c94546dc = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $aae8b551a2b64d12$export$bdea01a6b1d2d7bb = ({ children: children })=>{
    const [userMetadata, setUserMetadata] = (0, $1v5pe.useState)();
    (0, $1v5pe.useEffect)(()=>{
        const messageHandler = (event)=>{
            if (event.data.type === 'GET_USER_METADATA_RESPONSE') setUserMetadata({
                isExtensionPinned: event.data.isExtensionPinned,
                ntpEnabled: event.data.ntpEnabled
            });
        };
        window.addEventListener('message', messageHandler, false);
        (0, $bI4fx.postMessageToParent)({
            type: 'GET_USER_METADATA_REQUEST'
        });
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($aae8b551a2b64d12$export$a31cbab4c94546dc.Provider, {
        value: {
            userMetadata: userMetadata,
            setUserMetadata: setUserMetadata
        }
    }, children);
};
const $aae8b551a2b64d12$export$5266e6a20baaf888 = ()=>{
    /// context may be undefined if outside context provider, extension does not have message handler and cannot respond, or still awaiting response
    return (0, $1v5pe.useContext)($aae8b551a2b64d12$export$a31cbab4c94546dc);
};

});

parcelRegister("1t5Vd", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("kcDls")
]).then(()=>parcelRequire('1onKS'));

});


parcelRegister("7jMOi", function(module, exports) {
$parcel$export(module.exports, "assetsConfig", () => $0c865b8448de8f3f$export$3c97e0dabadb52a9);
const $0c865b8448de8f3f$var$allAtlassian = ({ entry: entry })=>{
    const isAtlassian = entry.name.includes('atlaskit') || entry.name.includes('atlassian') || entry.name.includes('atl-pass.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js');
    return isAtlassian;
};
const $0c865b8448de8f3f$var$preloaded = ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
    return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
};
const $0c865b8448de8f3f$export$3c97e0dabadb52a9 = {
    allowedTypes: [
        'js',
        'css'
    ],
    classification: {
        all: true,
        allAtlassian: $0c865b8448de8f3f$var$allAtlassian,
        preloaded: $0c865b8448de8f3f$var$preloaded
    }
};

});


parcelRegister("67pgD", function(module, exports) {
$parcel$export(module.exports, "useReactUFORouteWatcher", () => $d492408853c0b7a1$export$cfd6347884237953);

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("calFH");
var $30t8d = parcelRequire("30t8d");

var $54iU5 = parcelRequire("54iU5");

var $cnQYP = parcelRequire("cnQYP");
parcelRequire("lxvXO");
var $3dX4H = parcelRequire("3dX4H");
/**
 * **Important**: This variable definition is read by the observability pipeline step for the purpose of automatically
 * setting up service level objectives (SLOs) for selected routes. If you want to create an SLO for your route, provide
 * a RouteSLOKey for its UFO name below, otherwise use a regular string. If you need to rename this variable or move its
 * definition into another file for some reason, update the `ROUTE_DEFINITION_VARIABLE` and `ROUTE_DEFINITION_FILE` in
 * the file `afm/rovo-extension/operations/scripts/constants.ts` accordingly.
 */ const $d492408853c0b7a1$var$ufoRouteNameByPath = {
    '/extension': (0, $3dX4H.RouteSLOKeys).HOME,
    '/extension/login-redirect': 'login-redirect',
    '/extension/log-out': 'logout',
    '/extension/menu': 'menu',
    '/extension/ntp-login-redirect': (0, $3dX4H.RouteSLOKeys).NTP_LOGIN_REDIRECT,
    '/extension/ntp-logout-redirect': 'ntp-logout-redirect',
    '/extension/options': (0, $3dX4H.RouteSLOKeys).OPTIONS,
    '/extension/popup': (0, $3dX4H.RouteSLOKeys).POPUP,
    '/extension/rovo-chat': (0, $3dX4H.RouteSLOKeys).CHAT,
    '/extension/session': 'session',
    '/extension/uninstall': (0, $3dX4H.RouteSLOKeys).UNINSTALL,
    '/extension/welcome': (0, $3dX4H.RouteSLOKeys).WELCOME
};
function $d492408853c0b7a1$export$cfd6347884237953() {
    const location = (0, $30t8d.useLocation)();
    const isFirstRender = (0, $1v5pe.useRef)(true);
    const pathname = (0, $1v5pe.useRef)('');
    if (pathname.current !== location.pathname) {
        pathname.current = location.pathname;
        // do not emit UFO events for any undefined experiences
        const ufoName = $d492408853c0b7a1$var$ufoRouteNameByPath[location.pathname];
        if (ufoName) {
            if (isFirstRender.current) {
                (0, $54iU5.default)(ufoName);
                isFirstRender.current = false;
            } else (0, $cnQYP.default)(ufoName);
        }
    }
}

});
parcelRegister("cnQYP", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc5bcc9fbd628c6a$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $664X1 = parcelRequire("664X1");

var $fskN5 = parcelRequire("fskN5");

var $5tITM = parcelRequire("5tITM");

var $68Mzh = parcelRequire("68Mzh");

var $31aDV = parcelRequire("31aDV");

var $8OjRF = parcelRequire("8OjRF");

var $5CbDz = parcelRequire("5CbDz");

var $e2Ub8 = parcelRequire("e2Ub8");
function $dc5bcc9fbd628c6a$var$traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, $5tITM.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $5tITM.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $8OjRF.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $8OjRF.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $5CbDz.default).current = ufoName;
        const rate = (0, $5tITM.getInteractionRate)(ufoName, 'transition');
        if ((0, $fskN5.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $664X1.v4)();
            (0, $e2Ub8.setInteractionActiveTrace)(newId);
            (0, $31aDV.DefaultInteractionID).current = newId;
            (0, $8OjRF.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $68Mzh.getActiveTrace)());
        }
    }
}
function $dc5bcc9fbd628c6a$export$369f0ded13ce6c50() {
    const interactionId = (0, $1v5pe.useContext)((0, $31aDV.default));
    const capturedInteractionId = interactionId.current;
    (0, $1v5pe.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $8OjRF.tryComplete)(capturedInteractionId);
                });
            });
            (0, $8OjRF.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$dc5bcc9fbd628c6a$export$2e2bcd8739ae039 = $dc5bcc9fbd628c6a$var$traceUFOTransition;

});
parcelRegister("e2Ub8", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $e63ac7d9b4d08edf$export$f2e521e495a88544);

var $68Mzh = parcelRequire("68Mzh");

var $fenoB = parcelRequire("fenoB");
function $e63ac7d9b4d08edf$export$f2e521e495a88544(newId) {
    (0, $68Mzh.setActiveTrace)(newId.replace(/-/g, ''), (0, $fenoB.generateSpanId)(), 'transition');
}

});
parcelRegister("fenoB", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $c90f5aa9a36536a0$export$295213bc4d0c54ad);
function $c90f5aa9a36536a0$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("lxvXO", function(module, exports) {
$parcel$export(module.exports, "ExperienceSLOKeys", () => (parcelRequire("3dX4H")).ExperienceSLOKeys);
$parcel$export(module.exports, "PerformanceSLOKeys", () => (parcelRequire("3dX4H")).PerformanceSLOKeys);
$parcel$export(module.exports, "RouteSLOKeys", () => (parcelRequire("3dX4H")).RouteSLOKeys);

var $3dX4H = parcelRequire("3dX4H");

});
parcelRegister("3dX4H", function(module, exports) {
$parcel$export(module.exports, "RouteSLOKeys", () => $370ba3cc4bb486b0$export$cc067c37658d47e4);
$parcel$export(module.exports, "PerformanceSLOKeys", () => $370ba3cc4bb486b0$export$818b2df6d68c10f);
$parcel$export(module.exports, "ExperienceSLOKeys", () => $370ba3cc4bb486b0$export$24627c49e42d1e9f);
const $370ba3cc4bb486b0$export$cc067c37658d47e4 = {
    CHAT: 'chat',
    HOME: 'home',
    NTP_LOGIN_REDIRECT: 'ntp-login-redirect',
    OPTIONS: 'options',
    POPUP: 'popup',
    UNINSTALL: 'uninstall',
    WELCOME: 'welcome'
};
const $370ba3cc4bb486b0$export$818b2df6d68c10f = {
    APPLICATION_BOOTSTRAP: 'application-bootstrap'
};
const $370ba3cc4bb486b0$export$24627c49e42d1e9f = {
    ANNOUNCEMENT_BANNER: 'announcement-banner',
    ANNOUNCEMENT_WIDGET: 'announcement-widget',
    ADMIN_OPTIONS_SECTION: 'admin-options-section',
    ADMIN_SITE_SELECTOR_WIDGET: 'admin-site-selector-widget',
    ADMIN_CONTROLLED_USER_SETTINGS: 'admin-controlled-user-settings',
    ADMIN_MANAGE_ANNOUNCEMENT_SETTINGS: 'admin-manage-announcement-settings',
    ADMIN_THEME_SETTINGS_SECTION: 'admin-theme-settings-section',
    APP_ROOT: 'app-root',
    BOOKMARKS_BAR: 'bookmarks-bar',
    CHAT_CONTENT_FULLPAGE: 'chat-content-fullpage',
    CHAT_PAGE: 'chat-page',
    CONVERSATION_ASSISTANT_FULLPAGE: 'conversation-assistant-fullpage',
    DISMISSIBLE_WIDGETS: 'dismissible-widgets',
    GENERAL_OPTIONS_SECTION: 'general-options-section',
    HOME_CONTENT: 'home-content',
    NEW_TAB_PAGE_OPTIONS_SECTION: 'new-tab-page-options-section',
    OPTIONS_FOOTER: 'options-footer',
    OPTIONS_PAGE: 'options-page',
    PAGE_LAYOUT: 'page-layout',
    RECENT_WORK_WIDGET: 'recent-work-widget',
    SEARCH_TAB: 'search-tab',
    SEARCH_TAB_SELECTOR: 'search-tab-selector',
    SEARCH_TAB_SELECTOR_WIDGET: 'search-tab-selector-widget',
    SHORTCUTS: 'shortcuts',
    SITE_SELECTOR: 'site-selector',
    USER_SITE_SELECTOR_WIDGET: 'user-site-selector-widget',
    TOP_BAR: 'top-bar',
    WELCOME_HEADER: 'welcome-header'
};

});



parcelRegister("j0FUQ", function(module, exports) {
$parcel$export(module.exports, "toError", () => $bed9ac47c0171753$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "reportUFOError", () => $bed9ac47c0171753$export$ff4295e7b5197bb4);
$parcel$export(module.exports, "useReportUFOError", () => $bed9ac47c0171753$export$b131dcf56bc238d7);

var $hRUfe = parcelRequire("hRUfe");

var $8OjRF = parcelRequire("8OjRF");

var $1v5pe = parcelRequire("1v5pe");
function $bed9ac47c0171753$var$isError(maybeError) {
    return maybeError !== null && typeof maybeError === 'object' && 'name' in maybeError && 'message' in maybeError && typeof maybeError.name === 'string' && typeof maybeError.message === 'string';
}
function $bed9ac47c0171753$export$54a3d316be2099f1(unknown) {
    return typeof unknown === 'object' ? JSON.stringify(unknown) : String(unknown);
}
function $bed9ac47c0171753$export$cc3b967c039ed3e7(maybeError) {
    return $bed9ac47c0171753$var$isError(maybeError) ? maybeError : new Error($bed9ac47c0171753$export$54a3d316be2099f1(maybeError));
}
const $bed9ac47c0171753$var$reportedUFOErrors = new WeakSet();
function $bed9ac47c0171753$export$ff4295e7b5197bb4(error, origin, context) {
    if ($bed9ac47c0171753$var$reportedUFOErrors.has(error)) return false;
    const interaction = (0, $8OjRF.getActiveInteraction)();
    const labelStack = context?.labelStack ?? null;
    if (interaction?.id) (0, $8OjRF.addError)(interaction.id, origin, labelStack, error.name, error.message, error.stack);
    else (0, $8OjRF.addErrorToAll)(origin, labelStack, error.name, error.message, error.stack);
    $bed9ac47c0171753$var$reportedUFOErrors.add(error);
    return true;
}
function $bed9ac47c0171753$export$b131dcf56bc238d7(origin = '[unknown]') {
    const ufoInteractionContext = (0, $hRUfe.useInteractionContext)();
    return (0, $1v5pe.useCallback)((maybeError)=>void $bed9ac47c0171753$export$ff4295e7b5197bb4($bed9ac47c0171753$export$cc3b967c039ed3e7(maybeError), origin, ufoInteractionContext), [
        origin,
        ufoInteractionContext
    ]);
}

});

parcelRegister("8widT", function(module, exports) {
$parcel$export(module.exports, "UFOLoadingSpinner", () => $d694ede1be70d4a2$export$5a0e489182bd8790);

var $1v5pe = parcelRequire("1v5pe");

var $5I7AE = parcelRequire("5I7AE");
function $d694ede1be70d4a2$export$5a0e489182bd8790({ interactionName: interactionName, label: label, size: size = 'medium', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5I7AE.default), {
        interactionName: interactionName,
        label: label,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cFd5E", function(module, exports) {
$parcel$export(module.exports, "UFOSuspenseFallback", () => $e1b84d7be1e5c7b6$export$4f598ec1eca7d9b7);

var $1v5pe = parcelRequire("1v5pe");

var $fjzd2 = parcelRequire("fjzd2");
function $e1b84d7be1e5c7b6$export$4f598ec1eca7d9b7({ name: name, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fjzd2.default), {
        name: name
    }, children);
}

});
parcelRegister("fjzd2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9a278a35979f368$export$2e2bcd8739ae039);

var $fVlp5 = parcelRequire("fVlp5");
var $a9a278a35979f368$export$2e2bcd8739ae039 = (0, $fVlp5.default);

});
parcelRegister("fVlp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b1c2f89981130d3$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $5tITM = parcelRequire("5tITM");

var $hRUfe = parcelRequire("hRUfe");

var $31aDV = parcelRequire("31aDV");
const $6b1c2f89981130d3$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $1v5pe.useEffect) : (0, $1v5pe.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $6b1c2f89981130d3$var$useInteractionIdValue() {
    const interactionId = (0, $1v5pe.useContext)((0, $31aDV.default));
    const [currentId, setCurrentId] = (0, $1v5pe.useState)(interactionId?.current || null);
    $6b1c2f89981130d3$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $31aDV.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $6b1c2f89981130d3$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $5tITM.isUFOEnabled)();
    const currentInteractionId = $6b1c2f89981130d3$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $1v5pe.useContext)((0, $hRUfe.default));
    $6b1c2f89981130d3$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, children) : null;
}

});



parcelRegister("6vVPG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c04dd2b1c4f35ee$export$2e2bcd8739ae039);

var $6K3dF = parcelRequire("6K3dF");



var $0c04dd2b1c4f35ee$export$2e2bcd8739ae039 = (0, $6K3dF.default);

});
parcelRegister("6K3dF", function(module, exports) {
$parcel$export(module.exports, "default", () => $aec24f21bfd6f6c3$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hziAm = parcelRequire("hziAm");

var $664X1 = parcelRequire("664X1");

var $fskN5 = parcelRequire("fskN5");

var $5tITM = parcelRequire("5tITM");

var $5Mr7y = parcelRequire("5Mr7y");

var $68Mzh = parcelRequire("68Mzh");

var $hRUfe = parcelRequire("hRUfe");

var $31aDV = parcelRequire("31aDV");

var $8OjRF = parcelRequire("8OjRF");

var $5CbDz = parcelRequire("5CbDz");

var $cWira = parcelRequire("cWira");

var $jnGk3 = parcelRequire("jnGk3");

var $cNKkA = parcelRequire("cNKkA");
let $aec24f21bfd6f6c3$var$tryCompleteHandle;
/** A portion of the page we apply measurement to */ const $aec24f21bfd6f6c3$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $5tITM.isUFOEnabled)();
    const parentContext = (0, $1v5pe.useContext)((0, $hRUfe.default));
    const segmentIdMap = (0, $1v5pe.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $1v5pe.useMemo)(()=>{
        if (mode === 'single') return (0, $cWira.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $cWira.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $1v5pe.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            } // Only pass non-default types (not 'first-party') in payload to reduce size
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $1v5pe.useContext)((0, $31aDV.default));
    const interactionContext = (0, $1v5pe.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($aec24f21bfd6f6c3$var$tryCompleteHandle) cancelAnimationFrame?.($aec24f21bfd6f6c3$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $aec24f21bfd6f6c3$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $aec24f21bfd6f6c3$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $8OjRF.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $8OjRF.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $hziAm.unstable_scheduleCallback)((0, $hziAm.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $8OjRF.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $8OjRF.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $8OjRF.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $5tITM.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $5tITM.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    const activeInteraction = (0, $8OjRF.getActiveInteraction)();
                    activeInteraction?.minorInteractions?.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $8OjRF.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $5tITM.getInteractionRate)(name, 'press');
                if ((0, $fskN5.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $664X1.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $68Mzh.setInteractionActiveTrace)(newId, 'press');
                    (0, $8OjRF.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $5CbDz.default).current, (0, $68Mzh.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $8OjRF.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $8OjRF.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $8OjRF.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $8OjRF.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $8OjRF.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $8OjRF.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $8OjRF.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $8OjRF.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $jnGk3.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $1v5pe.useRef)(false);
    const onRender = (0, $1v5pe.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $5tITM.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $1v5pe.useEffect)(()=>{
        (0, $8OjRF.addSegment)(labelStack);
        return ()=>{
            (0, $8OjRF.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $1v5pe.useMemo)(()=>labelStack.map((l)=>(0, $5Mr7y.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, children);
    const ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hRUfe.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1v5pe.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cNKkA.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args)
    }, ufoSegment);
};
$aec24f21bfd6f6c3$var$UFOSegment.displayName = 'UFOSegment';
var $aec24f21bfd6f6c3$export$2e2bcd8739ae039 = $aec24f21bfd6f6c3$var$UFOSegment;

});
parcelRegister("cWira", function(module, exports) {
$parcel$export(module.exports, "default", () => $771022ca5d40fea3$export$2e2bcd8739ae039);
function $771022ca5d40fea3$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $771022ca5d40fea3$export$2e2bcd8739ae039 = $771022ca5d40fea3$var$generateId;

});

parcelRegister("jnGk3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7492fa49b0b52229$export$2e2bcd8739ae039);

var $k1Wvt = parcelRequire("k1Wvt");
function $7492fa49b0b52229$var$scheduleOnPaint(callback) {
    const isSSR = typeof window === 'undefined' || Boolean(globalThis?.__SERVER__) || typeof $k1Wvt !== 'undefined' && Boolean($k1Wvt?.env?.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $7492fa49b0b52229$export$2e2bcd8739ae039 = $7492fa49b0b52229$var$scheduleOnPaint;

});





parcelRegister("9NbMC", function(module, exports) {
$parcel$export(module.exports, "StatSigInitialization", () => $3b4b724c5ed68853$export$6d222e25f24bf52e);
$parcel$export(module.exports, "useCheckStatSigFeatureGate", () => $3b4b724c5ed68853$export$a206847220e68830);
$parcel$export(module.exports, "useCheckStatsigGetAllFeatureGates", () => $3b4b724c5ed68853$export$7b88a4f26e43ec9a);
$parcel$export(module.exports, "useStatsigBooleanDynamicConfig", () => $3b4b724c5ed68853$export$f88e8f22c22ee285);
$parcel$export(module.exports, "useStatsigStringDynamicConfig", () => $3b4b724c5ed68853$export$90a9516121173515);
$parcel$export(module.exports, "useListDynamicConfigs", () => $3b4b724c5ed68853$export$5b20d03d8c798d4b);

var $1v5pe = parcelRequire("1v5pe");

var $l83dT = parcelRequire("l83dT");

var $4d1Vr = parcelRequire("4d1Vr");

var $hRUfe = parcelRequire("hRUfe");

var $SOJpc = parcelRequire("SOJpc");

var $lKdQo = parcelRequire("lKdQo");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $22hwD = parcelRequire("22hwD");

var $TrAR1 = parcelRequire("TrAR1");

var $lFK5D = parcelRequire("lFK5D");

var $hAM4Q = parcelRequire("hAM4Q");

var $dX6kP = parcelRequire("dX6kP");

var $lsxLV = parcelRequire("lsxLV");

var $3Dil2 = parcelRequire("3Dil2");

var $dqHaj = parcelRequire("dqHaj");
const $3b4b724c5ed68853$var$isProd = (0, $dqHaj.bifrostEnv) === 'prod';
let $3b4b724c5ed68853$var$configClientInstance = null;
async function $3b4b724c5ed68853$var$initializeConfigClient(identifiers) {
    try {
        const ffsBaseUrl = $3b4b724c5ed68853$var$isProd ? 'https://api.atlassian.com/flags' : 'https://api.stg.atlassian.com/flags';
        $3b4b724c5ed68853$var$configClientInstance = await (0, $l83dT.ConfigClient).fetch({
            ffsBaseUrl: ffsBaseUrl,
            ffsApiKey: "ebe2c06b-b4ec-4545-82a1-da3ae7cad15b",
            context: {
                namespace: 'rovo-extension_web',
                identifiers: identifiers,
                metadata: {
                    environment: (0, $dqHaj.bifrostEnv)
                }
            }
        });
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to initialize config client'
        });
    } finally{
        (0, $3Dil2.statsigStore).emitChange();
    }
}
const $3b4b724c5ed68853$export$8beae2bb7cabc6fd = ()=>$3b4b724c5ed68853$var$configClientInstance;
function $3b4b724c5ed68853$export$6d222e25f24bf52e({ site: site, children: children, userAccount: userAccount, analyticsAnonymousId: analyticsAnonymousId, onInitialized: onInitialized }) {
    const atlassianAccountId = userAccount?.accountId;
    const ufoContext = (0, $hRUfe.useInteractionContext)();
    const releaseHoldRef = (0, $1v5pe.useRef)(null);
    const locale = (0, $dqHaj.getLocale)();
    const { browserManifestVersion: browserManifestVersion } = (0, $hAM4Q.useManifestVersion)();
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    // Set up provider callback to trigger store updates when feature gates change
    (0, $1v5pe.useEffect)(()=>{
        (0, $lKdQo.pollingProvider).setClientVersion('5.5.7');
        (0, $lKdQo.pollingProvider).setApplyUpdateCallback((_experimentsResult)=>{
            (0, $3Dil2.statsigStore).emitChange();
        });
    }, []);
    const featureGatesIdentifiers = (0, $1v5pe.useMemo)(()=>({
            ...atlassianAccountId ? {
                atlassianAccountId: atlassianAccountId
            } : {},
            ...analyticsAnonymousId ? {
                analyticsAnonymousId: analyticsAnonymousId
            } : {},
            tenantId: site?.workspace.cloudId,
            atlassianOrgId: site?.workspace.organisationId
        }), [
        atlassianAccountId,
        analyticsAnonymousId,
        site
    ]);
    const customAttributes = (0, $1v5pe.useMemo)(()=>({
            tenantId: site?.workspace.cloudId ?? '',
            atlassianOrgId: site?.workspace.organisationId ?? '',
            extensionLocale: locale,
            extensionVersion: browserManifestVersion
        }), [
        site,
        locale,
        browserManifestVersion
    ]);
    // Use programmatic UFO hold for StatSig initialization
    (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useEffect(()=>{
        const releaseHold = ufoContext?.hold('feature-gates-statsig-initialization');
        releaseHoldRef.current = releaseHold ?? null;
        return ()=>{
            // Cleanup: release hold if component unmounts before initialization completes
            releaseHoldRef.current?.();
            releaseHoldRef.current = null;
        };
    }, [
        ufoContext
    ]);
    const handleOnReady = (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useCallback((err)=>{
        // Release the UFO hold when initialization completes
        releaseHoldRef.current?.();
        releaseHoldRef.current = null;
        if (err) // https://data-portal.internal.atlassian.com/analytics/registry/80196
        sendAnalyticEvent({
            eventType: 'operational',
            event: {
                action: 'failed',
                actionSubject: (0, $lsxLV.ANALYTICS_OPERATIONAL_EVENT_ACTION_SUBJECTS).FG_CLIENT_INITIALIZATION,
                source: 'extensionFrontend',
                attributes: {
                    error: err.message
                }
            },
            userId: atlassianAccountId ?? ''
        });
        else {
            $3b4b724c5ed68853$var$initializeConfigClient(featureGatesIdentifiers);
            onInitialized?.();
        }
    }, [
        sendAnalyticEvent,
        atlassianAccountId,
        featureGatesIdentifiers,
        onInitialized
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $SOJpc.FeatureGatesInitializationWithProvider), {
        customAttributes: customAttributes,
        enabled: true,
        identifiers: featureGatesIdentifiers,
        onReady: handleOnReady,
        options: (0, $lKdQo.featureGatesOptions),
        provider: (0, $lKdQo.pollingProvider)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($3b4b724c5ed68853$export$6a103eee5b0843dd, null, children));
}
const $3b4b724c5ed68853$export$fac938004b8ad59f = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);
const $3b4b724c5ed68853$export$6a103eee5b0843dd = ({ children: children })=>{
    // Get the current statsig store value
    const value = (0, $1v5pe.useSyncExternalStore)((0, $3Dil2.statsigStore).subscribe, (0, $3Dil2.statsigStore).getSnapshot);
    const [updateState, setUpdateState] = (0, $1v5pe.useState)(false);
    // using a boolean state to force a re-render of components that depend on useCheckStatSigFeatureGate. the boolean value itself has no meaning
    const refreshStatSigContext = ()=>setUpdateState((state)=>!state);
    // refresh context if external store value changes
    (0, $1v5pe.useEffect)(()=>{
        refreshStatSigContext();
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($3b4b724c5ed68853$export$fac938004b8ad59f.Provider, {
        value: {
            refreshStatSigContext: refreshStatSigContext,
            contextState: updateState
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($3b4b724c5ed68853$var$PlatformFeatureGateResolver, null, children));
};
const $3b4b724c5ed68853$var$useStatSigUpdateContext = ()=>{
    const context = (0, $1v5pe.useContext)($3b4b724c5ed68853$export$fac938004b8ad59f);
    if (context === undefined) throw new Error('useStatSigContext must be used within a StatSigUpdateProvider');
    return context;
};
const $3b4b724c5ed68853$export$a206847220e68830 = ()=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $1v5pe.useCallback)((featureGate)=>{
        return (0, $4d1Vr.default).checkGate(featureGate);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contextState
    ] // this will cause a re-render of components that depend on this hook, meaning they will re-check the feature gate with updated experiment values
    );
};
const $3b4b724c5ed68853$export$7b88a4f26e43ec9a = ()=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $1v5pe.useCallback)(()=>{
        const allFeatureGates = {};
        // Loop through all enum values
        Object.values((0, $TrAR1.STATSIG_FEATURE_GATES)).forEach((featureGate)=>{
            allFeatureGates[featureGate] = (0, $4d1Vr.default).checkGate(featureGate);
        });
        return allFeatureGates;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contextState
    ] // this will cause a re-render of components that depend on this hook, meaning they will re-check the feature gate with updated experiment values
    );
};
const $3b4b724c5ed68853$var$hasDynamicConfigValue = (configResult)=>{
    return typeof configResult === 'object' && configResult !== null && 'value' in configResult;
};
const $3b4b724c5ed68853$export$f88e8f22c22ee285 = (configKey)=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $1v5pe.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getBoolean(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$90a9516121173515 = (configKey, fallbackValue = '')=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $1v5pe.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getString(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : fallbackValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        fallbackValue,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$ee54c2d113c24b93 = (configKey, fallbackValue)=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $1v5pe.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getNumber(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : fallbackValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        fallbackValue,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$addbb45fa105d750 = (configKey, fallbackValue)=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $1v5pe.useMemo)(()=>{
        const configResult = $3b4b724c5ed68853$export$8beae2bb7cabc6fd()?.getStringList(configKey);
        return $3b4b724c5ed68853$var$hasDynamicConfigValue(configResult) ? configResult.value : fallbackValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configKey,
        fallbackValue,
        contextState
    ]);
};
const $3b4b724c5ed68853$export$5b20d03d8c798d4b = ()=>{
    const { contextState: contextState } = $3b4b724c5ed68853$var$useStatSigUpdateContext();
    return (0, $1v5pe.useMemo)(()=>{
        const configClient = $3b4b724c5ed68853$export$8beae2bb7cabc6fd();
        if (!configClient) return {
            isInitialized: false,
            listedDynamicConfigs: []
        };
        return {
            isInitialized: true,
            listedDynamicConfigs: Object.entries((0, $TrAR1.STATSIG_DYNAMIC_CONFIGS)).map(([enumKey, configName])=>{
                const configNameString = String(configName);
                const booleanValueResult = configClient.getBoolean(configNameString);
                const stringValueResult = configClient.getString(configNameString);
                const numberValueResult = configClient.getNumber(configNameString);
                const stringListValueResult = configClient.getStringList(configNameString);
                const booleanValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(booleanValueResult) ? booleanValueResult.value : undefined;
                const stringValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(stringValueResult) ? stringValueResult.value : undefined;
                const numberValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(numberValueResult) ? numberValueResult.value : undefined;
                const stringListValue = $3b4b724c5ed68853$var$hasDynamicConfigValue(stringListValueResult) ? stringListValueResult.value : undefined;
                if (typeof booleanValue === 'boolean') return {
                    name: configNameString,
                    value: booleanValue,
                    type: 'boolean',
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, 'dynamicConfig'),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, 'dynamicConfig')
                };
                if (typeof stringValue === 'string') return {
                    name: configNameString,
                    value: `"${stringValue}"`,
                    type: 'string',
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, 'dynamicConfig'),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, 'dynamicConfig')
                };
                if (typeof numberValue === 'number') return {
                    name: configNameString,
                    value: numberValue,
                    type: 'number',
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, 'dynamicConfig'),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, 'dynamicConfig')
                };
                if (Array.isArray(stringListValue) && stringListValue.every((item)=>typeof item === 'string')) return {
                    name: configNameString,
                    value: stringListValue,
                    type: 'string []',
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, 'dynamicConfig'),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, 'dynamicConfig')
                };
                return {
                    name: configNameString,
                    value: 'Not found',
                    type: 'unknown',
                    enumKey: enumKey,
                    statsigUrl: (0, $dqHaj.getStatsigUrl)(configNameString, 'dynamicConfig'),
                    switcherooUrl: (0, $dqHaj.getSwitcherooUrl)(configNameString, 'dynamicConfig')
                };
            })
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contextState
    ]);
};
const $3b4b724c5ed68853$export$569e7a603f4242a6 = (configClient)=>{
    $3b4b724c5ed68853$var$configClientInstance = configClient;
};
const $3b4b724c5ed68853$export$2c2302bdcd1c63f1 = ()=>{
    $3b4b724c5ed68853$var$configClientInstance = null;
};
const $3b4b724c5ed68853$var$PlatformFeatureGateResolver = ({ children: children })=>{
    (0, $lFK5D.setPlatformFeatureFlagResolver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, children);
};

});
parcelRegister("lKdQo", function(module, exports) {
$parcel$export(module.exports, "pollingProvider", () => $9dcab05ae59e0014$export$a44f07fc377ba900);
$parcel$export(module.exports, "featureGatesOptions", () => $9dcab05ae59e0014$export$6d95ae50c07db82e);

var $275D8 = parcelRequire("275D8");

var $joS99 = parcelRequire("joS99");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");
const $9dcab05ae59e0014$var$isProd = (0, $dqHaj.bifrostEnv) === 'prod';
const $9dcab05ae59e0014$var$getFeatureGateEnv = ()=>$9dcab05ae59e0014$var$isProd ? (0, $joS99.FeatureGateEnvironment).Production : (0, $joS99.FeatureGateEnvironment).Staging;
const $9dcab05ae59e0014$var$providerOptions = {
    apiKey: "ebe2c06b-b4ec-4545-82a1-da3ae7cad15b",
    initialFetchTimeout: 5000,
    useGatewayURL: false // Browser extensions must use direct FFS URLs, not gateway proxy
};
/**
 * Singleton instance of PollingProvider for feature gate management
 *
 * Features:
 * - Automatic polling for feature gate updates
 * - IndexedDB caching for fast initialization
 * - Cross-tab synchronization via BroadcastChannel
 */ const $9dcab05ae59e0014$var$provider = new (0, $275D8.default)($9dcab05ae59e0014$var$providerOptions);
// Using the FeatureGates client version from package.json
$9dcab05ae59e0014$var$provider.setClientVersion('5.5.7');
const $9dcab05ae59e0014$export$a44f07fc377ba900 = $9dcab05ae59e0014$var$provider;
const $9dcab05ae59e0014$export$6d95ae50c07db82e = {
    targetApp: "rovo-extension_web",
    apiKey: "ebe2c06b-b4ec-4545-82a1-da3ae7cad15b",
    environment: $9dcab05ae59e0014$var$getFeatureGateEnv(),
    perimeter: (0, $joS99.PerimeterType).COMMERCIAL
};

});

parcelRegister("lFK5D", function(module, exports) {
$parcel$export(module.exports, "setPlatformFeatureFlagResolver", () => $a10f9b8762cab036$export$438cd9f17441b356);

var $1fNbV = parcelRequire("1fNbV");

var $4d1Vr = parcelRequire("4d1Vr");
const $a10f9b8762cab036$export$438cd9f17441b356 = ()=>{
    (0, $1fNbV.setBooleanFeatureFlagResolver)((key)=>{
        return (0, $4d1Vr.default).checkGate(key);
    });
};

});
parcelRegister("1fNbV", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $3d393b26a821fa9b$export$ba05d765b8392e5e);

var $3y7aZ = parcelRequire("3y7aZ");
function $3d393b26a821fa9b$export$ba05d765b8392e5e(flagResolver) {
    (0, $3y7aZ.setBooleanResolver)(flagResolver);
}

});
parcelRegister("3y7aZ", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $fb49d88681de5f85$export$f2b591175b3e424c);

var $8puww = parcelRequire("8puww");

var $4cILa = parcelRequire("4cILa");
function $fb49d88681de5f85$export$f2b591175b3e424c(resolver) {
    (0, $8puww.globalVar)[0, $4cILa.PFF_GLOBAL_KEY].booleanResolver = resolver;
}

});



parcelRegister("3Dil2", function(module, exports) {
$parcel$export(module.exports, "statsigStore", () => $24c059b3a96baa82$export$d5468990a66e2f3c);
// This is a simple store that allows us to subscribe to changes in the statsig context
// and trigger a re-render of components that depend on the statsig context.
// This is used to avoid remounting components when the statsig context changes.
class $24c059b3a96baa82$var$StatsigStore {
    constructor(){
        this.listeners = new Set();
        this.updateCount = 0;
        this.subscribe = (listener)=>{
            this.listeners.add(listener);
            return ()=>this.listeners.delete(listener);
        };
        this.emitChange = ()=>{
            this.updateCount++;
            this.listeners.forEach((listener)=>listener());
        };
        this.getSnapshot = ()=>this.updateCount;
    }
}
const $24c059b3a96baa82$export$d5468990a66e2f3c = new $24c059b3a96baa82$var$StatsigStore();

});


parcelRegister("cKss1", function(module, exports) {
$parcel$export(module.exports, "queryClient", () => $12d35b2aef9102e1$export$7c07b633a151f9c5);
$parcel$export(module.exports, "persister", () => $12d35b2aef9102e1$export$a2ba0fb8628135cb);
$parcel$export(module.exports, "default", () => $12d35b2aef9102e1$export$2e2bcd8739ae039);

var $7KlwK = parcelRequire("7KlwK");

var $jDOwD = parcelRequire("jDOwD");

var $1v5pe = parcelRequire("1v5pe");

var $30t8d = parcelRequire("30t8d");
parcelRequire("1wxU2");
var $cFd5E = parcelRequire("cFd5E");
var $67pgD = parcelRequire("67pgD");

var $2j9H9 = parcelRequire("2j9H9");

var $6ascs = parcelRequire("6ascs");

var $im7kM = parcelRequire("im7kM");
parcelRequire("imFpy");
var $aBqKF = parcelRequire("aBqKF");

var $d4v8F = parcelRequire("d4v8F");

var $642vm = parcelRequire("642vm");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $aLmHL = parcelRequire("aLmHL");
parcelRequire("gfRi5");
var $8jOpu = parcelRequire("8jOpu");
var $3dX4H = parcelRequire("3dX4H");

const $12d35b2aef9102e1$var$SessionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("haUlu")));

const $12d35b2aef9102e1$var$PopupLoginRedirectPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("1mQym")).then((module)=>({
            default: module.PopupLoginRedirectPage
        })));

const $12d35b2aef9102e1$var$NtpLoginRedirectPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("fUiFW")).then((module)=>({
            default: module.NtpLoginRedirectPage
        })));

const $12d35b2aef9102e1$var$NtpLogoutRedirectPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("7n07k")).then((module)=>({
            default: module.NtpLogoutRedirectPage
        })));

const $12d35b2aef9102e1$var$ChatPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("ZRTp0")).then((module)=>({
            default: module.ChatPage
        })));

const $12d35b2aef9102e1$var$OptionsPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("iPNXp")).then((module)=>({
            default: module.OptionsPage
        })));

const $12d35b2aef9102e1$var$HomeLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("3MDdT")));

const $12d35b2aef9102e1$var$WelcomePageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("jkjAy")));

const $12d35b2aef9102e1$var$PopupPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("4MiNJ")));

const $12d35b2aef9102e1$var$MenuPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("3dVS3")).then((module)=>({
            default: module.MenuPage
        })));

const $12d35b2aef9102e1$var$PageLayoutLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("lY7Cz")));

const $12d35b2aef9102e1$var$UninstallPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("cGtxy")));
const $12d35b2aef9102e1$export$7c07b633a151f9c5 = new (0, $jDOwD.QueryClient)({
    defaultOptions: {
        queries: {
            gcTime: 86400000 // 24 hours
        }
    }
});
const $12d35b2aef9102e1$export$a2ba0fb8628135cb = (0, $7KlwK.createSyncStoragePersister)({
    storage: window.localStorage
});
function $12d35b2aef9102e1$export$2e2bcd8739ae039({ userAccount: userAccount }) {
    // Add route watcher inside router context
    (0, $67pgD.useReactUFORouteWatcher)();
    // Broadcast Rovo Context Menu variants once for the content-script overlay to read.
    (0, $aLmHL.useBroadcastProactiveContextMenuVariants)();
    const isDevBuild = (0, $dqHaj.bifrostEnv) === 'dev';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6ascs.AnalyticsUserMetadataProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2j9H9.SessionReplayInitializer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8jOpu.ExperienceSLO), {
        ufo: (0, $3dX4H.ExperienceSLOKeys).APP_ROOT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1v5pe.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cFd5E.UFOSuspenseFallback), {
            name: "app-root-suspense"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $642vm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $im7kM.ConsentBanner), null), isDevBuild && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $aBqKF.LocalDevBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Routes), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        path: "/extension"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        Component: $12d35b2aef9102e1$var$WelcomePageLazy,
        path: "welcome"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        Component: $12d35b2aef9102e1$var$PopupLoginRedirectPageLazy,
        path: "login-redirect"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        Component: (0, $d4v8F.IdentityLogout),
        path: "log-out"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        Component: $12d35b2aef9102e1$var$NtpLoginRedirectPageLazy,
        path: "ntp-login-redirect"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        Component: $12d35b2aef9102e1$var$NtpLogoutRedirectPageLazy,
        path: "ntp-logout-redirect"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        Component: $12d35b2aef9102e1$var$PopupPageLazy,
        path: "popup"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        Component: $12d35b2aef9102e1$var$UninstallPageLazy,
        path: "uninstall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($12d35b2aef9102e1$var$PageLayoutLazy, {
            userAccount: userAccount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($12d35b2aef9102e1$var$MenuPageLazy, {
            userAccount: userAccount
        }),
        path: "menu"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($12d35b2aef9102e1$var$OptionsPageLazy, {
            userAccount: userAccount
        }),
        path: "options"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($12d35b2aef9102e1$var$HomeLazy, {
            userAccount: userAccount
        }),
        path: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($12d35b2aef9102e1$var$ChatPageLazy, {
            userAccount: userAccount
        }),
        path: "rovo-chat"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $30t8d.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($12d35b2aef9102e1$var$SessionLazy, null),
        path: "session"
    }))))));
}

});
parcelRegister("2j9H9", function(module, exports) {
$parcel$export(module.exports, "SessionReplayInitializer", () => $f1dc510eb77a0827$export$f511ef2adb3a5466);

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("calFH");
var $30t8d = parcelRequire("30t8d");

var $crLv5 = parcelRequire("crLv5");

var $22hwD = parcelRequire("22hwD");

var $hAu9l = parcelRequire("hAu9l");

var $39pGM = parcelRequire("39pGM");

var $jliSL = parcelRequire("jliSL");

var $8i7E1 = parcelRequire("8i7E1");
/** Serialized reconcile so concurrent ticks (Strict Mode, poll + subscription) do not race. */ let $f1dc510eb77a0827$var$reconcileTail = Promise.resolve();
const $f1dc510eb77a0827$var$SESSION_REPLAY_CONDITION_POLL_MS = 60000;
const $f1dc510eb77a0827$export$cea275c20b2dc2d6 = ()=>{
    (0, $39pGM.sessionReplayDocumentState).reset();
    $f1dc510eb77a0827$var$reconcileTail = Promise.resolve();
};
async function $f1dc510eb77a0827$var$runSessionReplayReconcileSafe() {
    try {
        await $f1dc510eb77a0827$var$runSessionReplayReconcile();
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Session replay eligibility reconcile failed'
        });
    }
}
/** Chains work on `reconcileTail` so ticks never overlap; the work itself uses async/await in {@link runSessionReplayReconcileSafe}. */ function $f1dc510eb77a0827$var$enqueueSessionReplayReconcile() {
    $f1dc510eb77a0827$var$reconcileTail = $f1dc510eb77a0827$var$reconcileTail.then(()=>$f1dc510eb77a0827$var$runSessionReplayReconcileSafe());
    return $f1dc510eb77a0827$var$reconcileTail;
}
async function $f1dc510eb77a0827$var$runSessionReplayReconcile() {
    const eligible = (0, $crLv5.isSessionReplayEnabled)();
    if (eligible && !(0, $39pGM.sessionReplayDocumentState).isInitialized) {
        await (0, $hAu9l.initializeSessionReplay)();
        (0, $39pGM.sessionReplayDocumentState).markInitialized();
    }
// While the same Gas session id is active, keep recording even if the gate later becomes false.
// When Gas mints a new session id, `onAnalyticsWebClientSessionRotation` flushes and either
// updates Amplitude's session or shuts replay down if no longer eligible.
}


const $f1dc510eb77a0827$export$f511ef2adb3a5466 = ()=>{
    const flushAttachedRef = (0, $1v5pe.useRef)(false);
    const removePagehideRef = (0, $1v5pe.useRef)(undefined);
    const location = (0, $30t8d.useLocation)();
    const prevPathnameRef = (0, $1v5pe.useRef)(location.pathname);
    (0, $1v5pe.useEffect)(()=>{
        let mounted = true;
        const detachFlushListeners = ()=>{
            removePagehideRef.current?.();
            removePagehideRef.current = undefined;
            flushAttachedRef.current = false;
        };
        const attachFlushListeners = async ()=>{
            if (flushAttachedRef.current || !(0, $39pGM.sessionReplayDocumentState).isInitialized) return;
            // Named async chunk for session-replay (see `initializeSessionReplay.ts` module comment: Atlaspack + `webpackChunkName`).
            const { flush: flush } = await (parcelRequire("ckOyv"));
            const doFlush = ()=>{
                flush(true);
            };
            window.addEventListener('pagehide', doFlush);
            removePagehideRef.current = ()=>window.removeEventListener('pagehide', doFlush);
            flushAttachedRef.current = true;
        };
        const syncFlushAttachment = async ()=>{
            if ((0, $39pGM.sessionReplayDocumentState).isInitialized && !flushAttachedRef.current) await attachFlushListeners();
            else if (!(0, $39pGM.sessionReplayDocumentState).isInitialized && flushAttachedRef.current) detachFlushListeners();
        };
        const unregisterFlushAttachmentSync = (0, $jliSL.registerSessionReplayFlushAttachmentSync)(()=>{
            syncFlushAttachment();
        });
        const tick = async ()=>{
            await $f1dc510eb77a0827$var$enqueueSessionReplayReconcile();
            if (!mounted) return;
            await syncFlushAttachment();
        };
        tick();
        const unsubscribeGate = (0, $8i7E1.subscribeSessionReplayGate)(()=>{
            tick();
        });
        const pollId = window.setInterval(()=>{
            tick();
        }, $f1dc510eb77a0827$var$SESSION_REPLAY_CONDITION_POLL_MS);
        return ()=>{
            mounted = false;
            unregisterFlushAttachmentSync();
            unsubscribeGate();
            window.clearInterval(pollId);
            detachFlushListeners();
        // NTP mounts once per tab today; if this component were reused in a mount/unmount loop, this
        // cleanup must stay in sync with every timer and listener above.
        };
    }, []);
    // Flush when user navigates within the app (e.g. NTP → options) so events are sent before the view changes.
    (0, $1v5pe.useEffect)(()=>{
        if (!flushAttachedRef.current || prevPathnameRef.current === location.pathname) return;
        prevPathnameRef.current = location.pathname;
        // Same async chunk — see `initializeSessionReplay.ts` module comment.
        (parcelRequire("ckOyv")).then(({ flush: flush })=>flush(true));
    }, [
        location.pathname
    ]);
    return null;
};

});
parcelRegister("hAu9l", function(module, exports) {
$parcel$export(module.exports, "initializeSessionReplay", () => $d92c1b31faac3cf1$export$f690d86bb27f2336);
$parcel$export(module.exports, "shutdownSessionReplay", () => $d92c1b31faac3cf1$export$eb455cee783926a7);
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $dX6kP = parcelRequire("dX6kP");

var $22hwD = parcelRequire("22hwD");
/**
 * Dynamic imports of `@amplitude/session-replay-browser` use `webpackChunkName` magic comments so the
 * bundler can emit a stable async chunk. **Atlaspack respects these** when built with
 * `supportWebpackChunkName` (see `scripts/atlaspack-build.js` in extension-frontend).
 */ /**
 * UGC filter rules for session replay (required if Heatmaps are enabled).
 * Redact URLs to avoid recording sensitive paths. Aligned with Atlassian integration guide.
 */ const $d92c1b31faac3cf1$var$UGC_FILTER_RULES = [
    {
        selector: 'https://*.atlassian.net/browse/*',
        replacement: 'https://REDACTED.atlassian.net/browse/REDACTED'
    },
    {
        selector: 'https://*',
        replacement: 'https://REDACTED'
    },
    {
        selector: 'http://*',
        replacement: 'http://REDACTED'
    }
];
/**
 * NTP (New Tab Page) UGC privacy: mask or block user-identifiable and user-generated content in session replay.
 *
 * All widgets (shortcuts, recent work, announcements, calendar) get the same treatment:
 * - Block only images (favicons, avatars, icons) → grey in replay.
 * - Mask text (titles, metadata) → starred in replay.
 *
 * Profile (top right): container text masked, profile picture blocked (grey).
 *
 * Chat input area (uploaded files, chat mode options, prompt text): entire area masked (text starred),
 * any file preview images blocked (grey).
 *
 * `body` is included last as an Atlassian session-replay integration failsafe: when the effective
 * `defaultMaskLevel` is not `conservative` (e.g. remote `sr_privacy_config` override), the SDK falls
 * back to `maskSelector` only without `maskTextSelector: '*'`. `body` then keeps text masked broadly.
 *
 * **Root `amp-mask`:** `public/index.html` sets `class="amp-mask"` on `#root` (same class as
 * {@link SessionReplayUGC}). rrweb only runs `maskTextFn` on text when `needMaskingText` passes; with
 * conservative config the SDK sets `maskTextSelector: '*'`, and `closest('*')` can fail inside rrweb’s
 * try/catch so static text is skipped while `maskAllInputs` still masks typing. A real `.amp-mask`
 * ancestor fixes the gate for the whole app on first paint and async-loaded NTP content.
 */ const $d92c1b31faac3cf1$var$NTP_PRIVACY_MASK_SELECTORS = [
    "[data-testid='search-input']",
    "[data-testid='full-chat-input']",
    /** Chat box: prompt text, uploaded file names, chat mode menu labels (reasoning, web search, etc.) */ "[data-testid='rovo-chat-box-wrapper']",
    "[data-testid='chat-input-wrapper']",
    "[data-testid='welcome-header-container']",
    "[data-testid='profile-container']",
    "[data-testid='empty-shortcuts-container']",
    /** Shortcuts: star titles */ "[data-testid='ntp-shortcuts-section']",
    /** All dismissible widgets (recent work, announcements, calendar): star text */ "[data-testid='ntp-dismissible-widgets']",
    /** Failsafe — see module comment above */ 'body'
];
const $d92c1b31faac3cf1$var$NTP_PRIVACY_BLOCK_SELECTORS = [
    '.bookmarks_container',
    /** Shortcuts: grey favicons only */ "[data-testid='ntp-shortcuts-section'] img",
    /** All widgets: grey images only (avatars, icons, favicons in recent work, announcements, calendar) */ "[data-testid='ntp-dismissible-widgets'] img",
    /** Profile (top right): grey profile picture only */ "[data-testid='profile-container'] img",
    /** Chat box: grey file preview / thumbnail images only */ "[data-testid='rovo-chat-box-wrapper'] img",
    "[data-testid='chat-input-wrapper'] img"
];

const $d92c1b31faac3cf1$export$f690d86bb27f2336 = async ()=>{
    const apiKey = (0, $dqHaj.getSessionReplayAmplitudeApiKey)();
    if (!apiKey) return;
    try {
        // Same async chunk as `onAnalyticsWebClientSessionRotation` / `SessionReplayInitializer` (see file comment above).
        const { init: init } = await (parcelRequire("ckOyv"));
        const deviceId = (0, $dX6kP.analyticsClient).getAnonymousId();
        const sessionId = (0, $dX6kP.analyticsClient).getCurrentSessionId();
        await init(apiKey, {
            deviceId: deviceId,
            sessionId: sessionId,
            /** Use IndexedDB so events persist when the user navigates away (e.g. to options); memory is lost on unload. */ storeType: 'idb',
            optOut: false,
            applyBackgroundColorToBlockedElements: true,
            /** Record 100% of sessions when selected; without this the SDK defaults to sampling and opts sessions out */ sampleRate: 1,
            /** In dev, level 4 (Debug) so you can see when replay data is sent in the console */ logLevel: (0, $dqHaj.debugEnabled) ? 4 : undefined,
            privacyConfig: {
                defaultMaskLevel: 'conservative',
                maskSelector: $d92c1b31faac3cf1$var$NTP_PRIVACY_MASK_SELECTORS,
                blockSelector: $d92c1b31faac3cf1$var$NTP_PRIVACY_BLOCK_SELECTORS
            },
            interactionConfig: {
                enabled: true,
                batch: true,
                ugcFilterRules: $d92c1b31faac3cf1$var$UGC_FILTER_RULES
            }
        }).promise;
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to initialize session replay'
        });
    }
};

const $d92c1b31faac3cf1$export$eb455cee783926a7 = async ()=>{
    try {
        const { shutdown: shutdown } = await (parcelRequire("ckOyv"));
        shutdown();
    } catch (error) {
        (0, $22hwD.logError)({
            error: error,
            impact: 'Failed to shutdown session replay'
        });
    }
};

});
parcelRegister("ckOyv", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("8nHA4")
]).then(()=>parcelRequire('k37rv'));

});


parcelRegister("39pGM", function(module, exports) {
$parcel$export(module.exports, "sessionReplayDocumentState", () => $a1d5b3e5a25b17e6$export$28c1476832ad9fdd);
/**
 * Document-scoped session replay flag (survives React Strict Mode for the first start).
 *
 * After `shutdownSessionReplay` (e.g. Gas rotation while ineligible), {@link SessionReplayDocumentState.reset}
 * clears state so {@link SessionReplayInitializer} may call `initializeSessionReplay` again — multiple
 * start/stop cycles per document are intentional.
 *
 * Use {@link sessionReplayDocumentState} rather than module-level `let` exports: private field avoids
 * accidental mutation, and `isInitialized` is always read at access time (no stale captured binding).
 */ class $a1d5b3e5a25b17e6$export$31d667b2aa0ae85c {
    get isInitialized() {
        return this._initialized;
    }
    markInitialized() {
        this._initialized = true;
    }
    reset() {
        this._initialized = false;
    }
    constructor(){
        this._initialized = false;
    }
}
const $a1d5b3e5a25b17e6$export$28c1476832ad9fdd = new $a1d5b3e5a25b17e6$export$31d667b2aa0ae85c();

});

parcelRegister("jliSL", function(module, exports) {
$parcel$export(module.exports, "registerSessionReplayFlushAttachmentSync", () => $209ecfb854425216$export$94528fca79ed440d);
$parcel$export(module.exports, "runSessionReplayFlushAttachmentSync", () => $209ecfb854425216$export$b3f82bbebfe3db66);
/**
 * Single-slot callback so session-replay code outside the React tree can refresh pagehide / flush
 * attachment after shutdown. Only one registrant is supported: a second `register*` overwrites the
 * previous slot until its returned unregister runs. That matches today’s single `SessionReplayInitializer`
 * instance; if multiple mount concurrently, the last registration wins (call unregister on unmount).
 */ let $209ecfb854425216$var$syncFlushAttachment;
function $209ecfb854425216$export$94528fca79ed440d(fn) {
    $209ecfb854425216$var$syncFlushAttachment = fn;
    return ()=>{
        $209ecfb854425216$var$syncFlushAttachment = undefined;
    };
}
function $209ecfb854425216$export$b3f82bbebfe3db66() {
    $209ecfb854425216$var$syncFlushAttachment?.();
}

});

parcelRegister("8i7E1", function(module, exports) {
$parcel$export(module.exports, "subscribeSessionReplayGate", () => $43fd3bc1ac716e3f$export$f022d8449a6a65be);

var $4d1Vr = parcelRequire("4d1Vr");

var $TrAR1 = parcelRequire("TrAR1");
const $43fd3bc1ac716e3f$export$f022d8449a6a65be = (onGateMaybeChanged)=>{
    return (0, $4d1Vr.default).onGateUpdated((0, $TrAR1.STATSIG_FEATURE_GATES).SESSION_REPLAY, ()=>{
        onGateMaybeChanged();
    });
};

});


parcelRegister("im7kM", function(module, exports) {
$parcel$export(module.exports, "ConsentBanner", () => $3892e83c8bdf2269$export$903b95b8397e77e9);

var $1v5pe = parcelRequire("1v5pe");

var $4d1Vr = parcelRequire("4d1Vr");

var $kdPoW = parcelRequire("kdPoW");

var $TrAR1 = parcelRequire("TrAR1");
const $3892e83c8bdf2269$export$903b95b8397e77e9 = ()=>{
    const showConsentBanner = (0, $4d1Vr.default).checkGate((0, $TrAR1.STATSIG_FEATURE_GATES).CONSENT);
    if (!showConsentBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kdPoW.ConsentBanner), {
        product: "rovo-extension"
    });
};

});
parcelRegister("kdPoW", function(module, exports) {
$parcel$export(module.exports, "ConsentBanner", () => $2c754042296d1aa7$export$903b95b8397e77e9);

var $1v5pe = parcelRequire("1v5pe");

var $ja864 = parcelRequire("ja864");

var $bHcZt = parcelRequire("bHcZt");

var $2aEiL = parcelRequire("2aEiL");

var $bEUFb = parcelRequire("bEUFb");

var $fLr09 = parcelRequire("fLr09");
const $2c754042296d1aa7$export$903b95b8397e77e9 = (props)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $2aEiL.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $1v5pe.useEffect)(()=>{
            onConsentBannerBailOut?.();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $ja864.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bHcZt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fLr09.ConsentBannerImpl), props)));
};

});
parcelRegister("ja864", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $df353b629fcf3192$export$e926676385687eaf);
$parcel$export(module.exports, "withErrorBoundary", () => $df353b629fcf3192$export$f0c7a449e0cfaec7);

var $1v5pe = parcelRequire("1v5pe");
'use client';
const $df353b629fcf3192$export$b16d9fb1a22de840 = (0, $1v5pe.createContext)(null);
const $df353b629fcf3192$var$initialState = {
    didCatch: false,
    error: null
};
class $df353b629fcf3192$export$e926676385687eaf extends (0, $1v5pe.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $df353b629fcf3192$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($df353b629fcf3192$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $df353b629fcf3192$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($df353b629fcf3192$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $1v5pe.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $1v5pe.createElement)($df353b629fcf3192$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $df353b629fcf3192$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $df353b629fcf3192$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $df353b629fcf3192$export$c052f6604b7d51fe() {
    const context = (0, $1v5pe.useContext)($df353b629fcf3192$export$b16d9fb1a22de840);
    $df353b629fcf3192$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $1v5pe.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $1v5pe.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $df353b629fcf3192$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $1v5pe.forwardRef)((props, ref)=>(0, $1v5pe.createElement)($df353b629fcf3192$export$e926676385687eaf, errorBoundaryProps, (0, $1v5pe.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("bEUFb", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $af55bfd2cef1b264$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");

var $hDU2p = parcelRequire("hDU2p");

var $bwJVB = parcelRequire("bwJVB");

var $8VkkR = parcelRequire("8VkkR");

var $kDq5E = parcelRequire("kDq5E");
const $af55bfd2cef1b264$var$formatMetadata = (metadata)=>{
    if (!metadata) return '';
    // `LoggingMetadata` allows a bare string; emit it as-is rather than running it
    // through JSON.stringify, which would wrap it in extra quotes ("error-code" -> '"error-code"').
    return typeof metadata === 'string' ? metadata : JSON.stringify(metadata);
};
class $af55bfd2cef1b264$export$efa9a398d6368992 {
    // All console output below ERROR (info/warn/debug) is gated behind
    // `platform_moonjelly_bsc_warn_on_set_blocked` so this package's new logging stays dark until
    // the flag is enabled. ERROR output is intentionally always on (subject only to the log level).
    //
    // The log-level comparison is evaluated FIRST in each guard so that `fg` is never called at
    // module-load time: at the default ERROR level these methods short-circuit before reaching
    // `fg`, which keeps a plain `import` of this package from evaluating feature gates (the same
    // import-time concern handled in determine-log-level.ts).
    static info(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).INFO && (0, $2aEiL.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.info(`${(0, $hDU2p.LOG_PREFIX)}: ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    static warn(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).WARN && (0, $2aEiL.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.warn(`${(0, $hDU2p.LOG_PREFIX)}: ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    static error(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).ERROR) console.error(`${(0, $hDU2p.LOG_PREFIX)}: ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    static debug(message, metadata) {
        if ((0, $bwJVB.determineLogLevel)() >= (0, $kDq5E.LogLevel).DEBUG && (0, $2aEiL.fg)('platform_moonjelly_bsc_warn_on_set_blocked')) console.debug(`${(0, $hDU2p.LOG_PREFIX)}: DEBUG ${message}`, $af55bfd2cef1b264$var$formatMetadata(metadata));
    }
    /**
   * Sends an unsampled operational event to backend telemetry and also emits the message via
   * `Logger.error`. When `platform_bsc_throttle_error_events` is enabled the telemetry send is
   * throttled per-action (see error-event-throttle); otherwise it is unconditional. The console
   * output is always at ERROR level (subject to the resolved log level).
   */ static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            // When the throttle gate is OFF the second operand is never evaluated, so no throttle
            // state is recorded and behaviour is unchanged. When ON, shouldSendErrorEvent records
            // the send and limits per-action volume.
            if (!(0, $2aEiL.fg)('platform_bsc_throttle_error_events') || (0, $8VkkR.shouldSendErrorEvent)(action)) (0, $7WT4C.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata);
    }
}

});
parcelRegister("7WT4C", function(module, exports) {
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $2710243828018c15$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $2710243828018c15$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $2710243828018c15$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $2710243828018c15$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $2710243828018c15$export$1ba525b8a711eaac);

var $jcoDC = parcelRequire("jcoDC");
var $6yEEN = parcelRequire("6yEEN");

var $jeHvL = parcelRequire("jeHvL");

var $hDU2p = parcelRequire("hDU2p");

var $3Tj3s = parcelRequire("3Tj3s");

var $h4Fd6 = parcelRequire("h4Fd6");
const $2710243828018c15$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $6yEEN.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $6yEEN.envType).DEV;
    return (0, $6yEEN.envType).PROD;
};
const $2710243828018c15$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $2710243828018c15$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $2710243828018c15$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $2710243828018c15$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $2710243828018c15$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $2710243828018c15$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $2710243828018c15$export$fce3dd735e04d566();
    return {
        packageName: $3Tj3s.packageName,
        packageVersion: $3Tj3s.packageVersion,
        domain: domain,
        product: (0, $jeHvL.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $2710243828018c15$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $jeHvL.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $jcoDC.default)({
                    env: $2710243828018c15$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $jeHvL.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $6yEEN.tenantType).CLOUD_ID, (0, $jeHvL.getBscGlobalState)().cloudId);
                if ((0, $jeHvL.getBscGlobalState)().userId) instance.setUserInfo((0, $6yEEN.userType).ATLASSIAN_ACCOUNT, (0, $jeHvL.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $hDU2p.LOG_PREFIX)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $jeHvL.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $2710243828018c15$export$5bfe55348e7aebc1(properties) {
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.action, ()=>$2710243828018c15$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        }));
}
function $2710243828018c15$export$c986f0e7f985d67f(properties) {
    $2710243828018c15$export$fde53e78fd93a54d()?.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
    });
}
function $2710243828018c15$export$1aecf263098db667(properties) {
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>$2710243828018c15$export$fde53e78fd93a54d()?.sendUIEvent({
            ...properties,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        }));
}
function $2710243828018c15$export$22a3b1671f38a193(properties) {
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.name, ()=>$2710243828018c15$export$fde53e78fd93a54d()?.sendScreenEvent({
            ...properties,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        }));
}
function $2710243828018c15$export$1ba525b8a711eaac(properties) {
    const { onSent: onSent, ...eventProperties } = properties;
    (0, $h4Fd6.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        const client = $2710243828018c15$export$fde53e78fd93a54d();
        if (!client) // No client means nothing was emitted, so we must not run onSent
        return;
        client.sendTrackEvent({
            ...eventProperties,
            attributes: $2710243828018c15$var$decorateEventAttributes(properties.attributes)
        });
        onSent?.();
    });
}

});
parcelRegister("jeHvL", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $12abd53530fa2f1e$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $12abd53530fa2f1e$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $12abd53530fa2f1e$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $12abd53530fa2f1e$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $12abd53530fa2f1e$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $12abd53530fa2f1e$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetDisableWebStorageConsentChecksGlobalState", () => $12abd53530fa2f1e$export$ea650e4f51ec84d8);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $12abd53530fa2f1e$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", () => $12abd53530fa2f1e$export$b60c6437117dfaf9);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState", () => $12abd53530fa2f1e$export$cff869f7e58c9036);
$parcel$export(module.exports, "__internalGetShouldEnforceKeyGlobalState", () => $12abd53530fa2f1e$export$45364c2f8f3ebde3);
$parcel$export(module.exports, "__internalSetCacheLoadedDate", () => $12abd53530fa2f1e$export$491d0e6c401a0697);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $12abd53530fa2f1e$export$ea32fe1e8610fd3b);

var $2W5OM = parcelRequire("2W5OM");

var $bwJVB = parcelRequire("bwJVB");
let $12abd53530fa2f1e$var$analyticsEnabledGlobalState;
let $12abd53530fa2f1e$var$productGlobalState;
let $12abd53530fa2f1e$var$perimeterGlobalState;
let $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState;
let $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState;
let $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState;
let $12abd53530fa2f1e$var$localConsentModeGlobalState;
let $12abd53530fa2f1e$var$packageLogLevelGlobalState;
let $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState;
let $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
let $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState;
let $12abd53530fa2f1e$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
let $12abd53530fa2f1e$var$userIdGlobalState;
let $12abd53530fa2f1e$var$cloudIdGlobalState;
let $12abd53530fa2f1e$var$hasInitialized = false;
let $12abd53530fa2f1e$var$cacheLoadedDateGlobalState;
let $12abd53530fa2f1e$var$cookiesCacheLoader;
let $12abd53530fa2f1e$var$localStorageCacheLoader;
let $12abd53530fa2f1e$var$sessionStorageCacheLoader;
let $12abd53530fa2f1e$var$indexedDBCacheLoader;
let $12abd53530fa2f1e$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $2W5OM.CategoryStorageType).Cookies:
            return await $12abd53530fa2f1e$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).LocalStorage:
            return await $12abd53530fa2f1e$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).SessionStorage:
            return await $12abd53530fa2f1e$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).IndexedDB:
            return await $12abd53530fa2f1e$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
let $12abd53530fa2f1e$var$loadCacheMaybeSync = (storageType)=>{
    switch(storageType){
        case (0, $2W5OM.CategoryStorageType).Cookies:
            return $12abd53530fa2f1e$var$cookiesCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).LocalStorage:
            return $12abd53530fa2f1e$var$localStorageCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).SessionStorage:
            return $12abd53530fa2f1e$var$sessionStorageCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $2W5OM.CategoryStorageType).IndexedDB:
            return $12abd53530fa2f1e$var$indexedDBCacheLoader?.getStorageControlsDataFromCache() ?? $12abd53530fa2f1e$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $12abd53530fa2f1e$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $12abd53530fa2f1e$var$analyticsEnabledGlobalState ?? true,
        product: $12abd53530fa2f1e$var$productGlobalState,
        perimeter: $12abd53530fa2f1e$var$perimeterGlobalState,
        webStorageEnabled: $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $12abd53530fa2f1e$var$localConsentModeGlobalState ?? false,
        allowUncategorizedCookiesInOverrides: $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        allowUncategorizedItemsInIndexedDBOverrides: $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState ?? false,
        __UNSAFE_shouldEnforceKeyForRollout: $12abd53530fa2f1e$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState,
        packageLogLevel: $12abd53530fa2f1e$var$packageLogLevelGlobalState,
        cookiesCacheLoader: $12abd53530fa2f1e$var$cookiesCacheLoader,
        localStorageCacheLoader: $12abd53530fa2f1e$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $12abd53530fa2f1e$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $12abd53530fa2f1e$var$indexedDBCacheLoader,
        loadCache: $12abd53530fa2f1e$var$loadCache,
        loadCacheMaybeSync: $12abd53530fa2f1e$var$loadCacheMaybeSync,
        hasInitialized: $12abd53530fa2f1e$var$hasInitialized,
        userId: $12abd53530fa2f1e$var$userIdGlobalState,
        cloudId: $12abd53530fa2f1e$var$cloudIdGlobalState,
        cacheLoadedDate: $12abd53530fa2f1e$var$cacheLoadedDateGlobalState
    };
};
const $12abd53530fa2f1e$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $12abd53530fa2f1e$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $12abd53530fa2f1e$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $12abd53530fa2f1e$var$productGlobalState = overrideProduct;
};
const $12abd53530fa2f1e$export$ac7c2edd09656c05 = ()=>{
    $12abd53530fa2f1e$var$analyticsEnabledGlobalState = undefined;
    $12abd53530fa2f1e$var$productGlobalState = undefined;
    $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState = undefined;
    $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState = undefined;
    $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState = undefined;
    $12abd53530fa2f1e$var$localConsentModeGlobalState = undefined;
    $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = undefined;
    $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $12abd53530fa2f1e$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = undefined;
    $12abd53530fa2f1e$var$userIdGlobalState = undefined;
    $12abd53530fa2f1e$var$cloudIdGlobalState = undefined;
    $12abd53530fa2f1e$var$packageLogLevelGlobalState = undefined;
    // Reset the resolved-log-level cache too, so a teardown that clears global state without a
    // following initializeGlobalState() can't bleed the previous request's level into the next.
    (0, $bwJVB.resetLogLevelCache)();
    $12abd53530fa2f1e$var$cookiesCacheLoader = undefined;
    $12abd53530fa2f1e$var$localStorageCacheLoader = undefined;
    $12abd53530fa2f1e$var$sessionStorageCacheLoader = undefined;
    $12abd53530fa2f1e$var$indexedDBCacheLoader = undefined;
    $12abd53530fa2f1e$var$hasInitialized = false;
    $12abd53530fa2f1e$var$cacheLoadedDateGlobalState = undefined;
};
function $12abd53530fa2f1e$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $12abd53530fa2f1e$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState !== undefined) $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState = updates.allowUncategorizedItemsInIndexedDBOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState !== undefined) $12abd53530fa2f1e$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $12abd53530fa2f1e$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $12abd53530fa2f1e$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $12abd53530fa2f1e$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $12abd53530fa2f1e$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $12abd53530fa2f1e$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $12abd53530fa2f1e$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $12abd53530fa2f1e$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageLogLevelGlobalState !== undefined) $12abd53530fa2f1e$var$packageLogLevelGlobalState = updates.packageLogLevelGlobalState;
    if (updates.hasInitialized !== undefined) $12abd53530fa2f1e$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $12abd53530fa2f1e$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $12abd53530fa2f1e$var$userIdGlobalState = updates.userIdGlobalState;
}
function $12abd53530fa2f1e$export$8835d45f445e6ba4() {
    return $12abd53530fa2f1e$var$hasInitialized;
}
function $12abd53530fa2f1e$export$9dfdd17bbd03b460() {
    return $12abd53530fa2f1e$var$productGlobalState;
}
function $12abd53530fa2f1e$export$d96c3b0fb6d35c5d() {
    return $12abd53530fa2f1e$var$webStorageControlsEnabledGlobalState;
}
function $12abd53530fa2f1e$export$c8554d68c78456d3() {
    return $12abd53530fa2f1e$var$indexedDbControlsEnabledGlobalState;
}
function $12abd53530fa2f1e$export$ea650e4f51ec84d8() {
    return $12abd53530fa2f1e$var$disableWebStorageConsentChecksGlobalState;
}
function $12abd53530fa2f1e$export$fa1f6ebb49ec4b30() {
    return $12abd53530fa2f1e$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $12abd53530fa2f1e$export$b60c6437117dfaf9() {
    return $12abd53530fa2f1e$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $12abd53530fa2f1e$export$cff869f7e58c9036() {
    return $12abd53530fa2f1e$var$allowUncategorizedItemsInIndexedDBOverridesGlobalState;
}
function $12abd53530fa2f1e$export$45364c2f8f3ebde3() {
    return $12abd53530fa2f1e$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
}
function $12abd53530fa2f1e$export$491d0e6c401a0697(date) {
    if ($12abd53530fa2f1e$var$cacheLoadedDateGlobalState === undefined) $12abd53530fa2f1e$var$cacheLoadedDateGlobalState = date;
}
function $12abd53530fa2f1e$export$ea32fe1e8610fd3b() {
    return $12abd53530fa2f1e$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("2W5OM", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $55482963df864ddc$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $55482963df864ddc$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $55482963df864ddc$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $55482963df864ddc$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $55482963df864ddc$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $55482963df864ddc$export$96e9906d6d93a972);
var $55482963df864ddc$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $55482963df864ddc$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $55482963df864ddc$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $55482963df864ddc$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $55482963df864ddc$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $55482963df864ddc$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $55482963df864ddc$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $55482963df864ddc$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("bwJVB", function(module, exports) {
$parcel$export(module.exports, "determineLogLevel", () => $a07afcb50518ebcb$export$5461380538f47d52);
$parcel$export(module.exports, "resetLogLevelCache", () => $a07afcb50518ebcb$export$977223726df102da);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");

var $kDq5E = parcelRequire("kDq5E");
/**
 * Returns the active log level for the BSC Logger, resolved from (in order):
 * developer cookie override, consumer init param, or `DEFAULT_LOG_LEVEL`.
 *
 * The first call resolves and caches; subsequent calls return the cached
 * value. `initializeGlobalState` invalidates the cache via
 * `resetLogLevelCache()` so an init that runs after the first Logger call
 * still picks up the consumer's `packageLogLevel`.
 *
 * SSR caveat: `cachedLogLevel` is a module-level singleton, so in a shared
 * Node module cache it persists across requests. Both `initializeGlobalState`
 * and `clearGlobalState` call `resetLogLevelCache()`, so per-request init and
 * teardown keep it correct — one request's resolved level cannot leak into the
 * next.
 */ let $a07afcb50518ebcb$var$cachedLogLevel;
const $a07afcb50518ebcb$export$5461380538f47d52 = ()=>{
    if ($a07afcb50518ebcb$var$cachedLogLevel !== undefined) return $a07afcb50518ebcb$var$cachedLogLevel;
    $a07afcb50518ebcb$var$cachedLogLevel = $a07afcb50518ebcb$var$readDebugCookieOverride() ?? $a07afcb50518ebcb$var$readInitParamLogLevel() ?? (0, $kDq5E.DEFAULT_LOG_LEVEL);
    return $a07afcb50518ebcb$var$cachedLogLevel;
};
const $a07afcb50518ebcb$export$977223726df102da = ()=>{
    $a07afcb50518ebcb$var$cachedLogLevel = undefined;
};
/**
 * Returns `LogLevel.DEBUG` when the dev override is active (cookie set AND
 * the safety-net FF is enabled), else `null`. The FF gate lets us remotely
 * disable the cookie path if it ever misbehaves.
 *
 * The cookie is checked BEFORE the feature gate on purpose: `fg` is only ever
 * evaluated when the (rare, dev-only) `atl-bsc-debug-mode` cookie is present.
 * This keeps `Logger.*` calls — including ones that run at module-load time
 * (e.g. the AtlIndexedDb singleton) — from calling `fg` during a plain import.
 * Otherwise importing BSC crashes any consumer whose test mocks `fg` with a
 * not-yet-initialized factory variable ("Cannot access 'mockFg' before
 * initialization").
 */ const $a07afcb50518ebcb$var$readDebugCookieOverride = ()=>{
    let debugCookieSet = false;
    try {
        debugCookieSet = (0, $6yOvq.default).get('atl-bsc-debug-mode') === 'true';
    } catch  {
        // Cookie access can throw in sandboxed iframes / strict cookie policies.
        return null;
    }
    if (!debugCookieSet) return null;
    return (0, $2aEiL.fg)('platform_moonjelly_bsc_debug_mode') ? (0, $kDq5E.LogLevel).DEBUG : null;
};
/**
 * Returns the LogLevel corresponding to the consumer's `packageLogLevel` init
 * param, or `null` if unset or unrecognized.
 */ const $a07afcb50518ebcb$var$readInitParamLogLevel = ()=>{
    return (0, $kDq5E.packageLogLevelStringToEnum)((0, $jeHvL.getBscGlobalState)().packageLogLevel);
};

});
parcelRegister("6yOvq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c6d187aa5a59fb0$export$2e2bcd8739ae039);
/*! js-cookie v3.0.8 | MIT */ function $4c6d187aa5a59fb0$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $4c6d187aa5a59fb0$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $4c6d187aa5a59fb0$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $4c6d187aa5a59fb0$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $4c6d187aa5a59fb0$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $4c6d187aa5a59fb0$var$init(this.converter, $4c6d187aa5a59fb0$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $4c6d187aa5a59fb0$var$init($4c6d187aa5a59fb0$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $4c6d187aa5a59fb0$export$2e2bcd8739ae039 = $4c6d187aa5a59fb0$var$init($4c6d187aa5a59fb0$var$defaultConverter, {
    path: '/'
});

});

parcelRegister("kDq5E", function(module, exports) {
$parcel$export(module.exports, "LogLevel", () => $3574737933c084ff$export$243e62d78d3b544d);
$parcel$export(module.exports, "DEFAULT_LOG_LEVEL", () => $3574737933c084ff$export$97d4c6871900dcac);
$parcel$export(module.exports, "packageLogLevelStringToEnum", () => $3574737933c084ff$export$6b31b02af0747fdf);
/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */ var $3574737933c084ff$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["SILENT"] = 0] = "SILENT";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    return LogLevel;
}({});
const $3574737933c084ff$export$97d4c6871900dcac = 1;
const $3574737933c084ff$var$PACKAGE_LOG_LEVEL_BY_STRING = {
    silent: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4
};
const $3574737933c084ff$export$6b31b02af0747fdf = (value)=>{
    if (value === undefined) return null;
    return $3574737933c084ff$var$PACKAGE_LOG_LEVEL_BY_STRING[value] ?? null;
};

});



parcelRegister("hDU2p", function(module, exports) {
$parcel$export(module.exports, "LOG_PREFIX", () => $6f37f4e2602467c2$export$5e28bf885ebebfa6);
$parcel$export(module.exports, "ERROR_EVENT_THROTTLE_INTERVAL_MS", () => $6f37f4e2602467c2$export$aeb1f5aa1188ce28);
$parcel$export(module.exports, "ERROR_EVENT_MAX_PER_SESSION", () => $6f37f4e2602467c2$export$ee3d07c2528881e2);
const $6f37f4e2602467c2$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $6f37f4e2602467c2$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $6f37f4e2602467c2$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

});

parcelRegister("3Tj3s", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $87aed303a1b1e5fe$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $87aed303a1b1e5fe$export$91546b032799aa40);
const $87aed303a1b1e5fe$export$9345d7360ffe0722 = undefined ?? '';
const $87aed303a1b1e5fe$export$91546b032799aa40 = undefined ?? '';

});

parcelRegister("h4Fd6", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $54092f12bef1ca09$export$67b6e87f323cb6ad);

var $2W5OM = parcelRequire("2W5OM");

var $jeHvL = parcelRequire("jeHvL");

var $bHi4N = parcelRequire("bHi4N");

var $dS1lP = parcelRequire("dS1lP");
const $54092f12bef1ca09$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $54092f12bef1ca09$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $54092f12bef1ca09$var$loadSamplingConfig() {
    if ((0, $bHi4N.cache).cachedSamplingConfig) return (0, $bHi4N.cache).cachedSamplingConfig;
    if ((0, $dS1lP.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $jeHvL.getBscGlobalState)();
    const controlsData = await loadCache((0, $2W5OM.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $bHi4N.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $54092f12bef1ca09$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($54092f12bef1ca09$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $54092f12bef1ca09$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $54092f12bef1ca09$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $54092f12bef1ca09$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $54092f12bef1ca09$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $54092f12bef1ca09$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $54092f12bef1ca09$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $54092f12bef1ca09$export$b286f5e8716d11ad(analyticsEventKey);
    $54092f12bef1ca09$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("bHi4N", function(module, exports) {
$parcel$export(module.exports, "cache", () => $82b98c816b467d71$export$69a3209f1a06c04d);

var $TDqoV = parcelRequire("TDqoV");
const $82b98c816b467d71$export$69a3209f1a06c04d = new (0, $TDqoV.CachedSamplingConfig)();

});
parcelRegister("TDqoV", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $96d7295b8fe60ffd$export$b886edaf6623554a);
class $96d7295b8fe60ffd$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("dS1lP", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $281cf2428eba4b45$export$48d7c418edadb60c);

var $jcoDC = parcelRequire("jcoDC");

var $2aEiL = parcelRequire("2aEiL");
const $281cf2428eba4b45$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $2aEiL.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $jcoDC.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});



parcelRegister("8VkkR", function(module, exports) {
$parcel$export(module.exports, "shouldSendErrorEvent", () => $28311beab73b7c0c$export$e54335114720f029);

var $hDU2p = parcelRequire("hDU2p");
// Per-process (per page load) throttle state, keyed by operational event action.
// Resets naturally on page reload because module state is re-initialised, which gives
// us the "per session" semantic for free (same pattern as bsc-global-state).
const $28311beab73b7c0c$var$throttleState = new Map();
function $28311beab73b7c0c$export$e54335114720f029(action) {
    const now = Date.now();
    const entry = $28311beab73b7c0c$var$throttleState.get(action);
    if (!entry) {
        // First occurrence of this action this session always sends.
        $28311beab73b7c0c$var$throttleState.set(action, {
            lastSentAt: now,
            sentCount: 1
        });
        return true;
    }
    if (entry.sentCount >= (0, $hDU2p.ERROR_EVENT_MAX_PER_SESSION)) // Hard per-session cap reached — drop regardless of elapsed time.
    return false;
    if (now - entry.lastSentAt < (0, $hDU2p.ERROR_EVENT_THROTTLE_INTERVAL_MS)) // Within the cooldown window since the last send for this action.
    return false;
    entry.lastSentAt = now;
    entry.sentCount += 1;
    return true;
}
function $28311beab73b7c0c$export$a5ff37ede5ff9625() {
    $28311beab73b7c0c$var$throttleState.clear();
}

});


parcelRegister("fLr09", function(module, exports) {
$parcel$export(module.exports, "ConsentBannerImpl", () => $33a6600c5da46c88$export$24af610f9b900e82);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $1v5pe = parcelRequire("1v5pe");

var $lJYzG = parcelRequire("lJYzG");
var $kK7WO = parcelRequire("kK7WO");

var $bHcZt = parcelRequire("bHcZt");
var $dNZ1k = parcelRequire("dNZ1k");

var $4saCT = parcelRequire("4saCT");

var $8sBGu = parcelRequire("8sBGu");

var $2aEiL = parcelRequire("2aEiL");

var $k0q1a = parcelRequire("k0q1a");

var $bEI9C = parcelRequire("bEI9C");
var $7WT4C = parcelRequire("7WT4C");

var $7N5mY = parcelRequire("7N5mY");

var $bEUFb = parcelRequire("bEUFb");

var $3yjSR = parcelRequire("3yjSR");

var $hFmCB = parcelRequire("hFmCB");
var $dbJ6U = parcelRequire("dbJ6U");

var $6t0zJ = parcelRequire("6t0zJ");

var $eEjwS = parcelRequire("eEjwS");

var $1H4sW = parcelRequire("1H4sW");

var $9jI7c = parcelRequire("9jI7c");

var $ilta6 = parcelRequire("ilta6");

var $ace0b = parcelRequire("ace0b");
const $33a6600c5da46c88$var$SuccessWithIntl = (0, $lJYzG.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8sBGu))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.success',
            defaultMessage: 'Success',
            description: 'The text is shown as the title of a success toast notification that appears in the consent banner after the user successfully saves their cookie preferences.'
        }),
        spacing: (0, $2aEiL.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $33a6600c5da46c88$var$ErrorWithIntl = (0, $lJYzG.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4saCT))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        }),
        spacing: (0, $2aEiL.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $33a6600c5da46c88$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($33a6600c5da46c88$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $33a6600c5da46c88$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($33a6600c5da46c88$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $33a6600c5da46c88$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter = 'commercial' })=>{
    const firstRender = (0, $1v5pe.useRef)(true);
    (0, $1v5pe.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $7WT4C.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $hFmCB.deleteCookie)((0, $3yjSR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $1v5pe.useEffect)(()=>{
        if ((0, $2aEiL.fg)('fedramp-consent-banner-perimeter-prop')) (0, $bEI9C.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
        else (0, $bEI9C.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $1v5pe.useState)(false);
    const intl = (0, $kK7WO.default)();
    const { showFlag: showFlag } = (0, $dNZ1k.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $9jI7c.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $ace0b.default)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $1v5pe.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $1v5pe.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $1v5pe.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $1v5pe.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$33a6600c5da46c88$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $eEjwS.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $eEjwS.i18n).successFlagTitle)
        });
        else showFlag({
            ...$33a6600c5da46c88$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $eEjwS.i18n).successFlagDescription),
            title: intl.formatMessage((0, $eEjwS.i18n).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $1v5pe.useCallback)(()=>{
        showFlag({
            ...$33a6600c5da46c88$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $eEjwS.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $eEjwS.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $1v5pe.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $7WT4C.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $6t0zJ.updatePreferences)((0, $3yjSR.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $7WT4C.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $3yjSR.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $1v5pe.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $7WT4C.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $6t0zJ.updatePreferences)((0, $3yjSR.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $7WT4C.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $3yjSR.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $1v5pe.useCallback)(()=>{
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $1v5pe.useEffect)(()=>{
        if (showBanner) (0, $k0q1a.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow?.();
        else if (!showBanner) onHide?.();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $1v5pe.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut?.();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bHcZt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $7N5mY.BSCIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $ilta6.PresentationalConsentBanner), {
        onClickOnlyNecessary: onClickOnlyNecessary,
        onClickAcceptAll: onClickAcceptAll,
        onClickPreferences: onClickPreferences,
        onClickTrackingNoticeLink: onClickTrackingNoticeLink,
        minWidth: minWidth,
        newMinHeight: newMinHeight
    }), isPreferencesModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1H4sW.PreferenceModal), {
        onClose: closePreferenceModal,
        onSubmit: onPreferenceModalSubmit,
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag,
        shouldAddWrappers: false
    })));
};

});
parcelRegister("4saCT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8eaaa23a968450e17340047f7baad741>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e205216bc950b6$var$_react = $33e205216bc950b6$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $33e205216bc950b6$var$_baseNew = $33e205216bc950b6$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $33e205216bc950b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e205216bc950b6$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $33e205216bc950b6$var$_react.default.createElement($33e205216bc950b6$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$33e205216bc950b6$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $33e205216bc950b6$var$_default = module.exports.default = $33e205216bc950b6$var$StatusErrorIcon;

});

parcelRegister("8sBGu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43780b3395052aa320d1077123ecca9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $628e2b93b0e85985$var$_react = $628e2b93b0e85985$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $628e2b93b0e85985$var$_baseNew = $628e2b93b0e85985$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $628e2b93b0e85985$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $628e2b93b0e85985$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $628e2b93b0e85985$var$_react.default.createElement($628e2b93b0e85985$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$628e2b93b0e85985$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $628e2b93b0e85985$var$_default = module.exports.default = $628e2b93b0e85985$var$StatusSuccessIcon;

});

parcelRegister("k0q1a", function(module, exports) {
$parcel$export(module.exports, "default", () => $58150e041f5c98b7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $58150e041f5c98b7$export$d12f56a472cdbe6c);

var $1v5pe = parcelRequire("1v5pe");

var $hRUfe = parcelRequire("hRUfe");

var $31aDV = parcelRequire("31aDV");

var $8OjRF = parcelRequire("8OjRF");
function $58150e041f5c98b7$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $1v5pe.useContext)((0, $hRUfe.default));
    (0, $1v5pe.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $58150e041f5c98b7$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $31aDV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $8OjRF.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $8OjRF.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("bEI9C", function(module, exports) {
$parcel$export(module.exports, "initializeGlobalState", () => $751de4a961087994$export$882c4530c58781d8);

var $cc5qg = parcelRequire("cc5qg");

var $2aEiL = parcelRequire("2aEiL");

var $2W5OM = parcelRequire("2W5OM");

var $ad5Pz = parcelRequire("ad5Pz");

var $bEUFb = parcelRequire("bEUFb");

var $bwJVB = parcelRequire("bwJVB");

var $jeHvL = parcelRequire("jeHvL");
const $751de4a961087994$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, disableWebStorageConsentChecks: disableWebStorageConsentChecks, packageLogLevel: packageLogLevel, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides, allowUncategorizedItemsInIndexedDBOverrides: allowUncategorizedItemsInIndexedDBOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, __UNSAFE_shouldEnforceKeyForRollout: __UNSAFE_shouldEnforceKeyForRollout, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $bEUFb.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, $jeHvL.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $jeHvL.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $jeHvL.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $2aEiL.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $jeHvL.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $2aEiL.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, $jeHvL.__internalGetDisableWebStorageConsentChecksGlobalState)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $jeHvL.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, $jeHvL.__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    // `allowUncategorizedItemsInIndexedDBOverrides` is the IDB-only counterpart to
    // `allowUncategorizedItemsInWebStorageOverrides`. It is sticky in the same way, and only
    // takes effect when IndexedDB controls are enabled. It does not affect cookies or web storage.
    const allowUncategorizedItemsInIndexedDBOverridesGlobalState = (0, $jeHvL.__internalGetAllowUncategorizedItemsInIndexedDBOverridesGlobalState)();
    if (allowUncategorizedItemsInIndexedDBOverrides !== undefined && allowUncategorizedItemsInIndexedDBOverridesGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        allowUncategorizedItemsInIndexedDBOverridesGlobalState: allowUncategorizedItemsInIndexedDBOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $jeHvL.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // Sticky on first set, mirroring the consent-check flags above.
    const __UNSAFE_shouldEnforceKeyForRolloutGlobalState = (0, $jeHvL.__internalGetShouldEnforceKeyGlobalState)();
    if (__UNSAFE_shouldEnforceKeyForRollout !== undefined && __UNSAFE_shouldEnforceKeyForRolloutGlobalState === undefined) (0, $jeHvL.__internalApplyInitialState)({
        __UNSAFE_shouldEnforceKeyForRolloutGlobalState: __UNSAFE_shouldEnforceKeyForRollout
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    // This behaviour is gated behind the fedramp-consent-banner-perimeter-prop feature flag.
    if ((0, $jeHvL.__internalGetHasInitialized)() && !(overrideOnceParams && (0, $2aEiL.fg)('fedramp-consent-banner-perimeter-prop'))) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, $cc5qg.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, $ad5Pz.CacheLoader)((0, $2W5OM.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $ad5Pz.CacheLoader)((0, $2W5OM.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $ad5Pz.CacheLoader)((0, $2W5OM.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $ad5Pz.CacheLoader)((0, $2W5OM.CategoryStorageType).IndexedDB, perimeter);
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageLogLevelGlobalState: packageLogLevel,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $jeHvL.__internalApplyInitialState)(updates);
    // Invalidate the resolved Logger level so any callers that triggered an
    // early `Logger.*` call before init pick up the new `packageLogLevel`.
    (0, $bwJVB.resetLogLevelCache)();
};

});
parcelRegister("ad5Pz", function(module, exports) {
$parcel$export(module.exports, "CacheLoader", () => $2c756d3d602be1a8$export$e479342c697b82a9);

var $2aEiL = parcelRequire("2aEiL");

var $fqfOD = parcelRequire("fqfOD");
var $5ndys = parcelRequire("5ndys");

var $jeHvL = parcelRequire("jeHvL");

var $9ofjk = parcelRequire("9ofjk");

var $bEUFb = parcelRequire("bEUFb");

var $jBwyl = parcelRequire("jBwyl");
class $2c756d3d602be1a8$export$e479342c697b82a9 {
    constructor(storageType, perimeter = 'commercial'){
        const useFlatFormat = (0, $9ofjk.isFlatPatternFileFormatEnabled)();
        const cacheUrlLookup = (0, $jBwyl.getCategoryCacheUrlPerimeterLookup)(useFlatFormat)[perimeter] || (0, $jBwyl.getCommercialCategoryCacheUrlLookup)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $5ndys.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, $fqfOD.ExperienceTypes).Load,
                performanceType: (0, $fqfOD.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $bEUFb.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            if ((0, $2aEiL.fg)('platform_bsc_cache_load_date')) (0, $jeHvL.__internalSetCacheLoadedDate)(new Date().toISOString().slice(0, 10));
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $bEUFb.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("5ndys", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $f2a6449edcdd04f6$export$c00d22927c60484a);

var $84srt = parcelRequire("84srt");
class $f2a6449edcdd04f6$export$c00d22927c60484a extends (0, $84srt.UFOAbstractExperience) {
}

});
parcelRegister("84srt", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $e0d00430607227ba$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $664X1 = parcelRequire("664X1");

var $2aEiL = parcelRequire("2aEiL");

var $b1aN1 = parcelRequire("b1aN1");

var $5078C = parcelRequire("5078C");

var $aJPNr = parcelRequire("aJPNr");

var $4hthk = parcelRequire("4hthk");

var $eWLNl = parcelRequire("eWLNl");

var $5wsAo = parcelRequire("5wsAo");

var $5IKwo = parcelRequire("5IKwo");

var $jjfdf = parcelRequire("jjfdf");

var $9KfqA = parcelRequire("9KfqA");

var $8B5VS = parcelRequire("8B5VS");

var $hFdXd = parcelRequire("hFdXd");

var $c8cYi = parcelRequire("c8cYi");

var $ltNHt = parcelRequire("ltNHt");

var $lMJNN = parcelRequire("lMJNN");

var $fqfOD = parcelRequire("fqfOD");
const $e0d00430607227ba$var$getPageVisibleState = ()=>{
    return !(0, $5IKwo.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $hFdXd.PageVisibleState).VISIBLE : (0, $hFdXd.PageVisibleState).HIDDEN;
};
const $e0d00430607227ba$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $c8cYi.roundPerfNow)();
};
class $e0d00430607227ba$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $ltNHt.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $hFdXd.PageVisibleState).MIXED;
            (0, $8B5VS.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $e0d00430607227ba$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $fqfOD.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $fqfOD.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $9KfqA.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $lMJNN.canTransition)(this.state, newState)) {
            (0, $9KfqA.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $ltNHt.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $e0d00430607227ba$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $664X1.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $e0d00430607227ba$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $jjfdf.getGlobalEventStream)().push((0, $jjfdf.unsubscribeEvent)((0, $hFdXd.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $9KfqA.ufolog)('this.parent', this.parent);
                (0, $jjfdf.getGlobalEventStream)().push((0, $jjfdf.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $9KfqA.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $9KfqA.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $ltNHt.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $e0d00430607227ba$var$getPageVisibleState();
            (0, $8B5VS.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $9KfqA.ufolog)('subscribed', this.id);
                (0, $jjfdf.getGlobalEventStream)().push((0, $jjfdf.subscribeEvent)((0, $hFdXd.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $hFdXd.FMP_MARK) && name !== (0, $hFdXd.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $9KfqA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $e0d00430607227ba$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $ltNHt.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $hFdXd.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $hFdXd.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $2aEiL.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $4hthk.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $aJPNr.generateTraceId)(),
                    spanId: (0, $5078C.generateSpanId)()
                };
                (0, $eWLNl.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $2aEiL.fg)('ufo_v1_tracing')) (0, $b1aN1.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $9KfqA.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $8B5VS.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $ltNHt.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $ltNHt.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $ltNHt.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $9KfqA.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $5wsAo.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $2aEiL.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("b1aN1", function(module, exports) {
$parcel$export(module.exports, "clearActiveTrace", () => $5c9fc3f123bf9849$export$17ab21d7be720b);

var $8WfCw = parcelRequire("8WfCw");
function $5c9fc3f123bf9849$export$17ab21d7be720b() {
    (0, $8WfCw.state).context = null;
}

});
parcelRegister("8WfCw", function(module, exports) {
$parcel$export(module.exports, "state", () => $dd442011e39d6c6f$export$ca000e230c0caa3e);
const $dd442011e39d6c6f$export$ca000e230c0caa3e = {
    context: null
};

});


parcelRegister("5078C", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $385cf53b09c338fc$export$295213bc4d0c54ad);
/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */ function $385cf53b09c338fc$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("aJPNr", function(module, exports) {
$parcel$export(module.exports, "generateTraceId", () => $b315c7e8da913596$export$dc6d7ea554bcce10);
/**
 * Generates a random 32-character hexadecimal trace ID.
 * This is used for creating new trace IDs in distributed tracing.
 *
 * @returns A 32-character hexadecimal string
 *
 * @example
 * ```typescript
 * const traceId = generateTraceId(); // e.g., "9ad3407c1a7d484b86847e7226e566d3"
 * ```
 */ function $b315c7e8da913596$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});

parcelRegister("4hthk", function(module, exports) {
$parcel$export(module.exports, "getActiveTrace", () => $4c70377c21c9ac88$export$b6ac780db3a3cc77);

var $8WfCw = parcelRequire("8WfCw");
function $4c70377c21c9ac88$export$b6ac780db3a3cc77() {
    return (0, $8WfCw.state).context;
}

});

parcelRegister("eWLNl", function(module, exports) {
$parcel$export(module.exports, "setActiveTrace", () => $bd1491c47b3a7afc$export$a1002be327997103);

var $jcoDC = parcelRequire("jcoDC");

var $bxQue = parcelRequire("bxQue");

var $8WfCw = parcelRequire("8WfCw");
const $bd1491c47b3a7afc$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = (0, $bxQue.getEnvironment)();
            instance = new (0, $jcoDC.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
function $bd1491c47b3a7afc$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ((0, $8WfCw.state).context !== null) $bd1491c47b3a7afc$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: (0, $8WfCw.state).context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else (0, $8WfCw.state).context = {
        traceId: traceId,
        spanId: spanId
    };
}

});
parcelRegister("bxQue", function(module, exports) {
$parcel$export(module.exports, "getEnvironment", () => $6d986f8ac8a310bd$export$57570b1603cf6adb);

var $6yEEN = parcelRequire("6yEEN");
function $6d986f8ac8a310bd$export$57570b1603cf6adb() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $6yEEN.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $6yEEN.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $6yEEN.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $6yEEN.envType).STAGING;
    return (0, $6yEEN.envType).PROD;
}

});


parcelRegister("5wsAo", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $69a92176ffd57aeb$export$2295b861f318254a);
// temp solution until we can get it automated
const $69a92176ffd57aeb$export$2295b861f318254a = '0.1.5';

});

parcelRegister("c8cYi", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $8af30e183b517e3b$export$5f490af6b2b115cf);
const $8af30e183b517e3b$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("ltNHt", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $6a6a93583b1abdd9$export$81b70111112841a0);
const $6a6a93583b1abdd9$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("lMJNN", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $921cec6479bfa15e$export$178881f329fdb81f);

var $ltNHt = parcelRequire("ltNHt");
const $921cec6479bfa15e$var$UFOStateAvailableTransitions = {
    [(0, $ltNHt.UFOExperienceState).NOT_STARTED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).STARTED.id]: [
        (0, $ltNHt.UFOExperienceState).IN_PROGRESS.id,
        (0, $ltNHt.UFOExperienceState).BLOCKED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $ltNHt.UFOExperienceState).BLOCKED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).BLOCKED.id]: [
        (0, $ltNHt.UFOExperienceState).RECOVERED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).RECOVERED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).SUCCEEDED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $ltNHt.UFOExperienceState).SUCCEEDED.id,
        (0, $ltNHt.UFOExperienceState).FAILED.id,
        (0, $ltNHt.UFOExperienceState).ABORTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).FAILED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ],
    [(0, $ltNHt.UFOExperienceState).ABORTED.id]: [
        (0, $ltNHt.UFOExperienceState).STARTED.id
    ]
};
const $921cec6479bfa15e$export$178881f329fdb81f = (state1, state2)=>{
    return $921cec6479bfa15e$var$UFOStateAvailableTransitions[state1.id] && $921cec6479bfa15e$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});



parcelRegister("9ofjk", function(module, exports) {
$parcel$export(module.exports, "isFlatPatternFileFormatEnabled", () => $ae95425a4d75d2eb$export$43a35c1452d55dd7);

var $2aEiL = parcelRequire("2aEiL");

var $dS1lP = parcelRequire("dS1lP");
const $ae95425a4d75d2eb$export$43a35c1452d55dd7 = ()=>(0, $dS1lP.isSSR)() ? (0, $2aEiL.fg)('platform_bsc_ssr_flat_pattern_file_format') : (0, $2aEiL.fg)('platform_bsc_flat_pattern_file_structure');

});

parcelRegister("jBwyl", function(module, exports) {
$parcel$export(module.exports, "getCommercialCategoryCacheUrlLookup", () => $560c29f7f06e7acf$export$5989415260e0cf82);
$parcel$export(module.exports, "getCategoryCacheUrlPerimeterLookup", () => $560c29f7f06e7acf$export$9797a362f9385b1a);

var $2aEiL = parcelRequire("2aEiL");

var $2W5OM = parcelRequire("2W5OM");

var $9ofjk = parcelRequire("9ofjk");
var $560c29f7f06e7acf$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $560c29f7f06e7acf$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $560c29f7f06e7acf$var$generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    // TEMPORARY: gate that switches category file fetching from the production CDN
    // to the staging CDN for testing. Remove once COOK-587 is tested.
    const useStagingCategories = (0, $2aEiL.fg)('platform_bsc_categories_from_staging');
    const baseBifrostCommercialPath = useStagingCategories ? 'https://atlassian-cookies.stg-east.frontend.public.atl-paas.net/' : 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
    const baseBifrostFedrampPath = useStagingCategories ? 'https://atlassian-cookies.stg.frontend.cdn.atlassian-us-gov-mod.com/' : 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${baseBifrostCommercialPath}${fileName}`;
        default:
            return `${baseBifrostCommercialPath}${fileName}`;
    }
};
const $560c29f7f06e7acf$export$5989415260e0cf82 = (useFlatFormat = false)=>{
    return {
        [(0, $2W5OM.CategoryStorageType).Cookies]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, $2W5OM.CategoryStorageType).LocalStorage]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, $2W5OM.CategoryStorageType).SessionStorage]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, $2W5OM.CategoryStorageType).IndexedDB]: $560c29f7f06e7acf$var$generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const $560c29f7f06e7acf$export$9797a362f9385b1a = (useFlatFormat = false)=>{
    return {
        commercial: $560c29f7f06e7acf$export$5989415260e0cf82(useFlatFormat),
        'fedramp-moderate': {
            [(0, $2W5OM.CategoryStorageType).Cookies]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, $2W5OM.CategoryStorageType).LocalStorage]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, $2W5OM.CategoryStorageType).SessionStorage]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, $2W5OM.CategoryStorageType).IndexedDB]: $560c29f7f06e7acf$var$generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const $560c29f7f06e7acf$export$1f60178895e28eb8 = (source, perimeter, storageType)=>{
    const useFlatFormat = (0, $9ofjk.isFlatPatternFileFormatEnabled)();
    return $560c29f7f06e7acf$var$generateResourcePath(perimeter, storageType, useFlatFormat);
};

});



parcelRegister("7N5mY", function(module, exports) {
$parcel$export(module.exports, "BSCIntlProvider", () => $c92052f02b4f1e2c$export$9aa38aed134c207f);

var $1v5pe = parcelRequire("1v5pe");

var $7EVvM = parcelRequire("7EVvM");

var $gVdmf = parcelRequire("gVdmf");
var $2eGnS = parcelRequire("2eGnS");
const $c92052f02b4f1e2c$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $7EVvM.default), {
        defaultMessages: (0, $gVdmf.default),
        loaderFn: (0, $2eGnS.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("7EVvM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c423de30497c8ed$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $cZ6aD = parcelRequire("cZ6aD");

var $6c3s0 = parcelRequire("6c3s0");

var $hb3uL = parcelRequire("hb3uL");
function $4c423de30497c8ed$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $hb3uL.useSafeIntl)();
    const messages = (0, $6c3s0.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $1v5pe.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cZ6aD.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("6c3s0", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $baef41f646f5e783$export$4d17e2d9c5348842);

var $1v5pe = parcelRequire("1v5pe");

var $75gx9 = parcelRequire("75gx9");
function $baef41f646f5e783$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $1v5pe.useState)((0, $75gx9.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $1v5pe.useRef)(localeState.locale);
    (0, $1v5pe.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("75gx9", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $60abd50562ea94da$export$79618bef82c02d4c);
const $60abd50562ea94da$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("hb3uL", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $248d35f15899d432$export$f752ac21ea3960a5);

var $1v5pe = parcelRequire("1v5pe");

var $1YTwG = parcelRequire("1YTwG");
var $3zCfq = parcelRequire("3zCfq");
var $lJYzG = parcelRequire("lJYzG");

var $75gx9 = parcelRequire("75gx9");
// Prevents memory leaks
const $248d35f15899d432$var$cache = (0, $3zCfq.createIntlCache)();
const $248d35f15899d432$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $1v5pe.useContext)((0, $lJYzG.Context));
    if (!context) return (0, $1YTwG.createIntl)((0, $75gx9.DEFAULT_LOCALE_STATE), $248d35f15899d432$var$cache);
    return context;
};

});


parcelRegister("gVdmf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c25cdb5eabfe9ffe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $caExe = parcelRequire("caExe");
var $c25cdb5eabfe9ffe$export$2e2bcd8739ae039 = (0, $caExe.default);

});
parcelRegister("caExe", function(module, exports) {
$parcel$export(module.exports, "default", () => $9da0062b2c8868e7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $9da0062b2c8868e7$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify': 'Measures usage to improve app performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.strict.description.082624-appify': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-description.text.no.link': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved',
    'browser-storage-controls.consent-banner.toast.error': 'Error',
    'browser-storage-controls.consent-banner.toast.success': 'Success'
};

});


parcelRegister("2eGnS", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $06c5662aff3a78a3$export$2b153a2030b0feb2);

var $gVdmf = parcelRequire("gVdmf");




























const $06c5662aff3a78a3$var$locales = {
    cs: ()=>(parcelRequire("14qB5")),
    da: ()=>(parcelRequire("7dw0Q")),
    de: ()=>(parcelRequire("eDKB8")),
    'en-GB': ()=>(parcelRequire("5SK4h")),
    'en-ZZ': ()=>(parcelRequire("e9tfD")),
    en: ()=>Promise.resolve((parcelRequire("gVdmf"))),
    es: ()=>(parcelRequire("1ibWM")),
    fi: ()=>(parcelRequire("97hnQ")),
    fr: ()=>(parcelRequire("drGZp")),
    hu: ()=>(parcelRequire("h5U2C")),
    it: ()=>(parcelRequire("koda3")),
    ja: ()=>(parcelRequire("h3R2B")),
    ko: ()=>(parcelRequire("id0BC")),
    nb: ()=>(parcelRequire("gvKVh")),
    nl: ()=>(parcelRequire("lITsv")),
    pl: ()=>(parcelRequire("dY63n")),
    'pt-BR': ()=>(parcelRequire("hoyQq")),
    ru: ()=>(parcelRequire("5B4Fk")),
    sl: ()=>(parcelRequire("jvXO5")),
    sr_RS: ()=>(parcelRequire("f8lyW")),
    sr_YR: ()=>(parcelRequire("dCpPA")),
    sv: ()=>(parcelRequire("9nP7X")),
    th: ()=>(parcelRequire("XnU7s")),
    tr: ()=>(parcelRequire("hgibD")),
    uk: ()=>(parcelRequire("fi91r")),
    vi: ()=>(parcelRequire("2FW77")),
    zh_TW: ()=>(parcelRequire("c902I")),
    zh: ()=>(parcelRequire("kDSyb"))
};
const $06c5662aff3a78a3$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $06c5662aff3a78a3$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $06c5662aff3a78a3$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("14qB5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("dVKpW").then(()=>parcelRequire('6slG9'));

});

parcelRegister("7dw0Q", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("43lkL").then(()=>parcelRequire('gjhTq'));

});

parcelRegister("eDKB8", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("43lkL").then(()=>parcelRequire('l0wdU'));

});

parcelRegister("5SK4h", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iGj6U").then(()=>parcelRequire('dRvqw'));

});

parcelRegister("e9tfD", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("ewhfv").then(()=>parcelRequire('9d5OX'));

});

parcelRegister("1ibWM", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gQ7JT").then(()=>parcelRequire('l8cRV'));

});

parcelRegister("97hnQ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iuUPX").then(()=>parcelRequire('5X1w8'));

});

parcelRegister("drGZp", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iuUPX").then(()=>parcelRequire('kLJGB'));

});

parcelRegister("h5U2C", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("12h7x")
]).then(()=>parcelRequire('gQDnO'));

});

parcelRegister("koda3", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gQ7JT").then(()=>parcelRequire('8T59R'));

});

parcelRegister("h3R2B", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("25yRO").then(()=>parcelRequire('3PPyG'));

});

parcelRegister("id0BC", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4csLu").then(()=>parcelRequire('29irv'));

});

parcelRegister("gvKVh", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iuUPX").then(()=>parcelRequire('6uJ2c'));

});

parcelRegister("lITsv", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6YZP2").then(()=>parcelRequire('11erB'));

});

parcelRegister("dY63n", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8Zg4U").then(()=>parcelRequire('lQBP5'));

});

parcelRegister("hoyQq", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("43lkL").then(()=>parcelRequire('h8jEY'));

});

parcelRegister("5B4Fk", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6YZP2").then(()=>parcelRequire('2d0pq'));

});

parcelRegister("jvXO5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6YZP2").then(()=>parcelRequire('AbHno'));

});

parcelRegister("f8lyW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6YZP2").then(()=>parcelRequire('fIxue'));

});

parcelRegister("dCpPA", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6YZP2").then(()=>parcelRequire('92dzO'));

});

parcelRegister("9nP7X", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gQ7JT").then(()=>parcelRequire('cF1HM'));

});

parcelRegister("XnU7s", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fP7eR").then(()=>parcelRequire('3ywlL'));

});

parcelRegister("hgibD", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8Zg4U").then(()=>parcelRequire('dMRBw'));

});

parcelRegister("fi91r", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("9FkCP")
]).then(()=>parcelRequire('9CSHE'));

});

parcelRegister("2FW77", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4csLu").then(()=>parcelRequire('7SAGf'));

});

parcelRegister("c902I", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("j6sDm").then(()=>parcelRequire('gDdcv'));

});

parcelRegister("kDSyb", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4tQLd").then(()=>parcelRequire('5EtxQ'));

});



parcelRegister("3yjSR", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $7dce39c1a1830d4b$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $7dce39c1a1830d4b$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $7dce39c1a1830d4b$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $7dce39c1a1830d4b$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $7dce39c1a1830d4b$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $7dce39c1a1830d4b$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $7dce39c1a1830d4b$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $7dce39c1a1830d4b$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $7dce39c1a1830d4b$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $7dce39c1a1830d4b$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $7dce39c1a1830d4b$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $7dce39c1a1830d4b$export$31deaeaebce525bb);

var $2W5OM = parcelRequire("2W5OM");
const $7dce39c1a1830d4b$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $7dce39c1a1830d4b$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $7dce39c1a1830d4b$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $7dce39c1a1830d4b$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $7dce39c1a1830d4b$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $7dce39c1a1830d4b$export$37073d560ecebada = 'atl-testing-consents';
const $7dce39c1a1830d4b$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $7dce39c1a1830d4b$export$b28b5d760fe14a21 = {
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $2W5OM.PreferenceCategory).Functional]: true,
    [(0, $2W5OM.PreferenceCategory).Marketing]: true,
    [(0, $2W5OM.PreferenceCategory).Analytics]: true,
    [(0, $2W5OM.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $7dce39c1a1830d4b$export$4a12f9e99971760a = {
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $2W5OM.PreferenceCategory).Functional]: false,
    [(0, $2W5OM.PreferenceCategory).Marketing]: false,
    [(0, $2W5OM.PreferenceCategory).Analytics]: false,
    [(0, $2W5OM.PreferenceCategory).Unknown]: false
};
const $7dce39c1a1830d4b$export$f0fd1d13ec1d48f2 = {
    ...$7dce39c1a1830d4b$export$4a12f9e99971760a,
    [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $7dce39c1a1830d4b$export$f95182b7aa141c57 = '001';
const $7dce39c1a1830d4b$export$1f25427b34f9c405 = '002';
const $7dce39c1a1830d4b$export$31deaeaebce525bb = '003';

});

parcelRegister("hFmCB", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $2dfafd1edeed1471$export$b43e45590305ffaa);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
const $2dfafd1edeed1471$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, $6yOvq.default).remove(key, attributes);
    else try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $6yOvq.default).remove(key, attributes);
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});

parcelRegister("dbJ6U", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $185be24be28f778f$export$4be65e66cfa2648a);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
function $185be24be28f778f$export$4be65e66cfa2648a(key) {
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, $6yOvq.default).get(key) : (0, $6yOvq.default).get();
    try {
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, $6yOvq.default).get(key) : (0, $6yOvq.default).get();
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("6t0zJ", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", () => $6c9ad8f22389201e$export$7bb3e177c1a1e841);

var $jeHvL = parcelRequire("jeHvL");

var $3yjSR = parcelRequire("3yjSR");

var $2W5OM = parcelRequire("2W5OM");

var $97upc = parcelRequire("97upc");

var $jlHNc = parcelRequire("jlHNc");

var $hJye1 = parcelRequire("hJye1");
const $6c9ad8f22389201e$var$emptyDisplayedTextMap = {
    [(0, $2W5OM.PreferenceCategory).Analytics]: '',
    [(0, $2W5OM.PreferenceCategory).Functional]: '',
    [(0, $2W5OM.PreferenceCategory).Marketing]: '',
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $2W5OM.PreferenceCategory).Unknown]: ''
};
async function $6c9ad8f22389201e$export$7bb3e177c1a1e841(preferences, displayedTextMap = $6c9ad8f22389201e$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $hJye1.packUserPreferences)(preferences);
        (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $97upc.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("97upc", function(module, exports) {
$parcel$export(module.exports, "setConsentToken", () => $dc55a943bed32c59$export$fbf549fe6f0e91dc);

var $bEUFb = parcelRequire("bEUFb");

var $37e9E = parcelRequire("37e9E");

var $9e4p2 = parcelRequire("9e4p2");

var $2W5OM = parcelRequire("2W5OM");

var $3za5i = parcelRequire("3za5i");

var $hJye1 = parcelRequire("hJye1");

var $6IUqE = parcelRequire("6IUqE");
const $dc55a943bed32c59$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $hJye1.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $9e4p2.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $6IUqE.onlySetFallbackIfDifferent)(consentToken);
    else (0, $3za5i.setConsentTokenFallbackCookie)(consentToken);
    (0, $3za5i.setConsentTokenCookie)(consentToken);
    (0, $3za5i.setShouldShowBannerCookie)(consentToken);
};
const $dc55a943bed32c59$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $9e4p2.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $9e4p2.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $hJye1.packUserPreferences)({
        ...mergedPrefs,
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible // Indicates we were unable to hit ConsentHub when the consents were created
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $bEUFb.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $6IUqE.onlySetFallbackIfDifferent)(consentToken);
        (0, $3za5i.setConsentTokenCookie)(consentToken);
        (0, $3za5i.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $bEUFb.Logger).error('Token failed to save');
    (0, $6IUqE.onlySetFallbackIfDifferent)(consentToken);
    (0, $3za5i.setShouldShowBannerCookie)(consentToken);
};
const $dc55a943bed32c59$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $6IUqE.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $37e9E.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $dc55a943bed32c59$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $dc55a943bed32c59$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("37e9E", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $62248c49724835b7$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $62248c49724835b7$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $62248c49724835b7$export$f8422650c3dec8b2);

var $2aEiL = parcelRequire("2aEiL");

var $bEUFb = parcelRequire("bEUFb");

var $9e4p2 = parcelRequire("9e4p2");
const $62248c49724835b7$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $62248c49724835b7$var$POST_CONSENTS_URL = `${$62248c49724835b7$var$BASE_CONSENTS_URL}/user`;
const $62248c49724835b7$var$GET_CONSENTS_URL = `${$62248c49724835b7$var$POST_CONSENTS_URL}/consents/cookies`;
const $62248c49724835b7$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        ...(0, $2aEiL.fg)('platform_bsc_consent_hub_x_origin') ? {
            'X-Request-Origin': 'bsc'
        } : {}
    });
const $62248c49724835b7$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $9e4p2.serializeConsents)(consentData);
        const consentTimestamp = (0, $9e4p2.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $9e4p2.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $62248c49724835b7$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$62248c49724835b7$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $62248c49724835b7$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $62248c49724835b7$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $62248c49724835b7$export$bd9f5bcbf9cd947c();
    }
};
const $62248c49724835b7$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $9e4p2.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $62248c49724835b7$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$62248c49724835b7$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $62248c49724835b7$var$getConsentHubHeaders(),
            body: $62248c49724835b7$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $9e4p2.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});
parcelRegister("9e4p2", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $7e84a4a6a15a5d61$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $7e84a4a6a15a5d61$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $7e84a4a6a15a5d61$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $7e84a4a6a15a5d61$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $7e84a4a6a15a5d61$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $7e84a4a6a15a5d61$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $7e84a4a6a15a5d61$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a);

var $ihZsR = parcelRequire("ihZsR");

var $3yjSR = parcelRequire("3yjSR");

var $dbJ6U = parcelRequire("dbJ6U");

var $2W5OM = parcelRequire("2W5OM");

var $iyNrT = parcelRequire("iyNrT");
const $7e84a4a6a15a5d61$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $3yjSR.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $7e84a4a6a15a5d61$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $3yjSR.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $7e84a4a6a15a5d61$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($7e84a4a6a15a5d61$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $7e84a4a6a15a5d61$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $7e84a4a6a15a5d61$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $7e84a4a6a15a5d61$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $7e84a4a6a15a5d61$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $ihZsR.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $7e84a4a6a15a5d61$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $3yjSR.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $2W5OM.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $ihZsR.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $ihZsR.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $ihZsR.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $7e84a4a6a15a5d61$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $ihZsR.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $iyNrT.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $7e84a4a6a15a5d61$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $7e84a4a6a15a5d61$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $7e84a4a6a15a5d61$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $7e84a4a6a15a5d61$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $7e84a4a6a15a5d61$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $2W5OM.PreferenceCategory).StrictlyNecessary,
        (0, $2W5OM.PreferenceCategory).Functional,
        (0, $2W5OM.PreferenceCategory).Analytics,
        (0, $2W5OM.PreferenceCategory).Marketing,
        (0, $2W5OM.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: (0, $iyNrT.ConsentHubKey).StrictlyNecessary,
        [(0, $2W5OM.PreferenceCategory).Functional]: (0, $iyNrT.ConsentHubKey).Functional,
        [(0, $2W5OM.PreferenceCategory).Analytics]: (0, $iyNrT.ConsentHubKey).Analytics,
        [(0, $2W5OM.PreferenceCategory).Marketing]: (0, $iyNrT.ConsentHubKey).Marketing,
        [(0, $2W5OM.PreferenceCategory).Unknown]: (0, $iyNrT.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $7e84a4a6a15a5d61$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $7e84a4a6a15a5d61$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $7e84a4a6a15a5d61$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $7e84a4a6a15a5d61$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7e84a4a6a15a5d61$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("ihZsR", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $eeb94047a7db081a$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $eeb94047a7db081a$export$27647458f3cf29d2);
const $eeb94047a7db081a$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $eeb94047a7db081a$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("iyNrT", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $790c381024427f82$export$31140359b1e505cf);
var $790c381024427f82$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});



parcelRegister("3za5i", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $7d000fce1a5acd38$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $7d000fce1a5acd38$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $7d000fce1a5acd38$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $7d000fce1a5acd38$export$b3365240280cb3c3);

var $2aEiL = parcelRequire("2aEiL");

var $ihZsR = parcelRequire("ihZsR");
var $bEUFb = parcelRequire("bEUFb");

var $3yjSR = parcelRequire("3yjSR");

var $il7mV = parcelRequire("il7mV");

var $jlHNc = parcelRequire("jlHNc");
const $7d000fce1a5acd38$var$LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES = 10;
const $7d000fce1a5acd38$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $7d000fce1a5acd38$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $7d000fce1a5acd38$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($7d000fce1a5acd38$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $7d000fce1a5acd38$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $7d000fce1a5acd38$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $7d000fce1a5acd38$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $7d000fce1a5acd38$export$6e0b780517c88191();
const $7d000fce1a5acd38$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    const lifetimeInMinutes = (0, $2aEiL.fg)('platform_bsc_cookie_lifetime') ? $7d000fce1a5acd38$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES : $7d000fce1a5acd38$var$LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES;
    expiryDate.setTime(expiryDate.getTime() + lifetimeInMinutes * 60000);
    return expiryDate;
};
const $7d000fce1a5acd38$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: $7d000fce1a5acd38$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $bEUFb.Logger).debug(`Set Consent Token ${(0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $7d000fce1a5acd38$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $bEUFb.Logger).debug(`set fallback consent token: ${(0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $7d000fce1a5acd38$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $il7mV.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $ihZsR.getBitValueFromBool)(!!bannerVisibility);
    (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: $7d000fce1a5acd38$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $bEUFb.Logger).debug(`set shouldShowBannerCookie: ${(0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $7d000fce1a5acd38$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $7d000fce1a5acd38$export$8e560d0760f733a2(consentToken);
    $7d000fce1a5acd38$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("il7mV", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $530e0d9245369756$export$bfdb9f82a9194c1e);

var $6yOvq = parcelRequire("6yOvq");

var $dS1lP = parcelRequire("dS1lP");

var $ihZsR = parcelRequire("ihZsR");

var $3yjSR = parcelRequire("3yjSR");

var $9e4p2 = parcelRequire("9e4p2");

var $dbJ6U = parcelRequire("dbJ6U");

var $hJye1 = parcelRequire("hJye1");
const $530e0d9245369756$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $hJye1.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $530e0d9245369756$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $ihZsR.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $9e4p2.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $9e4p2.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $530e0d9245369756$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $9e4p2.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $530e0d9245369756$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $ihZsR.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $9e4p2.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $530e0d9245369756$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $9e4p2.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $530e0d9245369756$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $9e4p2.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $530e0d9245369756$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, $6yOvq.default).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions?.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $dS1lP.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $530e0d9245369756$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $ihZsR.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $530e0d9245369756$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $530e0d9245369756$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("hJye1", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $e32595370751d489$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $e32595370751d489$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $e32595370751d489$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initializePreferencesData", () => $e32595370751d489$export$7962405c3ca274b1);

var $jeHvL = parcelRequire("jeHvL");

var $ihZsR = parcelRequire("ihZsR");

var $3yjSR = parcelRequire("3yjSR");

var $9e4p2 = parcelRequire("9e4p2");

var $2W5OM = parcelRequire("2W5OM");
const $e32595370751d489$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $3yjSR.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $3yjSR.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $3yjSR.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $3yjSR.V001_SCHEMA_KEY),
        (0, $3yjSR.V002_SCHEMA_KEY),
        (0, $3yjSR.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $e32595370751d489$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $3yjSR.V001_SCHEMA_KEY);
    return [
        version,
        (0, $ihZsR.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $ihZsR.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $ihZsR.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $ihZsR.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $e32595370751d489$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $2W5OM.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $2W5OM.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $2W5OM.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $2W5OM.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $e32595370751d489$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $2W5OM.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Functional]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Analytics]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Marketing]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Unknown]),
        (0, $ihZsR.getBitValueFromBool)(isDefaultConsentBit),
        (0, $ihZsR.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $ihZsR.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $e32595370751d489$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $9e4p2.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$e32595370751d489$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $e32595370751d489$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $3yjSR.V003_SCHEMA_KEY);
    return [
        version,
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Functional]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Analytics]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Marketing]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.PreferenceCategory).Unknown]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $ihZsR.getBitValueFromBool)(userPreferences[(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $e32595370751d489$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $2W5OM.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $2W5OM.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $2W5OM.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $2W5OM.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $e32595370751d489$var$V002SpecificBitKeys = [
    (0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $2W5OM.ConsentPreferenceV2).ConsentedUnderFADP
];
const $e32595370751d489$var$V003SpecificBitKeys = [
    (0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault,
    (0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated,
    (0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable
];
function $e32595370751d489$export$3199823fec979bd1(userPreferences) {
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) return $e32595370751d489$var$packPrefsVersion001(userPreferences);
    const isV002 = $e32595370751d489$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $e32595370751d489$var$packPrefsVersion002(userPreferences);
    const isV003 = $e32595370751d489$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $e32595370751d489$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $e32595370751d489$var$packPrefsVersion001(userPreferences);
}
function $e32595370751d489$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $3yjSR.V001_SCHEMA_KEY)) return $e32595370751d489$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $e32595370751d489$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $e32595370751d489$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $e32595370751d489$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $e32595370751d489$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $e32595370751d489$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $e32595370751d489$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $2W5OM.PrefetchedPreferenceState).INTERNAL) {
        if ($e32595370751d489$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $e32595370751d489$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $9e4p2.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $e32595370751d489$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $2W5OM.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("jlHNc", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $30eaf03d4efae8df$export$93509ff9a62ee022);

var $6yOvq = parcelRequire("6yOvq");

var $2aEiL = parcelRequire("2aEiL");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $bEUFb = parcelRequire("bEUFb");
const $30eaf03d4efae8df$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, $6yOvq.default).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $jeHvL.getBscGlobalState)().hasInitialized && (0, $2aEiL.fg)('platform_bsc_initialize_controls_analytics')) (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $7WT4C.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, $6yOvq.default).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $bEUFb.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("6IUqE", function(module, exports) {
$parcel$export(module.exports, "mergeConsentUpdates", () => $9969f6229a98cbaa$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $9969f6229a98cbaa$export$a023a0b818522757);

var $3yjSR = parcelRequire("3yjSR");

var $2W5OM = parcelRequire("2W5OM");

var $dbJ6U = parcelRequire("dbJ6U");

var $3za5i = parcelRequire("3za5i");

var $hJye1 = parcelRequire("hJye1");
const $9969f6229a98cbaa$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $2W5OM.PreferenceCategory).StrictlyNecessary],
        [(0, $2W5OM.PreferenceCategory).Functional]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Functional],
        [(0, $2W5OM.PreferenceCategory).Analytics]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Analytics],
        [(0, $2W5OM.PreferenceCategory).Marketing]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Marketing],
        [(0, $2W5OM.PreferenceCategory).Unknown]: updatedPreferences[(0, $2W5OM.PreferenceCategory).Unknown]
    };
};
const $9969f6229a98cbaa$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences?.[(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!consentPreferences?.[(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable];
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!consentPreferences?.[(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault];
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $2W5OM.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $2W5OM.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $2W5OM.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $9969f6229a98cbaa$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $hJye1.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $3yjSR.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$9969f6229a98cbaa$var$pruneLegacyProperties(updatedPreferences),
            ...$9969f6229a98cbaa$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $3yjSR.DEFAULT_PREFERENCES),
            ...$9969f6229a98cbaa$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $3yjSR.DEFAULT_PREFERENCES),
        ...$9969f6229a98cbaa$var$pruneLegacyProperties(updatedPreferences),
        ...$9969f6229a98cbaa$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $9969f6229a98cbaa$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $3za5i.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("eEjwS", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $3b34077852b8f32d$export$a7357cdd1f0b0168);

var $75IaS = parcelRequire("75IaS");
const $3b34077852b8f32d$export$a7357cdd1f0b0168 = (0, $75IaS.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    useCookiesDescriptionNoLink: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text.no.link',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("1H4sW", function(module, exports) {
$parcel$export(module.exports, "PreferenceModal", () => $bbe9d9ffb1100a9a$export$94c5684831c222e7);

var $1v5pe = parcelRequire("1v5pe");

var $bHcZt = parcelRequire("bHcZt");

var $2aEiL = parcelRequire("2aEiL");

var $7WT4C = parcelRequire("7WT4C");

var $7N5mY = parcelRequire("7N5mY");

var $bEUFb = parcelRequire("bEUFb");

var $3yjSR = parcelRequire("3yjSR");

var $6t0zJ = parcelRequire("6t0zJ");

var $3KitZ = parcelRequire("3KitZ");

var $9jI7c = parcelRequire("9jI7c");
const $bbe9d9ffb1100a9a$export$94c5684831c222e7 = (props)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $2aEiL.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($bbe9d9ffb1100a9a$export$30df3cfccbe10e6e, props);
};
const $bbe9d9ffb1100a9a$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $1v5pe.useState)(true);
    const isEventSent = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $7WT4C.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $9jI7c.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $3yjSR.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $1v5pe.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $7WT4C.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $6t0zJ.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $7WT4C.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag?.();
            } catch (e) {
                (0, $bEUFb.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag?.();
            }
            setIsModalOpen(false);
            onSubmit?.();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag?.();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $3KitZ.PresentationalPreferenceModal), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $3yjSR.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, shouldAddWrappers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bHcZt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $7N5mY.BSCIntlProvider), null, modalContent)) : modalContent);
};

});
parcelRegister("3KitZ", function(module, exports) {
$parcel$export(module.exports, "PresentationalPreferenceModal", () => $1fdd8efae9e052a3$export$9921ee7829a3ba4);

var $1v5pe = parcelRequire("1v5pe");

var $b2Az1 = parcelRequire("b2Az1");
var $kK7WO = parcelRequire("kK7WO");

var $bcdfp = parcelRequire("bcdfp");

var $c25AW = parcelRequire("c25AW");

var $ayBRL = parcelRequire("ayBRL");

var $cOGx6 = parcelRequire("cOGx6");
var $2rArt = parcelRequire("2rArt");
var $kYkRP = parcelRequire("kYkRP");
var $epvFM = parcelRequire("epvFM");
var $8O99O = parcelRequire("8O99O");
var $bCJu2 = parcelRequire("bCJu2");

var $2aEiL = parcelRequire("2aEiL");

var $hpF1c = parcelRequire("hpF1c");
var $eMSEP = parcelRequire("eMSEP");
var $iOq8l = parcelRequire("iOq8l");
var $fRfXo = parcelRequire("fRfXo");
var $bQOrV = parcelRequire("bQOrV");

var $7WT4C = parcelRequire("7WT4C");

var $28KCa = parcelRequire("28KCa");

var $2W5OM = parcelRequire("2W5OM");

var $6Yrr4 = parcelRequire("6Yrr4");

var $1RtbY = parcelRequire("1RtbY");
const $1fdd8efae9e052a3$var$categoryNameStyles = (0, $bQOrV.xcss)({
    fontWeight: 'font.weight.bold'
});
const $1fdd8efae9e052a3$var$customHeaderStyles = (0, $bQOrV.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $1fdd8efae9e052a3$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($1fdd8efae9e052a3$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).isValidElement(node)) {
        if (node.props.children) return $1fdd8efae9e052a3$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $1fdd8efae9e052a3$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $1RtbY.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $1RtbY.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $2aEiL.fg)('product-terminology-refresh') ? (0, $1RtbY.i18n).strictDescriptionAppify : (0, $1RtbY.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $1fdd8efae9e052a3$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $1fdd8efae9e052a3$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $2W5OM.PreferenceCategory).Functional,
            title: (0, $1RtbY.i18n).functionalOption,
            description: (0, $1RtbY.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $2W5OM.PreferenceCategory).Analytics,
            title: (0, $1RtbY.i18n).analyticalOption,
            description: (0, $2aEiL.fg)('product-terminology-refresh') ? (0, $1RtbY.i18n).analyticalOptionDescriptionAppify : (0, $1RtbY.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $2W5OM.PreferenceCategory).Marketing,
            title: (0, $1RtbY.i18n).marketingOption,
            description: (0, $1RtbY.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $28KCa.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $1fdd8efae9e052a3$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
                xcss: $1fdd8efae9e052a3$var$categoryNameStyles
            }, translatedTitle),
            descriptionElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), null, translatedDescription),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $1fdd8efae9e052a3$var$noop = ()=>{};
const $1fdd8efae9e052a3$var$CustomHeader = ({ onClose: onClose })=>{
    const { titleId: titleId } = (0, $bCJu2.useModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $1fdd8efae9e052a3$var$customHeaderStyles,
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cOGx6.CloseButton), {
        onClick: onClose,
        testId: "close-modal-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $ayBRL.default), {
        as: "h1",
        size: "medium",
        id: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1RtbY.i18n).title)));
};
const $1fdd8efae9e052a3$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $1fdd8efae9e052a3$var$noop, onSubmit: onSubmit = $1fdd8efae9e052a3$var$noop, onClose: onClose = $1fdd8efae9e052a3$var$noop, setIsOpen: setIsOpen = $1fdd8efae9e052a3$var$noop })=>{
    const intl = (0, $kK7WO.default)();
    const onCloseModal = (0, $1v5pe.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $1v5pe.useCallback)(()=>{
        onCloseModal();
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $1v5pe.useCallback)(()=>{
        onCloseModal();
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $1v5pe.useCallback)(()=>{
        onCloseModal();
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $1v5pe.useCallback)(()=>{
        (0, $7WT4C.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $1v5pe.useMemo)(()=>{
        return $1fdd8efae9e052a3$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $1v5pe.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $8O99O.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2rArt.default), {
        onClose: onClickBackground
    }, (0, $2aEiL.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $c25AW.default), {
        onSubmit: handleSubmission
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($1fdd8efae9e052a3$var$CustomHeader, {
        onClose: onClickClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kYkRP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        ...(0, $1RtbY.i18n).summaryDescription,
        values: {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.default), {
                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1RtbY.i18n).trackingLink))
        },
        tagName: 'p'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        ...(0, $2aEiL.fg)('product-terminology-refresh') ? (0, $1RtbY.i18n).strictDescriptionAppify : (0, $1RtbY.i18n).strictDescription,
        values: {
            bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fRfXo.default), {
                    weight: "bold"
                }, msg)
        },
        tagName: 'p'
    })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6Yrr4.CookieCategorySection), {
            category: category,
            titleElement: titleElement,
            titleString: titleString,
            descriptionElement: description,
            isChecked: (preferences && preferences[category]) ?? false,
            setPreferencesData: setPreferencesData
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $epvFM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bcdfp.default), {
        appearance: "subtle",
        onClick: onClickCancel,
        testId: "consent-preference-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1RtbY.i18n).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bcdfp.default), {
        type: "submit",
        appearance: "primary",
        onClick: handleSubmission,
        testId: "consent-preference-confirm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1RtbY.i18n).confirmBtn)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $c25AW.default), {
        onSubmit: handleSubmission
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($1fdd8efae9e052a3$var$CustomHeader, {
            onClose: onClickClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kYkRP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
            ...(0, $1RtbY.i18n).summaryDescription,
            values: {
                link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.default), {
                    href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                    target: "_blank",
                    onClick: onClickTrackingNoticeLink
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1RtbY.i18n).trackingLink))
            },
            tagName: 'p'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
            ...(0, $2aEiL.fg)('product-terminology-refresh') ? (0, $1RtbY.i18n).strictDescriptionAppify : (0, $1RtbY.i18n).strictDescription,
            values: {
                bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fRfXo.default), {
                        weight: "bold"
                    }, msg)
            },
            tagName: 'p'
        })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iOq8l.default), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6Yrr4.CookieCategorySection), {
                category: category,
                titleElement: titleElement,
                titleString: titleString,
                descriptionElement: description,
                isChecked: (preferences && preferences[category]) ?? false,
                setPreferencesData: setPreferencesData
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $epvFM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bcdfp.default), {
            appearance: "subtle",
            onClick: onClickCancel,
            testId: "consent-preference-cancel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1RtbY.i18n).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bcdfp.default), {
            type: "submit",
            appearance: "primary",
            onClick: handleSubmission,
            testId: "consent-preference-confirm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $1RtbY.i18n).confirmBtn)))))));
};

});
parcelRegister("cOGx6", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $b20a8251098e354e$export$de65de8213222d10);

var $1v5pe = parcelRequire("1v5pe");

var $hHzJx = parcelRequire("hHzJx");

var $ebDRY = parcelRequire("ebDRY");
const $b20a8251098e354e$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hHzJx.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebDRY))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });

});
parcelRegister("hHzJx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a449b98196b2c781$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $fl4ll = parcelRequire("fl4ll");

var $1Tz0w = parcelRequire("1Tz0w");

var $kFr83 = parcelRequire("kFr83");

var $1895S = parcelRequire("1895S");

var $1TZ74 = parcelRequire("1TZ74");

var $lreqQ = parcelRequire("lreqQ");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $a449b98196b2c781$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1895S.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1TZ74.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $lreqQ.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kFr83.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1Tz0w.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1895S.default), {
            ...saferRest,
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: (e, analyticsEvent)=>{
                onClick?.(e, analyticsEvent);
                triggerProps.onClick?.(e);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                saferRest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                saferRest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                saferRest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                saferRest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                saferRest.onBlur?.(e);
            },
            ref: (0, $fl4ll.default)([
                ref,
                triggerProps?.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1TZ74.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $lreqQ.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kFr83.default), null, label))));
}));
$a449b98196b2c781$var$IconButton.displayName = 'IconButton';
var $a449b98196b2c781$export$2e2bcd8739ae039 = $a449b98196b2c781$var$IconButton;

});

parcelRegister("ebDRY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdf99897c5696ca9ecbe3cd832bc46f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a541050e0dc5b1ad$var$_react = $a541050e0dc5b1ad$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $a541050e0dc5b1ad$var$_baseNew = $a541050e0dc5b1ad$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $a541050e0dc5b1ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a541050e0dc5b1ad$var$CrossIcon = (props)=>/*#__PURE__*/ $a541050e0dc5b1ad$var$_react.default.createElement($a541050e0dc5b1ad$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$a541050e0dc5b1ad$var$CrossIcon.displayName = 'CrossIcon';
var $a541050e0dc5b1ad$var$_default = module.exports.default = $a541050e0dc5b1ad$var$CrossIcon;

});


parcelRegister("2rArt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca3762ffc2207830$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hRF0p = parcelRequire("hRF0p");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $ca3762ffc2207830$var$ModalWrapper = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hRF0p.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$ca3762ffc2207830$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ca3762ffc2207830$export$2e2bcd8739ae039 = $ca3762ffc2207830$var$ModalWrapper;

});
parcelRegister("hRF0p", function(module, exports) {
$parcel$export(module.exports, "default", () => $70ef7ffe6f4f9558$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $4r5TA = parcelRequire("4r5TA");

var $ccDPm = parcelRequire("ccDPm");

var $j9QYE = parcelRequire("j9QYE");

var $6pgJk = parcelRequire("6pgJk");

var $aD9yk = parcelRequire("aD9yk");

var $Ms2ib = parcelRequire("Ms2ib");

var $lHxwq = parcelRequire("lHxwq");

var $azfBr = parcelRequire("azfBr");

var $fsl6p = parcelRequire("fsl6p");

var $eTbg2 = parcelRequire("eTbg2");

var $7dKqR = parcelRequire("7dKqR");

var $etMwD = parcelRequire("etMwD");

var $2aEiL = parcelRequire("2aEiL");

var $kARP4 = parcelRequire("kARP4");
parcelRequire("9kZyw");
var $jySDc = parcelRequire("jySDc");

var $iMM0r = parcelRequire("iMM0r");

var $h4l9f = parcelRequire("h4l9f");
var $gUI7t = parcelRequire("gUI7t");

var $3Lr6X = parcelRequire("3Lr6X");

var $eSj0I = parcelRequire("eSj0I");

var $3nXae = parcelRequire("3nXae");

var $5ogzQ = parcelRequire("5ogzQ");

var $9o1SS = parcelRequire("9o1SS");

var $94IQO = parcelRequire("94IQO");

var $11R2l = parcelRequire("11R2l");

var $1LjAb = parcelRequire("1LjAb");

var $7Skuo = parcelRequire("7Skuo");

var $401cB = parcelRequire("401cB");

var $5BrkL = parcelRequire("5BrkL");
const $70ef7ffe6f4f9558$var$fillScreenStyles = null;
// Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $70ef7ffe6f4f9558$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $70ef7ffe6f4f9558$var$topLayerStyles = {
    content: "_1e0c1txw _4t3i1osq _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _zg7p130s",
    borderRadius: "_epkxfajl",
    borderRadiusT26: "_epkxpb1k"
};
// Scroll-mode styles for the content div.
// Height overrides use ID-scoped <style> (see dialogPositionStyles) because
// Compiled atomic classes have specificity (0,1,0) (increaseSpecificity is disabled).
// The doubled-ID selector (#id#id > div) at (2,0,1) reliably wins.
// Only non-height properties needing the && boost remain here.
const $70ef7ffe6f4f9558$var$topLayerBodyScrollStyles = null;
const $70ef7ffe6f4f9558$var$topLayerViewportScrollStyles = null;
const $70ef7ffe6f4f9558$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (Boolean(document.querySelector('.aui-blanket:not([hidden])'))) return false;
    // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
// Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $70ef7ffe6f4f9558$var$useModalCloseHandler(providedOnClose) {
    return (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $aD9yk.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
}
/**
 * Top-layer rendering path (platform-dst-top-layer).
 *
 * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
 * management with native <dialog> via @atlaskit/top-layer/dialog.
 *
 * Key decisions:
 * - Animation: CSS transitions via @starting-style / allow-discrete.
 * - Close gating: onDialogClose only forwards allowed reasons
 *   (see notes/guides/dialog-close-flow.md).
 * - onClose event param: undefined - consumers should use close reason.
 * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
 *   returnFocus (see accessibility-criteria.md).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * top-layer path, so it never shares a hook sequence with the legacy path.
 */ function $70ef7ffe6f4f9558$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $aD9yk.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen } = props;
    const calculatedStackIndex = (0, $3nXae.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const onCloseHandler = $70ef7ffe6f4f9558$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $7dKqR.useExitingPersistence)();
    // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $lHxwq.useId)();
    const titleId = `modal-dialog-title-${id}`;
    // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $1v5pe.useRef)(null);
    // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $1v5pe.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
    // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $1v5pe.useRef)(null);
    const modalDialogContext = (0, $1v5pe.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        providedOnClose,
        isFullScreen
    ]);
    // Only forward close when the reason is allowed by props.
    // Passes a synthetic event to satisfy the KeyboardOrMouseEvent contract.
    const onDialogClose = (0, $1v5pe.useCallback)(({ reason: reason })=>{
        if (reason === 'escape' && shouldCloseOnEscapePress) onCloseHandler((0, $h4l9f.createCloseEvent)({
            reason: reason
        }));
        if (reason === 'overlay-click' && shouldCloseOnOverlayClick) onCloseHandler((0, $h4l9f.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler,
        shouldCloseOnEscapePress,
        shouldCloseOnOverlayClick
    ]);
    // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $1v5pe.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish?.();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    // Fire onOpenComplete after mount.
    (0, $1v5pe.useEffect)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $1v5pe.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $1v5pe.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []);
    // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $Ms2ib.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object');
    // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $1v5pe.useEffect)(()=>{
        return (0, $jySDc.combine)((0, $9o1SS.disableDraggingToCrossOriginIFramesForElement)(), (0, $11R2l.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $94IQO.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    // Responsive layout via ID-scoped <style> (same pattern as Dialog's hideBackdrop).
    // ID selector beats Compiled atomic classes without !important and supports @media.
    const namedWidth = (0, $401cB.dialogWidth)(width ?? 'medium');
    const dialogId = `modal-dialog-${id}`;
    const escapedDialogId = CSS.escape(dialogId);
    // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    const resolvedWidth = namedWidth.endsWith('%') ? `calc(${parseFloat(namedWidth)} * (100vw - 120px) / 100)` : namedWidth;
    const dialogStyle = isFullScreen ? {
        width: '100vw',
        height: '100vh',
        margin: '0'
    } : {
        width: `min(${resolvedWidth}, 100vw)`
    };
    // Shift stacked background modals down by space.100 (8px) per level.
    if (stackIndex > 0) dialogStyle['transform'] = `translateY(calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"}))`;
    // Mobile: viewport fill. Desktop (≥ 30rem): gutter margins, auto height.
    // Content-div height set via #id > div to beat Compiled's atomic specificity.
    const desktopMargin = shouldScrollInViewport ? '60px auto' : '60px auto auto';
    const resolvedHeight = (0, $7Skuo.dialogHeight)(height);
    // Body-scroll: specified height or auto. Viewport-scroll: uses min-height.
    const desktopContentHeight = shouldScrollInViewport ? 'auto' : resolvedHeight;
    const desktopContentMinHeight = shouldScrollInViewport ? resolvedHeight : 'auto';
    // Viewport-scroll: the legacy Positioner was a fixed 100vh container that
    // scrolled internally, so the modal section could fill (100vh - 60px top gutter).
    // In the top layer the <dialog> sizes to content with height:auto, so we need
    // an explicit min-height to ensure the dialog stretches to the same visible area.
    const desktopDialogMinHeight = shouldScrollInViewport ? 'min-height:calc(100vh - 60px);' : '';
    // Doubled-ID selector (#id#id > div) at specificity (2,0,1) beats
    // Compiled atomic classes at (0,1,0) (increaseSpecificity is disabled).
    const dialogPositionStyles = isFullScreen ? '' : // Mobile: edge-to-edge. Desktop (≥ 30rem): 60px gutters, max-width.
    `#${escapedDialogId}#${escapedDialogId}{margin:0;height:100vh}#${escapedDialogId}#${escapedDialogId}>div{height:100%}@media(min-width:30rem){#${escapedDialogId}#${escapedDialogId}{margin:${desktopMargin};height:auto;${desktopDialogMinHeight}max-width:calc(100vw - 120px)}#${escapedDialogId}#${escapedDialogId}>div{height:${desktopContentHeight};min-height:${desktopContentMinHeight}}}`;
    return /*#__PURE__*/ $1v5pe.createElement((0, $gUI7t.Dialog), {
        ref: dialogRef,
        id: dialogId,
        onClose: onDialogClose,
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        shouldHideBackdrop: stackIndex > 0 || Boolean(isBlanketHidden),
        ...label ? {
            label: label
        } : {
            labelledBy: titleId
        },
        testId: defaultTestId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dialogStyle
    }, /*#__PURE__*/ $1v5pe.createElement((0, $3Lr6X.DialogScrollLock), {
        isOpen: true
    }), dialogPositionStyles && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ $1v5pe.createElement("style", null, dialogPositionStyles), /*#__PURE__*/ $1v5pe.createElement("div", {
        ref: contentRef,
        className: (0, $hMvDh.default)([
            $70ef7ffe6f4f9558$var$topLayerStyles.content,
            !isFullScreen && $70ef7ffe6f4f9558$var$topLayerStyles.borderRadius,
            !isFullScreen && (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $70ef7ffe6f4f9558$var$topLayerStyles.borderRadiusT26,
            !isFullScreen && !shouldScrollInViewport && "_bolhzwhf",
            !isFullScreen && shouldScrollInViewport && "_1tke1kxc _c71lglyw"
        ])
    }, /*#__PURE__*/ $1v5pe.createElement((0, $eSj0I.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $1v5pe.createElement((0, $1LjAb.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, children))));
}
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $70ef7ffe6f4f9558$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $aD9yk.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $3nXae.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    // If no ref is provided, autofocus on first element
    const autoFocusLock = !(typeof autoFocus === 'object');
    const onCloseHandler = $70ef7ffe6f4f9558$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $1v5pe.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $1v5pe.useCallback)((element)=>$70ef7ffe6f4f9558$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $5ogzQ.default)();
    // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $aD9yk.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ $1v5pe.createElement((0, $6pgJk.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`
    }, /*#__PURE__*/ $1v5pe.createElement((0, $5BrkL.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen,
        UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
        ref: ref
    }, children));
    let returnFocus = true;
    let onDeactivation = (0, $aD9yk.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ $1v5pe.createElement((0, $azfBr.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $1v5pe.createElement((0, $kARP4.default), {
        zIndex: (0, $iMM0r.layers).modal()
    }, !UNSAFE_shouldDisableMotionUplift && (0, $2aEiL.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $1v5pe.createElement((0, $eTbg2.default), {
        enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }, /*#__PURE__*/ $1v5pe.createElement("div", {
        "aria-hidden": !isForeground,
        className: (0, $hMvDh.default)([
            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
        ])
    }, /*#__PURE__*/ $1v5pe.createElement((0, $4r5TA.default), {
        autoFocus: autoFocusLock,
        returnFocus: returnFocus,
        onDeactivation: onDeactivation,
        whiteList: allowListCallback
    }, /*#__PURE__*/ $1v5pe.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ccDPm))), null), shouldScrollInViewport ? /*#__PURE__*/ $1v5pe.createElement((0, $ccDPm.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket))) : /*#__PURE__*/ $1v5pe.createElement((0, $etMwD.default), null, (fadeInProps)=>/*#__PURE__*/ $1v5pe.createElement("div", {
            ...fadeInProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hMvDh.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }, /*#__PURE__*/ $1v5pe.createElement((0, $4r5TA.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $1v5pe.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ccDPm))), null), shouldScrollInViewport ? /*#__PURE__*/ $1v5pe.createElement((0, $ccDPm.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
});
// Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $70ef7ffe6f4f9558$var$InternalModalWrapper = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    if ((0, $2aEiL.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ $1v5pe.createElement($70ef7ffe6f4f9558$var$ModalWrapperTopLayer, props);
    return /*#__PURE__*/ $1v5pe.createElement($70ef7ffe6f4f9558$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70ef7ffe6f4f9558$export$2e2bcd8739ae039 = $70ef7ffe6f4f9558$var$InternalModalWrapper;

});
parcelRegister("4r5TA", function(module, exports) {
$parcel$export(module.exports, "default", () => $33ae41c83818243c$export$2e2bcd8739ae039);

var $86t7j = parcelRequire("86t7j");

var $33ae41c83818243c$export$2e2bcd8739ae039 = (0, $86t7j.default);

});
parcelRegister("86t7j", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e65784494cf7684$export$2e2bcd8739ae039);

var $3mdE8 = parcelRequire("3mdE8");

var $87uOn = parcelRequire("87uOn");

var $1v5pe = parcelRequire("1v5pe");

var $4OfHG = parcelRequire("4OfHG");

var $cey1i = parcelRequire("cey1i");
var $5e65784494cf7684$var$FocusLockCombination = /*#__PURE__*/ $1v5pe.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $1v5pe.createElement((0, $4OfHG.default), (0, $87uOn.default)({
        sideCar: (0, $cey1i.default),
        ref: ref
    }, props));
});
var $5e65784494cf7684$var$_ref = (0, $4OfHG.default).propTypes || {}, $5e65784494cf7684$var$sideCar = $5e65784494cf7684$var$_ref.sideCar, $5e65784494cf7684$var$propTypes = (0, $3mdE8.default)($5e65784494cf7684$var$_ref, [
    "sideCar"
]);
$5e65784494cf7684$var$FocusLockCombination.propTypes = {};
var $5e65784494cf7684$export$2e2bcd8739ae039 = $5e65784494cf7684$var$FocusLockCombination;

});
parcelRegister("3mdE8", function(module, exports) {
$parcel$export(module.exports, "default", () => $271e0311c2a8a765$export$2e2bcd8739ae039);
function $271e0311c2a8a765$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("4OfHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $380803570801efac$export$2e2bcd8739ae039);

var $87uOn = parcelRequire("87uOn");

var $1v5pe = parcelRequire("1v5pe");


var $kmUY7 = parcelRequire("kmUY7");

var $jxPGo = parcelRequire("jxPGo");

var $l3Z1u = parcelRequire("l3Z1u");

var $ahIvS = parcelRequire("ahIvS");

var $cIY8V = parcelRequire("cIY8V");
var $380803570801efac$var$emptyArray = [];
var $380803570801efac$var$FocusLock = /*#__PURE__*/ $1v5pe.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $1v5pe.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $1v5pe.useRef();
    var isActive = $1v5pe.useRef(false);
    var originalFocusedElement = $1v5pe.useRef(null);
    var _React$useState2 = $1v5pe.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $380803570801efac$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $1v5pe.useState({}), id = _React$useState3[0];
    var onActivation = $1v5pe.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $1v5pe.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $1v5pe.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $1v5pe.useCallback(function(event) {
        if (isActive.current) (0, $ahIvS.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $ahIvS.mediumBlur).useMedium;
    var setObserveNode = $1v5pe.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $87uOn.default)((_extends2 = {}, _extends2[$kmUY7.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$kmUY7.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $jxPGo.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $1v5pe.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $1v5pe.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $l3Z1u.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $1v5pe.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $l3Z1u.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $1v5pe.createElement(SideCar, {
        id: id,
        sideCar: (0, $ahIvS.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $1v5pe.createElement(Container, (0, $87uOn.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $1v5pe.createElement((0, $cIY8V.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $1v5pe.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $l3Z1u.hiddenGuard)
    }));
});
$380803570801efac$var$FocusLock.propTypes = {};
var $380803570801efac$export$2e2bcd8739ae039 = $380803570801efac$var$FocusLock;

});
parcelRegister("kmUY7", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $ed420d86be8f85e2$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $ed420d86be8f85e2$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $ed420d86be8f85e2$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $ed420d86be8f85e2$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $ed420d86be8f85e2$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $ed420d86be8f85e2$export$4f9a06cb7441a087 = 'data-focus-lock';
var $ed420d86be8f85e2$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $ed420d86be8f85e2$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $ed420d86be8f85e2$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $ed420d86be8f85e2$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("jxPGo", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $e3a93085e0ad49b5$export$74665b213cb5c4cf);

var $1v5pe = parcelRequire("1v5pe");

var $5sYpU = parcelRequire("5sYpU");

var $xSLU7 = parcelRequire("xSLU7");
var $e3a93085e0ad49b5$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $1v5pe.useLayoutEffect : $1v5pe.useEffect;
var $e3a93085e0ad49b5$var$currentValues = new WeakMap();
function $e3a93085e0ad49b5$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $xSLU7.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $5sYpU.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $e3a93085e0ad49b5$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $e3a93085e0ad49b5$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $5sYpU.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $5sYpU.assignRef)(ref, current_1);
            });
        }
        $e3a93085e0ad49b5$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("5sYpU", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $3fae6eca4f3f66bc$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $3fae6eca4f3f66bc$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("xSLU7", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $065d91b0b3cc0abd$export$25bec8c6f54ee79a);

var $1v5pe = parcelRequire("1v5pe");
function $065d91b0b3cc0abd$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $1v5pe.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("l3Z1u", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $f55936aed11027f3$export$b8c7b07253306600);

var $1v5pe = parcelRequire("1v5pe");

var $f55936aed11027f3$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $f55936aed11027f3$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $1v5pe.createElement($1v5pe.Fragment, null, /*#__PURE__*/ $1v5pe.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f55936aed11027f3$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $1v5pe.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f55936aed11027f3$export$b8c7b07253306600
    }));
};
$f55936aed11027f3$var$InFocusGuard.propTypes = {};
var $f55936aed11027f3$export$2e2bcd8739ae039 = $f55936aed11027f3$var$InFocusGuard;

});

parcelRegister("ahIvS", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $77ce054dbe1bfcfa$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $77ce054dbe1bfcfa$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $77ce054dbe1bfcfa$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $77ce054dbe1bfcfa$export$892cbf28e5518020);

var $laqft = parcelRequire("laqft");
var $77ce054dbe1bfcfa$export$5733e022b1d538cb = (0, $laqft.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $77ce054dbe1bfcfa$export$b3e9a9312f73723c = (0, $laqft.createMedium)();
var $77ce054dbe1bfcfa$export$3a1d52767cbc07b8 = (0, $laqft.createMedium)();
var $77ce054dbe1bfcfa$export$892cbf28e5518020 = (0, $laqft.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("laqft", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $f68ee48f68e39cb2$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $f68ee48f68e39cb2$export$e13ec7dd7a14088d);

var $lmviS = parcelRequire("lmviS");
function $f68ee48f68e39cb2$var$ItoI(a) {
    return a;
}
function $f68ee48f68e39cb2$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f68ee48f68e39cb2$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f68ee48f68e39cb2$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f68ee48f68e39cb2$var$ItoI;
    return $f68ee48f68e39cb2$var$innerCreateMedium(defaults, middleware);
}
function $f68ee48f68e39cb2$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f68ee48f68e39cb2$var$innerCreateMedium(null);
    medium.options = (0, $lmviS.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("cIY8V", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $94383f3e311e8147$export$f5272e9b1168239c);

var $1v5pe = parcelRequire("1v5pe");
var $94383f3e311e8147$export$f5272e9b1168239c = /*#__PURE__*/ (0, $1v5pe.createContext)(undefined);

});


parcelRegister("cey1i", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e812e808791c7e6$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");


var $lXRNa = parcelRequire("lXRNa");

var $dGPH2 = parcelRequire("dGPH2");
var $bZxBR = parcelRequire("bZxBR");
var $6lLiI = parcelRequire("6lLiI");
var $3vXZ0 = parcelRequire("3vXZ0");
var $iEzwC = parcelRequire("iEzwC");parcelRequire("94mkS");
var $l454t = parcelRequire("l454t");

var $aqTpV = parcelRequire("aqTpV");

var $ahIvS = parcelRequire("ahIvS");
var $8e812e808791c7e6$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $8e812e808791c7e6$var$isFreeFocus = function isFreeFocus() {
    return $8e812e808791c7e6$var$focusOnBody() || (0, $iEzwC.focusIsHidden)();
};
var $8e812e808791c7e6$var$lastActiveTrap = null;
var $8e812e808791c7e6$var$lastActiveFocus = null;
var $8e812e808791c7e6$var$lastPortaledElement = null;
var $8e812e808791c7e6$var$focusWasOutsideWindow = false;
var $8e812e808791c7e6$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $8e812e808791c7e6$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($8e812e808791c7e6$var$lastActiveTrap.whiteList || $8e812e808791c7e6$var$defaultWhitelist)(activeElement);
};
var $8e812e808791c7e6$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $8e812e808791c7e6$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $8e812e808791c7e6$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $8e812e808791c7e6$var$lastPortaledElement && $8e812e808791c7e6$var$lastPortaledElement.portaledElement === element;
};
function $8e812e808791c7e6$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $8e812e808791c7e6$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($8e812e808791c7e6$var$focusWasOutsideWindow);
    return $8e812e808791c7e6$var$focusWasOutsideWindow === 'meanwhile';
};
var $8e812e808791c7e6$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $8e812e808791c7e6$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $8e812e808791c7e6$var$checkInHost(activeElement, area, area);
    });
};
var $8e812e808791c7e6$var$activateTrap = function activateTrap() {
    var result = false;
    if ($8e812e808791c7e6$var$lastActiveTrap) {
        var _lastActiveTrap = $8e812e808791c7e6$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $8e812e808791c7e6$var$lastPortaledElement && $8e812e808791c7e6$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $aqTpV.extractRef)).filter(Boolean));
            if (!activeElement || $8e812e808791c7e6$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $8e812e808791c7e6$var$focusWasOutside(crossFrame) || !$8e812e808791c7e6$var$isFreeFocus() || !$8e812e808791c7e6$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $3vXZ0.focusInside)(workingArea) || activeElement && $8e812e808791c7e6$var$withinHost(activeElement, workingArea) || $8e812e808791c7e6$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$8e812e808791c7e6$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $l454t.moveFocusInside)(workingArea, $8e812e808791c7e6$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $8e812e808791c7e6$var$lastPortaledElement = {};
                        }
                    }
                    $8e812e808791c7e6$var$focusWasOutsideWindow = false;
                    $8e812e808791c7e6$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $bZxBR.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $8e812e808791c7e6$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $8e812e808791c7e6$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $8e812e808791c7e6$var$onTrap = function onTrap(event) {
    if ($8e812e808791c7e6$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $8e812e808791c7e6$var$onBlur = function onBlur() {
    return (0, $aqTpV.deferAction)($8e812e808791c7e6$var$activateTrap);
};
var $8e812e808791c7e6$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $8e812e808791c7e6$var$recordPortal(currentNode, source);
};
var $8e812e808791c7e6$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $8e812e808791c7e6$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        onBlur: $8e812e808791c7e6$var$onBlur,
        onFocus: $8e812e808791c7e6$var$onFocus
    }, children);
};
$8e812e808791c7e6$var$FocusTrap.propTypes = {};
var $8e812e808791c7e6$var$onWindowBlur = function onWindowBlur() {
    $8e812e808791c7e6$var$focusWasOutsideWindow = 'just';
    (0, $aqTpV.deferAction)(function() {
        $8e812e808791c7e6$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $8e812e808791c7e6$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $8e812e808791c7e6$var$onTrap);
    document.addEventListener('focusout', $8e812e808791c7e6$var$onBlur);
    window.addEventListener('blur', $8e812e808791c7e6$var$onWindowBlur);
};
var $8e812e808791c7e6$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $8e812e808791c7e6$var$onTrap);
    document.removeEventListener('focusout', $8e812e808791c7e6$var$onBlur);
    window.removeEventListener('blur', $8e812e808791c7e6$var$onWindowBlur);
};
function $8e812e808791c7e6$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $8e812e808791c7e6$var$focusLockAPI = {
    moveFocusInside: (0, $l454t.moveFocusInside),
    focusInside: (0, $3vXZ0.focusInside),
    focusNextElement: (0, $6lLiI.focusNextElement),
    focusPrevElement: (0, $6lLiI.focusPrevElement),
    focusFirstElement: (0, $6lLiI.focusFirstElement),
    focusLastElement: (0, $6lLiI.focusLastElement),
    captureFocusRestore: (0, $dGPH2.captureFocusRestore)
};
function $8e812e808791c7e6$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$8e812e808791c7e6$var$lastActiveTrap) $8e812e808791c7e6$var$attachHandler();
    var lastTrap = $8e812e808791c7e6$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $8e812e808791c7e6$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $8e812e808791c7e6$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($8e812e808791c7e6$var$focusLockAPI);
        $8e812e808791c7e6$var$activateTrap(true);
        (0, $aqTpV.deferAction)($8e812e808791c7e6$var$activateTrap);
    } else {
        $8e812e808791c7e6$var$detachHandler();
        $8e812e808791c7e6$var$lastActiveFocus = null;
    }
}
(0, $ahIvS.mediumFocus).assignSyncMedium($8e812e808791c7e6$var$onFocus);
(0, $ahIvS.mediumBlur).assignMedium($8e812e808791c7e6$var$onBlur);
(0, $ahIvS.mediumEffect).assignMedium(function(cb) {
    return cb($8e812e808791c7e6$var$focusLockAPI);
});
var $8e812e808791c7e6$export$2e2bcd8739ae039 = (0, $lXRNa.default)($8e812e808791c7e6$var$reducePropsToState, $8e812e808791c7e6$var$handleStateChangeOnClient)($8e812e808791c7e6$var$FocusWatcher);

});
parcelRegister("lXRNa", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffd8d5a72c526313$export$2e2bcd8739ae039);

var $k9pxZ = parcelRequire("k9pxZ");

var $7sAh5 = parcelRequire("7sAh5");

var $1v5pe = parcelRequire("1v5pe");
function $ffd8d5a72c526313$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $k9pxZ.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $1v5pe.PureComponent));
        (0, $7sAh5.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $ffd8d5a72c526313$export$2e2bcd8739ae039 = $ffd8d5a72c526313$var$withSideEffect;

});
parcelRegister("k9pxZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab877127cc595c9$export$2e2bcd8739ae039);

var $e9I1c = parcelRequire("e9I1c");
function $eab877127cc595c9$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $e9I1c.default)(t, o);
}

});
parcelRegister("e9I1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4e40d0ec96ef49b$export$2e2bcd8739ae039);
function $a4e40d0ec96ef49b$export$2e2bcd8739ae039(t, e) {
    return $a4e40d0ec96ef49b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a4e40d0ec96ef49b$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("7sAh5", function(module, exports) {
$parcel$export(module.exports, "default", () => $56e74951c021382b$export$2e2bcd8739ae039);

var $kq672 = parcelRequire("kq672");
function $56e74951c021382b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kq672.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("kq672", function(module, exports) {
$parcel$export(module.exports, "default", () => $eddafa2a5db3f8df$export$2e2bcd8739ae039);

var $ebQXH = parcelRequire("ebQXH");

var $d2s6k = parcelRequire("d2s6k");
function $eddafa2a5db3f8df$export$2e2bcd8739ae039(t) {
    var i = (0, $d2s6k.default)(t, "string");
    return "symbol" == (0, $ebQXH.default)(i) ? i : i + "";
}

});
parcelRegister("ebQXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a54b2ce35641e526$export$2e2bcd8739ae039);
function $a54b2ce35641e526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a54b2ce35641e526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a54b2ce35641e526$export$2e2bcd8739ae039(o);
}

});

parcelRegister("d2s6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $97e14288de754642$export$2e2bcd8739ae039);

var $ebQXH = parcelRequire("ebQXH");
function $97e14288de754642$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ebQXH.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ebQXH.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("dGPH2", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $9f774bc8fa0c8494$export$d357db6e554ff59a);

var $24xvB = parcelRequire("24xvB");
function $9f774bc8fa0c8494$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $9f774bc8fa0c8494$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $9f774bc8fa0c8494$var$weakRef(currentElement),
            parent: $9f774bc8fa0c8494$var$weakRef(currentElement.parentElement),
            left: $9f774bc8fa0c8494$var$weakRef(currentElement.previousElementSibling),
            right: $9f774bc8fa0c8494$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $9f774bc8fa0c8494$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $9f774bc8fa0c8494$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $24xvB.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $9f774bc8fa0c8494$export$d357db6e554ff59a = function(targetElement) {
    var location = $9f774bc8fa0c8494$export$5061a7725be48ff9(targetElement);
    return function() {
        return $9f774bc8fa0c8494$var$restoreFocusTo(location);
    };
};

});
parcelRegister("24xvB", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $1825f2a22ebc0286$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $1825f2a22ebc0286$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $1825f2a22ebc0286$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $1825f2a22ebc0286$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $1825f2a22ebc0286$export$2344b14b097df817);

var $d3kWD = parcelRequire("d3kWD");

var $3KPZd = parcelRequire("3KPZd");

var $e3qls = parcelRequire("e3qls");

var $5mocc = parcelRequire("5mocc");
var $1825f2a22ebc0286$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $d3kWD.toArray)(nodes).filter(function(node) {
        return (0, $3KPZd.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $3KPZd.notHiddenInput)(node);
    });
};
var $1825f2a22ebc0286$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $d3kWD.toArray)(nodes).filter(function(node) {
        return (0, $3KPZd.isAutoFocusAllowedCached)(cache, node);
    });
};
var $1825f2a22ebc0286$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $e3qls.orderByTabIndex)($1825f2a22ebc0286$export$6266a5cd5915dc33((0, $5mocc.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $1825f2a22ebc0286$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $e3qls.orderByTabIndex)($1825f2a22ebc0286$export$6266a5cd5915dc33((0, $5mocc.getFocusables)(topNodes), visibilityCache), false);
};
var $1825f2a22ebc0286$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $1825f2a22ebc0286$export$6266a5cd5915dc33((0, $5mocc.getParentAutofocusables)(topNode), visibilityCache);
};
var $1825f2a22ebc0286$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $1825f2a22ebc0286$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $d3kWD.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $1825f2a22ebc0286$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $1825f2a22ebc0286$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("d3kWD", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $980bcd5b32a1328e$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $980bcd5b32a1328e$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $980bcd5b32a1328e$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $980bcd5b32a1328e$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $980bcd5b32a1328e$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $980bcd5b32a1328e$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("3KPZd", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $2bbdfe660974b846$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $2bbdfe660974b846$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $2bbdfe660974b846$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $2bbdfe660974b846$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $2bbdfe660974b846$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $2bbdfe660974b846$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $2bbdfe660974b846$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $2bbdfe660974b846$export$4e62c701997796c1);

var $kmUY7 = parcelRequire("kmUY7");
var $2bbdfe660974b846$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $2bbdfe660974b846$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2bbdfe660974b846$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2bbdfe660974b846$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $2bbdfe660974b846$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2bbdfe660974b846$var$isTopNode(node) || !$2bbdfe660974b846$var$isElementHidden(node) && !$2bbdfe660974b846$var$isInert(node) && checkParent($2bbdfe660974b846$var$getParentNode(node));
};
var $2bbdfe660974b846$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2bbdfe660974b846$var$isVisibleUncached(node, $2bbdfe660974b846$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2bbdfe660974b846$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2bbdfe660974b846$var$isTopNode(node) ? $2bbdfe660974b846$export$b8550e27de209d85(node) ? checkParent($2bbdfe660974b846$var$getParentNode(node)) : false : true;
};
var $2bbdfe660974b846$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2bbdfe660974b846$var$isAutoFocusAllowedUncached(node, $2bbdfe660974b846$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2bbdfe660974b846$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2bbdfe660974b846$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $2bbdfe660974b846$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $2bbdfe660974b846$export$9d74f6fbc6f469d0 = function(node) {
    return $2bbdfe660974b846$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $2bbdfe660974b846$export$8197b0ea56b3b055 = function(node) {
    return !(($2bbdfe660974b846$export$88a6ceeed5737ba3(node) || $2bbdfe660974b846$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $2bbdfe660974b846$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $kmUY7.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $2bbdfe660974b846$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2bbdfe660974b846$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2bbdfe660974b846$export$602e5a0d338d7750 = function(node) {
    return !$2bbdfe660974b846$export$d94b8b58ec2f30eb(node);
};
var $2bbdfe660974b846$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("e3qls", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $a3b5c812bb69d297$export$cb40ee071f0d5226);

var $d3kWD = parcelRequire("d3kWD");
var $a3b5c812bb69d297$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $a3b5c812bb69d297$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $a3b5c812bb69d297$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $d3kWD.toArray)(nodes).map(function(node, index) {
        var tabIndex = $a3b5c812bb69d297$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($a3b5c812bb69d297$export$350ee6c095d98996);
};

});

parcelRegister("5mocc", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $3e71c696a64224eb$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $3e71c696a64224eb$export$853fa94d922e78b9);

var $kmUY7 = parcelRequire("kmUY7");

var $d3kWD = parcelRequire("d3kWD");

var $ayBHx = parcelRequire("ayBHx");
var $3e71c696a64224eb$var$queryTabbables = (0, $ayBHx.tabbables).join(',');
var $3e71c696a64224eb$var$queryGuardTabbables = "".concat($3e71c696a64224eb$var$queryTabbables, ", [data-focus-guard]");
var $3e71c696a64224eb$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $d3kWD.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $3e71c696a64224eb$var$queryGuardTabbables : $3e71c696a64224eb$var$queryTabbables) ? [
            child
        ] : [], $3e71c696a64224eb$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $3e71c696a64224eb$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $3e71c696a64224eb$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $3e71c696a64224eb$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $3e71c696a64224eb$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $3e71c696a64224eb$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $d3kWD.toArray)(parent.parentNode.querySelectorAll($3e71c696a64224eb$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $3e71c696a64224eb$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $kmUY7.FOCUS_AUTO), "]"));
    return (0, $d3kWD.toArray)(parentFocus).map(function(node) {
        return $3e71c696a64224eb$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("ayBHx", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $7afa530e5d8a2965$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $7afa530e5d8a2965$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("bZxBR", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $8baf7667b0e0242d$export$f89ac71e91767111);

var $4QHHA = parcelRequire("4QHHA");

var $3KPZd = parcelRequire("3KPZd");

var $D37dE = parcelRequire("D37dE");

var $e3qls = parcelRequire("e3qls");

var $5mocc = parcelRequire("5mocc");
var $8baf7667b0e0242d$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $4QHHA.getAllAffectedNodes)(topNode).filter((0, $3KPZd.isNotAGuard));
    var commonParent = (0, $D37dE.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $e3qls.orderByTabIndex)((0, $5mocc.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $5mocc.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $3KPZd.isGuard)(node)
        };
    });
};

});
parcelRegister("4QHHA", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $387deb0bc2bf6fd1$export$7e87c4720b9b279b);

var $kmUY7 = parcelRequire("kmUY7");

var $d3kWD = parcelRequire("d3kWD");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $387deb0bc2bf6fd1$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $387deb0bc2bf6fd1$var$getTopParent = function(node) {
    return node.parentNode ? $387deb0bc2bf6fd1$var$getTopParent(node.parentNode) : node;
};
var $387deb0bc2bf6fd1$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $d3kWD.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $kmUY7.FOCUS_GROUP));
        acc.push.apply(acc, group ? $387deb0bc2bf6fd1$var$filterNested((0, $d3kWD.toArray)($387deb0bc2bf6fd1$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $kmUY7.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $kmUY7.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("D37dE", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $07560f4b681c6d01$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $07560f4b681c6d01$export$8f99714c70a37db1);

var $24xvB = parcelRequire("24xvB");

var $d3kWD = parcelRequire("d3kWD");
var $07560f4b681c6d01$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $07560f4b681c6d01$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $07560f4b681c6d01$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $07560f4b681c6d01$var$getParents(nodeA);
    var parentsB = $07560f4b681c6d01$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $07560f4b681c6d01$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $d3kWD.asArray)(baseActiveElement);
    var leftEntries = (0, $d3kWD.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $07560f4b681c6d01$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $07560f4b681c6d01$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $24xvB.contains)(common, topCommon)) topCommon = common;
                else topCommon = $07560f4b681c6d01$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $07560f4b681c6d01$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $24xvB.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("6lLiI", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $49f96535dd423b3a$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $49f96535dd423b3a$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $49f96535dd423b3a$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $49f96535dd423b3a$export$6a79073ddabfd6c3);

var $4FC5g = parcelRequire("4FC5g");

var $24xvB = parcelRequire("24xvB");

var $d3kWD = parcelRequire("d3kWD");
var $49f96535dd423b3a$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $d3kWD.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $24xvB.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $24xvB.getTabbableNodes)(shards, new Map()) : (0, $24xvB.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $49f96535dd423b3a$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $24xvB.getTabbableNodes)((0, $d3kWD.asArray)(shards), new Map()) : (0, $24xvB.getFocusableNodes)((0, $d3kWD.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $49f96535dd423b3a$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $49f96535dd423b3a$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $49f96535dd423b3a$var$defaultOptions(options);
    var solution = $49f96535dd423b3a$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $4FC5g.focusOn)(target.node, newOptions.focusOptions);
};
var $49f96535dd423b3a$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $49f96535dd423b3a$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $49f96535dd423b3a$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $49f96535dd423b3a$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $4FC5g.focusOn)(node.node, options.focusOptions);
};
var $49f96535dd423b3a$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$pickBoundary(scope, options, 'first');
};
var $49f96535dd423b3a$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $49f96535dd423b3a$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("4FC5g", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $36688872895cdb77$export$c12b3da842c43a8);
var $36688872895cdb77$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("3vXZ0", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $28f2cbb71962bdef$export$20115f8da7baa6fa);

var $24xvB = parcelRequire("24xvB");

var $4QHHA = parcelRequire("4QHHA");

var $d3kWD = parcelRequire("d3kWD");

var $fI7MT = parcelRequire("fI7MT");
var $28f2cbb71962bdef$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $28f2cbb71962bdef$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $d3kWD.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $28f2cbb71962bdef$var$focusInFrame(node, activeElement);
    }));
};
var $28f2cbb71962bdef$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $fI7MT.getActiveElement)((0, $d3kWD.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $4QHHA.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $24xvB.contains)(node, activeElement) || $28f2cbb71962bdef$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("fI7MT", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $b7010183c30f5477$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $7bM1B = parcelRequire("7bM1B");
var $b7010183c30f5477$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b7010183c30f5477$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $7bM1B.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $b7010183c30f5477$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("7bM1B", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $53bed03270768e0b$export$78d20aae35adef88);
var $53bed03270768e0b$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("iEzwC", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $d94784f886733808$export$be6b21806d3fd485);

var $kmUY7 = parcelRequire("kmUY7");

var $24xvB = parcelRequire("24xvB");

var $d3kWD = parcelRequire("d3kWD");

var $fI7MT = parcelRequire("fI7MT");
var $d94784f886733808$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $fI7MT.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $d3kWD.toArray)(inDocument.querySelectorAll("[".concat((0, $kmUY7.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $24xvB.contains)(node, activeElement);
    });
};

});

parcelRegister("94mkS", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("l454t")).moveFocusInside);

var $kmUY7 = parcelRequire("kmUY7");

var $3vXZ0 = parcelRequire("3vXZ0");

var $iEzwC = parcelRequire("iEzwC");


var $bZxBR = parcelRequire("bZxBR");

var $l454t = parcelRequire("l454t");

var $dGPH2 = parcelRequire("dGPH2");

var $6lLiI = parcelRequire("6lLiI");

/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $69a5d02abfa89445$export$1a988e7317c65621 = $kmUY7;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $69a5d02abfa89445$var$deprecated_default_moveFocusInside = (0, $l454t.moveFocusInside);
var $69a5d02abfa89445$export$2e2bcd8739ae039 //
 = $69a5d02abfa89445$var$deprecated_default_moveFocusInside;

});
parcelRegister("l454t", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $f55de7b55d6b05f3$export$cd599851e879a025);

var $4FC5g = parcelRequire("4FC5g");

var $6E0kV = parcelRequire("6E0kV");
var $f55de7b55d6b05f3$var$guardCount = 0;
var $f55de7b55d6b05f3$var$lockDisabled = false;
var $f55de7b55d6b05f3$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $6E0kV.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($f55de7b55d6b05f3$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($f55de7b55d6b05f3$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $f55de7b55d6b05f3$var$lockDisabled = true;
            setTimeout(function() {
                $f55de7b55d6b05f3$var$lockDisabled = false;
            }, 1);
            return;
        }
        $f55de7b55d6b05f3$var$guardCount++;
        (0, $4FC5g.focusOn)(focusable.node, options.focusOptions);
        $f55de7b55d6b05f3$var$guardCount--;
    }
};

});
parcelRegister("6E0kV", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $4d66bd5977dbfc37$export$305758c744b57f6f);

var $dSsLM = parcelRequire("dSsLM");

var $24xvB = parcelRequire("24xvB");

var $4QHHA = parcelRequire("4QHHA");

var $d3kWD = parcelRequire("d3kWD");

var $kFmfz = parcelRequire("kFmfz");

var $fI7MT = parcelRequire("fI7MT");

var $3KPZd = parcelRequire("3KPZd");

var $D37dE = parcelRequire("D37dE");
var $4d66bd5977dbfc37$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $3KPZd.isDefined));
};
var $4d66bd5977dbfc37$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $fI7MT.getActiveElement)((0, $d3kWD.asArray)(topNode).length > 0 ? document : (0, $d3kWD.getFirst)(topNode).ownerDocument);
    var entries = (0, $4QHHA.getAllAffectedNodes)(topNode).filter((0, $3KPZd.isNotAGuard));
    var commonParent = (0, $D37dE.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $24xvB.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $3KPZd.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $24xvB.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $4d66bd5977dbfc37$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $dSsLM.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $dSsLM.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $kFmfz.pickAutofocus)(anyFocusable, innerTabbable, (0, $D37dE.allParentAutofocusables)(entries, visibilityCache)) || (0, $kFmfz.pickAutofocus)(anyFocusable, innerFocusables, (0, $D37dE.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("dSsLM", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $a1a6a293b1f32398$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $a1a6a293b1f32398$export$65842178e9bb4205);

var $jNkKQ = parcelRequire("jNkKQ");

var $RFASZ = parcelRequire("RFASZ");

var $3KPZd = parcelRequire("3KPZd");
var $a1a6a293b1f32398$export$85710b12cf912438 = 'NEW_FOCUS';
var $a1a6a293b1f32398$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $3KPZd.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $a1a6a293b1f32398$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $a1a6a293b1f32398$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $jNkKQ.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $RFASZ.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $RFASZ.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("jNkKQ", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $e692b15adeeece81$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $e692b15adeeece81$export$4a5a72a7124e45f9);

var $3KPZd = parcelRequire("3KPZd");
var $e692b15adeeece81$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $3KPZd.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $e692b15adeeece81$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $3KPZd.isRadioElement)(node) && node.name) return $e692b15adeeece81$var$findSelectedRadio(node, nodes);
    return node;
};
var $e692b15adeeece81$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($e692b15adeeece81$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("RFASZ", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $0a15370a6a924074$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $0a15370a6a924074$export$e06728ee87c96122);

var $jNkKQ = parcelRequire("jNkKQ");
var $0a15370a6a924074$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $jNkKQ.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $0a15370a6a924074$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $jNkKQ.correctNode)(node, nodes));
};

});


parcelRegister("kFmfz", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $f0b8e56b7f3735f2$export$cfb742983e257555);

var $24xvB = parcelRequire("24xvB");

var $RFASZ = parcelRequire("RFASZ");

var $3KPZd = parcelRequire("3KPZd");
var $f0b8e56b7f3735f2$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $3KPZd.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $f0b8e56b7f3735f2$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $24xvB.filterAutoFocusable)(nodes.filter($f0b8e56b7f3735f2$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $RFASZ.pickFirstFocus)(autoFocusable);
    return (0, $RFASZ.pickFirstFocus)((0, $24xvB.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("aqTpV", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $798751c431302401$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $798751c431302401$export$c613fed06e332533);
function $798751c431302401$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $798751c431302401$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $798751c431302401$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("ccDPm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2VrMI = parcelRequire("2VrMI");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $8e257ff035359448$var$_interopRequireDefault($2VrMI).default;
    }
});

var $7bfIM = parcelRequire("7bfIM");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $7bfIM.TouchScrollable;
    }
});
function $8e257ff035359448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2VrMI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $221675163850c778$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1v5pe = parcelRequire("1v5pe");
var $221675163850c778$var$_react2 = $221675163850c778$var$_interopRequireDefault($1v5pe);

var $hMzBt = parcelRequire("hMzBt");

var $7bfIM = parcelRequire("7bfIM");

var $bUDfS = parcelRequire("bUDfS");
var $221675163850c778$var$_withLockSheet2 = $221675163850c778$var$_interopRequireDefault($bUDfS);

var $jLDSu = parcelRequire("jLDSu");
var $221675163850c778$var$_withTouchListeners2 = $221675163850c778$var$_interopRequireDefault($jLDSu);

var $kWeoJ = parcelRequire("kWeoJ");
function $221675163850c778$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $221675163850c778$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $221675163850c778$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $221675163850c778$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $221675163850c778$var$ScrollLock = function(_PureComponent) {
    $221675163850c778$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $221675163850c778$var$_classCallCheck(this, ScrollLock);
        return $221675163850c778$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $221675163850c778$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$hMzBt.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $221675163850c778$var$_react2.default.createElement($7bfIM.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($1v5pe.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $221675163850c778$var$compose = (0, $kWeoJ.pipe)($221675163850c778$var$_withTouchListeners2.default, $221675163850c778$var$_withLockSheet2.default);
var $221675163850c778$var$SheetLock = $221675163850c778$var$compose($221675163850c778$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $221675163850c778$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $221675163850c778$var$_react2.default.createElement($221675163850c778$var$SheetLock, props) : props.children;
};
$221675163850c778$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $221675163850c778$var$LockToggle;

});
parcelRegister("hMzBt", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("7bfIM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $53a5c161f69d626a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $53a5c161f69d626a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1v5pe = parcelRequire("1v5pe");

var $hMzBt = parcelRequire("hMzBt");

var $kWeoJ = parcelRequire("kWeoJ");
function $53a5c161f69d626a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $53a5c161f69d626a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $53a5c161f69d626a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $53a5c161f69d626a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $53a5c161f69d626a$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $53a5c161f69d626a$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $53a5c161f69d626a$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $53a5c161f69d626a$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $53a5c161f69d626a$var$_possibleConstructorReturn(_this, _ret);
    }
    $53a5c161f69d626a$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$hMzBt.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $kWeoJ.preventInertiaScroll, $kWeoJ.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $kWeoJ.allowTouchMove, $kWeoJ.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$hMzBt.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $kWeoJ.preventInertiaScroll, $kWeoJ.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $kWeoJ.allowTouchMove, $kWeoJ.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $53a5c161f69d626a$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $1v5pe.cloneElement)(children, $53a5c161f69d626a$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($1v5pe.PureComponent);

});
parcelRegister("kWeoJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $f3e4648a60c21aa6$var$preventTouchMove;
module.exports.allowTouchMove = $f3e4648a60c21aa6$var$allowTouchMove;
module.exports.preventInertiaScroll = $f3e4648a60c21aa6$var$preventInertiaScroll;
module.exports.isTouchDevice = $f3e4648a60c21aa6$var$isTouchDevice;
module.exports.camelToKebab = $f3e4648a60c21aa6$var$camelToKebab;
module.exports.parse = $f3e4648a60c21aa6$var$parse;
module.exports.getPadding = $f3e4648a60c21aa6$var$getPadding;
module.exports.getWindowHeight = $f3e4648a60c21aa6$var$getWindowHeight;
module.exports.getDocumentHeight = $f3e4648a60c21aa6$var$getDocumentHeight;
module.exports.makeStyleTag = $f3e4648a60c21aa6$var$makeStyleTag;
module.exports.injectStyles = $f3e4648a60c21aa6$var$injectStyles;
module.exports.insertStyleTag = $f3e4648a60c21aa6$var$insertStyleTag;

var $hMzBt = parcelRequire("hMzBt");
var $f3e4648a60c21aa6$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $f3e4648a60c21aa6$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $f3e4648a60c21aa6$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $f3e4648a60c21aa6$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $f3e4648a60c21aa6$var$isTouchDevice() {
    if (!$hMzBt.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $f3e4648a60c21aa6$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $f3e4648a60c21aa6$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $f3e4648a60c21aa6$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $f3e4648a60c21aa6$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($f3e4648a60c21aa6$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $f3e4648a60c21aa6$var$getPadding() {
    if (!$hMzBt.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $f3e4648a60c21aa6$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($hMzBt.canUseDOM) return window.innerHeight * multiplier;
}
function $f3e4648a60c21aa6$var$getDocumentHeight() {
    if ($hMzBt.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $f3e4648a60c21aa6$var$makeStyleTag() {
    if (!$hMzBt.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $f3e4648a60c21aa6$var$injectStyles(tag, css) {
    if (!$hMzBt.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $f3e4648a60c21aa6$var$insertStyleTag(tag) {
    if (!$hMzBt.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("bUDfS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8ac35fe8abb45e58$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $8ac35fe8abb45e58$var$withLockSheet;

var $1v5pe = parcelRequire("1v5pe");
var $8ac35fe8abb45e58$var$_react2 = $8ac35fe8abb45e58$var$_interopRequireDefault($1v5pe);

var $kWeoJ = parcelRequire("kWeoJ");
function $8ac35fe8abb45e58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8ac35fe8abb45e58$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ac35fe8abb45e58$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8ac35fe8abb45e58$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8ac35fe8abb45e58$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $8ac35fe8abb45e58$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $8ac35fe8abb45e58$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8ac35fe8abb45e58$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $kWeoJ.makeStyleTag)();
                if (!sheet) return;
                (0, $kWeoJ.injectStyles)(sheet, styles);
                (0, $kWeoJ.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $kWeoJ.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $kWeoJ.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $8ac35fe8abb45e58$var$_possibleConstructorReturn(_this, _ret);
        }
        $8ac35fe8abb45e58$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $8ac35fe8abb45e58$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($1v5pe.PureComponent);
}

});

parcelRegister("jLDSu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e64156ffba0139f6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $e64156ffba0139f6$var$withTouchListeners;

var $1v5pe = parcelRequire("1v5pe");
var $e64156ffba0139f6$var$_react2 = $e64156ffba0139f6$var$_interopRequireDefault($1v5pe);

var $hMzBt = parcelRequire("hMzBt");

var $kWeoJ = parcelRequire("kWeoJ");
function $e64156ffba0139f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e64156ffba0139f6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e64156ffba0139f6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e64156ffba0139f6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $e64156ffba0139f6$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $e64156ffba0139f6$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $e64156ffba0139f6$var$_classCallCheck(this, TouchProvider);
            return $e64156ffba0139f6$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $e64156ffba0139f6$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$hMzBt.canUseDOM || !(0, $kWeoJ.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $kWeoJ.preventTouchMove, $kWeoJ.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$hMzBt.canUseDOM || !(0, $kWeoJ.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $kWeoJ.preventTouchMove, $kWeoJ.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $e64156ffba0139f6$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($1v5pe.PureComponent);
}

});



parcelRegister("6pgJk", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcb2eb3ac15674da$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $j9QYE = parcelRequire("j9QYE");

var $aD9yk = parcelRequire("aD9yk");
const $bcb2eb3ac15674da$var$packageName = undefined;
const $bcb2eb3ac15674da$var$packageVersion = undefined;
const $bcb2eb3ac15674da$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $bcb2eb3ac15674da$var$packageName,
    packageVersion: $bcb2eb3ac15674da$var$packageVersion
};
const $bcb2eb3ac15674da$var$baseStyles = null;
const $bcb2eb3ac15674da$var$shouldAllowClickThroughStyles = null;
const $bcb2eb3ac15674da$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const $bcb2eb3ac15674da$var$Blanket = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $aD9yk.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $1v5pe.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$bcb2eb3ac15674da$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $1v5pe.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $1v5pe.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $hMvDh.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ])
    }, children);
}));
$bcb2eb3ac15674da$var$Blanket.displayName = 'Blanket';
var $bcb2eb3ac15674da$export$2e2bcd8739ae039 = $bcb2eb3ac15674da$var$Blanket;

});

parcelRegister("9kZyw", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("jySDc")).combine);

var $jySDc = parcelRequire("jySDc");

});
parcelRegister("jySDc", function(module, exports) {
$parcel$export(module.exports, "combine", () => $ebaa074bf4f3e2a3$export$1be1fc439b849fdf);
function $ebaa074bf4f3e2a3$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});


parcelRegister("iMM0r", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $3p2SC = parcelRequire("3p2SC");
module.exports = Object.assign({}, $3p2SC, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($3p2SC.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("h4l9f", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $fa408d8f8cf4721c$export$330cd73b9da5838b);
function $fa408d8f8cf4721c$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("gUI7t", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $8fe22e09ea762de2$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v0.40.0 */ /* dialog-content.tsx generated by @compiled/babel-plugin v0.40.0 */ /* dialog-content.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $dmmsG = parcelRequire("dmmsG");

var $fl4ll = parcelRequire("fl4ll");

var $aD9yk = parcelRequire("aD9yk");

var $fsl6p = parcelRequire("fsl6p");

var $eaSsy = parcelRequire("eaSsy");

var $bLaOP = parcelRequire("bLaOP");

var $gfui4 = parcelRequire("gfui4");
// Surface reset — see the rationale on `surfaceResetStyles` in `popover/popover.tsx`.
// Neutralises inherited text-layout properties (e.g. `white-space: nowrap`) that leak
// into the top-layer surface. Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit). Pure layout reset with no box
// side-effects, so it does not reintroduce the `margin: auto` centering problem that
// kept `height: auto` off `Dialog`.
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `popover/popover.tsx`
// (ADS forbids sharing styles across files, so it is co-located and duplicated).
const $8fe22e09ea762de2$var$surfaceResetStyles = {
    root: "_o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
const $8fe22e09ea762de2$var$dialogStyles = {
    root: "_19itglyw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _p12fglyw _c71lglyw _bfhk1j28",
    motion: "_k8m011k7 _1oeci9qs _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v7kvq",
    exit: "_y44vgeqi"
};
const $8fe22e09ea762de2$var$backdropStyles = {
    root: "_1ltk1i5c",
    hidden: "_1ltk1j28",
    enter: "_1m5exbuz",
    exit: "_1m5e1op4"
};
const $8fe22e09ea762de2$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, xcss: consumerXcss, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $1v5pe.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $1v5pe.useRef)(null);
    const combinedRef = (0, $fl4ll.default)([
        ownRef,
        ref
    ]);
    const { phase: phase } = (0, $eaSsy.useAnimatedVisibility)({
        isOpen: isOpen,
        animationKind: 'dialog',
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    const isVisible = phase !== 'closed';
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at
    // the boundary (A → B → C → body → A). This hook intercepts Tab to wrap
    // directly (A → B → C → A), matching the WAI-ARIA APG pattern. Passing
    // `phase` keeps the listener attached through the animated-exit window
    // (WCAG 2.4.3 Focus Order regression guard).
    (0, $bLaOP.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Notify the open layer observer so app-coordination features
    // (open-count subscriptions) work with top-layer dialogs.
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        type: 'modal',
        isOpen: isOpen,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $aD9yk.default)
    });
    (0, $1v5pe.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Safari bug: escape closes open dialog and popovers, rather than just innermost popover
    // See notes/decisions/safari-escape-nested-popover-in-dialog.md
    const { shouldIgnoreEscape: shouldIgnoreEscape } = (0, $gfui4.useSafariEscapeFix)({
        dialogRef: ownRef,
        isVisible: isVisible
    });
    // Handle native Escape (cancel event)
    const handleCancel = (0, $1v5pe.useCallback)((event)=>{
        // Only handle a cancel targeting THIS dialog. Native `cancel` does not
        // bubble, but React's synthetic event bubbles up the component tree, so
        // for nested dialogs (one rendered inside another's DOM subtree) the
        // inner dialog's Escape would otherwise also fire an ancestor dialog's
        // handler and close it too. Mirrors the backdrop-click target guard below.
        if (event.target !== event.currentTarget) return;
        event.preventDefault();
        // Spurious Safari `cancel`: the keydown snapshot saw an open child
        // popover, so this Escape belongs to that popover (light-dismissed
        // natively). Keep the dialog open instead of forwarding to `onClose`.
        if (shouldIgnoreEscape()) return;
        onClose({
            reason: 'escape'
        });
    }, [
        onClose,
        shouldIgnoreEscape
    ]);
    // Handle backdrop click
    // Attached via bind-event-listener rather than a React prop so we avoid
    // a11y lint suppressions on the <dialog> element.
    // Keyboard dismiss is already handled natively (Escape → onCancel above).
    // `isVisible` is in deps so the listener re-binds to the new <dialog>
    // element after a host unmount / remount cycle.
    (0, $1v5pe.useEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $dmmsG.bind)(dialog, {
            type: 'click',
            listener (event) {
                if (event.target === event.currentTarget) onClose({
                    reason: 'overlay-click'
                });
            }
        });
    }, [
        onClose,
        isVisible
    ]);
    // Unmount the `<dialog>` once exit completes so it does not leave an
    // empty `role="dialog"` element in the accessibility tree. On the next
    // open the element remounts and the `[isOpen]` and `[onClose, isVisible]`
    // effects re-run against the fresh element.
    if (!isVisible) return null;
    const shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, $kIqwl.jsx)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // `aria-modal` is intentionally NOT set: native `<dialog>.showModal()`
        // already conveys modal semantics to assistive tech, and double-
        // declaring it forecloses non-modal use cases (consumers calling
        // `.show()` would still appear modal). Modern AT (NVDA / JAWS /
        // VoiceOver) infer modality from the platform accessibility API.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        onCancel: handleCancel,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hMvDh.default)([
            // Dialog styles
            $8fe22e09ea762de2$var$dialogStyles.root,
            $8fe22e09ea762de2$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $8fe22e09ea762de2$var$dialogStyles.enter,
            shouldAnimate && phase === 'exiting' && $8fe22e09ea762de2$var$dialogStyles.exit,
            shouldAnimate && $8fe22e09ea762de2$var$dialogStyles.motion,
            shouldHideBackdrop ? $8fe22e09ea762de2$var$backdropStyles.hidden : $8fe22e09ea762de2$var$backdropStyles.root,
            shouldAnimateBackdrop && phase === 'entering' && $8fe22e09ea762de2$var$backdropStyles.enter,
            shouldAnimateBackdrop && phase === 'exiting' && $8fe22e09ea762de2$var$backdropStyles.exit,
            (0, $hGIzV.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("eaSsy", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $a89544fdb2bf047e$export$1bccb45daf07907f);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $jGgQY = parcelRequire("jGgQY");
/**
 * Using the recommended motion timings for safety net.
 *
 * Not setting these timings on the preset config because they're defined in the CSS,
 * so configuring it in the preset doesn't achieve anything except introduce a potential
 * source of drift.
 *
 * TODO: figure out a way to not need to redeclare these in the future,
 * and keep CSS and JS timings in sync always.
 */ const $a89544fdb2bf047e$var$safetyNetMsMap = {
    dialog: {
        enter: 250,
        // Corresponds to `motion.duration.long`
        exit: 200 // Corresponds to `motion.duration.medium`
    },
    popover: {
        enter: 150,
        // Corresponds to `motion.duration.short`
        exit: 100 // Corresponds to `motion.duration.xshort`
    }
};
/**
 * Fires `onSettled` once when `transitionend` fires on `element`, or after
 * `safetyNetMs` if the event is swallowed (mid-transition unmount, CSS
 * mismatch, browser quirks). Returns a cleanup that cancels both paths.
 */ function $a89544fdb2bf047e$var$runOnTransitionEndOrTimeout({ element: element, safetyNetMs: safetyNetMs, onSettled: onSettled }) {
    const state = {
        isSettled: false
    };
    function teardown() {
        state.isSettled = true;
        clearTimeout(safetyNetId);
        unbind();
    }
    function settle() {
        if (state.isSettled) return;
        teardown();
        onSettled();
    }
    const unbind = (0, $dmmsG.bind)(element, {
        type: 'transitionend',
        listener: settle,
        options: {
            once: true
        }
    });
    const safetyNetId = setTimeout(settle, safetyNetMs);
    return teardown;
}
function $a89544fdb2bf047e$export$1bccb45daf07907f({ isOpen: isOpen, animationKind: animationKind, shouldAnimate: shouldAnimate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const willAnimate = shouldAnimate && !(0, $jGgQY.prefersReducedMotion)();
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    const [phase, setPhase] = (0, $1v5pe.useState)(()=>{
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    });
    if (isOpen && phase === 'closed') setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the toggle/close event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting') // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and timeout closures
    // always call the current callback without needing them in dependency arrays.
    const onEnterFinishRef = (0, $1v5pe.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    const onExitFinishRef = (0, $1v5pe.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for `transitionend` (or a safety-net timeout) and
    // move to `open`. The fallback guarantees settle on swallowed events
    // (zero-duration, browser quirk, mid-transition unmount).
    (0, $1v5pe.useEffect)(()=>{
        if (phase !== 'entering') return;
        const element = elementRef.current;
        if (!element) return;
        return $a89544fdb2bf047e$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: $a89544fdb2bf047e$var$safetyNetMsMap[animationKind].enter + 50,
            onSettled: ()=>{
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                onEnterFinishRef.current?.();
                setPhase((current)=>current === 'entering' ? 'open' : current);
            }
        });
    }, [
        phase,
        animationKind,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    const prevPhaseForEntryRef = (0, $1v5pe.useRef)('closed');
    (0, $1v5pe.useEffect)(()=>{
        const prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') onEnterFinishRef.current?.();
    }, [
        phase
    ]);
    // Animated exit: wait for `transitionend` (or a safety-net timeout),
    // fire `onExitFinish`, then move to `closed` to unmount the host.
    (0, $1v5pe.useEffect)(()=>{
        if (phase !== 'exiting' || !willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        return $a89544fdb2bf047e$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: $a89544fdb2bf047e$var$safetyNetMsMap[animationKind].exit + 50,
            onSettled: ()=>{
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                onExitFinishRef.current?.();
                setPhase((current)=>current === 'exiting' ? 'closed' : current);
            }
        });
    }, [
        phase,
        willAnimate,
        animationKind,
        elementRef
    ]);
    // Non-animated exit: wait for the browser's `toggle` (closed) or
    // `close` event before unmounting, so the consumer's listener (close
    // reason, nested focus restoration, `onClose`) and the browser's
    // native focus restoration both run against the still-attached
    // element. A naive `setTimeout(0)` occasionally beats the `toggle`
    // task in Chromium and drops focus restoration.
    //
    // `useLayoutEffect` so the listener binds in the same commit as the
    // show/hide layout effect that calls `hidePopover()` / `dialog.close()`.
    // The toggle/close event is queued as a task and cannot run until the
    // frame completes. SSR-safe: `phase` starts at `'closed'`.
    //
    // `onExitFinish` is fired separately (see effect below) so consumers
    // observe it the moment `isOpen` flips to `false`.
    (0, $1v5pe.useLayoutEffect)(()=>{
        if (phase !== 'exiting' || willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        function unmount() {
            setPhase((current)=>current === 'exiting' ? 'closed' : current);
        }
        return (0, $dmmsG.bindAll)(element, [
            {
                type: 'toggle',
                listener: (event)=>{
                    if (event.newState === 'closed') unmount();
                }
            },
            {
                type: 'close',
                listener: unmount
            }
        ]);
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Non-animated exit callback. No `transitionend` to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the toggle/close handshake above).
    const prevPhaseForExitRef = (0, $1v5pe.useRef)('closed');
    (0, $1v5pe.useEffect)(()=>{
        const prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnTransitionEndOrTimeout`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) onExitFinishRef.current?.();
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase
    };
}

});
parcelRegister("jGgQY", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $2c24a920ce9623ab$export$ff7706047246b98b);

var $c16KL = parcelRequire("c16KL");
const $2c24a920ce9623ab$export$ff7706047246b98b = (0, $c16KL.default)(()=>{
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("bLaOP", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $d65561d5406f117d$export$4f6462e86a70abe5);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $1CaUw = parcelRequire("1CaUw");

var $5Hn4C = parcelRequire("5Hn4C");

var $6rqEn = parcelRequire("6rqEn");

var $4UmzM = parcelRequire("4UmzM");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $d65561d5406f117d$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $d65561d5406f117d$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $1v5pe.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$d65561d5406f117d$var$roleRequiresFocusWrap(role) || !isVisible) return;
        const unbind = (0, $dmmsG.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $4UmzM.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                const next = (0, $6rqEn.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                const fallback = direction === 'forwards' ? (0, $1CaUw.getFirstFocusable)({
                    container: element
                }) : (0, $5Hn4C.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("1CaUw", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $37c529501327eaf4$export$748138f04a69bf21);

var $lAwsu = parcelRequire("lAwsu");
function $37c529501327eaf4$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $lAwsu.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("lAwsu", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $aec201ae6ec447e6$export$f6768025e418420e);

var $7oJqT = parcelRequire("7oJqT");

var $5xSak = parcelRequire("5xSak");
function $aec201ae6ec447e6$export$f6768025e418420e({ container: container, filter: filter }) {
    return Array.from(container.querySelectorAll((0, $5xSak.selectors).focusable)).filter((element)=>element instanceof HTMLElement).filter((element)=>(0, $7oJqT.isInSameLayer)({
            element: element,
            container: container
        })).filter((element)=>!filter || filter(element, container));
}

});
parcelRegister("7oJqT", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", () => $90e5e671ecbd0159$export$df8c72c64edc7260);
const $90e5e671ecbd0159$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $90e5e671ecbd0159$export$df8c72c64edc7260({ element: element, container: container }) {
    const elementLayer = element.closest($90e5e671ecbd0159$var$topLayerSelector);
    const containerLayer = container.closest($90e5e671ecbd0159$var$topLayerSelector);
    // Both elements are in the "document" layer
    if (!elementLayer && !containerLayer) return true;
    return elementLayer === containerLayer;
}

});

parcelRegister("5xSak", function(module, exports) {
$parcel$export(module.exports, "selectors", () => $b150483017e69b70$export$e1252723db1c541);
const $b150483017e69b70$export$e1252723db1c541 = (()=>{
    // Common exclusion filter applied to every selector.
    const not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    const notDisabled = `:not([disabled])${not}`;
    const focusable = [
        `a[href]${not}`,
        `area[href]${not}`,
        `input${notDisabled}:not([type="hidden"])`,
        `select${notDisabled}`,
        `textarea${notDisabled}`,
        `button${notDisabled}`,
        `iframe${not}`,
        `audio[controls]${not}`,
        `video[controls]${not}`,
        `[contenteditable]:not([contenteditable="false"])${not}`,
        `[tabindex]${notDisabled}${not}`
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map((selector)=>`${selector}:focus`).join(',')
    };
})();

});



parcelRegister("5Hn4C", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $541c55b0749826ce$export$73e81fa65335a75b);

var $lAwsu = parcelRequire("lAwsu");
function $541c55b0749826ce$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $lAwsu.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("6rqEn", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $eb45c20aea976e50$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $lAwsu = parcelRequire("lAwsu");

var $5xSak = parcelRequire("5xSak");
function $eb45c20aea976e50$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const all = (0, $lAwsu.getFocusables)({
        container: container,
        filter: filter
    });
    const current = container.querySelector((0, $5xSak.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    const index = all.indexOf(current);
    if (index === -1) return null;
    const nextIndex = (()=>{
        if (direction === 'forwards') return (index + 1) % all.length;
        const proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    })();
    return all[nextIndex] ?? null;
}

});

parcelRegister("4UmzM", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $5deb16e9987a17cb$export$b9590fdfeb5f722f);

var $brxde = parcelRequire("brxde");

var $7oJqT = parcelRequire("7oJqT");
function $5deb16e9987a17cb$export$b9590fdfeb5f722f({ container: container }) {
    const focused = (0, $brxde.getDocument)()?.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $7oJqT.isInSameLayer)({
        element: focused,
        container: container
    });
}

});


parcelRegister("gfui4", function(module, exports) {
$parcel$export(module.exports, "useSafariEscapeFix", () => $a8abc529ad2c3c63$export$52c229d83e45be61);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $EPIBl = parcelRequire("EPIBl");
function $a8abc529ad2c3c63$export$52c229d83e45be61({ dialogRef: dialogRef, isVisible: isVisible }) {
    const childPopoverOpenAtEscapeRef = (0, $1v5pe.useRef)(false);
    (0, $1v5pe.useEffect)(()=>{
        if (!(0, $EPIBl.isSafari)()) return;
        const dialog = dialogRef.current;
        if (!dialog) return;
        // Bind to `document`, not the dialog: on Safari focus can be on `<body>`
        // (buttons are not focused on click), where a dialog-scoped listener would
        // never fire. The query below stays scoped to this dialog's subtree.
        return (0, $dmmsG.bind)(document, {
            type: 'keydown',
            listener (event) {
                if (event.key !== 'Escape') return;
                try {
                    childPopoverOpenAtEscapeRef.current = Boolean(dialog.querySelector('[popover="auto"]:popover-open, [popover="hint"]:popover-open'));
                } catch  {
                    // `:popover-open` is unsupported in some environments (e.g. jsdom);
                    // treat as "no child popover" so a plain Escape still closes the dialog.
                    childPopoverOpenAtEscapeRef.current = false;
                }
            },
            options: {
                capture: true
            }
        });
    }, [
        dialogRef,
        isVisible
    ]);
    const api = (0, $1v5pe.useMemo)(()=>{
        return {
            shouldIgnoreEscape () {
                if (childPopoverOpenAtEscapeRef.current) {
                    childPopoverOpenAtEscapeRef.current = false;
                    return true;
                }
                return false;
            }
        };
    }, []);
    return api;
}

});


parcelRegister("3Lr6X", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $867840813305fda4$export$e458030908e2d723);

var $1v5pe = parcelRequire("1v5pe");

var $brxde = parcelRequire("brxde");
function $867840813305fda4$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $1v5pe.useLayoutEffect)(()=>{
        if (!isOpen) return;
        const body = (0, $brxde.getDocument)()?.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}

});

parcelRegister("eSj0I", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $c4e40c4c2ab840ea$export$ab57792b9b6974a6);

var $1v5pe = parcelRequire("1v5pe");
const $c4e40c4c2ab840ea$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("3nXae", function(module, exports) {
$parcel$export(module.exports, "default", () => $c792f126ececc6e3$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $bbv94 = parcelRequire("bbv94");

var $9UVx7 = parcelRequire("9UVx7");

var $6vllQ = parcelRequire("6vllQ");

var $7dKqR = parcelRequire("7dKqR");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $c792f126ececc6e3$var$modalStackRegister = [];
function $c792f126ececc6e3$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $7dKqR.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $6vllQ.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $9UVx7.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $bbv94.default)(()=>{
        const newStackIndex = $c792f126ececc6e3$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $1v5pe.useEffect)(()=>{
        const currentStackIndex = $c792f126ececc6e3$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $c792f126ececc6e3$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $c792f126ececc6e3$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $c792f126ececc6e3$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $1v5pe.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $c792f126ececc6e3$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $c792f126ececc6e3$var$modalStackRegister.splice(currentStackIndex, 1);
                $c792f126ececc6e3$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});

parcelRegister("5ogzQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5dce0559847068c$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $f5dce0559847068c$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $f5dce0559847068c$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $1v5pe.useState)(0);
    (0, $1v5pe.useLayoutEffect)(()=>{
        setScrollTopOffset($f5dce0559847068c$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $1v5pe.useCallback)(()=>{
        if ($f5dce0559847068c$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $1v5pe.useEffect)(()=>{
        return (0, $dmmsG.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("9o1SS", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $c15c65e15e82fcc1$export$ec28e97c7d8b1b35);

var $dmmsG = parcelRequire("dmmsG");
parcelRequire("9kZyw");
var $jySDc = parcelRequire("jySDc");
parcelRequire("bKDi7");
var $dkTAq = parcelRequire("dkTAq");

var $j8xpA = parcelRequire("j8xpA");
function $c15c65e15e82fcc1$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $dmmsG.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $dkTAq.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $jySDc.combine)(unbindEvents, unbindMonitor);
}
function $c15c65e15e82fcc1$var$watchForInteractionStart({ start: start }) {
    return (0, $dmmsG.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $c15c65e15e82fcc1$var$api = (0, $j8xpA.makeFixForAdapter)({
    watchForInteractionStart: $c15c65e15e82fcc1$var$watchForInteractionStart,
    watchForInteractionEnd: $c15c65e15e82fcc1$var$watchForInteractionEnd
});
function $c15c65e15e82fcc1$export$ec28e97c7d8b1b35() {
    return $c15c65e15e82fcc1$var$api.registerUsage();
}

});
parcelRegister("bKDi7", function(module, exports) {
$parcel$export(module.exports, "draggable", () => (parcelRequire("dkTAq")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("dkTAq")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("dkTAq")).monitorForElements);

var $dkTAq = parcelRequire("dkTAq");

});
parcelRegister("dkTAq", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $9759698508989323$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $9759698508989323$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $9759698508989323$export$c746a5152d4ba26c);

var $dmmsG = parcelRequire("dmmsG");

var $9FwzV = parcelRequire("9FwzV");

var $i4CJu = parcelRequire("i4CJu");

var $2nsfo = parcelRequire("2nsfo");

var $jySDc = parcelRequire("jySDc");

var $3piJr = parcelRequire("3piJr");

var $6hQzd = parcelRequire("6hQzd");

var $eUE4T = parcelRequire("eUE4T");

var $at0C2 = parcelRequire("at0C2");

var $doCBz = parcelRequire("doCBz");

var $7G5b7 = parcelRequire("7G5b7");

var $1RlTs = parcelRequire("1RlTs");
const $9759698508989323$var$draggableRegistry = new WeakMap();
function $9759698508989323$var$addToRegistry(args) {
    $9759698508989323$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $9759698508989323$var$draggableRegistry.delete(args.element);
    };
}
const $9759698508989323$var$honeyPotFix = (0, $i4CJu.makeHoneyPotFix)();
const $9759698508989323$var$adapter = (0, $2nsfo.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $jySDc.combine)($9759698508989323$var$honeyPotFix.bindEvents(), (0, $dmmsG.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $9759698508989323$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ const input = (0, $at0C2.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $9FwzV.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $eUE4T.isAndroid)() && !event.dataTransfer.types.includes((0, $doCBz.textMediaType)) && !event.dataTransfer.types.includes((0, $7G5b7.URLMediaType))) event.dataTransfer.setData((0, $doCBz.textMediaType), (0, $eUE4T.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $1RlTs.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $9759698508989323$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $9759698508989323$var$honeyPotFix.getOnPostDispatch()
});
const $9759698508989323$export$e7140b68045b5036 = $9759698508989323$var$adapter.dropTarget;
const $9759698508989323$export$59a074bac4c54f54 = $9759698508989323$var$adapter.monitor;
function $9759698508989323$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $jySDc.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $9759698508989323$var$adapter.registerUsage(), $9759698508989323$var$addToRegistry(args), (0, $6hQzd.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $3piJr.once)(cleanup);
}

});
parcelRegister("9FwzV", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $13938c9cffb86263$export$81d0353f25f5dd);

var $581yD = parcelRequire("581yD");
function $13938c9cffb86263$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $581yD.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("581yD", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $946c0be3506a2cb5$export$821bdcd739a2706b);

var $b6Cc1 = parcelRequire("b6Cc1");
function $946c0be3506a2cb5$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $b6Cc1.honeyPotDataAttribute));
}

});
parcelRegister("b6Cc1", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $a162174df15a583a$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $a162174df15a583a$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("i4CJu", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $92e541429d0ce4cb$export$8ecad27c959e89e0);

var $dmmsG = parcelRequire("dmmsG");

var $1oOCb = parcelRequire("1oOCb");

var $8PQQy = parcelRequire("8PQQy");

var $gDWyl = parcelRequire("gDWyl");

var $b6Cc1 = parcelRequire("b6Cc1");
const $92e541429d0ce4cb$var$honeyPotSize = 2;
const $92e541429d0ce4cb$var$halfHoneyPotSize = $92e541429d0ce4cb$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $92e541429d0ce4cb$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $92e541429d0ce4cb$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $92e541429d0ce4cb$var$halfHoneyPotSize,
        y: point.y - $92e541429d0ce4cb$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $92e541429d0ce4cb$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $92e541429d0ce4cb$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $92e541429d0ce4cb$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $92e541429d0ce4cb$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $92e541429d0ce4cb$var$getHoneyPotRectFor({ client: client }) {
    const point = $92e541429d0ce4cb$var$preventGoingForwardsOffScreen($92e541429d0ce4cb$var$preventGoingBackwardsOffScreen($92e541429d0ce4cb$var$pullBackByHalfHoneyPotSize($92e541429d0ce4cb$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $92e541429d0ce4cb$var$honeyPotSize,
        height: $92e541429d0ce4cb$var$honeyPotSize
    });
}
function $92e541429d0ce4cb$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $92e541429d0ce4cb$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $92e541429d0ce4cb$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $b6Cc1.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $gDWyl.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $92e541429d0ce4cb$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $gDWyl.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $8PQQy.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $1oOCb.maxZIndex)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$92e541429d0ce4cb$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $gDWyl.supportsPopover)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ const unbindPointerMove = (0, $dmmsG.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $92e541429d0ce4cb$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $92e541429d0ce4cb$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($92e541429d0ce4cb$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $dmmsG.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $92e541429d0ce4cb$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $dmmsG.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $92e541429d0ce4cb$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("1oOCb", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $975227891fdd5fcd$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $975227891fdd5fcd$export$7d0a15ee70427305 = 2147483647;

});

parcelRegister("8PQQy", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $ea5812bbc8641137$export$74004cb910cdc478);
const $ea5812bbc8641137$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("gDWyl", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $bc197170fdbde358$export$1150b66d0ff92823);

var $3piJr = parcelRequire("3piJr");
const $bc197170fdbde358$export$1150b66d0ff92823 = (0, $3piJr.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("3piJr", function(module, exports) {
$parcel$export(module.exports, "once", () => $4bbac7494ef928cd$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $4bbac7494ef928cd$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("2nsfo", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $bc3e86dff269c11f$export$2aa3a33160990d96);

var $1syxn = parcelRequire("1syxn");

var $9YLgA = parcelRequire("9YLgA");

var $jELIs = parcelRequire("jELIs");

var $2p571 = parcelRequire("2p571");
function $bc3e86dff269c11f$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $2p571.makeMonitor)();
    const dropTargetAPI = (0, $jELIs.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $1syxn.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $1syxn.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $9YLgA.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("1syxn", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $c33dafed8f75189b$export$3efdceeb8ca25c51);

var $dmmsG = parcelRequire("dmmsG");

var $9FwzV = parcelRequire("9FwzV");

var $581yD = parcelRequire("581yD");

var $04gGg = parcelRequire("04gGg");

var $i6Jl4 = parcelRequire("i6Jl4");

var $at0C2 = parcelRequire("at0C2");

var $loUD1 = parcelRequire("loUD1");
const $c33dafed8f75189b$var$globalState = {
    isActive: false
};
function $c33dafed8f75189b$var$canStart() {
    return !$c33dafed8f75189b$var$globalState.isActive;
}
function $c33dafed8f75189b$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $c33dafed8f75189b$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $c33dafed8f75189b$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$c33dafed8f75189b$var$canStart()) return;
    const initial = $c33dafed8f75189b$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $c33dafed8f75189b$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $c33dafed8f75189b$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $loUD1.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $c33dafed8f75189b$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $at0C2.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $581yD.isHoneyPotElement)(event.target) ? (0, $9FwzV.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $c33dafed8f75189b$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $c33dafed8f75189b$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $dmmsG.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $04gGg.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $at0C2.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $c33dafed8f75189b$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $at0C2.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $i6Jl4.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $c33dafed8f75189b$var$getNativeSetDragImage(event)
    });
}
function $c33dafed8f75189b$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $c33dafed8f75189b$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $at0C2.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $c33dafed8f75189b$export$3efdceeb8ca25c51 = {
    canStart: $c33dafed8f75189b$var$canStart,
    start: $c33dafed8f75189b$var$start
};

});
parcelRegister("04gGg", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $f0df7c10958e85a4$export$57d220c74e84a273);

var $4NBtu = parcelRequire("4NBtu");

var $3jeAD = parcelRequire("3jeAD");

var $2cSyW = parcelRequire("2cSyW");

var $3OQMh = parcelRequire("3OQMh");
function $f0df7c10958e85a4$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $3jeAD.isSafari)()) return (0, $2cSyW.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $4NBtu.isFirefox)()) return (0, $3OQMh.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("4NBtu", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $c4c411b71483ad5f$export$b7d78993b74f766d);

var $3piJr = parcelRequire("3piJr");
const $c4c411b71483ad5f$export$b7d78993b74f766d = (0, $3piJr.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("3jeAD", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $161ca076c8ad6f76$export$95df08bae54cb4df);

var $3piJr = parcelRequire("3piJr");
const $161ca076c8ad6f76$export$95df08bae54cb4df = (0, $3piJr.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("2cSyW", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $685df2234f141bbd$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $685df2234f141bbd$export$f21837c338005454);

var $dmmsG = parcelRequire("dmmsG");

var $3jeAD = parcelRequire("3jeAD");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $685df2234f141bbd$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $685df2234f141bbd$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $3jeAD.isSafari)()) return false;
    return dragEnter.hasOwnProperty($685df2234f141bbd$var$symbols.isEnteringWindow);
}
function $685df2234f141bbd$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $3jeAD.isSafari)()) return false;
    return dragLeave.hasOwnProperty($685df2234f141bbd$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $3jeAD.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $dmmsG.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$685df2234f141bbd$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$685df2234f141bbd$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("3OQMh", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $6449e0a0dba5a44c$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $6449e0a0dba5a44c$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $6449e0a0dba5a44c$export$e46810fef53b5b0e(eventTarget) {
    return $6449e0a0dba5a44c$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("i6Jl4", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $3da0ca8bbe7787e3$export$ac5e5b0daf997b2);
function $3da0ca8bbe7787e3$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("at0C2", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $4ca3c032d90d1186$export$7c112ceec8941e67);
function $4ca3c032d90d1186$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("loUD1", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $19c7f750f01d0057$export$9f13ecc44e83d682);

var $9q8C6 = parcelRequire("9q8C6");
const $19c7f750f01d0057$var$scheduleOnDrag = (0, $9q8C6.default)((fn)=>fn());
const $19c7f750f01d0057$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $19c7f750f01d0057$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $19c7f750f01d0057$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $19c7f750f01d0057$var$dragStart.flush();
            $19c7f750f01d0057$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $19c7f750f01d0057$var$scheduleOnDrag(()=>{
                $19c7f750f01d0057$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $19c7f750f01d0057$var$dragStart.flush();
            $19c7f750f01d0057$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("9q8C6", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dbd39392d980e15$export$2e2bcd8739ae039);
var $6dbd39392d980e15$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $6dbd39392d980e15$export$2e2bcd8739ae039 = $6dbd39392d980e15$var$rafSchd;

});



parcelRegister("9YLgA", function(module, exports) {
$parcel$export(module.exports, "register", () => $aa60299fbd6ceb4d$export$6503ec6e8aabbaf);
const $aa60299fbd6ceb4d$var$ledger = new Map();
function $aa60299fbd6ceb4d$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $aa60299fbd6ceb4d$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $aa60299fbd6ceb4d$var$ledger.set(typeKey, initial);
    return initial;
}
function $aa60299fbd6ceb4d$export$6503ec6e8aabbaf(args) {
    const entry = $aa60299fbd6ceb4d$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $aa60299fbd6ceb4d$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("jELIs", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $42479763e29ff9fb$export$47d10e7bd9c81890);

var $jySDc = parcelRequire("jySDc");

var $3piJr = parcelRequire("3piJr");

var $6hQzd = parcelRequire("6hQzd");
function $42479763e29ff9fb$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $42479763e29ff9fb$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $jySDc.combine)((0, $6hQzd.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $3piJr.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $42479763e29ff9fb$var$copyReverse(current);
        const actualCaptureOrdered = $42479763e29ff9fb$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $42479763e29ff9fb$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("6hQzd", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $e26a00fac74dbc30$export$5dcb5c23b6ba980a);
function $e26a00fac74dbc30$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("2p571", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $bffb96498b2d9e4d$export$5dd4ed888d5b12ca);

var $3piJr = parcelRequire("3piJr");
function $bffb96498b2d9e4d$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $3piJr.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("eUE4T", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $b3a6dc958f1f2889$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $b3a6dc958f1f2889$export$aceb3ed8b7f7bd2c);

var $3piJr = parcelRequire("3piJr");
const $b3a6dc958f1f2889$export$a11b0059900ceec8 = (0, $3piJr.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $b3a6dc958f1f2889$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("doCBz", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $ddfc3d7fb082b4bc$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $ddfc3d7fb082b4bc$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("7G5b7", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $1a20191a4a04eed1$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $1a20191a4a04eed1$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("1RlTs", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $697e6b46936239c7$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $697e6b46936239c7$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("j8xpA", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $924eed6d40e44b23$export$a74bff2507e6126b);
parcelRequire("9kZyw");
var $jySDc = parcelRequire("jySDc");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $924eed6d40e44b23$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $924eed6d40e44b23$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $924eed6d40e44b23$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$924eed6d40e44b23$var$hasSameOrigin(window.location.href, iframe.src);
}
const $924eed6d40e44b23$var$registry = new Map();
function $924eed6d40e44b23$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($924eed6d40e44b23$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $924eed6d40e44b23$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $924eed6d40e44b23$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $924eed6d40e44b23$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $924eed6d40e44b23$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $jySDc.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $924eed6d40e44b23$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $924eed6d40e44b23$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("94IQO", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $60d1b9698263783f$export$27d79116d3a4e7d5);
parcelRequire("jsUMT");
var $8W3qZ = parcelRequire("8W3qZ");

var $j8xpA = parcelRequire("j8xpA");
function $60d1b9698263783f$var$watchForInteractionStart({ start: start }) {
    return (0, $8W3qZ.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $60d1b9698263783f$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $8W3qZ.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $60d1b9698263783f$var$api = (0, $j8xpA.makeFixForAdapter)({
    watchForInteractionStart: $60d1b9698263783f$var$watchForInteractionStart,
    watchForInteractionEnd: $60d1b9698263783f$var$watchForInteractionEnd
});
function $60d1b9698263783f$export$27d79116d3a4e7d5() {
    return $60d1b9698263783f$var$api.registerUsage();
}

});
parcelRegister("jsUMT", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("8W3qZ")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("8W3qZ")).dropTargetForExternal);

var $8W3qZ = parcelRequire("8W3qZ");

});
parcelRegister("8W3qZ", function(module, exports) {
$parcel$export(module.exports, "dropTargetForExternal", () => $21bd1627266cc91b$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $21bd1627266cc91b$export$bb1740f3194979c1);

var $dmmsG = parcelRequire("dmmsG");

var $2nsfo = parcelRequire("2nsfo");

var $eUE4T = parcelRequire("eUE4T");

var $9fpdU = parcelRequire("9fpdU");

var $i6Jl4 = parcelRequire("i6Jl4");

var $doCBz = parcelRequire("doCBz");

var $1RlTs = parcelRequire("1RlTs");
function $21bd1627266cc91b$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $1RlTs.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $doCBz.textMediaType) && value === (0, $eUE4T.androidFallbackText)) return false;
    return true;
}
function $21bd1627266cc91b$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$21bd1627266cc91b$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $21bd1627266cc91b$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $21bd1627266cc91b$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $21bd1627266cc91b$var$didDragStartLocally = false;
const $21bd1627266cc91b$var$adapter = (0, $2nsfo.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $dmmsG.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($21bd1627266cc91b$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $9fpdU.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $21bd1627266cc91b$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $21bd1627266cc91b$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$21bd1627266cc91b$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $21bd1627266cc91b$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $21bd1627266cc91b$var$adapter.dropTarget(args);
}
function $21bd1627266cc91b$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $21bd1627266cc91b$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $21bd1627266cc91b$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $21bd1627266cc91b$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $dmmsG.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $i6Jl4.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $dmmsG.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $21bd1627266cc91b$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("9fpdU", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $fe839351c846fb59$export$d1c6f249e893cdf4);

var $4NBtu = parcelRequire("4NBtu");

var $3jeAD = parcelRequire("3jeAD");

var $2cSyW = parcelRequire("2cSyW");

var $3OQMh = parcelRequire("3OQMh");
function $fe839351c846fb59$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $3jeAD.isSafari)()) return (0, $2cSyW.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $4NBtu.isFirefox)()) return (0, $3OQMh.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("11R2l", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $0d688745ac2ae62e$export$9c0606fcefb5d1e2);

var $dmmsG = parcelRequire("dmmsG");
parcelRequire("9kZyw");
var $jySDc = parcelRequire("jySDc");
parcelRequire("kxkOo");
var $8GvKN = parcelRequire("8GvKN");

var $j8xpA = parcelRequire("j8xpA");
function $0d688745ac2ae62e$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $dmmsG.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $8GvKN.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $jySDc.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $0d688745ac2ae62e$var$watchForInteractionStart({ start: start }) {
    return (0, $dmmsG.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $0d688745ac2ae62e$var$api = (0, $j8xpA.makeFixForAdapter)({
    watchForInteractionStart: $0d688745ac2ae62e$var$watchForInteractionStart,
    watchForInteractionEnd: $0d688745ac2ae62e$var$watchForInteractionEnd
});
function $0d688745ac2ae62e$export$9c0606fcefb5d1e2() {
    return $0d688745ac2ae62e$var$api.registerUsage();
}

});
parcelRegister("kxkOo", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("8GvKN")).monitorForTextSelection);

var $8GvKN = parcelRequire("8GvKN");

});
parcelRegister("8GvKN", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $302810749f46f67c$export$2e178e3647f5e6e9);

var $dmmsG = parcelRequire("dmmsG");

var $i4CJu = parcelRequire("i4CJu");

var $2nsfo = parcelRequire("2nsfo");

var $jySDc = parcelRequire("jySDc");

var $3jeAD = parcelRequire("3jeAD");

var $3zF5U = parcelRequire("3zF5U");

var $doCBz = parcelRequire("doCBz");

var $1RlTs = parcelRequire("1RlTs");
function $302810749f46f67c$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $3jeAD.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $doCBz.textMediaType))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $302810749f46f67c$var$honeyPotFix = (0, $i4CJu.makeHoneyPotFix)();
const $302810749f46f67c$var$adapter = (0, $2nsfo.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $jySDc.combine)($302810749f46f67c$var$honeyPotFix.bindEvents(), (0, $dmmsG.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $1RlTs.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $doCBz.textMediaType))) return;
                const target = $302810749f46f67c$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $doCBz.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $3zF5U.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $302810749f46f67c$var$honeyPotFix.getOnPostDispatch()
});
function $302810749f46f67c$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $302810749f46f67c$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $302810749f46f67c$var$adapter.registerUsage();
})();
function $302810749f46f67c$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $302810749f46f67c$var$adapter.monitor(args);
}

});
parcelRegister("3zF5U", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $8b2ac2600ad4fda7$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $8b2ac2600ad4fda7$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("1LjAb", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $fe5f9084ae0bce2b$export$dece24112a937f92);

var $1v5pe = parcelRequire("1v5pe");
const $fe5f9084ae0bce2b$export$dece24112a937f92 = /*#__PURE__*/ (0, $1v5pe.createContext)(null);

});

parcelRegister("7Skuo", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $5f06d14dd588ddce$export$ceba93bf0bdd16f2);
const $5f06d14dd588ddce$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("401cB", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $32d58c5d43ea6efd$export$a3da89b899389ed8);

var $8KJ3R = parcelRequire("8KJ3R");
const $32d58c5d43ea6efd$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $8KJ3R.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $8KJ3R.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});
parcelRegister("8KJ3R", function(module, exports) {
$parcel$export(module.exports, "width", () => $dd588a9ad0085abc$export$7e3df82ee760448c);
const $dd588a9ad0085abc$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});


parcelRegister("5BrkL", function(module, exports) {
$parcel$export(module.exports, "default", () => $02b1de7676d62ddf$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.40.0 */ /* modal-dialog.tsx generated by @compiled/babel-plugin v0.40.0 */ /* modal-dialog.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $Ms2ib = parcelRequire("Ms2ib");

var $lHxwq = parcelRequire("lHxwq");

var $gvhLu = parcelRequire("gvhLu");

var $ulOZK = parcelRequire("ulOZK");

var $eTbg2 = parcelRequire("eTbg2");

var $etMwD = parcelRequire("etMwD");

var $2aEiL = parcelRequire("2aEiL");
parcelRequire("9kZyw");
var $jySDc = parcelRequire("jySDc");

var $eSj0I = parcelRequire("eSj0I");

var $iezB5 = parcelRequire("iezB5");

var $9o1SS = parcelRequire("9o1SS");

var $94IQO = parcelRequire("94IQO");

var $11R2l = parcelRequire("11R2l");

var $1LjAb = parcelRequire("1LjAb");

var $7Skuo = parcelRequire("7Skuo");

var $401cB = parcelRequire("401cB");

var $gdewX = parcelRequire("gdewX");
const $02b1de7676d62ddf$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $02b1de7676d62ddf$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k",
    motion: "_c71l1kw7 _p12f1kw7 _1e0c1txw _1jyk1jm9 _1if81osq",
    rootMotion: "_yakv1wug _4lht1wug",
    fullscreen: "_1jyk1osq"
};
const $02b1de7676d62ddf$var$viewportScrollStyles = null;
const $02b1de7676d62ddf$var$bodyScrollStyles = null;
const $02b1de7676d62ddf$var$ModalDialog = /*#__PURE__*/ (0, $1v5pe.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $lHxwq.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $1v5pe.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $jySDc.combine)((0, $9o1SS.disableDraggingToCrossOriginIFramesForElement)(), (0, $11R2l.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $94IQO.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $Ms2ib.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $iezB5.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $1v5pe.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $gvhLu.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $ulOZK.useLayering)();
    return /*#__PURE__*/ $1v5pe.createElement((0, $gdewX.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $1v5pe.createElement((0, $eSj0I.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $1v5pe.createElement((0, $1LjAb.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, !UNSAFE_shouldDisableMotionUplift && (0, $2aEiL.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $1v5pe.createElement((0, $eTbg2.default), {
        enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
        exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
        onFinish: onMotionFinish,
        xcss: (0, $ky45w.cx)($02b1de7676d62ddf$var$dialogStyles.motion, isFullScreen && $02b1de7676d62ddf$var$dialogStyles.fullscreen),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $401cB.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $7Skuo.dialogHeight)(height)
        }
    }, /*#__PURE__*/ $1v5pe.createElement("section", {
        "aria-label": label,
        ref: (0, $fl4ll.default)([
            motionRef,
            ref
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $401cB.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $7Skuo.dialogHeight)(height)
        },
        role: "dialog",
        "aria-labelledby": label ? undefined : titleId,
        "data-testid": defaultTestId,
        "data-modal-stack": stackIndex,
        tabIndex: -1,
        "aria-modal": true,
        "data-ds--level": currentLevel,
        className: (0, $hMvDh.default)([
            $02b1de7676d62ddf$var$dialogStyles.root,
            $02b1de7676d62ddf$var$dialogStyles.rootMotion,
            !isFullScreen && $02b1de7676d62ddf$var$dialogStyles.borderRadius,
            !isFullScreen && (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $02b1de7676d62ddf$var$dialogStyles.borderRadiusT26Shape,
            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
        ])
    }, children)) : /*#__PURE__*/ $1v5pe.createElement((0, $etMwD.default), {
        /**
         * We don't want a 'slide in' for the full screen modals.
         */ entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, (bottomFadeInProps)=>/*#__PURE__*/ $1v5pe.createElement("section", {
            ...bottomFadeInProps,
            "aria-label": label,
            ref: (0, $fl4ll.default)([
                bottomFadeInProps.ref,
                motionRef,
                ref
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $401cB.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $7Skuo.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $hMvDh.default)([
                $02b1de7676d62ddf$var$dialogStyles.root,
                !isFullScreen && $02b1de7676d62ddf$var$dialogStyles.borderRadius,
                !isFullScreen && (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $02b1de7676d62ddf$var$dialogStyles.borderRadiusT26Shape,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }, children)))));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
$02b1de7676d62ddf$export$2e2bcd8739ae039 = $02b1de7676d62ddf$var$ModalDialog;

});
parcelRegister("iezB5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff249416ebf3536e$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");
function $ff249416ebf3536e$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $1v5pe.useRef)(null);
    const onMotionFinish = (0, $1v5pe.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("gdewX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c9703ffa567416f$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $aWQrI = parcelRequire("aWQrI");

var $bKulK = parcelRequire("bKulK");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $2c9703ffa567416f$var$positionerStyles = null;
const $2c9703ffa567416f$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
const $2c9703ffa567416f$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $2c9703ffa567416f$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $2c9703ffa567416f$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $2c9703ffa567416f$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $bKulK.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $aWQrI.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $hMvDh.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $2c9703ffa567416f$var$stackStyles.stackTransition,
            stackIndex > 0 ? $2c9703ffa567416f$var$stackStyles.stackTransform : $2c9703ffa567416f$var$stackStyles.stackIdle,
            $2c9703ffa567416f$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c9703ffa567416f$export$2e2bcd8739ae039 = $2c9703ffa567416f$var$Positioner;

});




parcelRegister("kYkRP", function(module, exports) {
$parcel$export(module.exports, "default", () => $51feafb09f6da7fc$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $ccDPm = parcelRequire("ccDPm");

var $bCJu2 = parcelRequire("bCJu2");

var $l8fBF = parcelRequire("l8fBF");

var $4twQO = parcelRequire("4twQO");
const $51feafb09f6da7fc$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $51feafb09f6da7fc$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $bCJu2.useModal)();
    const shouldScrollInViewport = (0, $4twQO.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            $51feafb09f6da7fc$var$styles.root,
            hasInlinePadding && $51feafb09f6da7fc$var$styles.paddingInline
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $ccDPm.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $l8fBF.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            $51feafb09f6da7fc$var$styles.root,
            /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $51feafb09f6da7fc$var$styles.paddingBlock,
            hasInlinePadding && $51feafb09f6da7fc$var$styles.paddingInline
        ])
    }, children)));
};
var $51feafb09f6da7fc$export$2e2bcd8739ae039 = $51feafb09f6da7fc$var$ModalBody;

});
parcelRegister("bCJu2", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $99b27f95562a9c00$export$33ffd74ebf07f060);

var $1v5pe = parcelRequire("1v5pe");

var $eSj0I = parcelRequire("eSj0I");
const $99b27f95562a9c00$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $1v5pe.useContext)((0, $eSj0I.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("l8fBF", function(module, exports) {
$parcel$export(module.exports, "default", () => $05db46a3a69573a0$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.40.0 */ /* scroll-container.tsx generated by @compiled/babel-plugin v0.40.0 */ /* scroll-container.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $9q8C6 = parcelRequire("9q8C6");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $aD9yk = parcelRequire("aD9yk");

var $bbv94 = parcelRequire("bbv94");

var $22rKq = parcelRequire("22rKq");
const $05db46a3a69573a0$var$keylineColor = "var(--ds-border, #0B120E24)";
const $05db46a3a69573a0$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2ia51",
    bottomKeyline: "_179ria51"
};
const $05db46a3a69573a0$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $05db46a3a69573a0$var$ScrollContainer = /*#__PURE__*/ (0, $1v5pe.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $1v5pe.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $1v5pe.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $1v5pe.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $1v5pe.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $1v5pe.useEffect)(()=>{
        const schedule = (0, $9q8C6.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $bbv94.default)((0, $9q8C6.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $05db46a3a69573a0$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $05db46a3a69573a0$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $1v5pe.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $dmmsG.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $dmmsG.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $aD9yk.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $22rKq.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $fl4ll.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $ky45w.cx)($05db46a3a69573a0$var$styles.base, showTopKeyline && $05db46a3a69573a0$var$styles.topKeyline, showBottomKeyline && $05db46a3a69573a0$var$styles.bottomKeyline)
    }, children);
});
$05db46a3a69573a0$var$ScrollContainer.displayName = 'ScrollContainer';
var $05db46a3a69573a0$export$2e2bcd8739ae039 = $05db46a3a69573a0$var$ScrollContainer;

});

parcelRegister("4twQO", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cb5b4cfa9297de2$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $1LjAb = parcelRequire("1LjAb");
function $2cb5b4cfa9297de2$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $1v5pe.useContext)((0, $1LjAb.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("epvFM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf691c5b993c3527$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $bCJu2 = parcelRequire("bCJu2");
const $bf691c5b993c3527$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $bf691c5b993c3527$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $bCJu2.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ $1v5pe.createElement("div", {
        "data-testid": testId,
        className: (0, $hMvDh.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $bf691c5b993c3527$export$2e2bcd8739ae039 = $bf691c5b993c3527$var$ModalFooter;

});

parcelRegister("8O99O", function(module, exports) {
$parcel$export(module.exports, "default", () => $b04ddaa5ae898796$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $7dKqR = parcelRequire("7dKqR");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $b04ddaa5ae898796$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $7dKqR.default), {
        appear: true
    }, //Checking if children are undefined to prevent potential runtime errors in React 17
    props.children ?? null);
};
var $b04ddaa5ae898796$export$2e2bcd8739ae039 = $b04ddaa5ae898796$var$ModalTransition;

});

parcelRegister("28KCa", function(module, exports) {
$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $f08b7823d6424088$export$99df83ca0f45bd54);

var $2W5OM = parcelRequire("2W5OM");
const $f08b7823d6424088$export$99df83ca0f45bd54 = [
    (0, $2W5OM.PreferenceCategory).Analytics,
    (0, $2W5OM.PreferenceCategory).Functional,
    (0, $2W5OM.PreferenceCategory).Marketing,
    (0, $2W5OM.PreferenceCategory).StrictlyNecessary,
    (0, $2W5OM.PreferenceCategory).Unknown
];

});

parcelRegister("6Yrr4", function(module, exports) {
$parcel$export(module.exports, "CookieCategorySection", () => $c45ed46f0596e5e2$export$3c97a3b492e10ae9);

var $1v5pe = parcelRequire("1v5pe");

var $2FQOu = parcelRequire("2FQOu");

var $eMSEP = parcelRequire("eMSEP");
var $fRfXo = parcelRequire("fRfXo");
var $bQOrV = parcelRequire("bQOrV");

var $7WT4C = parcelRequire("7WT4C");

var $2W5OM = parcelRequire("2W5OM");
const $c45ed46f0596e5e2$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $c45ed46f0596e5e2$var$categoryBoxStyles = (0, $bQOrV.xcss)({
    paddingBlockStart: 'space.200'
});
const $c45ed46f0596e5e2$var$categoryDescriptionStyles = (0, $bQOrV.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $c45ed46f0596e5e2$var$categoryToEventSubjectMap = {
    [(0, $2W5OM.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $2W5OM.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $2W5OM.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $2W5OM.PreferenceCategory).Unknown]: null,
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: null
};
const $c45ed46f0596e5e2$var$categoryToTestIdMap = {
    [(0, $2W5OM.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $2W5OM.PreferenceCategory).Analytics]: 'analytics',
    [(0, $2W5OM.PreferenceCategory).Functional]: 'functional',
    [(0, $2W5OM.PreferenceCategory).Marketing]: 'marketing',
    [(0, $2W5OM.PreferenceCategory).Unknown]: null
};
const $c45ed46f0596e5e2$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $1v5pe.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $2W5OM.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $c45ed46f0596e5e2$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $7WT4C.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = `consent-preference-${$c45ed46f0596e5e2$var$categoryToTestIdMap[category]}-description`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $c45ed46f0596e5e2$var$categoryBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $2FQOu.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: `${$c45ed46f0596e5e2$var$tmpTrelloClassNameOverride}`,
        isChecked: isChecked,
        value: isChecked.toString(),
        onChange: onCheckboxChange,
        label: titleElement,
        name: `${titleString}`,
        testId: `consent-preference-${$c45ed46f0596e5e2$var$categoryToTestIdMap[category]}`,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $c45ed46f0596e5e2$var$categoryDescriptionStyles,
        id: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fRfXo.default), {
        size: "small",
        color: "color.text.subtle"
    }, descriptionElement)));
};

});
parcelRegister("2FQOu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebc43d0bdbfb771e$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");

var $j9QYE = parcelRequire("j9QYE");

var $fl4ll = parcelRequire("fl4ll");

var $bgQC7 = parcelRequire("bgQC7");

var $gfBoy = parcelRequire("gfBoy");

var $53Dxu = parcelRequire("53Dxu");

var $WgGC3 = parcelRequire("WgGC3");
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ const $ebc43d0bdbfb771e$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $ebc43d0bdbfb771e$var$Checkbox = /*#__PURE__*/ (0, $1v5pe.memo)(/*#__PURE__*/ (0, $1v5pe.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $1v5pe.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $1v5pe.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $j9QYE.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $1v5pe.useRef)(null);
    const mergedRefs = (0, $fl4ll.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $1v5pe.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $1v5pe.createElement((0, $gfBoy.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $1v5pe.createElement("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hMvDh.default)([
            $ebc43d0bdbfb771e$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $1v5pe.createElement((0, $bgQC7.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $1v5pe.createElement((0, $53Dxu.default), null, label, isRequired && /*#__PURE__*/ $1v5pe.createElement((0, $WgGC3.default), null)));
}));
$ebc43d0bdbfb771e$var$Checkbox.displayName = 'Checkbox';
var $ebc43d0bdbfb771e$export$2e2bcd8739ae039 = $ebc43d0bdbfb771e$var$Checkbox;

});
parcelRegister("bgQC7", function(module, exports) {
$parcel$export(module.exports, "default", () => $48722ba0ae9b45c7$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ const $48722ba0ae9b45c7$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $48722ba0ae9b45c7$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $1v5pe.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $1v5pe.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $48722ba0ae9b45c7$var$CheckboxIcon = /*#__PURE__*/ (0, $1v5pe.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $1v5pe.useMemo)(()=>$48722ba0ae9b45c7$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $1v5pe.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hMvDh.default)([
            $48722ba0ae9b45c7$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $1v5pe.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $1v5pe.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $hMvDh.default)([
            $48722ba0ae9b45c7$var$svgStyles.rect
        ])
    }), icon));
});
var $48722ba0ae9b45c7$export$2e2bcd8739ae039 = $48722ba0ae9b45c7$var$CheckboxIcon;

});

parcelRegister("gfBoy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0541050623ec6192$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ const $0541050623ec6192$var$baseStyles = null;
const $0541050623ec6192$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
const $0541050623ec6192$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
const $0541050623ec6192$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
const $0541050623ec6192$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
const $0541050623ec6192$var$disabledCheckedStyles = null;
function $0541050623ec6192$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $1v5pe.createElement("label", {
        className: (0, $hMvDh.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("53Dxu", function(module, exports) {
$parcel$export(module.exports, "default", () => $136267f4b4143d59$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $136267f4b4143d59$var$labelTextStyles = null;
function $136267f4b4143d59$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ $1v5pe.createElement("span", {
        className: (0, $hMvDh.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("WgGC3", function(module, exports) {
$parcel$export(module.exports, "default", () => $64516635a6c1fea0$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $64516635a6c1fea0$var$requiredIndicatorStyles = null;
function $64516635a6c1fea0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $1v5pe.createElement("span", {
        "aria-hidden": true,
        className: (0, $hMvDh.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}

});



parcelRegister("1RtbY", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $75b476d4f13492f7$export$a7357cdd1f0b0168);

var $75IaS = parcelRequire("75IaS");
const $75b476d4f13492f7$export$a7357cdd1f0b0168 = (0, $75IaS.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'The text is shown as the heading at the top of the cookie preferences modal dialog, which allows users to manage and configure their browser cookie and storage settings.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    },
    strictDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624-appify',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    analyticalOptionDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify',
        defaultMessage: 'Measures usage to improve app performance.',
        description: 'Cookie preferences modal analytical option description.'
    }
});

});


parcelRegister("9jI7c", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5b8a4c1ef8129f1$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $hJye1 = parcelRequire("hJye1");

var $hEEEo = parcelRequire("hEEEo");

var $6t0zJ = parcelRequire("6t0zJ");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $a5b8a4c1ef8129f1$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $hEEEo.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $a5b8a4c1ef8129f1$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
   * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
   *  during the initial render. Without this flag, the application might incorrectly display a banner based on
   * incomplete or missing preference data. During the rehydration process, this initial render triggers
   * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
   * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
   * and the client-rendered state.
   */ const isInitialRender = (0, $1v5pe.useRef)(true);
    const prefetchedPreferencesData = (0, $1v5pe.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $1v5pe.useState)((0, $hJye1.initializePreferencesData)(initialPreferences));
    (0, $1v5pe.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $hJye1.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $6t0zJ.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $a5b8a4c1ef8129f1$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData?.prefs,
        isPrefetchedPreferencesState: preferencesData?.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $a5b8a4c1ef8129f1$export$2e2bcd8739ae039 = $a5b8a4c1ef8129f1$var$usePreferences;

});
parcelRegister("hEEEo", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $7ca169793fac694e$export$1de6a888ae076ff8);
$parcel$export(module.exports, "getPreferencesMaybeSync", () => $7ca169793fac694e$export$39c2cb6e65c1c16b);

var $jeHvL = parcelRequire("jeHvL");
var $dS1lP = parcelRequire("dS1lP");

var $3yjSR = parcelRequire("3yjSR");

var $cSGfl = parcelRequire("cSGfl");

var $dbJ6U = parcelRequire("dbJ6U");

var $hJye1 = parcelRequire("hJye1");
async function $7ca169793fac694e$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $hJye1.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $cSGfl.getConsentToken)();
            if ((0, $dS1lP.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $hJye1.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $hJye1.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function $7ca169793fac694e$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $hJye1.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, $cSGfl.getConsentToken)().then((consentToken)=>{
            if ((0, $dS1lP.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $hJye1.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, $hJye1.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("cSGfl", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $5ff2410fc5eb96ca$export$f1b8f2ca713fca08);

var $3yjSR = parcelRequire("3yjSR");

var $dbJ6U = parcelRequire("dbJ6U");

var $iqJSJ = parcelRequire("iqJSJ");

var $3za5i = parcelRequire("3za5i");

var $fF3Mh = parcelRequire("fF3Mh");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 */ let $5ff2410fc5eb96ca$var$inFlightConsentToken = null;
const $5ff2410fc5eb96ca$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $fF3Mh.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $iqJSJ.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $dbJ6U.getCookie)((0, $3yjSR.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $3za5i.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $3za5i.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $3za5i.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $5ff2410fc5eb96ca$export$f1b8f2ca713fca08 = ()=>{
    // N concurrent callers share a single in-flight promise so only one ConsentHub fetch
    // fires per page load regardless of how many components call getPreferences() simultaneously.
    if ($5ff2410fc5eb96ca$var$inFlightConsentToken) return $5ff2410fc5eb96ca$var$inFlightConsentToken;
    $5ff2410fc5eb96ca$var$inFlightConsentToken = $5ff2410fc5eb96ca$var$_getConsentToken().finally(()=>{
        $5ff2410fc5eb96ca$var$inFlightConsentToken = null;
    });
    return $5ff2410fc5eb96ca$var$inFlightConsentToken;
};

});
parcelRegister("iqJSJ", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $0114ae2692bc3d79$export$b5282052fc15e1ae);

var $3yjSR = parcelRequire("3yjSR");

var $dbJ6U = parcelRequire("dbJ6U");
const $0114ae2692bc3d79$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $dbJ6U.getCookie)((0, $3yjSR.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("fF3Mh", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $58b04c3d4a0fa5f4$export$c515de1cc9cebc71);

var $3yjSR = parcelRequire("3yjSR");

var $37e9E = parcelRequire("37e9E");

var $hJye1 = parcelRequire("hJye1");
const $58b04c3d4a0fa5f4$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $37e9E.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $hJye1.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $3yjSR.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});





parcelRegister("ilta6", function(module, exports) {
$parcel$export(module.exports, "PresentationalConsentBanner", () => $4f78cee0f4ae6f10$export$dd3e60478510f81d);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $1v5pe = parcelRequire("1v5pe");

var $b2Az1 = parcelRequire("b2Az1");
var $kK7WO = parcelRequire("kK7WO");

var $49361 = parcelRequire("49361");

var $caOTO = parcelRequire("caOTO");

var $hpF1c = parcelRequire("hpF1c");
var $eMSEP = parcelRequire("eMSEP");
var $f4K70 = parcelRequire("f4K70");
var $bQOrV = parcelRequire("bQOrV");

var $iOm08 = parcelRequire("iOm08");

var $1Tz0w = parcelRequire("1Tz0w");

var $28KCa = parcelRequire("28KCa");

var $eEjwS = parcelRequire("eEjwS");
const $4f78cee0f4ae6f10$var$boxStylesPurpleWithMinHeight = (0, $bQOrV.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $4f78cee0f4ae6f10$var$noticeContainerStyles = (0, $bQOrV.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $4f78cee0f4ae6f10$var$inlineWrapperStylesStaticHeight = (0, $bQOrV.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $iOm08.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $4f78cee0f4ae6f10$var$buttonContainerStylesStaticHeight = (0, $bQOrV.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $iOm08.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $4f78cee0f4ae6f10$var$truncatedTextStyles = (0, $bQOrV.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $4f78cee0f4ae6f10$var$linkNoTruncateStyles = (0, $bQOrV.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $4f78cee0f4ae6f10$var$smallMediumScreenContainerStyles = (0, $bQOrV.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $iOm08.media).above.md]: {
        display: 'none'
    }
});
const $4f78cee0f4ae6f10$var$largeScreenContainerStyles = (0, $bQOrV.xcss)({
    display: 'none',
    [(0, $iOm08.media).above.md]: {
        display: 'block'
    }
});
const $4f78cee0f4ae6f10$var$noop = ()=>{};
const $4f78cee0f4ae6f10$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $28KCa.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $eEjwS.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $eEjwS.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $4f78cee0f4ae6f10$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $eEjwS.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $eEjwS.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $4f78cee0f4ae6f10$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $4f78cee0f4ae6f10$var$noop, onClickAcceptAll: onClickAcceptAll = $4f78cee0f4ae6f10$var$noop, onClickPreferences: onClickPreferences = $4f78cee0f4ae6f10$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $4f78cee0f4ae6f10$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const intl = (0, $kK7WO.default)();
    const displayedTextMap = (0, $1v5pe.useMemo)(()=>{
        return $4f78cee0f4ae6f10$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $1v5pe.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $4f78cee0f4ae6f10$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $1v5pe.useCallback)(()=>{
        const displayedTextAcceptAllMap = $4f78cee0f4ae6f10$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $4f78cee0f4ae6f10$var$boxStylesPurpleWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        xcss: $4f78cee0f4ae6f10$var$inlineWrapperStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        xcss: $4f78cee0f4ae6f10$var$noticeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        xcss: $4f78cee0f4ae6f10$var$smallMediumScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1Tz0w.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $eEjwS.i18n).useCookiesDescriptionNoLink),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        xcss: $4f78cee0f4ae6f10$var$truncatedTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        ...(0, $eEjwS.i18n).useCookiesDescriptionNoLink,
        tagName: "span"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.default), {
        id: "cookiesTrackingNoticeLink",
        href: "https://www.atlassian.com/legal/cookies",
        target: "_blank",
        onClick: onClickTrackingNoticeLink,
        xcss: $4f78cee0f4ae6f10$var$linkNoTruncateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $eEjwS.i18n).cookiesTrackingNotice))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $4f78cee0f4ae6f10$var$largeScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), {
        ...(0, $eEjwS.i18n).useCookiesDescription,
        tagName: "span",
        values: {
            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hpF1c.default), {
                id: "cookiesTrackingNoticeLink",
                href: "https://www.atlassian.com/legal/cookies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $eEjwS.i18n).cookiesTrackingNotice))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        space: "space.100",
        xcss: $4f78cee0f4ae6f10$var$buttonContainerStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $49361.default), {
        testId: "preferences-button",
        appearance: "subtle",
        onClick: onClickPreferences
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $eEjwS.i18n).preferencesBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $49361.default), {
        testId: "only-necessary-button",
        onClick: handleOnlyNecessaryClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $eEjwS.i18n).onlyNecessaryBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $49361.default), {
        testId: "accept-all-button",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($caOTO))),
        onClick: handleAcceptAllClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $b2Az1.default), (0, $eEjwS.i18n).acceptAllBtn)))));
};

});
parcelRegister("caOTO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::948526006d27d48bcd24e662b224371e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dcde6b856eadaa2$var$_react = $8dcde6b856eadaa2$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $8dcde6b856eadaa2$var$_baseNew = $8dcde6b856eadaa2$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $8dcde6b856eadaa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-mark
 * Usage guidance:
 * Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dcde6b856eadaa2$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $8dcde6b856eadaa2$var$_react.default.createElement($8dcde6b856eadaa2$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$8dcde6b856eadaa2$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $8dcde6b856eadaa2$var$_default = module.exports.default = $8dcde6b856eadaa2$var$CheckMarkIcon;

});


parcelRegister("ace0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $dccef779b4037a33$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $1v5pe = parcelRequire("1v5pe");

var $jeHvL = parcelRequire("jeHvL");
var $7WT4C = parcelRequire("7WT4C");

var $dS1lP = parcelRequire("dS1lP");

var $3yjSR = parcelRequire("3yjSR");

var $icwwm = parcelRequire("icwwm");

var $jlHNc = parcelRequire("jlHNc");

var $dbJ6U = parcelRequire("dbJ6U");

var $2W5OM = parcelRequire("2W5OM");
const $dccef779b4037a33$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions?.getCookie ? ssrOptions.getCookie((0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $dbJ6U.getCookie)((0, $3yjSR.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if ((ssrOptions?.isSSR ?? (0, $dS1lP.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, $2W5OM.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, $icwwm.shouldRenderBannerPrefetched)(initialPreferences, ssrOptions);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $dccef779b4037a33$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $1v5pe.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $1v5pe.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $jlHNc.setStrictlyNecessaryCookie)((0, $3yjSR.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $1v5pe.useMemo)(()=>{
        return $dccef779b4037a33$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $1v5pe.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $7WT4C.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $dccef779b4037a33$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $jeHvL.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if (ssrOptions?.isSSR ?? (0, $dS1lP.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $dccef779b4037a33$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $dccef779b4037a33$export$2e2bcd8739ae039 = $dccef779b4037a33$var$useBannerVisibility;

});
parcelRegister("icwwm", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $dee132b12fb8d196$export$6406464aa126433e);

var $2aEiL = parcelRequire("2aEiL");

var $37e9E = parcelRequire("37e9E");

var $9e4p2 = parcelRequire("9e4p2");

var $hJye1 = parcelRequire("hJye1");

var $il7mV = parcelRequire("il7mV");
const $dee132b12fb8d196$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $2aEiL.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $hJye1.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $il7mV.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $9e4p2.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $37e9E.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $il7mV.getBannerVisibility)(consentPrefsData, ssrOptions);
};

});





parcelRegister("imFpy", function(module, exports) {
$parcel$export(module.exports, "LocalDevBanner", () => (parcelRequire("aBqKF")).LocalDevBanner);

var $aBqKF = parcelRequire("aBqKF");

});
parcelRegister("aBqKF", function(module, exports) {
$parcel$export(module.exports, "LocalDevBanner", () => $45d521762c118a78$export$666bf55c5f3504f6);

var $1v5pe = parcelRequire("1v5pe");

var $eMSEP = parcelRequire("eMSEP");
var $f4K70 = parcelRequire("f4K70");
var $bQOrV = parcelRequire("bQOrV");

var $kK7WO = parcelRequire("kK7WO");

var $hHzJx = parcelRequire("hHzJx");

var $jMvEo = parcelRequire("jMvEo");

var $ebDRY = parcelRequire("ebDRY");

var $4PeMk = parcelRequire("4PeMk");
parcelRequire("cDuOd");
var $fgIUF = parcelRequire("fgIUF");
parcelRequire("jMN8E");
var $hZQIF = parcelRequire("hZQIF");
const $45d521762c118a78$var$bannerContainerStyles = (0, $bQOrV.xcss)({
    position: 'fixed',
    bottom: 'space.200',
    left: 'space.200',
    zIndex: 'tooltip'
});
const $45d521762c118a78$var$bannerStyles = (0, $bQOrV.xcss)({
    position: 'relative',
    backgroundColor: 'color.background.warning.bold',
    color: 'color.text.inverse',
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    borderRadius: 'radius.medium',
    font: 'font.body.small',
    fontWeight: 'font.weight.bold',
    boxShadow: 'elevation.shadow.overlay',
    userSelect: 'none'
});
const $45d521762c118a78$var$closeButtonStyles = (0, $bQOrV.xcss)({
    position: 'absolute',
    top: 'space.negative.150',
    right: 'space.negative.150'
});
const $45d521762c118a78$export$666bf55c5f3504f6 = ()=>{
    const { formatMessage: formatMessage } = (0, $kK7WO.default)();
    const { localStoredSettings: localStoredSettings } = (0, $hZQIF.useSettings)();
    const isLocalDevBannerEnabled = localStoredSettings[(0, $fgIUF.LocalStorageKey).LOCAL_DEV_BANNER_ENABLED];
    const [isHidden, setIsHidden] = (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useState(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useState(false);
    if (!isLocalDevBannerEnabled || isHidden) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: "local-dev-banner-container",
        xcss: $45d521762c118a78$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        testId: "local-dev-banner",
        xcss: $45d521762c118a78$var$bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $f4K70.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jMvEo))), {
        label: ""
    }), formatMessage((0, $4PeMk.messages).localDevBannerLabel)), isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eMSEP.default), {
        xcss: $45d521762c118a78$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $hHzJx.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebDRY))), {
                ...iconProps,
                size: "small"
            }),
        label: "Close",
        onClick: ()=>setIsHidden(true),
        shape: "circle",
        spacing: "compact",
        testId: "local-dev-banner-close-button"
    }))));
};

});
parcelRegister("4PeMk", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0eb5cb14898616fb$export$defe85febe8b728c);

var $75IaS = parcelRequire("75IaS");
const $0eb5cb14898616fb$export$defe85febe8b728c = (0, $75IaS.defineMessages)({
    localDevBannerLabel: {
        id: 'rovo-extension.local-dev-banner.label.no-translate',
        defaultMessage: 'LOCAL DEV',
        description: 'The text is shown as a banner label at the top of the extension UI when running in local development mode to distinguish it from production. This string should NOT be translated.'
    }
});

});



parcelRegister("d4v8F", function(module, exports) {
$parcel$export(module.exports, "IdentityLogout", () => $2d99e710bd4c2cb9$export$5d2f0914e2ff154b);

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $lsxLV = parcelRequire("lsxLV");

var $dX6kP = parcelRequire("dX6kP");

var $f0dSY = parcelRequire("f0dSY");
const $2d99e710bd4c2cb9$export$5d2f0914e2ff154b = ()=>{
    const sendAnalyticEvent = (0, $dX6kP.useSendAnalyticEvent)();
    (0, $1v5pe.useEffect)(()=>{
        const redirectToIdentity = ()=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/74804
            sendAnalyticEvent({
                eventType: 'track',
                event: {
                    action: 'initialised',
                    actionSubject: (0, $lsxLV.ANALYTICS_TRACK_EVENT_ACTION_SUBJECTS).LOGOUT,
                    source: (0, $lsxLV.ANALYTICS_SCREEN_NAMES).EXTENSION_REDIRECT_TO_IDENTITY_SCREEN
                },
                userId: ''
            });
            (0, $f0dSY.clearSentryUser)();
            const IdentityLogoutUrl = (0, $dqHaj.getIdentityUrl)() + '/logout';
            const IdentityLogOutUrlWithRedirect = `${IdentityLogoutUrl}?continue=${encodeURIComponent((0, $dqHaj.getRovoExtensionWebBaseUrl)() + '/extension/ntp-logout-redirect')}`;
            window.parent.location.href = IdentityLogOutUrlWithRedirect;
        };
        redirectToIdentity();
    }, [
        sendAnalyticEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null);
};

});

parcelRegister("642vm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ee50410b1fd3b05$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $lNKZj = parcelRequire("lNKZj");
const $5ee50410b1fd3b05$var$MetaTags = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $lNKZj.Helmet), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("meta", {
        content: "Rovo Extension",
        name: "application-name"
    }));
};
var $5ee50410b1fd3b05$export$2e2bcd8739ae039 = $5ee50410b1fd3b05$var$MetaTags;

});

parcelRegister("aLmHL", function(module, exports) {
$parcel$export(module.exports, "useBroadcastProactiveContextMenuVariants", () => $7bbee4da21a22b37$export$e954790d8fe3207b);

var $1v5pe = parcelRequire("1v5pe");

var $9JAaz = parcelRequire("9JAaz");

var $1PE4Q = parcelRequire("1PE4Q");
const $7bbee4da21a22b37$export$e954790d8fe3207b = ()=>{
    const proactiveContextMenuVariants = (0, $1PE4Q.useProactiveContextMenuVariants)();
    (0, $1v5pe.useEffect)(()=>{
        (0, $9JAaz.broadcastRovoContextMenuVariantsToExtension)(proactiveContextMenuVariants);
    }, [
        proactiveContextMenuVariants
    ]);
};

});
parcelRegister("1PE4Q", function(module, exports) {
$parcel$export(module.exports, "useProactiveContextMenuVariants", () => $eed6e5f3bb0fa033$export$c2a3ebc285f59a9f);

var $1v5pe = parcelRequire("1v5pe");

var $3Dil2 = parcelRequire("3Dil2");

var $crLv5 = parcelRequire("crLv5");
const $eed6e5f3bb0fa033$export$c2a3ebc285f59a9f = ()=>{
    const statsigVersion = (0, $1v5pe.useSyncExternalStore)((0, $3Dil2.statsigStore).subscribe, (0, $3Dil2.statsigStore).getSnapshot, (0, $3Dil2.statsigStore).getSnapshot);
    return (0, $1v5pe.useMemo)(()=>{
        const { highlightEntry: highlightEntry, searchBehavior: searchBehavior } = (0, $crLv5.getAllRovoContextMenuVariants)();
        return {
            highlightEntry: highlightEntry,
            searchBehavior: searchBehavior,
            isRovoContextMenuEnabled: (0, $crLv5.deriveIsRovoContextMenuEnabled)(highlightEntry, searchBehavior),
            isHighlightFabEnabled: (0, $crLv5.deriveIsRovoContextMenuHighlightFabEnabled)(highlightEntry),
            isRightClickFabEnabled: (0, $crLv5.deriveIsRovoContextMenuRightClickFabEnabled)(highlightEntry),
            isSearchInSidePanelEnabled: (0, $crLv5.deriveIsRovoContextMenuSearchInSidePanelEnabled)(searchBehavior),
            isSearchFullPageEnabled: (0, $crLv5.deriveIsRovoContextMenuSearchFullPageEnabled)(searchBehavior)
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        statsigVersion
    ]);
};

});


parcelRegister("gfRi5", function(module, exports) {
$parcel$export(module.exports, "ExperienceSLO", () => (parcelRequire("8jOpu")).ExperienceSLO);
$parcel$export(module.exports, "PerformanceSLO", () => (parcelRequire("4xT8j")).PerformanceSLO);
$parcel$export(module.exports, "ExperienceSLOKeys", () => (parcelRequire("3dX4H")).ExperienceSLOKeys);
$parcel$export(module.exports, "PerformanceSLOKeys", () => (parcelRequire("3dX4H")).PerformanceSLOKeys);

var $8jOpu = parcelRequire("8jOpu");

var $4xT8j = parcelRequire("4xT8j");
parcelRequire("lxvXO");
var $3dX4H = parcelRequire("3dX4H");

});
parcelRegister("8jOpu", function(module, exports) {
$parcel$export(module.exports, "ExperienceSLO", () => $7d88e33816f8fd49$export$d2edfcbe997fe43d);

var $8OjRF = parcelRequire("8OjRF");

var $7qISg = parcelRequire("7qISg");

var $9zTQv = parcelRequire("9zTQv");

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("1wxU2");
var $6vVPG = parcelRequire("6vVPG");

var $j0FUQ = parcelRequire("j0FUQ");
/**
 * This "soft" error boundary reports UFO failure events only for the outermost, originating SLO component.
 */ class $7d88e33816f8fd49$var$UFOErrorReporter extends (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Component {
    static{
        this.contextType = (0, $7qISg.default);
    }
    constructor(props){
        super(props);
        this.state = {
            childHasThrown: false
        };
    }
    static getDerivedStateFromError(_) {
        return {
            childHasThrown: true
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null, this.state.childHasThrown ? null : this.props.children);
    }
    componentDidCatch(maybeError, _) {
        // original signature: componentDidCatch?(error: Error, errorInfo: ErrorInfo): void
        // …but React isn't telling the truth: error may not be an Error… hence the below verification
        const error = (0, $j0FUQ.toError)(maybeError);
        if ((0, $j0FUQ.reportUFOError)(error, this.props.ufo, this.context)) $9zTQv.withScope((scope)=>{
            scope.setTag('slo-key', this.props.ufo);
            scope.setTag('interaction-id', (0, $8OjRF.getActiveInteraction)()?.id);
            scope.captureException(error, {
                mechanism: {
                    handled: false
                }
            });
        });
        throw error;
    }
}
const $7d88e33816f8fd49$export$d2edfcbe997fe43d = ({ children: children, ufo: ufo })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
        name: ufo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($7d88e33816f8fd49$var$UFOErrorReporter, {
        ufo: ufo
    }, children));
};

});

parcelRegister("4xT8j", function(module, exports) {
$parcel$export(module.exports, "PerformanceSLO", () => $c2a0e391e5e971ec$export$81f8fd4eaf989719);

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("1wxU2");
var $6vVPG = parcelRequire("6vVPG");
const $c2a0e391e5e971ec$export$81f8fd4eaf989719 = ({ children: children, ufo: ufo })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $6vVPG.default), {
        name: ufo
    }, children);
};

});


parcelRegister("haUlu", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("25yRO").then(()=>parcelRequire('SjqiU'));

});

parcelRegister("1mQym", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("12h7x")
]).then(()=>parcelRequire('eVpdu'));

});

parcelRegister("fUiFW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("12h7x")
]).then(()=>parcelRequire('gdrql'));

});

parcelRegister("7n07k", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8Zg4U").then(()=>parcelRequire('b1ht5'));

});

parcelRegister("ZRTp0", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("jdzWq")
]).then(()=>parcelRequire('4ZxOH'));

});

parcelRegister("iPNXp", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("bFpnu"),
    $7mhPs("6y1PR"),
    $7mhPs("8muIR")
]).then(()=>parcelRequire('eNWQ7'));

});

parcelRegister("3MDdT", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("8E256"),
    $7mhPs("ePwFc"),
    $7mhPs("8s6PC"),
    $7mhPs("5B03s"),
    $7mhPs("315AH"),
    $7mhPs("c9kPJ"),
    $7mhPs("gbkwR"),
    $7mhPs("ioxtj"),
    $7mhPs("4agdk"),
    $7mhPs("f8hVA"),
    $7mhPs("iWpRr"),
    $7mhPs("aCB2m"),
    $7mhPs("dkuaN"),
    $7mhPs("7t4nQ"),
    $7mhPs("jt2Wg"),
    $7mhPs("7obgz"),
    $7mhPs("dW5dK"),
    $7mhPs("iv2XG"),
    $7mhPs("2Ss4L"),
    $7mhPs("6y1PR"),
    $7mhPs("5jxBl"),
    $7mhPs("67nVR")
]).then(()=>parcelRequire('7R4XE'));

});

parcelRegister("jkjAy", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("9FkCP")
]).then(()=>parcelRequire('l8zUz'));

});

parcelRegister("4MiNJ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("9FkCP")
]).then(()=>parcelRequire('7gMoN'));

});

parcelRegister("3dVS3", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("6y1PR"),
    $7mhPs("gAIAC")
]).then(()=>parcelRequire('ieuG6'));

});

parcelRegister("lY7Cz", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("ed20T"),
    $7mhPs("bFpnu"),
    $7mhPs("6y1PR"),
    $7mhPs("iv2XG"),
    $7mhPs("2Ss4L"),
    $7mhPs("aOg0l")
]).then(()=>parcelRequire('3gu2l'));

});

parcelRegister("cGtxy", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("9FkCP")
]).then(()=>parcelRequire('59nED'));

});


parcelRegister("VkTYT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ac589ac0a8d0d7e$var$ReactIs, $0ac589ac0a8d0d7e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("atFq8"))();

});
parcelRegister("atFq8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7IFBr = parcelRequire("7IFBr");
function $7a0cbe10261dc603$var$emptyFunction() {}
function $7a0cbe10261dc603$var$emptyFunctionWithReset() {}
$7a0cbe10261dc603$var$emptyFunctionWithReset.resetWarningCache = $7a0cbe10261dc603$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7IFBr) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $7a0cbe10261dc603$var$emptyFunctionWithReset,
        resetWarningCache: $7a0cbe10261dc603$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7IFBr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $59ece9f03da6ea40$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $59ece9f03da6ea40$var$ReactPropTypesSecret;

});



parcelRegister("iRj1b", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iAHii").then(()=>parcelRequire('gRPyi'));

});

parcelRegister("eV8o2", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4tQLd").then(()=>parcelRequire('97mKG'));

});

parcelRegister("l0tcr", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eMa0g").then(()=>parcelRequire('d8D9C'));

});

parcelRegister("axkt2", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eMa0g").then(()=>parcelRequire('6YWM6'));

});

parcelRegister("8NcvZ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cEJUJ").then(()=>parcelRequire('cU7KO'));

});

parcelRegister("4dsLZ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("bIDvE").then(()=>parcelRequire('3ArEy'));

});

parcelRegister("jlWDy", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("atddJ").then(()=>parcelRequire('2RPnA'));

});

parcelRegister("va0m5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9dPtY").then(()=>parcelRequire('jxONJ'));

});

parcelRegister("cnQQp", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jTYrv").then(()=>parcelRequire('kwa4L'));

});

parcelRegister("5tYLV", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("exNkW").then(()=>parcelRequire('5r02C'));

});

parcelRegister("ir5gm", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("f5Z8V").then(()=>parcelRequire('3CnEI'));

});

parcelRegister("lqDtF", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("ewhfv").then(()=>parcelRequire('iOFoK'));

});

parcelRegister("lOWYU", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("04ZSs").then(()=>parcelRequire('5Uxss'));

});

parcelRegister("4GxCy", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iyB2S").then(()=>parcelRequire('e8xnr'));

});

parcelRegister("5kNc4", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fTsTH").then(()=>parcelRequire('44M3J'));

});

parcelRegister("bpMAu", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("95Hx1").then(()=>parcelRequire('k30ji'));

});

parcelRegister("fr7Kc", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3CyoQ").then(()=>parcelRequire('1BHcS'));

});

parcelRegister("hJquZ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cHRku").then(()=>parcelRequire('hGhtt'));

});

parcelRegister("iubfc", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cEJUJ").then(()=>parcelRequire('iT6R3'));

});

parcelRegister("bip1o", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3CyoQ").then(()=>parcelRequire('eA1zq'));

});

parcelRegister("7yIcl", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("04ZSs").then(()=>parcelRequire('2nOLA'));

});

parcelRegister("59QBA", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("7JMB4").then(()=>parcelRequire('kDbbn'));

});

parcelRegister("5F7KT", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cHRku").then(()=>parcelRequire('9Ejl5'));

});

parcelRegister("835lU", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cEJUJ").then(()=>parcelRequire('adU62'));

});

parcelRegister("f6Ic2", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("btM1p").then(()=>parcelRequire('eU8bk'));

});

parcelRegister("g11oP", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("bqUkI").then(()=>parcelRequire('deseo'));

});

parcelRegister("9UqAc", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8bkiW").then(()=>parcelRequire('akQAg'));

});

parcelRegister("eyN06", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hajTb").then(()=>parcelRequire('b3Ma4'));

});

parcelRegister("ichXA", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gk5JH").then(()=>parcelRequire('feQwD'));

});

parcelRegister("diXhU", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("OIxb0").then(()=>parcelRequire('b9ES4'));

});

parcelRegister("dQsEO", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("kjtnK").then(()=>parcelRequire('8mUnO'));

});

parcelRegister("kdbzi", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fP7eR").then(()=>parcelRequire('jQlMi'));

});

parcelRegister("85tRy", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iyB2S").then(()=>parcelRequire('6wo9P'));

});

parcelRegister("uJe8k", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hZIHZ").then(()=>parcelRequire('hqioc'));

});

parcelRegister("hkzru", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fTsTH").then(()=>parcelRequire('hj1HQ'));

});

parcelRegister("1D1yV", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gu9H0").then(()=>parcelRequire('fJdEs'));

});

parcelRegister("37cGi", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("4csLu").then(()=>parcelRequire('8JJ6q'));

});

parcelRegister("4G3WH", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("95Hx1").then(()=>parcelRequire('69Oqr'));

});

parcelRegister("iIsNV", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jGuRp").then(()=>parcelRequire('iKumT'));

});

parcelRegister("eRCVN", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9dPtY").then(()=>parcelRequire('gQCYe'));

});

parcelRegister("8cptK", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("btM1p").then(()=>parcelRequire('jPuGw'));

});

parcelRegister("bApwq", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("25yRO").then(()=>parcelRequire('5zkgG'));

});

parcelRegister("60pr7", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("95Hx1").then(()=>parcelRequire('bqDQS'));

});

parcelRegister("hGn9B", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iyB2S").then(()=>parcelRequire('dI6kE'));

});

parcelRegister("g4m4n", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jTYrv").then(()=>parcelRequire('cxE9G'));

});

parcelRegister("ePNsB", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lfuw8").then(()=>parcelRequire('e8tb1'));

});

parcelRegister("4DBAq", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("l5Nzc").then(()=>parcelRequire('iuM5s'));

});

parcelRegister("69vvN", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jGuRp").then(()=>parcelRequire('2Vvcm'));

});

parcelRegister("9di9L", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("atddJ").then(()=>parcelRequire('6PCGi'));

});

parcelRegister("bdxP4", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jTYrv").then(()=>parcelRequire('frVPV'));

});

parcelRegister("iM03G", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8KEei").then(()=>parcelRequire('abZ7W'));

});

parcelRegister("hxsUH", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iGj6U").then(()=>parcelRequire('4IoKU'));

});

parcelRegister("h8oTp", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("f5Z8V").then(()=>parcelRequire('9q1gb'));

});

parcelRegister("2SOcP", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("bIDvE").then(()=>parcelRequire('lwfVR'));

});

parcelRegister("dZRyh", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9dPtY").then(()=>parcelRequire('fIOB3'));

});

parcelRegister("fI2BU", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eMa0g").then(()=>parcelRequire('g14Fu'));

});

parcelRegister("i09H8", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8Zg4U").then(()=>parcelRequire('duWET'));

});

parcelRegister("dI0wG", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hZIHZ").then(()=>parcelRequire('4iM62'));

});

parcelRegister("DrbWG", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jTYrv").then(()=>parcelRequire('5qdqB'));

});

parcelRegister("kPN7L", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("exNkW").then(()=>parcelRequire('3Hrt9'));

});

parcelRegister("ccc2a", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("2L0y7").then(()=>parcelRequire('8UHY0'));

});

parcelRegister("kaeEG", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8TaCR").then(()=>parcelRequire('eYanF'));

});

parcelRegister("j4XLF", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fz2th").then(()=>parcelRequire('035eH'));

});

parcelRegister("jEKGe", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eeKV2").then(()=>parcelRequire('6omcm'));

});

parcelRegister("eodvL", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8ryQT").then(()=>parcelRequire('7ADmj'));

});

parcelRegister("g0zg5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("kPimI").then(()=>parcelRequire('eKTDv'));

});

parcelRegister("dWDvj", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hy49z").then(()=>parcelRequire('lVEDg'));

});

parcelRegister("jjQFx", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("kPimI").then(()=>parcelRequire('6skxX'));

});

parcelRegister("75L0G", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gk5JH").then(()=>parcelRequire('5BXlj'));

});

parcelRegister("c771G", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("l7tEb").then(()=>parcelRequire('3qjDD'));

});

parcelRegister("2QrSw", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3DxtL").then(()=>parcelRequire('jm8Wo'));

});

parcelRegister("h5WTW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("43lkL").then(()=>parcelRequire('fzKCF'));

});

parcelRegister("1W5NJ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9dPtY").then(()=>parcelRequire('imZgn'));

});

parcelRegister("lMWEK", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fTsTH").then(()=>parcelRequire('bbEAE'));

});

parcelRegister("jICau", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("exNkW").then(()=>parcelRequire('4M0ma'));

});

parcelRegister("kUglV", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("1hvQ2").then(()=>parcelRequire('5OWeM'));

});

parcelRegister("5W7v2", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gQ7JT").then(()=>parcelRequire('bEy6H'));

});

parcelRegister("jrHfE", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hZIHZ").then(()=>parcelRequire('3SZVA'));

});

parcelRegister("6tia3", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jTYrv").then(()=>parcelRequire('dl8mv'));

});

parcelRegister("8isfR", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jGuRp").then(()=>parcelRequire('gHetY'));

});

parcelRegister("k5PZJ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("arlkG").then(()=>parcelRequire('laoMY'));

});

parcelRegister("3WUXC", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("j6sDm").then(()=>parcelRequire('eRE3n'));

});

parcelRegister("bkpY2", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("bIDvE").then(()=>parcelRequire('8Z8XL'));

});

parcelRegister("ckosZ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3DxtL").then(()=>parcelRequire('a5ACI'));

});

parcelRegister("ji1Ji", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("f5Z8V").then(()=>parcelRequire('6bLYY'));

});

parcelRegister("3ucPb", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("l7tEb").then(()=>parcelRequire('5wIYa'));

});

parcelRegister("1JT01", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("12h7x")
]).then(()=>parcelRequire('lfxwm'));

});

parcelRegister("dXAIn", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cEJUJ").then(()=>parcelRequire('UBUb1'));

});

parcelRegister("2ZTM3", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cHRku").then(()=>parcelRequire('igxMj'));

});

parcelRegister("dXuhF", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fTsTH").then(()=>parcelRequire('iktft'));

});

parcelRegister("aok1J", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3tKmN").then(()=>parcelRequire('kZQ2M'));

});

parcelRegister("angFn", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3OrwA").then(()=>parcelRequire('iRnQA'));

});

parcelRegister("ebEBn", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6CpeM").then(()=>parcelRequire('3JvrM'));

});

parcelRegister("icPMB", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("7hOFr").then(()=>parcelRequire('4cBSR'));

});

parcelRegister("gqigL", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lfuw8").then(()=>parcelRequire('cRmbc'));

});

parcelRegister("2fevf", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iAHii").then(()=>parcelRequire('gDacN'));

});

parcelRegister("kVRHu", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("1gjln").then(()=>parcelRequire('2uh15'));

});

parcelRegister("dAeLp", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jGuRp").then(()=>parcelRequire('80mo7'));

});

parcelRegister("ljdeS", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("7JMB4").then(()=>parcelRequire('f2epq'));

});

parcelRegister("4LLbN", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fTsTH").then(()=>parcelRequire('75GV0'));

});

parcelRegister("hR4UU", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3cyFB").then(()=>parcelRequire('kiYto'));

});

parcelRegister("34yCo", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8ryQT").then(()=>parcelRequire('lixSc'));

});

parcelRegister("5rw4R", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("9dPtY").then(()=>parcelRequire('cU2rL'));

});

parcelRegister("ZY1cn", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iyB2S").then(()=>parcelRequire('bkmHy'));

});

parcelRegister("b1Gh5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("2L0y7").then(()=>parcelRequire('fpoEx'));

});

parcelRegister("dmmzd", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6CpeM").then(()=>parcelRequire('ijHC0'));

});

parcelRegister("61uIW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iuUPX").then(()=>parcelRequire('98Yzq'));

});

parcelRegister("2OxNK", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("jGuRp").then(()=>parcelRequire('7m8jT'));

});

parcelRegister("esSry", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cHRku").then(()=>parcelRequire('kd8nu'));

});

parcelRegister("fePoE", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("exNkW").then(()=>parcelRequire('6ueLO'));

});

parcelRegister("5EQGe", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6LTZP").then(()=>parcelRequire('jgB0o'));

});

parcelRegister("lMt3g", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("39nEY").then(()=>parcelRequire('cDzkg'));

});

parcelRegister("hCISi", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("gu9H0").then(()=>parcelRequire('2zOqa'));

});

parcelRegister("7fgvq", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("1hvQ2").then(()=>parcelRequire('4WC2t'));

});

parcelRegister("4lbb0", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hajTb").then(()=>parcelRequire('82ExZ'));

});

parcelRegister("dEQHr", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8nDIO").then(()=>parcelRequire('a6IcZ'));

});

parcelRegister("1JvrW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("dVKpW").then(()=>parcelRequire('bxh0b'));

});

parcelRegister("7rIss", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("l7tEb").then(()=>parcelRequire('eXi4o'));

});

parcelRegister("fcmVb", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("04ZSs").then(()=>parcelRequire('1Gpsj'));

});

parcelRegister("3Rh9z", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("cHRku").then(()=>parcelRequire('kLk4F'));

});

parcelRegister("c8xxo", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("215YM").then(()=>parcelRequire('a36B4'));

});

parcelRegister("7yYm3", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("bn8SL").then(()=>parcelRequire('csH5K'));

});

parcelRegister("g2G5X", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("OIxb0").then(()=>parcelRequire('8gS3R'));

});

parcelRegister("5iBxW", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("7hOFr").then(()=>parcelRequire('4XCHq'));

});

parcelRegister("4ujXg", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("kjtnK").then(()=>parcelRequire('5gINq'));

});

parcelRegister("leZ9E", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("fz2th").then(()=>parcelRequire('kkBQj'));

});

parcelRegister("leX5H", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("6HPwW").then(()=>parcelRequire('gxo4a'));

});

parcelRegister("7XzSo", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8nDIO").then(()=>parcelRequire('dCIJ2'));

});

parcelRegister("jpyRj", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("8KEei").then(()=>parcelRequire('aDB9U'));

});

parcelRegister("lksJn", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("3DxtL").then(()=>parcelRequire('88IA0'));

});

parcelRegister("lYQWJ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("eeKV2").then(()=>parcelRequire('2fCZH'));

});

parcelRegister("fIbpN", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("lUDxb").then(()=>parcelRequire('8ixRq'));

});

parcelRegister("7Q8K9", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("arlkG").then(()=>parcelRequire('dOwnU'));

});

parcelRegister("dofpL", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("1gjln").then(()=>parcelRequire('8uhdx'));

});

parcelRegister("6wKoJ", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("hZIHZ").then(()=>parcelRequire('hxdL7'));

});

parcelRegister("6upwj", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("aXqWz")
]).then(()=>parcelRequire('hyHdR'));

});

parcelRegister("7oGJw", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("h17LB").then(()=>parcelRequire('1BO7y'));

});

parcelRegister("8vLc5", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("btM1p").then(()=>parcelRequire('lPKIZ'));

});

parcelRegister("6x8el", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("l5Nzc").then(()=>parcelRequire('c1UGz'));

});

parcelRegister("c7WqB", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = $7mhPs("iyB2S").then(()=>parcelRequire('6tOKv'));

});

parcelRegister("cPUrl", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("aXqWz")
]).then(()=>parcelRequire('7z7ba'));

});

parcelRegister("ilgi0", function(module, exports) {

var $7mhPs = parcelRequire("7mhPs");
module.exports = Promise.all([
    $7mhPs("5jxBl"),
    $7mhPs("iv2XG"),
    $7mhPs("aV9zV")
]).then(()=>parcelRequire('6K9xo'));

});

parcelRegister("hacB2", function(module, exports) {
'use strict';
var $c7ed243b039b52b5$var$has = Object.prototype.hasOwnProperty, $c7ed243b039b52b5$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $c7ed243b039b52b5$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $c7ed243b039b52b5$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $c7ed243b039b52b5$var$Events().__proto__) $c7ed243b039b52b5$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $c7ed243b039b52b5$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $c7ed243b039b52b5$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $c7ed243b039b52b5$var$EE(fn, context || emitter, once), evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $c7ed243b039b52b5$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $c7ed243b039b52b5$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $c7ed243b039b52b5$var$EventEmitter() {
    this._events = new $c7ed243b039b52b5$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($c7ed243b039b52b5$var$has.call(events, name)) names.push($c7ed243b039b52b5$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $c7ed243b039b52b5$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $c7ed243b039b52b5$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $c7ed243b039b52b5$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $c7ed243b039b52b5$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $c7ed243b039b52b5$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c7ed243b039b52b5$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $c7ed243b039b52b5$var$prefix ? $c7ed243b039b52b5$var$prefix + event : event;
        if (this._events[evt]) $c7ed243b039b52b5$var$clearEvent(this, evt);
    } else {
        this._events = new $c7ed243b039b52b5$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$c7ed243b039b52b5$var$EventEmitter.prototype.off = $c7ed243b039b52b5$var$EventEmitter.prototype.removeListener;
$c7ed243b039b52b5$var$EventEmitter.prototype.addListener = $c7ed243b039b52b5$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$c7ed243b039b52b5$var$EventEmitter.prefixed = $c7ed243b039b52b5$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$c7ed243b039b52b5$var$EventEmitter.EventEmitter = $c7ed243b039b52b5$var$EventEmitter;
module.exports = $c7ed243b039b52b5$var$EventEmitter;

});

parcelRegister("1KT2J", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $97c32b7902cf0ed6$export$64d6499adf9b2e51);

var $houtj = parcelRequire("houtj");
function $97c32b7902cf0ed6$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $houtj.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("houtj", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $618b22bc7e7c0afa$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $618b22bc7e7c0afa$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $618b22bc7e7c0afa$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $618b22bc7e7c0afa$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $618b22bc7e7c0afa$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $618b22bc7e7c0afa$export$404582bc18fe4d9e);
const $618b22bc7e7c0afa$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $618b22bc7e7c0afa$export$f005e2e9f707cb5f = 'commercial';
const $618b22bc7e7c0afa$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $618b22bc7e7c0afa$export$a739cd5aac835909 = 'stg';
const $618b22bc7e7c0afa$export$42dd0cdd351a4a9 = 'prod';
const $618b22bc7e7c0afa$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("eTtS7", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $ad7d5fb26eb33771$export$39716b4af53f4ad);

var $gDf1S = parcelRequire("gDf1S");

var $hGIzV = parcelRequire("hGIzV");
function $ad7d5fb26eb33771$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $gDf1S.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $gDf1S.createStrictSetupError)();
        },
        cx: $hGIzV.cx,
        XCSSProp () {
            throw (0, $gDf1S.createStrictSetupError)();
        }
    };
}

});
parcelRegister("gDf1S", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $c1bbf258741050ab$export$c4df1cb0c2b4d77c);
const $c1bbf258741050ab$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $c1bbf258741050ab$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});


parcelRegister("eduFF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d32ce3f51357233e$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $6tlN4 = parcelRequire("6tlN4");

var $5Qmrb = parcelRequire("5Qmrb");

var $H8FDJ = parcelRequire("H8FDJ");

var $iBcO5 = parcelRequire("iBcO5");

var $jG29I = parcelRequire("jG29I");

var $nPPwU = parcelRequire("nPPwU");

var $iQ4mB = parcelRequire("iQ4mB");
function $d32ce3f51357233e$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $d32ce3f51357233e$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $d32ce3f51357233e$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $jG29I.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $1v5pe.useState)($d32ce3f51357233e$var$initial);
    const onMouseEnter = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $1v5pe.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iQ4mB.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tlN4))).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iQ4mB.default).Consumer, {
            mode: mode,
            state: $d32ce3f51357233e$var$getInteractionState({
                ...state,
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            }),
            iconIsOnlyChild: (0, $H8FDJ.default)(restProps),
            isLoading: isLoading,
            ...restProps
        }, ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5Qmrb.default), {
                ...restProps,
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $iBcO5.default), restProps) : null,
                // No need to render aria-disabled when it is false
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $nPPwU.getSpecifiers)(buttonStyles)
            }))));
}));
// Tools including enzyme rely on components having a display name
$d32ce3f51357233e$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $d32ce3f51357233e$export$2e2bcd8739ae039 = $d32ce3f51357233e$var$CustomThemeButton;

});
parcelRegister("6tlN4", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $1xuMt = parcelRequire("1xuMt");
module.exports = Object.assign({}, $1xuMt, {
    themed: (propsToValues)=>(props)=>{
            const vals = typeof propsToValues === 'function' ? propsToValues(props) : propsToValues;
            return vals.light;
        }
});
if ($1xuMt.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("iBcO5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bac09e2367545890$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $5I7AE = parcelRequire("5I7AE");
function $bac09e2367545890$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $bac09e2367545890$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5I7AE.default), {
        size: size,
        label: ", Loading",
        appearance: $bac09e2367545890$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("jG29I", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $af9996ddd1d07b48$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $af9996ddd1d07b48$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("nPPwU", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $eef0a32b5e180a41$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $eef0a32b5e180a41$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("iQ4mB", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc5bbd794beb60ab$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6tlN4 = parcelRequire("6tlN4");

var $hfjHG = parcelRequire("hfjHG");
const $bc5bbd794beb60ab$var$Theme = (0, $6tlN4.createTheme)((themeProps)=>({
        buttonStyles: (0, $hfjHG.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bc5bbd794beb60ab$export$2e2bcd8739ae039 = $bc5bbd794beb60ab$var$Theme;

});
parcelRegister("hfjHG", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $faef32d12c334334$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eJD8u = parcelRequire("eJD8u");
const $faef32d12c334334$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $faef32d12c334334$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $eJD8u.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $faef32d12c334334$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("kHOHC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6464fc3501ef95b4ce0d44356e317be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12f2748c3811675$var$_react = $f12f2748c3811675$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $f12f2748c3811675$var$_baseNew = $f12f2748c3811675$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $f12f2748c3811675$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12f2748c3811675$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $f12f2748c3811675$var$_react.default.createElement($f12f2748c3811675$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$f12f2748c3811675$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $f12f2748c3811675$var$_default = module.exports.default = $f12f2748c3811675$var$StatusInformationIcon;

});

parcelRegister("1LQZ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d15ab13bccd5974ddb056f1635cc0800>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14a347fd5452dd17$var$_react = $14a347fd5452dd17$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $14a347fd5452dd17$var$_baseNew = $14a347fd5452dd17$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $14a347fd5452dd17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14a347fd5452dd17$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $14a347fd5452dd17$var$_react.default.createElement($14a347fd5452dd17$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$14a347fd5452dd17$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $14a347fd5452dd17$var$_default = module.exports.default = $14a347fd5452dd17$var$StatusWarningIcon;

});

parcelRegister("7IGXm", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $7edeb4032320163a$export$1a04351537078b55);

var $1v5pe = parcelRequire("1v5pe");

var $8g8jL = parcelRequire("8g8jL");

var $gEAl7 = parcelRequire("gEAl7");
function $7edeb4032320163a$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $8g8jL.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $gEAl7.useTrackedRef)(analyticsData);
    const fnRef = (0, $gEAl7.useTrackedRef)(fn);
    const handler = (0, $1v5pe.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("6439G", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $a4bb0dad2b0f6cd4$export$69e99ed50b2534c9);

var $4MXgM = parcelRequire("4MXgM");
function $a4bb0dad2b0f6cd4$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $4MXgM.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("4MXgM", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $ad3035c5b9315788$export$27df359c528b7120);
const $ad3035c5b9315788$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("jL9lp", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $2c5ea079d1bfd0d5$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v0.40.0 */ /* popover.tsx generated by @compiled/babel-plugin v0.40.0 */ /* popover.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $kIqwl = parcelRequire("kIqwl");

var $hMvDh = parcelRequire("hMvDh");

var $1v5pe = parcelRequire("1v5pe");

var $hGIzV = parcelRequire("hGIzV");

var $dmmsG = parcelRequire("dmmsG");

var $fl4ll = parcelRequire("fl4ll");

var $c16KL = parcelRequire("c16KL");

var $fsl6p = parcelRequire("fsl6p");

var $w8uxN = parcelRequire("w8uxN");

var $3Snjp = parcelRequire("3Snjp");

var $eaSsy = parcelRequire("eaSsy");

var $bLaOP = parcelRequire("bLaOP");

var $ilEG4 = parcelRequire("ilEG4");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $2c5ea079d1bfd0d5$var$supportsPopoverHint = (0, $c16KL.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited text-layout properties (e.g.
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
const $2c5ea079d1bfd0d5$var$surfaceResetStyles = {
    root: "_o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
const $2c5ea079d1bfd0d5$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const $2c5ea079d1bfd0d5$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ const $2c5ea079d1bfd0d5$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
const $2c5ea079d1bfd0d5$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $1v5pe.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, placement: placement, testId: testId, isOpen: isOpen, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $1v5pe.useId)();
    const ownRef = (0, $1v5pe.useRef)(null);
    const combinedRef = (0, $fl4ll.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;
    const { phase: phase } = (0, $eaSsy.useAnimatedVisibility)({
        isOpen: isOpen,
        animationKind: 'popover',
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    const isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $bLaOP.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $ilEG4.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    const handleObserverClose = (0, $1v5pe.useCallback)(()=>{
        onClose?.({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $fsl6p.useNotifyOpenLayerObserver)({
        type: role && $2c5ea079d1bfd0d5$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$2c5ea079d1bfd0d5$var$supportsPopoverHint() ? 'auto' : modeProp;
    const popupMotionStyle = (0, $1v5pe.useMemo)(()=>{
        if (!placement || !shouldAnimate) return undefined;
        const { axis: axis, edge: edge } = (0, $w8uxN.resolvePlacement)({
            placement: placement
        });
        return $2c5ea079d1bfd0d5$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    const programmaticCloseRef = (0, $1v5pe.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    const closeReasonRef = (0, $1v5pe.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    const previouslyFocusedElementRef = (0, $1v5pe.useRef)(null);
    const handleBeforeToggle = (0, $1v5pe.useCallback)((event)=>{
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        const active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    const handleToggle = (0, $1v5pe.useCallback)((event)=>{
        const element = ownRef.current;
        if (event.newState === 'open') return;
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                const previouslyFocused = previouslyFocusedElementRef.current;
                const reason = closeReasonRef.current;
                const isProgrammatic = programmaticCloseRef.current;
                const shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $3Snjp.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) {
                // Reset reason so a stale 'escape' from a race with Escape keydown
                // does not corrupt the next browser-dismiss cycle.
                closeReasonRef.current = 'light-dismiss';
                return;
            }
            // Browser dismiss (Escape/click-outside).
            const reason = closeReasonRef.current;
            closeReasonRef.current = 'light-dismiss';
            // Optional: `manual` mode has no `onClose` in the forwarded type.
            onClose?.({
                reason: reason
            });
        }
    }, [
        onClose,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $1v5pe.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $dmmsG.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $dmmsG.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        const unbindBeforeToggle = (0, $dmmsG.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $1v5pe.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $hMvDh.default)([
            $2c5ea079d1bfd0d5$var$styles.root,
            $2c5ea079d1bfd0d5$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $2c5ea079d1bfd0d5$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $2c5ea079d1bfd0d5$var$styles.exit,
            shouldAnimate && $2c5ea079d1bfd0d5$var$styles.motion,
            (0, $hGIzV.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("w8uxN", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $66b0604844607e9f$export$63044d21bc3d3fa2);

var $8r31n = parcelRequire("8r31n");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ const $66b0604844607e9f$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $66b0604844607e9f$export$63044d21bc3d3fa2({ placement: placement }) {
    const consumerGap = placement.offset?.gap;
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        offset: {
            gap: consumerGap === undefined ? $66b0604844607e9f$var$DEFAULT_GAP : (0, $8r31n.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $8r31n.toCssLengthString)({
                    value: placement.offset?.crossAxisShift?.value ?? 0
                }),
                direction: placement.offset?.crossAxisShift?.direction ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("8r31n", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $34b3b64660bbd320$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $34b3b64660bbd320$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});


parcelRegister("3Snjp", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", () => $7359abab294476d5$export$b12adccf56228c71);
/**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ const $7359abab294476d5$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $7359abab294476d5$export$b12adccf56228c71({ role: role }) {
    if (!role) return false;
    return $7359abab294476d5$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("ilEG4", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $ecf1828dad6b4d94$export$e992c40175757a22);

var $1v5pe = parcelRequire("1v5pe");

var $1CaUw = parcelRequire("1CaUw");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $ecf1828dad6b4d94$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $ecf1828dad6b4d94$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $ecf1828dad6b4d94$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $ecf1828dad6b4d94$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$ecf1828dad6b4d94$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $ecf1828dad6b4d94$var$getInitialFocusTarget({ container: container, role: role }) {
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $1CaUw.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($ecf1828dad6b4d94$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $1CaUw.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($ecf1828dad6b4d94$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $1CaUw.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $ecf1828dad6b4d94$export$e992c40175757a22({ elementRef: elementRef, phase: phase, role: role }) {
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    const prevPhaseRef = (0, $1v5pe.useRef)('closed');
    (0, $1v5pe.useEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (!element) return;
        $ecf1828dad6b4d94$var$getInitialFocusTarget({
            container: element,
            role: role
        })?.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("7EdN0", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", () => $83c2343d3cf659ac$export$56b02a1e583f953c);
/**
 * Anchor positioning for top-layer popovers. See
 * `notes/architecture/positioning.md` for the full model.
 *
 * Two runtime paths: CSS Anchor Positioning (modern browsers) and a JS
 * fallback that measures the trigger and writes `top`/`left`.
 *
 * Both paths honour `offset.gap` and `offset.crossAxisShift`. The
 * CSS path passes the values through as strings; the JS fallback resolves
 * them to pixels via a hidden DOM probe (see `resolveCssLengthToPixels`)
 * so tokens, `calc()`, `var()`, etc all work. The JS fallback hides the
 * popover with `opacity: 0` until the first measurement completes, so it
 * is never painted at the wrong location.
 */ 
var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $9q8C6 = parcelRequire("9q8C6");

var $c16KL = parcelRequire("c16KL");

var $6jPWA = parcelRequire("6jPWA");

var $2uH9r = parcelRequire("2uH9r");

var $SOdAk = parcelRequire("SOdAk");

var $fn0x0 = parcelRequire("fn0x0");

var $2Octq = parcelRequire("2Octq");

var $w8uxN = parcelRequire("w8uxN");

var $dKqTB = parcelRequire("dKqTB");
// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ const $83c2343d3cf659ac$var$NoopResizeObserver = class {
    observe() {}
    unobserve() {}
    disconnect() {}
};
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $83c2343d3cf659ac$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ const $83c2343d3cf659ac$var$supportsAnchorPositioning = (0, $c16KL.default)(()=>{
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $83c2343d3cf659ac$var$edgeMargin({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    const value = offset;
    if (axis === 'block' && edge === 'end') return {
        property: 'margin-block-start',
        value: value
    };
    if (axis === 'block' && edge === 'start') return {
        property: 'margin-block-end',
        value: value
    };
    if (axis === 'inline' && edge === 'end') return {
        property: 'margin-inline-start',
        value: value
    };
    if (axis === 'inline' && edge === 'start') return {
        property: 'margin-inline-end',
        value: value
    };
    return {
        property: 'margin-block-start',
        value: value
    };
}
/**
 * Cross-axis shift margin. Margin side matches the popover's anchored
 * cross-axis edge: `align: 'start'` uses the START margin, `align: 'end'`
 * uses the END margin with the sign inverted (so `forwards` is always
 * positive), `align: 'center'` uses START. Margin on the un-anchored side
 * has no effect under CSS Anchor Positioning.
 */ function $83c2343d3cf659ac$var$crossAxisShiftMargin({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const { axis: axis, align: align } = placement;
    const directionSign = direction === 'forwards' ? 1 : -1;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const useEndSide = align === 'end';
    const side = useEndSide ? 'end' : 'start';
    const sideSign = useEndSide ? -1 : 1;
    const finalSign = directionSign * sideSign;
    // Wrap any string in calc() with the sign factor. CSS handles the math.
    const value = finalSign === 1 ? crossAxisShiftCssValue : `calc(-1 * ${crossAxisShiftCssValue})`;
    return {
        property: `margin-${crossAxis}-${side}`,
        value: value
    };
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $83c2343d3cf659ac$var$useStablePlacement(placement) {
    const resolved = (0, $w8uxN.resolvePlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $1v5pe.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $83c2343d3cf659ac$export$56b02a1e583f953c({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement = {}, forceFallbackPositioning: forceFallbackPositioning = false, isEnabled: isEnabled = true, isOpen: isOpen }) {
    const id = (0, $1v5pe.useId)();
    const stablePlacement = $83c2343d3cf659ac$var$useStablePlacement(placement);
    (0, $1v5pe.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const trigger = anchorRef.current;
        const popover = popoverRef.current;
        if (!trigger || !popover) return;
        const gapCssValue = stablePlacement.offset.gap;
        const crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        const shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($83c2343d3cf659ac$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            const anchorName = trigger.style.getPropertyValue('anchor-name') || `--anchor-${id.replace(/:/g, '')}`;
            const gap = $83c2343d3cf659ac$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; reused below to populate the active
            // `--ds-cross-axis-shift-margin-*` custom property for the
            // named arrow @position-try rules.
            const crossAxisShift = $83c2343d3cf659ac$var$crossAxisShiftMargin({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            const popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $SOdAk.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $fn0x0.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                {
                    property: gap.property,
                    value: gap.value
                },
                {
                    property: crossAxisShift.property,
                    value: crossAxisShift.value
                }
            ];
            // Expose the active cross-axis shift via custom properties so each
            // named arrow @position-try rule can re-apply it after a flip.
            // One of the four (cross-axis, side) properties is non-zero at a time.
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-end',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-end',
                value: '0px'
            });
            // `crossAxisShift` IS the active margin; reuse instead of recomputing.
            const crossAxisShiftActive = crossAxisShift;
            const customPropertyByMarginProperty = {
                'margin-inline-start': '--ds-cross-axis-shift-margin-start',
                'margin-inline-end': '--ds-cross-axis-shift-margin-end',
                'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
                'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
            };
            const crossAxisShiftCustomProperty = customPropertyByMarginProperty[crossAxisShiftActive.property];
            if (crossAxisShiftCustomProperty) popoverStyles.push({
                property: crossAxisShiftCustomProperty,
                value: crossAxisShiftActive.value
            });
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            const undoPositioning = (0, $2uH9r.combine)((0, $dKqTB.setStyle)({
                element: popover,
                styles: popoverStyles
            }));
            return undoPositioning;
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        const cleanupBaseStyles = (0, $dKqTB.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        function update() {
            if (!trigger || !popover) return;
            const triggerRect = trigger.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            const gapPx = (0, $2Octq.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            const crossAxisShiftPx = (0, $2Octq.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            const { top: top, left: left } = (0, $6jPWA.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            });
            popover.style.setProperty('top', `${top}px`);
            popover.style.setProperty('left', `${left}px`);
            // Reveal the popover only after it has been positioned.
            // See the toggle listener below for why we hide on open.
            popover.style.removeProperty('opacity');
        }
        // Throttle scroll/resize updates to one per animation frame
        const scheduledUpdate = (0, $9q8C6.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        const ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $83c2343d3cf659ac$var$NoopResizeObserver;
        const resizeObserver = new ResizeObserverImpl(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($83c2343d3cf659ac$var$isPopoverOpen(popover)) {
            popover.style.setProperty('opacity', '0');
            resizeObserver.observe(popover);
        }
        const undoPositioning = (0, $2uH9r.combine)(cleanupBaseStyles, // On every open: hide synchronously so the user never sees
        // the UA-default position, then re-observe for a fresh
        // measurement. We use `opacity: 0` rather than
        // `visibility: hidden` because Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal. See
        // `form-in-popup.spec.tsx` on `desktop-firefox`.
        (0, $dmmsG.bind)(popover, {
            type: 'toggle',
            listener: (event)=>{
                const toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    popover.style.setProperty('opacity', '0');
                    resizeObserver.observe(popover);
                }
            }
        }), ()=>resizeObserver.disconnect(), (0, $dmmsG.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $dmmsG.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), ()=>{
            scheduledUpdate.cancel();
            popover.style.removeProperty('top');
            popover.style.removeProperty('left');
            popover.style.removeProperty('opacity');
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("6jPWA", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $ce1c1570938dbad2$export$d5ef1dac02135664);
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $ce1c1570938dbad2$var$computeEdgePosition({ axis: axis, edge: edge, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        const spaceBelow = viewport.height - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        const spaceAbove = triggerRect.top;
        const spaceBelow = viewport.height - triggerRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const useAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        const spaceRight = viewport.width - triggerRect.right;
        const spaceLeft = triggerRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        const spaceLeft = triggerRect.left;
        const spaceRight = viewport.width - triggerRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const useLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $ce1c1570938dbad2$var$applyAlignment({ position: position, axis: axis, align: align, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return {
            ...position,
            left: triggerRect.left
        };
        // align === 'end'
        return {
            ...position,
            left: triggerRect.right - popoverWidth
        };
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return {
        ...position,
        top: triggerRect.top
    };
    // align === 'end'
    return {
        ...position,
        top: triggerRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset.
 *
 * The sign mirrors the CSS path (see `crossAxisShiftMargin` in
 * `use-anchor-position.tsx`):
 *   - `align: 'start' | 'center'` + `forwards`  → push toward end (positive)
 *   - `align: 'end'`              + `forwards`  → push toward start (negative)
 *   - `backwards` flips the sign in both cases.
 */ function $ce1c1570938dbad2$var$applyCrossAxisShift({ position: position, axis: axis, align: align, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const sideSign = align === 'end' ? -1 : 1;
    const delta = crossAxisShift.value * directionSign * sideSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $ce1c1570938dbad2$export$d5ef1dac02135664({ triggerRect: triggerRect, popoverEl: popoverEl, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    const popoverWidth = popoverEl.offsetWidth;
    const popoverHeight = popoverEl.offsetHeight;
    const basePosition = $ce1c1570938dbad2$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $ce1c1570938dbad2$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $ce1c1570938dbad2$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        align: align,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("2uH9r", function(module, exports) {
$parcel$export(module.exports, "combine", () => $177bb383354a9b97$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $177bb383354a9b97$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((callback)=>callback?.());
    };
}

});

parcelRegister("SOdAk", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $af251e087d568e42$export$de49b61f233ddeb9);

var $w8uxN = parcelRequire("w8uxN");
function $af251e087d568e42$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = (0, $w8uxN.resolvePlacement)({
        placement: placement
    });
    const edgeValue = `${axis}-${edge}`;
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDir = align === 'start' ? 'end' : 'start';
    return `${edgeValue} span-${crossAxis}-${spanDir}`;
}

});

parcelRegister("fn0x0", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $0219925b37a22a2f$export$c4e16947a95d61f1);

var $w8uxN = parcelRequire("w8uxN");
function $0219925b37a22a2f$var$slideOnEdge({ align: align, edgeKey: edgeKey, crossAxis: crossAxis }) {
    if (align === 'center') return [
        `${edgeKey} span-${crossAxis}-end`,
        `${edgeKey} span-${crossAxis}-start`
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    const near = align === 'start' ? 'end' : 'start';
    const far = align === 'start' ? 'start' : 'end';
    return [
        `${edgeKey} span-${crossAxis}-${near}`,
        edgeKey,
        `${edgeKey} span-${crossAxis}-${far}`
    ];
}
function $0219925b37a22a2f$var$flipDiagonally({ axis: axis }) {
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    const flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${flipOnMainAxis} ${flipToCrossAxis}`;
}
function $0219925b37a22a2f$export$c4e16947a95d61f1({ placement: placement }) {
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ const resolved = (0, $w8uxN.resolvePlacement)({
        placement: placement
    });
    const { axis: axis, edge: edge, align: align } = resolved;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const flippedEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${flippedEdge}`;
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $0219925b37a22a2f$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $0219925b37a22a2f$var$flipDiagonally({
            axis: axis
        }) : null,
        $0219925b37a22a2f$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}

});

parcelRegister("2Octq", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $35b07ad90ce4713a$export$98721546d2816d9e);
const $35b07ad90ce4713a$var$elementCaches = new WeakMap();
function $35b07ad90ce4713a$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $35b07ad90ce4713a$var$getCachedResolvedLength({ element: element, value: value }) {
    if (!$35b07ad90ce4713a$var$canCacheResolvedLength(value)) return null;
    const cacheForElement = $35b07ad90ce4713a$var$elementCaches.get(element);
    return cacheForElement?.get(value) ?? null;
}
function $35b07ad90ce4713a$var$cacheResolvedLength({ element: element, value: value, result: result }) {
    if (!$35b07ad90ce4713a$var$canCacheResolvedLength(value)) return;
    const cacheForElement = $35b07ad90ce4713a$var$elementCaches.get(element) ?? new Map();
    cacheForElement.set(value, result);
    $35b07ad90ce4713a$var$elementCaches.set(element, cacheForElement);
}
function $35b07ad90ce4713a$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    const pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    const cached = $35b07ad90ce4713a$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    const resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    const result = Number.isFinite(resolved) ? resolved : 0;
    $35b07ad90ce4713a$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("dKqTB", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $a23d91c132b59eec$export$37a5fde709c1db82);
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $a23d91c132b59eec$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("hF1ty", function(module, exports) {
$parcel$export(module.exports, "useAnchorPositionAtPoint", () => $0a49c3f3fd11dbb9$export$6f230729189a5b8a);

var $1v5pe = parcelRequire("1v5pe");

var $7EdN0 = parcelRequire("7EdN0");
/**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $0a49c3f3fd11dbb9$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $0a49c3f3fd11dbb9$export$6f230729189a5b8a({ popoverRef: popoverRef, placement: placement, getPoint: getPoint, isEnabled: isEnabled = true, isOpen: isOpen }) {
    const syntheticAnchorRef = (0, $1v5pe.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    const getPointRef = (0, $1v5pe.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $1v5pe.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $0a49c3f3fd11dbb9$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = `${point.y}px`;
        anchor.style.left = `${point.x}px`;
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $7EdN0.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}

});

parcelRegister("fZI65", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $6b8f44bf9ae3bdad$export$9198c6c168be2eeb);

var $lHxwq = parcelRequire("lHxwq");
function $6b8f44bf9ae3bdad$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return `popover-${(0, $lHxwq.useId)()}`;
}

});

parcelRegister("hGfOz", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", () => $dfe6ff052ff42192$export$7071d791a7b131ed);

var $1v5pe = parcelRequire("1v5pe");

var $dKqTB = parcelRequire("dKqTB");
function $dfe6ff052ff42192$export$7071d791a7b131ed({ mode: mode, popoverRef: popoverRef, anchorRef: anchorRef, isOpen: isOpen }) {
    (0, $1v5pe.useLayoutEffect)(()=>{
        const node = popoverRef.current;
        if (!node) return;
        // Feature-detect `anchor-size()` specifically (not just `anchor-name`)
        // so the JS fallback fires correctly in browsers that support anchor
        // positioning but not anchor sizing.
        const supportsAnchorSize = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('width', 'anchor-size(width)');
        if (mode === 'match-anchor') {
            // Set an exact width matching the anchor.
            // `min-inline-size` is intentionally NOT set here - it would override the
            // explicit width constraint, allowing the popover to grow past the anchor's width.
            if (supportsAnchorSize) return (0, $dKqTB.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            // JS fallback: one-off read of the anchor's width.
            const anchor = anchorRef.current;
            if (anchor) return (0, $dKqTB.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            return;
        }
        // For 'min-anchor' and 'none', apply `min-inline-size: max-content` to ensure
        // correct position-try-fallbacks behaviour (popover margin box overflows the
        // viewport when its span region is too narrow, rather than wrapping content).
        const minInlineSizeStyle = {
            property: 'min-inline-size',
            value: 'max-content'
        };
        if (mode === 'min-anchor') {
            // Set a minimum width matching the anchor. The popover can grow wider
            // if its content requires it.
            if (supportsAnchorSize) return (0, $dKqTB.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            const anchor = anchorRef.current;
            if (anchor) return (0, $dKqTB.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            // No anchor available in JS fallback - still apply min-inline-size.
            return (0, $dKqTB.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle
                ]
            });
        }
        // 'none' mode: no explicit width, but still apply `min-inline-size: max-content`.
        return (0, $dKqTB.setStyle)({
            element: node,
            styles: [
                minInlineSizeStyle
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("j5RGe", function(module, exports) {
$parcel$export(module.exports, "default", () => $b03a10dc09d07869$export$2e2bcd8739ae039);

var $21yAH = parcelRequire("21yAH");

var $cgaUN = parcelRequire("cgaUN");
class $b03a10dc09d07869$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $b03a10dc09d07869$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$b03a10dc09d07869$export$2e2bcd8739ae039.observer) {
            $b03a10dc09d07869$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $cgaUN.default)();
                $b03a10dc09d07869$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $b03a10dc09d07869$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $21yAH.THEME_DATA_ATTRIBUTE),
                    (0, $21yAH.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $b03a10dc09d07869$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($b03a10dc09d07869$export$2e2bcd8739ae039.callbacks.size === 0 && $b03a10dc09d07869$export$2e2bcd8739ae039.observer) {
            $b03a10dc09d07869$export$2e2bcd8739ae039.observer.disconnect();
            $b03a10dc09d07869$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});

parcelRegister("6p0OQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6af69c0da1151808644d1b7c1f4d031c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a95b6879649f707$var$_react = $4a95b6879649f707$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $4a95b6879649f707$var$_baseNew = $4a95b6879649f707$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $4a95b6879649f707$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a95b6879649f707$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $4a95b6879649f707$var$_react.default.createElement($4a95b6879649f707$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$4a95b6879649f707$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $4a95b6879649f707$var$_default = module.exports.default = $4a95b6879649f707$var$ChevronDownIcon;

});

parcelRegister("See7r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43da111d5da2bc4c58e22bdbb274e37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a3014644fe1d04b$var$_react = $0a3014644fe1d04b$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $0a3014644fe1d04b$var$_baseNew = $0a3014644fe1d04b$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $0a3014644fe1d04b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0a3014644fe1d04b$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $0a3014644fe1d04b$var$_react.default.createElement($0a3014644fe1d04b$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$0a3014644fe1d04b$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $0a3014644fe1d04b$var$_default = module.exports.default = $0a3014644fe1d04b$var$ChevronUpIcon;

});

parcelRegister("5Wk1R", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $4531e7dae4644d11$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $4531e7dae4644d11$var$invariant;

});

parcelRegister("3BJhC", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("j2K7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $daee67072644a367$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $cgaUN = parcelRequire("cgaUN");

var $j5RGe = parcelRequire("j5RGe");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $daee67072644a367$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $1v5pe.useState)((0, $cgaUN.default)());
    (0, $1v5pe.useEffect)(()=>{
        const observer = new (0, $j5RGe.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $daee67072644a367$export$2e2bcd8739ae039 = $daee67072644a367$var$useThemeObserver;

});

parcelRegister("kHb6M", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $9e342fc2b1cfe745$export$839b022803d38d4d);

var $ggGWC = parcelRequire("ggGWC");

var $dEnZ3 = parcelRequire("dEnZ3");
function $9e342fc2b1cfe745$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return (0, $dEnZ3.isIsolatedCloud)() ? globalThis.ssrContext?.icName : undefined;
    const atlCtxCookieValues = (0, $ggGWC.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}

});
parcelRegister("dEnZ3", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $812d05a916a874d0$export$9186ccba8effc5de);

var $bIhqQ = parcelRequire("bIhqQ");

var $ggGWC = parcelRequire("ggGWC");
function $812d05a916a874d0$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext?.isInIC ?? false;
    const atlCtxCookieValues = (0, $ggGWC.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $bIhqQ.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("bIhqQ", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $70c90d79d9f5ec2b$export$d8347b4aae768c2d);

var $aPJb3 = parcelRequire("aPJb3");
const $70c90d79d9f5ec2b$export$d8347b4aae768c2d = [
    (0, $aPJb3.COMMERCIAL)
];

});



parcelRegister("9FFsN", function(module, exports) {
$parcel$export(module.exports, "extract", () => $70a81b2540816ea4$export$f9380c9a627682d3, (v) => $70a81b2540816ea4$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $70a81b2540816ea4$export$98e6a39c04603d36, (v) => $70a81b2540816ea4$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $70a81b2540816ea4$export$fac44ee5b035f737, (v) => $70a81b2540816ea4$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $70a81b2540816ea4$export$7a5253c0f62e0150, (v) => $70a81b2540816ea4$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $70a81b2540816ea4$export$a8c1621ea79325d3, (v) => $70a81b2540816ea4$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $70a81b2540816ea4$export$357523c63a2253b9, (v) => $70a81b2540816ea4$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $70a81b2540816ea4$export$44c361b8ec72ef7f, (v) => $70a81b2540816ea4$export$44c361b8ec72ef7f = v);
var $70a81b2540816ea4$export$f9380c9a627682d3;
var $70a81b2540816ea4$export$98e6a39c04603d36;
var $70a81b2540816ea4$export$fac44ee5b035f737;
var $70a81b2540816ea4$export$7a5253c0f62e0150;
var $70a81b2540816ea4$export$a8c1621ea79325d3;
var $70a81b2540816ea4$export$357523c63a2253b9;
var $70a81b2540816ea4$export$44c361b8ec72ef7f;
'use strict';

var $9c1gy = parcelRequire("9c1gy");

var $dkHF4 = parcelRequire("dkHF4");

var $2DDeI = parcelRequire("2DDeI");

var $4eK5n = parcelRequire("4eK5n");
const $70a81b2540816ea4$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $70a81b2540816ea4$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $70a81b2540816ea4$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[',
                            $70a81b2540816ea4$var$encode(index, options),
                            ']=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '[]=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            ':list=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $70a81b2540816ea4$var$encode(key, options),
                                keyValueSep,
                                $70a81b2540816ea4$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $70a81b2540816ea4$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $70a81b2540816ea4$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $70a81b2540816ea4$var$encode(key, options),
                            '=',
                            $70a81b2540816ea4$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $70a81b2540816ea4$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $70a81b2540816ea4$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $70a81b2540816ea4$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$70a81b2540816ea4$var$decode(item, options)) : value === null ? value : $70a81b2540816ea4$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $70a81b2540816ea4$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$70a81b2540816ea4$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $70a81b2540816ea4$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $70a81b2540816ea4$var$encode(value, options) {
    if (options.encode) return options.strict ? $9c1gy(value) : encodeURIComponent(value);
    return value;
}
function $70a81b2540816ea4$var$decode(value, options) {
    if (options.decode) return $dkHF4(value);
    return value;
}
function $70a81b2540816ea4$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $70a81b2540816ea4$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $70a81b2540816ea4$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $70a81b2540816ea4$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $70a81b2540816ea4$var$extract(input) {
    input = $70a81b2540816ea4$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $70a81b2540816ea4$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $70a81b2540816ea4$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $70a81b2540816ea4$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $70a81b2540816ea4$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $2DDeI(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $70a81b2540816ea4$var$decode(value, options);
        formatter($70a81b2540816ea4$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $70a81b2540816ea4$var$parseValue(value[k], options);
        else ret[key] = $70a81b2540816ea4$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $70a81b2540816ea4$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$70a81b2540816ea4$export$f9380c9a627682d3 = $70a81b2540816ea4$var$extract;
$70a81b2540816ea4$export$98e6a39c04603d36 = $70a81b2540816ea4$var$parse;
$70a81b2540816ea4$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $70a81b2540816ea4$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $70a81b2540816ea4$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $70a81b2540816ea4$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $70a81b2540816ea4$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $70a81b2540816ea4$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $70a81b2540816ea4$var$encode(key, options) + '=' + $70a81b2540816ea4$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$70a81b2540816ea4$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $2DDeI(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $70a81b2540816ea4$var$parse($70a81b2540816ea4$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $70a81b2540816ea4$var$decode(hash, options)
    } : {});
};
$70a81b2540816ea4$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$70a81b2540816ea4$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $70a81b2540816ea4$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $70a81b2540816ea4$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $70a81b2540816ea4$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $70a81b2540816ea4$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $70a81b2540816ea4$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$70a81b2540816ea4$var$encodeFragmentIdentifier] ? $70a81b2540816ea4$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$70a81b2540816ea4$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$70a81b2540816ea4$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $70a81b2540816ea4$export$7a5253c0f62e0150(input, options);
    return $70a81b2540816ea4$export$a8c1621ea79325d3({
        url: url,
        query: $4eK5n(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$70a81b2540816ea4$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $70a81b2540816ea4$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("9c1gy", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("dkHF4", function(module, exports) {
'use strict';
var $9b4f02e1ed474cb7$var$token = '%[a-f0-9]{2}';
var $9b4f02e1ed474cb7$var$singleMatcher = new RegExp('(' + $9b4f02e1ed474cb7$var$token + ')|([^%]+?)', 'gi');
var $9b4f02e1ed474cb7$var$multiMatcher = new RegExp('(' + $9b4f02e1ed474cb7$var$token + ')+', 'gi');
function $9b4f02e1ed474cb7$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $9b4f02e1ed474cb7$var$decodeComponents(left), $9b4f02e1ed474cb7$var$decodeComponents(right));
}
function $9b4f02e1ed474cb7$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($9b4f02e1ed474cb7$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $9b4f02e1ed474cb7$var$decodeComponents(tokens, i).join('');
            tokens = input.match($9b4f02e1ed474cb7$var$singleMatcher) || [];
        }
        return input;
    }
}
function $9b4f02e1ed474cb7$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $9b4f02e1ed474cb7$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $9b4f02e1ed474cb7$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $9b4f02e1ed474cb7$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $9b4f02e1ed474cb7$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("2DDeI", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("4eK5n", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("3WNR1", function(module, exports) {
'use strict';

var $2Kd38 = parcelRequire("2Kd38");
/**
 * Expose `traverse`.
 */ module.exports = $2dfd75dfb2dce420$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $2dfd75dfb2dce420$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $2dfd75dfb2dce420$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $2dfd75dfb2dce420$var$traverseArray(input, strict);
    else if ($2Kd38.is(input, strict)) return $2Kd38.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $2dfd75dfb2dce420$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $2dfd75dfb2dce420$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $2dfd75dfb2dce420$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $2dfd75dfb2dce420$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("2Kd38", function(module, exports) {
$parcel$export(module.exports, "parse", () => $1ffa0000a57ce84b$export$98e6a39c04603d36, (v) => $1ffa0000a57ce84b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $1ffa0000a57ce84b$export$226b3eccf92c9ed9, (v) => $1ffa0000a57ce84b$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $1ffa0000a57ce84b$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $1ffa0000a57ce84b$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $1ffa0000a57ce84b$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$1ffa0000a57ce84b$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $1ffa0000a57ce84b$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$1ffa0000a57ce84b$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $1ffa0000a57ce84b$var$matcher.test(string);
};

});


parcelRegister("75pqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $528cb9888068240e$export$2e2bcd8739ae039);

var $fwHtn = parcelRequire("fwHtn");

var $90QDS = parcelRequire("90QDS");

var $aGVpx = parcelRequire("aGVpx");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $528cb9888068240e$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $528cb9888068240e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aGVpx.default)(2, arguments);
    var dateLeft = (0, $fwHtn.default)(dirtyDateLeft);
    var dateRight = (0, $fwHtn.default)(dirtyDateRight);
    var sign = $528cb9888068240e$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $90QDS.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($528cb9888068240e$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("fwHtn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4db90f1fc297c62$export$2e2bcd8739ae039);

var $ebQXH = parcelRequire("ebQXH");

var $aGVpx = parcelRequire("aGVpx");
function $b4db90f1fc297c62$export$2e2bcd8739ae039(argument) {
    (0, $aGVpx.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $ebQXH.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("aGVpx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c8a5c373eceec49$export$2e2bcd8739ae039);
function $7c8a5c373eceec49$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("90QDS", function(module, exports) {
$parcel$export(module.exports, "default", () => $68fcf2ca31f71173$export$2e2bcd8739ae039);

var $7VYPy = parcelRequire("7VYPy");

var $3brbU = parcelRequire("3brbU");

var $aGVpx = parcelRequire("aGVpx");
var $68fcf2ca31f71173$var$MILLISECONDS_IN_DAY = 86400000;
function $68fcf2ca31f71173$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aGVpx.default)(2, arguments);
    var startOfDayLeft = (0, $3brbU.default)(dirtyDateLeft);
    var startOfDayRight = (0, $3brbU.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $7VYPy.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $7VYPy.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $68fcf2ca31f71173$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("7VYPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c6d0af2b07a2d73$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $5c6d0af2b07a2d73$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("3brbU", function(module, exports) {
$parcel$export(module.exports, "default", () => $25177dc20b8655a0$export$2e2bcd8739ae039);

var $fwHtn = parcelRequire("fwHtn");

var $aGVpx = parcelRequire("aGVpx");
function $25177dc20b8655a0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aGVpx.default)(1, arguments);
    var date = (0, $fwHtn.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("cwFVG", function(module, exports) {
$parcel$export(module.exports, "default", () => $91e8ff83ae1b0516$export$2e2bcd8739ae039);
var $91e8ff83ae1b0516$var$isProduction = true;
var $91e8ff83ae1b0516$var$prefix = 'Invariant failed';
function $91e8ff83ae1b0516$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($91e8ff83ae1b0516$var$isProduction) throw new Error($91e8ff83ae1b0516$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($91e8ff83ae1b0516$var$prefix, ": ").concat(provided) : $91e8ff83ae1b0516$var$prefix;
    throw new Error(value);
}

});

parcelRegister("8DJJm", function(module, exports) {
$parcel$export(module.exports, "default", () => $64a5706228df7f3f$export$2e2bcd8739ae039);

var $jmiQS = parcelRequire("jmiQS");

var $ciYbF = parcelRequire("ciYbF");

var $2F73D = parcelRequire("2F73D");

var $5JACb = parcelRequire("5JACb");
function $64a5706228df7f3f$export$2e2bcd8739ae039(r) {
    return (0, $jmiQS.default)(r) || (0, $ciYbF.default)(r) || (0, $2F73D.default)(r) || (0, $5JACb.default)();
}

});
parcelRegister("jmiQS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e17eb1f5a625d0ef$export$2e2bcd8739ae039);

var $6PHt4 = parcelRequire("6PHt4");
function $e17eb1f5a625d0ef$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $6PHt4.default)(r);
}

});
parcelRegister("6PHt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f9939508535248f$export$2e2bcd8739ae039);
function $4f9939508535248f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("ciYbF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f55da6080fcbe48$export$2e2bcd8739ae039);
function $8f55da6080fcbe48$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("2F73D", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f04e29861d89dd2$export$2e2bcd8739ae039);

var $6PHt4 = parcelRequire("6PHt4");
function $1f04e29861d89dd2$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $6PHt4.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $6PHt4.default)(r, a) : void 0;
    }
}

});

parcelRegister("5JACb", function(module, exports) {
$parcel$export(module.exports, "default", () => $42cd8eadc628a70e$export$2e2bcd8739ae039);
function $42cd8eadc628a70e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("aHHxB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cafb1d869c61cd5$export$2e2bcd8739ae039);

var $2O9FJ = parcelRequire("2O9FJ");

var $7Vg2o = parcelRequire("7Vg2o");

var $2F73D = parcelRequire("2F73D");

var $3rTYB = parcelRequire("3rTYB");
function $7cafb1d869c61cd5$export$2e2bcd8739ae039(r, e) {
    return (0, $2O9FJ.default)(r) || (0, $7Vg2o.default)(r, e) || (0, $2F73D.default)(r, e) || (0, $3rTYB.default)();
}

});
parcelRegister("2O9FJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $20b7c0efb9fe7864$export$2e2bcd8739ae039);
function $20b7c0efb9fe7864$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("7Vg2o", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c4a4c01b3b4a9f5$export$2e2bcd8739ae039);
function $5c4a4c01b3b4a9f5$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3rTYB", function(module, exports) {
$parcel$export(module.exports, "default", () => $282f50745c15ad9b$export$2e2bcd8739ae039);
function $282f50745c15ad9b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("68sLR", function(module, exports) {
$parcel$export(module.exports, "default", () => $4779cebd937020fa$export$2e2bcd8739ae039);

var $3mdE8 = parcelRequire("3mdE8");
function $4779cebd937020fa$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3mdE8.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("dEGdm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec1b1ad1c034dad44344f797e0630b31>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f0fc1bb0ceaf995$var$_react = $9f0fc1bb0ceaf995$var$_interopRequireDefault((parcelRequire("1v5pe")));

var $9f0fc1bb0ceaf995$var$_baseNew = $9f0fc1bb0ceaf995$var$_interopRequireDefault((parcelRequire("9ZOp1")));
function $9f0fc1bb0ceaf995$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f0fc1bb0ceaf995$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $9f0fc1bb0ceaf995$var$_react.default.createElement($9f0fc1bb0ceaf995$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$9f0fc1bb0ceaf995$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $9f0fc1bb0ceaf995$var$_default = module.exports.default = $9f0fc1bb0ceaf995$var$ShowMoreHorizontalIcon;

});

parcelRegister("buVzG", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $85ef282a3a95bb33$var$__DEV__ = false;
var $85ef282a3a95bb33$var$warning = function() {};
if ($85ef282a3a95bb33$var$__DEV__) {
    var $85ef282a3a95bb33$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $85ef282a3a95bb33$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $85ef282a3a95bb33$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $85ef282a3a95bb33$var$warning;

});

parcelRegister("73rbT", function(module, exports) {

var $d7Zdm = parcelRequire("d7Zdm");
var $522de7c5d7bf45c6$var$listeningFocusTrap = null;
function $522de7c5d7bf45c6$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $522de7c5d7bf45c6$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($522de7c5d7bf45c6$var$listeningFocusTrap) $522de7c5d7bf45c6$var$listeningFocusTrap.pause();
        $522de7c5d7bf45c6$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        $522de7c5d7bf45c6$var$tryFocus(firstFocusNode());
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $522de7c5d7bf45c6$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $522de7c5d7bf45c6$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $522de7c5d7bf45c6$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $522de7c5d7bf45c6$var$tryFocus(lastTabbableNode);
            return $522de7c5d7bf45c6$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $522de7c5d7bf45c6$var$tryFocus(firstTabbableNode);
        $522de7c5d7bf45c6$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $d7Zdm(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $522de7c5d7bf45c6$var$tryFocus(lastTabbableNode);
        $522de7c5d7bf45c6$var$tryFocus(firstTabbableNode);
    }
}
function $522de7c5d7bf45c6$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $522de7c5d7bf45c6$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $522de7c5d7bf45c6$var$focusTrap;

});
parcelRegister("d7Zdm", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $98eb69b7c9d0c9bd$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $98eb69b7c9d0c9bd$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("lCX8B", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $9ccccad6ce8cd30b$export$9dd1d61dd4d4755);

var $6CPFR = parcelRequire("6CPFR");
function $9ccccad6ce8cd30b$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `roleToAriaHasPopup` accepts a wider role union (including tooltip-family
    // roles that map to `undefined`). `TAriaForTriggerRole` excludes those, so
    // the returned value is guaranteed to be a defined string. The cast narrows
    // the wider helper signature to match.
    const ariaHasPopup = (0, $6CPFR.roleToAriaHasPopup)({
        role: role
    });
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': ariaHasPopup,
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});
parcelRegister("6CPFR", function(module, exports) {
$parcel$export(module.exports, "roleToAriaHasPopup", () => $add0bb8444e3a709$export$6cb223e9f5abbdb0);
function $add0bb8444e3a709$export$6cb223e9f5abbdb0({ role: role }) {
    if (role === 'menu') return 'menu';
    if (role === 'listbox') return 'listbox';
    if (role === 'tree') return 'tree';
    if (role === 'grid') return 'grid';
    if (role === 'dialog' || role === 'alertdialog') return 'dialog';
    // Non-popup roles (tooltip, note, status, alert, log) and the
    // no-role case: omit `aria-haspopup` entirely. React drops the
    // attribute when the value is `undefined`.
    return undefined;
}

});


parcelRegister("gwg8K", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $3b5bf4c3b75e7323$export$27b4de066896ac63);
function $3b5bf4c3b75e7323$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});

parcelRegister("iZeuf", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $e93112f190ac8ffc$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $kIqwl = parcelRequire("kIqwl");
parcelRequire("1v5pe");

var $hMvDh = parcelRequire("hMvDh");
const $e93112f190ac8ffc$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $e93112f190ac8ffc$export$8b7437164e479115({ children: children }) {
    return /*#__PURE__*/ (0, $kIqwl.jsx)("div", {
        className: (0, $hMvDh.default)([
            $e93112f190ac8ffc$var$styles.root
        ]),
        children: children
    });
}

});

parcelRegister("gQyTH", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b19770410a1bc1c$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.40.0 */ /* link.tsx generated by @compiled/babel-plugin v0.40.0 */ /* link.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $Ms2ib = parcelRequire("Ms2ib");

var $2aEiL = parcelRequire("2aEiL");

var $hK1py = parcelRequire("hK1py");

var $1TZ74 = parcelRequire("1TZ74");

var $lreqQ = parcelRequire("lreqQ");
const $8b19770410a1bc1c$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const $8b19770410a1bc1c$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $8b19770410a1bc1c$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $8b19770410a1bc1c$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _irr31afz _1di61kru"
};
const $8b19770410a1bc1c$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $8b19770410a1bc1c$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $8b19770410a1bc1c$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $8b19770410a1bc1c$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $8b19770410a1bc1c$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $8b19770410a1bc1c$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $1v5pe.useRef)(null);
    (0, $Ms2ib.default)(localRef, autoFocus);
    const combinedRef = (0, $fl4ll.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $1v5pe.createElement((0, $hK1py.Anchor), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $ky45w.cx)($8b19770410a1bc1c$var$styles.base, (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $8b19770410a1bc1c$var$styles.baseT26Shape, !isDisabled && (0, $2aEiL.fg)('platform-dst-motion-uplift-button') && $8b19770410a1bc1c$var$styles.interactiveMotion, appearance === 'default' && $8b19770410a1bc1c$var$defaultStyles.root, appearance === 'primary' && $8b19770410a1bc1c$var$primaryStyles.root, appearance === 'rovo' && $8b19770410a1bc1c$var$rovoStyles.root, appearance === 'warning' && $8b19770410a1bc1c$var$warningStyles.root, appearance === 'danger' && $8b19770410a1bc1c$var$dangerStyles.root, appearance === 'discovery' && $8b19770410a1bc1c$var$discoveryStyles.root, appearance === 'subtle' && $8b19770410a1bc1c$var$subtleStyles.root, $8b19770410a1bc1c$var$styles.linkDecorationUnset, isSelected && $8b19770410a1bc1c$var$selectedStyles.root, isSelected && appearance === 'danger' && $8b19770410a1bc1c$var$selectedStyles.danger, isSelected && appearance === 'warning' && $8b19770410a1bc1c$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $8b19770410a1bc1c$var$selectedStyles.discovery, isDisabled && $8b19770410a1bc1c$var$styles.disabled, spacing === 'compact' && $8b19770410a1bc1c$var$styles.spacingCompact, hasIconBefore && $8b19770410a1bc1c$var$styles.buttonIconBefore, hasIconAfter && $8b19770410a1bc1c$var$styles.buttonIconAfter, shouldFitContainer && $8b19770410a1bc1c$var$styles.fullWidth)
    }, iconBefore && /*#__PURE__*/ $1v5pe.createElement((0, $1TZ74.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $1v5pe.createElement((0, $lreqQ.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $1v5pe.createElement((0, $1TZ74.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $1v5pe.createElement((0, $1TZ74.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $1v5pe.createElement((0, $lreqQ.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $8b19770410a1bc1c$var$LinkButton = /*#__PURE__*/ (0, $1v5pe.forwardRef)($8b19770410a1bc1c$var$LinkButtonBase);
$8b19770410a1bc1c$var$LinkButton.displayName = 'LinkButton';
var $8b19770410a1bc1c$export$2e2bcd8739ae039 = $8b19770410a1bc1c$var$LinkButton;

});

parcelRegister("iPwBl", function(module, exports) {
$parcel$export(module.exports, "default", () => $28de279ae06ecdcb$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.40.0 */ /* link.tsx generated by @compiled/babel-plugin v0.40.0 */ /* link.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $1v5pe = parcelRequire("1v5pe");

var $ky45w = parcelRequire("ky45w");

var $fl4ll = parcelRequire("fl4ll");

var $Ms2ib = parcelRequire("Ms2ib");

var $2aEiL = parcelRequire("2aEiL");

var $hK1py = parcelRequire("hK1py");

var $1Tz0w = parcelRequire("1Tz0w");

var $kFr83 = parcelRequire("kFr83");

var $1TZ74 = parcelRequire("1TZ74");

var $lreqQ = parcelRequire("lreqQ");
const $28de279ae06ecdcb$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const $28de279ae06ecdcb$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $28de279ae06ecdcb$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $28de279ae06ecdcb$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _irr31afz _1di61kru"
};
const $28de279ae06ecdcb$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $28de279ae06ecdcb$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $28de279ae06ecdcb$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $28de279ae06ecdcb$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $1v5pe.useRef)(null);
    (0, $Ms2ib.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ $1v5pe.createElement((0, $1Tz0w.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
    }, (triggerProps)=>/*#__PURE__*/ $1v5pe.createElement((0, $hK1py.Anchor), {
            ...saferRest,
            "aria-labelledby": ariaLabelledBy,
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                saferRest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                saferRest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                saferRest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                saferRest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                saferRest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                saferRest.onBlur?.(e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (0, $fl4ll.default)([
                localRef,
                ref,
                triggerProps.ref
            ].filter(Boolean)),
            // Base props only
            xcss: (0, $ky45w.cx)($28de279ae06ecdcb$var$styles.base, (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $28de279ae06ecdcb$var$styles.baseT26Shape, !isDisabled && (0, $2aEiL.fg)('platform-dst-motion-uplift-button') && $28de279ae06ecdcb$var$styles.interactiveMotion, appearance === 'default' && $28de279ae06ecdcb$var$defaultStyles.root, appearance === 'primary' && $28de279ae06ecdcb$var$primaryStyles.root, appearance === 'rovo' && $28de279ae06ecdcb$var$rovoStyles.root, appearance === 'discovery' && $28de279ae06ecdcb$var$discoveryStyles.root, appearance === 'subtle' && $28de279ae06ecdcb$var$subtleStyles.root, $28de279ae06ecdcb$var$styles.linkDecorationUnset, isSelected && $28de279ae06ecdcb$var$selectedStyles.root, isSelected && appearance === 'discovery' && $28de279ae06ecdcb$var$selectedStyles.discovery, isDisabled && $28de279ae06ecdcb$var$styles.disabled, $28de279ae06ecdcb$var$styles.iconButton, spacing === 'compact' && $28de279ae06ecdcb$var$styles.spacingCompact, shape === 'circle' && $28de279ae06ecdcb$var$styles.circle),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
            href: isDisabled ? undefined : href,
            role: isDisabled ? 'link' : undefined,
            "aria-disabled": isDisabled === true ? true : undefined
        }, /*#__PURE__*/ $1v5pe.createElement((0, $1TZ74.default), {
            type: "icon",
            isLoading: false
        }, /*#__PURE__*/ $1v5pe.createElement((0, $lreqQ.default), {
            icon: icon
        }), /*#__PURE__*/ $1v5pe.createElement((0, $kFr83.default), null, label))));
    return /*#__PURE__*/ $1v5pe.createElement((0, $hK1py.Anchor), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $fl4ll.default)([
            localRef,
            ref
        ]),
        xcss: (0, $ky45w.cx)($28de279ae06ecdcb$var$styles.base, (0, $2aEiL.fg)('platform-dst-shape-theme-default') && $28de279ae06ecdcb$var$styles.baseT26Shape, !isDisabled && (0, $2aEiL.fg)('platform-dst-motion-uplift-button') && $28de279ae06ecdcb$var$styles.interactiveMotion, appearance === 'default' && $28de279ae06ecdcb$var$defaultStyles.root, appearance === 'primary' && $28de279ae06ecdcb$var$primaryStyles.root, appearance === 'rovo' && $28de279ae06ecdcb$var$rovoStyles.root, appearance === 'discovery' && $28de279ae06ecdcb$var$discoveryStyles.root, appearance === 'subtle' && $28de279ae06ecdcb$var$subtleStyles.root, $28de279ae06ecdcb$var$styles.linkDecorationUnset, isSelected && $28de279ae06ecdcb$var$selectedStyles.root, isSelected && appearance === 'discovery' && $28de279ae06ecdcb$var$selectedStyles.discovery, isDisabled && $28de279ae06ecdcb$var$styles.disabled, $28de279ae06ecdcb$var$styles.iconButton, spacing === 'compact' && $28de279ae06ecdcb$var$styles.spacingCompact, shape === 'circle' && $28de279ae06ecdcb$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, /*#__PURE__*/ $1v5pe.createElement((0, $1TZ74.default), {
        type: "icon",
        isLoading: false
    }, /*#__PURE__*/ $1v5pe.createElement((0, $lreqQ.default), {
        icon: icon
    }), /*#__PURE__*/ $1v5pe.createElement((0, $kFr83.default), null, label)));
};
// Workarounds to support generic types with forwardRef + memo
const $28de279ae06ecdcb$var$WithRef = /*#__PURE__*/ (0, $1v5pe.forwardRef)($28de279ae06ecdcb$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $28de279ae06ecdcb$var$LinkIconButton = /*#__PURE__*/ (0, $1v5pe.memo)($28de279ae06ecdcb$var$WithRef);
var $28de279ae06ecdcb$export$2e2bcd8739ae039 = $28de279ae06ecdcb$var$LinkIconButton;

});

parcelRegister("2U8d1", function(module, exports) {
$parcel$export(module.exports, "default", () => $21d72dda49ef485d$export$2e2bcd8739ae039);
function $21d72dda49ef485d$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $21d72dda49ef485d$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $21d72dda49ef485d$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $21d72dda49ef485d$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $21d72dda49ef485d$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $21d72dda49ef485d$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $21d72dda49ef485d$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $21d72dda49ef485d$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $21d72dda49ef485d$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $21d72dda49ef485d$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $21d72dda49ef485d$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $21d72dda49ef485d$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $21d72dda49ef485d$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $21d72dda49ef485d$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $21d72dda49ef485d$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $21d72dda49ef485d$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $21d72dda49ef485d$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $21d72dda49ef485d$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $21d72dda49ef485d$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $21d72dda49ef485d$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $21d72dda49ef485d$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $21d72dda49ef485d$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $21d72dda49ef485d$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $21d72dda49ef485d$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $21d72dda49ef485d$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $21d72dda49ef485d$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $21d72dda49ef485d$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $21d72dda49ef485d$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $21d72dda49ef485d$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $21d72dda49ef485d$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $21d72dda49ef485d$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $21d72dda49ef485d$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $21d72dda49ef485d$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $21d72dda49ef485d$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $21d72dda49ef485d$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $21d72dda49ef485d$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $21d72dda49ef485d$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $21d72dda49ef485d$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $21d72dda49ef485d$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $21d72dda49ef485d$var$fromHex_1 = $21d72dda49ef485d$var$fromHex, $21d72dda49ef485d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $21d72dda49ef485d$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $21d72dda49ef485d$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $21d72dda49ef485d$var$fromRgb_1 = $21d72dda49ef485d$var$fromRgb, $21d72dda49ef485d$var$fromCssRgb_1 = $21d72dda49ef485d$var$fromCssRgb, $21d72dda49ef485d$var$fromHsl_1 = $21d72dda49ef485d$var$fromHsl, $21d72dda49ef485d$var$fromCssHsl_1 = $21d72dda49ef485d$var$fromCssHsl, $21d72dda49ef485d$var$fromHsv_1 = $21d72dda49ef485d$var$fromHsv, $21d72dda49ef485d$var$fromCmyk_1 = $21d72dda49ef485d$var$fromCmyk, $21d72dda49ef485d$var$fromYiq_1 = $21d72dda49ef485d$var$fromYiq, $21d72dda49ef485d$var$fromXYZ_1 = $21d72dda49ef485d$var$fromXYZ, $21d72dda49ef485d$var$fromxyY_1 = $21d72dda49ef485d$var$fromxyY, $21d72dda49ef485d$var$fromLms_1 = $21d72dda49ef485d$var$fromLms, $21d72dda49ef485d$var$fromCieLab_1 = $21d72dda49ef485d$var$fromCieLab, $21d72dda49ef485d$var$fromCieLuv_1 = $21d72dda49ef485d$var$fromCieLuv, $21d72dda49ef485d$var$fromCieLch_1 = $21d72dda49ef485d$var$fromCieLch, $21d72dda49ef485d$var$fromHsluv = $21d72dda49ef485d$var$fromCieLch$1, $21d72dda49ef485d$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $21d72dda49ef485d$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $21d72dda49ef485d$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $21d72dda49ef485d$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $21d72dda49ef485d$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $21d72dda49ef485d$var$fromHsluv
    }
}, $21d72dda49ef485d$var$adapt_1 = $21d72dda49ef485d$var$adapt, $21d72dda49ef485d$var$adjacent_1 = $21d72dda49ef485d$var$adjacent, $21d72dda49ef485d$var$brightness_1 = $21d72dda49ef485d$var$brightness, $21d72dda49ef485d$var$complementary_1 = $21d72dda49ef485d$var$complementary, $21d72dda49ef485d$var$contrast_1 = $21d72dda49ef485d$var$contrast, $21d72dda49ef485d$var$contrastRatio_1 = $21d72dda49ef485d$var$contrastRatio, $21d72dda49ef485d$var$convert_1 = $21d72dda49ef485d$var$convert, $21d72dda49ef485d$var$difference_1 = $21d72dda49ef485d$var$difference, $21d72dda49ef485d$var$fade_1 = $21d72dda49ef485d$var$fade, $21d72dda49ef485d$var$greyscale_1 = $21d72dda49ef485d$var$greyscale, $21d72dda49ef485d$var$hue_1 = $21d72dda49ef485d$var$hue, $21d72dda49ef485d$var$invert_1 = $21d72dda49ef485d$var$invert, $21d72dda49ef485d$var$invertLightness_1 = $21d72dda49ef485d$var$invertLightness, $21d72dda49ef485d$var$mid_1 = $21d72dda49ef485d$var$mid, $21d72dda49ef485d$var$multiply_1 = $21d72dda49ef485d$var$multiply, $21d72dda49ef485d$var$saturation_1 = $21d72dda49ef485d$var$saturation, $21d72dda49ef485d$var$sepia_1 = $21d72dda49ef485d$var$sepia, $21d72dda49ef485d$var$shade_1 = $21d72dda49ef485d$var$shade, $21d72dda49ef485d$var$temperature_1 = $21d72dda49ef485d$var$temperature, $21d72dda49ef485d$var$tetrad_1 = $21d72dda49ef485d$var$tetrad, $21d72dda49ef485d$var$triad_1 = $21d72dda49ef485d$var$triad, $21d72dda49ef485d$var$index$2 = {
    adapt: $21d72dda49ef485d$var$adapt_1,
    adjacent: $21d72dda49ef485d$var$adjacent_1,
    brightness: $21d72dda49ef485d$var$brightness_1,
    complementary: $21d72dda49ef485d$var$complementary_1,
    contrast: $21d72dda49ef485d$var$contrast_1,
    contrastRatio: $21d72dda49ef485d$var$contrastRatio_1,
    convert: $21d72dda49ef485d$var$convert_1,
    difference: $21d72dda49ef485d$var$difference_1,
    fade: $21d72dda49ef485d$var$fade_1,
    greyscale: $21d72dda49ef485d$var$greyscale_1,
    hue: $21d72dda49ef485d$var$hue_1,
    invert: $21d72dda49ef485d$var$invert_1,
    invertLightness: $21d72dda49ef485d$var$invertLightness_1,
    mid: $21d72dda49ef485d$var$mid_1,
    multiply: $21d72dda49ef485d$var$multiply_1,
    saturation: $21d72dda49ef485d$var$saturation_1,
    sepia: $21d72dda49ef485d$var$sepia_1,
    shade: $21d72dda49ef485d$var$shade_1,
    temperature: $21d72dda49ef485d$var$temperature_1,
    tetrad: $21d72dda49ef485d$var$tetrad_1,
    triad: $21d72dda49ef485d$var$triad_1
}, $21d72dda49ef485d$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $21d72dda49ef485d$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $21d72dda49ef485d$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($21d72dda49ef485d$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $21d72dda49ef485d$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($21d72dda49ef485d$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $21d72dda49ef485d$var$api_1 = $21d72dda49ef485d$var$api, $21d72dda49ef485d$var$helpers = {
    getIlluminant: function(r) {
        return $21d72dda49ef485d$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $21d72dda49ef485d$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $21d72dda49ef485d$var$index)if ($21d72dda49ef485d$var$index.hasOwnProperty(e) && $21d72dda49ef485d$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $21d72dda49ef485d$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $21d72dda49ef485d$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $21d72dda49ef485d$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $21d72dda49ef485d$var$constants, s));
            default:
                return null;
        }
    }
}, $21d72dda49ef485d$var$helpers_1 = $21d72dda49ef485d$var$helpers, $21d72dda49ef485d$var$dependencies = {
    conversions: $21d72dda49ef485d$var$index,
    operations: $21d72dda49ef485d$var$index$2,
    helpers: $21d72dda49ef485d$var$helpers_1
}, $21d72dda49ef485d$var$entry = $21d72dda49ef485d$var$api_1($21d72dda49ef485d$var$dependencies, $21d72dda49ef485d$var$constants);
var $21d72dda49ef485d$export$2e2bcd8739ae039 = $21d72dda49ef485d$var$entry;

});

parcelRegister("iOTGy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ac2da4870fcb99f$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $2aEiL = parcelRequire("2aEiL");

var $8ADAn = parcelRequire("8ADAn");

var $eDbv3 = parcelRequire("eDbv3");

var $fCtGh = parcelRequire("fCtGh");
const $0ac2da4870fcb99f$var$AnalyticsContext = (props)=>{
    const computeIsModernContext = ()=>(0, $8ADAn.default) || (0, $2aEiL.fg)('analytics-next-use-legacy-context') === false;
    // Gated by analytics-next-lock-context-type: capture the value once at mount so a late gate flip can't swap the component type and remount the subtree. While locked the gate is not re-read on later renders.
    const [lockedIsModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).useState(computeIsModernContext);
    const isModernContext = (0, $2aEiL.fg)('analytics-next-lock-context-type') ? lockedIsModernContext : computeIsModernContext();
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fCtGh.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eDbv3.default), props);
};
var $0ac2da4870fcb99f$export$2e2bcd8739ae039 = $0ac2da4870fcb99f$var$AnalyticsContext;

});
parcelRegister("8ADAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbfa168f03c85eec$export$2e2bcd8739ae039);
/// <reference types="node" />

var $k1Wvt = parcelRequire("k1Wvt");
const $cbfa168f03c85eec$var$_default_1 = typeof $k1Wvt !== 'undefined' && $k1Wvt !== null && $k1Wvt.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];
var $cbfa168f03c85eec$export$2e2bcd8739ae039 = $cbfa168f03c85eec$var$_default_1;

});

parcelRegister("eDbv3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6362bcf0e20038d$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $VkTYT = parcelRequire("VkTYT");

var $eRjpU = parcelRequire("eRjpU");
const $e6362bcf0e20038d$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($VkTYT))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($VkTYT))).func
};
const $e6362bcf0e20038d$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e6362bcf0e20038d$var$AnalyticsContext extends (0, $1v5pe.Component) {
    static{
        this.contextTypes = $e6362bcf0e20038d$var$ContextTypes;
    }
    static{
        this.childContextTypes = $e6362bcf0e20038d$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $e6362bcf0e20038d$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $e6362bcf0e20038d$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eRjpU.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $e6362bcf0e20038d$export$2e2bcd8739ae039 = $e6362bcf0e20038d$var$AnalyticsContext;

});

parcelRegister("fCtGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f021210a6c5c043$export$2e2bcd8739ae039);

var $1v5pe = parcelRequire("1v5pe");

var $eRjpU = parcelRequire("eRjpU");

var $4jgWK = parcelRequire("4jgWK");

var $gEAl7 = parcelRequire("gEAl7");
const $0f021210a6c5c043$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $gEAl7.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $4jgWK.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $1v5pe.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $1v5pe.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $eRjpU.default).Provider, {
        value: value
    }, children);
};
var $0f021210a6c5c043$export$2e2bcd8739ae039 = $0f021210a6c5c043$var$AnalyticsContext;

});


parcelRegister("5b3W5", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $43533fd8ef128479$export$f1bba0ef464d60af);
const $43533fd8ef128479$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $43533fd8ef128479$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $43533fd8ef128479$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $43533fd8ef128479$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($43533fd8ef128479$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $43533fd8ef128479$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("36bb9", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $a730fec82441170f$export$23dfbae28e0cc453);

var $1v5pe = parcelRequire("1v5pe");

var $dmmsG = parcelRequire("dmmsG");

var $brxde = parcelRequire("brxde");

var $2cXad = parcelRequire("2cXad");

var $1CaUw = parcelRequire("1CaUw");

var $5Hn4C = parcelRequire("5Hn4C");

var $6rqEn = parcelRequire("6rqEn");
const $a730fec82441170f$var$menuScope = '[role="menu"]';
function $a730fec82441170f$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $1v5pe.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $brxde.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($a730fec82441170f$var$menuScope) !== container) return;
        }
        if (event.key === (0, $2cXad.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $6rqEn.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $2cXad.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $6rqEn.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $2cXad.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $1CaUw.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $2cXad.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $5Hn4C.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $2cXad.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($a730fec82441170f$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $1v5pe.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $dmmsG.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("dtLWD", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $9d032ca0a0a2aabe$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $9d032ca0a0a2aabe$export$f681a8129d2e9d28);

var $87uOn = parcelRequire("87uOn");

var $3mdE8 = parcelRequire("3mdE8");
//      
var $9d032ca0a0a2aabe$var$charCodeOfDot = ".".charCodeAt(0);
var $9d032ca0a0a2aabe$var$reEscapeChar = /\\(\\)?/g;
var $9d032ca0a0a2aabe$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $9d032ca0a0a2aabe$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $9d032ca0a0a2aabe$var$charCodeOfDot) result.push("");
    string.replace($9d032ca0a0a2aabe$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($9d032ca0a0a2aabe$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $9d032ca0a0a2aabe$var$keysCache = {};
var $9d032ca0a0a2aabe$var$keysRegex = /[.[\]]+/;
var $9d032ca0a0a2aabe$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($9d032ca0a0a2aabe$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $9d032ca0a0a2aabe$var$keysCache[key] = key.split($9d032ca0a0a2aabe$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $9d032ca0a0a2aabe$var$keysCache[key] = $9d032ca0a0a2aabe$var$stringToPath(key);
    }
    return $9d032ca0a0a2aabe$var$keysCache[key];
};
//      
var $9d032ca0a0a2aabe$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $9d032ca0a0a2aabe$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $9d032ca0a0a2aabe$var$_toPropertyKey(arg) {
    var key = $9d032ca0a0a2aabe$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $9d032ca0a0a2aabe$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $9d032ca0a0a2aabe$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $3mdE8.default)(current, [
                key
            ].map($9d032ca0a0a2aabe$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $87uOn.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $9d032ca0a0a2aabe$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $9d032ca0a0a2aabe$var$setInRecursor(state, 0, $9d032ca0a0a2aabe$var$toPath(key), value1, destroyArrays);
};
var $9d032ca0a0a2aabe$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $9d032ca0a0a2aabe$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $9d032ca0a0a2aabe$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $9d032ca0a0a2aabe$export$c52e5867d5879e24(values, name);
    var error = $9d032ca0a0a2aabe$export$c52e5867d5879e24(errors, name);
    if (error && error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a]) error = error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a];
    var submitError = submitErrors && $9d032ca0a0a2aabe$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $9d032ca0a0a2aabe$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $9d032ca0a0a2aabe$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $9d032ca0a0a2aabe$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $9d032ca0a0a2aabe$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$9d032ca0a0a2aabe$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $9d032ca0a0a2aabe$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $9d032ca0a0a2aabe$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $9d032ca0a0a2aabe$var$subscriptionFilter(result, state, previousState, subscription, $9d032ca0a0a2aabe$export$41e855cb628c1b55, $9d032ca0a0a2aabe$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $9d032ca0a0a2aabe$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $9d032ca0a0a2aabe$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $9d032ca0a0a2aabe$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $9d032ca0a0a2aabe$var$subscriptionFilter(result, state, previousState, subscription, $9d032ca0a0a2aabe$export$f1ff97b9d1c7a3c3, $9d032ca0a0a2aabe$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $9d032ca0a0a2aabe$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$9d032ca0a0a2aabe$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $9d032ca0a0a2aabe$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $9d032ca0a0a2aabe$export$83d89fbfd8236492 = "4.20.10";
var $9d032ca0a0a2aabe$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $9d032ca0a0a2aabe$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $9d032ca0a0a2aabe$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $9d032ca0a0a2aabe$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $9d032ca0a0a2aabe$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $9d032ca0a0a2aabe$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $9d032ca0a0a2aabe$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $9d032ca0a0a2aabe$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($9d032ca0a0a2aabe$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $9d032ca0a0a2aabe$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $87uOn.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $87uOn.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $87uOn.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $87uOn.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $87uOn.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $9d032ca0a0a2aabe$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $9d032ca0a0a2aabe$export$e6bdf135a54e021b,
                    shallowEqual: $9d032ca0a0a2aabe$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $87uOn.default)({}, state.formState.values)); // clone to avoid writing
            if ($9d032ca0a0a2aabe$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $9d032ca0a0a2aabe$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $9d032ca0a0a2aabe$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $87uOn.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $87uOn.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $9d032ca0a0a2aabe$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $9d032ca0a0a2aabe$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a]) {
                    var existing = $9d032ca0a0a2aabe$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$9d032ca0a0a2aabe$export$735bebc8ffabf28a] = error[$9d032ca0a0a2aabe$export$735bebc8ffabf28a];
                    merged = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$9d032ca0a0a2aabe$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$9d032ca0a0a2aabe$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $87uOn.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $9d032ca0a0a2aabe$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $9d032ca0a0a2aabe$var$notify(fieldSubscriber, fieldState, lastFieldState, $9d032ca0a0a2aabe$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $9d032ca0a0a2aabe$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $87uOn.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key), $9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key), $9d032ca0a0a2aabe$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$9d032ca0a0a2aabe$var$hasAnyError(formState.errors) && !(formState.submitErrors && $9d032ca0a0a2aabe$var$hasAnyError(formState.submitErrors));
        var nextFormState = $9d032ca0a0a2aabe$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $9d032ca0a0a2aabe$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $9d032ca0a0a2aabe$var$notify(state.subscribers, nextFormState, lastFormState, $9d032ca0a0a2aabe$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $87uOn.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $87uOn.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $87uOn.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key), $9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $9d032ca0a0a2aabe$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $9d032ca0a0a2aabe$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $9d032ca0a0a2aabe$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.values, name) === $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $9d032ca0a0a2aabe$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $9d032ca0a0a2aabe$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $87uOn.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $87uOn.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $87uOn.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $9d032ca0a0a2aabe$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$9d032ca0a0a2aabe$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $87uOn.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $9d032ca0a0a2aabe$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $9d032ca0a0a2aabe$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $9d032ca0a0a2aabe$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $9d032ca0a0a2aabe$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("bOSZO", function(module, exports) {
$parcel$export(module.exports, "default", () => $89af0645ec0d6178$export$2e2bcd8739ae039);

var $dtLWD = parcelRequire("dtLWD");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $89af0645ec0d6178$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $89af0645ec0d6178$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($89af0645ec0d6178$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $89af0645ec0d6178$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $dtLWD.getIn)(errors, input.name);
    });
};
//      
var $89af0645ec0d6178$var$noop = function noop() {};
var $89af0645ec0d6178$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $89af0645ec0d6178$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $89af0645ec0d6178$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $89af0645ec0d6178$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $89af0645ec0d6178$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($89af0645ec0d6178$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$89af0645ec0d6178$export$2e2bcd8739ae039 = $89af0645ec0d6178$var$createDecorator;

});

parcelRegister("bhyFt", function(module, exports) {

var $d0bln = parcelRequire("d0bln");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $836c2c8b4ace22e3$var$set(object, path, value) {
    return object == null ? object : $d0bln(object, path, value);
}
module.exports = $836c2c8b4ace22e3$var$set;

});
parcelRegister("d0bln", function(module, exports) {

var $1GvDV = parcelRequire("1GvDV");

var $h8usd = parcelRequire("h8usd");

var $gCPVC = parcelRequire("gCPVC");

var $ghi1o = parcelRequire("ghi1o");

var $gwgzf = parcelRequire("gwgzf");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $977413183639e1db$var$baseSet(object, path, value, customizer) {
    if (!$ghi1o(object)) return object;
    path = $h8usd(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $gwgzf(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $ghi1o(objValue) ? objValue : $gCPVC(path[index + 1]) ? [] : {};
        }
        $1GvDV(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $977413183639e1db$var$baseSet;

});
parcelRegister("1GvDV", function(module, exports) {

var $1VaWt = parcelRequire("1VaWt");

var $dIKIh = parcelRequire("dIKIh");
/** Used for built-in method references. */ var $13a242587f9f07a3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $13a242587f9f07a3$var$hasOwnProperty = $13a242587f9f07a3$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $13a242587f9f07a3$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($13a242587f9f07a3$var$hasOwnProperty.call(object, key) && $dIKIh(objValue, value)) || value === undefined && !(key in object)) $1VaWt(object, key, value);
}
module.exports = $13a242587f9f07a3$var$assignValue;

});
parcelRegister("1VaWt", function(module, exports) {

var $2yWCC = parcelRequire("2yWCC");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $16639a3460adc762$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $2yWCC) $2yWCC(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $16639a3460adc762$var$baseAssignValue;

});
parcelRegister("2yWCC", function(module, exports) {

var $coVaf = parcelRequire("coVaf");
var $1ddc3acff07af414$var$defineProperty = function() {
    try {
        var func = $coVaf(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $1ddc3acff07af414$var$defineProperty;

});
parcelRegister("coVaf", function(module, exports) {

var $b17iw = parcelRequire("b17iw");

var $bGZgc = parcelRequire("bGZgc");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9074118dbd2c7036$var$getNative(object, key) {
    var value = $bGZgc(object, key);
    return $b17iw(value) ? value : undefined;
}
module.exports = $9074118dbd2c7036$var$getNative;

});
parcelRegister("b17iw", function(module, exports) {

var $6pshK = parcelRequire("6pshK");

var $emhAZ = parcelRequire("emhAZ");

var $ghi1o = parcelRequire("ghi1o");

var $jkHbF = parcelRequire("jkHbF");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $805572df233b3952$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $805572df233b3952$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $805572df233b3952$var$funcProto = Function.prototype, $805572df233b3952$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $805572df233b3952$var$funcToString = $805572df233b3952$var$funcProto.toString;
/** Used to check objects for own properties. */ var $805572df233b3952$var$hasOwnProperty = $805572df233b3952$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $805572df233b3952$var$reIsNative = RegExp('^' + $805572df233b3952$var$funcToString.call($805572df233b3952$var$hasOwnProperty).replace($805572df233b3952$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $805572df233b3952$var$baseIsNative(value) {
    if (!$ghi1o(value) || $emhAZ(value)) return false;
    var pattern = $6pshK(value) ? $805572df233b3952$var$reIsNative : $805572df233b3952$var$reIsHostCtor;
    return pattern.test($jkHbF(value));
}
module.exports = $805572df233b3952$var$baseIsNative;

});
parcelRegister("6pshK", function(module, exports) {

var $avvbo = parcelRequire("avvbo");

var $ghi1o = parcelRequire("ghi1o");
/** `Object#toString` result references. */ var $4aab04bb04c3c752$var$asyncTag = '[object AsyncFunction]', $4aab04bb04c3c752$var$funcTag = '[object Function]', $4aab04bb04c3c752$var$genTag = '[object GeneratorFunction]', $4aab04bb04c3c752$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4aab04bb04c3c752$var$isFunction(value) {
    if (!$ghi1o(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $avvbo(value);
    return tag == $4aab04bb04c3c752$var$funcTag || tag == $4aab04bb04c3c752$var$genTag || tag == $4aab04bb04c3c752$var$asyncTag || tag == $4aab04bb04c3c752$var$proxyTag;
}
module.exports = $4aab04bb04c3c752$var$isFunction;

});
parcelRegister("avvbo", function(module, exports) {

var $ePDSv = parcelRequire("ePDSv");

var $22dFu = parcelRequire("22dFu");

var $awAG2 = parcelRequire("awAG2");
/** `Object#toString` result references. */ var $7a64fce3ad35bec5$var$nullTag = '[object Null]', $7a64fce3ad35bec5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $7a64fce3ad35bec5$var$symToStringTag = $ePDSv ? $ePDSv.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $7a64fce3ad35bec5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $7a64fce3ad35bec5$var$undefinedTag : $7a64fce3ad35bec5$var$nullTag;
    return $7a64fce3ad35bec5$var$symToStringTag && $7a64fce3ad35bec5$var$symToStringTag in Object(value) ? $22dFu(value) : $awAG2(value);
}
module.exports = $7a64fce3ad35bec5$var$baseGetTag;

});
parcelRegister("ePDSv", function(module, exports) {

var $fu3MD = parcelRequire("fu3MD");
/** Built-in value references. */ var $acc4c30f6ac65f0b$var$Symbol = $fu3MD.Symbol;
module.exports = $acc4c30f6ac65f0b$var$Symbol;

});
parcelRegister("fu3MD", function(module, exports) {

var $1TD6g = parcelRequire("1TD6g");
/** Detect free variable `self`. */ var $b45c97ab92a0072f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b45c97ab92a0072f$var$root = $1TD6g || $b45c97ab92a0072f$var$freeSelf || Function('return this')();
module.exports = $b45c97ab92a0072f$var$root;

});
parcelRegister("1TD6g", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $161941f40ca968ed$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $161941f40ca968ed$var$freeGlobal;

});



parcelRegister("22dFu", function(module, exports) {

var $ePDSv = parcelRequire("ePDSv");
/** Used for built-in method references. */ var $17b65edff2091133$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $17b65edff2091133$var$hasOwnProperty = $17b65edff2091133$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $17b65edff2091133$var$nativeObjectToString = $17b65edff2091133$var$objectProto.toString;
/** Built-in value references. */ var $17b65edff2091133$var$symToStringTag = $ePDSv ? $ePDSv.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $17b65edff2091133$var$getRawTag(value) {
    var isOwn = $17b65edff2091133$var$hasOwnProperty.call(value, $17b65edff2091133$var$symToStringTag), tag = value[$17b65edff2091133$var$symToStringTag];
    try {
        value[$17b65edff2091133$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $17b65edff2091133$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$17b65edff2091133$var$symToStringTag] = tag;
        else delete value[$17b65edff2091133$var$symToStringTag];
    }
    return result;
}
module.exports = $17b65edff2091133$var$getRawTag;

});

parcelRegister("awAG2", function(module, exports) {
/** Used for built-in method references. */ var $7a9957d78791668c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7a9957d78791668c$var$nativeObjectToString = $7a9957d78791668c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $7a9957d78791668c$var$objectToString(value) {
    return $7a9957d78791668c$var$nativeObjectToString.call(value);
}
module.exports = $7a9957d78791668c$var$objectToString;

});


parcelRegister("ghi1o", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bd9c36897f32bc54$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $bd9c36897f32bc54$var$isObject;

});


parcelRegister("emhAZ", function(module, exports) {

var $Y8psS = parcelRequire("Y8psS");
/** Used to detect methods masquerading as native. */ var $a740c4e72789ae48$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($Y8psS && $Y8psS.keys && $Y8psS.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $a740c4e72789ae48$var$isMasked(func) {
    return !!$a740c4e72789ae48$var$maskSrcKey && $a740c4e72789ae48$var$maskSrcKey in func;
}
module.exports = $a740c4e72789ae48$var$isMasked;

});
parcelRegister("Y8psS", function(module, exports) {

var $fu3MD = parcelRequire("fu3MD");
/** Used to detect overreaching core-js shims. */ var $0b4c20b5139a10a8$var$coreJsData = $fu3MD["__core-js_shared__"];
module.exports = $0b4c20b5139a10a8$var$coreJsData;

});


parcelRegister("jkHbF", function(module, exports) {
/** Used for built-in method references. */ var $e13162a47d6fb338$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e13162a47d6fb338$var$funcToString = $e13162a47d6fb338$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e13162a47d6fb338$var$toSource(func) {
    if (func != null) {
        try {
            return $e13162a47d6fb338$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $e13162a47d6fb338$var$toSource;

});


parcelRegister("bGZgc", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $883322f59f53af56$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $883322f59f53af56$var$getValue;

});




parcelRegister("dIKIh", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $9fd39eaea35431d7$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $9fd39eaea35431d7$var$eq;

});


parcelRegister("h8usd", function(module, exports) {

var $ipbSm = parcelRequire("ipbSm");

var $9drQl = parcelRequire("9drQl");

var $eOUCX = parcelRequire("eOUCX");

var $5QJ6w = parcelRequire("5QJ6w");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $c79ace8e8923b573$var$castPath(value, object) {
    if ($ipbSm(value)) return value;
    return $9drQl(value, object) ? [
        value
    ] : $eOUCX($5QJ6w(value));
}
module.exports = $c79ace8e8923b573$var$castPath;

});
parcelRegister("ipbSm", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d663c614f5215881$var$isArray = Array.isArray;
module.exports = $d663c614f5215881$var$isArray;

});

parcelRegister("9drQl", function(module, exports) {

var $ipbSm = parcelRequire("ipbSm");

var $3qRJb = parcelRequire("3qRJb");
/** Used to match property names within property paths. */ var $6b5aed0b8bd97525$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6b5aed0b8bd97525$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6b5aed0b8bd97525$var$isKey(value, object) {
    if ($ipbSm(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $3qRJb(value)) return true;
    return $6b5aed0b8bd97525$var$reIsPlainProp.test(value) || !$6b5aed0b8bd97525$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $6b5aed0b8bd97525$var$isKey;

});
parcelRegister("3qRJb", function(module, exports) {

var $avvbo = parcelRequire("avvbo");

var $jbhhu = parcelRequire("jbhhu");
/** `Object#toString` result references. */ var $27fd7a001b9ede2a$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $27fd7a001b9ede2a$var$isSymbol(value) {
    return typeof value == 'symbol' || $jbhhu(value) && $avvbo(value) == $27fd7a001b9ede2a$var$symbolTag;
}
module.exports = $27fd7a001b9ede2a$var$isSymbol;

});
parcelRegister("jbhhu", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $df6c731445d1c69b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $df6c731445d1c69b$var$isObjectLike;

});



parcelRegister("eOUCX", function(module, exports) {

var $icnUd = parcelRequire("icnUd");
/** Used to match property names within property paths. */ var $aca1a93159f58f02$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $aca1a93159f58f02$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $aca1a93159f58f02$var$stringToPath = $icnUd(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($aca1a93159f58f02$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($aca1a93159f58f02$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $aca1a93159f58f02$var$stringToPath;

});
parcelRegister("icnUd", function(module, exports) {

var $2NdRj = parcelRequire("2NdRj");
/** Used as the maximum memoize cache size. */ var $d3fbe429b5f3b19b$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d3fbe429b5f3b19b$var$memoizeCapped(func) {
    var result = $2NdRj(func, function(key) {
        if (cache.size === $d3fbe429b5f3b19b$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $d3fbe429b5f3b19b$var$memoizeCapped;

});
parcelRegister("2NdRj", function(module, exports) {

var $32K13 = parcelRequire("32K13");
/** Error message constants. */ var $208ae870bcf3547f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $208ae870bcf3547f$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($208ae870bcf3547f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($208ae870bcf3547f$var$memoize.Cache || $32K13);
    return memoized;
}
// Expose `MapCache`.
$208ae870bcf3547f$var$memoize.Cache = $32K13;
module.exports = $208ae870bcf3547f$var$memoize;

});
parcelRegister("32K13", function(module, exports) {

var $aVbEC = parcelRequire("aVbEC");

var $bNRYK = parcelRequire("bNRYK");

var $fIhoV = parcelRequire("fIhoV");

var $i44Yz = parcelRequire("i44Yz");

var $dlpHP = parcelRequire("dlpHP");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $237540cfc67316b2$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$237540cfc67316b2$var$MapCache.prototype.clear = $aVbEC;
$237540cfc67316b2$var$MapCache.prototype['delete'] = $bNRYK;
$237540cfc67316b2$var$MapCache.prototype.get = $fIhoV;
$237540cfc67316b2$var$MapCache.prototype.has = $i44Yz;
$237540cfc67316b2$var$MapCache.prototype.set = $dlpHP;
module.exports = $237540cfc67316b2$var$MapCache;

});
parcelRegister("aVbEC", function(module, exports) {

var $gpYdu = parcelRequire("gpYdu");

var $1bAQy = parcelRequire("1bAQy");

var $dYTal = parcelRequire("dYTal");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7f38448c07a8a7be$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $gpYdu,
        'map': new ($dYTal || $1bAQy),
        'string': new $gpYdu
    };
}
module.exports = $7f38448c07a8a7be$var$mapCacheClear;

});
parcelRegister("gpYdu", function(module, exports) {

var $b4JwA = parcelRequire("b4JwA");

var $2BXwW = parcelRequire("2BXwW");

var $iVnot = parcelRequire("iVnot");

var $jjfwg = parcelRequire("jjfwg");

var $aDnu6 = parcelRequire("aDnu6");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bf3db0e5391a0b9d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$bf3db0e5391a0b9d$var$Hash.prototype.clear = $b4JwA;
$bf3db0e5391a0b9d$var$Hash.prototype['delete'] = $2BXwW;
$bf3db0e5391a0b9d$var$Hash.prototype.get = $iVnot;
$bf3db0e5391a0b9d$var$Hash.prototype.has = $jjfwg;
$bf3db0e5391a0b9d$var$Hash.prototype.set = $aDnu6;
module.exports = $bf3db0e5391a0b9d$var$Hash;

});
parcelRegister("b4JwA", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $810361a45cfd08e9$var$hashClear() {
    this.__data__ = $k1DLg ? $k1DLg(null) : {};
    this.size = 0;
}
module.exports = $810361a45cfd08e9$var$hashClear;

});
parcelRegister("k1DLg", function(module, exports) {

var $coVaf = parcelRequire("coVaf");
/* Built-in method references that are verified to be native. */ var $e942be69d5fbf0e2$var$nativeCreate = $coVaf(Object, 'create');
module.exports = $e942be69d5fbf0e2$var$nativeCreate;

});


parcelRegister("2BXwW", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1e6d36fa5c851050$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $1e6d36fa5c851050$var$hashDelete;

});

parcelRegister("iVnot", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/** Used to stand-in for `undefined` hash values. */ var $dc6fb25f703dc4ae$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $dc6fb25f703dc4ae$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dc6fb25f703dc4ae$var$hasOwnProperty = $dc6fb25f703dc4ae$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dc6fb25f703dc4ae$var$hashGet(key) {
    var data = this.__data__;
    if ($k1DLg) {
        var result = data[key];
        return result === $dc6fb25f703dc4ae$var$HASH_UNDEFINED ? undefined : result;
    }
    return $dc6fb25f703dc4ae$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $dc6fb25f703dc4ae$var$hashGet;

});

parcelRegister("jjfwg", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/** Used for built-in method references. */ var $e0ebd4835837def6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e0ebd4835837def6$var$hasOwnProperty = $e0ebd4835837def6$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e0ebd4835837def6$var$hashHas(key) {
    var data = this.__data__;
    return $k1DLg ? data[key] !== undefined : $e0ebd4835837def6$var$hasOwnProperty.call(data, key);
}
module.exports = $e0ebd4835837def6$var$hashHas;

});

parcelRegister("aDnu6", function(module, exports) {

var $k1DLg = parcelRequire("k1DLg");
/** Used to stand-in for `undefined` hash values. */ var $7bdfc36eb48f506f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7bdfc36eb48f506f$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1DLg && value === undefined ? $7bdfc36eb48f506f$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $7bdfc36eb48f506f$var$hashSet;

});


parcelRegister("1bAQy", function(module, exports) {

var $2p8wj = parcelRequire("2p8wj");

var $dq02L = parcelRequire("dq02L");

var $9HiR0 = parcelRequire("9HiR0");

var $kgnUT = parcelRequire("kgnUT");

var $78vJm = parcelRequire("78vJm");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0dd3668639474479$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0dd3668639474479$var$ListCache.prototype.clear = $2p8wj;
$0dd3668639474479$var$ListCache.prototype['delete'] = $dq02L;
$0dd3668639474479$var$ListCache.prototype.get = $9HiR0;
$0dd3668639474479$var$ListCache.prototype.has = $kgnUT;
$0dd3668639474479$var$ListCache.prototype.set = $78vJm;
module.exports = $0dd3668639474479$var$ListCache;

});
parcelRegister("2p8wj", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $1c0486841de95923$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $1c0486841de95923$var$listCacheClear;

});

parcelRegister("dq02L", function(module, exports) {

var $gouco = parcelRequire("gouco");
/** Used for built-in method references. */ var $9c4dbcb59f18bdd5$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9c4dbcb59f18bdd5$var$splice = $9c4dbcb59f18bdd5$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9c4dbcb59f18bdd5$var$listCacheDelete(key) {
    var data = this.__data__, index = $gouco(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9c4dbcb59f18bdd5$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $9c4dbcb59f18bdd5$var$listCacheDelete;

});
parcelRegister("gouco", function(module, exports) {

var $dIKIh = parcelRequire("dIKIh");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bef65017ff6db777$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($dIKIh(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $bef65017ff6db777$var$assocIndexOf;

});


parcelRegister("9HiR0", function(module, exports) {

var $gouco = parcelRequire("gouco");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $70f6c138ecccaaf3$var$listCacheGet(key) {
    var data = this.__data__, index = $gouco(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $70f6c138ecccaaf3$var$listCacheGet;

});

parcelRegister("kgnUT", function(module, exports) {

var $gouco = parcelRequire("gouco");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ec07daa171d63c49$var$listCacheHas(key) {
    return $gouco(this.__data__, key) > -1;
}
module.exports = $ec07daa171d63c49$var$listCacheHas;

});

parcelRegister("78vJm", function(module, exports) {

var $gouco = parcelRequire("gouco");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $5321e4cf4863d336$var$listCacheSet(key, value) {
    var data = this.__data__, index = $gouco(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $5321e4cf4863d336$var$listCacheSet;

});


parcelRegister("dYTal", function(module, exports) {

var $coVaf = parcelRequire("coVaf");

var $fu3MD = parcelRequire("fu3MD");
/* Built-in method references that are verified to be native. */ var $a2dbabb923309a8e$var$Map = $coVaf($fu3MD, 'Map');
module.exports = $a2dbabb923309a8e$var$Map;

});


parcelRegister("bNRYK", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $897e245e65a839c9$var$mapCacheDelete(key) {
    var result = $6xSxU(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $897e245e65a839c9$var$mapCacheDelete;

});
parcelRegister("6xSxU", function(module, exports) {

var $1qmou = parcelRequire("1qmou");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4c4022cedd2a0b42$var$getMapData(map, key) {
    var data = map.__data__;
    return $1qmou(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $4c4022cedd2a0b42$var$getMapData;

});
parcelRegister("1qmou", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $10999726243b507e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $10999726243b507e$var$isKeyable;

});



parcelRegister("fIhoV", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b7087693d496d27b$var$mapCacheGet(key) {
    return $6xSxU(this, key).get(key);
}
module.exports = $b7087693d496d27b$var$mapCacheGet;

});

parcelRegister("i44Yz", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d26c75d4e211fc20$var$mapCacheHas(key) {
    return $6xSxU(this, key).has(key);
}
module.exports = $d26c75d4e211fc20$var$mapCacheHas;

});

parcelRegister("dlpHP", function(module, exports) {

var $6xSxU = parcelRequire("6xSxU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $9b712d2b24952120$var$mapCacheSet(key, value) {
    var data = $6xSxU(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $9b712d2b24952120$var$mapCacheSet;

});





parcelRegister("5QJ6w", function(module, exports) {

var $i9Zi5 = parcelRequire("i9Zi5");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4424cbdb269ee075$var$toString(value) {
    return value == null ? '' : $i9Zi5(value);
}
module.exports = $4424cbdb269ee075$var$toString;

});
parcelRegister("i9Zi5", function(module, exports) {

var $ePDSv = parcelRequire("ePDSv");

var $33rLk = parcelRequire("33rLk");

var $ipbSm = parcelRequire("ipbSm");

var $3qRJb = parcelRequire("3qRJb");
/** Used as references for various `Number` constants. */ var $d3889c5089f753f0$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $d3889c5089f753f0$var$symbolProto = $ePDSv ? $ePDSv.prototype : undefined, $d3889c5089f753f0$var$symbolToString = $d3889c5089f753f0$var$symbolProto ? $d3889c5089f753f0$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $d3889c5089f753f0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($ipbSm(value)) // Recursively convert values (susceptible to call stack limits).
    return $33rLk(value, $d3889c5089f753f0$var$baseToString) + '';
    if ($3qRJb(value)) return $d3889c5089f753f0$var$symbolToString ? $d3889c5089f753f0$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$d3889c5089f753f0$var$INFINITY ? '-0' : result;
}
module.exports = $d3889c5089f753f0$var$baseToString;

});
parcelRegister("33rLk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $23972ff20fae130f$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $23972ff20fae130f$var$arrayMap;

});




parcelRegister("gCPVC", function(module, exports) {
/** Used as references for various `Number` constants. */ var $c1a879d795ff798d$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $c1a879d795ff798d$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $c1a879d795ff798d$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $c1a879d795ff798d$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $c1a879d795ff798d$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $c1a879d795ff798d$var$isIndex;

});

parcelRegister("gwgzf", function(module, exports) {

var $3qRJb = parcelRequire("3qRJb");
/** Used as references for various `Number` constants. */ var $c06c7c7b121484de$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c06c7c7b121484de$var$toKey(value) {
    if (typeof value == 'string' || $3qRJb(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$c06c7c7b121484de$var$INFINITY ? '-0' : result;
}
module.exports = $c06c7c7b121484de$var$toKey;

});



parcelRegister("iboSh", function(module, exports) {
$parcel$export(module.exports, "z", () => (parcelRequire("f6NIw")));

var $f6NIw = parcelRequire("f6NIw");

var $d3cc8c9d1566ca60$export$2e2bcd8739ae039 = $f6NIw;

});
parcelRegister("f6NIw", function(module, exports) {

var $4YGLw = parcelRequire("4YGLw");

var $c3uro = parcelRequire("c3uro");

var $8wOm4 = parcelRequire("8wOm4");

var $2v1nA = parcelRequire("2v1nA");

var $4MVWb = parcelRequire("4MVWb");

var $ffJWC = parcelRequire("ffJWC");
$parcel$exportWildcard(module.exports, $4YGLw);
$parcel$exportWildcard(module.exports, $c3uro);
$parcel$exportWildcard(module.exports, $8wOm4);
$parcel$exportWildcard(module.exports, $2v1nA);
$parcel$exportWildcard(module.exports, $4MVWb);
$parcel$exportWildcard(module.exports, $ffJWC);

});
parcelRegister("4YGLw", function(module, exports) {
$parcel$export(module.exports, "setErrorMap", () => $39fdf059a76c76f1$export$1097a8289cfd22d7);
$parcel$export(module.exports, "getErrorMap", () => $39fdf059a76c76f1$export$32f27c719778d4c4);
$parcel$export(module.exports, "defaultErrorMap", () => (parcelRequire("7Lhde")).default);

var $7Lhde = parcelRequire("7Lhde");
let $39fdf059a76c76f1$var$overrideErrorMap = (0, $7Lhde.default);
function $39fdf059a76c76f1$export$1097a8289cfd22d7(map) {
    $39fdf059a76c76f1$var$overrideErrorMap = map;
}
function $39fdf059a76c76f1$export$32f27c719778d4c4() {
    return $39fdf059a76c76f1$var$overrideErrorMap;
}

});
parcelRegister("7Lhde", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a6a46333f8bff17$export$2e2bcd8739ae039);

var $ffJWC = parcelRequire("ffJWC");

var $2v1nA = parcelRequire("2v1nA");
const $5a6a46333f8bff17$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $ffJWC.ZodIssueCode).invalid_type:
            if (issue.received === (0, $2v1nA.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $2v1nA.util).jsonStringifyReplacer)}`;
            break;
        case (0, $ffJWC.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $2v1nA.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $2v1nA.util).joinValues(issue.options)}`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $2v1nA.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $2v1nA.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $ffJWC.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $ffJWC.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $ffJWC.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, $ffJWC.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $ffJWC.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $ffJWC.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $2v1nA.util).assertNever(issue);
    }
    return {
        message: message
    };
};
var $5a6a46333f8bff17$export$2e2bcd8739ae039 = $5a6a46333f8bff17$var$errorMap;

});
parcelRegister("ffJWC", function(module, exports) {
$parcel$export(module.exports, "ZodIssueCode", () => $b1abe557bb36d754$export$5ba560653e4a1035);
$parcel$export(module.exports, "quotelessJson", () => $b1abe557bb36d754$export$913eddeaf297cfea);
$parcel$export(module.exports, "ZodError", () => $b1abe557bb36d754$export$f98dac4b251ab333);

var $2v1nA = parcelRequire("2v1nA");
const $b1abe557bb36d754$export$5ba560653e4a1035 = (0, $2v1nA.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $b1abe557bb36d754$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $b1abe557bb36d754$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $b1abe557bb36d754$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $2v1nA.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$b1abe557bb36d754$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $b1abe557bb36d754$export$f98dac4b251ab333(issues);
    return error;
};

});
parcelRegister("2v1nA", function(module, exports) {
$parcel$export(module.exports, "util", () => $1d1f8bedac522174$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "objectUtil", () => $1d1f8bedac522174$export$4aa2142c225fd5c7);
$parcel$export(module.exports, "ZodParsedType", () => $1d1f8bedac522174$export$5716da67bfaa244d);
$parcel$export(module.exports, "getParsedType", () => $1d1f8bedac522174$export$3e9057828ebd5c7a);
var $1d1f8bedac522174$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($1d1f8bedac522174$export$7debb50ef11d5e0b || ($1d1f8bedac522174$export$7debb50ef11d5e0b = {}));
var $1d1f8bedac522174$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($1d1f8bedac522174$export$4aa2142c225fd5c7 || ($1d1f8bedac522174$export$4aa2142c225fd5c7 = {}));
const $1d1f8bedac522174$export$5716da67bfaa244d = $1d1f8bedac522174$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $1d1f8bedac522174$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $1d1f8bedac522174$export$5716da67bfaa244d.undefined;
        case "string":
            return $1d1f8bedac522174$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $1d1f8bedac522174$export$5716da67bfaa244d.nan : $1d1f8bedac522174$export$5716da67bfaa244d.number;
        case "boolean":
            return $1d1f8bedac522174$export$5716da67bfaa244d.boolean;
        case "function":
            return $1d1f8bedac522174$export$5716da67bfaa244d.function;
        case "bigint":
            return $1d1f8bedac522174$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $1d1f8bedac522174$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $1d1f8bedac522174$export$5716da67bfaa244d.array;
            if (data === null) return $1d1f8bedac522174$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $1d1f8bedac522174$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $1d1f8bedac522174$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $1d1f8bedac522174$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $1d1f8bedac522174$export$5716da67bfaa244d.date;
            return $1d1f8bedac522174$export$5716da67bfaa244d.object;
        default:
            return $1d1f8bedac522174$export$5716da67bfaa244d.unknown;
    }
};

});




parcelRegister("c3uro", function(module, exports) {
$parcel$export(module.exports, "makeIssue", () => $8c6d60c885190470$export$244a85fde9c419ed);
$parcel$export(module.exports, "EMPTY_PATH", () => $8c6d60c885190470$export$1526d2e05f74572);
$parcel$export(module.exports, "addIssueToContext", () => $8c6d60c885190470$export$db7caee60e5d514d);
$parcel$export(module.exports, "ParseStatus", () => $8c6d60c885190470$export$5b20a5c3d05c1f6f);
$parcel$export(module.exports, "INVALID", () => $8c6d60c885190470$export$9a105a556e65c2c0);
$parcel$export(module.exports, "DIRTY", () => $8c6d60c885190470$export$325a211da9693fcf);
$parcel$export(module.exports, "OK", () => $8c6d60c885190470$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "isAborted", () => $8c6d60c885190470$export$afa861e3c5730743);
$parcel$export(module.exports, "isDirty", () => $8c6d60c885190470$export$910b6cdd390341b3);
$parcel$export(module.exports, "isValid", () => $8c6d60c885190470$export$1ea939691cdc45b8);
$parcel$export(module.exports, "isAsync", () => $8c6d60c885190470$export$aefee5ebe1dcfd9e);

var $4YGLw = parcelRequire("4YGLw");

var $7Lhde = parcelRequire("7Lhde");
const $8c6d60c885190470$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $8c6d60c885190470$export$1526d2e05f74572 = [];
function $8c6d60c885190470$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $4YGLw.getErrorMap)();
    const issue = $8c6d60c885190470$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $7Lhde.default) ? undefined : (0, $7Lhde.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $8c6d60c885190470$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $8c6d60c885190470$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $8c6d60c885190470$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $8c6d60c885190470$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $8c6d60c885190470$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $8c6d60c885190470$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $8c6d60c885190470$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $8c6d60c885190470$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $8c6d60c885190470$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $8c6d60c885190470$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $8c6d60c885190470$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $8c6d60c885190470$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

});

parcelRegister("8wOm4", function(module, exports) {

});

parcelRegister("4MVWb", function(module, exports) {
$parcel$export(module.exports, "ZodType", () => $37c89648753752d6$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodEffects", () => $37c89648753752d6$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodFirstPartyTypeKind", () => $37c89648753752d6$export$558106ce543bd011);
$parcel$export(module.exports, "ZodOptional", () => $37c89648753752d6$export$aa56fec1e9d629b8);
$parcel$export(module.exports, "ZodNullable", () => $37c89648753752d6$export$aaac0b8b429cef5);
$parcel$export(module.exports, "ZodArray", () => $37c89648753752d6$export$7acfc3e64785411);
$parcel$export(module.exports, "ZodPromise", () => $37c89648753752d6$export$3f196b0127d6e50a);
$parcel$export(module.exports, "ZodUnion", () => $37c89648753752d6$export$a8b236cb5070a311);
$parcel$export(module.exports, "ZodIntersection", () => $37c89648753752d6$export$c02deaf0bb5203d4);
$parcel$export(module.exports, "ZodDefault", () => $37c89648753752d6$export$bb19b37874861e7e);
$parcel$export(module.exports, "ZodBranded", () => $37c89648753752d6$export$66b0c798a395271f);
$parcel$export(module.exports, "ZodCatch", () => $37c89648753752d6$export$75a44ec6249ac76b);
$parcel$export(module.exports, "ZodPipeline", () => $37c89648753752d6$export$a3c3ef8a0e95c6da);
$parcel$export(module.exports, "ZodReadonly", () => $37c89648753752d6$export$5d1f7ef05c4e493a);
$parcel$export(module.exports, "datetimeRegex", () => $37c89648753752d6$export$a4b563879add27a);
$parcel$export(module.exports, "ZodString", () => $37c89648753752d6$export$1230eb29b8d3b502);
$parcel$export(module.exports, "ZodNumber", () => $37c89648753752d6$export$5b070a55c0c43e09);
$parcel$export(module.exports, "ZodBigInt", () => $37c89648753752d6$export$67d741fd70ff98f4);
$parcel$export(module.exports, "ZodBoolean", () => $37c89648753752d6$export$723d146f80596191);
$parcel$export(module.exports, "ZodDate", () => $37c89648753752d6$export$e974be33bdc55521);
$parcel$export(module.exports, "ZodSymbol", () => $37c89648753752d6$export$bcc3b40f6b638044);
$parcel$export(module.exports, "ZodUndefined", () => $37c89648753752d6$export$4e780e961c30340d);
$parcel$export(module.exports, "ZodNull", () => $37c89648753752d6$export$a96281f914484f2d);
$parcel$export(module.exports, "ZodAny", () => $37c89648753752d6$export$b9d1edb536b4e4eb);
$parcel$export(module.exports, "ZodUnknown", () => $37c89648753752d6$export$ef3b1bb1630977ae);
$parcel$export(module.exports, "ZodNever", () => $37c89648753752d6$export$1e576a20c3ce9fb5);
$parcel$export(module.exports, "ZodVoid", () => $37c89648753752d6$export$7d39f5df85f21031);
$parcel$export(module.exports, "ZodObject", () => $37c89648753752d6$export$736315c5b55efbad);
$parcel$export(module.exports, "ZodTuple", () => $37c89648753752d6$export$e2a18bb771d8e6a3);
$parcel$export(module.exports, "ZodLazy", () => $37c89648753752d6$export$378d0cfce37406e6);
$parcel$export(module.exports, "ZodLiteral", () => $37c89648753752d6$export$7e44096782a165d3);
$parcel$export(module.exports, "ZodEnum", () => $37c89648753752d6$export$d325d1f0e1c20179);
$parcel$export(module.exports, "ZodNativeEnum", () => $37c89648753752d6$export$370b2e8d6d6f5c56);
$parcel$export(module.exports, "ZodDiscriminatedUnion", () => $37c89648753752d6$export$5ef2424805ac76a3);
$parcel$export(module.exports, "ZodRecord", () => $37c89648753752d6$export$a2acc09968cb4b7f);
$parcel$export(module.exports, "ZodMap", () => $37c89648753752d6$export$163b6a2b712d9542);
$parcel$export(module.exports, "ZodSet", () => $37c89648753752d6$export$977057706f816712);
$parcel$export(module.exports, "ZodFunction", () => $37c89648753752d6$export$d4602ba55673f53c);
$parcel$export(module.exports, "ZodTransformer", () => $37c89648753752d6$export$a60af00cc0ce2582);
$parcel$export(module.exports, "ZodNaN", () => $37c89648753752d6$export$26ccfa0145e8511f);
$parcel$export(module.exports, "BRAND", () => $37c89648753752d6$export$cf2deea74cde46b4);
$parcel$export(module.exports, "custom", () => $37c89648753752d6$export$4c00f665f0d4b443);
$parcel$export(module.exports, "Schema", () => $37c89648753752d6$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "ZodSchema", () => $37c89648753752d6$export$2afb8ab49d4b92c0);
$parcel$export(module.exports, "late", () => $37c89648753752d6$export$1ee8ee30835eab8b);
$parcel$export(module.exports, "instanceof", () => $37c89648753752d6$export$3d916e7c22dbd8b5);
$parcel$export(module.exports, "string", () => $37c89648753752d6$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $37c89648753752d6$export$98e628dec113755e);
$parcel$export(module.exports, "nan", () => $37c89648753752d6$export$9e06de0973666692);
$parcel$export(module.exports, "bigint", () => $37c89648753752d6$export$a0f65b52274bcc00);
$parcel$export(module.exports, "boolean", () => $37c89648753752d6$export$4a21f16c33752377);
$parcel$export(module.exports, "date", () => $37c89648753752d6$export$324d90190a8b822a);
$parcel$export(module.exports, "symbol", () => $37c89648753752d6$export$8f701197936bc2a6);
$parcel$export(module.exports, "undefined", () => $37c89648753752d6$export$1db45310990710a5);
$parcel$export(module.exports, "null", () => $37c89648753752d6$export$7b1b591b262c240);
$parcel$export(module.exports, "any", () => $37c89648753752d6$export$4154a199d7d90455);
$parcel$export(module.exports, "unknown", () => $37c89648753752d6$export$19282c40b967aec6);
$parcel$export(module.exports, "never", () => $37c89648753752d6$export$b3e22bcfd64c1022);
$parcel$export(module.exports, "void", () => $37c89648753752d6$export$490e536ee7389aeb);
$parcel$export(module.exports, "array", () => $37c89648753752d6$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $37c89648753752d6$export$be5493f9613cbbe);
$parcel$export(module.exports, "strictObject", () => $37c89648753752d6$export$8fb0df5f40d0b477);
$parcel$export(module.exports, "union", () => $37c89648753752d6$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "discriminatedUnion", () => $37c89648753752d6$export$4b888e40c4ee26dd);
$parcel$export(module.exports, "intersection", () => $37c89648753752d6$export$bc86dfbf7795668c);
$parcel$export(module.exports, "tuple", () => $37c89648753752d6$export$65e3907585753458);
$parcel$export(module.exports, "record", () => $37c89648753752d6$export$e5185e241753e543);
$parcel$export(module.exports, "map", () => $37c89648753752d6$export$871de8747c9eaa88);
$parcel$export(module.exports, "set", () => $37c89648753752d6$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "function", () => $37c89648753752d6$export$44e51c8aac7c2deb);
$parcel$export(module.exports, "lazy", () => $37c89648753752d6$export$488013bae63b21da);
$parcel$export(module.exports, "literal", () => $37c89648753752d6$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "enum", () => $37c89648753752d6$export$78a99c8d44d72635);
$parcel$export(module.exports, "nativeEnum", () => $37c89648753752d6$export$6fe7eca19ebe5199);
$parcel$export(module.exports, "promise", () => $37c89648753752d6$export$c957ef27a0ebfd4);
$parcel$export(module.exports, "effect", () => $37c89648753752d6$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "optional", () => $37c89648753752d6$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "nullable", () => $37c89648753752d6$export$133fc36489ac9add);
$parcel$export(module.exports, "preprocess", () => $37c89648753752d6$export$fc37fe19dfda43ee);
$parcel$export(module.exports, "pipeline", () => $37c89648753752d6$export$43f28b24e1eb8181);
$parcel$export(module.exports, "ostring", () => $37c89648753752d6$export$3b3d07727c5b702c);
$parcel$export(module.exports, "onumber", () => $37c89648753752d6$export$eb150471a61fced6);
$parcel$export(module.exports, "oboolean", () => $37c89648753752d6$export$269251733cdcbbf1);
$parcel$export(module.exports, "coerce", () => $37c89648753752d6$export$8c14e57e778d3873);
$parcel$export(module.exports, "transformer", () => $37c89648753752d6$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "NEVER", () => $37c89648753752d6$export$96c94437c95d7862);

var $ffJWC = parcelRequire("ffJWC");
parcelRequire("4YGLw");
var $7Lhde = parcelRequire("7Lhde");
var $4YGLw = parcelRequire("4YGLw");

var $bbepS = parcelRequire("bbepS");

var $c3uro = parcelRequire("c3uro");

var $2v1nA = parcelRequire("2v1nA");
class $37c89648753752d6$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $37c89648753752d6$var$handleResult = (ctx, result)=>{
    if ((0, $c3uro.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $ffJWC.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $37c89648753752d6$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $37c89648753752d6$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $2v1nA.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $2v1nA.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $c3uro.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $2v1nA.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $c3uro.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $2v1nA.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $37c89648753752d6$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $2v1nA.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $c3uro.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $c3uro.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $2v1nA.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $c3uro.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $37c89648753752d6$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $ffJWC.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $37c89648753752d6$export$a60af00cc0ce2582({
            schema: this,
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $37c89648753752d6$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $37c89648753752d6$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $37c89648753752d6$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $37c89648753752d6$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $37c89648753752d6$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $37c89648753752d6$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $37c89648753752d6$export$a60af00cc0ce2582({
            ...$37c89648753752d6$var$processCreateParams(this._def),
            schema: this,
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $37c89648753752d6$export$bb19b37874861e7e({
            ...$37c89648753752d6$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $37c89648753752d6$export$66b0c798a395271f({
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$37c89648753752d6$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $37c89648753752d6$export$75a44ec6249ac76b({
            ...$37c89648753752d6$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $37c89648753752d6$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $37c89648753752d6$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $37c89648753752d6$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $37c89648753752d6$var$cuid2Regex = /^[0-9a-z]+$/;
const $37c89648753752d6$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $37c89648753752d6$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $37c89648753752d6$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $37c89648753752d6$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $37c89648753752d6$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $37c89648753752d6$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $37c89648753752d6$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $37c89648753752d6$var$emojiRegex;
// faster, simpler, safer
const $37c89648753752d6$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $37c89648753752d6$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $37c89648753752d6$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $37c89648753752d6$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $37c89648753752d6$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $37c89648753752d6$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $37c89648753752d6$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $37c89648753752d6$var$dateRegex = new RegExp(`^${$37c89648753752d6$var$dateRegexSource}$`);
function $37c89648753752d6$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $37c89648753752d6$var$timeRegex(args) {
    return new RegExp(`^${$37c89648753752d6$var$timeRegexSource(args)}$`);
}
function $37c89648753752d6$export$a4b563879add27a(args) {
    let regex = `${$37c89648753752d6$var$dateRegexSource}T${$37c89648753752d6$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $37c89648753752d6$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $37c89648753752d6$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $37c89648753752d6$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $37c89648753752d6$var$isValidJWT(jwt, alg) {
    if (!$37c89648753752d6$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $37c89648753752d6$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $37c89648753752d6$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $37c89648753752d6$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $37c89648753752d6$export$1230eb29b8d3b502 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        const status = new (0, $c3uro.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$37c89648753752d6$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$37c89648753752d6$var$emojiRegex) $37c89648753752d6$var$emojiRegex = new RegExp($37c89648753752d6$var$_emojiRegex, "u");
                if (!$37c89648753752d6$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$37c89648753752d6$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$37c89648753752d6$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$37c89648753752d6$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$37c89648753752d6$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$37c89648753752d6$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $c3uro.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, $ffJWC.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $37c89648753752d6$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $37c89648753752d6$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $37c89648753752d6$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$37c89648753752d6$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$37c89648753752d6$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$37c89648753752d6$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$37c89648753752d6$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$37c89648753752d6$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$37c89648753752d6$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, $ffJWC.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $2v1nA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $ffJWC.ZodIssueCode).invalid_string,
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $37c89648753752d6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $bbepS.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $bbepS.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $bbepS.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $bbepS.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $bbepS.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $bbepS.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $bbepS.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $bbepS.errorUtil).errToObj(message));
    }
    trim() {
        return new $37c89648753752d6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $37c89648753752d6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $37c89648753752d6$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$37c89648753752d6$export$1230eb29b8d3b502.create = (params)=>{
    return new $37c89648753752d6$export$1230eb29b8d3b502({
        checks: [],
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $37c89648753752d6$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $37c89648753752d6$export$5b070a55c0c43e09 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        let ctx = undefined;
        const status = new (0, $c3uro.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $2v1nA.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($37c89648753752d6$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $2v1nA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $bbepS.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $bbepS.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $bbepS.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $bbepS.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $37c89648753752d6$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $bbepS.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $37c89648753752d6$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $bbepS.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $2v1nA.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$37c89648753752d6$export$5b070a55c0c43e09.create = (params)=>{
    return new $37c89648753752d6$export$5b070a55c0c43e09({
        checks: [],
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$67d741fd70ff98f4 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $c3uro.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $2v1nA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $c3uro.addIssueToContext)(ctx, {
            code: (0, $ffJWC.ZodIssueCode).invalid_type,
            expected: (0, $2v1nA.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, $c3uro.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $bbepS.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $bbepS.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $bbepS.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $bbepS.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $37c89648753752d6$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $bbepS.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $37c89648753752d6$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$37c89648753752d6$export$67d741fd70ff98f4.create = (params)=>{
    return new $37c89648753752d6$export$67d741fd70ff98f4({
        checks: [],
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$723d146f80596191 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        return (0, $c3uro.OK)(input.data);
    }
}
$37c89648753752d6$export$723d146f80596191.create = (params)=>{
    return new $37c89648753752d6$export$723d146f80596191({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$e974be33bdc55521 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_date
            });
            return 0, $c3uro.INVALID;
        }
        const status = new (0, $c3uro.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $2v1nA.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $37c89648753752d6$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $bbepS.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$37c89648753752d6$export$e974be33bdc55521.create = (params)=>{
    return new $37c89648753752d6$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodDate,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$bcc3b40f6b638044 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        return (0, $c3uro.OK)(input.data);
    }
}
$37c89648753752d6$export$bcc3b40f6b638044.create = (params)=>{
    return new $37c89648753752d6$export$bcc3b40f6b638044({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodSymbol,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$4e780e961c30340d extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        return (0, $c3uro.OK)(input.data);
    }
}
$37c89648753752d6$export$4e780e961c30340d.create = (params)=>{
    return new $37c89648753752d6$export$4e780e961c30340d({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodUndefined,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$a96281f914484f2d extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        return (0, $c3uro.OK)(input.data);
    }
}
$37c89648753752d6$export$a96281f914484f2d.create = (params)=>{
    return new $37c89648753752d6$export$a96281f914484f2d({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodNull,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$b9d1edb536b4e4eb extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $c3uro.OK)(input.data);
    }
}
$37c89648753752d6$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $37c89648753752d6$export$b9d1edb536b4e4eb({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodAny,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$ef3b1bb1630977ae extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $c3uro.OK)(input.data);
    }
}
$37c89648753752d6$export$ef3b1bb1630977ae.create = (params)=>{
    return new $37c89648753752d6$export$ef3b1bb1630977ae({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodUnknown,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$1e576a20c3ce9fb5 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $c3uro.addIssueToContext)(ctx, {
            code: (0, $ffJWC.ZodIssueCode).invalid_type,
            expected: (0, $2v1nA.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, $c3uro.INVALID;
    }
}
$37c89648753752d6$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $37c89648753752d6$export$1e576a20c3ce9fb5({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodNever,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$7d39f5df85f21031 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        return (0, $c3uro.OK)(input.data);
    }
}
$37c89648753752d6$export$7d39f5df85f21031.create = (params)=>{
    return new $37c89648753752d6$export$7d39f5df85f21031({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodVoid,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$7acfc3e64785411 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).array) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $c3uro.addIssueToContext)(ctx, {
                    code: tooBig ? (0, $ffJWC.ZodIssueCode).too_big : (0, $ffJWC.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $c3uro.addIssueToContext)(ctx, {
                    code: (0, $ffJWC.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $c3uro.addIssueToContext)(ctx, {
                    code: (0, $ffJWC.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $37c89648753752d6$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $c3uro.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $37c89648753752d6$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $c3uro.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $37c89648753752d6$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $bbepS.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $37c89648753752d6$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $bbepS.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new $37c89648753752d6$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $bbepS.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$37c89648753752d6$export$7acfc3e64785411.create = (schema, params)=>{
    return new $37c89648753752d6$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodArray,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
function $37c89648753752d6$var$deepPartialify(schema) {
    if (schema instanceof $37c89648753752d6$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $37c89648753752d6$export$aa56fec1e9d629b8.create($37c89648753752d6$var$deepPartialify(fieldSchema));
        }
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $37c89648753752d6$export$7acfc3e64785411) return new $37c89648753752d6$export$7acfc3e64785411({
        ...schema._def,
        type: $37c89648753752d6$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $37c89648753752d6$export$aa56fec1e9d629b8) return $37c89648753752d6$export$aa56fec1e9d629b8.create($37c89648753752d6$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $37c89648753752d6$export$aaac0b8b429cef5) return $37c89648753752d6$export$aaac0b8b429cef5.create($37c89648753752d6$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $37c89648753752d6$export$e2a18bb771d8e6a3) return $37c89648753752d6$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$37c89648753752d6$var$deepPartialify(item)));
    else return schema;
}
class $37c89648753752d6$export$736315c5b55efbad extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $2v1nA.util).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $37c89648753752d6$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $37c89648753752d6$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $c3uro.addIssueToContext)(ctx, {
                        code: (0, $ffJWC.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $c3uro.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, $c3uro.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $bbepS.errorUtil).errToObj;
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $bbepS.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $37c89648753752d6$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $2v1nA.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $2v1nA.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $37c89648753752d6$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $2v1nA.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $2v1nA.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $37c89648753752d6$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $37c89648753752d6$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $37c89648753752d6$var$createZodEnum((0, $2v1nA.util).objectKeys(this.shape));
    }
}
$37c89648753752d6$export$736315c5b55efbad.create = (shape, params)=>{
    return new $37c89648753752d6$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $37c89648753752d6$export$1e576a20c3ce9fb5.create(),
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodObject,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
$37c89648753752d6$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $37c89648753752d6$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $37c89648753752d6$export$1e576a20c3ce9fb5.create(),
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodObject,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
$37c89648753752d6$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $37c89648753752d6$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $37c89648753752d6$export$1e576a20c3ce9fb5.create(),
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodObject,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$a8b236cb5070a311 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $ffJWC.ZodError)(result.ctx.common.issues));
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $c3uro.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $ffJWC.ZodError)(issues));
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $c3uro.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
$37c89648753752d6$export$a8b236cb5070a311.create = (types, params)=>{
    return new $37c89648753752d6$export$a8b236cb5070a311({
        options: types,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodUnion,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $37c89648753752d6$var$getDiscriminator = (type)=>{
    if (type instanceof $37c89648753752d6$export$378d0cfce37406e6) return $37c89648753752d6$var$getDiscriminator(type.schema);
    else if (type instanceof $37c89648753752d6$export$a60af00cc0ce2582) return $37c89648753752d6$var$getDiscriminator(type.innerType());
    else if (type instanceof $37c89648753752d6$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $37c89648753752d6$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $37c89648753752d6$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $2v1nA.util).objectValues(type.enum);
    else if (type instanceof $37c89648753752d6$export$bb19b37874861e7e) return $37c89648753752d6$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $37c89648753752d6$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $37c89648753752d6$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $37c89648753752d6$export$aa56fec1e9d629b8) return [
        undefined,
        ...$37c89648753752d6$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $37c89648753752d6$export$aaac0b8b429cef5) return [
        null,
        ...$37c89648753752d6$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $37c89648753752d6$export$66b0c798a395271f) return $37c89648753752d6$var$getDiscriminator(type.unwrap());
    else if (type instanceof $37c89648753752d6$export$5d1f7ef05c4e493a) return $37c89648753752d6$var$getDiscriminator(type.unwrap());
    else if (type instanceof $37c89648753752d6$export$75a44ec6249ac76b) return $37c89648753752d6$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $37c89648753752d6$export$5ef2424805ac76a3 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).object) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $c3uro.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $37c89648753752d6$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $37c89648753752d6$export$5ef2424805ac76a3({
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$37c89648753752d6$var$processCreateParams(params)
        });
    }
}
function $37c89648753752d6$var$mergeValues(a, b) {
    const aType = (0, $2v1nA.getParsedType)(a);
    const bType = (0, $2v1nA.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $2v1nA.ZodParsedType).object && bType === (0, $2v1nA.ZodParsedType).object) {
        const bKeys = (0, $2v1nA.util).objectKeys(b);
        const sharedKeys = (0, $2v1nA.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $37c89648753752d6$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $2v1nA.ZodParsedType).array && bType === (0, $2v1nA.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $37c89648753752d6$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $2v1nA.ZodParsedType).date && bType === (0, $2v1nA.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $37c89648753752d6$export$c02deaf0bb5203d4 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $c3uro.isAborted)(parsedLeft) || (0, $c3uro.isAborted)(parsedRight)) return 0, $c3uro.INVALID;
            const merged = $37c89648753752d6$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $c3uro.addIssueToContext)(ctx, {
                    code: (0, $ffJWC.ZodIssueCode).invalid_intersection_types
                });
                return 0, $c3uro.INVALID;
            }
            if ((0, $c3uro.isDirty)(parsedLeft) || (0, $c3uro.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$37c89648753752d6$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $37c89648753752d6$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodIntersection,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$e2a18bb771d8e6a3 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).array) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $c3uro.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $c3uro.ParseStatus).mergeArray(status, results);
        });
        else return (0, $c3uro.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $37c89648753752d6$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$37c89648753752d6$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $37c89648753752d6$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$a2acc09968cb4b7f extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).object) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $c3uro.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, $c3uro.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $37c89648753752d6$export$2afb8ab49d4b92c0) return new $37c89648753752d6$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodRecord,
            ...$37c89648753752d6$var$processCreateParams(third)
        });
        return new $37c89648753752d6$export$a2acc09968cb4b7f({
            keyType: $37c89648753752d6$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodRecord,
            ...$37c89648753752d6$var$processCreateParams(second)
        });
    }
}
class $37c89648753752d6$export$163b6a2b712d9542 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).map) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $c3uro.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $c3uro.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$37c89648753752d6$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $37c89648753752d6$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodMap,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$977057706f816712 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).set) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $c3uro.addIssueToContext)(ctx, {
                    code: (0, $ffJWC.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $c3uro.addIssueToContext)(ctx, {
                    code: (0, $ffJWC.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $c3uro.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $37c89648753752d6$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $37c89648753752d6$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $bbepS.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $37c89648753752d6$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $bbepS.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$37c89648753752d6$export$977057706f816712.create = (valueType, params)=>{
    return new $37c89648753752d6$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodSet,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$d4602ba55673f53c extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).function) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $c3uro.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $4YGLw.getErrorMap)(),
                    (0, $7Lhde.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $ffJWC.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $c3uro.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $4YGLw.getErrorMap)(),
                    (0, $7Lhde.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $ffJWC.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $37c89648753752d6$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $c3uro.OK)(async function(...args) {
                const error = new (0, $ffJWC.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $c3uro.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $ffJWC.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $ffJWC.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $37c89648753752d6$export$d4602ba55673f53c({
            ...this._def,
            args: $37c89648753752d6$export$e2a18bb771d8e6a3.create(items).rest($37c89648753752d6$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $37c89648753752d6$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $37c89648753752d6$export$d4602ba55673f53c({
            args: args ? args : $37c89648753752d6$export$e2a18bb771d8e6a3.create([]).rest($37c89648753752d6$export$ef3b1bb1630977ae.create()),
            returns: returns || $37c89648753752d6$export$ef3b1bb1630977ae.create(),
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodFunction,
            ...$37c89648753752d6$var$processCreateParams(params)
        });
    }
}
class $37c89648753752d6$export$378d0cfce37406e6 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$37c89648753752d6$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $37c89648753752d6$export$378d0cfce37406e6({
        getter: getter,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodLazy,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$7e44096782a165d3 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $ffJWC.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, $c3uro.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$37c89648753752d6$export$7e44096782a165d3.create = (value, params)=>{
    return new $37c89648753752d6$export$7e44096782a165d3({
        value: value,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodLiteral,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
function $37c89648753752d6$var$createZodEnum(values, params) {
    return new $37c89648753752d6$export$d325d1f0e1c20179({
        values: values,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodEnum,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
}
class $37c89648753752d6$export$d325d1f0e1c20179 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $c3uro.addIssueToContext)(ctx, {
                expected: (0, $2v1nA.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $ffJWC.ZodIssueCode).invalid_type
            });
            return 0, $c3uro.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $c3uro.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $ffJWC.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $c3uro.INVALID;
        }
        return (0, $c3uro.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $37c89648753752d6$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $37c89648753752d6$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$37c89648753752d6$export$d325d1f0e1c20179.create = $37c89648753752d6$var$createZodEnum;
class $37c89648753752d6$export$370b2e8d6d6f5c56 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $2v1nA.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).string && ctx.parsedType !== (0, $2v1nA.ZodParsedType).number) {
            const expectedValues = (0, $2v1nA.util).objectValues(nativeEnumValues);
            (0, $c3uro.addIssueToContext)(ctx, {
                expected: (0, $2v1nA.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $ffJWC.ZodIssueCode).invalid_type
            });
            return 0, $c3uro.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, $2v1nA.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $2v1nA.util).objectValues(nativeEnumValues);
            (0, $c3uro.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $ffJWC.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $c3uro.INVALID;
        }
        return (0, $c3uro.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$37c89648753752d6$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $37c89648753752d6$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodNativeEnum,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$3f196b0127d6e50a extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $2v1nA.ZodParsedType).promise && ctx.common.async === false) {
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        const promisified = ctx.parsedType === (0, $2v1nA.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $c3uro.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$37c89648753752d6$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $37c89648753752d6$export$3f196b0127d6e50a({
        type: schema,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodPromise,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$a60af00cc0ce2582 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $37c89648753752d6$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $c3uro.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $c3uro.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $c3uro.INVALID;
                if (result.status === "dirty") return (0, $c3uro.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $c3uro.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $c3uro.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $c3uro.INVALID;
                if (result.status === "dirty") return (0, $c3uro.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $c3uro.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $c3uro.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $c3uro.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $c3uro.isValid)(base)) return 0, $c3uro.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $c3uro.isValid)(base)) return 0, $c3uro.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $2v1nA.util).assertNever(effect);
    }
}
$37c89648753752d6$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $37c89648753752d6$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
$37c89648753752d6$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $37c89648753752d6$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodEffects,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$aa56fec1e9d629b8 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $2v1nA.ZodParsedType).undefined) return (0, $c3uro.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$37c89648753752d6$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $37c89648753752d6$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodOptional,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$aaac0b8b429cef5 extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $2v1nA.ZodParsedType).null) return (0, $c3uro.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$37c89648753752d6$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $37c89648753752d6$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodNullable,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$bb19b37874861e7e extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $2v1nA.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$37c89648753752d6$export$bb19b37874861e7e.create = (type, params)=>{
    return new $37c89648753752d6$export$bb19b37874861e7e({
        innerType: type,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$75a44ec6249ac76b extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $c3uro.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $ffJWC.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $ffJWC.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$37c89648753752d6$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $37c89648753752d6$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
class $37c89648753752d6$export$26ccfa0145e8511f extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $2v1nA.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $c3uro.addIssueToContext)(ctx, {
                code: (0, $ffJWC.ZodIssueCode).invalid_type,
                expected: (0, $2v1nA.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, $c3uro.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$37c89648753752d6$export$26ccfa0145e8511f.create = (params)=>{
    return new $37c89648753752d6$export$26ccfa0145e8511f({
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodNaN,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
const $37c89648753752d6$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $37c89648753752d6$export$66b0c798a395271f extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $37c89648753752d6$export$a3c3ef8a0e95c6da extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $c3uro.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $c3uro.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $c3uro.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $37c89648753752d6$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $37c89648753752d6$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $37c89648753752d6$export$5d1f7ef05c4e493a extends $37c89648753752d6$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $c3uro.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $c3uro.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$37c89648753752d6$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $37c89648753752d6$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $37c89648753752d6$export$558106ce543bd011.ZodReadonly,
        ...$37c89648753752d6$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $37c89648753752d6$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $37c89648753752d6$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $37c89648753752d6$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $37c89648753752d6$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $37c89648753752d6$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $37c89648753752d6$export$b9d1edb536b4e4eb.create();
}
const $37c89648753752d6$export$1ee8ee30835eab8b = {
    object: $37c89648753752d6$export$736315c5b55efbad.lazycreate
};
var $37c89648753752d6$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($37c89648753752d6$export$558106ce543bd011 || ($37c89648753752d6$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $37c89648753752d6$var$Class {
    constructor(..._){}
}
const $37c89648753752d6$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$37c89648753752d6$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $37c89648753752d6$export$22b082955e083ec3 = $37c89648753752d6$export$1230eb29b8d3b502.create;
const $37c89648753752d6$export$98e628dec113755e = $37c89648753752d6$export$5b070a55c0c43e09.create;
const $37c89648753752d6$export$9e06de0973666692 = $37c89648753752d6$export$26ccfa0145e8511f.create;
const $37c89648753752d6$export$a0f65b52274bcc00 = $37c89648753752d6$export$67d741fd70ff98f4.create;
const $37c89648753752d6$export$4a21f16c33752377 = $37c89648753752d6$export$723d146f80596191.create;
const $37c89648753752d6$export$324d90190a8b822a = $37c89648753752d6$export$e974be33bdc55521.create;
const $37c89648753752d6$export$8f701197936bc2a6 = $37c89648753752d6$export$bcc3b40f6b638044.create;
const $37c89648753752d6$export$1db45310990710a5 = $37c89648753752d6$export$4e780e961c30340d.create;
const $37c89648753752d6$export$7b1b591b262c240 = $37c89648753752d6$export$a96281f914484f2d.create;
const $37c89648753752d6$export$4154a199d7d90455 = $37c89648753752d6$export$b9d1edb536b4e4eb.create;
const $37c89648753752d6$export$19282c40b967aec6 = $37c89648753752d6$export$ef3b1bb1630977ae.create;
const $37c89648753752d6$export$b3e22bcfd64c1022 = $37c89648753752d6$export$1e576a20c3ce9fb5.create;
const $37c89648753752d6$export$490e536ee7389aeb = $37c89648753752d6$export$7d39f5df85f21031.create;
const $37c89648753752d6$export$2f23118c22fb2630 = $37c89648753752d6$export$7acfc3e64785411.create;
const $37c89648753752d6$export$be5493f9613cbbe = $37c89648753752d6$export$736315c5b55efbad.create;
const $37c89648753752d6$export$8fb0df5f40d0b477 = $37c89648753752d6$export$736315c5b55efbad.strictCreate;
const $37c89648753752d6$export$971dd5b0dfd021b6 = $37c89648753752d6$export$a8b236cb5070a311.create;
const $37c89648753752d6$export$4b888e40c4ee26dd = $37c89648753752d6$export$5ef2424805ac76a3.create;
const $37c89648753752d6$export$bc86dfbf7795668c = $37c89648753752d6$export$c02deaf0bb5203d4.create;
const $37c89648753752d6$export$65e3907585753458 = $37c89648753752d6$export$e2a18bb771d8e6a3.create;
const $37c89648753752d6$export$e5185e241753e543 = $37c89648753752d6$export$a2acc09968cb4b7f.create;
const $37c89648753752d6$export$871de8747c9eaa88 = $37c89648753752d6$export$163b6a2b712d9542.create;
const $37c89648753752d6$export$adaa4cf7ef1b65be = $37c89648753752d6$export$977057706f816712.create;
const $37c89648753752d6$export$44e51c8aac7c2deb = $37c89648753752d6$export$d4602ba55673f53c.create;
const $37c89648753752d6$export$488013bae63b21da = $37c89648753752d6$export$378d0cfce37406e6.create;
const $37c89648753752d6$export$c8ec6e1ec9fefcb0 = $37c89648753752d6$export$7e44096782a165d3.create;
const $37c89648753752d6$export$78a99c8d44d72635 = $37c89648753752d6$export$d325d1f0e1c20179.create;
const $37c89648753752d6$export$6fe7eca19ebe5199 = $37c89648753752d6$export$370b2e8d6d6f5c56.create;
const $37c89648753752d6$export$c957ef27a0ebfd4 = $37c89648753752d6$export$3f196b0127d6e50a.create;
const $37c89648753752d6$export$dc573d8a6576cdb3 = $37c89648753752d6$export$a60af00cc0ce2582.create;
const $37c89648753752d6$export$516e28dec6a4b6d4 = $37c89648753752d6$export$aa56fec1e9d629b8.create;
const $37c89648753752d6$export$133fc36489ac9add = $37c89648753752d6$export$aaac0b8b429cef5.create;
const $37c89648753752d6$export$fc37fe19dfda43ee = $37c89648753752d6$export$a60af00cc0ce2582.createWithPreprocess;
const $37c89648753752d6$export$43f28b24e1eb8181 = $37c89648753752d6$export$a3c3ef8a0e95c6da.create;
const $37c89648753752d6$export$3b3d07727c5b702c = ()=>$37c89648753752d6$export$22b082955e083ec3().optional();
const $37c89648753752d6$export$eb150471a61fced6 = ()=>$37c89648753752d6$export$98e628dec113755e().optional();
const $37c89648753752d6$export$269251733cdcbbf1 = ()=>$37c89648753752d6$export$4a21f16c33752377().optional();
const $37c89648753752d6$export$8c14e57e778d3873 = {
    string: (arg)=>$37c89648753752d6$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$37c89648753752d6$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$37c89648753752d6$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$37c89648753752d6$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$37c89648753752d6$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $37c89648753752d6$export$96c94437c95d7862 = (0, $c3uro.INVALID);

});
parcelRegister("bbepS", function(module, exports) {
$parcel$export(module.exports, "errorUtil", () => $823be79742e1de9d$export$b9faa7f0c32cb80d);
var $823be79742e1de9d$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($823be79742e1de9d$export$b9faa7f0c32cb80d || ($823be79742e1de9d$export$b9faa7f0c32cb80d = {}));

});






var $1v5pe = parcelRequire("1v5pe");

var $4okYx = parcelRequire("4okYx");

var $calFH = parcelRequire("calFH");

var $bHcZt = parcelRequire("bHcZt");


var $lNKZj = parcelRequire("lNKZj");

var $gOQGR = parcelRequire("gOQGR");

var $aX5WL = parcelRequire("aX5WL");

var $f0dSY = parcelRequire("f0dSY");

var $1v5pe = parcelRequire("1v5pe");
parcelRequire("calFH");
var $30t8d = parcelRequire("30t8d");

var $fjzd2 = parcelRequire("fjzd2");

var $f0dSY = parcelRequire("f0dSY");

var $9NbMC = parcelRequire("9NbMC");

var $9aNsE = parcelRequire("9aNsE");

var $bFW4F = parcelRequire("bFW4F");

var $1QYE6 = parcelRequire("1QYE6");

var $bI4fx = parcelRequire("bI4fx");
function $6a928bdc46f360ef$export$5f3292ad3ab2d536(userEmail) {
    return userEmail.endsWith('@atlassian.com');
}



var $1v5pe = parcelRequire("1v5pe");

var $5I7AE = parcelRequire("5I7AE");
const $c105407717ae6200$var$AuthLoadingScreen = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        "data-testid": "auth-loading-screen",
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            backgroundColor: 'elevation.surface'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $5I7AE.default), {
        size: 150
    }));
};
var $c105407717ae6200$export$2e2bcd8739ae039 = $c105407717ae6200$var$AuthLoadingScreen;


const $a801d5f2705eca37$export$a832bf999c337547 = 'site-loading';
const $a801d5f2705eca37$export$cab619d1bce8d47a = 'user-loading';
function $a801d5f2705eca37$export$2e2bcd8739ae039({ Component: Component, LoginComponent: LoginComponent, publicRoutes: publicRoutes = [] }) {
    const [site, setSite] = (0, $1v5pe.useState)((0, $1QYE6.getSelectedSiteFromLocalStorage)());
    const [_, setIsInitialized] = (0, $1v5pe.useState)(false);
    const { pathname: pathname } = (0, $30t8d.useLocation)();
    const anonymousId = JSON.parse(localStorage.getItem('ajs_anonymous_id') ?? '""') || undefined;
    const { data: userAccount, error: userError, isLoading: isUserLoading, isFetching: isFetching, isSuccess: isSuccess, isError: isError } = (0, $bFW4F.useUserAccount)();
    const isPublicRoute = publicRoutes.some((route)=>pathname.startsWith(route));
    if (isPublicRoute) {
        const isQueryRunning = isFetching || !isSuccess && !isError;
        // block Statsig initialization until we know the final user state
        // instead, show a loading screen while waiting for the user account to load
        if (isQueryRunning) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $c105407717ae6200$export$2e2bcd8739ae039), null);
        // if the user is logged out, use the anonymous id for initialization
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9NbMC.StatSigInitialization), {
            analyticsAnonymousId: anonymousId,
            userAccount: userAccount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, {
            site: site,
            userAccount: userAccount
        }));
    }
    const handleSiteChange = async (newSite)=>{
        setSite(newSite);
    };
    if (isUserLoading || !userAccount && !userError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $fjzd2.default), {
        name: "user-authentication-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement("div", {
        "data-testid": $a801d5f2705eca37$export$cab619d1bce8d47a
    }));
    if (userError) return LoginComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9NbMC.StatSigInitialization), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(LoginComponent, {
        hasError: userError.errorType !== (0, $9aNsE.RequestErrorType).AUTH_ERROR
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).Fragment, null);
    (0, $bI4fx.postMessageToParent)({
        type: 'USER_UPDATE',
        value: {
            userId: userAccount.accountId,
            isAtlassianUser: (0, $6a928bdc46f360ef$export$5f3292ad3ab2d536)(userAccount.email)
        }
    });
    (0, $f0dSY.setSentryUser)(userAccount.accountId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $9NbMC.StatSigInitialization), {
        analyticsAnonymousId: anonymousId,
        onInitialized: ()=>setIsInitialized(true),
        site: site,
        userAccount: userAccount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1QYE6.SiteProvider), {
        onSiteChange: handleSiteChange,
        userAccount: userAccount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement(Component, {
        site: site,
        userAccount: userAccount
    })));
}



var $cKss1 = parcelRequire("cKss1");

var $1v5pe = parcelRequire("1v5pe");

var $cZ6aD = parcelRequire("cZ6aD");
function $34dba73ed8a4a50e$export$89c0607256d35f0a(message) {
    if (typeof console !== 'undefined' && console.info) console.info(`[rovo-extension/i18n] ${message}`);
}
function $34dba73ed8a4a50e$export$58da9968c3170cb1(errorInfo) {
    if (typeof console !== 'undefined' && console.error) console.error(`[rovo-extension/i18n] ${errorInfo.impact}`, errorInfo.error);
}


const $6967de817d53f553$export$94d2d72df36bbb16 = [
    'cs',
    'da',
    'de',
    'en',
    'en-GB',
    'en-AU',
    'en-IN',
    'en-NZ',
    'en-US',
    'en-XA',
    'en-XB',
    'en-ZZ',
    'es',
    'fi',
    'fr',
    'hr',
    'hu',
    'it',
    'ja',
    'ko',
    'nb',
    'nl',
    'pl',
    'pt',
    'pt-BR',
    'ru',
    'sl',
    'sr',
    'sv',
    'th',
    'tr',
    'uk',
    'vi',
    'zh',
    'zh-TW'
];
function $6967de817d53f553$export$e88b669f03544b69(locale) {
    const normalizedLocale = locale.replace('_', '-');
    if ($6967de817d53f553$export$94d2d72df36bbb16.includes(normalizedLocale)) return normalizedLocale;
    if ((normalizedLocale.match(/-/g) ?? []).length > 1) {
        const secondHyphen = normalizedLocale.indexOf('-', 3);
        const localeWithoutVariant = normalizedLocale.substring(0, secondHyphen);
        if ($6967de817d53f553$export$94d2d72df36bbb16.includes(localeWithoutVariant)) {
            (0, $34dba73ed8a4a50e$export$89c0607256d35f0a)(`Unable to find locale data for ${locale}, attempting to load ${localeWithoutVariant} fallback`);
            return localeWithoutVariant;
        }
    }
    const languageCode = normalizedLocale.substring(0, 2);
    if ($6967de817d53f553$export$94d2d72df36bbb16.includes(languageCode)) {
        (0, $34dba73ed8a4a50e$export$89c0607256d35f0a)(`Unable to find locale data for ${locale}, attempting to load ${languageCode} fallback`);
        return languageCode;
    }
    (0, $34dba73ed8a4a50e$export$89c0607256d35f0a)(`Unable to find locale data for ${locale}, attempting to load English fallback`);
    return 'en';
}


function $e5f9102dfff0b1bd$export$aaf01d6467973d49(messages) {
    const blockified = {};
    const blockMap = {
        a: "\uFF41",
        b: "\uFF42",
        c: "\uFF43",
        d: "\uFF44",
        e: "\uFF45",
        f: "\uFF46",
        g: "\uFF47",
        h: "\uFF48",
        i: "\uFF49",
        j: "\uFF4A",
        k: "\uFF4B",
        l: "\uFF4C",
        m: "\uFF4D",
        n: "\uFF4E",
        o: "\uFF4F",
        p: "\uFF50",
        q: "\uFF51",
        r: "\uFF52",
        s: "\uFF53",
        t: "\uFF54",
        u: "\uFF55",
        v: "\uFF56",
        w: "\uFF57",
        x: "\uFF58",
        y: "\uFF59",
        z: "\uFF5A",
        A: "\uFF21",
        B: "\uFF22",
        C: "\uFF23",
        D: "\uFF24",
        E: "\uFF25",
        F: "\uFF26",
        G: "\uFF27",
        H: "\uFF28",
        I: "\uFF29",
        J: "\uFF2A",
        K: "\uFF2B",
        L: "\uFF2C",
        M: "\uFF2D",
        N: "\uFF2E",
        O: "\uFF2F",
        P: "\uFF30",
        Q: "\uFF31",
        R: "\uFF32",
        S: "\uFF33",
        T: "\uFF34",
        U: "\uFF35",
        V: "\uFF36",
        W: "\uFF37",
        X: "\uFF38",
        Y: "\uFF39",
        Z: "\uFF3A",
        0: "\uFF10",
        1: "\uFF11",
        2: "\uFF12",
        3: "\uFF13",
        4: "\uFF14",
        5: "\uFF15",
        6: "\uFF16",
        7: "\uFF17",
        8: "\uFF18",
        9: "\uFF19"
    };
    for (const [key, value] of Object.entries(messages))if (typeof value === 'string') blockified[key] = `[${value.split('').map((char)=>blockMap[char] || char).join('')}]`;
    else blockified[key] = value;
    return blockified;
}
function $e5f9102dfff0b1bd$export$899c38795c0a61a4(messages) {
    const bracketed = {};
    for (const [key, value] of Object.entries(messages))if (typeof value === 'string') bracketed[key] = `\xab${value}\xbb`;
    else bracketed[key] = value;
    return bracketed;
}



/**
 * Extract messages from a dynamic import result.
 * Handles both ESM default exports (webpack) and CJS module.exports (Atlaspack).
 * - Webpack wraps JSON in { default: {...} }
 * - Atlaspack transforms JSON to module.exports = {...} which may not have .default
 */ function $6282422f2c3f73f1$var$resolveMessages(mod) {
    return mod?.default ?? mod;
}


















































































































































/**
 * Returns all i18n import promises for a given locale —
 * extension messages + conversation-assistant sub-package messages.
 */ function $6282422f2c3f73f1$var$getMessageLoaders(localeToLoad) {
    switch(localeToLoad){
        case 'cs':
            return [
                (parcelRequire("iRj1b")),
                (parcelRequire("eV8o2")),
                (parcelRequire("l0tcr")),
                (parcelRequire("axkt2")),
                (parcelRequire("8NcvZ"))
            ];
        case 'da':
            return [
                (parcelRequire("4dsLZ")),
                (parcelRequire("jlWDy")),
                (parcelRequire("va0m5")),
                (parcelRequire("cnQQp")),
                (parcelRequire("5tYLV"))
            ];
        case 'de':
            return [
                (parcelRequire("ir5gm")),
                (parcelRequire("lqDtF")),
                (parcelRequire("lOWYU")),
                (parcelRequire("4GxCy")),
                (parcelRequire("5kNc4"))
            ];
        case 'en-GB':
        case 'en-AU':
        case 'en-IN':
        case 'en-NZ':
            return [
                (parcelRequire("bpMAu")),
                (parcelRequire("fr7Kc")),
                (parcelRequire("hJquZ")),
                (parcelRequire("iubfc")),
                (parcelRequire("bip1o"))
            ];
        case 'en-XA':
            return [
                (parcelRequire("7yIcl")).then((mod)=>(0, $e5f9102dfff0b1bd$export$aaf01d6467973d49)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("59QBA")).then((mod)=>(0, $e5f9102dfff0b1bd$export$aaf01d6467973d49)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("5F7KT")).then((mod)=>(0, $e5f9102dfff0b1bd$export$aaf01d6467973d49)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("835lU")).then((mod)=>(0, $e5f9102dfff0b1bd$export$aaf01d6467973d49)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("f6Ic2")).then((mod)=>(0, $e5f9102dfff0b1bd$export$aaf01d6467973d49)($6282422f2c3f73f1$var$resolveMessages(mod)))
            ];
        case 'en-XB':
            return [
                (parcelRequire("7yIcl")).then((mod)=>(0, $e5f9102dfff0b1bd$export$899c38795c0a61a4)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("59QBA")).then((mod)=>(0, $e5f9102dfff0b1bd$export$899c38795c0a61a4)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("5F7KT")).then((mod)=>(0, $e5f9102dfff0b1bd$export$899c38795c0a61a4)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("835lU")).then((mod)=>(0, $e5f9102dfff0b1bd$export$899c38795c0a61a4)($6282422f2c3f73f1$var$resolveMessages(mod))),
                (parcelRequire("f6Ic2")).then((mod)=>(0, $e5f9102dfff0b1bd$export$899c38795c0a61a4)($6282422f2c3f73f1$var$resolveMessages(mod)))
            ];
        case 'en-ZZ':
            return [
                (parcelRequire("g11oP")),
                (parcelRequire("9UqAc")),
                (parcelRequire("eyN06")),
                (parcelRequire("ichXA")),
                (parcelRequire("diXhU"))
            ];
        case 'es':
            return [
                (parcelRequire("dQsEO")),
                (parcelRequire("kdbzi")),
                (parcelRequire("85tRy")),
                (parcelRequire("uJe8k")),
                (parcelRequire("hkzru"))
            ];
        case 'fi':
            return [
                (parcelRequire("1D1yV")),
                (parcelRequire("37cGi")),
                (parcelRequire("4G3WH")),
                (parcelRequire("iIsNV")),
                (parcelRequire("eRCVN"))
            ];
        case 'fr':
            return [
                (parcelRequire("8cptK")),
                (parcelRequire("bApwq")),
                (parcelRequire("60pr7")),
                (parcelRequire("hGn9B")),
                (parcelRequire("g4m4n"))
            ];
        case 'hr':
            return [
                (parcelRequire("ePNsB")),
                (parcelRequire("4DBAq")),
                (parcelRequire("69vvN")),
                (parcelRequire("9di9L")),
                (parcelRequire("bdxP4"))
            ];
        case 'hu':
            return [
                (parcelRequire("iM03G")),
                (parcelRequire("hxsUH")),
                (parcelRequire("h8oTp")),
                (parcelRequire("2SOcP")),
                (parcelRequire("dZRyh"))
            ];
        case 'it':
            return [
                (parcelRequire("fI2BU")),
                (parcelRequire("i09H8")),
                (parcelRequire("dI0wG")),
                (parcelRequire("DrbWG")),
                (parcelRequire("kPN7L"))
            ];
        case 'ja':
            return [
                (parcelRequire("ccc2a")),
                (parcelRequire("kaeEG")),
                (parcelRequire("j4XLF")),
                (parcelRequire("jEKGe")),
                (parcelRequire("eodvL"))
            ];
        case 'ko':
            return [
                (parcelRequire("g0zg5")),
                (parcelRequire("dWDvj")),
                (parcelRequire("jjQFx")),
                (parcelRequire("75L0G")),
                (parcelRequire("c771G"))
            ];
        case 'nb':
            return [
                (parcelRequire("2QrSw")),
                (parcelRequire("h5WTW")),
                (parcelRequire("1W5NJ")),
                (parcelRequire("lMWEK")),
                (parcelRequire("jICau"))
            ];
        case 'nl':
            return [
                (parcelRequire("kUglV")),
                (parcelRequire("5W7v2")),
                (parcelRequire("jrHfE")),
                (parcelRequire("6tia3")),
                (parcelRequire("8isfR"))
            ];
        case 'pl':
            return [
                (parcelRequire("k5PZJ")),
                (parcelRequire("3WUXC")),
                (parcelRequire("bkpY2")),
                (parcelRequire("ckosZ")),
                (parcelRequire("ji1Ji"))
            ];
        case 'pt':
        case 'pt-BR':
            return [
                (parcelRequire("3ucPb")),
                (parcelRequire("1JT01")),
                (parcelRequire("dXAIn")),
                (parcelRequire("2ZTM3")),
                (parcelRequire("dXuhF"))
            ];
        case 'ru':
            return [
                (parcelRequire("aok1J")),
                (parcelRequire("angFn")),
                (parcelRequire("ebEBn")),
                (parcelRequire("icPMB")),
                (parcelRequire("gqigL"))
            ];
        case 'sl':
            return [
                (parcelRequire("2fevf")),
                (parcelRequire("kVRHu")),
                (parcelRequire("dAeLp")),
                (parcelRequire("ljdeS")),
                (parcelRequire("4LLbN"))
            ];
        case 'sr':
            return [
                (parcelRequire("hR4UU")),
                (parcelRequire("34yCo")),
                (parcelRequire("5rw4R")),
                (parcelRequire("ZY1cn")),
                (parcelRequire("b1Gh5"))
            ];
        case 'sv':
            return [
                (parcelRequire("dmmzd")),
                (parcelRequire("61uIW")),
                (parcelRequire("2OxNK")),
                (parcelRequire("esSry")),
                (parcelRequire("fePoE"))
            ];
        case 'th':
            return [
                (parcelRequire("5EQGe")),
                (parcelRequire("lMt3g")),
                (parcelRequire("hCISi")),
                (parcelRequire("7fgvq")),
                (parcelRequire("4lbb0"))
            ];
        case 'tr':
            return [
                (parcelRequire("dEQHr")),
                (parcelRequire("1JvrW")),
                (parcelRequire("7rIss")),
                (parcelRequire("fcmVb")),
                (parcelRequire("3Rh9z"))
            ];
        case 'uk':
            return [
                (parcelRequire("c8xxo")),
                (parcelRequire("7yYm3")),
                (parcelRequire("g2G5X")),
                (parcelRequire("5iBxW")),
                (parcelRequire("4ujXg"))
            ];
        case 'vi':
            return [
                (parcelRequire("leZ9E")),
                (parcelRequire("leX5H")),
                (parcelRequire("7XzSo")),
                (parcelRequire("jpyRj")),
                (parcelRequire("lksJn"))
            ];
        case 'zh':
            return [
                (parcelRequire("lYQWJ")),
                (parcelRequire("fIbpN")),
                (parcelRequire("7Q8K9")),
                (parcelRequire("dofpL")),
                (parcelRequire("6wKoJ"))
            ];
        case 'zh-TW':
            return [
                (parcelRequire("6upwj")),
                (parcelRequire("7oGJw")),
                (parcelRequire("8vLc5")),
                (parcelRequire("6x8el")),
                (parcelRequire("c7WqB"))
            ];
        case 'en':
        case 'en-US':
        default:
            return [
                (parcelRequire("7yIcl"))
            ];
    }
}

async function $6282422f2c3f73f1$export$99be592f797bf55d(locale) {
    const localeToLoad = (0, $6967de817d53f553$export$e88b669f03544b69)(locale);
    try {
        const results = await Promise.all($6282422f2c3f73f1$var$getMessageLoaders(localeToLoad));
        return Object.assign({}, ...results.map($6282422f2c3f73f1$var$resolveMessages));
    } catch (error) {
        (0, $34dba73ed8a4a50e$export$58da9968c3170cb1)({
            error: error,
            impact: 'Failed to import locale strings, attempting to load English fallback'
        });
        return $6282422f2c3f73f1$var$resolveMessages(await (parcelRequire("7yIcl")));
    }
}


parcelRequire("iuDZJ");
var $dqHaj = parcelRequire("dqHaj");

var $22hwD = parcelRequire("22hwD");
const $41e07a503512b44a$export$43ce528bbe72160e = (props)=>{
    const [messages, setMessages] = (0, $1v5pe.useState)({});
    const locale = (0, $dqHaj.getLocale)();
    (0, $1v5pe.useEffect)(()=>{
        (0, $6282422f2c3f73f1$export$99be592f797bf55d)(locale).then((localeMessages)=>{
            setMessages(localeMessages);
        }).catch((error)=>{
            (0, $22hwD.logError)({
                error: error,
                impact: 'Failed to load locale strings'
            });
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cZ6aD.default), {
        locale: locale,
        messages: messages,
        onError: ()=>{}
    }, props.children);
};


parcelRequire("1wxU2");
var $iVysF = parcelRequire("iVysF");
var $cFd5E = parcelRequire("cFd5E");

var $1v5pe = parcelRequire("1v5pe");

var $k0q1a = parcelRequire("k0q1a");

var $1v5pe = parcelRequire("1v5pe");

var $bI4fx = parcelRequire("bI4fx");
const $1c59f638f90642aa$export$9438e87dff4966f4 = ()=>{
    const [timingData, setTimingData] = (0, $1v5pe.useState)();
    (0, $1v5pe.useEffect)(()=>{
        const messageHandler = (event)=>{
            if (event.data.type === 'GET_EXTENSION_INIT_TIMING_RESPONSE') setTimingData(event.data.timingData);
            else if (event.data.type === 'IFRAME_LOAD_COMPLETE') // Request updated timing data immediately when iframe load completes
            (0, $bI4fx.postMessageToParent)({
                type: 'GET_EXTENSION_INIT_TIMING_REQUEST'
            });
        };
        window.addEventListener('message', messageHandler, false);
        // Request timing data from extension-chrome
        (0, $bI4fx.postMessageToParent)({
            type: 'GET_EXTENSION_INIT_TIMING_REQUEST'
        });
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, []); // No dependencies - effect runs once on mount
    return timingData;
};


const $72a03799bd3fe790$export$62712945821e44d1 = ()=>{
    const timingData = (0, $1c59f638f90642aa$export$9438e87dff4966f4)();
    if (!timingData) return null;
    const customData = {
        extensionScriptInitDuration: timingData.scriptInitDuration,
        extensionPageReadyDuration: timingData.pageReadyDuration,
        extensionInitStartTime: timingData.scriptInitStartTime,
        extensionInitEndTime: timingData.pageReadyEndTime,
        // Include iframe load timing data if available
        ...timingData.iframeLoadDuration && {
            extensionIframeLoadDuration: timingData.iframeLoadDuration,
            extensionIframeLoadStartTime: timingData.iframeLoadStartTime,
            extensionIframeLoadEndTime: timingData.iframeLoadEndTime
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $k0q1a.default), {
        data: customData
    });
};



var $kA1Vr = parcelRequire("kA1Vr");
parcelRequire("gfRi5");
var $4xT8j = parcelRequire("4xT8j");
var $3dX4H = parcelRequire("3dX4H");
parcelRequire("iuDZJ");

const $c4c47b0e78c26f17$var$HomeLoginPageLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("cPUrl")));
(0, $f0dSY.initializeSentry)();
// Initialize UFO as early as possible to capture more initialization time
(0, $iVysF.initUFO)();
const $c4c47b0e78c26f17$var$container = document.getElementById('root');
const $c4c47b0e78c26f17$var$root = (0, $4okYx.createRoot)($c4c47b0e78c26f17$var$container);

const $c4c47b0e78c26f17$var$LazyApp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).lazy(()=>(parcelRequire("ilgi0")));
// Component to handle extension timing data within UFO context
const $c4c47b0e78c26f17$var$ExtensionTimingHandler = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $72a03799bd3fe790$export$62712945821e44d1), null);
};
$c4c47b0e78c26f17$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $4xT8j.PerformanceSLO), {
    ufo: (0, $3dX4H.PerformanceSLOKeys).APPLICATION_BOOTSTRAP
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement($c4c47b0e78c26f17$var$ExtensionTimingHandler, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $lNKZj.HelmetProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $41e07a503512b44a$export$43ce528bbe72160e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $aX5WL.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $calFH.BrowserRouter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $bHcZt.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $gOQGR.PersistQueryClientProvider), {
    client: (0, $cKss1.queryClient),
    persistOptions: {
        persister: $cKss1.persister
    }
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $kA1Vr.ThemeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $1v5pe.Suspense), {
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $cFd5E.UFOSuspenseFallback), {
        name: "main-app-loading"
    })
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1v5pe))).createElement((0, $a801d5f2705eca37$export$2e2bcd8739ae039), {
    Component: $c4c47b0e78c26f17$var$LazyApp,
    LoginComponent: $c4c47b0e78c26f17$var$HomeLoginPageLazy,
    publicRoutes: [
        '/extension/welcome',
        '/extension/log-out',
        '/extension/ntp-logout-redirect'
    ]
})))))))))));


//# sourceMappingURL=index.d6bfea68.js.map
